var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var eventemitter3 = {exports: {}};

(function (module) {

	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';

	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */
	function Events() {}

	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);

	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}

	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}

	/**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */
	function addListener(emitter, event, fn, context, once) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('The listener must be a function');
	  }

	  var listener = new EE(fn, context || emitter, once)
	    , evt = prefix ? prefix + event : event;

	  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
	  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
	  else emitter._events[evt] = [emitter._events[evt], listener];

	  return emitter;
	}

	/**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */
	function clearEvent(emitter, evt) {
	  if (--emitter._eventsCount === 0) emitter._events = new Events();
	  else delete emitter._events[evt];
	}

	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}

	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;

	  if (this._eventsCount === 0) return names;

	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }

	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }

	  return names;
	};

	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  var evt = prefix ? prefix + event : event
	    , handlers = this._events[evt];

	  if (!handlers) return [];
	  if (handlers.fn) return [handlers.fn];

	  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
	    ee[i] = handlers[i].fn;
	  }

	  return ee;
	};

	/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */
	EventEmitter.prototype.listenerCount = function listenerCount(event) {
	  var evt = prefix ? prefix + event : event
	    , listeners = this._events[evt];

	  if (!listeners) return 0;
	  if (listeners.fn) return 1;
	  return listeners.length;
	};

	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return false;

	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;

	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }

	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }

	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;

	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }

	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }

	  return true;
	};

	/**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  return addListener(this, event, fn, context, false);
	};

	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  return addListener(this, event, fn, context, true);
	};

	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return this;
	  if (!fn) {
	    clearEvent(this, evt);
	    return this;
	  }

	  var listeners = this._events[evt];

	  if (listeners.fn) {
	    if (
	      listeners.fn === fn &&
	      (!once || listeners.once) &&
	      (!context || listeners.context === context)
	    ) {
	      clearEvent(this, evt);
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	        listeners[i].fn !== fn ||
	        (once && !listeners[i].once) ||
	        (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }

	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else clearEvent(this, evt);
	  }

	  return this;
	};

	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;

	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) clearEvent(this, evt);
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }

	  return this;
	};

	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;

	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;

	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;

	//
	// Expose the module.
	//
	{
	  module.exports = EventEmitter;
	} 
} (eventemitter3));

var eventemitter3Exports = eventemitter3.exports;
var EventEmitter = /*@__PURE__*/getDefaultExportFromCjs(eventemitter3Exports);

/** @internal Last-resort "this", if it gets here it probably would fail anyway */
function evaluateThis(fn) {
    return fn('return this');
}
/**
 * A cross-environment implementation for globalThis
 */
const xglobal =  (typeof globalThis !== 'undefined'
    ? globalThis
    : typeof global !== 'undefined'
        ? global
        : typeof self !== 'undefined'
            ? self
            : typeof window !== 'undefined'
                ? window
                : evaluateThis(Function));
/**
 * Extracts a known global from the environment, applying a fallback if not found
 */
function extractGlobal(name, fallback) {
    // Not quite sure why this is here - snuck in with TS 4.7.2 with no real idea
    // (as of now) as to why this looks like an "any" when we do cast it to a T
    //
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return typeof xglobal[name] === 'undefined'
        ? fallback
        : xglobal[name];
}

let TextDecoder$1 = class TextDecoder {
    __encoding;
    constructor(encoding) {
        this.__encoding = encoding;
    }
    decode(value) {
        let result = '';
        for (let i = 0, count = value.length; i < count; i++) {
            result += String.fromCharCode(value[i]);
        }
        return result;
    }
};

const TextDecoder = /*#__PURE__*/ extractGlobal('TextDecoder', TextDecoder$1);

let TextEncoder$2 = class TextEncoder {
    encode(value) {
        const count = value.length;
        const u8a = new Uint8Array(count);
        for (let i = 0; i < count; i++) {
            u8a[i] = value.charCodeAt(i);
        }
        return u8a;
    }
};

const TextEncoder$1 = /*#__PURE__*/ extractGlobal('TextEncoder', TextEncoder$2);

/**
 * @name isFunction
 * @summary Tests for a `function`.
 * @description
 * Checks to see if the input value is a JavaScript function.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isFunction } from '@polkadot/util';
 *
 * isFunction(() => false); // => true
 * ```
 */
function isFunction$1(value) {
    return typeof value === 'function';
}

/**
 * @name arrayChunk
 * @summary Split T[] into T[][] based on the defind size
 * @description
 * Returns a set ao arrays based on the chunksize
 * @example
 * <BR>
 *
 * ```javascript
 * import { arrayChunk } from '@polkadot/util';
 *
 * arrayChunk([1, 2, 3, 4, 5]); // [[1, 2], [3, 4], [5]]
 * ```
 */
function arrayChunk(array, chunkSize) {
    const outputSize = Math.ceil(array.length / chunkSize);
    // shortcut for the single-split case
    if (outputSize === 1) {
        return [array];
    }
    const output = Array(outputSize);
    for (let i = 0; i < outputSize; i++) {
        const offset = i * chunkSize;
        output[i] = array.slice(offset, offset + chunkSize);
    }
    return output;
}

/**
 * @name arrayFlatten
 * @summary Merge T[][] into T[]
 * @description
 * Returns a new array with all arrays merged into one
 * @example
 * <BR>
 *
 * ```javascript
 * import { arrayFlatten } from '@polkadot/util';
 *
 * arrayFlatten([[1, 2], [3, 4], [5]]); // [1, 2, 3, 4, 5]
 * ```
 */
function arrayFlatten(arrays) {
    const num = arrays.length;
    // shortcuts for the empty & single-entry case
    if (num === 0) {
        return [];
    }
    else if (num === 1) {
        return arrays[0];
    }
    // pre-allocate based on the combined size
    let size = 0;
    for (let i = 0; i < num; i++) {
        size += arrays[i].length;
    }
    const output = new Array(size);
    let i = -1;
    for (let j = 0; j < num; j++) {
        const a = arrays[j];
        // instead of pushing, we just set the entries
        for (let e = 0, count = a.length; e < count; e++) {
            output[++i] = a[e];
        }
    }
    return output;
}

/**
 * @name assert
 * @summary Checks for a valid test, if not Error is thrown.
 * @description
 * Checks that `test` is a truthy value. If value is falsy (`null`, `undefined`, `false`, ...), it throws an Error with the supplied `message`. When `test` passes, `true` is returned.
 * @example
 * <BR>
 *
 * ```javascript
 * const { assert } from '@polkadot/util';
 *
 * assert(true, 'True should be true'); // passes
 * assert(false, 'False should not be true'); // Error thrown
 * assert(false, () => 'message'); // Error with 'message'
 * ```
 */
function assert(condition, message) {
    if (!condition) {
        throw new Error(isFunction$1(message)
            ? message()
            : message);
    }
}
/**
 * @name assertReturn
 * @description Returns when the value is not undefined/null, otherwise throws assertion error
 */
function assertReturn(value, message) {
    assert(value !== undefined && value !== null, message);
    return value;
}
/**
 * @name assertUnreachable
 * @description An assertion helper that ensures all codepaths are followed
 */
function assertUnreachable(x) {
    throw new Error(`This codepath should be unreachable. Unhandled input: ${x}`);
}

/** @internal */
function createCmp(cmp) {
    return (...items) => {
        const count = items.length;
        if (count === 0) {
            throw new Error('Must provide one or more arguments');
        }
        let result = items[0];
        for (let i = 1; i < count; i++) {
            if (cmp(items[i], result)) {
                result = items[i];
            }
        }
        return result;
    };
}

/**
 * @internal
 *
 * There are _still_ some older environments (specifically RN < 0.70), that does
 * not have proper BigInt support - a non-working fallback is provided for those.
 *
 * We detect availability of BigInt upon usage, so this is purely to allow functional
 * compilation & bundling. Since we have operators such as *+-/ top-level, a number-ish
 * result is used here.
 */
function invalidFallback() {
    return Number.NaN;
}
const BigInt$1 = /*#__PURE__*/ extractGlobal('BigInt', invalidFallback);

/**
 * @name _0n
 * @summary BigInt constant for 0.
 */
const _0n$5 = /*#__PURE__*/ BigInt$1(0);
/**
 * @name _1n
 * @summary BigInt constant for 1.
 */
const _1n$5 = /*#__PURE__*/ BigInt$1(1);

const CHR$1 = '0123456789abcdef';
const U8$1 = new Uint8Array(256);
const U16$1 = new Uint8Array(256 * 256);
for (let i = 0, count = CHR$1.length; i < count; i++) {
    U8$1[CHR$1[i].charCodeAt(0) | 0] = i | 0;
    if (i > 9) {
        U8$1[CHR$1[i].toUpperCase().charCodeAt(0) | 0] = i | 0;
    }
}
for (let i = 0; i < 256; i++) {
    const s = i << 8;
    for (let j = 0; j < 256; j++) {
        U16$1[s | j] = (U8$1[i] << 4) | U8$1[j];
    }
}
/**
 * @name hexToU8a
 * @summary Creates a Uint8Array object from a hex string.
 * @description
 * `null` inputs returns an empty `Uint8Array` result. Hex input values return the actual bytes value converted to a Uint8Array. Anything that is not a hex string (including the `0x` prefix) throws an error.
 * @example
 * <BR>
 *
 * ```javascript
 * import { hexToU8a } from '@polkadot/util';
 *
 * hexToU8a('0x80001f'); // Uint8Array([0x80, 0x00, 0x1f])
 * hexToU8a('0x80001f', 32); // Uint8Array([0x00, 0x80, 0x00, 0x1f])
 * ```
 */
function hexToU8a(value, bitLength = -1) {
    if (!value) {
        return new Uint8Array();
    }
    let s = value.startsWith('0x')
        ? 2
        : 0;
    const decLength = Math.ceil((value.length - s) / 2);
    const endLength = Math.ceil(bitLength === -1
        ? decLength
        : bitLength / 8);
    const result = new Uint8Array(endLength);
    const offset = endLength > decLength
        ? endLength - decLength
        : 0;
    for (let i = offset; i < endLength; i++, s += 2) {
        // The big factor here is actually the string lookups. If we do
        // HEX_TO_U16[value.substring()] we get an 10x slowdown. In the
        // same vein using charCodeAt (as opposed to value[s] or value.charAt(s)) is
        // also the faster operation by at least 2x with the character map above
        result[i] = U16$1[(value.charCodeAt(s) << 8) | value.charCodeAt(s + 1)];
    }
    return result;
}

var bn = {exports: {}};

var _nodeResolve_empty = {};

var _nodeResolve_empty$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	default: _nodeResolve_empty
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty$1);

bn.exports;

(function (module) {
	(function (module, exports) {

	  // Utils
	  function assert (val, msg) {
	    if (!val) throw new Error(msg || 'Assertion failed');
	  }

	  // Could use `inherits` module, but don't want to move from single file
	  // architecture yet.
	  function inherits (ctor, superCtor) {
	    ctor.super_ = superCtor;
	    var TempCtor = function () {};
	    TempCtor.prototype = superCtor.prototype;
	    ctor.prototype = new TempCtor();
	    ctor.prototype.constructor = ctor;
	  }

	  // BN

	  function BN (number, base, endian) {
	    if (BN.isBN(number)) {
	      return number;
	    }

	    this.negative = 0;
	    this.words = null;
	    this.length = 0;

	    // Reduction context
	    this.red = null;

	    if (number !== null) {
	      if (base === 'le' || base === 'be') {
	        endian = base;
	        base = 10;
	      }

	      this._init(number || 0, base || 10, endian || 'be');
	    }
	  }
	  if (typeof module === 'object') {
	    module.exports = BN;
	  } else {
	    exports.BN = BN;
	  }

	  BN.BN = BN;
	  BN.wordSize = 26;

	  var Buffer;
	  try {
	    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
	      Buffer = window.Buffer;
	    } else {
	      Buffer = require$$0.Buffer;
	    }
	  } catch (e) {
	  }

	  BN.isBN = function isBN (num) {
	    if (num instanceof BN) {
	      return true;
	    }

	    return num !== null && typeof num === 'object' &&
	      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
	  };

	  BN.max = function max (left, right) {
	    if (left.cmp(right) > 0) return left;
	    return right;
	  };

	  BN.min = function min (left, right) {
	    if (left.cmp(right) < 0) return left;
	    return right;
	  };

	  BN.prototype._init = function init (number, base, endian) {
	    if (typeof number === 'number') {
	      return this._initNumber(number, base, endian);
	    }

	    if (typeof number === 'object') {
	      return this._initArray(number, base, endian);
	    }

	    if (base === 'hex') {
	      base = 16;
	    }
	    assert(base === (base | 0) && base >= 2 && base <= 36);

	    number = number.toString().replace(/\s+/g, '');
	    var start = 0;
	    if (number[0] === '-') {
	      start++;
	      this.negative = 1;
	    }

	    if (start < number.length) {
	      if (base === 16) {
	        this._parseHex(number, start, endian);
	      } else {
	        this._parseBase(number, base, start);
	        if (endian === 'le') {
	          this._initArray(this.toArray(), base, endian);
	        }
	      }
	    }
	  };

	  BN.prototype._initNumber = function _initNumber (number, base, endian) {
	    if (number < 0) {
	      this.negative = 1;
	      number = -number;
	    }
	    if (number < 0x4000000) {
	      this.words = [number & 0x3ffffff];
	      this.length = 1;
	    } else if (number < 0x10000000000000) {
	      this.words = [
	        number & 0x3ffffff,
	        (number / 0x4000000) & 0x3ffffff
	      ];
	      this.length = 2;
	    } else {
	      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
	      this.words = [
	        number & 0x3ffffff,
	        (number / 0x4000000) & 0x3ffffff,
	        1
	      ];
	      this.length = 3;
	    }

	    if (endian !== 'le') return;

	    // Reverse the bytes
	    this._initArray(this.toArray(), base, endian);
	  };

	  BN.prototype._initArray = function _initArray (number, base, endian) {
	    // Perhaps a Uint8Array
	    assert(typeof number.length === 'number');
	    if (number.length <= 0) {
	      this.words = [0];
	      this.length = 1;
	      return this;
	    }

	    this.length = Math.ceil(number.length / 3);
	    this.words = new Array(this.length);
	    for (var i = 0; i < this.length; i++) {
	      this.words[i] = 0;
	    }

	    var j, w;
	    var off = 0;
	    if (endian === 'be') {
	      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
	        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
	        this.words[j] |= (w << off) & 0x3ffffff;
	        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
	        off += 24;
	        if (off >= 26) {
	          off -= 26;
	          j++;
	        }
	      }
	    } else if (endian === 'le') {
	      for (i = 0, j = 0; i < number.length; i += 3) {
	        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
	        this.words[j] |= (w << off) & 0x3ffffff;
	        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
	        off += 24;
	        if (off >= 26) {
	          off -= 26;
	          j++;
	        }
	      }
	    }
	    return this._strip();
	  };

	  function parseHex4Bits (string, index) {
	    var c = string.charCodeAt(index);
	    // '0' - '9'
	    if (c >= 48 && c <= 57) {
	      return c - 48;
	    // 'A' - 'F'
	    } else if (c >= 65 && c <= 70) {
	      return c - 55;
	    // 'a' - 'f'
	    } else if (c >= 97 && c <= 102) {
	      return c - 87;
	    } else {
	      assert(false, 'Invalid character in ' + string);
	    }
	  }

	  function parseHexByte (string, lowerBound, index) {
	    var r = parseHex4Bits(string, index);
	    if (index - 1 >= lowerBound) {
	      r |= parseHex4Bits(string, index - 1) << 4;
	    }
	    return r;
	  }

	  BN.prototype._parseHex = function _parseHex (number, start, endian) {
	    // Create possibly bigger array to ensure that it fits the number
	    this.length = Math.ceil((number.length - start) / 6);
	    this.words = new Array(this.length);
	    for (var i = 0; i < this.length; i++) {
	      this.words[i] = 0;
	    }

	    // 24-bits chunks
	    var off = 0;
	    var j = 0;

	    var w;
	    if (endian === 'be') {
	      for (i = number.length - 1; i >= start; i -= 2) {
	        w = parseHexByte(number, start, i) << off;
	        this.words[j] |= w & 0x3ffffff;
	        if (off >= 18) {
	          off -= 18;
	          j += 1;
	          this.words[j] |= w >>> 26;
	        } else {
	          off += 8;
	        }
	      }
	    } else {
	      var parseLength = number.length - start;
	      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
	        w = parseHexByte(number, start, i) << off;
	        this.words[j] |= w & 0x3ffffff;
	        if (off >= 18) {
	          off -= 18;
	          j += 1;
	          this.words[j] |= w >>> 26;
	        } else {
	          off += 8;
	        }
	      }
	    }

	    this._strip();
	  };

	  function parseBase (str, start, end, mul) {
	    var r = 0;
	    var b = 0;
	    var len = Math.min(str.length, end);
	    for (var i = start; i < len; i++) {
	      var c = str.charCodeAt(i) - 48;

	      r *= mul;

	      // 'a'
	      if (c >= 49) {
	        b = c - 49 + 0xa;

	      // 'A'
	      } else if (c >= 17) {
	        b = c - 17 + 0xa;

	      // '0' - '9'
	      } else {
	        b = c;
	      }
	      assert(c >= 0 && b < mul, 'Invalid character');
	      r += b;
	    }
	    return r;
	  }

	  BN.prototype._parseBase = function _parseBase (number, base, start) {
	    // Initialize as zero
	    this.words = [0];
	    this.length = 1;

	    // Find length of limb in base
	    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
	      limbLen++;
	    }
	    limbLen--;
	    limbPow = (limbPow / base) | 0;

	    var total = number.length - start;
	    var mod = total % limbLen;
	    var end = Math.min(total, total - mod) + start;

	    var word = 0;
	    for (var i = start; i < end; i += limbLen) {
	      word = parseBase(number, i, i + limbLen, base);

	      this.imuln(limbPow);
	      if (this.words[0] + word < 0x4000000) {
	        this.words[0] += word;
	      } else {
	        this._iaddn(word);
	      }
	    }

	    if (mod !== 0) {
	      var pow = 1;
	      word = parseBase(number, i, number.length, base);

	      for (i = 0; i < mod; i++) {
	        pow *= base;
	      }

	      this.imuln(pow);
	      if (this.words[0] + word < 0x4000000) {
	        this.words[0] += word;
	      } else {
	        this._iaddn(word);
	      }
	    }

	    this._strip();
	  };

	  BN.prototype.copy = function copy (dest) {
	    dest.words = new Array(this.length);
	    for (var i = 0; i < this.length; i++) {
	      dest.words[i] = this.words[i];
	    }
	    dest.length = this.length;
	    dest.negative = this.negative;
	    dest.red = this.red;
	  };

	  function move (dest, src) {
	    dest.words = src.words;
	    dest.length = src.length;
	    dest.negative = src.negative;
	    dest.red = src.red;
	  }

	  BN.prototype._move = function _move (dest) {
	    move(dest, this);
	  };

	  BN.prototype.clone = function clone () {
	    var r = new BN(null);
	    this.copy(r);
	    return r;
	  };

	  BN.prototype._expand = function _expand (size) {
	    while (this.length < size) {
	      this.words[this.length++] = 0;
	    }
	    return this;
	  };

	  // Remove leading `0` from `this`
	  BN.prototype._strip = function strip () {
	    while (this.length > 1 && this.words[this.length - 1] === 0) {
	      this.length--;
	    }
	    return this._normSign();
	  };

	  BN.prototype._normSign = function _normSign () {
	    // -0 = 0
	    if (this.length === 1 && this.words[0] === 0) {
	      this.negative = 0;
	    }
	    return this;
	  };

	  // Check Symbol.for because not everywhere where Symbol defined
	  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
	  if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
	    try {
	      BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
	    } catch (e) {
	      BN.prototype.inspect = inspect;
	    }
	  } else {
	    BN.prototype.inspect = inspect;
	  }

	  function inspect () {
	    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
	  }

	  /*

	  var zeros = [];
	  var groupSizes = [];
	  var groupBases = [];

	  var s = '';
	  var i = -1;
	  while (++i < BN.wordSize) {
	    zeros[i] = s;
	    s += '0';
	  }
	  groupSizes[0] = 0;
	  groupSizes[1] = 0;
	  groupBases[0] = 0;
	  groupBases[1] = 0;
	  var base = 2 - 1;
	  while (++base < 36 + 1) {
	    var groupSize = 0;
	    var groupBase = 1;
	    while (groupBase < (1 << BN.wordSize) / base) {
	      groupBase *= base;
	      groupSize += 1;
	    }
	    groupSizes[base] = groupSize;
	    groupBases[base] = groupBase;
	  }

	  */

	  var zeros = [
	    '',
	    '0',
	    '00',
	    '000',
	    '0000',
	    '00000',
	    '000000',
	    '0000000',
	    '00000000',
	    '000000000',
	    '0000000000',
	    '00000000000',
	    '000000000000',
	    '0000000000000',
	    '00000000000000',
	    '000000000000000',
	    '0000000000000000',
	    '00000000000000000',
	    '000000000000000000',
	    '0000000000000000000',
	    '00000000000000000000',
	    '000000000000000000000',
	    '0000000000000000000000',
	    '00000000000000000000000',
	    '000000000000000000000000',
	    '0000000000000000000000000'
	  ];

	  var groupSizes = [
	    0, 0,
	    25, 16, 12, 11, 10, 9, 8,
	    8, 7, 7, 7, 7, 6, 6,
	    6, 6, 6, 6, 6, 5, 5,
	    5, 5, 5, 5, 5, 5, 5,
	    5, 5, 5, 5, 5, 5, 5
	  ];

	  var groupBases = [
	    0, 0,
	    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
	    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
	    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
	    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
	    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
	  ];

	  BN.prototype.toString = function toString (base, padding) {
	    base = base || 10;
	    padding = padding | 0 || 1;

	    var out;
	    if (base === 16 || base === 'hex') {
	      out = '';
	      var off = 0;
	      var carry = 0;
	      for (var i = 0; i < this.length; i++) {
	        var w = this.words[i];
	        var word = (((w << off) | carry) & 0xffffff).toString(16);
	        carry = (w >>> (24 - off)) & 0xffffff;
	        off += 2;
	        if (off >= 26) {
	          off -= 26;
	          i--;
	        }
	        if (carry !== 0 || i !== this.length - 1) {
	          out = zeros[6 - word.length] + word + out;
	        } else {
	          out = word + out;
	        }
	      }
	      if (carry !== 0) {
	        out = carry.toString(16) + out;
	      }
	      while (out.length % padding !== 0) {
	        out = '0' + out;
	      }
	      if (this.negative !== 0) {
	        out = '-' + out;
	      }
	      return out;
	    }

	    if (base === (base | 0) && base >= 2 && base <= 36) {
	      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
	      var groupSize = groupSizes[base];
	      // var groupBase = Math.pow(base, groupSize);
	      var groupBase = groupBases[base];
	      out = '';
	      var c = this.clone();
	      c.negative = 0;
	      while (!c.isZero()) {
	        var r = c.modrn(groupBase).toString(base);
	        c = c.idivn(groupBase);

	        if (!c.isZero()) {
	          out = zeros[groupSize - r.length] + r + out;
	        } else {
	          out = r + out;
	        }
	      }
	      if (this.isZero()) {
	        out = '0' + out;
	      }
	      while (out.length % padding !== 0) {
	        out = '0' + out;
	      }
	      if (this.negative !== 0) {
	        out = '-' + out;
	      }
	      return out;
	    }

	    assert(false, 'Base should be between 2 and 36');
	  };

	  BN.prototype.toNumber = function toNumber () {
	    var ret = this.words[0];
	    if (this.length === 2) {
	      ret += this.words[1] * 0x4000000;
	    } else if (this.length === 3 && this.words[2] === 0x01) {
	      // NOTE: at this stage it is known that the top bit is set
	      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
	    } else if (this.length > 2) {
	      assert(false, 'Number can only safely store up to 53 bits');
	    }
	    return (this.negative !== 0) ? -ret : ret;
	  };

	  BN.prototype.toJSON = function toJSON () {
	    return this.toString(16, 2);
	  };

	  if (Buffer) {
	    BN.prototype.toBuffer = function toBuffer (endian, length) {
	      return this.toArrayLike(Buffer, endian, length);
	    };
	  }

	  BN.prototype.toArray = function toArray (endian, length) {
	    return this.toArrayLike(Array, endian, length);
	  };

	  var allocate = function allocate (ArrayType, size) {
	    if (ArrayType.allocUnsafe) {
	      return ArrayType.allocUnsafe(size);
	    }
	    return new ArrayType(size);
	  };

	  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
	    this._strip();

	    var byteLength = this.byteLength();
	    var reqLength = length || Math.max(1, byteLength);
	    assert(byteLength <= reqLength, 'byte array longer than desired length');
	    assert(reqLength > 0, 'Requested array length <= 0');

	    var res = allocate(ArrayType, reqLength);
	    var postfix = endian === 'le' ? 'LE' : 'BE';
	    this['_toArrayLike' + postfix](res, byteLength);
	    return res;
	  };

	  BN.prototype._toArrayLikeLE = function _toArrayLikeLE (res, byteLength) {
	    var position = 0;
	    var carry = 0;

	    for (var i = 0, shift = 0; i < this.length; i++) {
	      var word = (this.words[i] << shift) | carry;

	      res[position++] = word & 0xff;
	      if (position < res.length) {
	        res[position++] = (word >> 8) & 0xff;
	      }
	      if (position < res.length) {
	        res[position++] = (word >> 16) & 0xff;
	      }

	      if (shift === 6) {
	        if (position < res.length) {
	          res[position++] = (word >> 24) & 0xff;
	        }
	        carry = 0;
	        shift = 0;
	      } else {
	        carry = word >>> 24;
	        shift += 2;
	      }
	    }

	    if (position < res.length) {
	      res[position++] = carry;

	      while (position < res.length) {
	        res[position++] = 0;
	      }
	    }
	  };

	  BN.prototype._toArrayLikeBE = function _toArrayLikeBE (res, byteLength) {
	    var position = res.length - 1;
	    var carry = 0;

	    for (var i = 0, shift = 0; i < this.length; i++) {
	      var word = (this.words[i] << shift) | carry;

	      res[position--] = word & 0xff;
	      if (position >= 0) {
	        res[position--] = (word >> 8) & 0xff;
	      }
	      if (position >= 0) {
	        res[position--] = (word >> 16) & 0xff;
	      }

	      if (shift === 6) {
	        if (position >= 0) {
	          res[position--] = (word >> 24) & 0xff;
	        }
	        carry = 0;
	        shift = 0;
	      } else {
	        carry = word >>> 24;
	        shift += 2;
	      }
	    }

	    if (position >= 0) {
	      res[position--] = carry;

	      while (position >= 0) {
	        res[position--] = 0;
	      }
	    }
	  };

	  if (Math.clz32) {
	    BN.prototype._countBits = function _countBits (w) {
	      return 32 - Math.clz32(w);
	    };
	  } else {
	    BN.prototype._countBits = function _countBits (w) {
	      var t = w;
	      var r = 0;
	      if (t >= 0x1000) {
	        r += 13;
	        t >>>= 13;
	      }
	      if (t >= 0x40) {
	        r += 7;
	        t >>>= 7;
	      }
	      if (t >= 0x8) {
	        r += 4;
	        t >>>= 4;
	      }
	      if (t >= 0x02) {
	        r += 2;
	        t >>>= 2;
	      }
	      return r + t;
	    };
	  }

	  BN.prototype._zeroBits = function _zeroBits (w) {
	    // Short-cut
	    if (w === 0) return 26;

	    var t = w;
	    var r = 0;
	    if ((t & 0x1fff) === 0) {
	      r += 13;
	      t >>>= 13;
	    }
	    if ((t & 0x7f) === 0) {
	      r += 7;
	      t >>>= 7;
	    }
	    if ((t & 0xf) === 0) {
	      r += 4;
	      t >>>= 4;
	    }
	    if ((t & 0x3) === 0) {
	      r += 2;
	      t >>>= 2;
	    }
	    if ((t & 0x1) === 0) {
	      r++;
	    }
	    return r;
	  };

	  // Return number of used bits in a BN
	  BN.prototype.bitLength = function bitLength () {
	    var w = this.words[this.length - 1];
	    var hi = this._countBits(w);
	    return (this.length - 1) * 26 + hi;
	  };

	  function toBitArray (num) {
	    var w = new Array(num.bitLength());

	    for (var bit = 0; bit < w.length; bit++) {
	      var off = (bit / 26) | 0;
	      var wbit = bit % 26;

	      w[bit] = (num.words[off] >>> wbit) & 0x01;
	    }

	    return w;
	  }

	  // Number of trailing zero bits
	  BN.prototype.zeroBits = function zeroBits () {
	    if (this.isZero()) return 0;

	    var r = 0;
	    for (var i = 0; i < this.length; i++) {
	      var b = this._zeroBits(this.words[i]);
	      r += b;
	      if (b !== 26) break;
	    }
	    return r;
	  };

	  BN.prototype.byteLength = function byteLength () {
	    return Math.ceil(this.bitLength() / 8);
	  };

	  BN.prototype.toTwos = function toTwos (width) {
	    if (this.negative !== 0) {
	      return this.abs().inotn(width).iaddn(1);
	    }
	    return this.clone();
	  };

	  BN.prototype.fromTwos = function fromTwos (width) {
	    if (this.testn(width - 1)) {
	      return this.notn(width).iaddn(1).ineg();
	    }
	    return this.clone();
	  };

	  BN.prototype.isNeg = function isNeg () {
	    return this.negative !== 0;
	  };

	  // Return negative clone of `this`
	  BN.prototype.neg = function neg () {
	    return this.clone().ineg();
	  };

	  BN.prototype.ineg = function ineg () {
	    if (!this.isZero()) {
	      this.negative ^= 1;
	    }

	    return this;
	  };

	  // Or `num` with `this` in-place
	  BN.prototype.iuor = function iuor (num) {
	    while (this.length < num.length) {
	      this.words[this.length++] = 0;
	    }

	    for (var i = 0; i < num.length; i++) {
	      this.words[i] = this.words[i] | num.words[i];
	    }

	    return this._strip();
	  };

	  BN.prototype.ior = function ior (num) {
	    assert((this.negative | num.negative) === 0);
	    return this.iuor(num);
	  };

	  // Or `num` with `this`
	  BN.prototype.or = function or (num) {
	    if (this.length > num.length) return this.clone().ior(num);
	    return num.clone().ior(this);
	  };

	  BN.prototype.uor = function uor (num) {
	    if (this.length > num.length) return this.clone().iuor(num);
	    return num.clone().iuor(this);
	  };

	  // And `num` with `this` in-place
	  BN.prototype.iuand = function iuand (num) {
	    // b = min-length(num, this)
	    var b;
	    if (this.length > num.length) {
	      b = num;
	    } else {
	      b = this;
	    }

	    for (var i = 0; i < b.length; i++) {
	      this.words[i] = this.words[i] & num.words[i];
	    }

	    this.length = b.length;

	    return this._strip();
	  };

	  BN.prototype.iand = function iand (num) {
	    assert((this.negative | num.negative) === 0);
	    return this.iuand(num);
	  };

	  // And `num` with `this`
	  BN.prototype.and = function and (num) {
	    if (this.length > num.length) return this.clone().iand(num);
	    return num.clone().iand(this);
	  };

	  BN.prototype.uand = function uand (num) {
	    if (this.length > num.length) return this.clone().iuand(num);
	    return num.clone().iuand(this);
	  };

	  // Xor `num` with `this` in-place
	  BN.prototype.iuxor = function iuxor (num) {
	    // a.length > b.length
	    var a;
	    var b;
	    if (this.length > num.length) {
	      a = this;
	      b = num;
	    } else {
	      a = num;
	      b = this;
	    }

	    for (var i = 0; i < b.length; i++) {
	      this.words[i] = a.words[i] ^ b.words[i];
	    }

	    if (this !== a) {
	      for (; i < a.length; i++) {
	        this.words[i] = a.words[i];
	      }
	    }

	    this.length = a.length;

	    return this._strip();
	  };

	  BN.prototype.ixor = function ixor (num) {
	    assert((this.negative | num.negative) === 0);
	    return this.iuxor(num);
	  };

	  // Xor `num` with `this`
	  BN.prototype.xor = function xor (num) {
	    if (this.length > num.length) return this.clone().ixor(num);
	    return num.clone().ixor(this);
	  };

	  BN.prototype.uxor = function uxor (num) {
	    if (this.length > num.length) return this.clone().iuxor(num);
	    return num.clone().iuxor(this);
	  };

	  // Not ``this`` with ``width`` bitwidth
	  BN.prototype.inotn = function inotn (width) {
	    assert(typeof width === 'number' && width >= 0);

	    var bytesNeeded = Math.ceil(width / 26) | 0;
	    var bitsLeft = width % 26;

	    // Extend the buffer with leading zeroes
	    this._expand(bytesNeeded);

	    if (bitsLeft > 0) {
	      bytesNeeded--;
	    }

	    // Handle complete words
	    for (var i = 0; i < bytesNeeded; i++) {
	      this.words[i] = ~this.words[i] & 0x3ffffff;
	    }

	    // Handle the residue
	    if (bitsLeft > 0) {
	      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
	    }

	    // And remove leading zeroes
	    return this._strip();
	  };

	  BN.prototype.notn = function notn (width) {
	    return this.clone().inotn(width);
	  };

	  // Set `bit` of `this`
	  BN.prototype.setn = function setn (bit, val) {
	    assert(typeof bit === 'number' && bit >= 0);

	    var off = (bit / 26) | 0;
	    var wbit = bit % 26;

	    this._expand(off + 1);

	    if (val) {
	      this.words[off] = this.words[off] | (1 << wbit);
	    } else {
	      this.words[off] = this.words[off] & ~(1 << wbit);
	    }

	    return this._strip();
	  };

	  // Add `num` to `this` in-place
	  BN.prototype.iadd = function iadd (num) {
	    var r;

	    // negative + positive
	    if (this.negative !== 0 && num.negative === 0) {
	      this.negative = 0;
	      r = this.isub(num);
	      this.negative ^= 1;
	      return this._normSign();

	    // positive + negative
	    } else if (this.negative === 0 && num.negative !== 0) {
	      num.negative = 0;
	      r = this.isub(num);
	      num.negative = 1;
	      return r._normSign();
	    }

	    // a.length > b.length
	    var a, b;
	    if (this.length > num.length) {
	      a = this;
	      b = num;
	    } else {
	      a = num;
	      b = this;
	    }

	    var carry = 0;
	    for (var i = 0; i < b.length; i++) {
	      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
	      this.words[i] = r & 0x3ffffff;
	      carry = r >>> 26;
	    }
	    for (; carry !== 0 && i < a.length; i++) {
	      r = (a.words[i] | 0) + carry;
	      this.words[i] = r & 0x3ffffff;
	      carry = r >>> 26;
	    }

	    this.length = a.length;
	    if (carry !== 0) {
	      this.words[this.length] = carry;
	      this.length++;
	    // Copy the rest of the words
	    } else if (a !== this) {
	      for (; i < a.length; i++) {
	        this.words[i] = a.words[i];
	      }
	    }

	    return this;
	  };

	  // Add `num` to `this`
	  BN.prototype.add = function add (num) {
	    var res;
	    if (num.negative !== 0 && this.negative === 0) {
	      num.negative = 0;
	      res = this.sub(num);
	      num.negative ^= 1;
	      return res;
	    } else if (num.negative === 0 && this.negative !== 0) {
	      this.negative = 0;
	      res = num.sub(this);
	      this.negative = 1;
	      return res;
	    }

	    if (this.length > num.length) return this.clone().iadd(num);

	    return num.clone().iadd(this);
	  };

	  // Subtract `num` from `this` in-place
	  BN.prototype.isub = function isub (num) {
	    // this - (-num) = this + num
	    if (num.negative !== 0) {
	      num.negative = 0;
	      var r = this.iadd(num);
	      num.negative = 1;
	      return r._normSign();

	    // -this - num = -(this + num)
	    } else if (this.negative !== 0) {
	      this.negative = 0;
	      this.iadd(num);
	      this.negative = 1;
	      return this._normSign();
	    }

	    // At this point both numbers are positive
	    var cmp = this.cmp(num);

	    // Optimization - zeroify
	    if (cmp === 0) {
	      this.negative = 0;
	      this.length = 1;
	      this.words[0] = 0;
	      return this;
	    }

	    // a > b
	    var a, b;
	    if (cmp > 0) {
	      a = this;
	      b = num;
	    } else {
	      a = num;
	      b = this;
	    }

	    var carry = 0;
	    for (var i = 0; i < b.length; i++) {
	      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
	      carry = r >> 26;
	      this.words[i] = r & 0x3ffffff;
	    }
	    for (; carry !== 0 && i < a.length; i++) {
	      r = (a.words[i] | 0) + carry;
	      carry = r >> 26;
	      this.words[i] = r & 0x3ffffff;
	    }

	    // Copy rest of the words
	    if (carry === 0 && i < a.length && a !== this) {
	      for (; i < a.length; i++) {
	        this.words[i] = a.words[i];
	      }
	    }

	    this.length = Math.max(this.length, i);

	    if (a !== this) {
	      this.negative = 1;
	    }

	    return this._strip();
	  };

	  // Subtract `num` from `this`
	  BN.prototype.sub = function sub (num) {
	    return this.clone().isub(num);
	  };

	  function smallMulTo (self, num, out) {
	    out.negative = num.negative ^ self.negative;
	    var len = (self.length + num.length) | 0;
	    out.length = len;
	    len = (len - 1) | 0;

	    // Peel one iteration (compiler can't do it, because of code complexity)
	    var a = self.words[0] | 0;
	    var b = num.words[0] | 0;
	    var r = a * b;

	    var lo = r & 0x3ffffff;
	    var carry = (r / 0x4000000) | 0;
	    out.words[0] = lo;

	    for (var k = 1; k < len; k++) {
	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
	      // note that ncarry could be >= 0x3ffffff
	      var ncarry = carry >>> 26;
	      var rword = carry & 0x3ffffff;
	      var maxJ = Math.min(k, num.length - 1);
	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
	        var i = (k - j) | 0;
	        a = self.words[i] | 0;
	        b = num.words[j] | 0;
	        r = a * b + rword;
	        ncarry += (r / 0x4000000) | 0;
	        rword = r & 0x3ffffff;
	      }
	      out.words[k] = rword | 0;
	      carry = ncarry | 0;
	    }
	    if (carry !== 0) {
	      out.words[k] = carry | 0;
	    } else {
	      out.length--;
	    }

	    return out._strip();
	  }

	  // TODO(indutny): it may be reasonable to omit it for users who don't need
	  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
	  // multiplication (like elliptic secp256k1).
	  var comb10MulTo = function comb10MulTo (self, num, out) {
	    var a = self.words;
	    var b = num.words;
	    var o = out.words;
	    var c = 0;
	    var lo;
	    var mid;
	    var hi;
	    var a0 = a[0] | 0;
	    var al0 = a0 & 0x1fff;
	    var ah0 = a0 >>> 13;
	    var a1 = a[1] | 0;
	    var al1 = a1 & 0x1fff;
	    var ah1 = a1 >>> 13;
	    var a2 = a[2] | 0;
	    var al2 = a2 & 0x1fff;
	    var ah2 = a2 >>> 13;
	    var a3 = a[3] | 0;
	    var al3 = a3 & 0x1fff;
	    var ah3 = a3 >>> 13;
	    var a4 = a[4] | 0;
	    var al4 = a4 & 0x1fff;
	    var ah4 = a4 >>> 13;
	    var a5 = a[5] | 0;
	    var al5 = a5 & 0x1fff;
	    var ah5 = a5 >>> 13;
	    var a6 = a[6] | 0;
	    var al6 = a6 & 0x1fff;
	    var ah6 = a6 >>> 13;
	    var a7 = a[7] | 0;
	    var al7 = a7 & 0x1fff;
	    var ah7 = a7 >>> 13;
	    var a8 = a[8] | 0;
	    var al8 = a8 & 0x1fff;
	    var ah8 = a8 >>> 13;
	    var a9 = a[9] | 0;
	    var al9 = a9 & 0x1fff;
	    var ah9 = a9 >>> 13;
	    var b0 = b[0] | 0;
	    var bl0 = b0 & 0x1fff;
	    var bh0 = b0 >>> 13;
	    var b1 = b[1] | 0;
	    var bl1 = b1 & 0x1fff;
	    var bh1 = b1 >>> 13;
	    var b2 = b[2] | 0;
	    var bl2 = b2 & 0x1fff;
	    var bh2 = b2 >>> 13;
	    var b3 = b[3] | 0;
	    var bl3 = b3 & 0x1fff;
	    var bh3 = b3 >>> 13;
	    var b4 = b[4] | 0;
	    var bl4 = b4 & 0x1fff;
	    var bh4 = b4 >>> 13;
	    var b5 = b[5] | 0;
	    var bl5 = b5 & 0x1fff;
	    var bh5 = b5 >>> 13;
	    var b6 = b[6] | 0;
	    var bl6 = b6 & 0x1fff;
	    var bh6 = b6 >>> 13;
	    var b7 = b[7] | 0;
	    var bl7 = b7 & 0x1fff;
	    var bh7 = b7 >>> 13;
	    var b8 = b[8] | 0;
	    var bl8 = b8 & 0x1fff;
	    var bh8 = b8 >>> 13;
	    var b9 = b[9] | 0;
	    var bl9 = b9 & 0x1fff;
	    var bh9 = b9 >>> 13;

	    out.negative = self.negative ^ num.negative;
	    out.length = 19;
	    /* k = 0 */
	    lo = Math.imul(al0, bl0);
	    mid = Math.imul(al0, bh0);
	    mid = (mid + Math.imul(ah0, bl0)) | 0;
	    hi = Math.imul(ah0, bh0);
	    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
	    w0 &= 0x3ffffff;
	    /* k = 1 */
	    lo = Math.imul(al1, bl0);
	    mid = Math.imul(al1, bh0);
	    mid = (mid + Math.imul(ah1, bl0)) | 0;
	    hi = Math.imul(ah1, bh0);
	    lo = (lo + Math.imul(al0, bl1)) | 0;
	    mid = (mid + Math.imul(al0, bh1)) | 0;
	    mid = (mid + Math.imul(ah0, bl1)) | 0;
	    hi = (hi + Math.imul(ah0, bh1)) | 0;
	    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
	    w1 &= 0x3ffffff;
	    /* k = 2 */
	    lo = Math.imul(al2, bl0);
	    mid = Math.imul(al2, bh0);
	    mid = (mid + Math.imul(ah2, bl0)) | 0;
	    hi = Math.imul(ah2, bh0);
	    lo = (lo + Math.imul(al1, bl1)) | 0;
	    mid = (mid + Math.imul(al1, bh1)) | 0;
	    mid = (mid + Math.imul(ah1, bl1)) | 0;
	    hi = (hi + Math.imul(ah1, bh1)) | 0;
	    lo = (lo + Math.imul(al0, bl2)) | 0;
	    mid = (mid + Math.imul(al0, bh2)) | 0;
	    mid = (mid + Math.imul(ah0, bl2)) | 0;
	    hi = (hi + Math.imul(ah0, bh2)) | 0;
	    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
	    w2 &= 0x3ffffff;
	    /* k = 3 */
	    lo = Math.imul(al3, bl0);
	    mid = Math.imul(al3, bh0);
	    mid = (mid + Math.imul(ah3, bl0)) | 0;
	    hi = Math.imul(ah3, bh0);
	    lo = (lo + Math.imul(al2, bl1)) | 0;
	    mid = (mid + Math.imul(al2, bh1)) | 0;
	    mid = (mid + Math.imul(ah2, bl1)) | 0;
	    hi = (hi + Math.imul(ah2, bh1)) | 0;
	    lo = (lo + Math.imul(al1, bl2)) | 0;
	    mid = (mid + Math.imul(al1, bh2)) | 0;
	    mid = (mid + Math.imul(ah1, bl2)) | 0;
	    hi = (hi + Math.imul(ah1, bh2)) | 0;
	    lo = (lo + Math.imul(al0, bl3)) | 0;
	    mid = (mid + Math.imul(al0, bh3)) | 0;
	    mid = (mid + Math.imul(ah0, bl3)) | 0;
	    hi = (hi + Math.imul(ah0, bh3)) | 0;
	    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
	    w3 &= 0x3ffffff;
	    /* k = 4 */
	    lo = Math.imul(al4, bl0);
	    mid = Math.imul(al4, bh0);
	    mid = (mid + Math.imul(ah4, bl0)) | 0;
	    hi = Math.imul(ah4, bh0);
	    lo = (lo + Math.imul(al3, bl1)) | 0;
	    mid = (mid + Math.imul(al3, bh1)) | 0;
	    mid = (mid + Math.imul(ah3, bl1)) | 0;
	    hi = (hi + Math.imul(ah3, bh1)) | 0;
	    lo = (lo + Math.imul(al2, bl2)) | 0;
	    mid = (mid + Math.imul(al2, bh2)) | 0;
	    mid = (mid + Math.imul(ah2, bl2)) | 0;
	    hi = (hi + Math.imul(ah2, bh2)) | 0;
	    lo = (lo + Math.imul(al1, bl3)) | 0;
	    mid = (mid + Math.imul(al1, bh3)) | 0;
	    mid = (mid + Math.imul(ah1, bl3)) | 0;
	    hi = (hi + Math.imul(ah1, bh3)) | 0;
	    lo = (lo + Math.imul(al0, bl4)) | 0;
	    mid = (mid + Math.imul(al0, bh4)) | 0;
	    mid = (mid + Math.imul(ah0, bl4)) | 0;
	    hi = (hi + Math.imul(ah0, bh4)) | 0;
	    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
	    w4 &= 0x3ffffff;
	    /* k = 5 */
	    lo = Math.imul(al5, bl0);
	    mid = Math.imul(al5, bh0);
	    mid = (mid + Math.imul(ah5, bl0)) | 0;
	    hi = Math.imul(ah5, bh0);
	    lo = (lo + Math.imul(al4, bl1)) | 0;
	    mid = (mid + Math.imul(al4, bh1)) | 0;
	    mid = (mid + Math.imul(ah4, bl1)) | 0;
	    hi = (hi + Math.imul(ah4, bh1)) | 0;
	    lo = (lo + Math.imul(al3, bl2)) | 0;
	    mid = (mid + Math.imul(al3, bh2)) | 0;
	    mid = (mid + Math.imul(ah3, bl2)) | 0;
	    hi = (hi + Math.imul(ah3, bh2)) | 0;
	    lo = (lo + Math.imul(al2, bl3)) | 0;
	    mid = (mid + Math.imul(al2, bh3)) | 0;
	    mid = (mid + Math.imul(ah2, bl3)) | 0;
	    hi = (hi + Math.imul(ah2, bh3)) | 0;
	    lo = (lo + Math.imul(al1, bl4)) | 0;
	    mid = (mid + Math.imul(al1, bh4)) | 0;
	    mid = (mid + Math.imul(ah1, bl4)) | 0;
	    hi = (hi + Math.imul(ah1, bh4)) | 0;
	    lo = (lo + Math.imul(al0, bl5)) | 0;
	    mid = (mid + Math.imul(al0, bh5)) | 0;
	    mid = (mid + Math.imul(ah0, bl5)) | 0;
	    hi = (hi + Math.imul(ah0, bh5)) | 0;
	    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
	    w5 &= 0x3ffffff;
	    /* k = 6 */
	    lo = Math.imul(al6, bl0);
	    mid = Math.imul(al6, bh0);
	    mid = (mid + Math.imul(ah6, bl0)) | 0;
	    hi = Math.imul(ah6, bh0);
	    lo = (lo + Math.imul(al5, bl1)) | 0;
	    mid = (mid + Math.imul(al5, bh1)) | 0;
	    mid = (mid + Math.imul(ah5, bl1)) | 0;
	    hi = (hi + Math.imul(ah5, bh1)) | 0;
	    lo = (lo + Math.imul(al4, bl2)) | 0;
	    mid = (mid + Math.imul(al4, bh2)) | 0;
	    mid = (mid + Math.imul(ah4, bl2)) | 0;
	    hi = (hi + Math.imul(ah4, bh2)) | 0;
	    lo = (lo + Math.imul(al3, bl3)) | 0;
	    mid = (mid + Math.imul(al3, bh3)) | 0;
	    mid = (mid + Math.imul(ah3, bl3)) | 0;
	    hi = (hi + Math.imul(ah3, bh3)) | 0;
	    lo = (lo + Math.imul(al2, bl4)) | 0;
	    mid = (mid + Math.imul(al2, bh4)) | 0;
	    mid = (mid + Math.imul(ah2, bl4)) | 0;
	    hi = (hi + Math.imul(ah2, bh4)) | 0;
	    lo = (lo + Math.imul(al1, bl5)) | 0;
	    mid = (mid + Math.imul(al1, bh5)) | 0;
	    mid = (mid + Math.imul(ah1, bl5)) | 0;
	    hi = (hi + Math.imul(ah1, bh5)) | 0;
	    lo = (lo + Math.imul(al0, bl6)) | 0;
	    mid = (mid + Math.imul(al0, bh6)) | 0;
	    mid = (mid + Math.imul(ah0, bl6)) | 0;
	    hi = (hi + Math.imul(ah0, bh6)) | 0;
	    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
	    w6 &= 0x3ffffff;
	    /* k = 7 */
	    lo = Math.imul(al7, bl0);
	    mid = Math.imul(al7, bh0);
	    mid = (mid + Math.imul(ah7, bl0)) | 0;
	    hi = Math.imul(ah7, bh0);
	    lo = (lo + Math.imul(al6, bl1)) | 0;
	    mid = (mid + Math.imul(al6, bh1)) | 0;
	    mid = (mid + Math.imul(ah6, bl1)) | 0;
	    hi = (hi + Math.imul(ah6, bh1)) | 0;
	    lo = (lo + Math.imul(al5, bl2)) | 0;
	    mid = (mid + Math.imul(al5, bh2)) | 0;
	    mid = (mid + Math.imul(ah5, bl2)) | 0;
	    hi = (hi + Math.imul(ah5, bh2)) | 0;
	    lo = (lo + Math.imul(al4, bl3)) | 0;
	    mid = (mid + Math.imul(al4, bh3)) | 0;
	    mid = (mid + Math.imul(ah4, bl3)) | 0;
	    hi = (hi + Math.imul(ah4, bh3)) | 0;
	    lo = (lo + Math.imul(al3, bl4)) | 0;
	    mid = (mid + Math.imul(al3, bh4)) | 0;
	    mid = (mid + Math.imul(ah3, bl4)) | 0;
	    hi = (hi + Math.imul(ah3, bh4)) | 0;
	    lo = (lo + Math.imul(al2, bl5)) | 0;
	    mid = (mid + Math.imul(al2, bh5)) | 0;
	    mid = (mid + Math.imul(ah2, bl5)) | 0;
	    hi = (hi + Math.imul(ah2, bh5)) | 0;
	    lo = (lo + Math.imul(al1, bl6)) | 0;
	    mid = (mid + Math.imul(al1, bh6)) | 0;
	    mid = (mid + Math.imul(ah1, bl6)) | 0;
	    hi = (hi + Math.imul(ah1, bh6)) | 0;
	    lo = (lo + Math.imul(al0, bl7)) | 0;
	    mid = (mid + Math.imul(al0, bh7)) | 0;
	    mid = (mid + Math.imul(ah0, bl7)) | 0;
	    hi = (hi + Math.imul(ah0, bh7)) | 0;
	    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
	    w7 &= 0x3ffffff;
	    /* k = 8 */
	    lo = Math.imul(al8, bl0);
	    mid = Math.imul(al8, bh0);
	    mid = (mid + Math.imul(ah8, bl0)) | 0;
	    hi = Math.imul(ah8, bh0);
	    lo = (lo + Math.imul(al7, bl1)) | 0;
	    mid = (mid + Math.imul(al7, bh1)) | 0;
	    mid = (mid + Math.imul(ah7, bl1)) | 0;
	    hi = (hi + Math.imul(ah7, bh1)) | 0;
	    lo = (lo + Math.imul(al6, bl2)) | 0;
	    mid = (mid + Math.imul(al6, bh2)) | 0;
	    mid = (mid + Math.imul(ah6, bl2)) | 0;
	    hi = (hi + Math.imul(ah6, bh2)) | 0;
	    lo = (lo + Math.imul(al5, bl3)) | 0;
	    mid = (mid + Math.imul(al5, bh3)) | 0;
	    mid = (mid + Math.imul(ah5, bl3)) | 0;
	    hi = (hi + Math.imul(ah5, bh3)) | 0;
	    lo = (lo + Math.imul(al4, bl4)) | 0;
	    mid = (mid + Math.imul(al4, bh4)) | 0;
	    mid = (mid + Math.imul(ah4, bl4)) | 0;
	    hi = (hi + Math.imul(ah4, bh4)) | 0;
	    lo = (lo + Math.imul(al3, bl5)) | 0;
	    mid = (mid + Math.imul(al3, bh5)) | 0;
	    mid = (mid + Math.imul(ah3, bl5)) | 0;
	    hi = (hi + Math.imul(ah3, bh5)) | 0;
	    lo = (lo + Math.imul(al2, bl6)) | 0;
	    mid = (mid + Math.imul(al2, bh6)) | 0;
	    mid = (mid + Math.imul(ah2, bl6)) | 0;
	    hi = (hi + Math.imul(ah2, bh6)) | 0;
	    lo = (lo + Math.imul(al1, bl7)) | 0;
	    mid = (mid + Math.imul(al1, bh7)) | 0;
	    mid = (mid + Math.imul(ah1, bl7)) | 0;
	    hi = (hi + Math.imul(ah1, bh7)) | 0;
	    lo = (lo + Math.imul(al0, bl8)) | 0;
	    mid = (mid + Math.imul(al0, bh8)) | 0;
	    mid = (mid + Math.imul(ah0, bl8)) | 0;
	    hi = (hi + Math.imul(ah0, bh8)) | 0;
	    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
	    w8 &= 0x3ffffff;
	    /* k = 9 */
	    lo = Math.imul(al9, bl0);
	    mid = Math.imul(al9, bh0);
	    mid = (mid + Math.imul(ah9, bl0)) | 0;
	    hi = Math.imul(ah9, bh0);
	    lo = (lo + Math.imul(al8, bl1)) | 0;
	    mid = (mid + Math.imul(al8, bh1)) | 0;
	    mid = (mid + Math.imul(ah8, bl1)) | 0;
	    hi = (hi + Math.imul(ah8, bh1)) | 0;
	    lo = (lo + Math.imul(al7, bl2)) | 0;
	    mid = (mid + Math.imul(al7, bh2)) | 0;
	    mid = (mid + Math.imul(ah7, bl2)) | 0;
	    hi = (hi + Math.imul(ah7, bh2)) | 0;
	    lo = (lo + Math.imul(al6, bl3)) | 0;
	    mid = (mid + Math.imul(al6, bh3)) | 0;
	    mid = (mid + Math.imul(ah6, bl3)) | 0;
	    hi = (hi + Math.imul(ah6, bh3)) | 0;
	    lo = (lo + Math.imul(al5, bl4)) | 0;
	    mid = (mid + Math.imul(al5, bh4)) | 0;
	    mid = (mid + Math.imul(ah5, bl4)) | 0;
	    hi = (hi + Math.imul(ah5, bh4)) | 0;
	    lo = (lo + Math.imul(al4, bl5)) | 0;
	    mid = (mid + Math.imul(al4, bh5)) | 0;
	    mid = (mid + Math.imul(ah4, bl5)) | 0;
	    hi = (hi + Math.imul(ah4, bh5)) | 0;
	    lo = (lo + Math.imul(al3, bl6)) | 0;
	    mid = (mid + Math.imul(al3, bh6)) | 0;
	    mid = (mid + Math.imul(ah3, bl6)) | 0;
	    hi = (hi + Math.imul(ah3, bh6)) | 0;
	    lo = (lo + Math.imul(al2, bl7)) | 0;
	    mid = (mid + Math.imul(al2, bh7)) | 0;
	    mid = (mid + Math.imul(ah2, bl7)) | 0;
	    hi = (hi + Math.imul(ah2, bh7)) | 0;
	    lo = (lo + Math.imul(al1, bl8)) | 0;
	    mid = (mid + Math.imul(al1, bh8)) | 0;
	    mid = (mid + Math.imul(ah1, bl8)) | 0;
	    hi = (hi + Math.imul(ah1, bh8)) | 0;
	    lo = (lo + Math.imul(al0, bl9)) | 0;
	    mid = (mid + Math.imul(al0, bh9)) | 0;
	    mid = (mid + Math.imul(ah0, bl9)) | 0;
	    hi = (hi + Math.imul(ah0, bh9)) | 0;
	    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
	    w9 &= 0x3ffffff;
	    /* k = 10 */
	    lo = Math.imul(al9, bl1);
	    mid = Math.imul(al9, bh1);
	    mid = (mid + Math.imul(ah9, bl1)) | 0;
	    hi = Math.imul(ah9, bh1);
	    lo = (lo + Math.imul(al8, bl2)) | 0;
	    mid = (mid + Math.imul(al8, bh2)) | 0;
	    mid = (mid + Math.imul(ah8, bl2)) | 0;
	    hi = (hi + Math.imul(ah8, bh2)) | 0;
	    lo = (lo + Math.imul(al7, bl3)) | 0;
	    mid = (mid + Math.imul(al7, bh3)) | 0;
	    mid = (mid + Math.imul(ah7, bl3)) | 0;
	    hi = (hi + Math.imul(ah7, bh3)) | 0;
	    lo = (lo + Math.imul(al6, bl4)) | 0;
	    mid = (mid + Math.imul(al6, bh4)) | 0;
	    mid = (mid + Math.imul(ah6, bl4)) | 0;
	    hi = (hi + Math.imul(ah6, bh4)) | 0;
	    lo = (lo + Math.imul(al5, bl5)) | 0;
	    mid = (mid + Math.imul(al5, bh5)) | 0;
	    mid = (mid + Math.imul(ah5, bl5)) | 0;
	    hi = (hi + Math.imul(ah5, bh5)) | 0;
	    lo = (lo + Math.imul(al4, bl6)) | 0;
	    mid = (mid + Math.imul(al4, bh6)) | 0;
	    mid = (mid + Math.imul(ah4, bl6)) | 0;
	    hi = (hi + Math.imul(ah4, bh6)) | 0;
	    lo = (lo + Math.imul(al3, bl7)) | 0;
	    mid = (mid + Math.imul(al3, bh7)) | 0;
	    mid = (mid + Math.imul(ah3, bl7)) | 0;
	    hi = (hi + Math.imul(ah3, bh7)) | 0;
	    lo = (lo + Math.imul(al2, bl8)) | 0;
	    mid = (mid + Math.imul(al2, bh8)) | 0;
	    mid = (mid + Math.imul(ah2, bl8)) | 0;
	    hi = (hi + Math.imul(ah2, bh8)) | 0;
	    lo = (lo + Math.imul(al1, bl9)) | 0;
	    mid = (mid + Math.imul(al1, bh9)) | 0;
	    mid = (mid + Math.imul(ah1, bl9)) | 0;
	    hi = (hi + Math.imul(ah1, bh9)) | 0;
	    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
	    w10 &= 0x3ffffff;
	    /* k = 11 */
	    lo = Math.imul(al9, bl2);
	    mid = Math.imul(al9, bh2);
	    mid = (mid + Math.imul(ah9, bl2)) | 0;
	    hi = Math.imul(ah9, bh2);
	    lo = (lo + Math.imul(al8, bl3)) | 0;
	    mid = (mid + Math.imul(al8, bh3)) | 0;
	    mid = (mid + Math.imul(ah8, bl3)) | 0;
	    hi = (hi + Math.imul(ah8, bh3)) | 0;
	    lo = (lo + Math.imul(al7, bl4)) | 0;
	    mid = (mid + Math.imul(al7, bh4)) | 0;
	    mid = (mid + Math.imul(ah7, bl4)) | 0;
	    hi = (hi + Math.imul(ah7, bh4)) | 0;
	    lo = (lo + Math.imul(al6, bl5)) | 0;
	    mid = (mid + Math.imul(al6, bh5)) | 0;
	    mid = (mid + Math.imul(ah6, bl5)) | 0;
	    hi = (hi + Math.imul(ah6, bh5)) | 0;
	    lo = (lo + Math.imul(al5, bl6)) | 0;
	    mid = (mid + Math.imul(al5, bh6)) | 0;
	    mid = (mid + Math.imul(ah5, bl6)) | 0;
	    hi = (hi + Math.imul(ah5, bh6)) | 0;
	    lo = (lo + Math.imul(al4, bl7)) | 0;
	    mid = (mid + Math.imul(al4, bh7)) | 0;
	    mid = (mid + Math.imul(ah4, bl7)) | 0;
	    hi = (hi + Math.imul(ah4, bh7)) | 0;
	    lo = (lo + Math.imul(al3, bl8)) | 0;
	    mid = (mid + Math.imul(al3, bh8)) | 0;
	    mid = (mid + Math.imul(ah3, bl8)) | 0;
	    hi = (hi + Math.imul(ah3, bh8)) | 0;
	    lo = (lo + Math.imul(al2, bl9)) | 0;
	    mid = (mid + Math.imul(al2, bh9)) | 0;
	    mid = (mid + Math.imul(ah2, bl9)) | 0;
	    hi = (hi + Math.imul(ah2, bh9)) | 0;
	    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
	    w11 &= 0x3ffffff;
	    /* k = 12 */
	    lo = Math.imul(al9, bl3);
	    mid = Math.imul(al9, bh3);
	    mid = (mid + Math.imul(ah9, bl3)) | 0;
	    hi = Math.imul(ah9, bh3);
	    lo = (lo + Math.imul(al8, bl4)) | 0;
	    mid = (mid + Math.imul(al8, bh4)) | 0;
	    mid = (mid + Math.imul(ah8, bl4)) | 0;
	    hi = (hi + Math.imul(ah8, bh4)) | 0;
	    lo = (lo + Math.imul(al7, bl5)) | 0;
	    mid = (mid + Math.imul(al7, bh5)) | 0;
	    mid = (mid + Math.imul(ah7, bl5)) | 0;
	    hi = (hi + Math.imul(ah7, bh5)) | 0;
	    lo = (lo + Math.imul(al6, bl6)) | 0;
	    mid = (mid + Math.imul(al6, bh6)) | 0;
	    mid = (mid + Math.imul(ah6, bl6)) | 0;
	    hi = (hi + Math.imul(ah6, bh6)) | 0;
	    lo = (lo + Math.imul(al5, bl7)) | 0;
	    mid = (mid + Math.imul(al5, bh7)) | 0;
	    mid = (mid + Math.imul(ah5, bl7)) | 0;
	    hi = (hi + Math.imul(ah5, bh7)) | 0;
	    lo = (lo + Math.imul(al4, bl8)) | 0;
	    mid = (mid + Math.imul(al4, bh8)) | 0;
	    mid = (mid + Math.imul(ah4, bl8)) | 0;
	    hi = (hi + Math.imul(ah4, bh8)) | 0;
	    lo = (lo + Math.imul(al3, bl9)) | 0;
	    mid = (mid + Math.imul(al3, bh9)) | 0;
	    mid = (mid + Math.imul(ah3, bl9)) | 0;
	    hi = (hi + Math.imul(ah3, bh9)) | 0;
	    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
	    w12 &= 0x3ffffff;
	    /* k = 13 */
	    lo = Math.imul(al9, bl4);
	    mid = Math.imul(al9, bh4);
	    mid = (mid + Math.imul(ah9, bl4)) | 0;
	    hi = Math.imul(ah9, bh4);
	    lo = (lo + Math.imul(al8, bl5)) | 0;
	    mid = (mid + Math.imul(al8, bh5)) | 0;
	    mid = (mid + Math.imul(ah8, bl5)) | 0;
	    hi = (hi + Math.imul(ah8, bh5)) | 0;
	    lo = (lo + Math.imul(al7, bl6)) | 0;
	    mid = (mid + Math.imul(al7, bh6)) | 0;
	    mid = (mid + Math.imul(ah7, bl6)) | 0;
	    hi = (hi + Math.imul(ah7, bh6)) | 0;
	    lo = (lo + Math.imul(al6, bl7)) | 0;
	    mid = (mid + Math.imul(al6, bh7)) | 0;
	    mid = (mid + Math.imul(ah6, bl7)) | 0;
	    hi = (hi + Math.imul(ah6, bh7)) | 0;
	    lo = (lo + Math.imul(al5, bl8)) | 0;
	    mid = (mid + Math.imul(al5, bh8)) | 0;
	    mid = (mid + Math.imul(ah5, bl8)) | 0;
	    hi = (hi + Math.imul(ah5, bh8)) | 0;
	    lo = (lo + Math.imul(al4, bl9)) | 0;
	    mid = (mid + Math.imul(al4, bh9)) | 0;
	    mid = (mid + Math.imul(ah4, bl9)) | 0;
	    hi = (hi + Math.imul(ah4, bh9)) | 0;
	    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
	    w13 &= 0x3ffffff;
	    /* k = 14 */
	    lo = Math.imul(al9, bl5);
	    mid = Math.imul(al9, bh5);
	    mid = (mid + Math.imul(ah9, bl5)) | 0;
	    hi = Math.imul(ah9, bh5);
	    lo = (lo + Math.imul(al8, bl6)) | 0;
	    mid = (mid + Math.imul(al8, bh6)) | 0;
	    mid = (mid + Math.imul(ah8, bl6)) | 0;
	    hi = (hi + Math.imul(ah8, bh6)) | 0;
	    lo = (lo + Math.imul(al7, bl7)) | 0;
	    mid = (mid + Math.imul(al7, bh7)) | 0;
	    mid = (mid + Math.imul(ah7, bl7)) | 0;
	    hi = (hi + Math.imul(ah7, bh7)) | 0;
	    lo = (lo + Math.imul(al6, bl8)) | 0;
	    mid = (mid + Math.imul(al6, bh8)) | 0;
	    mid = (mid + Math.imul(ah6, bl8)) | 0;
	    hi = (hi + Math.imul(ah6, bh8)) | 0;
	    lo = (lo + Math.imul(al5, bl9)) | 0;
	    mid = (mid + Math.imul(al5, bh9)) | 0;
	    mid = (mid + Math.imul(ah5, bl9)) | 0;
	    hi = (hi + Math.imul(ah5, bh9)) | 0;
	    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
	    w14 &= 0x3ffffff;
	    /* k = 15 */
	    lo = Math.imul(al9, bl6);
	    mid = Math.imul(al9, bh6);
	    mid = (mid + Math.imul(ah9, bl6)) | 0;
	    hi = Math.imul(ah9, bh6);
	    lo = (lo + Math.imul(al8, bl7)) | 0;
	    mid = (mid + Math.imul(al8, bh7)) | 0;
	    mid = (mid + Math.imul(ah8, bl7)) | 0;
	    hi = (hi + Math.imul(ah8, bh7)) | 0;
	    lo = (lo + Math.imul(al7, bl8)) | 0;
	    mid = (mid + Math.imul(al7, bh8)) | 0;
	    mid = (mid + Math.imul(ah7, bl8)) | 0;
	    hi = (hi + Math.imul(ah7, bh8)) | 0;
	    lo = (lo + Math.imul(al6, bl9)) | 0;
	    mid = (mid + Math.imul(al6, bh9)) | 0;
	    mid = (mid + Math.imul(ah6, bl9)) | 0;
	    hi = (hi + Math.imul(ah6, bh9)) | 0;
	    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
	    w15 &= 0x3ffffff;
	    /* k = 16 */
	    lo = Math.imul(al9, bl7);
	    mid = Math.imul(al9, bh7);
	    mid = (mid + Math.imul(ah9, bl7)) | 0;
	    hi = Math.imul(ah9, bh7);
	    lo = (lo + Math.imul(al8, bl8)) | 0;
	    mid = (mid + Math.imul(al8, bh8)) | 0;
	    mid = (mid + Math.imul(ah8, bl8)) | 0;
	    hi = (hi + Math.imul(ah8, bh8)) | 0;
	    lo = (lo + Math.imul(al7, bl9)) | 0;
	    mid = (mid + Math.imul(al7, bh9)) | 0;
	    mid = (mid + Math.imul(ah7, bl9)) | 0;
	    hi = (hi + Math.imul(ah7, bh9)) | 0;
	    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
	    w16 &= 0x3ffffff;
	    /* k = 17 */
	    lo = Math.imul(al9, bl8);
	    mid = Math.imul(al9, bh8);
	    mid = (mid + Math.imul(ah9, bl8)) | 0;
	    hi = Math.imul(ah9, bh8);
	    lo = (lo + Math.imul(al8, bl9)) | 0;
	    mid = (mid + Math.imul(al8, bh9)) | 0;
	    mid = (mid + Math.imul(ah8, bl9)) | 0;
	    hi = (hi + Math.imul(ah8, bh9)) | 0;
	    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
	    w17 &= 0x3ffffff;
	    /* k = 18 */
	    lo = Math.imul(al9, bl9);
	    mid = Math.imul(al9, bh9);
	    mid = (mid + Math.imul(ah9, bl9)) | 0;
	    hi = Math.imul(ah9, bh9);
	    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
	    w18 &= 0x3ffffff;
	    o[0] = w0;
	    o[1] = w1;
	    o[2] = w2;
	    o[3] = w3;
	    o[4] = w4;
	    o[5] = w5;
	    o[6] = w6;
	    o[7] = w7;
	    o[8] = w8;
	    o[9] = w9;
	    o[10] = w10;
	    o[11] = w11;
	    o[12] = w12;
	    o[13] = w13;
	    o[14] = w14;
	    o[15] = w15;
	    o[16] = w16;
	    o[17] = w17;
	    o[18] = w18;
	    if (c !== 0) {
	      o[19] = c;
	      out.length++;
	    }
	    return out;
	  };

	  // Polyfill comb
	  if (!Math.imul) {
	    comb10MulTo = smallMulTo;
	  }

	  function bigMulTo (self, num, out) {
	    out.negative = num.negative ^ self.negative;
	    out.length = self.length + num.length;

	    var carry = 0;
	    var hncarry = 0;
	    for (var k = 0; k < out.length - 1; k++) {
	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
	      // note that ncarry could be >= 0x3ffffff
	      var ncarry = hncarry;
	      hncarry = 0;
	      var rword = carry & 0x3ffffff;
	      var maxJ = Math.min(k, num.length - 1);
	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
	        var i = k - j;
	        var a = self.words[i] | 0;
	        var b = num.words[j] | 0;
	        var r = a * b;

	        var lo = r & 0x3ffffff;
	        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
	        lo = (lo + rword) | 0;
	        rword = lo & 0x3ffffff;
	        ncarry = (ncarry + (lo >>> 26)) | 0;

	        hncarry += ncarry >>> 26;
	        ncarry &= 0x3ffffff;
	      }
	      out.words[k] = rword;
	      carry = ncarry;
	      ncarry = hncarry;
	    }
	    if (carry !== 0) {
	      out.words[k] = carry;
	    } else {
	      out.length--;
	    }

	    return out._strip();
	  }

	  function jumboMulTo (self, num, out) {
	    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
	    // var fftm = new FFTM();
	    // return fftm.mulp(self, num, out);
	    return bigMulTo(self, num, out);
	  }

	  BN.prototype.mulTo = function mulTo (num, out) {
	    var res;
	    var len = this.length + num.length;
	    if (this.length === 10 && num.length === 10) {
	      res = comb10MulTo(this, num, out);
	    } else if (len < 63) {
	      res = smallMulTo(this, num, out);
	    } else if (len < 1024) {
	      res = bigMulTo(this, num, out);
	    } else {
	      res = jumboMulTo(this, num, out);
	    }

	    return res;
	  };

	  // Multiply `this` by `num`
	  BN.prototype.mul = function mul (num) {
	    var out = new BN(null);
	    out.words = new Array(this.length + num.length);
	    return this.mulTo(num, out);
	  };

	  // Multiply employing FFT
	  BN.prototype.mulf = function mulf (num) {
	    var out = new BN(null);
	    out.words = new Array(this.length + num.length);
	    return jumboMulTo(this, num, out);
	  };

	  // In-place Multiplication
	  BN.prototype.imul = function imul (num) {
	    return this.clone().mulTo(num, this);
	  };

	  BN.prototype.imuln = function imuln (num) {
	    var isNegNum = num < 0;
	    if (isNegNum) num = -num;

	    assert(typeof num === 'number');
	    assert(num < 0x4000000);

	    // Carry
	    var carry = 0;
	    for (var i = 0; i < this.length; i++) {
	      var w = (this.words[i] | 0) * num;
	      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
	      carry >>= 26;
	      carry += (w / 0x4000000) | 0;
	      // NOTE: lo is 27bit maximum
	      carry += lo >>> 26;
	      this.words[i] = lo & 0x3ffffff;
	    }

	    if (carry !== 0) {
	      this.words[i] = carry;
	      this.length++;
	    }
	    this.length = num === 0 ? 1 : this.length;

	    return isNegNum ? this.ineg() : this;
	  };

	  BN.prototype.muln = function muln (num) {
	    return this.clone().imuln(num);
	  };

	  // `this` * `this`
	  BN.prototype.sqr = function sqr () {
	    return this.mul(this);
	  };

	  // `this` * `this` in-place
	  BN.prototype.isqr = function isqr () {
	    return this.imul(this.clone());
	  };

	  // Math.pow(`this`, `num`)
	  BN.prototype.pow = function pow (num) {
	    var w = toBitArray(num);
	    if (w.length === 0) return new BN(1);

	    // Skip leading zeroes
	    var res = this;
	    for (var i = 0; i < w.length; i++, res = res.sqr()) {
	      if (w[i] !== 0) break;
	    }

	    if (++i < w.length) {
	      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
	        if (w[i] === 0) continue;

	        res = res.mul(q);
	      }
	    }

	    return res;
	  };

	  // Shift-left in-place
	  BN.prototype.iushln = function iushln (bits) {
	    assert(typeof bits === 'number' && bits >= 0);
	    var r = bits % 26;
	    var s = (bits - r) / 26;
	    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
	    var i;

	    if (r !== 0) {
	      var carry = 0;

	      for (i = 0; i < this.length; i++) {
	        var newCarry = this.words[i] & carryMask;
	        var c = ((this.words[i] | 0) - newCarry) << r;
	        this.words[i] = c | carry;
	        carry = newCarry >>> (26 - r);
	      }

	      if (carry) {
	        this.words[i] = carry;
	        this.length++;
	      }
	    }

	    if (s !== 0) {
	      for (i = this.length - 1; i >= 0; i--) {
	        this.words[i + s] = this.words[i];
	      }

	      for (i = 0; i < s; i++) {
	        this.words[i] = 0;
	      }

	      this.length += s;
	    }

	    return this._strip();
	  };

	  BN.prototype.ishln = function ishln (bits) {
	    // TODO(indutny): implement me
	    assert(this.negative === 0);
	    return this.iushln(bits);
	  };

	  // Shift-right in-place
	  // NOTE: `hint` is a lowest bit before trailing zeroes
	  // NOTE: if `extended` is present - it will be filled with destroyed bits
	  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
	    assert(typeof bits === 'number' && bits >= 0);
	    var h;
	    if (hint) {
	      h = (hint - (hint % 26)) / 26;
	    } else {
	      h = 0;
	    }

	    var r = bits % 26;
	    var s = Math.min((bits - r) / 26, this.length);
	    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
	    var maskedWords = extended;

	    h -= s;
	    h = Math.max(0, h);

	    // Extended mode, copy masked part
	    if (maskedWords) {
	      for (var i = 0; i < s; i++) {
	        maskedWords.words[i] = this.words[i];
	      }
	      maskedWords.length = s;
	    }

	    if (s === 0) ; else if (this.length > s) {
	      this.length -= s;
	      for (i = 0; i < this.length; i++) {
	        this.words[i] = this.words[i + s];
	      }
	    } else {
	      this.words[0] = 0;
	      this.length = 1;
	    }

	    var carry = 0;
	    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
	      var word = this.words[i] | 0;
	      this.words[i] = (carry << (26 - r)) | (word >>> r);
	      carry = word & mask;
	    }

	    // Push carried bits as a mask
	    if (maskedWords && carry !== 0) {
	      maskedWords.words[maskedWords.length++] = carry;
	    }

	    if (this.length === 0) {
	      this.words[0] = 0;
	      this.length = 1;
	    }

	    return this._strip();
	  };

	  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
	    // TODO(indutny): implement me
	    assert(this.negative === 0);
	    return this.iushrn(bits, hint, extended);
	  };

	  // Shift-left
	  BN.prototype.shln = function shln (bits) {
	    return this.clone().ishln(bits);
	  };

	  BN.prototype.ushln = function ushln (bits) {
	    return this.clone().iushln(bits);
	  };

	  // Shift-right
	  BN.prototype.shrn = function shrn (bits) {
	    return this.clone().ishrn(bits);
	  };

	  BN.prototype.ushrn = function ushrn (bits) {
	    return this.clone().iushrn(bits);
	  };

	  // Test if n bit is set
	  BN.prototype.testn = function testn (bit) {
	    assert(typeof bit === 'number' && bit >= 0);
	    var r = bit % 26;
	    var s = (bit - r) / 26;
	    var q = 1 << r;

	    // Fast case: bit is much higher than all existing words
	    if (this.length <= s) return false;

	    // Check bit and return
	    var w = this.words[s];

	    return !!(w & q);
	  };

	  // Return only lowers bits of number (in-place)
	  BN.prototype.imaskn = function imaskn (bits) {
	    assert(typeof bits === 'number' && bits >= 0);
	    var r = bits % 26;
	    var s = (bits - r) / 26;

	    assert(this.negative === 0, 'imaskn works only with positive numbers');

	    if (this.length <= s) {
	      return this;
	    }

	    if (r !== 0) {
	      s++;
	    }
	    this.length = Math.min(s, this.length);

	    if (r !== 0) {
	      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
	      this.words[this.length - 1] &= mask;
	    }

	    return this._strip();
	  };

	  // Return only lowers bits of number
	  BN.prototype.maskn = function maskn (bits) {
	    return this.clone().imaskn(bits);
	  };

	  // Add plain number `num` to `this`
	  BN.prototype.iaddn = function iaddn (num) {
	    assert(typeof num === 'number');
	    assert(num < 0x4000000);
	    if (num < 0) return this.isubn(-num);

	    // Possible sign change
	    if (this.negative !== 0) {
	      if (this.length === 1 && (this.words[0] | 0) <= num) {
	        this.words[0] = num - (this.words[0] | 0);
	        this.negative = 0;
	        return this;
	      }

	      this.negative = 0;
	      this.isubn(num);
	      this.negative = 1;
	      return this;
	    }

	    // Add without checks
	    return this._iaddn(num);
	  };

	  BN.prototype._iaddn = function _iaddn (num) {
	    this.words[0] += num;

	    // Carry
	    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
	      this.words[i] -= 0x4000000;
	      if (i === this.length - 1) {
	        this.words[i + 1] = 1;
	      } else {
	        this.words[i + 1]++;
	      }
	    }
	    this.length = Math.max(this.length, i + 1);

	    return this;
	  };

	  // Subtract plain number `num` from `this`
	  BN.prototype.isubn = function isubn (num) {
	    assert(typeof num === 'number');
	    assert(num < 0x4000000);
	    if (num < 0) return this.iaddn(-num);

	    if (this.negative !== 0) {
	      this.negative = 0;
	      this.iaddn(num);
	      this.negative = 1;
	      return this;
	    }

	    this.words[0] -= num;

	    if (this.length === 1 && this.words[0] < 0) {
	      this.words[0] = -this.words[0];
	      this.negative = 1;
	    } else {
	      // Carry
	      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
	        this.words[i] += 0x4000000;
	        this.words[i + 1] -= 1;
	      }
	    }

	    return this._strip();
	  };

	  BN.prototype.addn = function addn (num) {
	    return this.clone().iaddn(num);
	  };

	  BN.prototype.subn = function subn (num) {
	    return this.clone().isubn(num);
	  };

	  BN.prototype.iabs = function iabs () {
	    this.negative = 0;

	    return this;
	  };

	  BN.prototype.abs = function abs () {
	    return this.clone().iabs();
	  };

	  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
	    var len = num.length + shift;
	    var i;

	    this._expand(len);

	    var w;
	    var carry = 0;
	    for (i = 0; i < num.length; i++) {
	      w = (this.words[i + shift] | 0) + carry;
	      var right = (num.words[i] | 0) * mul;
	      w -= right & 0x3ffffff;
	      carry = (w >> 26) - ((right / 0x4000000) | 0);
	      this.words[i + shift] = w & 0x3ffffff;
	    }
	    for (; i < this.length - shift; i++) {
	      w = (this.words[i + shift] | 0) + carry;
	      carry = w >> 26;
	      this.words[i + shift] = w & 0x3ffffff;
	    }

	    if (carry === 0) return this._strip();

	    // Subtraction overflow
	    assert(carry === -1);
	    carry = 0;
	    for (i = 0; i < this.length; i++) {
	      w = -(this.words[i] | 0) + carry;
	      carry = w >> 26;
	      this.words[i] = w & 0x3ffffff;
	    }
	    this.negative = 1;

	    return this._strip();
	  };

	  BN.prototype._wordDiv = function _wordDiv (num, mode) {
	    var shift = this.length - num.length;

	    var a = this.clone();
	    var b = num;

	    // Normalize
	    var bhi = b.words[b.length - 1] | 0;
	    var bhiBits = this._countBits(bhi);
	    shift = 26 - bhiBits;
	    if (shift !== 0) {
	      b = b.ushln(shift);
	      a.iushln(shift);
	      bhi = b.words[b.length - 1] | 0;
	    }

	    // Initialize quotient
	    var m = a.length - b.length;
	    var q;

	    if (mode !== 'mod') {
	      q = new BN(null);
	      q.length = m + 1;
	      q.words = new Array(q.length);
	      for (var i = 0; i < q.length; i++) {
	        q.words[i] = 0;
	      }
	    }

	    var diff = a.clone()._ishlnsubmul(b, 1, m);
	    if (diff.negative === 0) {
	      a = diff;
	      if (q) {
	        q.words[m] = 1;
	      }
	    }

	    for (var j = m - 1; j >= 0; j--) {
	      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
	        (a.words[b.length + j - 1] | 0);

	      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
	      // (0x7ffffff)
	      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

	      a._ishlnsubmul(b, qj, j);
	      while (a.negative !== 0) {
	        qj--;
	        a.negative = 0;
	        a._ishlnsubmul(b, 1, j);
	        if (!a.isZero()) {
	          a.negative ^= 1;
	        }
	      }
	      if (q) {
	        q.words[j] = qj;
	      }
	    }
	    if (q) {
	      q._strip();
	    }
	    a._strip();

	    // Denormalize
	    if (mode !== 'div' && shift !== 0) {
	      a.iushrn(shift);
	    }

	    return {
	      div: q || null,
	      mod: a
	    };
	  };

	  // NOTE: 1) `mode` can be set to `mod` to request mod only,
	  //       to `div` to request div only, or be absent to
	  //       request both div & mod
	  //       2) `positive` is true if unsigned mod is requested
	  BN.prototype.divmod = function divmod (num, mode, positive) {
	    assert(!num.isZero());

	    if (this.isZero()) {
	      return {
	        div: new BN(0),
	        mod: new BN(0)
	      };
	    }

	    var div, mod, res;
	    if (this.negative !== 0 && num.negative === 0) {
	      res = this.neg().divmod(num, mode);

	      if (mode !== 'mod') {
	        div = res.div.neg();
	      }

	      if (mode !== 'div') {
	        mod = res.mod.neg();
	        if (positive && mod.negative !== 0) {
	          mod.iadd(num);
	        }
	      }

	      return {
	        div: div,
	        mod: mod
	      };
	    }

	    if (this.negative === 0 && num.negative !== 0) {
	      res = this.divmod(num.neg(), mode);

	      if (mode !== 'mod') {
	        div = res.div.neg();
	      }

	      return {
	        div: div,
	        mod: res.mod
	      };
	    }

	    if ((this.negative & num.negative) !== 0) {
	      res = this.neg().divmod(num.neg(), mode);

	      if (mode !== 'div') {
	        mod = res.mod.neg();
	        if (positive && mod.negative !== 0) {
	          mod.isub(num);
	        }
	      }

	      return {
	        div: res.div,
	        mod: mod
	      };
	    }

	    // Both numbers are positive at this point

	    // Strip both numbers to approximate shift value
	    if (num.length > this.length || this.cmp(num) < 0) {
	      return {
	        div: new BN(0),
	        mod: this
	      };
	    }

	    // Very short reduction
	    if (num.length === 1) {
	      if (mode === 'div') {
	        return {
	          div: this.divn(num.words[0]),
	          mod: null
	        };
	      }

	      if (mode === 'mod') {
	        return {
	          div: null,
	          mod: new BN(this.modrn(num.words[0]))
	        };
	      }

	      return {
	        div: this.divn(num.words[0]),
	        mod: new BN(this.modrn(num.words[0]))
	      };
	    }

	    return this._wordDiv(num, mode);
	  };

	  // Find `this` / `num`
	  BN.prototype.div = function div (num) {
	    return this.divmod(num, 'div', false).div;
	  };

	  // Find `this` % `num`
	  BN.prototype.mod = function mod (num) {
	    return this.divmod(num, 'mod', false).mod;
	  };

	  BN.prototype.umod = function umod (num) {
	    return this.divmod(num, 'mod', true).mod;
	  };

	  // Find Round(`this` / `num`)
	  BN.prototype.divRound = function divRound (num) {
	    var dm = this.divmod(num);

	    // Fast case - exact division
	    if (dm.mod.isZero()) return dm.div;

	    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

	    var half = num.ushrn(1);
	    var r2 = num.andln(1);
	    var cmp = mod.cmp(half);

	    // Round down
	    if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div;

	    // Round up
	    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
	  };

	  BN.prototype.modrn = function modrn (num) {
	    var isNegNum = num < 0;
	    if (isNegNum) num = -num;

	    assert(num <= 0x3ffffff);
	    var p = (1 << 26) % num;

	    var acc = 0;
	    for (var i = this.length - 1; i >= 0; i--) {
	      acc = (p * acc + (this.words[i] | 0)) % num;
	    }

	    return isNegNum ? -acc : acc;
	  };

	  // WARNING: DEPRECATED
	  BN.prototype.modn = function modn (num) {
	    return this.modrn(num);
	  };

	  // In-place division by number
	  BN.prototype.idivn = function idivn (num) {
	    var isNegNum = num < 0;
	    if (isNegNum) num = -num;

	    assert(num <= 0x3ffffff);

	    var carry = 0;
	    for (var i = this.length - 1; i >= 0; i--) {
	      var w = (this.words[i] | 0) + carry * 0x4000000;
	      this.words[i] = (w / num) | 0;
	      carry = w % num;
	    }

	    this._strip();
	    return isNegNum ? this.ineg() : this;
	  };

	  BN.prototype.divn = function divn (num) {
	    return this.clone().idivn(num);
	  };

	  BN.prototype.egcd = function egcd (p) {
	    assert(p.negative === 0);
	    assert(!p.isZero());

	    var x = this;
	    var y = p.clone();

	    if (x.negative !== 0) {
	      x = x.umod(p);
	    } else {
	      x = x.clone();
	    }

	    // A * x + B * y = x
	    var A = new BN(1);
	    var B = new BN(0);

	    // C * x + D * y = y
	    var C = new BN(0);
	    var D = new BN(1);

	    var g = 0;

	    while (x.isEven() && y.isEven()) {
	      x.iushrn(1);
	      y.iushrn(1);
	      ++g;
	    }

	    var yp = y.clone();
	    var xp = x.clone();

	    while (!x.isZero()) {
	      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
	      if (i > 0) {
	        x.iushrn(i);
	        while (i-- > 0) {
	          if (A.isOdd() || B.isOdd()) {
	            A.iadd(yp);
	            B.isub(xp);
	          }

	          A.iushrn(1);
	          B.iushrn(1);
	        }
	      }

	      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
	      if (j > 0) {
	        y.iushrn(j);
	        while (j-- > 0) {
	          if (C.isOdd() || D.isOdd()) {
	            C.iadd(yp);
	            D.isub(xp);
	          }

	          C.iushrn(1);
	          D.iushrn(1);
	        }
	      }

	      if (x.cmp(y) >= 0) {
	        x.isub(y);
	        A.isub(C);
	        B.isub(D);
	      } else {
	        y.isub(x);
	        C.isub(A);
	        D.isub(B);
	      }
	    }

	    return {
	      a: C,
	      b: D,
	      gcd: y.iushln(g)
	    };
	  };

	  // This is reduced incarnation of the binary EEA
	  // above, designated to invert members of the
	  // _prime_ fields F(p) at a maximal speed
	  BN.prototype._invmp = function _invmp (p) {
	    assert(p.negative === 0);
	    assert(!p.isZero());

	    var a = this;
	    var b = p.clone();

	    if (a.negative !== 0) {
	      a = a.umod(p);
	    } else {
	      a = a.clone();
	    }

	    var x1 = new BN(1);
	    var x2 = new BN(0);

	    var delta = b.clone();

	    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
	      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
	      if (i > 0) {
	        a.iushrn(i);
	        while (i-- > 0) {
	          if (x1.isOdd()) {
	            x1.iadd(delta);
	          }

	          x1.iushrn(1);
	        }
	      }

	      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
	      if (j > 0) {
	        b.iushrn(j);
	        while (j-- > 0) {
	          if (x2.isOdd()) {
	            x2.iadd(delta);
	          }

	          x2.iushrn(1);
	        }
	      }

	      if (a.cmp(b) >= 0) {
	        a.isub(b);
	        x1.isub(x2);
	      } else {
	        b.isub(a);
	        x2.isub(x1);
	      }
	    }

	    var res;
	    if (a.cmpn(1) === 0) {
	      res = x1;
	    } else {
	      res = x2;
	    }

	    if (res.cmpn(0) < 0) {
	      res.iadd(p);
	    }

	    return res;
	  };

	  BN.prototype.gcd = function gcd (num) {
	    if (this.isZero()) return num.abs();
	    if (num.isZero()) return this.abs();

	    var a = this.clone();
	    var b = num.clone();
	    a.negative = 0;
	    b.negative = 0;

	    // Remove common factor of two
	    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
	      a.iushrn(1);
	      b.iushrn(1);
	    }

	    do {
	      while (a.isEven()) {
	        a.iushrn(1);
	      }
	      while (b.isEven()) {
	        b.iushrn(1);
	      }

	      var r = a.cmp(b);
	      if (r < 0) {
	        // Swap `a` and `b` to make `a` always bigger than `b`
	        var t = a;
	        a = b;
	        b = t;
	      } else if (r === 0 || b.cmpn(1) === 0) {
	        break;
	      }

	      a.isub(b);
	    } while (true);

	    return b.iushln(shift);
	  };

	  // Invert number in the field F(num)
	  BN.prototype.invm = function invm (num) {
	    return this.egcd(num).a.umod(num);
	  };

	  BN.prototype.isEven = function isEven () {
	    return (this.words[0] & 1) === 0;
	  };

	  BN.prototype.isOdd = function isOdd () {
	    return (this.words[0] & 1) === 1;
	  };

	  // And first word and num
	  BN.prototype.andln = function andln (num) {
	    return this.words[0] & num;
	  };

	  // Increment at the bit position in-line
	  BN.prototype.bincn = function bincn (bit) {
	    assert(typeof bit === 'number');
	    var r = bit % 26;
	    var s = (bit - r) / 26;
	    var q = 1 << r;

	    // Fast case: bit is much higher than all existing words
	    if (this.length <= s) {
	      this._expand(s + 1);
	      this.words[s] |= q;
	      return this;
	    }

	    // Add bit and propagate, if needed
	    var carry = q;
	    for (var i = s; carry !== 0 && i < this.length; i++) {
	      var w = this.words[i] | 0;
	      w += carry;
	      carry = w >>> 26;
	      w &= 0x3ffffff;
	      this.words[i] = w;
	    }
	    if (carry !== 0) {
	      this.words[i] = carry;
	      this.length++;
	    }
	    return this;
	  };

	  BN.prototype.isZero = function isZero () {
	    return this.length === 1 && this.words[0] === 0;
	  };

	  BN.prototype.cmpn = function cmpn (num) {
	    var negative = num < 0;

	    if (this.negative !== 0 && !negative) return -1;
	    if (this.negative === 0 && negative) return 1;

	    this._strip();

	    var res;
	    if (this.length > 1) {
	      res = 1;
	    } else {
	      if (negative) {
	        num = -num;
	      }

	      assert(num <= 0x3ffffff, 'Number is too big');

	      var w = this.words[0] | 0;
	      res = w === num ? 0 : w < num ? -1 : 1;
	    }
	    if (this.negative !== 0) return -res | 0;
	    return res;
	  };

	  // Compare two numbers and return:
	  // 1 - if `this` > `num`
	  // 0 - if `this` == `num`
	  // -1 - if `this` < `num`
	  BN.prototype.cmp = function cmp (num) {
	    if (this.negative !== 0 && num.negative === 0) return -1;
	    if (this.negative === 0 && num.negative !== 0) return 1;

	    var res = this.ucmp(num);
	    if (this.negative !== 0) return -res | 0;
	    return res;
	  };

	  // Unsigned comparison
	  BN.prototype.ucmp = function ucmp (num) {
	    // At this point both numbers have the same sign
	    if (this.length > num.length) return 1;
	    if (this.length < num.length) return -1;

	    var res = 0;
	    for (var i = this.length - 1; i >= 0; i--) {
	      var a = this.words[i] | 0;
	      var b = num.words[i] | 0;

	      if (a === b) continue;
	      if (a < b) {
	        res = -1;
	      } else if (a > b) {
	        res = 1;
	      }
	      break;
	    }
	    return res;
	  };

	  BN.prototype.gtn = function gtn (num) {
	    return this.cmpn(num) === 1;
	  };

	  BN.prototype.gt = function gt (num) {
	    return this.cmp(num) === 1;
	  };

	  BN.prototype.gten = function gten (num) {
	    return this.cmpn(num) >= 0;
	  };

	  BN.prototype.gte = function gte (num) {
	    return this.cmp(num) >= 0;
	  };

	  BN.prototype.ltn = function ltn (num) {
	    return this.cmpn(num) === -1;
	  };

	  BN.prototype.lt = function lt (num) {
	    return this.cmp(num) === -1;
	  };

	  BN.prototype.lten = function lten (num) {
	    return this.cmpn(num) <= 0;
	  };

	  BN.prototype.lte = function lte (num) {
	    return this.cmp(num) <= 0;
	  };

	  BN.prototype.eqn = function eqn (num) {
	    return this.cmpn(num) === 0;
	  };

	  BN.prototype.eq = function eq (num) {
	    return this.cmp(num) === 0;
	  };

	  //
	  // A reduce context, could be using montgomery or something better, depending
	  // on the `m` itself.
	  //
	  BN.red = function red (num) {
	    return new Red(num);
	  };

	  BN.prototype.toRed = function toRed (ctx) {
	    assert(!this.red, 'Already a number in reduction context');
	    assert(this.negative === 0, 'red works only with positives');
	    return ctx.convertTo(this)._forceRed(ctx);
	  };

	  BN.prototype.fromRed = function fromRed () {
	    assert(this.red, 'fromRed works only with numbers in reduction context');
	    return this.red.convertFrom(this);
	  };

	  BN.prototype._forceRed = function _forceRed (ctx) {
	    this.red = ctx;
	    return this;
	  };

	  BN.prototype.forceRed = function forceRed (ctx) {
	    assert(!this.red, 'Already a number in reduction context');
	    return this._forceRed(ctx);
	  };

	  BN.prototype.redAdd = function redAdd (num) {
	    assert(this.red, 'redAdd works only with red numbers');
	    return this.red.add(this, num);
	  };

	  BN.prototype.redIAdd = function redIAdd (num) {
	    assert(this.red, 'redIAdd works only with red numbers');
	    return this.red.iadd(this, num);
	  };

	  BN.prototype.redSub = function redSub (num) {
	    assert(this.red, 'redSub works only with red numbers');
	    return this.red.sub(this, num);
	  };

	  BN.prototype.redISub = function redISub (num) {
	    assert(this.red, 'redISub works only with red numbers');
	    return this.red.isub(this, num);
	  };

	  BN.prototype.redShl = function redShl (num) {
	    assert(this.red, 'redShl works only with red numbers');
	    return this.red.shl(this, num);
	  };

	  BN.prototype.redMul = function redMul (num) {
	    assert(this.red, 'redMul works only with red numbers');
	    this.red._verify2(this, num);
	    return this.red.mul(this, num);
	  };

	  BN.prototype.redIMul = function redIMul (num) {
	    assert(this.red, 'redMul works only with red numbers');
	    this.red._verify2(this, num);
	    return this.red.imul(this, num);
	  };

	  BN.prototype.redSqr = function redSqr () {
	    assert(this.red, 'redSqr works only with red numbers');
	    this.red._verify1(this);
	    return this.red.sqr(this);
	  };

	  BN.prototype.redISqr = function redISqr () {
	    assert(this.red, 'redISqr works only with red numbers');
	    this.red._verify1(this);
	    return this.red.isqr(this);
	  };

	  // Square root over p
	  BN.prototype.redSqrt = function redSqrt () {
	    assert(this.red, 'redSqrt works only with red numbers');
	    this.red._verify1(this);
	    return this.red.sqrt(this);
	  };

	  BN.prototype.redInvm = function redInvm () {
	    assert(this.red, 'redInvm works only with red numbers');
	    this.red._verify1(this);
	    return this.red.invm(this);
	  };

	  // Return negative clone of `this` % `red modulo`
	  BN.prototype.redNeg = function redNeg () {
	    assert(this.red, 'redNeg works only with red numbers');
	    this.red._verify1(this);
	    return this.red.neg(this);
	  };

	  BN.prototype.redPow = function redPow (num) {
	    assert(this.red && !num.red, 'redPow(normalNum)');
	    this.red._verify1(this);
	    return this.red.pow(this, num);
	  };

	  // Prime numbers with efficient reduction
	  var primes = {
	    k256: null,
	    p224: null,
	    p192: null,
	    p25519: null
	  };

	  // Pseudo-Mersenne prime
	  function MPrime (name, p) {
	    // P = 2 ^ N - K
	    this.name = name;
	    this.p = new BN(p, 16);
	    this.n = this.p.bitLength();
	    this.k = new BN(1).iushln(this.n).isub(this.p);

	    this.tmp = this._tmp();
	  }

	  MPrime.prototype._tmp = function _tmp () {
	    var tmp = new BN(null);
	    tmp.words = new Array(Math.ceil(this.n / 13));
	    return tmp;
	  };

	  MPrime.prototype.ireduce = function ireduce (num) {
	    // Assumes that `num` is less than `P^2`
	    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
	    var r = num;
	    var rlen;

	    do {
	      this.split(r, this.tmp);
	      r = this.imulK(r);
	      r = r.iadd(this.tmp);
	      rlen = r.bitLength();
	    } while (rlen > this.n);

	    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
	    if (cmp === 0) {
	      r.words[0] = 0;
	      r.length = 1;
	    } else if (cmp > 0) {
	      r.isub(this.p);
	    } else {
	      if (r.strip !== undefined) {
	        // r is a BN v4 instance
	        r.strip();
	      } else {
	        // r is a BN v5 instance
	        r._strip();
	      }
	    }

	    return r;
	  };

	  MPrime.prototype.split = function split (input, out) {
	    input.iushrn(this.n, 0, out);
	  };

	  MPrime.prototype.imulK = function imulK (num) {
	    return num.imul(this.k);
	  };

	  function K256 () {
	    MPrime.call(
	      this,
	      'k256',
	      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
	  }
	  inherits(K256, MPrime);

	  K256.prototype.split = function split (input, output) {
	    // 256 = 9 * 26 + 22
	    var mask = 0x3fffff;

	    var outLen = Math.min(input.length, 9);
	    for (var i = 0; i < outLen; i++) {
	      output.words[i] = input.words[i];
	    }
	    output.length = outLen;

	    if (input.length <= 9) {
	      input.words[0] = 0;
	      input.length = 1;
	      return;
	    }

	    // Shift by 9 limbs
	    var prev = input.words[9];
	    output.words[output.length++] = prev & mask;

	    for (i = 10; i < input.length; i++) {
	      var next = input.words[i] | 0;
	      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
	      prev = next;
	    }
	    prev >>>= 22;
	    input.words[i - 10] = prev;
	    if (prev === 0 && input.length > 10) {
	      input.length -= 10;
	    } else {
	      input.length -= 9;
	    }
	  };

	  K256.prototype.imulK = function imulK (num) {
	    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
	    num.words[num.length] = 0;
	    num.words[num.length + 1] = 0;
	    num.length += 2;

	    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
	    var lo = 0;
	    for (var i = 0; i < num.length; i++) {
	      var w = num.words[i] | 0;
	      lo += w * 0x3d1;
	      num.words[i] = lo & 0x3ffffff;
	      lo = w * 0x40 + ((lo / 0x4000000) | 0);
	    }

	    // Fast length reduction
	    if (num.words[num.length - 1] === 0) {
	      num.length--;
	      if (num.words[num.length - 1] === 0) {
	        num.length--;
	      }
	    }
	    return num;
	  };

	  function P224 () {
	    MPrime.call(
	      this,
	      'p224',
	      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
	  }
	  inherits(P224, MPrime);

	  function P192 () {
	    MPrime.call(
	      this,
	      'p192',
	      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
	  }
	  inherits(P192, MPrime);

	  function P25519 () {
	    // 2 ^ 255 - 19
	    MPrime.call(
	      this,
	      '25519',
	      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
	  }
	  inherits(P25519, MPrime);

	  P25519.prototype.imulK = function imulK (num) {
	    // K = 0x13
	    var carry = 0;
	    for (var i = 0; i < num.length; i++) {
	      var hi = (num.words[i] | 0) * 0x13 + carry;
	      var lo = hi & 0x3ffffff;
	      hi >>>= 26;

	      num.words[i] = lo;
	      carry = hi;
	    }
	    if (carry !== 0) {
	      num.words[num.length++] = carry;
	    }
	    return num;
	  };

	  // Exported mostly for testing purposes, use plain name instead
	  BN._prime = function prime (name) {
	    // Cached version of prime
	    if (primes[name]) return primes[name];

	    var prime;
	    if (name === 'k256') {
	      prime = new K256();
	    } else if (name === 'p224') {
	      prime = new P224();
	    } else if (name === 'p192') {
	      prime = new P192();
	    } else if (name === 'p25519') {
	      prime = new P25519();
	    } else {
	      throw new Error('Unknown prime ' + name);
	    }
	    primes[name] = prime;

	    return prime;
	  };

	  //
	  // Base reduction engine
	  //
	  function Red (m) {
	    if (typeof m === 'string') {
	      var prime = BN._prime(m);
	      this.m = prime.p;
	      this.prime = prime;
	    } else {
	      assert(m.gtn(1), 'modulus must be greater than 1');
	      this.m = m;
	      this.prime = null;
	    }
	  }

	  Red.prototype._verify1 = function _verify1 (a) {
	    assert(a.negative === 0, 'red works only with positives');
	    assert(a.red, 'red works only with red numbers');
	  };

	  Red.prototype._verify2 = function _verify2 (a, b) {
	    assert((a.negative | b.negative) === 0, 'red works only with positives');
	    assert(a.red && a.red === b.red,
	      'red works only with red numbers');
	  };

	  Red.prototype.imod = function imod (a) {
	    if (this.prime) return this.prime.ireduce(a)._forceRed(this);

	    move(a, a.umod(this.m)._forceRed(this));
	    return a;
	  };

	  Red.prototype.neg = function neg (a) {
	    if (a.isZero()) {
	      return a.clone();
	    }

	    return this.m.sub(a)._forceRed(this);
	  };

	  Red.prototype.add = function add (a, b) {
	    this._verify2(a, b);

	    var res = a.add(b);
	    if (res.cmp(this.m) >= 0) {
	      res.isub(this.m);
	    }
	    return res._forceRed(this);
	  };

	  Red.prototype.iadd = function iadd (a, b) {
	    this._verify2(a, b);

	    var res = a.iadd(b);
	    if (res.cmp(this.m) >= 0) {
	      res.isub(this.m);
	    }
	    return res;
	  };

	  Red.prototype.sub = function sub (a, b) {
	    this._verify2(a, b);

	    var res = a.sub(b);
	    if (res.cmpn(0) < 0) {
	      res.iadd(this.m);
	    }
	    return res._forceRed(this);
	  };

	  Red.prototype.isub = function isub (a, b) {
	    this._verify2(a, b);

	    var res = a.isub(b);
	    if (res.cmpn(0) < 0) {
	      res.iadd(this.m);
	    }
	    return res;
	  };

	  Red.prototype.shl = function shl (a, num) {
	    this._verify1(a);
	    return this.imod(a.ushln(num));
	  };

	  Red.prototype.imul = function imul (a, b) {
	    this._verify2(a, b);
	    return this.imod(a.imul(b));
	  };

	  Red.prototype.mul = function mul (a, b) {
	    this._verify2(a, b);
	    return this.imod(a.mul(b));
	  };

	  Red.prototype.isqr = function isqr (a) {
	    return this.imul(a, a.clone());
	  };

	  Red.prototype.sqr = function sqr (a) {
	    return this.mul(a, a);
	  };

	  Red.prototype.sqrt = function sqrt (a) {
	    if (a.isZero()) return a.clone();

	    var mod3 = this.m.andln(3);
	    assert(mod3 % 2 === 1);

	    // Fast case
	    if (mod3 === 3) {
	      var pow = this.m.add(new BN(1)).iushrn(2);
	      return this.pow(a, pow);
	    }

	    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
	    //
	    // Find Q and S, that Q * 2 ^ S = (P - 1)
	    var q = this.m.subn(1);
	    var s = 0;
	    while (!q.isZero() && q.andln(1) === 0) {
	      s++;
	      q.iushrn(1);
	    }
	    assert(!q.isZero());

	    var one = new BN(1).toRed(this);
	    var nOne = one.redNeg();

	    // Find quadratic non-residue
	    // NOTE: Max is such because of generalized Riemann hypothesis.
	    var lpow = this.m.subn(1).iushrn(1);
	    var z = this.m.bitLength();
	    z = new BN(2 * z * z).toRed(this);

	    while (this.pow(z, lpow).cmp(nOne) !== 0) {
	      z.redIAdd(nOne);
	    }

	    var c = this.pow(z, q);
	    var r = this.pow(a, q.addn(1).iushrn(1));
	    var t = this.pow(a, q);
	    var m = s;
	    while (t.cmp(one) !== 0) {
	      var tmp = t;
	      for (var i = 0; tmp.cmp(one) !== 0; i++) {
	        tmp = tmp.redSqr();
	      }
	      assert(i < m);
	      var b = this.pow(c, new BN(1).iushln(m - i - 1));

	      r = r.redMul(b);
	      c = b.redSqr();
	      t = t.redMul(c);
	      m = i;
	    }

	    return r;
	  };

	  Red.prototype.invm = function invm (a) {
	    var inv = a._invmp(this.m);
	    if (inv.negative !== 0) {
	      inv.negative = 0;
	      return this.imod(inv).redNeg();
	    } else {
	      return this.imod(inv);
	    }
	  };

	  Red.prototype.pow = function pow (a, num) {
	    if (num.isZero()) return new BN(1).toRed(this);
	    if (num.cmpn(1) === 0) return a.clone();

	    var windowSize = 4;
	    var wnd = new Array(1 << windowSize);
	    wnd[0] = new BN(1).toRed(this);
	    wnd[1] = a;
	    for (var i = 2; i < wnd.length; i++) {
	      wnd[i] = this.mul(wnd[i - 1], a);
	    }

	    var res = wnd[0];
	    var current = 0;
	    var currentLen = 0;
	    var start = num.bitLength() % 26;
	    if (start === 0) {
	      start = 26;
	    }

	    for (i = num.length - 1; i >= 0; i--) {
	      var word = num.words[i];
	      for (var j = start - 1; j >= 0; j--) {
	        var bit = (word >> j) & 1;
	        if (res !== wnd[0]) {
	          res = this.sqr(res);
	        }

	        if (bit === 0 && current === 0) {
	          currentLen = 0;
	          continue;
	        }

	        current <<= 1;
	        current |= bit;
	        currentLen++;
	        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

	        res = this.mul(res, wnd[current]);
	        currentLen = 0;
	        current = 0;
	      }
	      start = 26;
	    }

	    return res;
	  };

	  Red.prototype.convertTo = function convertTo (num) {
	    var r = num.umod(this.m);

	    return r === num ? r.clone() : r;
	  };

	  Red.prototype.convertFrom = function convertFrom (num) {
	    var res = num.clone();
	    res.red = null;
	    return res;
	  };

	  //
	  // Montgomery method engine
	  //

	  BN.mont = function mont (num) {
	    return new Mont(num);
	  };

	  function Mont (m) {
	    Red.call(this, m);

	    this.shift = this.m.bitLength();
	    if (this.shift % 26 !== 0) {
	      this.shift += 26 - (this.shift % 26);
	    }

	    this.r = new BN(1).iushln(this.shift);
	    this.r2 = this.imod(this.r.sqr());
	    this.rinv = this.r._invmp(this.m);

	    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
	    this.minv = this.minv.umod(this.r);
	    this.minv = this.r.sub(this.minv);
	  }
	  inherits(Mont, Red);

	  Mont.prototype.convertTo = function convertTo (num) {
	    return this.imod(num.ushln(this.shift));
	  };

	  Mont.prototype.convertFrom = function convertFrom (num) {
	    var r = this.imod(num.mul(this.rinv));
	    r.red = null;
	    return r;
	  };

	  Mont.prototype.imul = function imul (a, b) {
	    if (a.isZero() || b.isZero()) {
	      a.words[0] = 0;
	      a.length = 1;
	      return a;
	    }

	    var t = a.imul(b);
	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
	    var u = t.isub(c).iushrn(this.shift);
	    var res = u;

	    if (u.cmp(this.m) >= 0) {
	      res = u.isub(this.m);
	    } else if (u.cmpn(0) < 0) {
	      res = u.iadd(this.m);
	    }

	    return res._forceRed(this);
	  };

	  Mont.prototype.mul = function mul (a, b) {
	    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

	    var t = a.mul(b);
	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
	    var u = t.isub(c).iushrn(this.shift);
	    var res = u;
	    if (u.cmp(this.m) >= 0) {
	      res = u.isub(this.m);
	    } else if (u.cmpn(0) < 0) {
	      res = u.iadd(this.m);
	    }

	    return res._forceRed(this);
	  };

	  Mont.prototype.invm = function invm (a) {
	    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
	    var res = this.imod(a._invmp(this.m).mul(this.r2));
	    return res._forceRed(this);
	  };
	})(module, commonjsGlobal); 
} (bn));

var bnExports = bn.exports;
var BN = /*@__PURE__*/getDefaultExportFromCjs(bnExports);

/**
 * @name isBn
 * @summary Tests for a `BN` object instance.
 * @description
 * Checks to see if the input object is an instance of `BN` (bn.js).
 * @example
 * <BR>
 *
 * ```javascript
 * import BN from 'bn.js';
 * import { isBn } from '@polkadot/util';
 *
 * console.log('isBn', isBn(new BN(1))); // => true
 * ```
 */
function isBn(value) {
    return BN.isBN(value);
}

const REGEX_HEX_PREFIXED = /^0x[\da-fA-F]+$/;
const REGEX_HEX_NOPREFIX = /^[\da-fA-F]+$/;
/**
 * @name isHex
 * @summary Tests for a hex string.
 * @description
 * Checks to see if the input value is a `0x` prefixed hex string. Optionally (`bitLength` !== -1) checks to see if the bitLength is correct.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isHex } from '@polkadot/util';
 *
 * isHex('0x1234'); // => true
 * isHex('0x1234', 8); // => false
 * ```
 */
function isHex(value, bitLength = -1, ignoreLength) {
    return (typeof value === 'string' && (value === '0x' ||
        REGEX_HEX_PREFIXED.test(value))) && (bitLength === -1
        ? (ignoreLength || (value.length % 2 === 0))
        : (value.length === (2 + Math.ceil(bitLength / 4))));
}

/**
 * @name isObject
 * @summary Tests for an `object`.
 * @description
 * Checks to see if the input value is a JavaScript object.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isObject } from '@polkadot/util';
 *
 * isObject({}); // => true
 * isObject('something'); // => false
 * ```
 */
function isObject(value) {
    return !!value && typeof value === 'object';
}

function isOn(...fns) {
    return (value) => (isObject(value) || isFunction$1(value)) &&
        fns.every((f) => isFunction$1(value[f]));
}
function isOnFunction(...fns) {
    return (value) => isFunction$1(value) &&
        fns.every((f) => isFunction$1(value[f]));
}
function isOnObject(...fns) {
    return (value) => isObject(value) &&
        fns.every((f) => isFunction$1(value[f]));
}

const isToBigInt = /*#__PURE__*/ isOn('toBigInt');

const isToBn$1 = /*#__PURE__*/ isOn('toBn');

/** true if the environment has proper BigInt support */
const hasBigInt = typeof BigInt$1 === 'function' && typeof BigInt$1.asIntN === 'function';
/** true if the environment has support for Buffer (typically Node.js) */
const hasBuffer = typeof xglobal.Buffer === 'function' && typeof xglobal.Buffer.isBuffer === 'function';
/** true if the environment has process available (typically Node.js) */
typeof xglobal.process === 'object';

/**
 * @name isBuffer
 * @summary Tests for a `Buffer` object instance.
 * @description
 * Checks to see if the input object is an instance of `Buffer`.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isBuffer } from '@polkadot/util';
 *
 * console.log('isBuffer', isBuffer(Buffer.from([]))); // => true
 * ```
 */
function isBuffer(value) {
    // we do check a function first, since it is slightly faster than isBuffer itself
    return hasBuffer && !!value && isFunction$1(value.readDoubleLE) && xglobal.Buffer.isBuffer(value);
}

/**
 * @name isU8a
 * @summary Tests for a `Uint8Array` object instance.
 * @description
 * Checks to see if the input object is an instance of `Uint8Array`.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isUint8Array } from '@polkadot/util';
 *
 * console.log('isU8a', isU8a([])); // => false
 * ```
 */
function isU8a(value) {
    // here we defer the instanceof check which is actually slightly
    // slower than just checking the constrctor (direct instances)
    return (((value && value.constructor) === Uint8Array) ||
        value instanceof Uint8Array);
}

const encoder = new TextEncoder$1();
/**
 * @name stringToU8a
 * @summary Creates a Uint8Array object from a utf-8 string.
 * @description
 * String input values return the actual encoded `UInt8Array`. `null` or `undefined` values returns an empty encoded array.
 * @example
 * <BR>
 *
 * ```javascript
 * import { stringToU8a } from '@polkadot/util';
 *
 * stringToU8a('hello'); // [0x68, 0x65, 0x6c, 0x6c, 0x6f]
 * ```
 */
function stringToU8a(value) {
    return value
        ? encoder.encode(value.toString())
        : new Uint8Array();
}

/**
 * @name u8aToU8a
 * @summary Creates a Uint8Array value from a Uint8Array, Buffer, string or hex input.
 * @description
 * `null` or `undefined` inputs returns a `[]` result, Uint8Array values returns the value, hex strings returns a Uint8Array representation.
 * If `strict` is true, `null` or `undefined` will throw an error instead of returning an empty array.
 * Supports input types: Uint8Array, Buffer, hex string, string, or number array.
 * @example
 * <BR>
 *
 * ```javascript
 * import { u8aToU8a } from '@polkadot/util';
 *
 * u8aToU8a(new Uint8Array([0x12, 0x34]); // => Uint8Array([0x12, 0x34])
 * u8aToU8a(0x1234); // => Uint8Array([0x12, 0x34])
 * ```
 */
function u8aToU8a(value, strict = false) {
    if (strict && (value === null || value === undefined)) {
        throw new Error('u8aToU8a: Expected non-null, non-undefined value');
    }
    return isU8a(value)
        // NOTE isBuffer needs to go here since it actually extends
        // Uint8Array on Node.js environments, so all Buffer are Uint8Array,
        // but Uint8Array is not Buffer
        ? isBuffer(value)
            ? new Uint8Array(value)
            : value
        : isHex(value)
            ? hexToU8a(value)
            : Array.isArray(value)
                ? new Uint8Array(value)
                : stringToU8a(value);
}

/**
 * @name u8aConcat
 * @summary Creates a concatenated Uint8Array from the inputs.
 * @description
 * Concatenates the input arrays into a single `UInt8Array`.
 * @example
 * <BR>
 *
 * ```javascript
 * import { { u8aConcat } from '@polkadot/util';
 *
 * u8aConcat(
 *   new Uint8Array([1, 2, 3]),
 *   new Uint8Array([4, 5, 6])
 * ); // [1, 2, 3, 4, 5, 6]
 * ```
 */
function u8aConcat(...list) {
    const count = list.length;
    const u8as = new Array(count);
    let length = 0;
    for (let i = 0; i < count; i++) {
        u8as[i] = u8aToU8a(list[i]);
        length += u8as[i].length;
    }
    return u8aConcatStrict(u8as, length);
}
/**
 * @name u8aConcatStrict
 * @description A strict version of [[u8aConcat]], accepting only Uint8Array inputs
 */
function u8aConcatStrict(u8as, length = 0) {
    const count = u8as.length;
    let offset = 0;
    if (!length) {
        for (let i = 0; i < count; i++) {
            length += u8as[i].length;
        }
    }
    const result = new Uint8Array(length);
    for (let i = 0; i < count; i++) {
        result.set(u8as[i], offset);
        offset += u8as[i].length;
    }
    return result;
}

/**
 * @name u8aEq
 * @summary Compares two Uint8Arrays for equality.
 * @description
 * For `UInt8Array` (or hex string) input values true if there is a match.
 * @example
 * <BR>
 *
 * ```javascript
 * import { u8aEq } from '@polkadot/util';
 *
 * u8aEq(new Uint8Array([0x68, 0x65]), new Uint8Array([0x68, 0x65])); // true
 * ```
 */
function u8aEq(a, b) {
    const u8aa = u8aToU8a(a);
    const u8ab = u8aToU8a(b);
    if (u8aa.length === u8ab.length) {
        const dvA = new DataView(u8aa.buffer, u8aa.byteOffset);
        const dvB = new DataView(u8ab.buffer, u8ab.byteOffset);
        const mod = (u8aa.length % 4) | 0;
        const length = (u8aa.length - mod) | 0;
        for (let i = 0; i < length; i += 4) {
            if (dvA.getUint32(i) !== dvB.getUint32(i)) {
                return false;
            }
        }
        for (let i = length, count = u8aa.length; i < count; i++) {
            if (u8aa[i] !== u8ab[i]) {
                return false;
            }
        }
        return true;
    }
    return false;
}

/**
 * @name u8aToBn
 * @summary Creates a BN from a Uint8Array object.
 * @description
 * `UInt8Array` input values return the actual BN. `null` or `undefined` values returns an `0x0` value.
 * @param value The value to convert
 * @param options Options to pass while converting
 * @param options.isLe Convert using Little Endian (default)
 * @param options.isNegative Convert using two's complement
 * @example
 * <BR>
 *
 * ```javascript
 * import { u8aToBn } from '@polkadot/util';
 *
 * u8aToHex(new Uint8Array([0x68, 0x65, 0x6c, 0x6c, 0xf])); // 0x68656c0f
 * ```
 */
function u8aToBn(value, { isLe = true, isNegative = false } = {}) {
    // slice + reverse is expensive, however SCALE is LE by default so this is the path
    // we are most interested in (the BE is added for the sake of being comprehensive)
    if (!isLe) {
        value = value.slice().reverse();
    }
    const count = value.length;
    // shortcut for <= u48 values - in this case the manual conversion
    // here seems to be more efficient than passing the full array
    if (isNegative && count && (value[count - 1] & 0x80)) {
        // Most common case i{8, 16, 32} default LE SCALE-encoded
        // For <= 32, we also optimize the xor to a single op
        switch (count) {
            case 0:
                return new BN(0);
            case 1:
                return new BN(((value[0] ^ 0x0000_00ff) * -1) - 1);
            case 2:
                return new BN((((value[0] + (value[1] << 8)) ^ 0x0000_ffff) * -1) - 1);
            case 3:
                return new BN((((value[0] + (value[1] << 8) + (value[2] << 16)) ^ 0x00ff_ffff) * -1) - 1);
            case 4:
                // for the 3rd byte, we don't << 24 - since JS converts all bitwise operators to
                // 32-bit, in the case where the top-most bit is set this yields a negative value
                return new BN((((value[0] + (value[1] << 8) + (value[2] << 16) + (value[3] * 0x1_00_00_00)) ^ 0xffff_ffff) * -1) - 1);
            case 5:
                return new BN(((((value[0] + (value[1] << 8) + (value[2] << 16) + (value[3] * 0x1_00_00_00)) ^ 0xffff_ffff) + ((value[4] ^ 0xff) * 0x1_00_00_00_00)) * -1) - 1);
            case 6:
                return new BN(((((value[0] + (value[1] << 8) + (value[2] << 16) + (value[3] * 0x1_00_00_00)) ^ 0xffff_ffff) + (((value[4] + (value[5] << 8)) ^ 0x0000_ffff) * 0x1_00_00_00_00)) * -1) - 1);
            default:
                return new BN(value, 'le').fromTwos(count * 8);
        }
    }
    // Most common case - u{8, 16, 32} default LE SCALE-encoded
    //
    // There are some slight benefits in unrolling this specific loop,
    // however it comes with diminishing returns since here the actual
    // `new BN` does seem to take up the bulk of the time
    switch (count) {
        case 0:
            return new BN(0);
        case 1:
            return new BN(value[0]);
        case 2:
            return new BN(value[0] + (value[1] << 8));
        case 3:
            return new BN(value[0] + (value[1] << 8) + (value[2] << 16));
        case 4:
            // for the 3rd byte, we don't << 24 - since JS converts all bitwise operators to
            // 32-bit, in the case where the top-most bit is set this yields a negative value
            return new BN(value[0] + (value[1] << 8) + (value[2] << 16) + (value[3] * 0x1_00_00_00));
        case 5:
            return new BN(value[0] + (value[1] << 8) + (value[2] << 16) + ((value[3] + (value[4] << 8)) * 0x1_00_00_00));
        case 6:
            return new BN(value[0] + (value[1] << 8) + (value[2] << 16) + ((value[3] + (value[4] << 8) + (value[5] << 16)) * 0x1_00_00_00));
        default:
            return new BN(value, 'le');
    }
}

/**
 * @name u8aToFloat
 * @description Converts a Uint8Array value into the float (either 32 or 64-bit)
 * representation.
 */
function u8aToFloat(value, { bitLength = 32, isLe = true } = {}) {
    if (bitLength !== 32 && bitLength !== 64) {
        throw new Error('Invalid bitLength provided, expected 32 or 64');
    }
    else if (value.length < (bitLength / 8)) {
        throw new Error(`Invalid input buffer provided, expected at least ${bitLength / 8} bytes, found ${value.length}`);
    }
    const dv = new DataView(value.buffer, value.byteOffset);
    return bitLength === 32
        ? dv.getFloat32(0, isLe)
        : dv.getFloat64(0, isLe);
}

const U8 = new Array(256);
const U16 = new Array(256 * 256);
for (let n = 0; n < 256; n++) {
    U8[n] = n.toString(16).padStart(2, '0');
}
for (let i = 0; i < 256; i++) {
    const s = i << 8;
    for (let j = 0; j < 256; j++) {
        U16[s | j] = U8[i] + U8[j];
    }
}
/** @internal */
function hex(value, result) {
    const mod = (value.length % 2) | 0;
    const length = (value.length - mod) | 0;
    for (let i = 0; i < length; i += 2) {
        result += U16[(value[i] << 8) | value[i + 1]];
    }
    if (mod) {
        result += U8[value[length] | 0];
    }
    return result;
}
/**
 * @name u8aToHex
 * @summary Creates a hex string from a Uint8Array object.
 * @description
 * `UInt8Array` input values return the actual hex string. `null` or `undefined` values returns an `0x` string.
 * @example
 * <BR>
 *
 * ```javascript
 * import { u8aToHex } from '@polkadot/util';
 *
 * u8aToHex(new Uint8Array([0x68, 0x65, 0x6c, 0x6c, 0xf])); // 0x68656c0f
 * ```
 */
function u8aToHex(value, bitLength = -1, isPrefixed = true) {
    // this is not 100% correct sinmce we support isPrefixed = false....
    const empty = isPrefixed
        ? '0x'
        : '';
    if (!value?.length) {
        return empty;
    }
    else if (bitLength > 0) {
        const length = Math.ceil(bitLength / 8);
        if (value.length > length) {
            return `${hex(value.subarray(0, length / 2), empty)}…${hex(value.subarray(value.length - length / 2), '')}`;
        }
    }
    return hex(value, empty);
}

/**
 * @name u8aToNumber
 * @summary Creates a number from a Uint8Array object.
 */
function u8aToNumber(value, { isLe = true, isNegative = false } = {}) {
    // slice + reverse is expensive, however SCALE is LE by default so this is the path
    // we are most interested in (the BE is added for the sake of being comprehensive)
    if (!isLe) {
        value = value.slice().reverse();
    }
    const count = value.length;
    // When the value is a i{8, 16, 24, 32, 40, 40} values and the top-most bit
    // indicates a signed value, we use a two's complement conversion. If one of these
    // flags are not set, we just do a normal unsigned conversion (the same shortcut
    // applies in both the u8aTo{BigInt, Bn} conversions as well)
    if (isNegative && count && (value[count - 1] & 0x80)) {
        switch (count) {
            case 0:
                return 0;
            case 1:
                return (((value[0] ^ 0x0000_00ff) * -1) - 1);
            case 2:
                return ((((value[0] + (value[1] << 8)) ^ 0x0000_ffff) * -1) - 1);
            case 3:
                return ((((value[0] + (value[1] << 8) + (value[2] << 16)) ^ 0x00ff_ffff) * -1) - 1);
            case 4:
                // for the 3rd byte, we don't << 24 - since JS converts all bitwise operators to
                // 32-bit, in the case where the top-most bit is set this yields a negative value
                return ((((value[0] + (value[1] << 8) + (value[2] << 16) + (value[3] * 0x1_00_00_00)) ^ 0xffff_ffff) * -1) - 1);
            case 5:
                return (((((value[0] + (value[1] << 8) + (value[2] << 16) + (value[3] * 0x1_00_00_00)) ^ 0xffff_ffff) + ((value[4] ^ 0xff) * 0x1_00_00_00_00)) * -1) - 1);
            case 6:
                return (((((value[0] + (value[1] << 8) + (value[2] << 16) + (value[3] * 0x1_00_00_00)) ^ 0xffff_ffff) + (((value[4] + (value[5] << 8)) ^ 0x0000_ffff) * 0x1_00_00_00_00)) * -1) - 1);
            default:
                throw new Error('Value more than 48-bits cannot be reliably converted');
        }
    }
    switch (count) {
        case 0:
            return 0;
        case 1:
            return value[0];
        case 2:
            return value[0] + (value[1] << 8);
        case 3:
            return value[0] + (value[1] << 8) + (value[2] << 16);
        case 4:
            // for the 3rd byte, we don't << 24 - since JS converts all bitwise operators to
            // 32-bit, in the case where the top-most bit is set this yields a negative value
            return value[0] + (value[1] << 8) + (value[2] << 16) + (value[3] * 0x1_00_00_00);
        case 5:
            return value[0] + (value[1] << 8) + (value[2] << 16) + ((value[3] + (value[4] << 8)) * 0x1_00_00_00);
        case 6:
            return value[0] + (value[1] << 8) + (value[2] << 16) + ((value[3] + (value[4] << 8) + (value[5] << 16)) * 0x1_00_00_00);
        default:
            throw new Error('Value more than 48-bits cannot be reliably converted');
    }
}

const decoder = new TextDecoder('utf-8');
/**
 * @name u8aToString
 * @summary Creates a utf-8 string from a Uint8Array object.
 * @description
 * `UInt8Array` input values return the actual decoded utf-8 string. `null` or `undefined` values returns an empty string.
 * @example
 * <BR>
 *
 * ```javascript
 * import { u8aToString } from '@polkadot/util';
 *
 * u8aToString(new Uint8Array([0x68, 0x65, 0x6c, 0x6c, 0x6f])); // hello
 * ```
 */
function u8aToString(value) {
    return value
        ? decoder.decode(value)
        : '';
}

/**
 * @name hexStripPrefix
 * @summary Strips any leading `0x` prefix.
 * @description
 * Tests for the existence of a `0x` prefix, and returns the value without the prefix. Un-prefixed values are returned as-is.
 * @example
 * <BR>
 *
 * ```javascript
 * import { hexStripPrefix } from '@polkadot/util';
 *
 * console.log('stripped', hexStripPrefix('0x1234')); // => 1234
 * ```
 */
function hexStripPrefix(value) {
    if (!value || value === '0x') {
        return '';
    }
    else if (REGEX_HEX_PREFIXED.test(value)) {
        return value.substring(2);
    }
    else if (REGEX_HEX_NOPREFIX.test(value)) {
        return value;
    }
    throw new Error(`Expected hex value to convert, found '${value}'`);
}

/**
 * @name hexToBn
 * @summary Creates a BN.js object from a hex string.
 * @description
 * `null` inputs returns a `BN(0)` result. Hex input values return the actual value converted to a BN. Anything that is not a hex string (including the `0x` prefix) throws an error.
 * @param _value The value to convert
 * @param _options Options to pass while converting
 * @param _options.isLe Convert using Little Endian
 * @param _options.isNegative Convert using two's complement
 * @example
 * <BR>
 *
 * ```javascript
 * import { hexToBn } from '@polkadot/util';
 *
 * hexToBn('0x123480001f'); // => BN(0x123480001f)
 * ```
 */
function hexToBn(value, { isLe = false, isNegative = false } = {}) {
    if (!value || value === '0x') {
        return new BN(0);
    }
    const stripped = hexStripPrefix(value);
    const bn = new BN(stripped, 16, isLe ? 'le' : 'be');
    // fromTwos takes as parameter the number of bits, which is the hex length
    // multiplied by 4 (2 bytes being 8 bits)
    return isNegative
        ? bn.fromTwos(stripped.length * 4)
        : bn;
}

/**
 * @name bnMax
 * @summary Finds and returns the highest value in an array of BNs.
 * @example
 * <BR>
 *
 * ```javascript
 * import BN from 'bn.js';
 * import { bnMax } from '@polkadot/util';
 *
 * bnMax([new BN(1), new BN(3), new BN(2)]).toString(); // => '3'
 * ```
 */
const bnMax = /*#__PURE__*/ createCmp((a, b) => a.gt(b));
/**
 * @name bnMin
 * @summary Finds and returns the smallest value in an array of BNs.
 * @example
 * <BR>
 *
 * ```javascript
 * import BN from 'bn.js';
 * import { bnMin } from '@polkadot/util';
 *
 * bnMin([new BN(1), new BN(3), new BN(2)]).toString(); // => '1'
 * ```
 */
const bnMin = /*#__PURE__*/ createCmp((a, b) => a.lt(b));

/**
 * @name BN_ZERO
 * @summary BN constant for 0.
 */
const BN_ZERO = /*#__PURE__*/ new BN(0);
/**
 * @name BN_ONE
 * @summary BN constant for 1.
 */
const BN_ONE = /*#__PURE__*/ new BN(1);
/**
 * @name BN_TWO
 * @summary BN constant for 2.
 */
const BN_TWO = /*#__PURE__*/ new BN(2);
/**
 * @name BN_HUNDRED
 * @summary BN constant for 100.
 */
const BN_HUNDRED = /*#__PURE__*/ new BN(100);
/**
 * @name BN_MILLION
 * @summary BN constant for 1,000,000.
 */
const BN_MILLION = /*#__PURE__*/ new BN(1_000_000);
/**
 * @name BN_BILLION
 * @summary BN constant for 1,000,000,000.
 */
const BN_BILLION = /*#__PURE__*/ new BN(1_000_000_000);
/**
 * @name BN_QUINTILL
 * @summary BN constant for 1,000,000,000,000,000,000.
 */
const BN_QUINTILL = BN_BILLION.mul(BN_BILLION);
/**
 * @name BN_MAX_INTEGER
 * @summary BN constant for MAX_SAFE_INTEGER
 */
const BN_MAX_INTEGER = /*#__PURE__*/ new BN(Number.MAX_SAFE_INTEGER);
/**
 * @name BN_SQRT_MAX_INTEGER
 * @summary BN constant for Math.sqrt(MAX_SAFE_INTEGER)
 */
const BN_SQRT_MAX_INTEGER = /*#__PURE__*/ new BN(94906265);

/**
 * @name isBigInt
 * @summary Tests for a `BigInt` object instance.
 * @description
 * Checks to see if the input object is an instance of `BigInt`
 * @example
 * <BR>
 *
 * ```javascript
 * import { isBigInt } from '@polkadot/util';
 *
 * console.log('isBigInt', isBigInt(123_456n)); // => true
 * ```
 */
function isBigInt(value) {
    return typeof value === 'bigint';
}

/**
 * @name bnToBn
 * @summary Creates a BN value from a BN, bigint, string (base 10 or hex) or number input.
 * @description
 * `null` inputs returns a `0x0` result, BN values returns the value, numbers returns a BN representation.
 * @example
 * <BR>
 *
 * ```javascript
 * import BN from 'bn.js';
 * import { bnToBn } from '@polkadot/util';
 *
 * bnToBn(0x1234); // => BN(0x1234)
 * bnToBn(new BN(0x1234)); // => BN(0x1234)
 * ```
 */
function bnToBn(value) {
    return value
        ? BN.isBN(value)
            ? value
            : isHex(value)
                ? hexToBn(value.toString())
                : isBigInt(value)
                    ? new BN(value.toString())
                    : isToBn$1(value)
                        ? value.toBn()
                        : isToBigInt(value)
                            ? new BN(value.toBigInt().toString())
                            : new BN(value)
        : new BN(0);
}

/**
 * @name bnSqrt
 * @summary Calculates the integer square root of a BN
 * @example
 * <BR>
 *
 * ```javascript
 * import BN from 'bn.js';
 * import { bnSqrt } from '@polkadot/util';
 *
 * bnSqrt(new BN(16)).toString(); // => '4'
 * ```
 */
function bnSqrt(value) {
    const n = bnToBn(value);
    if (n.isNeg()) {
        throw new Error('square root of negative numbers is not supported');
    }
    // https://stackoverflow.com/questions/53683995/javascript-big-integer-square-root/
    // shortcut <= 2^53 - 1 to use the JS utils
    if (n.lte(BN_MAX_INTEGER)) {
        // ~~ More performant version of Math.floor
        return new BN(~~Math.sqrt(n.toNumber()));
    }
    // Use sqrt(MAX_SAFE_INTEGER) as starting point. since we already know the
    // output will be larger than this, we expect this to be a safe start
    let x0 = BN_SQRT_MAX_INTEGER.clone();
    while (true) {
        const x1 = n.div(x0).iadd(x0).ishrn(1);
        if (x0.eq(x1) || x0.eq(x1.sub(BN_ONE))) {
            return x0;
        }
        x0 = x1;
    }
}

const DEFAULT_OPTS = { bitLength: -1, isLe: true, isNegative: false };
/**
 * @name bnToU8a
 * @summary Creates a Uint8Array object from a BN.
 * @description
 * `null`/`undefined`/`NaN` inputs returns an empty `Uint8Array` result. `BN` input values return the actual bytes value converted to a `Uint8Array`. Optionally convert using little-endian format if `isLE` is set.
 * @example
 * <BR>
 *
 * ```javascript
 * import { bnToU8a } from '@polkadot/util';
 *
 * bnToU8a(new BN(0x1234)); // => [0x12, 0x34]
 * ```
 */
function bnToU8a(value, { bitLength = -1, isLe = true, isNegative = false } = DEFAULT_OPTS) {
    const valueBn = bnToBn(value);
    const byteLength = bitLength === -1
        ? Math.ceil(valueBn.bitLength() / 8)
        : Math.ceil((bitLength || 0) / 8);
    if (!value) {
        return bitLength === -1
            ? new Uint8Array(1)
            : new Uint8Array(byteLength);
    }
    const output = new Uint8Array(byteLength);
    const bn = isNegative
        ? valueBn.toTwos(byteLength * 8)
        : valueBn;
    output.set(bn.toArray(isLe ? 'le' : 'be', byteLength), 0);
    return output;
}

/**
 * @name bnToHex
 * @summary Creates a hex value from a BN.js bignumber object.
 * @description
 * `null` inputs returns a `0x` result, BN values return the actual value as a `0x` prefixed hex value. Anything that is not a BN object throws an error. With `bitLength` set, it fixes the number to the specified length.
 * @example
 * <BR>
 *
 * ```javascript
 * import BN from 'bn.js';
 * import { bnToHex } from '@polkadot/util';
 *
 * bnToHex(new BN(0x123456)); // => '0x123456'
 * ```
 */
function bnToHex(value, { bitLength = -1, isLe = false, isNegative = false } = {}) {
    return u8aToHex(bnToU8a(value, { bitLength, isLe, isNegative }));
}

const MAX_U8 = BN_TWO.pow(new BN(8 - 2)).isub(BN_ONE);
const MAX_U16 = BN_TWO.pow(new BN(16 - 2)).isub(BN_ONE);
const MAX_U32 = BN_TWO.pow(new BN(32 - 2)).isub(BN_ONE);
const BL_16 = { bitLength: 16 };
const BL_32 = { bitLength: 32 };
/**
 * @name compactToU8a
 * @description Encodes a number into a compact representation
 * @example
 * <BR>
 *
 * ```javascript
 * import { compactToU8a } from '@polkadot/util';
 *
 * console.log(compactToU8a(511, 32)); // Uint8Array([0b11111101, 0b00000111])
 * ```
 */
function compactToU8a(value) {
    const bn = bnToBn(value);
    if (bn.lte(MAX_U8)) {
        return new Uint8Array([bn.toNumber() << 2]);
    }
    else if (bn.lte(MAX_U16)) {
        return bnToU8a(bn.shln(2).iadd(BN_ONE), BL_16);
    }
    else if (bn.lte(MAX_U32)) {
        return bnToU8a(bn.shln(2).iadd(BN_TWO), BL_32);
    }
    const u8a = bnToU8a(bn);
    let length = u8a.length;
    // adjust to the minimum number of bytes
    while (u8a[length - 1] === 0) {
        length--;
    }
    if (length < 4) {
        throw new Error('Invalid length, previous checks match anything less than 2^30');
    }
    return u8aConcatStrict([
        // subtract 4 as minimum (also catered for in decoding)
        new Uint8Array([((length - 4) << 2) + 0b11]),
        u8a.subarray(0, length)
    ]);
}

/**
 * @name compactAddLength
 * @description Adds a length prefix to the input value
 * @example
 * <BR>
 *
 * ```javascript
 * import { compactAddLength } from '@polkadot/util';
 *
 * console.log(compactAddLength(new Uint8Array([0xde, 0xad, 0xbe, 0xef]))); // Uint8Array([4 << 2, 0xde, 0xad, 0xbe, 0xef])
 * ```
 */
function compactAddLength(input) {
    return u8aConcatStrict([
        compactToU8a(input.length),
        input
    ]);
}

/**
 * @name compactFromU8a
 * @description Retrives the offset and encoded length from a compact-prefixed value
 * @example
 * <BR>
 *
 * ```javascript
 * import { compactFromU8a } from '@polkadot/util';
 *
 * const [offset, length] = compactFromU8a(new Uint8Array([254, 255, 3, 0]));
 *
 * console.log('value offset=', offset, 'length=', length); // 4, 0xffff
 * ```
 */
function compactFromU8a(input) {
    const u8a = u8aToU8a(input);
    // The u8a is manually converted here for 1, 2 & 4 lengths, it is 2x faster
    // than doing an additional call to u8aToBn (as with variable length)
    switch (u8a[0] & 0b11) {
        case 0b00:
            return [1, new BN(u8a[0] >>> 2)];
        case 0b01:
            return [2, new BN((u8a[0] + (u8a[1] << 8)) >>> 2)];
        case 0b10:
            // for the 3rd byte, we don't << 24 - since JS converts all bitwise operators to
            // 32-bit, in the case where the top-most bit is set this yields a negative value
            return [4, new BN((u8a[0] + (u8a[1] << 8) + (u8a[2] << 16) + (u8a[3] * 0x1_00_00_00)) >>> 2)];
        // 0b11
        default: {
            // add 5 to shifted (4 for base length, 1 for this byte)
            const offset = (u8a[0] >>> 2) + 5;
            // we unroll the loop
            switch (offset) {
                // there still could be 4 bytes data, similar to 0b10 above (with offsets)
                case 5:
                    // for the 3rd byte, we don't << 24 - since JS converts all bitwise operators to
                    // 32-bit, in the case where the top-most bit is set this yields a negative value
                    return [5, new BN(u8a[1] + (u8a[2] << 8) + (u8a[3] << 16) + (u8a[4] * 0x1_00_00_00))];
                case 6:
                    return [6, new BN(u8a[1] + (u8a[2] << 8) + (u8a[3] << 16) + ((u8a[4] + (u8a[5] << 8)) * 0x1_00_00_00))];
                // 6 bytes data is the maximum, 48 bits (56 would overflow)
                case 7:
                    return [7, new BN(u8a[1] + (u8a[2] << 8) + (u8a[3] << 16) + ((u8a[4] + (u8a[5] << 8) + (u8a[6] << 16)) * 0x1_00_00_00))];
                // for anything else, use the non-unrolled version
                default:
                    return [offset, u8aToBn(u8a.subarray(1, offset))];
            }
        }
    }
}
/**
 * @name compactFromU8aLim
 * @description A limited version of [[compactFromU8a]], accepting only Uint8Array inputs for values <= 48 bits
 */
function compactFromU8aLim(u8a) {
    // The u8a is manually converted here for 1, 2 & 4 lengths, it is 2x faster
    // than doing an additional call to u8aToBn (as with variable length)
    switch (u8a[0] & 0b11) {
        case 0b00:
            return [1, u8a[0] >>> 2];
        case 0b01:
            return [2, (u8a[0] + (u8a[1] << 8)) >>> 2];
        case 0b10:
            // for the 3rd byte, we don't << 24 - since JS converts all bitwise operators to
            // 32-bit, in the case where the top-most bit is set this yields a negative value
            return [4, (u8a[0] + (u8a[1] << 8) + (u8a[2] << 16) + (u8a[3] * 0x1_00_00_00)) >>> 2];
        // 0b11
        default: {
            // add 5 to shifted (4 for base length, 1 for this byte)
            // we unroll the loop
            switch ((u8a[0] >>> 2) + 5) {
                // there still could be 4 bytes data, similar to 0b10 above (with offsets)
                case 5:
                    return [5, u8a[1] + (u8a[2] << 8) + (u8a[3] << 16) + (u8a[4] * 0x1_00_00_00)];
                case 6:
                    return [6, u8a[1] + (u8a[2] << 8) + (u8a[3] << 16) + ((u8a[4] + (u8a[5] << 8)) * 0x1_00_00_00)];
                // 6 bytes data is the maximum, 48 bits (56 would overflow)
                case 7:
                    return [7, u8a[1] + (u8a[2] << 8) + (u8a[3] << 16) + ((u8a[4] + (u8a[5] << 8) + (u8a[6] << 16)) * 0x1_00_00_00)];
                // for anything else, we are above the actual MAX_SAFE_INTEGER - bail out
                default:
                    throw new Error('Compact input is > Number.MAX_SAFE_INTEGER');
            }
        }
    }
}

/**
 * @name compactStripLength
 * @description Removes the length prefix, returning both the total length (including the value + compact encoding) and the decoded value with the correct length
 * @example
 * <BR>
 *
 * ```javascript
 * import { compactStripLength } from '@polkadot/util';
 *
 * console.log(compactStripLength(new Uint8Array([2 << 2, 0xde, 0xad]))); // [2, Uint8Array[0xde, 0xad]]
 * ```
 */
function compactStripLength(input) {
    const [offset, length] = compactFromU8a(input);
    const total = offset + length.toNumber();
    return [
        total,
        input.subarray(offset, total)
    ];
}

/**
 * @name floatToU8a
 * @description Converts a float into a U8a representation (While we don't use BE in SCALE
 * we still allow for either representation, although, as elsewhere, isLe is default)
 */
function floatToU8a(value = 0.0, { bitLength = 32, isLe = true } = {}) {
    if (bitLength !== 32 && bitLength !== 64) {
        throw new Error('Invalid bitLength provided, expected 32 or 64');
    }
    const result = new Uint8Array(bitLength / 8);
    const dv = new DataView(result.buffer, result.byteOffset);
    if (bitLength === 32) {
        dv.setFloat32(0, Number(value), isLe);
    }
    else {
        dv.setFloat64(0, Number(value), isLe);
    }
    return result;
}

/**
 * @name isBoolean
 * @summary Tests for a boolean value.
 * @description
 * Checks to see if the input value is a JavaScript boolean.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isBoolean } from '@polkadot/util';
 *
 * isBoolean(false); // => true
 * ```
 */
function isBoolean(value) {
    return typeof value === 'boolean';
}

const NUMBER_REGEX = new RegExp('(\\d+?)(?=(\\d{3})+(?!\\d)|$)', 'g');
/**
 * @name formatDecimal
 * @description Formats a number into string format with thousand separators
 */
function formatDecimal(value, separator = ',') {
    // We can do this by adjusting the regx, however for the sake of clarity
    // we rather strip and re-add the negative sign in the output
    const isNegative = value[0].startsWith('-');
    const matched = isNegative
        ? value.substring(1).match(NUMBER_REGEX)
        : value.match(NUMBER_REGEX);
    return matched
        ? `${isNegative ? '-' : ''}${matched.join(separator)}`
        : value;
}

/**
 * Get the decimal and thousand separator of a locale
 * @param locale
 * @returns {decimal: string, thousand: string}
 */
function getSeparator(locale) {
    return {
        decimal: (0.1).toLocaleString(locale, { useGrouping: false }).charAt(1),
        thousand: (1000).toLocaleString(locale, { useGrouping: true }).replace(/\d/g, '').charAt(0)
    };
}

/** @internal */
const SI_MID = 8;
/** @internal */
const SI = [
    { power: -24, text: 'yocto', value: 'y' },
    { power: -21, text: 'zepto', value: 'z' },
    { power: -18, text: 'atto', value: 'a' },
    { power: -15, text: 'femto', value: 'f' },
    { power: -12, text: 'pico', value: 'p' },
    { power: -9, text: 'nano', value: 'n' },
    { power: -6, text: 'micro', value: 'µ' },
    { power: -3, text: 'milli', value: 'm' },
    { power: 0, text: 'Unit', value: '-' }, // position 8
    { power: 3, text: 'Kilo', value: 'k' },
    { power: 6, text: 'Mill', value: 'M' }, // Mega, M
    { power: 9, text: 'Bill', value: 'B' }, // Giga, G
    { power: 12, text: 'Tril', value: 'T' }, // Tera, T
    { power: 15, text: 'Peta', value: 'P' },
    { power: 18, text: 'Exa', value: 'E' },
    { power: 21, text: 'Zeta', value: 'Z' },
    { power: 24, text: 'Yotta', value: 'Y' }
];
/** @internal */
function findSi(type) {
    // use a loop here, better RN support (which doesn't have [].find)
    for (let i = 0, count = SI.length; i < count; i++) {
        if (SI[i].value === type) {
            return SI[i];
        }
    }
    return SI[SI_MID];
}
/** @internal */
function calcSi(text, decimals, forceUnit) {
    if (forceUnit) {
        return findSi(forceUnit);
    }
    const siDefIndex = (SI_MID - 1) + Math.ceil((text.length - decimals) / 3);
    return SI[siDefIndex] || SI[siDefIndex < 0 ? 0 : SI.length - 1];
}

const DEFAULT_DECIMALS = 0;
const DEFAULT_UNIT = SI[SI_MID].text;
let defaultDecimals = DEFAULT_DECIMALS;
let defaultUnit = DEFAULT_UNIT;
function _formatBalance(input, { decimals = defaultDecimals, forceUnit, locale = 'en', withAll = false, withSi = true, withSiFull = false, withUnit = true, withZero = true } = {}) {
    // we only work with string inputs here - convert anything
    // into the string-only value
    let text = bnToBn(input).toString();
    if (text.length === 0 || text === '0') {
        return '0';
    }
    // strip the negative sign so we can work with clean groupings, re-add this in the
    // end when we return the result (from here on we work with positive numbers)
    let sign = '';
    if (text[0].startsWith('-')) {
        sign = '-';
        text = text.substring(1);
    }
    // We start at midpoint (8) minus 1 - this means that values display as
    // 123.4567 instead of 0.1234 k (so we always have the most relevant).
    const si = calcSi(text, decimals, forceUnit);
    const mid = text.length - (decimals + si.power);
    const pre = mid <= 0 ? '0' : text.substring(0, mid);
    // get the post from the midpoint onward and then first add max decimals
    // before trimming to the correct (calculated) amount of decimals again
    let post = text
        .padStart(mid < 0 ? decimals : 1, '0')
        .substring(mid < 0 ? 0 : mid)
        .padEnd(withAll ? Math.max(decimals, 4) : 4, '0')
        .substring(0, withAll ? Math.max(4, decimals + si.power) : 4);
    // remove all trailing 0's (if required via flag)
    if (!withZero) {
        let end = post.length - 1;
        // This looks inefficient, however it is better to do the checks and
        // only make one final slice than it is to do it in multiples
        do {
            if (post[end] === '0') {
                end--;
            }
        } while (post[end] === '0');
        post = post.substring(0, end + 1);
    }
    // the display unit
    const unit = isBoolean(withUnit)
        ? SI[SI_MID].text
        : withUnit;
    // format the units for display based on the flags
    const units = withSi || withSiFull
        ? si.value === '-'
            ? withUnit
                ? ` ${unit}`
                : ''
            : ` ${withSiFull ? `${si.text}${withUnit ? ' ' : ''}` : si.value}${withUnit ? unit : ''}`
        : '';
    const { decimal, thousand } = getSeparator(locale);
    return `${sign}${formatDecimal(pre, thousand)}${post && `${decimal}${post}`}${units}`;
}
const formatBalance = _formatBalance;
formatBalance.calcSi = (text, decimals = defaultDecimals) => calcSi(text, decimals);
formatBalance.findSi = findSi;
formatBalance.getDefaults = () => {
    return {
        decimals: defaultDecimals,
        unit: defaultUnit
    };
};
formatBalance.getOptions = (decimals = defaultDecimals) => {
    return SI.filter(({ power }) => power < 0
        ? (decimals + power) >= 0
        : true);
};
formatBalance.setDefaults = ({ decimals, unit }) => {
    defaultDecimals = (Array.isArray(decimals)
        ? decimals[0]
        : decimals) ?? defaultDecimals;
    defaultUnit = (Array.isArray(unit)
        ? unit[0]
        : unit) ?? defaultUnit;
    SI[SI_MID].text = defaultUnit;
};

/** @internal */
function zeroPad(value) {
    return value.toString().padStart(2, '0');
}
/**
 * @name formatDate
 * @description Formats a date in CCYY-MM-DD HH:MM:SS format
 */
function formatDate(date) {
    const year = date.getFullYear().toString();
    const month = zeroPad((date.getMonth() + 1));
    const day = zeroPad(date.getDate());
    const hour = zeroPad(date.getHours());
    const minute = zeroPad(date.getMinutes());
    const second = zeroPad(date.getSeconds());
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}

/**
 * @name formatNumber
 * @description Formats a number into string format with thousand separators
 */
function formatNumber(value, { locale = 'en' } = {}) {
    const { thousand } = getSeparator(locale);
    return formatDecimal(bnToBn(value).toString(), thousand);
}

/**
 * @name isString
 * @summary Tests for a string.
 * @description
 * Checks to see if the input value is a JavaScript string.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isString } from '@polkadot/util';
 *
 * console.log('isString', isString('test')); // => true
 * ```
 */
function isString(value) {
    return typeof value === 'string' || value instanceof String;
}

/** @internal */
function isAsciiStr(str) {
    for (let i = 0, count = str.length; i < count; i++) {
        const b = str.charCodeAt(i);
        // check is inlined here, it is faster than making a call
        if (b < 32 || b > 126) {
            return false;
        }
    }
    return true;
}
/** @internal */
function isAsciiBytes(u8a) {
    for (let i = 0, count = u8a.length; i < count; i++) {
        const b = u8a[i] | 0;
        // check is inlined here, it is faster than making a call
        if (b < 32 || b > 126) {
            return false;
        }
    }
    return true;
}
/**
 * @name isAscii
 * @summary Tests if the input is printable ASCII
 * @description
 * Checks to see if the input string or Uint8Array is printable ASCII, 32-127 + formatters
 */
function isAscii(value) {
    return isString(value)
        ? isHex(value)
            ? isAsciiBytes(u8aToU8a(value))
            : isAsciiStr(value)
        : value
            ? isAsciiBytes(value)
            : false;
}

/**
 * @name isClass
 * Tests if the supplied argument is a Class
 */
const isClass = /*#__PURE__*/ isOnFunction('isPrototypeOf', 'hasOwnProperty');

/**
 * @name isChildClass
 * @summary Tests if the child extends the parent Class
 * @description
 * Checks to see if the child Class extends the parent Class
 * @example
 * <BR>
 *
 * ```javascript
 * import { isChildClass } from '@polkadot/util';
 *
 * console.log('isChildClass', isChildClass(BN, BN); // => true
 * console.log('isChildClass', isChildClass(BN, Uint8Array); // => false
 * ```
 */
function isChildClass(Parent, Child) {
    // https://stackoverflow.com/questions/30993434/check-if-a-constructor-inherits-another-in-es6/30993664
    return isClass(Child) && isClass(Parent)
        // eslint-disable-next-line no-prototype-builtins
        ? Parent === Child || Parent.isPrototypeOf(Child)
        : false;
}

const checkCodec = /*#__PURE__*/ isOnObject('toHex', 'toHuman', 'toU8a');
const checkRegistry = /*#__PURE__*/ isOnObject('get');
function isCodec(value) {
    return checkCodec(value) && checkRegistry(value.registry);
}

/**
 * @name isCompact
 * @summary Tests for SCALE-Compact-like object instance.
 */
const isCompact = /*#__PURE__*/ isOnObject('toBigInt', 'toBn', 'toNumber', 'unwrap');

/** @internal */
function replacer(_, v) {
    return isBigInt(v)
        ? v.toString()
        : v;
}
/**
 * @name stringify
 * @summary Performs a JSON.stringify, with BigInt handling
 * @description A wrapper for JSON.stringify that handles BigInt values transparently, converting them to string. No differences from the native JSON.stringify function otherwise.
 */
function stringify(value, space) {
    return JSON.stringify(value, replacer, space);
}

/**
 * @name isNull
 * @summary Tests for a `null` values.
 * @description
 * Checks to see if the input value is `null`.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isNull } from '@polkadot/util';
 *
 * console.log('isNull', isNull(null)); // => true
 * ```
 */
function isNull(value) {
    return value === null;
}

/**
 * @name isNumber
 * @summary Tests for a JavaScript number.
 * @description
 * Checks to see if the input value is a valid number.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isNumber } from '@polkadot/util';
 *
 * console.log('isNumber', isNumber(1234)); // => true
 * ```
 */
function isNumber(value) {
    return typeof value === 'number';
}

/**
 * @name isUndefined
 * @summary Tests for a `undefined` values.
 * @description
 * Checks to see if the input value is `undefined`.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isUndefined } from '@polkadot/util';
 *
 * console.log('isUndefined', isUndefined(void(0))); // => true
 * ```
 */
function isUndefined(value) {
    return value === undefined;
}

/**
 * @name isUtf8
 * @summary Tests if the input is valid Utf8
 * @description
 * Checks to see if the input string or Uint8Array is valid Utf8
 */
function isUtf8(value) {
    if (!value) {
        return isString(value);
    }
    const u8a = u8aToU8a(value);
    const len = u8a.length;
    let i = 0;
    while (i < len) {
        if (u8a[i] <= 0x7F) /* 00..7F */ {
            i += 1;
        }
        else if (u8a[i] >= 0xC2 && u8a[i] <= 0xDF) /* C2..DF 80..BF */ {
            if (i + 1 < len) /* Expect a 2nd byte */ {
                if (u8a[i + 1] < 0x80 || u8a[i + 1] > 0xBF) {
                    // *message = "After a first byte between C2 and DF, expecting a 2nd byte between 80 and BF";
                    // *faulty_bytes = 2;
                    return false;
                }
            }
            else {
                // *message = "After a first byte between C2 and DF, expecting a 2nd byte.";
                // *faulty_bytes = 1;
                return false;
            }
            i += 2;
        }
        else if (u8a[i] === 0xE0) /* E0 A0..BF 80..BF */ {
            if (i + 2 < len) /* Expect a 2nd and 3rd byte */ {
                if (u8a[i + 1] < 0xA0 || u8a[i + 1] > 0xBF) {
                    // *message = "After a first byte of E0, expecting a 2nd byte between A0 and BF.";
                    // *faulty_bytes = 2;
                    return false;
                }
                if (u8a[i + 2] < 0x80 || u8a[i + 2] > 0xBF) {
                    // *message = "After a first byte of E0, expecting a 3nd byte between 80 and BF.";
                    // *faulty_bytes = 3;
                    return false;
                }
            }
            else {
                // *message = "After a first byte of E0, expecting two following bytes.";
                // *faulty_bytes = 1;
                return false;
            }
            i += 3;
        }
        else if (u8a[i] >= 0xE1 && u8a[i] <= 0xEC) /* E1..EC 80..BF 80..BF */ {
            if (i + 2 < len) /* Expect a 2nd and 3rd byte */ {
                if (u8a[i + 1] < 0x80 || u8a[i + 1] > 0xBF) {
                    // *message = "After a first byte between E1 and EC, expecting the 2nd byte between 80 and BF.";
                    // *faulty_bytes = 2;
                    return false;
                }
                if (u8a[i + 2] < 0x80 || u8a[i + 2] > 0xBF) {
                    // *message = "After a first byte between E1 and EC, expecting the 3rd byte between 80 and BF.";
                    // *faulty_bytes = 3;
                    return false;
                }
            }
            else {
                // *message = "After a first byte between E1 and EC, expecting two following bytes.";
                // *faulty_bytes = 1;
                return false;
            }
            i += 3;
        }
        else if (u8a[i] === 0xED) /* ED 80..9F 80..BF */ {
            if (i + 2 < len) /* Expect a 2nd and 3rd byte */ {
                if (u8a[i + 1] < 0x80 || u8a[i + 1] > 0x9F) {
                    // *message = "After a first byte of ED, expecting 2nd byte between 80 and 9F.";
                    // *faulty_bytes = 2;
                    return false;
                }
                if (u8a[i + 2] < 0x80 || u8a[i + 2] > 0xBF) {
                    // *message = "After a first byte of ED, expecting 3rd byte between 80 and BF.";
                    // *faulty_bytes = 3;
                    return false;
                }
            }
            else {
                // *message = "After a first byte of ED, expecting two following bytes.";
                // *faulty_bytes = 1;
                return false;
            }
            i += 3;
        }
        else if (u8a[i] >= 0xEE && u8a[i] <= 0xEF) /* EE..EF 80..BF 80..BF */ {
            if (i + 2 < len) /* Expect a 2nd and 3rd byte */ {
                if (u8a[i + 1] < 0x80 || u8a[i + 1] > 0xBF) {
                    // *message = "After a first byte between EE and EF, expecting 2nd byte between 80 and BF.";
                    // *faulty_bytes = 2;
                    return false;
                }
                if (u8a[i + 2] < 0x80 || u8a[i + 2] > 0xBF) {
                    // *message = "After a first byte between EE and EF, expecting 3rd byte between 80 and BF.";
                    // *faulty_bytes = 3;
                    return false;
                }
            }
            else {
                // *message = "After a first byte between EE and EF, two following bytes.";
                // *faulty_bytes = 1;
                return false;
            }
            i += 3;
        }
        else if (u8a[i] === 0xF0) /* F0 90..BF 80..BF 80..BF */ {
            if (i + 3 < len) /* Expect a 2nd, 3rd 3th byte */ {
                if (u8a[i + 1] < 0x90 || u8a[i + 1] > 0xBF) {
                    // *message = "After a first byte of F0, expecting 2nd byte between 90 and BF.";
                    // *faulty_bytes = 2;
                    return false;
                }
                if (u8a[i + 2] < 0x80 || u8a[i + 2] > 0xBF) {
                    // *message = "After a first byte of F0, expecting 3rd byte between 80 and BF.";
                    // *faulty_bytes = 3;
                    return false;
                }
                if (u8a[i + 3] < 0x80 || u8a[i + 3] > 0xBF) {
                    // *message = "After a first byte of F0, expecting 4th byte between 80 and BF.";
                    // *faulty_bytes = 4;
                    return false;
                }
            }
            else {
                // *message = "After a first byte of F0, expecting three following bytes.";
                // *faulty_bytes = 1;
                return false;
            }
            i += 4;
        }
        else if (u8a[i] >= 0xF1 && u8a[i] <= 0xF3) /* F1..F3 80..BF 80..BF 80..BF */ {
            if (i + 3 < len) /* Expect a 2nd, 3rd 3th byte */ {
                if (u8a[i + 1] < 0x80 || u8a[i + 1] > 0xBF) {
                    // *message = "After a first byte of F1, F2, or F3, expecting a 2nd byte between 80 and BF.";
                    // *faulty_bytes = 2;
                    return false;
                }
                if (u8a[i + 2] < 0x80 || u8a[i + 2] > 0xBF) {
                    // *message = "After a first byte of F1, F2, or F3, expecting a 3rd byte between 80 and BF.";
                    // *faulty_bytes = 3;
                    return false;
                }
                if (u8a[i + 3] < 0x80 || u8a[i + 3] > 0xBF) {
                    // *message = "After a first byte of F1, F2, or F3, expecting a 4th byte between 80 and BF.";
                    // *faulty_bytes = 4;
                    return false;
                }
            }
            else {
                // *message = "After a first byte of F1, F2, or F3, expecting three following bytes.";
                // *faulty_bytes = 1;
                return false;
            }
            i += 4;
        }
        else if (u8a[i] === 0xF4) /* F4 80..8F 80..BF 80..BF */ {
            if (i + 3 < len) /* Expect a 2nd, 3rd 3th byte */ {
                if (u8a[i + 1] < 0x80 || u8a[i + 1] > 0x8F) {
                    // *message = "After a first byte of F4, expecting 2nd byte between 80 and 8F.";
                    // *faulty_bytes = 2;
                    return false;
                }
                if (u8a[i + 2] < 0x80 || u8a[i + 2] > 0xBF) {
                    // *message = "After a first byte of F4, expecting 3rd byte between 80 and BF.";
                    // *faulty_bytes = 3;
                    return false;
                }
                if (u8a[i + 3] < 0x80 || u8a[i + 3] > 0xBF) {
                    // *message = "After a first byte of F4, expecting 4th byte between 80 and BF.";
                    // *faulty_bytes = 4;
                    return false;
                }
            }
            else {
                // *message = "After a first byte of F4, expecting three following bytes.";
                // *faulty_bytes = 1;
                return false;
            }
            i += 4;
        }
        else {
            // *message = "Expecting bytes in the following ranges: 00..7F C2..F4.";
            // *faulty_bytes = 1;
            return false;
        }
    }
    return true;
}

/**
 * @name lazyMethod
 * @description
 * Creates a lazy, on-demand getter for the specific value. Upon get the value will be evaluated.
 */
function lazyMethod(result, item, creator, getName, index = 0) {
    const name = getName
        ? getName(item, index)
        : item.toString();
    let value;
    Object.defineProperty(result, name, {
        // This allows for re-configuration with the embedded defineProperty below
        // and ensures that on tested browsers and Node, it _will_ be redefined
        // and thus short-circuited for future access
        configurable: true,
        enumerable: true,
        // Use a function here, we don't want to capture the outer this, i.e.
        // don't use arrow functions in this context since we have a this inside
        get: function () {
            // This check should _always_ be false and unneeded, since we override
            // with a value below ... however we ensure we are quire vigilant against
            // all environment failures, so we are rather be safe than sorry
            if (value === undefined) {
                value = creator(item, index, this);
                try {
                    // re-define the property as a value, next time around this
                    // getter will only return the computed value
                    Object.defineProperty(this, name, { value });
                }
                catch {
                    // ignore any errors, since this _should_ not happen due to
                    // the "configurable" property above. But if it ever does
                    // from here-on we will be the cached value the next time
                    // around (with a very slight dip in performance)
                }
            }
            return value;
        }
    });
}
/**
 * @name lazyMethods
 * @description
 * Creates lazy, on-demand getters for the specific values.
 */
function lazyMethods(result, items, creator, getName) {
    for (let i = 0, count = items.length; i < count; i++) {
        lazyMethod(result, items[i], creator, getName, i);
    }
    return result;
}

/**
 * A sharable identity function. Returns the input as-is with no transformation applied.
 */
function identity$2(value) {
    return value;
}
/**
 * A sharable noop function. As the name suggests, does nothing
 */
function noop$1() {
    // noop
}

const logTo = {
    debug: 'log',
    error: 'error',
    log: 'log',
    warn: 'warn'
};
function formatOther(value) {
    if (value && isObject(value) && value.constructor === Object) {
        const result = {};
        for (const [k, v] of Object.entries(value)) {
            result[k] = loggerFormat(v);
        }
        return result;
    }
    return value;
}
function loggerFormat(value) {
    if (Array.isArray(value)) {
        return value.map(loggerFormat);
    }
    else if (isBn(value)) {
        return value.toString();
    }
    else if (isU8a(value) || isBuffer(value)) {
        return u8aToHex(u8aToU8a(value));
    }
    return formatOther(value);
}
function formatWithLength(maxLength) {
    return (v) => {
        if (maxLength <= 0) {
            return v;
        }
        const r = `${v}`;
        return r.length < maxLength
            ? v
            : `${r.substring(0, maxLength)} ...`;
    };
}
function apply(log, type, values, maxSize = -1) {
    if (values.length === 1 && isFunction$1(values[0])) {
        const fnResult = values[0]();
        return apply(log, type, Array.isArray(fnResult) ? fnResult : [fnResult], maxSize);
    }
    console[logTo[log]](formatDate(new Date()), type, ...values
        .map(loggerFormat)
        .map(formatWithLength(maxSize)));
}
function isDebugOn(e, type) {
    return !!e && (e === '*' ||
        type === e ||
        (e.endsWith('*') &&
            type.startsWith(e.slice(0, -1))));
}
function isDebugOff(e, type) {
    return !!e && (e.startsWith('-') &&
        (type === e.slice(1) ||
            (e.endsWith('*') &&
                type.startsWith(e.slice(1, -1)))));
}
function getDebugFlag(env, type) {
    let flag = false;
    for (const e of env) {
        if (isDebugOn(e, type)) {
            flag = true;
        }
        else if (isDebugOff(e, type)) {
            flag = false;
        }
    }
    return flag;
}
function parseEnv(type) {
    const maxSize = parseInt(xglobal.process?.env?.['DEBUG_MAX'] || '-1', 10);
    return [
        getDebugFlag((xglobal.process?.env?.['DEBUG'] || '').toLowerCase().split(','), type),
        isNaN(maxSize)
            ? -1
            : maxSize
    ];
}
/**
 * @name Logger
 * @summary Creates a consistent log interface for messages
 * @description
 * Returns a `Logger` that has `.log`, `.error`, `.warn` and `.debug` (controlled with environment `DEBUG=typeA,typeB`) methods. Logging is done with a consistent prefix (type of logger, date) followed by the actual message using the underlying console.
 * @example
 * <BR>
 *
 * ```javascript
 * import { logger } from '@polkadot/util';
 *
 * const l = logger('test');
 * ```
 */
function logger(origin) {
    const type = `${origin.toUpperCase()}:`.padStart(16);
    const [isDebug, maxSize] = parseEnv(origin.toLowerCase());
    return {
        debug: isDebug
            ? (...values) => apply('debug', type, values, maxSize)
            : noop$1,
        error: (...values) => apply('error', type, values),
        log: (...values) => apply('log', type, values),
        noop: noop$1,
        warn: (...values) => apply('warn', type, values)
    };
}

function defaultGetId() {
    return 'none';
}
/**
 * @name memoize
 * @description Memomize the function with a specific instanceId
 */
function memoize(fn, { getInstanceId = defaultGetId } = {}) {
    const cache = {};
    const memoized = (...args) => {
        const stringParams = stringify(args);
        const instanceId = getInstanceId();
        if (!cache[instanceId]) {
            cache[instanceId] = {};
        }
        if (cache[instanceId][stringParams] === undefined) {
            cache[instanceId][stringParams] = fn(...args);
        }
        return cache[instanceId][stringParams];
    };
    memoized.unmemoize = (...args) => {
        const stringParams = stringify(args);
        const instanceId = getInstanceId();
        if (cache[instanceId]?.[stringParams] !== undefined) {
            delete cache[instanceId][stringParams];
        }
    };
    return memoized;
}

/**
 * @name nextTick
 * @description Defer the operation to the queue for evaluation on the next tick
 */
function nextTick(onExec, onError) {
    // While Promise.resolve().then(...) would defer to the nextTick, this
    // actually does not play as nicely in browsers like the setTimeout(...)
    // approach. So the safer, though less optimal approach is the one taken here
    setTimeout(() => {
        Promise
            .resolve()
            .then(() => {
            onExec();
        })
            .catch((error) => {
            {
                console.error(error);
            }
        });
    }, 0);
}

/**
 * @name objectClear
 * @summary Removes all the keys from the input object
 */
function objectClear(value) {
    const keys = Object.keys(value);
    for (let i = 0, count = keys.length; i < count; i++) {
        delete value[keys[i]];
    }
    return value;
}

/**
 * @name objectSpread
 * @summary Concats all sources into the destination
 * @description Spreads object properties while maintaining object integrity
 */
function objectSpread(dest, ...sources) {
    const filterProps = new Set(['__proto__', 'constructor', 'prototype']);
    for (let i = 0, count = sources.length; i < count; i++) {
        const src = sources[i];
        if (src) {
            if (typeof src.entries === 'function') {
                for (const [key, value] of src.entries()) {
                    if (!filterProps.has(key)) {
                        dest[key] = value;
                    }
                }
            }
            else {
                // Create a clean copy of the source object
                const sanitizedSrc = Object.create(null);
                for (const [key, value] of Object.entries(src)) {
                    if (!filterProps.has(key)) {
                        sanitizedSrc[key] = value;
                    }
                }
                Object.assign(dest, sanitizedSrc);
            }
        }
    }
    return dest;
}

/**
 * @name objectProperty
 * @summary Assign a get property on the input object
 */
function objectProperty(that, key, getter, getName, index = 0) {
    const name = key;
    // There are 3 approaches here -
    //  - Object.prototype.hasOwnProperty.call(that, key) - this only checks the current class, i.e
    //    will retuirn false if the property is set in the parent class
    //  - isUndefined(...) - this may yield a false positive when the property is there, but not set.
    //    Additionally, on pre-defined getters it may make a call
    //  - key in that - Does not need to be combined with either of the above and checks the full chain
    if (!(name in that)) {
        Object.defineProperty(that, name, {
            enumerable: true,
            // Unlike in lazy, we always call into the upper function, i.e. this method
            // does not cache old values (it is expected to be used for dynamic values)
            get: function () {
                return getter(key, index, this);
            }
        });
    }
}
/**
 * @name objectProperties
 * @summary Assign get properties on the input object
 */
function objectProperties(that, keys, getter, getName) {
    for (let i = 0, count = keys.length; i < count; i++) {
        objectProperty(that, keys[i], getter, getName, i);
    }
}

const CC_TO_UP = new Array(256);
const CC_TO_LO = new Array(256);
for (let i = 0, count = CC_TO_UP.length; i < count; i++) {
    CC_TO_LO[i] = String.fromCharCode(i).toLowerCase();
    CC_TO_UP[i] = String.fromCharCode(i).toUpperCase();
}
/** @internal */
function formatAllCaps(w) {
    return w.slice(0, w.length - 1).toLowerCase() + CC_TO_UP[w.charCodeAt(w.length - 1)];
}
/**
 * @internal
 *
 * Inspired by https://stackoverflow.com/a/2970667
 *
 * This is not as optimal as the original SO answer (we split into per-word),
 * however it does pass the tests (which the SO version doesn't) and is still
 * a major improvement over the original camelcase npm package -
 *
 *   camelcase: 20.88 μs/op
 *        this:  1.00 μs/op
 *
 * Caveat of this: only Ascii, but acceptable for the intended usecase
 */
function converter$1(format) {
    return (value) => {
        const parts = value
            // replace all separators (including consequtive) with spaces
            .replace(/[-_., ]+/g, ' ')
            // we don't want leading or trailing spaces
            .trim()
            // split into words
            .split(' ');
        let result = '';
        for (let i = 0, count = parts.length; i < count; i++) {
            const w = parts[i];
            // apply the formatting
            result += format(/^[\dA-Z]+$/.test(w)
                // all full uppercase + letters are changed to lowercase
                ? w.toLowerCase()
                // all consecutive capitals + letters are changed to lowercase
                // e.g. UUID64 -> uuid64, while preserving splits, eg. NFTOrder -> nftOrder
                : w.replace(/^[\dA-Z]{2,}[^a-z]/, formatAllCaps), i);
        }
        return result;
    };
}
/**
 * @name stringCamelCase
 * @summary Convert a dash/dot/underscore/space separated Ascii string/String to camelCase
 */
const stringCamelCase = /*#__PURE__*/ converter$1((w, i) => 
(i ? CC_TO_UP[w.charCodeAt(0)] : CC_TO_LO[w.charCodeAt(0)]) + w.slice(1));
/**
 * @name stringPascalCase
 * @summary Convert a dash/dot/underscore/space separated Ascii string/String to PascalCase
 */
const stringPascalCase = /*#__PURE__*/ converter$1((w) => 
CC_TO_UP[w.charCodeAt(0)] + w.slice(1));

/** @internal */
function converter(map) {
    return (value) => value
        ? map[value.charCodeAt(0)] + value.slice(1)
        : '';
}
/**
 * @name stringUpperFirst
 * @summary Uppercase the first letter of a string
 * @description
 * Lowercase the first letter of a string
 * @example
 * <BR>
 *
 * ```javascript
 * import { stringUpperFirst } from '@polkadot/util';
 *
 * stringUpperFirst('abc'); // => 'Abc'
 * ```
 */
const stringUpperFirst = /*#__PURE__*/ converter(CC_TO_UP);

/**
 * @name stringToHex
 * @summary Creates a hex string from a utf-8 string
 * @description
 * String input values return the actual encoded hex value.
 * @example
 * <BR>
 *
 * ```javascript
 * import { stringToHex } from '@polkadot/util';
 *
 * stringToU8a('hello'); // 0x68656c6c6f
 * ```
 */
function stringToHex(value) {
    return u8aToHex(stringToU8a(value));
}

const packageInfo = { name: '@polkadot/api', path: (import.meta && import.meta.url) ? new URL(import.meta.url).pathname.substring(0, new URL(import.meta.url).pathname.lastIndexOf('/') + 1) : 'auto', version: '16.4.9' };

const crypto$1 = xglobal.crypto;
function getRandomValues(arr) {
    return crypto$1.getRandomValues(arr);
}

const DEFAULT_CRYPTO = { getRandomValues };
const DEFAULT_SELF = { crypto: DEFAULT_CRYPTO };
/**
 * @name Wbg
 * @description
 * This defines the internal interfaces that wasm-bindgen used to communicate
 * with the host layer. None of these functions are available to the user, rather
 * they are called internally from the WASM code itself.
 *
 * The interfaces here are exposed in the imports on the created WASM interfaces.
 *
 * Internally the implementation does a thin layer into the supplied bridge.
 */
class Wbg {
    #bridge;
    constructor(bridge) {
        this.#bridge = bridge;
    }
    /** @internal */
    abort = () => {
        throw new Error('abort');
    };
    /** @internal */
    __wbindgen_is_undefined = (idx) => {
        return this.#bridge.getObject(idx) === undefined;
    };
    /** @internal */
    __wbindgen_throw = (ptr, len) => {
        throw new Error(this.#bridge.getString(ptr, len));
    };
    /** @internal */
    __wbg_self_1b7a39e3a92c949c = () => {
        return this.#bridge.addObject(DEFAULT_SELF);
    };
    /** @internal */
    __wbg_require_604837428532a733 = (ptr, len) => {
        throw new Error(`Unable to require ${this.#bridge.getString(ptr, len)}`);
    };
    /** @internal */
    __wbg_crypto_968f1772287e2df0 = (_idx) => {
        return this.#bridge.addObject(DEFAULT_CRYPTO);
    };
    /** @internal */
    __wbg_getRandomValues_a3d34b4fee3c2869 = (_idx) => {
        return this.#bridge.addObject(DEFAULT_CRYPTO.getRandomValues);
    };
    /** @internal */
    __wbg_getRandomValues_f5e14ab7ac8e995d = (_arg0, ptr, len) => {
        DEFAULT_CRYPTO.getRandomValues(this.#bridge.getU8a(ptr, len));
    };
    /** @internal */
    __wbg_randomFillSync_d5bd2d655fdf256a = (_idx, _ptr, _len) => {
        throw new Error('randomFillsync is not available');
        // getObject(idx).randomFillSync(getU8a(ptr, len));
    };
    /** @internal */
    __wbindgen_object_drop_ref = (idx) => {
        this.#bridge.takeObject(idx);
    };
}

/**
 * @name Bridge
 * @description
 * Creates a bridge between the JS and WASM environments.
 *
 * For any bridge it is passed an function which is then called internally at the
 * time of initialization. This affectively implements the layer between WASM and
 * the native environment, providing all the plumbing needed for the Wbg classes.
 */
class Bridge {
    #createWasm;
    #heap;
    #wbg;
    #cachegetInt32;
    #cachegetUint8;
    #heapNext;
    #wasm;
    #wasmError;
    #wasmPromise;
    #type;
    constructor(createWasm) {
        this.#createWasm = createWasm;
        this.#cachegetInt32 = null;
        this.#cachegetUint8 = null;
        this.#heap = new Array(32)
            .fill(undefined)
            .concat(undefined, null, true, false);
        this.#heapNext = this.#heap.length;
        this.#type = 'none';
        this.#wasm = null;
        this.#wasmError = null;
        this.#wasmPromise = null;
        this.#wbg = { ...new Wbg(this) };
    }
    /** @description Returns the init error */
    get error() {
        return this.#wasmError;
    }
    /** @description Returns the init type */
    get type() {
        return this.#type;
    }
    /** @description Returns the created wasm interface */
    get wasm() {
        return this.#wasm;
    }
    /** @description Performs the wasm initialization */
    async init(createWasm) {
        if (!this.#wasmPromise || createWasm) {
            this.#wasmPromise = (createWasm || this.#createWasm)(this.#wbg);
        }
        const { error, type, wasm } = await this.#wasmPromise;
        this.#type = type;
        this.#wasm = wasm;
        this.#wasmError = error;
        return this.#wasm;
    }
    /**
     * @internal
     * @description Gets an object from the heap
     */
    getObject(idx) {
        return this.#heap[idx];
    }
    /**
     * @internal
     * @description Removes an object from the heap
     */
    dropObject(idx) {
        if (idx < 36) {
            return;
        }
        this.#heap[idx] = this.#heapNext;
        this.#heapNext = idx;
    }
    /**
     * @internal
     * @description Retrieves and removes an object to the heap
     */
    takeObject(idx) {
        const ret = this.getObject(idx);
        this.dropObject(idx);
        return ret;
    }
    /**
     * @internal
     * @description Adds an object to the heap
     */
    addObject(obj) {
        if (this.#heapNext === this.#heap.length) {
            this.#heap.push(this.#heap.length + 1);
        }
        const idx = this.#heapNext;
        this.#heapNext = this.#heap[idx];
        this.#heap[idx] = obj;
        return idx;
    }
    /**
     * @internal
     * @description Retrieve an Int32 in the WASM interface
     */
    getInt32() {
        if (this.#cachegetInt32 === null || this.#cachegetInt32.buffer !== this.#wasm.memory.buffer) {
            this.#cachegetInt32 = new Int32Array(this.#wasm.memory.buffer);
        }
        return this.#cachegetInt32;
    }
    /**
     * @internal
     * @description Retrieve an Uint8Array in the WASM interface
     */
    getUint8() {
        if (this.#cachegetUint8 === null || this.#cachegetUint8.buffer !== this.#wasm.memory.buffer) {
            this.#cachegetUint8 = new Uint8Array(this.#wasm.memory.buffer);
        }
        return this.#cachegetUint8;
    }
    /**
     * @internal
     * @description Retrieves an Uint8Array in the WASM interface
     */
    getU8a(ptr, len) {
        return this.getUint8().subarray(ptr / 1, ptr / 1 + len);
    }
    /**
     * @internal
     * @description Retrieves a string in the WASM interface
     */
    getString(ptr, len) {
        return u8aToString(this.getU8a(ptr, len));
    }
    /**
     * @internal
     * @description Allocates an Uint8Array in the WASM interface
     */
    allocU8a(arg) {
        const ptr = this.#wasm.__wbindgen_malloc(arg.length * 1);
        this.getUint8().set(arg, ptr / 1);
        return [ptr, arg.length];
    }
    /**
     * @internal
     * @description Allocates a string in the WASM interface
     */
    allocString(arg) {
        return this.allocU8a(stringToU8a(arg));
    }
    /**
     * @internal
     * @description Retrieves an Uint8Array from the WASM interface
     */
    resultU8a() {
        const r0 = this.getInt32()[8 / 4 + 0];
        const r1 = this.getInt32()[8 / 4 + 1];
        const ret = this.getU8a(r0, r1).slice();
        this.#wasm.__wbindgen_free(r0, r1 * 1);
        return ret;
    }
    /**
     * @internal
     * @description Retrieve a string from the WASM interface
     */
    resultString() {
        return u8aToString(this.resultU8a());
    }
}

/**
 * @name createWasmFn
 * @description
 * Create a WASM (or ASM.js) creator interface based on the supplied information.
 *
 * It will attempt to create a WASM interface first and if this fails or is not available in
 * the environment, will fallback to attempting to create an ASM.js interface.
 */
function createWasmFn(root, wasmBytes, asmFn) {
    return async (wbg) => {
        const result = {
            error: null,
            type: 'none',
            wasm: null
        };
        try {
            if (!wasmBytes?.length) {
                throw new Error('No WebAssembly provided for initialization');
            }
            else if (typeof WebAssembly !== 'object' || typeof WebAssembly.instantiate !== 'function') {
                throw new Error('WebAssembly is not available in your environment');
            }
            const source = await WebAssembly.instantiate(wasmBytes, { wbg });
            result.wasm = source.instance.exports;
            result.type = 'wasm';
        }
        catch (error) {
            // if we have a valid supplied asm.js, return that
            {
                result.error = `FATAL: Unable to initialize @polkadot/wasm-${root}:: ${error.message}`;
                console.error(result.error);
            }
        }
        return result;
    };
}

const CHR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
const map$1 = new Array(256);
for (let i = 0, count = CHR.length; i < count; i++) {
    map$1[CHR.charCodeAt(i)] = i;
}
/**
 * @name base64Decode
 * @description
 * A base64 decoding function that operates in all environments. Unlike decoding
 * from Buffer (Node.js only) or atob (browser-only) this implementation is
 * slightly slower, but it is platform independent.
 *
 * For our usage, since we have access to the static final size, so we decode
 * to a specified output buffer. This also means we have applied a number of
 * optimizations based on this - checking output position instead of chars.
 */
function base64Decode(data, out) {
    let byte = 0;
    let bits = 0;
    let pos = -1;
    for (let i = 0, last = out.length - 1; pos !== last; i++) {
        // each character represents 6 bits
        byte = (byte << 6) | map$1[data.charCodeAt(i)];
        // each byte needs to contain 8 bits
        if ((bits += 6) >= 8) {
            out[++pos] = (byte >>> (bits -= 8)) & 0xff;
        }
    }
    return out;
}

const u8$1 = Uint8Array, u16$1 = Uint16Array, u32$2 = Uint32Array;
const clim = new u8$1([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
const fleb = new u8$1([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, /* unused */ 0, 0, /* impossible */ 0]);
const fdeb = new u8$1([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, /* unused */ 0, 0]);
const freb = (eb, start) => {
    const b = new u16$1(31);
    for (let i = 0; i < 31; ++i) {
        b[i] = start += 1 << eb[i - 1];
    }
    // numbers here are at max 18 bits
    const r = new u32$2(b[30]);
    for (let i = 1; i < 30; ++i) {
        for (let j = b[i]; j < b[i + 1]; ++j) {
            r[j] = ((j - b[i]) << 5) | i;
        }
    }
    return [b, r];
};
const [fl, revfl] = freb(fleb, 2);
fl[28] = 258, revfl[258] = 28;
const [fd] = freb(fdeb, 0);
const rev = new u16$1(32768);
for (let i = 0; i < 32768; ++i) {
    // reverse table algorithm from SO
    let x = ((i & 0xAAAA) >>> 1) | ((i & 0x5555) << 1);
    x = ((x & 0xCCCC) >>> 2) | ((x & 0x3333) << 2);
    x = ((x & 0xF0F0) >>> 4) | ((x & 0x0F0F) << 4);
    rev[i] = (((x & 0xFF00) >>> 8) | ((x & 0x00FF) << 8)) >>> 1;
}
const hMap = ((cd, mb, r) => {
    const s = cd.length;
    // index
    let i = 0;
    // u16 "map": index -> # of codes with bit length = index
    const l = new u16$1(mb);
    // length of cd must be 288 (total # of codes)
    for (; i < s; ++i) {
        if (cd[i])
            ++l[cd[i] - 1];
    }
    // u16 "map": index -> minimum code for bit length = index
    const le = new u16$1(mb);
    for (i = 1; i < mb; ++i) {
        le[i] = (le[i - 1] + l[i - 1]) << 1;
    }
    let co;
    {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new u16$1(1 << mb);
        // bits to remove for reverser
        const rvb = 15 - mb;
        for (i = 0; i < s; ++i) {
            // ignore 0 lengths
            if (cd[i]) {
                // num encoding both symbol and bits read
                const sv = (i << 4) | cd[i];
                // free bits
                const r = mb - cd[i];
                // start value
                let v = le[cd[i] - 1]++ << r;
                // m is end value
                for (const m = v | ((1 << r) - 1); v <= m; ++v) {
                    // every 16 bit value starting with the code yields the same result
                    co[rev[v] >> rvb] = sv;
                }
            }
        }
    }
    return co;
});
const flt = new u8$1(288);
for (let i = 0; i < 144; ++i)
    flt[i] = 8;
for (let i = 144; i < 256; ++i)
    flt[i] = 9;
for (let i = 256; i < 280; ++i)
    flt[i] = 7;
for (let i = 280; i < 288; ++i)
    flt[i] = 8;
const fdt = new u8$1(32);
for (let i = 0; i < 32; ++i)
    fdt[i] = 5;
const flrm = hMap(flt, 9);
const fdrm = hMap(fdt, 5);
const bits = (d, p, m) => {
    const o = p >>> 3;
    return ((d[o] | (d[o + 1] << 8)) >>> (p & 7)) & m;
};
const bits16 = (d, p) => {
    const o = p >>> 3;
    return ((d[o] | (d[o + 1] << 8) | (d[o + 2] << 16)) >>> (p & 7));
};
const shft = (p) => (p >>> 3) + (p & 7 && 1);
const slc = (v, s, e) => {
    if (e == null || e > v.length)
        e = v.length;
    // can't use .constructor in case user-supplied
    const n = new (v instanceof u16$1 ? u16$1 : v instanceof u32$2 ? u32$2 : u8$1)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
const max = (a) => {
    let m = a[0];
    for (let i = 1, count = a.length; i < count; ++i) {
        if (a[i] > m)
            m = a[i];
    }
    return m;
};
const inflt = (dat, buf, st) => {
    const noSt = !st || st.i;
    if (!st)
        st = {};
    // source length
    const sl = dat.length;
    // have to estimate size
    const noBuf = !buf || !noSt;
    // Assumes roughly 33% compression ratio average
    if (!buf)
        buf = new u8$1(sl * 3);
    // ensure buffer can fit at least l elements
    const cbuf = (l) => {
        let bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            const nbuf = new u8$1(Math.max(bl << 1, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    let final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    if (final && !lm)
        return buf;
    // total bits
    const tbts = sl << 3;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            st.f = final = bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            const type = bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                const s = shft(pos) + 4, l = dat[s - 4] | (dat[s - 3] << 8), t = s + l;
                if (t > sl) {
                    if (noSt)
                        throw 'unexpected EOF';
                    break;
                }
                // ensure size
                if (noBuf)
                    cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t << 3;
                continue;
            }
            else if (type == 1)
                lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                const hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
                const tl = hLit + bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                const ldt = new u8$1(tl);
                // code length tree
                const clt = new u8$1(19);
                for (let i = 0; i < hcLen; ++i) {
                    // use index map to get real code
                    clt[clim[i]] = bits(dat, pos + i * 3, 7);
                }
                pos += hcLen * 3;
                // code lengths bits
                const clb = max(clt), clbmsk = (1 << clb) - 1;
                if (!noSt && pos + tl * (clb + 7) > tbts)
                    break;
                // code lengths map
                const clm = hMap(clt, clb);
                for (let i = 0; i < tl;) {
                    const r = clm[bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    const s = r >>> 4;
                    // code length to copy
                    if (s < 16) {
                        ldt[i++] = s;
                    }
                    else {
                        //  copy   count
                        let c = 0, n = 0;
                        if (s == 16)
                            n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17)
                            n = 3 + bits(dat, pos, 7), pos += 3;
                        else if (s == 18)
                            n = 11 + bits(dat, pos, 127), pos += 7;
                        while (n--)
                            ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                const lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = max(lt);
                // max dist bits
                dbt = max(dt);
                lm = hMap(lt, lbt);
                dm = hMap(dt, dbt);
            }
            else
                throw 'invalid block type';
            if (pos > tbts)
                throw 'unexpected EOF';
        }
        // Make sure the buffer can hold this + the largest possible addition
        // maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf)
            cbuf(bt + 131072);
        const lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        const mxa = lbt + dbt + 18;
        while (noSt || pos + mxa < tbts) {
            // bits read, code
            const c = lm[bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts)
                throw 'unexpected EOF';
            if (!c)
                throw 'invalid length/literal';
            if (sym < 256)
                buf[bt++] = sym;
            else if (sym == 256) {
                lm = undefined;
                break;
            }
            else {
                let add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    const i = sym - 257, b = fleb[i];
                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                    pos += b;
                }
                // dist
                const d = dm[bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d)
                    throw 'invalid distance';
                pos += d & 15;
                let dt = fd[dsym];
                if (dsym > 3) {
                    const b = fdeb[dsym];
                    dt += bits16(dat, pos) & ((1 << b) - 1), pos += b;
                }
                if (pos > tbts)
                    throw 'unexpected EOF';
                if (noBuf)
                    cbuf(bt + 131072);
                const end = bt + add;
                for (; bt < end; bt += 4) {
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = pos, st.b = bt;
        if (lm)
            final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    } while (!final);
    return bt == buf.length ? buf : slc(buf, 0, bt);
};
const zlv = (d) => {
    if ((d[0] & 15) != 8 || (d[0] >>> 4) > 7 || ((d[0] << 8 | d[1]) % 31))
        throw 'invalid zlib data';
    if (d[1] & 32)
        throw 'invalid zlib data: preset dictionaries not supported';
};
/**
 * Expands Zlib data
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */
function unzlibSync(data, out) {
    return inflt((zlv(data), data.subarray(2, -4)), out);
}

// Copyright 2019-2025 @polkadot/wasm-crypto-wasm authors & contributors
// SPDX-License-Identifier: Apache-2.0

// Generated as part of the build, do not edit

var lenIn = 176940;

var lenOut = 355100;

var bytes_1 = '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';

/**
 * @name wasmBytes
 * @description
 * The decoded WASM interface as exposed by this package.
 *
 * The build process will output into cjs/* into a compressed base64 format.
 * Upon loading the exposed bytes will be decoded and decompressed from this
 * specific format and returned.
 */
const wasmBytes = /*#__PURE__*/ unzlibSync(base64Decode(bytes_1, new Uint8Array(lenIn)), new Uint8Array(lenOut));

/**
 * @name createWasm
 * @description
 * Creates an interface using only WASM
 */
const createWasm = /*#__PURE__*/ createWasmFn('crypto', wasmBytes);

/**
 * @name bridge
 * @description
 * The JS <-> WASM bridge that is in operation. For the specific package
 * it is a global, i.e. all operations happens on this specific bridge
 */
const bridge = new Bridge(createWasm);
/**
 * @name initBridge
 * @description
 * Creates a new bridge interface with the (optional) initialization function
 */
async function initBridge(createWasm) {
    return bridge.init(createWasm);
}

/**
 * @internal
 * @description
 * This create an extenal interface function from the signature, all the while checking
 * the actual bridge wasm interface to ensure it has been initialized.
 *
 * This means that we can call it
 *
 *   withWasm(wasm: WasmCryptoInstance, a: number, b: string) => Uint8Array
 *
 * and in this case it will create an interface function with the signarure
 *
 *   (a: number, b: string) => Uint8Array
 */
function withWasm(fn) {
    return (...params) => {
        if (!bridge.wasm) {
            throw new Error('The WASM interface has not been initialized. Ensure that you wait for the initialization Promise with waitReady() from @polkadot/wasm-crypto (or cryptoWaitReady() from @polkadot/util-crypto) before attempting to use WASM-only interfaces.');
        }
        return fn(bridge.wasm, ...params);
    };
}
const secp256k1Expand$1 = /*#__PURE__*/ withWasm((wasm, pubkey) => {
    wasm.ext_secp_pub_expand(8, ...bridge.allocU8a(pubkey));
    return bridge.resultU8a();
});
const blake2b$2 = /*#__PURE__*/ withWasm((wasm, data, key, size) => {
    wasm.ext_blake2b(8, ...bridge.allocU8a(data), ...bridge.allocU8a(key), size);
    return bridge.resultU8a();
});
const keccak256 = /*#__PURE__*/ withWasm((wasm, data) => {
    wasm.ext_keccak256(8, ...bridge.allocU8a(data));
    return bridge.resultU8a();
});
const keccak512 = /*#__PURE__*/ withWasm((wasm, data) => {
    wasm.ext_keccak512(8, ...bridge.allocU8a(data));
    return bridge.resultU8a();
});
const twox = /*#__PURE__*/ withWasm((wasm, data, rounds) => {
    wasm.ext_twox(8, ...bridge.allocU8a(data), rounds);
    return bridge.resultU8a();
});
function isReady() {
    return !!bridge.wasm;
}
async function waitReady() {
    try {
        const wasm = await initBridge();
        return !!wasm;
    }
    catch {
        return false;
    }
}

function cryptoWaitReady() {
    return waitReady()
        .then(() => {
        if (!isReady()) {
            throw new Error('Unable to initialize @polkadot/util-crypto');
        }
        return true;
    })
        .catch(() => false);
}

/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function isBytes$1(a) {
    return a instanceof Uint8Array || (ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array');
}
function isArrayOf(isString, arr) {
    if (!Array.isArray(arr))
        return false;
    if (arr.length === 0)
        return true;
    if (isString) {
        return arr.every((item) => typeof item === 'string');
    }
    else {
        return arr.every((item) => Number.isSafeInteger(item));
    }
}
function astr(label, input) {
    if (typeof input !== 'string')
        throw new Error(`${label}: string expected`);
    return true;
}
function anumber$1(n) {
    if (!Number.isSafeInteger(n))
        throw new Error(`invalid integer: ${n}`);
}
function aArr(input) {
    if (!Array.isArray(input))
        throw new Error('array expected');
}
function astrArr(label, input) {
    if (!isArrayOf(true, input))
        throw new Error(`${label}: array of strings expected`);
}
function anumArr(label, input) {
    if (!isArrayOf(false, input))
        throw new Error(`${label}: array of numbers expected`);
}
/**
 * @__NO_SIDE_EFFECTS__
 */
function chain$1(...args) {
    const id = (a) => a;
    // Wrap call in closure so JIT can inline calls
    const wrap = (a, b) => (c) => a(b(c));
    // Construct chain of args[-1].encode(args[-2].encode([...]))
    const encode = args.map((x) => x.encode).reduceRight(wrap, id);
    // Construct chain of args[0].decode(args[1].decode(...))
    const decode = args.map((x) => x.decode).reduce(wrap, id);
    return { encode, decode };
}
/**
 * Encodes integer radix representation to array of strings using alphabet and back.
 * Could also be array of strings.
 * @__NO_SIDE_EFFECTS__
 */
function alphabet(letters) {
    // mapping 1 to "b"
    const lettersA = typeof letters === 'string' ? letters.split('') : letters;
    const len = lettersA.length;
    astrArr('alphabet', lettersA);
    // mapping "b" to 1
    const indexes = new Map(lettersA.map((l, i) => [l, i]));
    return {
        encode: (digits) => {
            aArr(digits);
            return digits.map((i) => {
                if (!Number.isSafeInteger(i) || i < 0 || i >= len)
                    throw new Error(`alphabet.encode: digit index outside alphabet "${i}". Allowed: ${letters}`);
                return lettersA[i];
            });
        },
        decode: (input) => {
            aArr(input);
            return input.map((letter) => {
                astr('alphabet.decode', letter);
                const i = indexes.get(letter);
                if (i === undefined)
                    throw new Error(`Unknown letter: "${letter}". Allowed: ${letters}`);
                return i;
            });
        },
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */
function join(separator = '') {
    astr('join', separator);
    return {
        encode: (from) => {
            astrArr('join.decode', from);
            return from.join(separator);
        },
        decode: (to) => {
            astr('join.decode', to);
            return to.split(separator);
        },
    };
}
/**
 * Slow: O(n^2) time complexity
 */
function convertRadix(data, from, to) {
    // base 1 is impossible
    if (from < 2)
        throw new Error(`convertRadix: invalid from=${from}, base cannot be less than 2`);
    if (to < 2)
        throw new Error(`convertRadix: invalid to=${to}, base cannot be less than 2`);
    aArr(data);
    if (!data.length)
        return [];
    let pos = 0;
    const res = [];
    const digits = Array.from(data, (d) => {
        anumber$1(d);
        if (d < 0 || d >= from)
            throw new Error(`invalid integer: ${d}`);
        return d;
    });
    const dlen = digits.length;
    while (true) {
        let carry = 0;
        let done = true;
        for (let i = pos; i < dlen; i++) {
            const digit = digits[i];
            const fromCarry = from * carry;
            const digitBase = fromCarry + digit;
            if (!Number.isSafeInteger(digitBase) ||
                fromCarry / from !== carry ||
                digitBase - digit !== fromCarry) {
                throw new Error('convertRadix: carry overflow');
            }
            const div = digitBase / to;
            carry = digitBase % to;
            const rounded = Math.floor(div);
            digits[i] = rounded;
            if (!Number.isSafeInteger(rounded) || rounded * to + carry !== digitBase)
                throw new Error('convertRadix: carry overflow');
            if (!done)
                continue;
            else if (!rounded)
                pos = i;
            else
                done = false;
        }
        res.push(carry);
        if (done)
            break;
    }
    for (let i = 0; i < data.length - 1 && data[i] === 0; i++)
        res.push(0);
    return res.reverse();
}
/**
 * @__NO_SIDE_EFFECTS__
 */
function radix(num) {
    anumber$1(num);
    const _256 = 2 ** 8;
    return {
        encode: (bytes) => {
            if (!isBytes$1(bytes))
                throw new Error('radix.encode input should be Uint8Array');
            return convertRadix(Array.from(bytes), _256, num);
        },
        decode: (digits) => {
            anumArr('radix.decode', digits);
            return Uint8Array.from(convertRadix(digits, num, _256));
        },
    };
}
// base58 code
// -----------
const genBase58 = /* @__NO_SIDE_EFFECTS__ */ (abc) => chain$1(radix(58), alphabet(abc), join(''));
/**
 * base58: base64 without ambigous characters +, /, 0, O, I, l.
 * Quadratic (O(n^2)) - so, can't be used on large inputs.
 * @example
 * ```js
 * base58.decode('01abcdef');
 * // => '3UhJW'
 * ```
 */
const base58 = genBase58('123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz');

/** @internal */
function createDecode({ coder, ipfs }, validate) {
    return (value, ipfsCompat) => {
        validate(value, ipfsCompat);
        return coder.decode(ipfsCompat
            ? value.substring(1)
            : value);
    };
}
/** @internal */
function createEncode({ coder, ipfs }) {
    return (value, ipfsCompat) => {
        const out = coder.encode(u8aToU8a(value));
        return ipfs && ipfsCompat
            ? `${ipfs}${out}`
            : out;
    };
}
/** @internal */
function createValidate({ chars, ipfs, type, withPadding }) {
    return (value, ipfsCompat) => {
        if (typeof value !== 'string') {
            throw new Error(`Expected ${type} string input`);
        }
        else if (ipfsCompat && !value.startsWith(ipfs)) {
            throw new Error(`Expected ipfs-compatible ${type} to start with '${ipfs}'`);
        }
        for (let i = (ipfsCompat ? 1 : 0), count = value.length; i < count; i++) {
            if (chars.includes(value[i])) ;
            else if (withPadding && value[i] === '=') {
                if (i === count - 1) ;
                else if (value[i + 1] === '=') ;
                else {
                    throw new Error(`Invalid ${type} padding sequence "${value[i]}${value[i + 1]}" at index ${i}`);
                }
            }
            else {
                throw new Error(`Invalid ${type} character "${value[i]}" (0x${value.charCodeAt(i).toString(16)}) at index ${i}`);
            }
        }
        return true;
    };
}

const config$1 = {
    chars: '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz',
    coder: base58,
    ipfs: 'z',
    type: 'base58'
};
/**
 * @name base58Validate
 * @summary Validates a base58 value.
 * @description
 * Validates that the supplied value is valid base58, throwing exceptions if not
 */
const base58Validate = /*#__PURE__*/ createValidate(config$1);
/**
 * @name base58Decode
 * @summary Decodes a base58 value.
 * @description
 * From the provided input, decode the base58 and return the result as an `Uint8Array`.
 */
const base58Decode = /*#__PURE__*/ createDecode(config$1, base58Validate);
/**
* @name base58Encode
* @summary Creates a base58 value.
* @description
* From the provided input, create the base58 and return the result as a string.
*/
const base58Encode = /*#__PURE__*/ createEncode(config$1);

const crypto = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;

/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
/** Checks if something is Uint8Array. Be careful: nodejs Buffer will return true. */
function isBytes(a) {
    return a instanceof Uint8Array || (ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array');
}
/** Asserts something is positive integer. */
function anumber(n) {
    if (!Number.isSafeInteger(n) || n < 0)
        throw new Error('positive integer expected, got ' + n);
}
/** Asserts something is Uint8Array. */
function abytes(b, ...lengths) {
    if (!isBytes(b))
        throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length))
        throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
/** Asserts something is hash */
function ahash(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function')
        throw new Error('Hash should be wrapped by utils.createHasher');
    anumber(h.outputLen);
    anumber(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */
function aexists(instance, checkFinished = true) {
    if (instance.destroyed)
        throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished)
        throw new Error('Hash#digest() has already been called');
}
/** Asserts output is properly-sized byte array */
function aoutput(out, instance) {
    abytes(out);
    const min = instance.outputLen;
    if (out.length < min) {
        throw new Error('digestInto() expects output buffer of length at least ' + min);
    }
}
/** Cast u8 / u16 / u32 to u32. */
function u32$1(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
/** Zeroize a byte array. Warning: JS provides no guarantees. */
function clean(...arrays) {
    for (let i = 0; i < arrays.length; i++) {
        arrays[i].fill(0);
    }
}
/** Create DataView of an array for easy byte-level manipulation. */
function createView(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** The rotate right (circular right shift) operation for uint32 */
function rotr(word, shift) {
    return (word << (32 - shift)) | (word >>> shift);
}
/** Is current platform little-endian? Most are. Big-Endian platform: IBM */
const isLE = /* @__PURE__ */ (() => new Uint8Array(new Uint32Array([0x11223344]).buffer)[0] === 0x44)();
/** The byte swap operation for uint32 */
function byteSwap(word) {
    return (((word << 24) & 0xff000000) |
        ((word << 8) & 0xff0000) |
        ((word >>> 8) & 0xff00) |
        ((word >>> 24) & 0xff));
}
/** Conditionally byte swap if on a big-endian platform */
const swap8IfBE = isLE
    ? (n) => n
    : (n) => byteSwap(n);
/** In place byte swap for Uint32Array */
function byteSwap32(arr) {
    for (let i = 0; i < arr.length; i++) {
        arr[i] = byteSwap(arr[i]);
    }
    return arr;
}
const swap32IfBE = isLE
    ? (u) => u
    : byteSwap32;
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const hasHexBuiltin = /* @__PURE__ */ (() => 
// @ts-ignore
typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// Array where index 0xf0 (240) is mapped to string 'f0'
const hexes = /* @__PURE__ */ Array.from({ length: 256 }, (_, i) => i.toString(16).padStart(2, '0'));
/**
 * Convert byte array to hex string. Uses built-in function, when available.
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */
function bytesToHex(bytes) {
    abytes(bytes);
    // @ts-ignore
    if (hasHexBuiltin)
        return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for (let i = 0; i < bytes.length; i++) {
        hex += hexes[bytes[i]];
    }
    return hex;
}
// We use optimized technique to convert hex string to byte array
const asciis = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function asciiToBase16(ch) {
    if (ch >= asciis._0 && ch <= asciis._9)
        return ch - asciis._0; // '2' => 50-48
    if (ch >= asciis.A && ch <= asciis.F)
        return ch - (asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= asciis.a && ch <= asciis.f)
        return ch - (asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * Convert hex string to byte array. Uses built-in function, when available.
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */
function hexToBytes(hex) {
    if (typeof hex !== 'string')
        throw new Error('hex string expected, got ' + typeof hex);
    // @ts-ignore
    if (hasHexBuiltin)
        return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2)
        throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for (let ai = 0, hi = 0; ai < al; ai++, hi += 2) {
        const n1 = asciiToBase16(hex.charCodeAt(hi));
        const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
/**
 * Converts string to bytes using UTF8 encoding.
 * @example utf8ToBytes('abc') // Uint8Array.from([97, 98, 99])
 */
function utf8ToBytes(str) {
    if (typeof str !== 'string')
        throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */
function toBytes(data) {
    if (typeof data === 'string')
        data = utf8ToBytes(data);
    abytes(data);
    return data;
}
/** Copies several Uint8Arrays into one. */
function concatBytes(...arrays) {
    let sum = 0;
    for (let i = 0; i < arrays.length; i++) {
        const a = arrays[i];
        abytes(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for (let i = 0, pad = 0; i < arrays.length; i++) {
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
/** For runtime check if class implements interface */
class Hash {
}
/** Wraps hash function, creating an interface on top of it */
function createHasher(hashCons) {
    const hashC = (msg) => hashCons().update(toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = () => hashCons();
    return hashC;
}
function createOptHasher(hashCons) {
    const hashC = (msg, opts) => hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts) => hashCons(opts);
    return hashC;
}
/** Cryptographically secure PRNG. Uses internal OS-level `crypto.getRandomValues`. */
function randomBytes(bytesLength = 32) {
    if (crypto && typeof crypto.getRandomValues === 'function') {
        return crypto.getRandomValues(new Uint8Array(bytesLength));
    }
    // Legacy Node.js compatibility
    if (crypto && typeof crypto.randomBytes === 'function') {
        return Uint8Array.from(crypto.randomBytes(bytesLength));
    }
    throw new Error('crypto.getRandomValues must be defined');
}

/**
 * Internal helpers for blake hash.
 * @module
 */
/**
 * Internal blake variable.
 * For BLAKE2b, the two extra permutations for rounds 10 and 11 are SIGMA[10..11] = SIGMA[0..1].
 */
// prettier-ignore
const BSIGMA = /* @__PURE__ */ Uint8Array.from([
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3,
    11, 8, 12, 0, 5, 2, 15, 13, 10, 14, 3, 6, 7, 1, 9, 4,
    7, 9, 3, 1, 13, 12, 11, 14, 2, 6, 5, 10, 4, 0, 15, 8,
    9, 0, 5, 7, 2, 4, 10, 15, 14, 1, 11, 12, 6, 8, 3, 13,
    2, 12, 6, 10, 0, 11, 8, 3, 4, 13, 7, 5, 15, 14, 1, 9,
    12, 5, 1, 15, 14, 13, 4, 10, 0, 7, 6, 3, 9, 2, 8, 11,
    13, 11, 7, 14, 12, 1, 3, 9, 5, 0, 15, 4, 8, 6, 2, 10,
    6, 15, 14, 9, 11, 3, 0, 8, 12, 2, 13, 7, 1, 4, 10, 5,
    10, 2, 8, 4, 7, 6, 1, 5, 15, 11, 9, 14, 3, 12, 13, 0,
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3,
    // Blake1, unused in others
    11, 8, 12, 0, 5, 2, 15, 13, 10, 14, 3, 6, 7, 1, 9, 4,
    7, 9, 3, 1, 13, 12, 11, 14, 2, 6, 5, 10, 4, 0, 15, 8,
    9, 0, 5, 7, 2, 4, 10, 15, 14, 1, 11, 12, 6, 8, 3, 13,
    2, 12, 6, 10, 0, 11, 8, 3, 4, 13, 7, 5, 15, 14, 1, 9,
]);

/**
 * Internal Merkle-Damgard hash utils.
 * @module
 */
/** Polyfill for Safari 14. https://caniuse.com/mdn-javascript_builtins_dataview_setbiguint64 */
function setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function')
        return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number((value >> _32n) & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
/** Choice: a ? b : c */
function Chi(a, b, c) {
    return (a & b) ^ (~a & c);
}
/** Majority function, true if any two inputs is true. */
function Maj(a, b, c) {
    return (a & b) ^ (a & c) ^ (b & c);
}
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */
class HashMD extends Hash {
    constructor(blockLen, outputLen, padOffset, isLE) {
        super();
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.buffer = new Uint8Array(blockLen);
        this.view = createView(this.buffer);
    }
    update(data) {
        aexists(this);
        data = toBytes(data);
        abytes(data);
        const { view, buffer, blockLen } = this;
        const len = data.length;
        for (let pos = 0; pos < len;) {
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = createView(data);
                for (; blockLen <= len - pos; pos += blockLen)
                    this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        aexists(this);
        aoutput(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer, view, blockLen, isLE } = this;
        let { pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 0b10000000;
        clean(this.buffer.subarray(pos));
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for (let i = pos; i < blockLen; i++)
            buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = createView(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4)
            throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length)
            throw new Error('_sha2: outputLen bigger than state');
        for (let i = 0; i < outLen; i++)
            oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer, outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen, buffer, length, finished, destroyed, pos } = this;
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        if (length % blockLen)
            to.buffer.set(buffer);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
/**
 * Initial SHA-2 state: fractional parts of square roots of first 16 primes 2..53.
 * Check out `test/misc/sha2-gen-iv.js` for recomputation guide.
 */
/** Initial SHA256 state. Bits 0..32 of frac part of sqrt of primes 2..19 */
const SHA256_IV = /* @__PURE__ */ Uint32Array.from([
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19,
]);

/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */
const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const _32n$1 = /* @__PURE__ */ BigInt(32);
function fromBig(n, le = false) {
    if (le)
        return { h: Number(n & U32_MASK64), l: Number((n >> _32n$1) & U32_MASK64) };
    return { h: Number((n >> _32n$1) & U32_MASK64) | 0, l: Number(n & U32_MASK64) | 0 };
}
function split(lst, le = false) {
    const len = lst.length;
    let Ah = new Uint32Array(len);
    let Al = new Uint32Array(len);
    for (let i = 0; i < len; i++) {
        const { h, l } = fromBig(lst[i], le);
        [Ah[i], Al[i]] = [h, l];
    }
    return [Ah, Al];
}
// Right rotate for Shift in [1, 32)
const rotrSH = (h, l, s) => (h >>> s) | (l << (32 - s));
const rotrSL = (h, l, s) => (h << (32 - s)) | (l >>> s);
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotrBH = (h, l, s) => (h << (64 - s)) | (l >>> (s - 32));
const rotrBL = (h, l, s) => (h >>> (s - 32)) | (l << (64 - s));
// Right rotate for shift===32 (just swaps l&h)
const rotr32H = (_h, l) => l;
const rotr32L = (h, _l) => h;
// Left rotate for Shift in [1, 32)
const rotlSH = (h, l, s) => (h << s) | (l >>> (32 - s));
const rotlSL = (h, l, s) => (l << s) | (h >>> (32 - s));
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotlBH = (h, l, s) => (l << (s - 32)) | (h >>> (64 - s));
const rotlBL = (h, l, s) => (h << (s - 32)) | (l >>> (64 - s));
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return { h: (Ah + Bh + ((l / 2 ** 32) | 0)) | 0, l: l | 0 };
}
// Addition with more than 2 elements
const add3L = (Al, Bl, Cl) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const add3H = (low, Ah, Bh, Ch) => (Ah + Bh + Ch + ((low / 2 ** 32) | 0)) | 0;

/**
 * blake2b (64-bit) & blake2s (8 to 32-bit) hash functions.
 * b could have been faster, but there is no fast u64 in js, so s is 1.5x faster.
 * @module
 */
// Same as SHA512_IV, but swapped endianness: LE instead of BE. iv[1] is iv[0], etc.
const B2B_IV = /* @__PURE__ */ Uint32Array.from([
    0xf3bcc908, 0x6a09e667, 0x84caa73b, 0xbb67ae85, 0xfe94f82b, 0x3c6ef372, 0x5f1d36f1, 0xa54ff53a,
    0xade682d1, 0x510e527f, 0x2b3e6c1f, 0x9b05688c, 0xfb41bd6b, 0x1f83d9ab, 0x137e2179, 0x5be0cd19,
]);
// Temporary buffer
const BBUF = /* @__PURE__ */ new Uint32Array(32);
// Mixing function G splitted in two halfs
function G1b(a, b, c, d, msg, x) {
    // NOTE: V is LE here
    const Xl = msg[x], Xh = msg[x + 1]; // prettier-ignore
    let Al = BBUF[2 * a], Ah = BBUF[2 * a + 1]; // prettier-ignore
    let Bl = BBUF[2 * b], Bh = BBUF[2 * b + 1]; // prettier-ignore
    let Cl = BBUF[2 * c], Ch = BBUF[2 * c + 1]; // prettier-ignore
    let Dl = BBUF[2 * d], Dh = BBUF[2 * d + 1]; // prettier-ignore
    // v[a] = (v[a] + v[b] + x) | 0;
    let ll = add3L(Al, Bl, Xl);
    Ah = add3H(ll, Ah, Bh, Xh);
    Al = ll | 0;
    // v[d] = rotr(v[d] ^ v[a], 32)
    ({ Dh, Dl } = { Dh: Dh ^ Ah, Dl: Dl ^ Al });
    ({ Dh, Dl } = { Dh: rotr32H(Dh, Dl), Dl: rotr32L(Dh) });
    // v[c] = (v[c] + v[d]) | 0;
    ({ h: Ch, l: Cl } = add(Ch, Cl, Dh, Dl));
    // v[b] = rotr(v[b] ^ v[c], 24)
    ({ Bh, Bl } = { Bh: Bh ^ Ch, Bl: Bl ^ Cl });
    ({ Bh, Bl } = { Bh: rotrSH(Bh, Bl, 24), Bl: rotrSL(Bh, Bl, 24) });
    (BBUF[2 * a] = Al), (BBUF[2 * a + 1] = Ah);
    (BBUF[2 * b] = Bl), (BBUF[2 * b + 1] = Bh);
    (BBUF[2 * c] = Cl), (BBUF[2 * c + 1] = Ch);
    (BBUF[2 * d] = Dl), (BBUF[2 * d + 1] = Dh);
}
function G2b(a, b, c, d, msg, x) {
    // NOTE: V is LE here
    const Xl = msg[x], Xh = msg[x + 1]; // prettier-ignore
    let Al = BBUF[2 * a], Ah = BBUF[2 * a + 1]; // prettier-ignore
    let Bl = BBUF[2 * b], Bh = BBUF[2 * b + 1]; // prettier-ignore
    let Cl = BBUF[2 * c], Ch = BBUF[2 * c + 1]; // prettier-ignore
    let Dl = BBUF[2 * d], Dh = BBUF[2 * d + 1]; // prettier-ignore
    // v[a] = (v[a] + v[b] + x) | 0;
    let ll = add3L(Al, Bl, Xl);
    Ah = add3H(ll, Ah, Bh, Xh);
    Al = ll | 0;
    // v[d] = rotr(v[d] ^ v[a], 16)
    ({ Dh, Dl } = { Dh: Dh ^ Ah, Dl: Dl ^ Al });
    ({ Dh, Dl } = { Dh: rotrSH(Dh, Dl, 16), Dl: rotrSL(Dh, Dl, 16) });
    // v[c] = (v[c] + v[d]) | 0;
    ({ h: Ch, l: Cl } = add(Ch, Cl, Dh, Dl));
    // v[b] = rotr(v[b] ^ v[c], 63)
    ({ Bh, Bl } = { Bh: Bh ^ Ch, Bl: Bl ^ Cl });
    ({ Bh, Bl } = { Bh: rotrBH(Bh, Bl, 63), Bl: rotrBL(Bh, Bl, 63) });
    (BBUF[2 * a] = Al), (BBUF[2 * a + 1] = Ah);
    (BBUF[2 * b] = Bl), (BBUF[2 * b + 1] = Bh);
    (BBUF[2 * c] = Cl), (BBUF[2 * c + 1] = Ch);
    (BBUF[2 * d] = Dl), (BBUF[2 * d + 1] = Dh);
}
function checkBlake2Opts(outputLen, opts = {}, keyLen, saltLen, persLen) {
    anumber(keyLen);
    if (outputLen < 0 || outputLen > keyLen)
        throw new Error('outputLen bigger than keyLen');
    const { key, salt, personalization } = opts;
    if (key !== undefined && (key.length < 1 || key.length > keyLen))
        throw new Error('key length must be undefined or 1..' + keyLen);
    if (salt !== undefined && salt.length !== saltLen)
        throw new Error('salt must be undefined or ' + saltLen);
    if (personalization !== undefined && personalization.length !== persLen)
        throw new Error('personalization must be undefined or ' + persLen);
}
/** Class, from which others are subclassed. */
class BLAKE2 extends Hash {
    constructor(blockLen, outputLen) {
        super();
        this.finished = false;
        this.destroyed = false;
        this.length = 0;
        this.pos = 0;
        anumber(blockLen);
        anumber(outputLen);
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.buffer = new Uint8Array(blockLen);
        this.buffer32 = u32$1(this.buffer);
    }
    update(data) {
        aexists(this);
        data = toBytes(data);
        abytes(data);
        // Main difference with other hashes: there is flag for last block,
        // so we cannot process current block before we know that there
        // is the next one. This significantly complicates logic and reduces ability
        // to do zero-copy processing
        const { blockLen, buffer, buffer32 } = this;
        const len = data.length;
        const offset = data.byteOffset;
        const buf = data.buffer;
        for (let pos = 0; pos < len;) {
            // If buffer is full and we still have input (don't process last block, same as blake2s)
            if (this.pos === blockLen) {
                swap32IfBE(buffer32);
                this.compress(buffer32, 0, false);
                swap32IfBE(buffer32);
                this.pos = 0;
            }
            const take = Math.min(blockLen - this.pos, len - pos);
            const dataOffset = offset + pos;
            // full block && aligned to 4 bytes && not last in input
            if (take === blockLen && !(dataOffset % 4) && pos + take < len) {
                const data32 = new Uint32Array(buf, dataOffset, Math.floor((len - pos) / 4));
                swap32IfBE(data32);
                for (let pos32 = 0; pos + blockLen < len; pos32 += buffer32.length, pos += blockLen) {
                    this.length += blockLen;
                    this.compress(data32, pos32, false);
                }
                swap32IfBE(data32);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            this.length += take;
            pos += take;
        }
        return this;
    }
    digestInto(out) {
        aexists(this);
        aoutput(out, this);
        const { pos, buffer32 } = this;
        this.finished = true;
        // Padding
        clean(this.buffer.subarray(pos));
        swap32IfBE(buffer32);
        this.compress(buffer32, 0, true);
        swap32IfBE(buffer32);
        const out32 = u32$1(out);
        this.get().forEach((v, i) => (out32[i] = swap8IfBE(v)));
    }
    digest() {
        const { buffer, outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        const { buffer, length, finished, destroyed, outputLen, pos } = this;
        to || (to = new this.constructor({ dkLen: outputLen }));
        to.set(...this.get());
        to.buffer.set(buffer);
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        // @ts-ignore
        to.outputLen = outputLen;
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
class BLAKE2b extends BLAKE2 {
    constructor(opts = {}) {
        const olen = opts.dkLen === undefined ? 64 : opts.dkLen;
        super(128, olen);
        // Same as SHA-512, but LE
        this.v0l = B2B_IV[0] | 0;
        this.v0h = B2B_IV[1] | 0;
        this.v1l = B2B_IV[2] | 0;
        this.v1h = B2B_IV[3] | 0;
        this.v2l = B2B_IV[4] | 0;
        this.v2h = B2B_IV[5] | 0;
        this.v3l = B2B_IV[6] | 0;
        this.v3h = B2B_IV[7] | 0;
        this.v4l = B2B_IV[8] | 0;
        this.v4h = B2B_IV[9] | 0;
        this.v5l = B2B_IV[10] | 0;
        this.v5h = B2B_IV[11] | 0;
        this.v6l = B2B_IV[12] | 0;
        this.v6h = B2B_IV[13] | 0;
        this.v7l = B2B_IV[14] | 0;
        this.v7h = B2B_IV[15] | 0;
        checkBlake2Opts(olen, opts, 64, 16, 16);
        let { key, personalization, salt } = opts;
        let keyLength = 0;
        if (key !== undefined) {
            key = toBytes(key);
            keyLength = key.length;
        }
        this.v0l ^= this.outputLen | (keyLength << 8) | (0x01 << 16) | (0x01 << 24);
        if (salt !== undefined) {
            salt = toBytes(salt);
            const slt = u32$1(salt);
            this.v4l ^= swap8IfBE(slt[0]);
            this.v4h ^= swap8IfBE(slt[1]);
            this.v5l ^= swap8IfBE(slt[2]);
            this.v5h ^= swap8IfBE(slt[3]);
        }
        if (personalization !== undefined) {
            personalization = toBytes(personalization);
            const pers = u32$1(personalization);
            this.v6l ^= swap8IfBE(pers[0]);
            this.v6h ^= swap8IfBE(pers[1]);
            this.v7l ^= swap8IfBE(pers[2]);
            this.v7h ^= swap8IfBE(pers[3]);
        }
        if (key !== undefined) {
            // Pad to blockLen and update
            const tmp = new Uint8Array(this.blockLen);
            tmp.set(key);
            this.update(tmp);
        }
    }
    // prettier-ignore
    get() {
        let { v0l, v0h, v1l, v1h, v2l, v2h, v3l, v3h, v4l, v4h, v5l, v5h, v6l, v6h, v7l, v7h } = this;
        return [v0l, v0h, v1l, v1h, v2l, v2h, v3l, v3h, v4l, v4h, v5l, v5h, v6l, v6h, v7l, v7h];
    }
    // prettier-ignore
    set(v0l, v0h, v1l, v1h, v2l, v2h, v3l, v3h, v4l, v4h, v5l, v5h, v6l, v6h, v7l, v7h) {
        this.v0l = v0l | 0;
        this.v0h = v0h | 0;
        this.v1l = v1l | 0;
        this.v1h = v1h | 0;
        this.v2l = v2l | 0;
        this.v2h = v2h | 0;
        this.v3l = v3l | 0;
        this.v3h = v3h | 0;
        this.v4l = v4l | 0;
        this.v4h = v4h | 0;
        this.v5l = v5l | 0;
        this.v5h = v5h | 0;
        this.v6l = v6l | 0;
        this.v6h = v6h | 0;
        this.v7l = v7l | 0;
        this.v7h = v7h | 0;
    }
    compress(msg, offset, isLast) {
        this.get().forEach((v, i) => (BBUF[i] = v)); // First half from state.
        BBUF.set(B2B_IV, 16); // Second half from IV.
        let { h, l } = fromBig(BigInt(this.length));
        BBUF[24] = B2B_IV[8] ^ l; // Low word of the offset.
        BBUF[25] = B2B_IV[9] ^ h; // High word.
        // Invert all bits for last block
        if (isLast) {
            BBUF[28] = ~BBUF[28];
            BBUF[29] = ~BBUF[29];
        }
        let j = 0;
        const s = BSIGMA;
        for (let i = 0; i < 12; i++) {
            G1b(0, 4, 8, 12, msg, offset + 2 * s[j++]);
            G2b(0, 4, 8, 12, msg, offset + 2 * s[j++]);
            G1b(1, 5, 9, 13, msg, offset + 2 * s[j++]);
            G2b(1, 5, 9, 13, msg, offset + 2 * s[j++]);
            G1b(2, 6, 10, 14, msg, offset + 2 * s[j++]);
            G2b(2, 6, 10, 14, msg, offset + 2 * s[j++]);
            G1b(3, 7, 11, 15, msg, offset + 2 * s[j++]);
            G2b(3, 7, 11, 15, msg, offset + 2 * s[j++]);
            G1b(0, 5, 10, 15, msg, offset + 2 * s[j++]);
            G2b(0, 5, 10, 15, msg, offset + 2 * s[j++]);
            G1b(1, 6, 11, 12, msg, offset + 2 * s[j++]);
            G2b(1, 6, 11, 12, msg, offset + 2 * s[j++]);
            G1b(2, 7, 8, 13, msg, offset + 2 * s[j++]);
            G2b(2, 7, 8, 13, msg, offset + 2 * s[j++]);
            G1b(3, 4, 9, 14, msg, offset + 2 * s[j++]);
            G2b(3, 4, 9, 14, msg, offset + 2 * s[j++]);
        }
        this.v0l ^= BBUF[0] ^ BBUF[16];
        this.v0h ^= BBUF[1] ^ BBUF[17];
        this.v1l ^= BBUF[2] ^ BBUF[18];
        this.v1h ^= BBUF[3] ^ BBUF[19];
        this.v2l ^= BBUF[4] ^ BBUF[20];
        this.v2h ^= BBUF[5] ^ BBUF[21];
        this.v3l ^= BBUF[6] ^ BBUF[22];
        this.v3h ^= BBUF[7] ^ BBUF[23];
        this.v4l ^= BBUF[8] ^ BBUF[24];
        this.v4h ^= BBUF[9] ^ BBUF[25];
        this.v5l ^= BBUF[10] ^ BBUF[26];
        this.v5h ^= BBUF[11] ^ BBUF[27];
        this.v6l ^= BBUF[12] ^ BBUF[28];
        this.v6h ^= BBUF[13] ^ BBUF[29];
        this.v7l ^= BBUF[14] ^ BBUF[30];
        this.v7h ^= BBUF[15] ^ BBUF[31];
        clean(BBUF);
    }
    destroy() {
        this.destroyed = true;
        clean(this.buffer32);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
/**
 * Blake2b hash function. 64-bit. 1.5x slower than blake2s in JS.
 * @param msg - message that would be hashed
 * @param opts - dkLen output length, key for MAC mode, salt, personalization
 */
const blake2b$1 = /* @__PURE__ */ createOptHasher((opts) => new BLAKE2b(opts));

/**
 * Blake2b hash function. Focuses on 64-bit platforms, but in JS speed different from Blake2s is negligible.
 * @module
 * @deprecated
 */
/** @deprecated Use import from `noble/hashes/blake2` module */
const blake2b = blake2b$1;

/** @internal */
function createAsHex(fn) {
    return (...args) => u8aToHex(fn(...args));
}
/** @internal */
function createDualHasher(wa, js) {
    return (value, bitLength = 256, onlyJs) => {
        const u8a = u8aToU8a(value);
        return !hasBigInt || (!onlyJs && isReady())
            ? wa[bitLength](u8a)
            : js[bitLength](u8a);
    };
}

/**
 * @name blake2AsU8a
 * @summary Creates a blake2b u8a from the input.
 * @description
 * From a `Uint8Array` input, create the blake2b and return the result as a u8a with the specified `bitLength`.
 * @example
 * <BR>
 *
 * ```javascript
 * import { blake2AsU8a } from '@polkadot/util-crypto';
 *
 * blake2AsU8a('abc'); // => [0xba, 0x80, 0xa5, 0x3f, 0x98, 0x1c, 0x4d, 0x0d]
 * ```
 */
function blake2AsU8a(data, bitLength = 256, key, onlyJs) {
    const byteLength = Math.ceil(bitLength / 8);
    const u8a = u8aToU8a(data);
    return !hasBigInt || (!onlyJs && isReady())
        ? blake2b$2(u8a, u8aToU8a(key), byteLength)
        : key
            ? blake2b(u8a, { dkLen: byteLength, key })
            : blake2b(u8a, { dkLen: byteLength });
}
/**
 * @name blake2AsHex
 * @description Creates a blake2b hex from the input.
 */
const blake2AsHex = /*#__PURE__*/ createAsHex(blake2AsU8a);

const SS58_PREFIX = stringToU8a('SS58PRE');
function sshash(key) {
    return blake2AsU8a(u8aConcat(SS58_PREFIX, key), 512);
}

function checkAddressChecksum(decoded) {
    const ss58Length = (decoded[0] & 0b0100_0000) ? 2 : 1;
    const ss58Decoded = ss58Length === 1
        ? decoded[0]
        : ((decoded[0] & 0b0011_1111) << 2) | (decoded[1] >> 6) | ((decoded[1] & 0b0011_1111) << 8);
    // 32/33 bytes public + 2 bytes checksum + prefix
    const isPublicKey = [34 + ss58Length, 35 + ss58Length].includes(decoded.length);
    const length = decoded.length - (isPublicKey ? 2 : 1);
    // calculate the hash and do the checksum byte checks
    const hash = sshash(decoded.subarray(0, length));
    const isValid = (decoded[0] & 0b1000_0000) === 0 && ![46, 47].includes(decoded[0]) && (isPublicKey
        ? decoded[decoded.length - 2] === hash[0] && decoded[decoded.length - 1] === hash[1]
        : decoded[decoded.length - 1] === hash[0]);
    return [isValid, length, ss58Length, ss58Decoded];
}

// Copyright (C) 2021-2024 Parity Technologies (UK) Ltd.
// SPDX-License-Identifier: Apache-2.0
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// 	http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var knownSubstrate = [
	{
		"prefix": 0,
		"network": "polkadot",
		"displayName": "Polkadot Relay Chain",
		"symbols": [
			"DOT"
		],
		"decimals": [
			10
		],
		"standardAccount": "*25519",
		"website": "https://polkadot.network"
	},
	{
		"prefix": 1,
		"network": "BareSr25519",
		"displayName": "Bare 32-bit Schnorr/Ristretto (S/R 25519) public key.",
		"symbols": [],
		"decimals": [],
		"standardAccount": "Sr25519",
		"website": null
	},
	{
		"prefix": 2,
		"network": "kusama",
		"displayName": "Kusama Relay Chain",
		"symbols": [
			"KSM"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://kusama.network"
	},
	{
		"prefix": 3,
		"network": "BareEd25519",
		"displayName": "Bare 32-bit Ed25519 public key.",
		"symbols": [],
		"decimals": [],
		"standardAccount": "Ed25519",
		"website": null
	},
	{
		"prefix": 4,
		"network": "katalchain",
		"displayName": "Katal Chain",
		"symbols": [],
		"decimals": [],
		"standardAccount": "*25519",
		"website": null
	},
	{
		"prefix": 5,
		"network": "astar",
		"displayName": "Astar Network",
		"symbols": [
			"ASTR"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://astar.network"
	},
	{
		"prefix": 6,
		"network": "bifrost",
		"displayName": "Bifrost",
		"symbols": [
			"BNC"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://bifrost.finance/"
	},
	{
		"prefix": 7,
		"network": "edgeware",
		"displayName": "Edgeware",
		"symbols": [
			"EDG"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://edgewa.re"
	},
	{
		"prefix": 8,
		"network": "karura",
		"displayName": "Karura",
		"symbols": [
			"KAR"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://karura.network/"
	},
	{
		"prefix": 9,
		"network": "reynolds",
		"displayName": "Laminar Reynolds Canary",
		"symbols": [
			"REY"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "http://laminar.network/"
	},
	{
		"prefix": 10,
		"network": "acala",
		"displayName": "Acala",
		"symbols": [
			"ACA"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://acala.network/"
	},
	{
		"prefix": 11,
		"network": "laminar",
		"displayName": "Laminar",
		"symbols": [
			"LAMI"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "http://laminar.network/"
	},
	{
		"prefix": 12,
		"network": "polymesh",
		"displayName": "Polymesh",
		"symbols": [
			"POLYX"
		],
		"decimals": [
			6
		],
		"standardAccount": "*25519",
		"website": "https://polymath.network/"
	},
	{
		"prefix": 13,
		"network": "integritee",
		"displayName": "Integritee",
		"symbols": [
			"TEER"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://integritee.network"
	},
	{
		"prefix": 14,
		"network": "totem",
		"displayName": "Totem",
		"symbols": [
			"TOTEM"
		],
		"decimals": [
			0
		],
		"standardAccount": "*25519",
		"website": "https://totemaccounting.com"
	},
	{
		"prefix": 15,
		"network": "synesthesia",
		"displayName": "Synesthesia",
		"symbols": [
			"SYN"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://synesthesia.network/"
	},
	{
		"prefix": 16,
		"network": "kulupu",
		"displayName": "Kulupu",
		"symbols": [
			"KLP"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://kulupu.network/"
	},
	{
		"prefix": 17,
		"network": "dark",
		"displayName": "Dark Mainnet",
		"symbols": [],
		"decimals": [],
		"standardAccount": "*25519",
		"website": null
	},
	{
		"prefix": 18,
		"network": "darwinia",
		"displayName": "Darwinia Network",
		"symbols": [
			"RING"
		],
		"decimals": [
			18
		],
		"standardAccount": "secp256k1",
		"website": "https://darwinia.network"
	},
	{
		"prefix": 19,
		"network": "watr",
		"displayName": "Watr Protocol",
		"symbols": [
			"WATR"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://www.watr.org"
	},
	{
		"prefix": 20,
		"network": "stafi",
		"displayName": "Stafi",
		"symbols": [
			"FIS"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://stafi.io"
	},
	{
		"prefix": 21,
		"network": "karmachain",
		"displayName": "Karmacoin",
		"symbols": [
			"KCOIN"
		],
		"decimals": [
			6
		],
		"standardAccount": "*25519",
		"website": "https://karmaco.in"
	},
	{
		"prefix": 22,
		"network": "dock-pos-mainnet",
		"displayName": "Dock Mainnet",
		"symbols": [
			"DCK"
		],
		"decimals": [
			6
		],
		"standardAccount": "*25519",
		"website": "https://dock.io"
	},
	{
		"prefix": 23,
		"network": "shift",
		"displayName": "ShiftNrg",
		"symbols": [],
		"decimals": [],
		"standardAccount": "*25519",
		"website": null
	},
	{
		"prefix": 24,
		"network": "zero",
		"displayName": "ZERO",
		"symbols": [
			"ZERO"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://zero.io"
	},
	{
		"prefix": 25,
		"network": "zero-alphaville",
		"displayName": "ZERO Alphaville",
		"symbols": [
			"ZERO"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://zero.io"
	},
	{
		"prefix": 26,
		"network": "jupiter",
		"displayName": "Jupiter",
		"symbols": [
			"jDOT"
		],
		"decimals": [
			10
		],
		"standardAccount": "*25519",
		"website": "https://jupiter.patract.io"
	},
	{
		"prefix": 27,
		"network": "kabocha",
		"displayName": "Kabocha",
		"symbols": [
			"KAB"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://kabocha.network"
	},
	{
		"prefix": 28,
		"network": "subsocial",
		"displayName": "Subsocial",
		"symbols": [],
		"decimals": [],
		"standardAccount": "*25519",
		"website": null
	},
	{
		"prefix": 29,
		"network": "cord",
		"displayName": "CORD Network",
		"symbols": [
			"DHI",
			"WAY"
		],
		"decimals": [
			12,
			12
		],
		"standardAccount": "*25519",
		"website": "https://cord.network/"
	},
	{
		"prefix": 30,
		"network": "phala",
		"displayName": "Phala Network",
		"symbols": [
			"PHA"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://phala.network"
	},
	{
		"prefix": 31,
		"network": "litentry",
		"displayName": "Litentry Network",
		"symbols": [
			"LIT"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://litentry.com/"
	},
	{
		"prefix": 32,
		"network": "robonomics",
		"displayName": "Robonomics",
		"symbols": [
			"XRT"
		],
		"decimals": [
			9
		],
		"standardAccount": "*25519",
		"website": "https://robonomics.network"
	},
	{
		"prefix": 33,
		"network": "datahighway",
		"displayName": "DataHighway",
		"symbols": [],
		"decimals": [],
		"standardAccount": "*25519",
		"website": null
	},
	{
		"prefix": 34,
		"network": "ares",
		"displayName": "Ares Protocol",
		"symbols": [
			"ARES"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://www.aresprotocol.com/"
	},
	{
		"prefix": 35,
		"network": "vln",
		"displayName": "Valiu Liquidity Network",
		"symbols": [
			"USDv"
		],
		"decimals": [
			15
		],
		"standardAccount": "*25519",
		"website": "https://valiu.com/"
	},
	{
		"prefix": 36,
		"network": "centrifuge",
		"displayName": "Centrifuge Chain",
		"symbols": [
			"CFG"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://centrifuge.io/"
	},
	{
		"prefix": 37,
		"network": "nodle",
		"displayName": "Nodle Chain",
		"symbols": [
			"NODL"
		],
		"decimals": [
			11
		],
		"standardAccount": "*25519",
		"website": "https://nodle.io/"
	},
	{
		"prefix": 38,
		"network": "kilt",
		"displayName": "KILT Spiritnet",
		"symbols": [
			"KILT"
		],
		"decimals": [
			15
		],
		"standardAccount": "*25519",
		"website": "https://kilt.io/"
	},
	{
		"prefix": 39,
		"network": "mathchain",
		"displayName": "MathChain mainnet",
		"symbols": [
			"MATH"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://mathwallet.org"
	},
	{
		"prefix": 40,
		"network": "mathchain-testnet",
		"displayName": "MathChain testnet",
		"symbols": [
			"MATH"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://mathwallet.org"
	},
	{
		"prefix": 41,
		"network": "polimec",
		"displayName": "Polimec Protocol",
		"symbols": [
			"PLMC"
		],
		"decimals": [
			10
		],
		"standardAccount": "*25519",
		"website": "https://www.polimec.org/"
	},
	{
		"prefix": 42,
		"network": "substrate",
		"displayName": "Substrate",
		"symbols": [],
		"decimals": [],
		"standardAccount": "*25519",
		"website": "https://substrate.io/"
	},
	{
		"prefix": 43,
		"network": "BareSecp256k1",
		"displayName": "Bare 32-bit ECDSA SECP-256k1 public key.",
		"symbols": [],
		"decimals": [],
		"standardAccount": "secp256k1",
		"website": null
	},
	{
		"prefix": 44,
		"network": "chainx",
		"displayName": "ChainX",
		"symbols": [
			"PCX"
		],
		"decimals": [
			8
		],
		"standardAccount": "*25519",
		"website": "https://chainx.org/"
	},
	{
		"prefix": 45,
		"network": "uniarts",
		"displayName": "UniArts Network",
		"symbols": [
			"UART",
			"UINK"
		],
		"decimals": [
			12,
			12
		],
		"standardAccount": "*25519",
		"website": "https://uniarts.me"
	},
	{
		"prefix": 46,
		"network": "reserved46",
		"displayName": "This prefix is reserved.",
		"symbols": [],
		"decimals": [],
		"standardAccount": null,
		"website": null
	},
	{
		"prefix": 47,
		"network": "reserved47",
		"displayName": "This prefix is reserved.",
		"symbols": [],
		"decimals": [],
		"standardAccount": null,
		"website": null
	},
	{
		"prefix": 48,
		"network": "neatcoin",
		"displayName": "Neatcoin Mainnet",
		"symbols": [
			"NEAT"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://neatcoin.org"
	},
	{
		"prefix": 49,
		"network": "picasso",
		"displayName": "Picasso",
		"symbols": [
			"PICA"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://picasso.composable.finance"
	},
	{
		"prefix": 50,
		"network": "composable",
		"displayName": "Composable Finance",
		"symbols": [
			"LAYR"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://composable.finance"
	},
	{
		"prefix": 51,
		"network": "oak",
		"displayName": "OAK Network",
		"symbols": [
			"OAK",
			"TUR"
		],
		"decimals": [
			10,
			10
		],
		"standardAccount": "*25519",
		"website": "https://oak.tech"
	},
	{
		"prefix": 52,
		"network": "KICO",
		"displayName": "KICO",
		"symbols": [
			"KICO"
		],
		"decimals": [
			14
		],
		"standardAccount": "*25519",
		"website": "https://dico.io"
	},
	{
		"prefix": 53,
		"network": "DICO",
		"displayName": "DICO",
		"symbols": [
			"DICO"
		],
		"decimals": [
			14
		],
		"standardAccount": "*25519",
		"website": "https://dico.io"
	},
	{
		"prefix": 54,
		"network": "cere",
		"displayName": "Cere Network",
		"symbols": [
			"CERE"
		],
		"decimals": [
			10
		],
		"standardAccount": "*25519",
		"website": "https://cere.network"
	},
	{
		"prefix": 55,
		"network": "xxnetwork",
		"displayName": "xx network",
		"symbols": [
			"XX"
		],
		"decimals": [
			9
		],
		"standardAccount": "*25519",
		"website": "https://xx.network"
	},
	{
		"prefix": 56,
		"network": "pendulum",
		"displayName": "Pendulum chain",
		"symbols": [
			"PEN"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://pendulumchain.org/"
	},
	{
		"prefix": 57,
		"network": "amplitude",
		"displayName": "Amplitude chain",
		"symbols": [
			"AMPE"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://pendulumchain.org/"
	},
	{
		"prefix": 58,
		"network": "eternal-civilization",
		"displayName": "Eternal Civilization",
		"symbols": [
			"ECC"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "http://www.ysknfr.cn/"
	},
	{
		"prefix": 63,
		"network": "hydradx",
		"displayName": "Hydration",
		"symbols": [
			"HDX"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://hydration.net"
	},
	{
		"prefix": 65,
		"network": "aventus",
		"displayName": "Aventus Mainnet",
		"symbols": [
			"AVT"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://aventus.io"
	},
	{
		"prefix": 66,
		"network": "crust",
		"displayName": "Crust Network",
		"symbols": [
			"CRU"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://crust.network"
	},
	{
		"prefix": 67,
		"network": "genshiro",
		"displayName": "Genshiro Network",
		"symbols": [
			"GENS",
			"EQD",
			"LPT0"
		],
		"decimals": [
			9,
			9,
			9
		],
		"standardAccount": "*25519",
		"website": "https://genshiro.equilibrium.io"
	},
	{
		"prefix": 68,
		"network": "equilibrium",
		"displayName": "Equilibrium Network",
		"symbols": [
			"EQ"
		],
		"decimals": [
			9
		],
		"standardAccount": "*25519",
		"website": "https://equilibrium.io"
	},
	{
		"prefix": 69,
		"network": "sora",
		"displayName": "SORA Network",
		"symbols": [
			"XOR"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://sora.org"
	},
	{
		"prefix": 71,
		"network": "p3d",
		"displayName": "3DP network",
		"symbols": [
			"P3D"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://3dpass.org"
	},
	{
		"prefix": 72,
		"network": "p3dt",
		"displayName": "3DP test network",
		"symbols": [
			"P3Dt"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://3dpass.org"
	},
	{
		"prefix": 73,
		"network": "zeitgeist",
		"displayName": "Zeitgeist",
		"symbols": [
			"ZTG"
		],
		"decimals": [
			10
		],
		"standardAccount": "*25519",
		"website": "https://zeitgeist.pm"
	},
	{
		"prefix": 77,
		"network": "manta",
		"displayName": "Manta network",
		"symbols": [
			"MANTA"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://manta.network"
	},
	{
		"prefix": 78,
		"network": "calamari",
		"displayName": "Calamari: Manta Canary Network",
		"symbols": [
			"KMA"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://manta.network"
	},
	{
		"prefix": 81,
		"network": "sora_dot_para",
		"displayName": "SORA Polkadot Parachain",
		"symbols": [
			"XOR"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://sora.org"
	},
	{
		"prefix": 88,
		"network": "polkadex",
		"displayName": "Polkadex Mainnet",
		"symbols": [
			"PDEX"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://polkadex.trade"
	},
	{
		"prefix": 89,
		"network": "polkadexparachain",
		"displayName": "Polkadex Parachain",
		"symbols": [
			"PDEX"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://polkadex.trade"
	},
	{
		"prefix": 90,
		"network": "frequency",
		"displayName": "Frequency",
		"symbols": [
			"FRQCY"
		],
		"decimals": [
			8
		],
		"standardAccount": "*25519",
		"website": "https://www.frequency.xyz"
	},
	{
		"prefix": 92,
		"network": "anmol",
		"displayName": "Anmol Network",
		"symbols": [
			"ANML"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://anmol.network/"
	},
	{
		"prefix": 93,
		"network": "fragnova",
		"displayName": "Fragnova Network",
		"symbols": [
			"NOVA"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://fragnova.com"
	},
	{
		"prefix": 98,
		"network": "polkasmith",
		"displayName": "PolkaSmith Canary Network",
		"symbols": [
			"PKS"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://polkafoundry.com"
	},
	{
		"prefix": 99,
		"network": "polkafoundry",
		"displayName": "PolkaFoundry Network",
		"symbols": [
			"PKF"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://polkafoundry.com"
	},
	{
		"prefix": 100,
		"network": "ibtida",
		"displayName": "Anmol Network Ibtida Canary network",
		"symbols": [
			"IANML"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://anmol.network/"
	},
	{
		"prefix": 101,
		"network": "origintrail-parachain",
		"displayName": "OriginTrail Parachain",
		"symbols": [
			"OTP"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://parachain.origintrail.io/"
	},
	{
		"prefix": 105,
		"network": "pontem-network",
		"displayName": "Pontem Network",
		"symbols": [
			"PONT"
		],
		"decimals": [
			10
		],
		"standardAccount": "*25519",
		"website": "https://pontem.network"
	},
	{
		"prefix": 110,
		"network": "heiko",
		"displayName": "Heiko",
		"symbols": [
			"HKO"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://parallel.fi/"
	},
	{
		"prefix": 113,
		"network": "integritee-incognito",
		"displayName": "Integritee Incognito",
		"symbols": [],
		"decimals": [],
		"standardAccount": "*25519",
		"website": "https://integritee.network"
	},
	{
		"prefix": 117,
		"network": "tinker",
		"displayName": "Tinker",
		"symbols": [
			"TNKR"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://invarch.network"
	},
	{
		"prefix": 126,
		"network": "joystream",
		"displayName": "Joystream",
		"symbols": [
			"JOY"
		],
		"decimals": [
			10
		],
		"standardAccount": "*25519",
		"website": "https://www.joystream.org"
	},
	{
		"prefix": 128,
		"network": "clover",
		"displayName": "Clover Finance",
		"symbols": [
			"CLV"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://clover.finance"
	},
	{
		"prefix": 129,
		"network": "dorafactory-polkadot",
		"displayName": "Dorafactory Polkadot Network",
		"symbols": [
			"DORA"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://dorafactory.org"
	},
	{
		"prefix": 131,
		"network": "litmus",
		"displayName": "Litmus Network",
		"symbols": [
			"LIT"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://litentry.com/"
	},
	{
		"prefix": 136,
		"network": "altair",
		"displayName": "Altair",
		"symbols": [
			"AIR"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://centrifuge.io/"
	},
	{
		"prefix": 137,
		"network": "vara",
		"displayName": "Vara Network",
		"symbols": [
			"VARA"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://vara.network/"
	},
	{
		"prefix": 172,
		"network": "parallel",
		"displayName": "Parallel",
		"symbols": [
			"PARA"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://parallel.fi/"
	},
	{
		"prefix": 252,
		"network": "social-network",
		"displayName": "Social Network",
		"symbols": [
			"NET"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://social.network"
	},
	{
		"prefix": 255,
		"network": "quartz_mainnet",
		"displayName": "QUARTZ by UNIQUE",
		"symbols": [
			"QTZ"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://unique.network"
	},
	{
		"prefix": 268,
		"network": "pioneer_network",
		"displayName": "Pioneer Network by Bit.Country",
		"symbols": [
			"NEER"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://bit.country"
	},
	{
		"prefix": 420,
		"network": "sora_kusama_para",
		"displayName": "SORA Kusama Parachain",
		"symbols": [
			"XOR"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://sora.org"
	},
	{
		"prefix": 440,
		"network": "allfeat_network",
		"displayName": "Allfeat Network",
		"symbols": [
			"AFT"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://allfeat.network"
	},
	{
		"prefix": 666,
		"network": "metaquity_network",
		"displayName": "Metaquity Network",
		"symbols": [
			"MQTY"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://metaquity.xyz/"
	},
	{
		"prefix": 777,
		"network": "curio",
		"displayName": "Curio",
		"symbols": [
			"CGT"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://parachain.capitaldex.exchange/"
	},
	{
		"prefix": 789,
		"network": "geek",
		"displayName": "GEEK Network",
		"symbols": [
			"GEEK"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://geek.gl"
	},
	{
		"prefix": 995,
		"network": "ternoa",
		"displayName": "Ternoa",
		"symbols": [
			"CAPS"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://www.ternoa.network"
	},
	{
		"prefix": 1110,
		"network": "efinity",
		"displayName": "Efinity",
		"symbols": [
			"EFI"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://efinity.io/"
	},
	{
		"prefix": 1221,
		"network": "peaq",
		"displayName": "Peaq Network",
		"symbols": [
			"PEAQ"
		],
		"decimals": [
			18
		],
		"standardAccount": "Sr25519",
		"website": "https://www.peaq.network/"
	},
	{
		"prefix": 1222,
		"network": "krest",
		"displayName": "Krest Network",
		"symbols": [
			"KREST"
		],
		"decimals": [
			18
		],
		"standardAccount": "Sr25519",
		"website": "https://www.peaq.network/"
	},
	{
		"prefix": 1284,
		"network": "moonbeam",
		"displayName": "Moonbeam",
		"symbols": [
			"GLMR"
		],
		"decimals": [
			18
		],
		"standardAccount": "secp256k1",
		"website": "https://moonbeam.network"
	},
	{
		"prefix": 1285,
		"network": "moonriver",
		"displayName": "Moonriver",
		"symbols": [
			"MOVR"
		],
		"decimals": [
			18
		],
		"standardAccount": "secp256k1",
		"website": "https://moonbeam.network"
	},
	{
		"prefix": 1328,
		"network": "ajuna",
		"displayName": "Ajuna Network",
		"symbols": [
			"AJUN"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://ajuna.io"
	},
	{
		"prefix": 1337,
		"network": "bajun",
		"displayName": "Bajun Network",
		"symbols": [
			"BAJU"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://ajuna.io"
	},
	{
		"prefix": 1516,
		"network": "societal",
		"displayName": "Societal",
		"symbols": [
			"SCTL"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://www.sctl.xyz"
	},
	{
		"prefix": 1985,
		"network": "seals",
		"displayName": "Seals Network",
		"symbols": [
			"SEAL"
		],
		"decimals": [
			9
		],
		"standardAccount": "*25519",
		"website": "https://seals.app"
	},
	{
		"prefix": 2007,
		"network": "kapex",
		"displayName": "Kapex",
		"symbols": [
			"KAPEX"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://totemaccounting.com"
	},
	{
		"prefix": 2009,
		"network": "cloudwalk_mainnet",
		"displayName": "CloudWalk Network Mainnet",
		"symbols": [
			"CWN"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://explorer.mainnet.cloudwalk.io"
	},
	{
		"prefix": 2021,
		"network": "logion",
		"displayName": "logion network",
		"symbols": [
			"LGNT"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://logion.network"
	},
	{
		"prefix": 2024,
		"network": "vow-chain",
		"displayName": "Enigmatic Smile",
		"symbols": [
			"VOW"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://www.vow.foundation/"
	},
	{
		"prefix": 2032,
		"network": "interlay",
		"displayName": "Interlay",
		"symbols": [
			"INTR"
		],
		"decimals": [
			10
		],
		"standardAccount": "*25519",
		"website": "https://interlay.io/"
	},
	{
		"prefix": 2092,
		"network": "kintsugi",
		"displayName": "Kintsugi",
		"symbols": [
			"KINT"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://interlay.io/"
	},
	{
		"prefix": 2106,
		"network": "bitgreen",
		"displayName": "Bitgreen",
		"symbols": [
			"BBB"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://bitgreen.org/"
	},
	{
		"prefix": 2112,
		"network": "chainflip",
		"displayName": "Chainflip",
		"symbols": [
			"FLIP"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://chainflip.io/"
	},
	{
		"prefix": 2199,
		"network": "moonsama",
		"displayName": "Moonsama",
		"symbols": [
			"SAMA"
		],
		"decimals": [
			18
		],
		"standardAccount": "secp256k1",
		"website": "https://moonsama.com"
	},
	{
		"prefix": 2206,
		"network": "ICE",
		"displayName": "ICE Network",
		"symbols": [
			"ICY"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://icenetwork.io"
	},
	{
		"prefix": 2207,
		"network": "SNOW",
		"displayName": "SNOW: ICE Canary Network",
		"symbols": [
			"ICZ"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://icenetwork.io"
	},
	{
		"prefix": 2254,
		"network": "subspace_testnet",
		"displayName": "Subspace testnet",
		"symbols": [
			"tSSC"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://subspace.network"
	},
	{
		"prefix": 3333,
		"network": "peerplays",
		"displayName": "Peerplays",
		"symbols": [
			"PPY"
		],
		"decimals": [
			18
		],
		"standardAccount": "secp256k1",
		"website": "https://www.peerplays.com/"
	},
	{
		"prefix": 4450,
		"network": "g1",
		"displayName": "Ğ1",
		"symbols": [
			"G1"
		],
		"decimals": [
			2
		],
		"standardAccount": "*25519",
		"website": "https://duniter.org"
	},
	{
		"prefix": 5234,
		"network": "humanode",
		"displayName": "Humanode Network",
		"symbols": [
			"HMND"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://humanode.io"
	},
	{
		"prefix": 5845,
		"network": "tangle",
		"displayName": "Tangle Network",
		"symbols": [
			"TNT"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://www.tangle.tools/"
	},
	{
		"prefix": 6094,
		"network": "autonomys",
		"displayName": "Autonomys",
		"symbols": [
			"AI3"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://autonomys.xyz"
	},
	{
		"prefix": 7007,
		"network": "tidefi",
		"displayName": "Tidefi",
		"symbols": [
			"TDFY"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://tidefi.com"
	},
	{
		"prefix": 7013,
		"network": "gm",
		"displayName": "GM",
		"symbols": [
			"FREN",
			"GM",
			"GN"
		],
		"decimals": [
			12,
			0,
			0
		],
		"standardAccount": "*25519",
		"website": "https://gmordie.com"
	},
	{
		"prefix": 7306,
		"network": "krigan",
		"displayName": "Krigan Network",
		"symbols": [
			"KRGN"
		],
		"decimals": [
			9
		],
		"standardAccount": "*25519",
		"website": "https://krigan.network"
	},
	{
		"prefix": 7391,
		"network": "unique_mainnet",
		"displayName": "Unique Network",
		"symbols": [
			"UNQ"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://unique.network"
	},
	{
		"prefix": 8866,
		"network": "golden_gate",
		"displayName": "Golden Gate",
		"symbols": [
			"GGX"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://ggxchain.io/"
	},
	{
		"prefix": 8883,
		"network": "sapphire_mainnet",
		"displayName": "Sapphire by Unique",
		"symbols": [
			"QTZ"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://unique.network"
	},
	{
		"prefix": 8886,
		"network": "golden_gate_sydney",
		"displayName": "Golden Gate Sydney",
		"symbols": [
			"GGXT"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://ggxchain.io/"
	},
	{
		"prefix": 9072,
		"network": "hashed",
		"displayName": "Hashed Network",
		"symbols": [
			"HASH"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://hashed.network"
	},
	{
		"prefix": 9807,
		"network": "dentnet",
		"displayName": "DENTNet",
		"symbols": [
			"DENTX"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://www.dentnet.io"
	},
	{
		"prefix": 9935,
		"network": "t3rn",
		"displayName": "t3rn",
		"symbols": [
			"TRN"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://t3rn.io/"
	},
	{
		"prefix": 10041,
		"network": "basilisk",
		"displayName": "Basilisk",
		"symbols": [
			"BSX"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://bsx.fi"
	},
	{
		"prefix": 11330,
		"network": "cess-testnet",
		"displayName": "CESS Testnet",
		"symbols": [
			"TCESS"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://cess.cloud"
	},
	{
		"prefix": 11331,
		"network": "cess",
		"displayName": "CESS",
		"symbols": [
			"CESS"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://cess.cloud"
	},
	{
		"prefix": 11486,
		"network": "luhn",
		"displayName": "Luhn Network",
		"symbols": [
			"LUHN"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://luhn.network"
	},
	{
		"prefix": 11820,
		"network": "contextfree",
		"displayName": "Automata ContextFree",
		"symbols": [
			"CTX"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://ata.network"
	},
	{
		"prefix": 12155,
		"network": "impact",
		"displayName": "Impact Protocol Network",
		"symbols": [
			"BSTY"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://impactprotocol.network/"
	},
	{
		"prefix": 12191,
		"network": "nftmart",
		"displayName": "NFTMart",
		"symbols": [
			"NMT"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://nftmart.io"
	},
	{
		"prefix": 12850,
		"network": "analog-timechain",
		"displayName": "Analog Timechain",
		"symbols": [
			"ANLOG"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://analog.one"
	},
	{
		"prefix": 13116,
		"network": "bittensor",
		"displayName": "Bittensor",
		"symbols": [
			"TAO"
		],
		"decimals": [
			9
		],
		"standardAccount": "*25519",
		"website": "https://bittensor.com"
	},
	{
		"prefix": 14697,
		"network": "goro",
		"displayName": "GORO Network",
		"symbols": [
			"GORO"
		],
		"decimals": [
			9
		],
		"standardAccount": "*25519",
		"website": "https://goro.network"
	},
	{
		"prefix": 14998,
		"network": "mosaic-chain",
		"displayName": "Mosaic Chain",
		"symbols": [
			"MOS"
		],
		"decimals": [
			18
		],
		"standardAccount": "*25519",
		"website": "https://mosaicchain.io"
	},
	{
		"prefix": 29972,
		"network": "mythos",
		"displayName": "Mythos",
		"symbols": [
			"MYTH"
		],
		"decimals": [
			18
		],
		"standardAccount": "secp256k1",
		"website": "https://mythos.foundation"
	},
	{
		"prefix": 8888,
		"network": "xcavate",
		"displayName": "Xcavate Protocol",
		"symbols": [
			"XCAV"
		],
		"decimals": [
			12
		],
		"standardAccount": "*25519",
		"website": "https://xcavate.io/"
	}
];

const knownGenesis = {
    acala: [
        '0xfc41b9bd8ef8fe53d58c7ea67c794c7ec9a73daf05e6d54b14ff6342c99ba64c'
    ],
    ajuna: [
        '0xe358eb1d11b31255a286c12e44fe6780b7edb171d657905a97e39f71d9c6c3ee'
    ],
    'aleph-node': [
        '0x70255b4d28de0fc4e1a193d7e175ad1ccef431598211c55538f1018651a0344e'
    ],
    astar: [
        '0x9eb76c5184c4ab8679d2d5d819fdf90b9c001403e9e17da2e14b6d8aec4029c6'
    ],
    basilisk: [
        '0xa85cfb9b9fd4d622a5b28289a02347af987d8f73fa3108450e2b4a11c1ce5755'
    ],
    bifrost: [
        '0x262e1b2ad728475fd6fe88e62d34c200abe6fd693931ddad144059b1eb884e5b'
    ],
    'bifrost-kusama': [
        '0x9f28c6a68e0fc9646eff64935684f6eeeece527e37bbe1f213d22caa1d9d6bed'
    ],
    bittensor: [
        '0x2f0555cc76fc2840a25a6ea3b9637146806f1f44b090c175ffde2a7e5ab36c03'
    ],
    centrifuge: [
        '0xb3db41421702df9a7fcac62b53ffeac85f7853cc4e689e0b93aeb3db18c09d82',
        '0x67dddf2673b69e5f875f6f25277495834398eafd67f492e09f3f3345e003d1b5'
    ],
    cere: [
        '0x81443836a9a24caaa23f1241897d1235717535711d1d3fe24eae4fdc942c092c'
    ],
    composable: [
        '0xdaab8df776eb52ec604a5df5d388bb62a050a0aaec4556a64265b9d42755552d'
    ],
    creditcoin3: [
        '0x4436a7d64e363df85e065a894721002a86643283f9707338bf195d360ba2ee71', // cc3 mainnet
        '0xfc4ec97a1c1f119c4353aecb4a17c7c0cf7b40d5d660143d8bad9117e9866572', // cc3 testnet/drynet
        '0xfc9df99a665f964aed6649f275055e54df5e3420489538ed31d7788f53d11ef6' // cc3 devnet
    ],
    darwinia: [
        '0xe71578b37a7c799b0ab4ee87ffa6f059a6b98f71f06fb8c84a8d88013a548ad6'
    ],
    dentnet: [
        '0x0313f6a011d128d22f996703cbab05162e2fdc9e031493314fe6db79979c5ca7'
    ],
    'dock-mainnet': [
        '0x6bfe24dca2a3be10f22212678ac13a6446ec764103c0f3471c71609eac384aae',
        '0xf73467c6544aa68df2ee546b135f955c46b90fa627e9b5d7935f41061bb8a5a9'
    ],
    edgeware: [
        '0x742a2ca70c2fda6cee4f8df98d64c4c670a052d9568058982dad9d5a7a135c5b'
    ],
    encointer: [
        '0x7dd99936c1e9e6d1ce7d90eb6f33bea8393b4bf87677d675aa63c9cb3e8c5b5b'
    ],
    enjin: [
        '0xd8761d3c88f26dc12875c00d3165f7d67243d56fc85b4cf19937601a7916e5a9'
    ],
    equilibrium: [
        '0x6f1a800de3daff7f5e037ddf66ab22ce03ab91874debeddb1086f5f7dbd48925'
    ],
    frequency: [
        '0x4a587bf17a404e3572747add7aab7bbe56e805a5479c6c436f07f36fcc8d3ae1'
    ],
    genshiro: [
        '0x9b8cefc0eb5c568b527998bdd76c184e2b76ae561be76e4667072230217ea243'
    ],
    hydradx: [
        '0xafdc188f45c71dacbaa0b62e16a91f726c7b8699a9748cdf715459de6b7f366d', // Hydration | HydraDX Parachain
        '0xd2a620c27ec5cbc5621ff9a522689895074f7cca0d08e7134a7804e1a3ba86fc', // Snakenet Gen3-1
        '0x10af6e84234477d84dc572bac0789813b254aa490767ed06fb9591191d1073f9', // Snakenet Gen3
        '0x3d75507dd46301767e601265791da1d9cb47b6ebc94e87347b635e5bf58bd047', // Snakenet Gen2
        '0x0ed32bfcab4a83517fac88f2aa7cbc2f88d3ab93be9a12b6188a036bf8a943c2' // Snakenet Gen1
    ],
    integritee: [
        '0xcdedc8eadbfa209d3f207bba541e57c3c58a667b05a2e1d1e86353c9000758da', // on Kusama
        '0xe13e7af377c64e83f95e0d70d5e5c3c01d697a84538776c5b9bbe0e7d7b6034c' // on Polkadot
    ],
    'interlay-parachain': [
        '0xbf88efe70e9e0e916416e8bed61f2b45717f517d7f3523e33c7b001e5ffcbc72'
    ],
    karura: [
        '0xbaf5aabe40646d11f0ee8abbdc64f4a4b7674925cba08e4a05ff9ebed6e2126b'
    ],
    khala: [
        '0xd43540ba6d3eb4897c28a77d48cb5b729fea37603cbbfc7a86a73b72adb3be8d'
    ],
    kulupu: [
        '0xf7a99d3cb92853d00d5275c971c132c074636256583fee53b3bbe60d7b8769ba'
    ],
    kusama: [
        '0xb0a8d493285c2df73290dfb7e61f870f17b41801197a149ca93654499ea3dafe', // Kusama CC3,
        '0xe3777fa922cafbff200cadeaea1a76bd7898ad5b89f7848999058b50e715f636', // Kusama CC2
        '0x3fd7b9eb6a00376e5be61f01abb429ffb0b104be05eaff4d458da48fcd425baf' // Kusama CC1
    ],
    liberland: [
        '0x6bd89e052d67a45bb60a9a23e8581053d5e0d619f15cb9865946937e690c42d6'
    ],
    matrixchain: [
        '0x3af4ff48ec76d2efc8476730f423ac07e25ad48f5f4c9dc39c778b164d808615'
    ],
    mythos: [
        '0xf6ee56e9c5277df5b4ce6ae9983ee88f3cbed27d31beeb98f9f84f997a1ab0b9'
    ],
    nodle: [
        '0x97da7ede98d7bad4e36b4d734b6055425a3be036da2a332ea5a7037656427a21'
    ],
    origintrail: [
        '0xe7e0962324a3b86c83404dbea483f25fb5dab4c224791c81b756cfc948006174'
    ],
    p3d: [
        '0x6c5894837ad89b6d92b114a2fb3eafa8fe3d26a54848e3447015442cd6ef4e66'
    ],
    parallel: [
        '0xe61a41c53f5dcd0beb09df93b34402aada44cb05117b71059cce40a2723a4e97'
    ],
    peaq: [
        '0xd2a5d385932d1f650dae03ef8e2748983779ee342c614f80854d32b8cd8fa48c'
    ],
    pendulum: [
        '0x5d3c298622d5634ed019bf61ea4b71655030015bde9beb0d6a24743714462c86'
    ],
    phala: [
        '0x1bb969d85965e4bb5a651abbedf21a54b6b31a21f66b5401cc3f1e286268d736'
    ],
    picasso: [
        '0x6811a339673c9daa897944dcdac99c6e2939cc88245ed21951a0a3c9a2be75bc',
        '0xe8e7f0f4c4f5a00720b4821dbfddefea7490bcf0b19009961cc46957984e2c1c'
    ],
    polimec: [
        '0x7eb9354488318e7549c722669dcbdcdc526f1fef1420e7944667212f3601fdbd'
    ],
    polkadex: [
        '0x3920bcb4960a1eef5580cd5367ff3f430eef052774f78468852f7b9cb39f8a3c'
    ],
    polkadot: [
        '0x91b171bb158e2d3848fa23a9f1c25182fb8e20313b2c1eb49219da7a70ce90c3'
    ],
    polymesh: [
        '0x6fbd74e5e1d0a61d52ccfe9d4adaed16dd3a7caa37c6bc4d0c2fa12e8b2f4063'
    ],
    quartz: [
        '0xcd4d732201ebe5d6b014edda071c4203e16867305332301dc8d092044b28e554'
    ],
    rococo: [
        '0x6408de7737c59c238890533af25896a2c20608d8b380bb01029acb392781063e',
        '0xaaf2cd1b74b5f726895921259421b534124726263982522174147046b8827897',
        '0x037f5f3c8e67b314062025fc886fcd6238ea25a4a9b45dce8d246815c9ebe770',
        '0xc196f81260cf1686172b47a79cf002120735d7cb0eb1474e8adce56618456fff',
        '0xf6e9983c37baf68846fedafe21e56718790e39fb1c582abc408b81bc7b208f9a',
        '0x5fce687da39305dfe682b117f0820b319348e8bb37eb16cf34acbf6a202de9d9',
        '0xe7c3d5edde7db964317cd9b51a3a059d7cd99f81bdbce14990047354334c9779',
        '0x1611e1dbf0405379b861e2e27daa90f480b2e6d3682414a80835a52e8cb8a215',
        '0x343442f12fa715489a8714e79a7b264ea88c0d5b8c66b684a7788a516032f6b9',
        '0x78bcd530c6b3a068bc17473cf5d2aff9c287102bed9af3ae3c41c33b9d6c6147',
        '0x47381ee0697153d64404fc578392c8fd5cba9073391908f46c888498415647bd',
        '0x19c0e4fa8ab75f5ac7865e0b8f74ff91eb9a100d336f423cd013a8befba40299'
    ],
    sora: [
        '0x7e4e32d0feafd4f9c9414b0be86373f9a1efa904809b683453a9af6856d38ad5'
    ],
    stafi: [
        '0x290a4149f09ea0e402c74c1c7e96ae4239588577fe78932f94f5404c68243d80'
    ],
    statemine: [
        '0x48239ef607d7928874027a43a67689209727dfb3d3dc5e5b03a39bdc2eda771a'
    ],
    statemint: [
        '0x68d56f15f85d3136970ec16946040bc1752654e906147f7e43e9d539d7c3de2f'
    ],
    subsocial: [
        '0x0bd72c1c305172e1275278aaeb3f161e02eccb7a819e63f62d47bd53a28189f8'
    ],
    ternoa: [
        '0x6859c81ca95ef624c9dfe4dc6e3381c33e5d6509e35e147092bfbc780f777c4e'
    ],
    unique: [
        '0x84322d9cddbf35088f1e54e9a85c967a41a56a4f43445768125e61af166c7d31'
    ],
    vara: [
        '0xfe1b4c55fd4d668101126434206571a7838a8b6b93a6d1b95d607e78e6c53763'
    ],
    vtb: [
        '0x286bc8414c7000ce1d6ee6a834e29a54c1784814b76243eb77ed0b2c5573c60f',
        '0x7483b89572fb2bd687c7b9a93b242d0b237f9aba463aba07ec24503931038aaa'
    ],
    westend: [
        '0xe143f23803ac50e8f6f8e62695d1ce9e4e1d68aa36c1cd2cfd15340213f3423e'
    ],
    xxnetwork: [
        '0x50dd5d206917bf10502c68fb4d18a59fc8aa31586f4e8856b493e43544aa82aa'
    ],
    zeitgeist: [
        '0x1bf2a2ecb4a868de66ea8610f2ce7c8c43706561b6476031315f6640fe38e060'
    ]
};

const knownIcon = {
    centrifuge: 'polkadot',
    kusama: 'polkadot',
    polkadot: 'polkadot',
    sora: 'polkadot',
    statemine: 'polkadot',
    statemint: 'polkadot',
    westmint: 'polkadot'
};

const knownLedger = {
    acala: 0x00000313,
    ajuna: 0x00000162,
    'aleph-node': 0x00000283,
    astar: 0x0000032a,
    bifrost: 0x00000314,
    'bifrost-kusama': 0x00000314,
    bittensor: 0x00000162,
    centrifuge: 0x000002eb,
    composable: 0x00000162,
    creditcoin3: 0x00000162,
    darwinia: 0x00000162,
    dentnet: 0x000002de,
    'dock-mainnet': 0x00000252,
    edgeware: 0x0000020b,
    encointer: 0x000001b2,
    enjin: 0x00000483,
    equilibrium: 0x05f5e0fd,
    frequency: 0x0000082b,
    genshiro: 0x05f5e0fc,
    hydradx: 0x00000162,
    integritee: 0x000007df,
    'interlay-parachain': 0x00000162,
    karura: 0x000002ae,
    khala: 0x000001b2,
    kusama: 0x000001b2,
    liberland: 0x000002ff,
    matrixchain: 0x00000483,
    mythos: 0x0000003c,
    nodle: 0x000003eb,
    origintrail: 0x00000162,
    parallel: 0x00000162,
    peaq: 0x00000d0a,
    pendulum: 0x00000162,
    phala: 0x00000162,
    picasso: 0x000001b2,
    polimec: 0x00000d10,
    polkadex: 0x0000031f,
    polkadot: 0x00000162,
    polymesh: 0x00000253,
    quartz: 0x00000277,
    sora: 0x00000269,
    stafi: 0x0000038b,
    statemine: 0x000001b2, // common-good on Kusama, shares derivation
    statemint: 0x00000162, // common-good on Polkadot, shares derivation
    ternoa: 0x00003e3,
    unique: 0x00000295,
    vara: 0x00001370,
    vtb: 0x000002b6,
    xxnetwork: 0x000007a3,
    zeitgeist: 0x00000162
};

const knownTestnet = {
    '': true, // this is the default non-network entry
    'cess-testnet': true,
    'dock-testnet': true,
    jupiter: true,
    'mathchain-testnet': true,
    p3dt: true,
    subspace_testnet: true,
    'zero-alphaville': true
};

const UNSORTED = [0, 2, 42];
const TESTNETS = ['testnet'];
function toExpanded(o) {
    const network = o.network || '';
    const nameParts = network.replace(/_/g, '-').split('-');
    const n = o;
    // ledger additions
    n.slip44 = knownLedger[network];
    n.hasLedgerSupport = !!n.slip44;
    // general items
    n.genesisHash = knownGenesis[network] || [];
    n.icon = knownIcon[network] || 'substrate';
    // filtering
    n.isTestnet = !!knownTestnet[network] || TESTNETS.includes(nameParts[nameParts.length - 1]);
    n.isIgnored = n.isTestnet || (!(o.standardAccount &&
        o.decimals?.length &&
        o.symbols?.length) &&
        o.prefix !== 42);
    return n;
}
function filterSelectable({ genesisHash, prefix }) {
    return !!genesisHash.length || prefix === 42;
}
function filterAvailable(n) {
    return !n.isIgnored && !!n.network;
}
function sortNetworks(a, b) {
    const isUnSortedA = UNSORTED.includes(a.prefix);
    const isUnSortedB = UNSORTED.includes(b.prefix);
    return isUnSortedA === isUnSortedB
        ? isUnSortedA
            ? 0
            : a.displayName.localeCompare(b.displayName)
        : isUnSortedA
            ? -1
            : 1;
}
const allNetworks = knownSubstrate.map(toExpanded);
const availableNetworks = allNetworks.filter(filterAvailable).sort(sortNetworks);
const selectableNetworks = availableNetworks.filter(filterSelectable);

const defaults$1 = {
    allowedDecodedLengths: [1, 2, 4, 8, 32, 33],
    // publicKey has prefix + 2 checksum bytes, short only prefix + 1 checksum byte
    allowedEncodedLengths: [3, 4, 6, 10, 35, 36, 37, 38],
    allowedPrefix: availableNetworks.map(({ prefix }) => prefix),
    prefix: 42
};

function decodeAddress(encoded, ignoreChecksum, ss58Format = -1) {
    if (!encoded) {
        throw new Error('Invalid empty address passed');
    }
    if (isU8a(encoded) || isHex(encoded)) {
        return u8aToU8a(encoded);
    }
    try {
        const decoded = base58Decode(encoded);
        if (!defaults$1.allowedEncodedLengths.includes(decoded.length)) {
            throw new Error('Invalid decoded address length');
        }
        const [isValid, endPos, ss58Length, ss58Decoded] = checkAddressChecksum(decoded);
        if (!isValid && !ignoreChecksum) {
            throw new Error('Invalid decoded address checksum');
        }
        else if (ss58Format !== -1 && ss58Format !== ss58Decoded) {
            throw new Error(`Expected ss58Format ${ss58Format}, received ${ss58Decoded}`);
        }
        return decoded.slice(ss58Length, endPos);
    }
    catch (error) {
        throw new Error(`Decoding ${encoded}: ${error.message}`);
    }
}

const BN_BE_256_OPTS = { bitLength: 256, isLe: false };

/**
 * SHA2 hash function. A.k.a. sha256, sha384, sha512, sha512_224, sha512_256.
 * SHA256 is the fastest hash implementable in JS, even faster than Blake3.
 * Check out [RFC 4634](https://datatracker.ietf.org/doc/html/rfc4634) and
 * [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 */
/**
 * Round constants:
 * First 32 bits of fractional parts of the cube roots of the first 64 primes 2..311)
 */
// prettier-ignore
const SHA256_K = /* @__PURE__ */ Uint32Array.from([
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
]);
/** Reusable temporary buffer. "W" comes straight from spec. */
const SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class SHA256 extends HashMD {
    constructor(outputLen = 32) {
        super(64, outputLen, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = SHA256_IV[0] | 0;
        this.B = SHA256_IV[1] | 0;
        this.C = SHA256_IV[2] | 0;
        this.D = SHA256_IV[3] | 0;
        this.E = SHA256_IV[4] | 0;
        this.F = SHA256_IV[5] | 0;
        this.G = SHA256_IV[6] | 0;
        this.H = SHA256_IV[7] | 0;
    }
    get() {
        const { A, B, C, D, E, F, G, H } = this;
        return [A, B, C, D, E, F, G, H];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for (let i = 0; i < 16; i++, offset += 4)
            SHA256_W[i] = view.getUint32(offset, false);
        for (let i = 16; i < 64; i++) {
            const W15 = SHA256_W[i - 15];
            const W2 = SHA256_W[i - 2];
            const s0 = rotr(W15, 7) ^ rotr(W15, 18) ^ (W15 >>> 3);
            const s1 = rotr(W2, 17) ^ rotr(W2, 19) ^ (W2 >>> 10);
            SHA256_W[i] = (s1 + SHA256_W[i - 7] + s0 + SHA256_W[i - 16]) | 0;
        }
        // Compression function main loop, 64 rounds
        let { A, B, C, D, E, F, G, H } = this;
        for (let i = 0; i < 64; i++) {
            const sigma1 = rotr(E, 6) ^ rotr(E, 11) ^ rotr(E, 25);
            const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const sigma0 = rotr(A, 2) ^ rotr(A, 13) ^ rotr(A, 22);
            const T2 = (sigma0 + Maj(A, B, C)) | 0;
            H = G;
            G = F;
            F = E;
            E = (D + T1) | 0;
            D = C;
            C = B;
            B = A;
            A = (T1 + T2) | 0;
        }
        // Add the compressed chunk to the current hash value
        A = (A + this.A) | 0;
        B = (B + this.B) | 0;
        C = (C + this.C) | 0;
        D = (D + this.D) | 0;
        E = (E + this.E) | 0;
        F = (F + this.F) | 0;
        G = (G + this.G) | 0;
        H = (H + this.H) | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        clean(SHA256_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        clean(this.buffer);
    }
}
/**
 * SHA2-256 hash function from RFC 4634.
 *
 * It is the fastest JS hash, even faster than Blake3.
 * To break sha256 using birthday attack, attackers need to try 2^128 hashes.
 * BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per 2025.
 */
const sha256 = /* @__PURE__ */ createHasher(() => new SHA256());

/**
 * HMAC: RFC2104 message authentication code.
 * @module
 */
class HMAC extends Hash {
    constructor(hash, _key) {
        super();
        this.finished = false;
        this.destroyed = false;
        ahash(hash);
        const key = toBytes(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== 'function')
            throw new Error('Expected instance of class which extends utils.Hash');
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for (let i = 0; i < pad.length; i++)
            pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for (let i = 0; i < pad.length; i++)
            pad[i] ^= 0x36 ^ 0x5c;
        this.oHash.update(pad);
        clean(pad);
    }
    update(buf) {
        aexists(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        aexists(this);
        abytes(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash, iHash, finished, destroyed, blockLen, outputLen } = this;
        to = to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 * @example
 * import { hmac } from '@noble/hashes/hmac';
 * import { sha256 } from '@noble/hashes/sha2';
 * const mac1 = hmac(sha256, 'key', 'message');
 */
const hmac = (hash, key, message) => new HMAC(hash, key).update(message).digest();
hmac.create = (hash, key) => new HMAC(hash, key);

/**
 * Hex, bytes and number utilities.
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n$4 = /* @__PURE__ */ BigInt(0);
const _1n$4 = /* @__PURE__ */ BigInt(1);
// tmp name until v2
function _abool2(value, title = '') {
    if (typeof value !== 'boolean') {
        const prefix = title && `"${title}"`;
        throw new Error(prefix + 'expected boolean, got type=' + typeof value);
    }
    return value;
}
// tmp name until v2
/** Asserts something is Uint8Array. */
function _abytes2(value, length, title = '') {
    const bytes = isBytes(value);
    const len = value?.length;
    const needsLen = length !== undefined;
    if (!bytes || (needsLen && len !== length)) {
        const prefix = title && `"${title}" `;
        const ofLen = needsLen ? ` of length ${length}` : '';
        const got = bytes ? `length=${len}` : `type=${typeof value}`;
        throw new Error(prefix + 'expected Uint8Array' + ofLen + ', got ' + got);
    }
    return value;
}
// Used in weierstrass, der
function numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? '0' + hex : hex;
}
function hexToNumber(hex) {
    if (typeof hex !== 'string')
        throw new Error('hex string expected, got ' + typeof hex);
    return hex === '' ? _0n$4 : BigInt('0x' + hex); // Big Endian
}
// BE: Big Endian, LE: Little Endian
function bytesToNumberBE(bytes) {
    return hexToNumber(bytesToHex(bytes));
}
function bytesToNumberLE(bytes) {
    abytes(bytes);
    return hexToNumber(bytesToHex(Uint8Array.from(bytes).reverse()));
}
function numberToBytesBE(n, len) {
    return hexToBytes(n.toString(16).padStart(len * 2, '0'));
}
function numberToBytesLE(n, len) {
    return numberToBytesBE(n, len).reverse();
}
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'secret key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */
function ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === 'string') {
        try {
            res = hexToBytes(hex);
        }
        catch (e) {
            throw new Error(title + ' must be hex string or Uint8Array, cause: ' + e);
        }
    }
    else if (isBytes(hex)) {
        // Uint8Array.from() instead of hash.slice() because node.js Buffer
        // is instance of Uint8Array, and its slice() creates **mutable** copy
        res = Uint8Array.from(hex);
    }
    else {
        throw new Error(title + ' must be hex string or Uint8Array');
    }
    res.length;
    return res;
}
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */
// export const utf8ToBytes: typeof utf8ToBytes_ = utf8ToBytes_;
/**
 * Converts bytes to string using UTF8 encoding.
 * @example bytesToUtf8(Uint8Array.from([97, 98, 99])) // 'abc'
 */
// export const bytesToUtf8: typeof bytesToUtf8_ = bytesToUtf8_;
// Is positive bigint
const isPosBig = (n) => typeof n === 'bigint' && _0n$4 <= n;
function inRange(n, min, max) {
    return isPosBig(n) && isPosBig(min) && isPosBig(max) && min <= n && n < max;
}
/**
 * Asserts min <= n < max. NOTE: It's < max and not <= max.
 * @example
 * aInRange('x', x, 1n, 256n); // would assume x is in (1n..255n)
 */
function aInRange(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!inRange(n, min, max))
        throw new Error('expected valid ' + title + ': ' + min + ' <= n < ' + max + ', got ' + n);
}
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 * TODO: merge with nLength in modular
 */
function bitLen(n) {
    let len;
    for (len = 0; n > _0n$4; n >>= _1n$4, len += 1)
        ;
    return len;
}
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */
const bitMask = (n) => (_1n$4 << BigInt(n)) - _1n$4;
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */
function createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== 'number' || hashLen < 2)
        throw new Error('hashLen must be a number');
    if (typeof qByteLen !== 'number' || qByteLen < 2)
        throw new Error('qByteLen must be a number');
    if (typeof hmacFn !== 'function')
        throw new Error('hmacFn must be a function');
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    const u8n = (len) => new Uint8Array(len); // creates Uint8Array
    const u8of = (byte) => Uint8Array.of(byte); // another shortcut
    let v = u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = () => {
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b) => hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = u8n(0)) => {
        // HMAC-DRBG reseed() function. Steps D-G
        k = h(u8of(0x00), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0)
            return;
        k = h(u8of(0x01), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = () => {
        // HMAC-DRBG generate() function
        if (i++ >= 1000)
            throw new Error('drbg: tried 1000 values');
        let len = 0;
        const out = [];
        while (len < qByteLen) {
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return concatBytes(...out);
    };
    const genUntil = (seed, pred) => {
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while (!(res = pred(gen())))
            reseed();
        reset();
        return res;
    };
    return genUntil;
}
function _validateObject(object, fields, optFields = {}) {
    if (!object || typeof object !== 'object')
        throw new Error('expected valid options object');
    function checkField(fieldName, expectedType, isOpt) {
        const val = object[fieldName];
        if (isOpt && val === undefined)
            return;
        const current = typeof val;
        if (current !== expectedType || val === null)
            throw new Error(`param "${fieldName}" is invalid: expected ${expectedType}, got ${current}`);
    }
    Object.entries(fields).forEach(([k, v]) => checkField(k, v, false));
    Object.entries(optFields).forEach(([k, v]) => checkField(k, v, true));
}
/**
 * Memoizes (caches) computation result.
 * Uses WeakMap: the value is going auto-cleaned by GC after last reference is removed.
 */
function memoized(fn) {
    const map = new WeakMap();
    return (arg, ...args) => {
        const val = map.get(arg);
        if (val !== undefined)
            return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}

/**
 * Utils for modular division and fields.
 * Field over 11 is a finite (Galois) field is integer number operations `mod 11`.
 * There is no division: it is replaced by modular multiplicative inverse.
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// prettier-ignore
const _0n$3 = BigInt(0), _1n$3 = BigInt(1), _2n$3 = /* @__PURE__ */ BigInt(2), _3n$1 = /* @__PURE__ */ BigInt(3);
// prettier-ignore
const _4n$1 = /* @__PURE__ */ BigInt(4), _5n = /* @__PURE__ */ BigInt(5), _7n$2 = /* @__PURE__ */ BigInt(7);
// prettier-ignore
const _8n = /* @__PURE__ */ BigInt(8), _9n = /* @__PURE__ */ BigInt(9), _16n$1 = /* @__PURE__ */ BigInt(16);
// Calculates a modulo b
function mod(a, b) {
    const result = a % b;
    return result >= _0n$3 ? result : b + result;
}
/** Does `x^(2^power)` mod p. `pow2(30, 4)` == `30^(2^4)` */
function pow2(x, power, modulo) {
    let res = x;
    while (power-- > _0n$3) {
        res *= res;
        res %= modulo;
    }
    return res;
}
/**
 * Inverses number over modulo.
 * Implemented using [Euclidean GCD](https://brilliant.org/wiki/extended-euclidean-algorithm/).
 */
function invert(number, modulo) {
    if (number === _0n$3)
        throw new Error('invert: expected non-zero number');
    if (modulo <= _0n$3)
        throw new Error('invert: expected positive modulus, got ' + modulo);
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = _0n$3, u = _1n$3;
    while (a !== _0n$3) {
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        // prettier-ignore
        b = a, a = r, x = u, u = m;
    }
    const gcd = b;
    if (gcd !== _1n$3)
        throw new Error('invert: does not exist');
    return mod(x, modulo);
}
function assertIsSquare(Fp, root, n) {
    if (!Fp.eql(Fp.sqr(root), n))
        throw new Error('Cannot find square root');
}
// Not all roots are possible! Example which will throw:
// const NUM =
// n = 72057594037927816n;
// Fp = Field(BigInt('0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaab'));
function sqrt3mod4(Fp, n) {
    const p1div4 = (Fp.ORDER + _1n$3) / _4n$1;
    const root = Fp.pow(n, p1div4);
    assertIsSquare(Fp, root, n);
    return root;
}
function sqrt5mod8(Fp, n) {
    const p5div8 = (Fp.ORDER - _5n) / _8n;
    const n2 = Fp.mul(n, _2n$3);
    const v = Fp.pow(n2, p5div8);
    const nv = Fp.mul(n, v);
    const i = Fp.mul(Fp.mul(nv, _2n$3), v);
    const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
    assertIsSquare(Fp, root, n);
    return root;
}
// Based on RFC9380, Kong algorithm
// prettier-ignore
function sqrt9mod16(P) {
    const Fp_ = Field(P);
    const tn = tonelliShanks(P);
    const c1 = tn(Fp_, Fp_.neg(Fp_.ONE)); //  1. c1 = sqrt(-1) in F, i.e., (c1^2) == -1 in F
    const c2 = tn(Fp_, c1); //  2. c2 = sqrt(c1) in F, i.e., (c2^2) == c1 in F
    const c3 = tn(Fp_, Fp_.neg(c1)); //  3. c3 = sqrt(-c1) in F, i.e., (c3^2) == -c1 in F
    const c4 = (P + _7n$2) / _16n$1; //  4. c4 = (q + 7) / 16        # Integer arithmetic
    return (Fp, n) => {
        let tv1 = Fp.pow(n, c4); //  1. tv1 = x^c4
        let tv2 = Fp.mul(tv1, c1); //  2. tv2 = c1 * tv1
        const tv3 = Fp.mul(tv1, c2); //  3. tv3 = c2 * tv1
        const tv4 = Fp.mul(tv1, c3); //  4. tv4 = c3 * tv1
        const e1 = Fp.eql(Fp.sqr(tv2), n); //  5.  e1 = (tv2^2) == x
        const e2 = Fp.eql(Fp.sqr(tv3), n); //  6.  e2 = (tv3^2) == x
        tv1 = Fp.cmov(tv1, tv2, e1); //  7. tv1 = CMOV(tv1, tv2, e1)  # Select tv2 if (tv2^2) == x
        tv2 = Fp.cmov(tv4, tv3, e2); //  8. tv2 = CMOV(tv4, tv3, e2)  # Select tv3 if (tv3^2) == x
        const e3 = Fp.eql(Fp.sqr(tv2), n); //  9.  e3 = (tv2^2) == x
        const root = Fp.cmov(tv1, tv2, e3); // 10.  z = CMOV(tv1, tv2, e3)   # Select sqrt from tv1 & tv2
        assertIsSquare(Fp, root, n);
        return root;
    };
}
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */
function tonelliShanks(P) {
    // Initialization (precomputation).
    // Caching initialization could boost perf by 7%.
    if (P < _3n$1)
        throw new Error('sqrt is not defined for small field');
    // Factor P - 1 = Q * 2^S, where Q is odd
    let Q = P - _1n$3;
    let S = 0;
    while (Q % _2n$3 === _0n$3) {
        Q /= _2n$3;
        S++;
    }
    // Find the first quadratic non-residue Z >= 2
    let Z = _2n$3;
    const _Fp = Field(P);
    while (FpLegendre(_Fp, Z) === 1) {
        // Basic primality test for P. After x iterations, chance of
        // not finding quadratic non-residue is 2^x, so 2^1000.
        if (Z++ > 1000)
            throw new Error('Cannot find square root: probably non-prime P');
    }
    // Fast-path; usually done before Z, but we do "primality test".
    if (S === 1)
        return sqrt3mod4;
    // Slow-path
    // TODO: test on Fp2 and others
    let cc = _Fp.pow(Z, Q); // c = z^Q
    const Q1div2 = (Q + _1n$3) / _2n$3;
    return function tonelliSlow(Fp, n) {
        if (Fp.is0(n))
            return n;
        // Check if n is a quadratic residue using Legendre symbol
        if (FpLegendre(Fp, n) !== 1)
            throw new Error('Cannot find square root');
        // Initialize variables for the main loop
        let M = S;
        let c = Fp.mul(Fp.ONE, cc); // c = z^Q, move cc from field _Fp into field Fp
        let t = Fp.pow(n, Q); // t = n^Q, first guess at the fudge factor
        let R = Fp.pow(n, Q1div2); // R = n^((Q+1)/2), first guess at the square root
        // Main loop
        // while t != 1
        while (!Fp.eql(t, Fp.ONE)) {
            if (Fp.is0(t))
                return Fp.ZERO; // if t=0 return R=0
            let i = 1;
            // Find the smallest i >= 1 such that t^(2^i) ≡ 1 (mod P)
            let t_tmp = Fp.sqr(t); // t^(2^1)
            while (!Fp.eql(t_tmp, Fp.ONE)) {
                i++;
                t_tmp = Fp.sqr(t_tmp); // t^(2^2)...
                if (i === M)
                    throw new Error('Cannot find square root');
            }
            // Calculate the exponent for b: 2^(M - i - 1)
            const exponent = _1n$3 << BigInt(M - i - 1); // bigint is important
            const b = Fp.pow(c, exponent); // b = 2^(M - i - 1)
            // Update variables
            M = i;
            c = Fp.sqr(b); // c = b^2
            t = Fp.mul(t, c); // t = (t * b^2)
            R = Fp.mul(R, b); // R = R*b
        }
        return R;
    };
}
/**
 * Square root for a finite field. Will try optimized versions first:
 *
 * 1. P ≡ 3 (mod 4)
 * 2. P ≡ 5 (mod 8)
 * 3. P ≡ 9 (mod 16)
 * 4. Tonelli-Shanks algorithm
 *
 * Different algorithms can give different roots, it is up to user to decide which one they want.
 * For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
 */
function FpSqrt(P) {
    // P ≡ 3 (mod 4) => √n = n^((P+1)/4)
    if (P % _4n$1 === _3n$1)
        return sqrt3mod4;
    // P ≡ 5 (mod 8) => Atkin algorithm, page 10 of https://eprint.iacr.org/2012/685.pdf
    if (P % _8n === _5n)
        return sqrt5mod8;
    // P ≡ 9 (mod 16) => Kong algorithm, page 11 of https://eprint.iacr.org/2012/685.pdf (algorithm 4)
    if (P % _16n$1 === _9n)
        return sqrt9mod16(P);
    // Tonelli-Shanks algorithm
    return tonelliShanks(P);
}
// prettier-ignore
const FIELD_FIELDS = [
    'create', 'isValid', 'is0', 'neg', 'inv', 'sqrt', 'sqr',
    'eql', 'add', 'sub', 'mul', 'pow', 'div',
    'addN', 'subN', 'mulN', 'sqrN'
];
function validateField(field) {
    const initial = {
        ORDER: 'bigint',
        MASK: 'bigint',
        BYTES: 'number',
        BITS: 'number',
    };
    const opts = FIELD_FIELDS.reduce((map, val) => {
        map[val] = 'function';
        return map;
    }, initial);
    _validateObject(field, opts);
    // const max = 16384;
    // if (field.BYTES < 1 || field.BYTES > max) throw new Error('invalid field');
    // if (field.BITS < 1 || field.BITS > 8 * max) throw new Error('invalid field');
    return field;
}
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */
function FpPow(Fp, num, power) {
    if (power < _0n$3)
        throw new Error('invalid exponent, negatives unsupported');
    if (power === _0n$3)
        return Fp.ONE;
    if (power === _1n$3)
        return num;
    let p = Fp.ONE;
    let d = num;
    while (power > _0n$3) {
        if (power & _1n$3)
            p = Fp.mul(p, d);
        d = Fp.sqr(d);
        power >>= _1n$3;
    }
    return p;
}
/**
 * Efficiently invert an array of Field elements.
 * Exception-free. Will return `undefined` for 0 elements.
 * @param passZero map 0 to 0 (instead of undefined)
 */
function FpInvertBatch(Fp, nums, passZero = false) {
    const inverted = new Array(nums.length).fill(passZero ? Fp.ZERO : undefined);
    // Walk from first to last, multiply them by each other MOD p
    const multipliedAcc = nums.reduce((acc, num, i) => {
        if (Fp.is0(num))
            return acc;
        inverted[i] = acc;
        return Fp.mul(acc, num);
    }, Fp.ONE);
    // Invert last element
    const invertedAcc = Fp.inv(multipliedAcc);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i) => {
        if (Fp.is0(num))
            return acc;
        inverted[i] = Fp.mul(acc, inverted[i]);
        return Fp.mul(acc, num);
    }, invertedAcc);
    return inverted;
}
/**
 * Legendre symbol.
 * Legendre constant is used to calculate Legendre symbol (a | p)
 * which denotes the value of a^((p-1)/2) (mod p).
 *
 * * (a | p) ≡ 1    if a is a square (mod p), quadratic residue
 * * (a | p) ≡ -1   if a is not a square (mod p), quadratic non residue
 * * (a | p) ≡ 0    if a ≡ 0 (mod p)
 */
function FpLegendre(Fp, n) {
    // We can use 3rd argument as optional cache of this value
    // but seems unneeded for now. The operation is very fast.
    const p1mod2 = (Fp.ORDER - _1n$3) / _2n$3;
    const powered = Fp.pow(n, p1mod2);
    const yes = Fp.eql(powered, Fp.ONE);
    const zero = Fp.eql(powered, Fp.ZERO);
    const no = Fp.eql(powered, Fp.neg(Fp.ONE));
    if (!yes && !zero && !no)
        throw new Error('invalid Legendre symbol result');
    return yes ? 1 : zero ? 0 : -1;
}
// CURVE.n lengths
function nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    if (nBitLength !== undefined)
        anumber(nBitLength);
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return { nBitLength: _nBitLength, nByteLength };
}
/**
 * Creates a finite field. Major performance optimizations:
 * * 1. Denormalized operations like mulN instead of mul.
 * * 2. Identical object shape: never add or remove keys.
 * * 3. `Object.freeze`.
 * Fragile: always run a benchmark on a change.
 * Security note: operations don't check 'isValid' for all elements for performance reasons,
 * it is caller responsibility to check this.
 * This is low-level code, please make sure you know what you're doing.
 *
 * Note about field properties:
 * * CHARACTERISTIC p = prime number, number of elements in main subgroup.
 * * ORDER q = similar to cofactor in curves, may be composite `q = p^m`.
 *
 * @param ORDER field order, probably prime, or could be composite
 * @param bitLen how many bits the field consumes
 * @param isLE (default: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */
function Field(ORDER, bitLenOrOpts, // TODO: use opts only in v2?
isLE = false, opts = {}) {
    if (ORDER <= _0n$3)
        throw new Error('invalid field: expected ORDER > 0, got ' + ORDER);
    let _nbitLength = undefined;
    let _sqrt = undefined;
    let modFromBytes = false;
    let allowedLengths = undefined;
    if (typeof bitLenOrOpts === 'object' && bitLenOrOpts != null) {
        if (opts.sqrt || isLE)
            throw new Error('cannot specify opts in two arguments');
        const _opts = bitLenOrOpts;
        if (_opts.BITS)
            _nbitLength = _opts.BITS;
        if (_opts.sqrt)
            _sqrt = _opts.sqrt;
        if (typeof _opts.isLE === 'boolean')
            isLE = _opts.isLE;
        if (typeof _opts.modFromBytes === 'boolean')
            modFromBytes = _opts.modFromBytes;
        allowedLengths = _opts.allowedLengths;
    }
    else {
        if (typeof bitLenOrOpts === 'number')
            _nbitLength = bitLenOrOpts;
        if (opts.sqrt)
            _sqrt = opts.sqrt;
    }
    const { nBitLength: BITS, nByteLength: BYTES } = nLength(ORDER, _nbitLength);
    if (BYTES > 2048)
        throw new Error('invalid field: expected ORDER of <= 2048 bytes');
    let sqrtP; // cached sqrtP
    const f = Object.freeze({
        ORDER,
        isLE,
        BITS,
        BYTES,
        MASK: bitMask(BITS),
        ZERO: _0n$3,
        ONE: _1n$3,
        allowedLengths: allowedLengths,
        create: (num) => mod(num, ORDER),
        isValid: (num) => {
            if (typeof num !== 'bigint')
                throw new Error('invalid field element: expected bigint, got ' + typeof num);
            return _0n$3 <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num) => num === _0n$3,
        // is valid and invertible
        isValidNot0: (num) => !f.is0(num) && f.isValid(num),
        isOdd: (num) => (num & _1n$3) === _1n$3,
        neg: (num) => mod(-num, ORDER),
        eql: (lhs, rhs) => lhs === rhs,
        sqr: (num) => mod(num * num, ORDER),
        add: (lhs, rhs) => mod(lhs + rhs, ORDER),
        sub: (lhs, rhs) => mod(lhs - rhs, ORDER),
        mul: (lhs, rhs) => mod(lhs * rhs, ORDER),
        pow: (num, power) => FpPow(f, num, power),
        div: (lhs, rhs) => mod(lhs * invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num) => num * num,
        addN: (lhs, rhs) => lhs + rhs,
        subN: (lhs, rhs) => lhs - rhs,
        mulN: (lhs, rhs) => lhs * rhs,
        inv: (num) => invert(num, ORDER),
        sqrt: _sqrt ||
            ((n) => {
                if (!sqrtP)
                    sqrtP = FpSqrt(ORDER);
                return sqrtP(f, n);
            }),
        toBytes: (num) => (isLE ? numberToBytesLE(num, BYTES) : numberToBytesBE(num, BYTES)),
        fromBytes: (bytes, skipValidation = true) => {
            if (allowedLengths) {
                if (!allowedLengths.includes(bytes.length) || bytes.length > BYTES) {
                    throw new Error('Field.fromBytes: expected ' + allowedLengths + ' bytes, got ' + bytes.length);
                }
                const padded = new Uint8Array(BYTES);
                // isLE add 0 to right, !isLE to the left.
                padded.set(bytes, isLE ? 0 : padded.length - bytes.length);
                bytes = padded;
            }
            if (bytes.length !== BYTES)
                throw new Error('Field.fromBytes: expected ' + BYTES + ' bytes, got ' + bytes.length);
            let scalar = isLE ? bytesToNumberLE(bytes) : bytesToNumberBE(bytes);
            if (modFromBytes)
                scalar = mod(scalar, ORDER);
            if (!skipValidation)
                if (!f.isValid(scalar))
                    throw new Error('invalid field element: outside of range 0..ORDER');
            // NOTE: we don't validate scalar here, please use isValid. This done such way because some
            // protocol may allow non-reduced scalar that reduced later or changed some other way.
            return scalar;
        },
        // TODO: we don't need it here, move out to separate fn
        invertBatch: (lst) => FpInvertBatch(f, lst),
        // We can't move this out because Fp6, Fp12 implement it
        // and it's unclear what to return in there.
        cmov: (a, b, c) => (c ? b : a),
    });
    return Object.freeze(f);
}
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */
function getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== 'bigint')
        throw new Error('field order must be bigint');
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */
function getMinHashLength(fieldOrder) {
    const length = getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */
function mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = getFieldBytesLength(fieldOrder);
    const minLen = getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024)
        throw new Error('expected ' + minLen + '-1024 bytes of input, got ' + len);
    const num = isLE ? bytesToNumberLE(key) : bytesToNumberBE(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = mod(num, fieldOrder - _1n$3) + _1n$3;
    return isLE ? numberToBytesLE(reduced, fieldLen) : numberToBytesBE(reduced, fieldLen);
}

/**
 * Methods for elliptic curve multiplication by scalars.
 * Contains wNAF, pippenger.
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n$2 = BigInt(0);
const _1n$2 = BigInt(1);
function negateCt(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
/**
 * Takes a bunch of Projective Points but executes only one
 * inversion on all of them. Inversion is very slow operation,
 * so this improves performance massively.
 * Optimization: converts a list of projective points to a list of identical points with Z=1.
 */
function normalizeZ(c, points) {
    const invertedZs = FpInvertBatch(c.Fp, points.map((p) => p.Z));
    return points.map((p, i) => c.fromAffine(p.toAffine(invertedZs[i])));
}
function validateW(W, bits) {
    if (!Number.isSafeInteger(W) || W <= 0 || W > bits)
        throw new Error('invalid window size, expected [1..' + bits + '], got W=' + W);
}
function calcWOpts(W, scalarBits) {
    validateW(W, scalarBits);
    const windows = Math.ceil(scalarBits / W) + 1; // W=8 33. Not 32, because we skip zero
    const windowSize = 2 ** (W - 1); // W=8 128. Not 256, because we skip zero
    const maxNumber = 2 ** W; // W=8 256
    const mask = bitMask(W); // W=8 255 == mask 0b11111111
    const shiftBy = BigInt(W); // W=8 8
    return { windows, windowSize, mask, maxNumber, shiftBy };
}
function calcOffsets(n, window, wOpts) {
    const { windowSize, mask, maxNumber, shiftBy } = wOpts;
    let wbits = Number(n & mask); // extract W bits.
    let nextN = n >> shiftBy; // shift number by W bits.
    // What actually happens here:
    // const highestBit = Number(mask ^ (mask >> 1n));
    // let wbits2 = wbits - 1; // skip zero
    // if (wbits2 & highestBit) { wbits2 ^= Number(mask); // (~);
    // split if bits > max: +224 => 256-32
    if (wbits > windowSize) {
        // we skip zero, which means instead of `>= size-1`, we do `> size`
        wbits -= maxNumber; // -32, can be maxNumber - wbits, but then we need to set isNeg here.
        nextN += _1n$2; // +256 (carry)
    }
    const offsetStart = window * windowSize;
    const offset = offsetStart + Math.abs(wbits) - 1; // -1 because we skip zero
    const isZero = wbits === 0; // is current window slice a 0?
    const isNeg = wbits < 0; // is current window slice negative?
    const isNegF = window % 2 !== 0; // fake random statement for noise
    const offsetF = offsetStart; // fake offset for noise
    return { nextN, offset, isZero, isNeg, isNegF, offsetF };
}
function validateMSMPoints(points, c) {
    if (!Array.isArray(points))
        throw new Error('array expected');
    points.forEach((p, i) => {
        if (!(p instanceof c))
            throw new Error('invalid point at index ' + i);
    });
}
function validateMSMScalars(scalars, field) {
    if (!Array.isArray(scalars))
        throw new Error('array of scalars expected');
    scalars.forEach((s, i) => {
        if (!field.isValid(s))
            throw new Error('invalid scalar at index ' + i);
    });
}
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes.
// Allows to make points frozen / immutable.
const pointPrecomputes = new WeakMap();
const pointWindowSizes = new WeakMap();
function getW(P) {
    // To disable precomputes:
    // return 1;
    return pointWindowSizes.get(P) || 1;
}
function assert0(n) {
    if (n !== _0n$2)
        throw new Error('invalid wNAF');
}
/**
 * Elliptic curve multiplication of Point by scalar. Fragile.
 * Table generation takes **30MB of ram and 10ms on high-end CPU**,
 * but may take much longer on slow devices. Actual generation will happen on
 * first call of `multiply()`. By default, `BASE` point is precomputed.
 *
 * Scalars should always be less than curve order: this should be checked inside of a curve itself.
 * Creates precomputation tables for fast multiplication:
 * - private scalar is split by fixed size windows of W bits
 * - every window point is collected from window's table & added to accumulator
 * - since windows are different, same point inside tables won't be accessed more than once per calc
 * - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
 * - +1 window is neccessary for wNAF
 * - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
 *
 * @todo Research returning 2d JS array of windows, instead of a single window.
 * This would allow windows to be in different memory locations
 */
class wNAF {
    // Parametrized with a given Point class (not individual point)
    constructor(Point, bits) {
        this.BASE = Point.BASE;
        this.ZERO = Point.ZERO;
        this.Fn = Point.Fn;
        this.bits = bits;
    }
    // non-const time multiplication ladder
    _unsafeLadder(elm, n, p = this.ZERO) {
        let d = elm;
        while (n > _0n$2) {
            if (n & _1n$2)
                p = p.add(d);
            d = d.double();
            n >>= _1n$2;
        }
        return p;
    }
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param point Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(point, W) {
        const { windows, windowSize } = calcWOpts(W, this.bits);
        const points = [];
        let p = point;
        let base = p;
        for (let window = 0; window < windows; window++) {
            base = p;
            points.push(base);
            // i=1, bc we skip 0
            for (let i = 1; i < windowSize; i++) {
                base = base.add(p);
                points.push(base);
            }
            p = base.double();
        }
        return points;
    }
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * More compact implementation:
     * https://github.com/paulmillr/noble-secp256k1/blob/47cb1669b6e506ad66b35fe7d76132ae97465da2/index.ts#L502-L541
     * @returns real and fake (for const-time) points
     */
    wNAF(W, precomputes, n) {
        // Scalar should be smaller than field order
        if (!this.Fn.isValid(n))
            throw new Error('invalid scalar');
        // Accumulators
        let p = this.ZERO;
        let f = this.BASE;
        // This code was first written with assumption that 'f' and 'p' will never be infinity point:
        // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
        // there is negate now: it is possible that negated element from low value
        // would be the same as high element, which will create carry into next window.
        // It's not obvious how this can fail, but still worth investigating later.
        const wo = calcWOpts(W, this.bits);
        for (let window = 0; window < wo.windows; window++) {
            // (n === _0n) is handled and not early-exited. isEven and offsetF are used for noise
            const { nextN, offset, isZero, isNeg, isNegF, offsetF } = calcOffsets(n, window, wo);
            n = nextN;
            if (isZero) {
                // bits are 0: add garbage to fake point
                // Important part for const-time getPublicKey: add random "noise" point to f.
                f = f.add(negateCt(isNegF, precomputes[offsetF]));
            }
            else {
                // bits are 1: add to result point
                p = p.add(negateCt(isNeg, precomputes[offset]));
            }
        }
        assert0(n);
        // Return both real and fake points: JIT won't eliminate f.
        // At this point there is a way to F be infinity-point even if p is not,
        // which makes it less const-time: around 1 bigint multiply.
        return { p, f };
    }
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */
    wNAFUnsafe(W, precomputes, n, acc = this.ZERO) {
        const wo = calcWOpts(W, this.bits);
        for (let window = 0; window < wo.windows; window++) {
            if (n === _0n$2)
                break; // Early-exit, skip 0 value
            const { nextN, offset, isZero, isNeg } = calcOffsets(n, window, wo);
            n = nextN;
            if (isZero) {
                // Window bits are 0: skip processing.
                // Move to next window.
                continue;
            }
            else {
                const item = precomputes[offset];
                acc = acc.add(isNeg ? item.negate() : item); // Re-using acc allows to save adds in MSM
            }
        }
        assert0(n);
        return acc;
    }
    getPrecomputes(W, point, transform) {
        // Calculate precomputes on a first run, reuse them after
        let comp = pointPrecomputes.get(point);
        if (!comp) {
            comp = this.precomputeWindow(point, W);
            if (W !== 1) {
                // Doing transform outside of if brings 15% perf hit
                if (typeof transform === 'function')
                    comp = transform(comp);
                pointPrecomputes.set(point, comp);
            }
        }
        return comp;
    }
    cached(point, scalar, transform) {
        const W = getW(point);
        return this.wNAF(W, this.getPrecomputes(W, point, transform), scalar);
    }
    unsafe(point, scalar, transform, prev) {
        const W = getW(point);
        if (W === 1)
            return this._unsafeLadder(point, scalar, prev); // For W=1 ladder is ~x2 faster
        return this.wNAFUnsafe(W, this.getPrecomputes(W, point, transform), scalar, prev);
    }
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    createCache(P, W) {
        validateW(W, this.bits);
        pointWindowSizes.set(P, W);
        pointPrecomputes.delete(P);
    }
    hasCache(elm) {
        return getW(elm) !== 1;
    }
}
/**
 * Endomorphism-specific multiplication for Koblitz curves.
 * Cost: 128 dbl, 0-256 adds.
 */
function mulEndoUnsafe(Point, point, k1, k2) {
    let acc = point;
    let p1 = Point.ZERO;
    let p2 = Point.ZERO;
    while (k1 > _0n$2 || k2 > _0n$2) {
        if (k1 & _1n$2)
            p1 = p1.add(acc);
        if (k2 & _1n$2)
            p2 = p2.add(acc);
        acc = acc.double();
        k1 >>= _1n$2;
        k2 >>= _1n$2;
    }
    return { p1, p2 };
}
/**
 * Pippenger algorithm for multi-scalar multiplication (MSM, Pa + Qb + Rc + ...).
 * 30x faster vs naive addition on L=4096, 10x faster than precomputes.
 * For N=254bit, L=1, it does: 1024 ADD + 254 DBL. For L=5: 1536 ADD + 254 DBL.
 * Algorithmically constant-time (for same L), even when 1 point + scalar, or when scalar = 0.
 * @param c Curve Point constructor
 * @param fieldN field over CURVE.N - important that it's not over CURVE.P
 * @param points array of L curve points
 * @param scalars array of L scalars (aka secret keys / bigints)
 */
function pippenger(c, fieldN, points, scalars) {
    // If we split scalars by some window (let's say 8 bits), every chunk will only
    // take 256 buckets even if there are 4096 scalars, also re-uses double.
    // TODO:
    // - https://eprint.iacr.org/2024/750.pdf
    // - https://tches.iacr.org/index.php/TCHES/article/view/10287
    // 0 is accepted in scalars
    validateMSMPoints(points, c);
    validateMSMScalars(scalars, fieldN);
    const plength = points.length;
    const slength = scalars.length;
    if (plength !== slength)
        throw new Error('arrays of points and scalars must have equal length');
    // if (plength === 0) throw new Error('array must be of length >= 2');
    const zero = c.ZERO;
    const wbits = bitLen(BigInt(plength));
    let windowSize = 1; // bits
    if (wbits > 12)
        windowSize = wbits - 3;
    else if (wbits > 4)
        windowSize = wbits - 2;
    else if (wbits > 0)
        windowSize = 2;
    const MASK = bitMask(windowSize);
    const buckets = new Array(Number(MASK) + 1).fill(zero); // +1 for zero array
    const lastBits = Math.floor((fieldN.BITS - 1) / windowSize) * windowSize;
    let sum = zero;
    for (let i = lastBits; i >= 0; i -= windowSize) {
        buckets.fill(zero);
        for (let j = 0; j < slength; j++) {
            const scalar = scalars[j];
            const wbits = Number((scalar >> BigInt(i)) & MASK);
            buckets[wbits] = buckets[wbits].add(points[j]);
        }
        let resI = zero; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for (let j = buckets.length - 1, sumI = zero; j > 0; j--) {
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0)
            for (let j = 0; j < windowSize; j++)
                sum = sum.double();
    }
    return sum;
}
function createField(order, field, isLE) {
    if (field) {
        if (field.ORDER !== order)
            throw new Error('Field.ORDER must match order: Fp == p, Fn == n');
        validateField(field);
        return field;
    }
    else {
        return Field(order, { isLE });
    }
}
/** Validates CURVE opts and creates fields */
function _createCurveFields(type, CURVE, curveOpts = {}, FpFnLE) {
    if (FpFnLE === undefined)
        FpFnLE = type === 'edwards';
    if (!CURVE || typeof CURVE !== 'object')
        throw new Error(`expected valid ${type} CURVE object`);
    for (const p of ['p', 'n', 'h']) {
        const val = CURVE[p];
        if (!(typeof val === 'bigint' && val > _0n$2))
            throw new Error(`CURVE.${p} must be positive bigint`);
    }
    const Fp = createField(CURVE.p, curveOpts.Fp, FpFnLE);
    const Fn = createField(CURVE.n, curveOpts.Fn, FpFnLE);
    const _b = 'b' ;
    const params = ['Gx', 'Gy', 'a', _b];
    for (const p of params) {
        // @ts-ignore
        if (!Fp.isValid(CURVE[p]))
            throw new Error(`CURVE.${p} must be valid field element of CURVE.Fp`);
    }
    CURVE = Object.freeze(Object.assign({}, CURVE));
    return { CURVE, Fp, Fn };
}

/**
 * Short Weierstrass curve methods. The formula is: y² = x³ + ax + b.
 *
 * ### Design rationale for types
 *
 * * Interaction between classes from different curves should fail:
 *   `k256.Point.BASE.add(p256.Point.BASE)`
 * * For this purpose we want to use `instanceof` operator, which is fast and works during runtime
 * * Different calls of `curve()` would return different classes -
 *   `curve(params) !== curve(params)`: if somebody decided to monkey-patch their curve,
 *   it won't affect others
 *
 * TypeScript can't infer types for classes created inside a function. Classes is one instance
 * of nominative types in TypeScript and interfaces only check for shape, so it's hard to create
 * unique type for every function call.
 *
 * We can use generic types via some param, like curve opts, but that would:
 *     1. Enable interaction between `curve(params)` and `curve(params)` (curves of same params)
 *     which is hard to debug.
 *     2. Params can be generic and we can't enforce them to be constant value:
 *     if somebody creates curve from non-constant params,
 *     it would be allowed to interact with other curves with non-constant params
 *
 * @todo https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-7.html#unique-symbol
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// We construct basis in such way that den is always positive and equals n, but num sign depends on basis (not on secret value)
const divNearest = (num, den) => (num + (num >= 0 ? den : -den) / _2n$2) / den;
/**
 * Splits scalar for GLV endomorphism.
 */
function _splitEndoScalar(k, basis, n) {
    // Split scalar into two such that part is ~half bits: `abs(part) < sqrt(N)`
    // Since part can be negative, we need to do this on point.
    // TODO: verifyScalar function which consumes lambda
    const [[a1, b1], [a2, b2]] = basis;
    const c1 = divNearest(b2 * k, n);
    const c2 = divNearest(-b1 * k, n);
    // |k1|/|k2| is < sqrt(N), but can be negative.
    // If we do `k1 mod N`, we'll get big scalar (`> sqrt(N)`): so, we do cheaper negation instead.
    let k1 = k - c1 * a1 - c2 * a2;
    let k2 = -c1 * b1 - c2 * b2;
    const k1neg = k1 < _0n$1;
    const k2neg = k2 < _0n$1;
    if (k1neg)
        k1 = -k1;
    if (k2neg)
        k2 = -k2;
    // Double check that resulting scalar less than half bits of N: otherwise wNAF will fail.
    // This should only happen on wrong basises. Also, math inside is too complex and I don't trust it.
    const MAX_NUM = bitMask(Math.ceil(bitLen(n) / 2)) + _1n$1; // Half bits of N
    if (k1 < _0n$1 || k1 >= MAX_NUM || k2 < _0n$1 || k2 >= MAX_NUM) {
        throw new Error('splitScalar (endomorphism): failed, k=' + k);
    }
    return { k1neg, k1, k2neg, k2 };
}
function validateSigFormat(format) {
    if (!['compact', 'recovered', 'der'].includes(format))
        throw new Error('Signature format must be "compact", "recovered", or "der"');
    return format;
}
function validateSigOpts(opts, def) {
    const optsn = {};
    for (let optName of Object.keys(def)) {
        // @ts-ignore
        optsn[optName] = opts[optName] === undefined ? def[optName] : opts[optName];
    }
    _abool2(optsn.lowS, 'lowS');
    _abool2(optsn.prehash, 'prehash');
    if (optsn.format !== undefined)
        validateSigFormat(optsn.format);
    return optsn;
}
class DERErr extends Error {
    constructor(m = '') {
        super(m);
    }
}
/**
 * ASN.1 DER encoding utilities. ASN is very complex & fragile. Format:
 *
 *     [0x30 (SEQUENCE), bytelength, 0x02 (INTEGER), intLength, R, 0x02 (INTEGER), intLength, S]
 *
 * Docs: https://letsencrypt.org/docs/a-warm-welcome-to-asn1-and-der/, https://luca.ntop.org/Teaching/Appunti/asn1.html
 */
const DER = {
    // asn.1 DER encoding utils
    Err: DERErr,
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
        encode: (tag, data) => {
            const { Err: E } = DER;
            if (tag < 0 || tag > 256)
                throw new E('tlv.encode: wrong tag');
            if (data.length & 1)
                throw new E('tlv.encode: unpadded data');
            const dataLen = data.length / 2;
            const len = numberToHexUnpadded(dataLen);
            if ((len.length / 2) & 128)
                throw new E('tlv.encode: long form length too big');
            // length of length with long form flag
            const lenLen = dataLen > 127 ? numberToHexUnpadded((len.length / 2) | 128) : '';
            const t = numberToHexUnpadded(tag);
            return t + lenLen + len + data;
        },
        // v - value, l - left bytes (unparsed)
        decode(tag, data) {
            const { Err: E } = DER;
            let pos = 0;
            if (tag < 0 || tag > 256)
                throw new E('tlv.encode: wrong tag');
            if (data.length < 2 || data[pos++] !== tag)
                throw new E('tlv.decode: wrong tlv');
            const first = data[pos++];
            const isLong = !!(first & 128); // First bit of first length byte is flag for short/long form
            let length = 0;
            if (!isLong)
                length = first;
            else {
                // Long form: [longFlag(1bit), lengthLength(7bit), length (BE)]
                const lenLen = first & 127;
                if (!lenLen)
                    throw new E('tlv.decode(long): indefinite length not supported');
                if (lenLen > 4)
                    throw new E('tlv.decode(long): byte length is too big'); // this will overflow u32 in js
                const lengthBytes = data.subarray(pos, pos + lenLen);
                if (lengthBytes.length !== lenLen)
                    throw new E('tlv.decode: length bytes not complete');
                if (lengthBytes[0] === 0)
                    throw new E('tlv.decode(long): zero leftmost byte');
                for (const b of lengthBytes)
                    length = (length << 8) | b;
                pos += lenLen;
                if (length < 128)
                    throw new E('tlv.decode(long): not minimal encoding');
            }
            const v = data.subarray(pos, pos + length);
            if (v.length !== length)
                throw new E('tlv.decode: wrong value length');
            return { v, l: data.subarray(pos + length) };
        },
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
        encode(num) {
            const { Err: E } = DER;
            if (num < _0n$1)
                throw new E('integer: negative integers are not allowed');
            let hex = numberToHexUnpadded(num);
            // Pad with zero byte if negative flag is present
            if (Number.parseInt(hex[0], 16) & 0b1000)
                hex = '00' + hex;
            if (hex.length & 1)
                throw new E('unexpected DER parsing assertion: unpadded hex');
            return hex;
        },
        decode(data) {
            const { Err: E } = DER;
            if (data[0] & 128)
                throw new E('invalid signature integer: negative');
            if (data[0] === 0x00 && !(data[1] & 128))
                throw new E('invalid signature integer: unnecessary leading zero');
            return bytesToNumberBE(data);
        },
    },
    toSig(hex) {
        // parse DER signature
        const { Err: E, _int: int, _tlv: tlv } = DER;
        const data = ensureBytes('signature', hex);
        const { v: seqBytes, l: seqLeftBytes } = tlv.decode(0x30, data);
        if (seqLeftBytes.length)
            throw new E('invalid signature: left bytes after parsing');
        const { v: rBytes, l: rLeftBytes } = tlv.decode(0x02, seqBytes);
        const { v: sBytes, l: sLeftBytes } = tlv.decode(0x02, rLeftBytes);
        if (sLeftBytes.length)
            throw new E('invalid signature: left bytes after parsing');
        return { r: int.decode(rBytes), s: int.decode(sBytes) };
    },
    hexFromSig(sig) {
        const { _tlv: tlv, _int: int } = DER;
        const rs = tlv.encode(0x02, int.encode(sig.r));
        const ss = tlv.encode(0x02, int.encode(sig.s));
        const seq = rs + ss;
        return tlv.encode(0x30, seq);
    },
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const _0n$1 = BigInt(0), _1n$1 = BigInt(1), _2n$2 = BigInt(2), _3n = BigInt(3), _4n = BigInt(4);
function _normFnElement(Fn, key) {
    const { BYTES: expected } = Fn;
    let num;
    if (typeof key === 'bigint') {
        num = key;
    }
    else {
        let bytes = ensureBytes('private key', key);
        try {
            num = Fn.fromBytes(bytes);
        }
        catch (error) {
            throw new Error(`invalid private key: expected ui8a of size ${expected}, got ${typeof key}`);
        }
    }
    if (!Fn.isValidNot0(num))
        throw new Error('invalid private key: out of range [1..N-1]');
    return num;
}
/**
 * Creates weierstrass Point constructor, based on specified curve options.
 *
 * @example
```js
const opts = {
  p: BigInt('0xffffffff00000001000000000000000000000000ffffffffffffffffffffffff'),
  n: BigInt('0xffffffff00000000ffffffffffffffffbce6faada7179e84f3b9cac2fc632551'),
  h: BigInt(1),
  a: BigInt('0xffffffff00000001000000000000000000000000fffffffffffffffffffffffc'),
  b: BigInt('0x5ac635d8aa3a93e7b3ebbd55769886bc651d06b0cc53b0f63bce3c3e27d2604b'),
  Gx: BigInt('0x6b17d1f2e12c4247f8bce6e563a440f277037d812deb33a0f4a13945d898c296'),
  Gy: BigInt('0x4fe342e2fe1a7f9b8ee7eb4a7c0f9e162bce33576b315ececbb6406837bf51f5'),
};
const p256_Point = weierstrass(opts);
```
 */
function weierstrassN(params, extraOpts = {}) {
    const validated = _createCurveFields('weierstrass', params, extraOpts);
    const { Fp, Fn } = validated;
    let CURVE = validated.CURVE;
    const { h: cofactor, n: CURVE_ORDER } = CURVE;
    _validateObject(extraOpts, {}, {
        allowInfinityPoint: 'boolean',
        clearCofactor: 'function',
        isTorsionFree: 'function',
        fromBytes: 'function',
        toBytes: 'function',
        endo: 'object',
        wrapPrivateKey: 'boolean',
    });
    const { endo } = extraOpts;
    if (endo) {
        // validateObject(endo, { beta: 'bigint', splitScalar: 'function' });
        if (!Fp.is0(CURVE.a) || typeof endo.beta !== 'bigint' || !Array.isArray(endo.basises)) {
            throw new Error('invalid endo: expected "beta": bigint and "basises": array');
        }
    }
    const lengths = getWLengths(Fp, Fn);
    function assertCompressionIsSupported() {
        if (!Fp.isOdd)
            throw new Error('compression is not supported: Field does not have .isOdd()');
    }
    // Implements IEEE P1363 point encoding
    function pointToBytes(_c, point, isCompressed) {
        const { x, y } = point.toAffine();
        const bx = Fp.toBytes(x);
        _abool2(isCompressed, 'isCompressed');
        if (isCompressed) {
            assertCompressionIsSupported();
            const hasEvenY = !Fp.isOdd(y);
            return concatBytes(pprefix(hasEvenY), bx);
        }
        else {
            return concatBytes(Uint8Array.of(0x04), bx, Fp.toBytes(y));
        }
    }
    function pointFromBytes(bytes) {
        _abytes2(bytes, undefined, 'Point');
        const { publicKey: comp, publicKeyUncompressed: uncomp } = lengths; // e.g. for 32-byte: 33, 65
        const length = bytes.length;
        const head = bytes[0];
        const tail = bytes.subarray(1);
        // No actual validation is done here: use .assertValidity()
        if (length === comp && (head === 0x02 || head === 0x03)) {
            const x = Fp.fromBytes(tail);
            if (!Fp.isValid(x))
                throw new Error('bad point: is not on curve, wrong x');
            const y2 = weierstrassEquation(x); // y² = x³ + ax + b
            let y;
            try {
                y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
            }
            catch (sqrtError) {
                const err = sqrtError instanceof Error ? ': ' + sqrtError.message : '';
                throw new Error('bad point: is not on curve, sqrt error' + err);
            }
            assertCompressionIsSupported();
            const isYOdd = Fp.isOdd(y); // (y & _1n) === _1n;
            const isHeadOdd = (head & 1) === 1; // ECDSA-specific
            if (isHeadOdd !== isYOdd)
                y = Fp.neg(y);
            return { x, y };
        }
        else if (length === uncomp && head === 0x04) {
            // TODO: more checks
            const L = Fp.BYTES;
            const x = Fp.fromBytes(tail.subarray(0, L));
            const y = Fp.fromBytes(tail.subarray(L, L * 2));
            if (!isValidXY(x, y))
                throw new Error('bad point: is not on curve');
            return { x, y };
        }
        else {
            throw new Error(`bad point: got length ${length}, expected compressed=${comp} or uncompressed=${uncomp}`);
        }
    }
    const encodePoint = extraOpts.toBytes || pointToBytes;
    const decodePoint = extraOpts.fromBytes || pointFromBytes;
    function weierstrassEquation(x) {
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x² * x
        return Fp.add(Fp.add(x3, Fp.mul(x, CURVE.a)), CURVE.b); // x³ + a * x + b
    }
    // TODO: move top-level
    /** Checks whether equation holds for given x, y: y² == x³ + ax + b */
    function isValidXY(x, y) {
        const left = Fp.sqr(y); // y²
        const right = weierstrassEquation(x); // x³ + ax + b
        return Fp.eql(left, right);
    }
    // Validate whether the passed curve params are valid.
    // Test 1: equation y² = x³ + ax + b should work for generator point.
    if (!isValidXY(CURVE.Gx, CURVE.Gy))
        throw new Error('bad curve params: generator point');
    // Test 2: discriminant Δ part should be non-zero: 4a³ + 27b² != 0.
    // Guarantees curve is genus-1, smooth (non-singular).
    const _4a3 = Fp.mul(Fp.pow(CURVE.a, _3n), _4n);
    const _27b2 = Fp.mul(Fp.sqr(CURVE.b), BigInt(27));
    if (Fp.is0(Fp.add(_4a3, _27b2)))
        throw new Error('bad curve params: a or b');
    /** Asserts coordinate is valid: 0 <= n < Fp.ORDER. */
    function acoord(title, n, banZero = false) {
        if (!Fp.isValid(n) || (banZero && Fp.is0(n)))
            throw new Error(`bad point coordinate ${title}`);
        return n;
    }
    function aprjpoint(other) {
        if (!(other instanceof Point))
            throw new Error('ProjectivePoint expected');
    }
    function splitEndoScalarN(k) {
        if (!endo || !endo.basises)
            throw new Error('no endo');
        return _splitEndoScalar(k, endo.basises, Fn.ORDER);
    }
    // Memoized toAffine / validity check. They are heavy. Points are immutable.
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (X, Y, Z) ∋ (x=X/Z, y=Y/Z)
    const toAffineMemo = memoized((p, iz) => {
        const { X, Y, Z } = p;
        // Fast-path for normalized points
        if (Fp.eql(Z, Fp.ONE))
            return { x: X, y: Y };
        const is0 = p.is0();
        // If invZ was 0, we return zero point. However we still want to execute
        // all operations, so we replace invZ with a random number, 1.
        if (iz == null)
            iz = is0 ? Fp.ONE : Fp.inv(Z);
        const x = Fp.mul(X, iz);
        const y = Fp.mul(Y, iz);
        const zz = Fp.mul(Z, iz);
        if (is0)
            return { x: Fp.ZERO, y: Fp.ZERO };
        if (!Fp.eql(zz, Fp.ONE))
            throw new Error('invZ was invalid');
        return { x, y };
    });
    // NOTE: on exception this will crash 'cached' and no value will be set.
    // Otherwise true will be return
    const assertValidMemo = memoized((p) => {
        if (p.is0()) {
            // (0, 1, 0) aka ZERO is invalid in most contexts.
            // In BLS, ZERO can be serialized, so we allow it.
            // (0, 0, 0) is invalid representation of ZERO.
            if (extraOpts.allowInfinityPoint && !Fp.is0(p.Y))
                return;
            throw new Error('bad point: ZERO');
        }
        // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
        const { x, y } = p.toAffine();
        if (!Fp.isValid(x) || !Fp.isValid(y))
            throw new Error('bad point: x or y not field elements');
        if (!isValidXY(x, y))
            throw new Error('bad point: equation left != right');
        if (!p.isTorsionFree())
            throw new Error('bad point: not in prime-order subgroup');
        return true;
    });
    function finishEndo(endoBeta, k1p, k2p, k1neg, k2neg) {
        k2p = new Point(Fp.mul(k2p.X, endoBeta), k2p.Y, k2p.Z);
        k1p = negateCt(k1neg, k1p);
        k2p = negateCt(k2neg, k2p);
        return k1p.add(k2p);
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates:(X, Y, Z) ∋ (x=X/Z, y=Y/Z).
     * Default Point works in 2d / affine coordinates: (x, y).
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */
    class Point {
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */
        constructor(X, Y, Z) {
            this.X = acoord('x', X);
            this.Y = acoord('y', Y, true);
            this.Z = acoord('z', Z);
            Object.freeze(this);
        }
        static CURVE() {
            return CURVE;
        }
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */
        static fromAffine(p) {
            const { x, y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y))
                throw new Error('invalid affine point');
            if (p instanceof Point)
                throw new Error('projective point not allowed');
            // (0, 0) would've produced (0, 0, 1) - instead, we need (0, 1, 0)
            if (Fp.is0(x) && Fp.is0(y))
                return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        static fromBytes(bytes) {
            const P = Point.fromAffine(decodePoint(_abytes2(bytes, undefined, 'point')));
            P.assertValidity();
            return P;
        }
        static fromHex(hex) {
            return Point.fromBytes(ensureBytes('pointHex', hex));
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         *
         * @param windowSize
         * @param isLazy true will defer table computation until the first multiplication
         * @returns
         */
        precompute(windowSize = 8, isLazy = true) {
            wnaf.createCache(this, windowSize);
            if (!isLazy)
                this.multiply(_3n); // random number
            return this;
        }
        // TODO: return `this`
        /** A point on curve is valid if it conforms to equation. */
        assertValidity() {
            assertValidMemo(this);
        }
        hasEvenY() {
            const { y } = this.toAffine();
            if (!Fp.isOdd)
                throw new Error("Field doesn't support isOdd");
            return !Fp.isOdd(y);
        }
        /** Compare one point to another. */
        equals(other) {
            aprjpoint(other);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const { X: X2, Y: Y2, Z: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /** Flips point to one corresponding to (x, -y) in Affine coordinates. */
        negate() {
            return new Point(this.X, Fp.neg(this.Y), this.Z);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a, b } = CURVE;
            const b3 = Fp.mul(b, _3n);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            aprjpoint(other);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const { X: X2, Y: Y2, Z: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, _3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */
        multiply(scalar) {
            const { endo } = extraOpts;
            if (!Fn.isValidNot0(scalar))
                throw new Error('invalid scalar: out of range'); // 0 is invalid
            let point, fake; // Fake point is used to const-time mult
            const mul = (n) => wnaf.cached(this, n, (p) => normalizeZ(Point, p));
            /** See docs for {@link EndomorphismOpts} */
            if (endo) {
                const { k1neg, k1, k2neg, k2 } = splitEndoScalarN(scalar);
                const { p: k1p, f: k1f } = mul(k1);
                const { p: k2p, f: k2f } = mul(k2);
                fake = k1f.add(k2f);
                point = finishEndo(endo.beta, k1p, k2p, k1neg, k2neg);
            }
            else {
                const { p, f } = mul(scalar);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return normalizeZ(Point, [point, fake])[0];
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed secret key e.g. sig verification, which works over *public* keys.
         */
        multiplyUnsafe(sc) {
            const { endo } = extraOpts;
            const p = this;
            if (!Fn.isValid(sc))
                throw new Error('invalid scalar: out of range'); // 0 is valid
            if (sc === _0n$1 || p.is0())
                return Point.ZERO;
            if (sc === _1n$1)
                return p; // fast-path
            if (wnaf.hasCache(this))
                return this.multiply(sc);
            if (endo) {
                const { k1neg, k1, k2neg, k2 } = splitEndoScalarN(sc);
                const { p1, p2 } = mulEndoUnsafe(Point, p, k1, k2); // 30% faster vs wnaf.unsafe
                return finishEndo(endo.beta, p1, p2, k1neg, k2neg);
            }
            else {
                return wnaf.unsafe(p, sc);
            }
        }
        multiplyAndAddUnsafe(Q, a, b) {
            const sum = this.multiplyUnsafe(a).add(Q.multiplyUnsafe(b));
            return sum.is0() ? undefined : sum;
        }
        /**
         * Converts Projective point to affine (x, y) coordinates.
         * @param invertedZ Z^-1 (inverted zero) - optional, precomputation is useful for invertBatch
         */
        toAffine(invertedZ) {
            return toAffineMemo(this, invertedZ);
        }
        /**
         * Checks whether Point is free of torsion elements (is in prime subgroup).
         * Always torsion-free for cofactor=1 curves.
         */
        isTorsionFree() {
            const { isTorsionFree } = extraOpts;
            if (cofactor === _1n$1)
                return true;
            if (isTorsionFree)
                return isTorsionFree(Point, this);
            return wnaf.unsafe(this, CURVE_ORDER).is0();
        }
        clearCofactor() {
            const { clearCofactor } = extraOpts;
            if (cofactor === _1n$1)
                return this; // Fast-path
            if (clearCofactor)
                return clearCofactor(Point, this);
            return this.multiplyUnsafe(cofactor);
        }
        isSmallOrder() {
            // can we use this.clearCofactor()?
            return this.multiplyUnsafe(cofactor).is0();
        }
        toBytes(isCompressed = true) {
            _abool2(isCompressed, 'isCompressed');
            this.assertValidity();
            return encodePoint(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return bytesToHex(this.toBytes(isCompressed));
        }
        toString() {
            return `<Point ${this.is0() ? 'ZERO' : this.toHex()}>`;
        }
        // TODO: remove
        get px() {
            return this.X;
        }
        get py() {
            return this.X;
        }
        get pz() {
            return this.Z;
        }
        toRawBytes(isCompressed = true) {
            return this.toBytes(isCompressed);
        }
        _setWindowSize(windowSize) {
            this.precompute(windowSize);
        }
        static normalizeZ(points) {
            return normalizeZ(Point, points);
        }
        static msm(points, scalars) {
            return pippenger(Point, Fn, points, scalars);
        }
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(_normFnElement(Fn, privateKey));
        }
    }
    // base / generator point
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    // zero / infinity / identity point
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO); // 0, 1, 0
    // math field
    Point.Fp = Fp;
    // scalar field
    Point.Fn = Fn;
    const bits = Fn.BITS;
    const wnaf = new wNAF(Point, extraOpts.endo ? Math.ceil(bits / 2) : bits);
    Point.BASE.precompute(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    return Point;
}
// Points start with byte 0x02 when y is even; otherwise 0x03
function pprefix(hasEvenY) {
    return Uint8Array.of(hasEvenY ? 0x02 : 0x03);
}
function getWLengths(Fp, Fn) {
    return {
        secretKey: Fn.BYTES,
        publicKey: 1 + Fp.BYTES,
        publicKeyUncompressed: 1 + 2 * Fp.BYTES,
        publicKeyHasPrefix: true,
        signature: 2 * Fn.BYTES,
    };
}
/**
 * Sometimes users only need getPublicKey, getSharedSecret, and secret key handling.
 * This helper ensures no signature functionality is present. Less code, smaller bundle size.
 */
function ecdh(Point, ecdhOpts = {}) {
    const { Fn } = Point;
    const randomBytes_ = ecdhOpts.randomBytes || randomBytes;
    const lengths = Object.assign(getWLengths(Point.Fp, Fn), { seed: getMinHashLength(Fn.ORDER) });
    function isValidSecretKey(secretKey) {
        try {
            return !!_normFnElement(Fn, secretKey);
        }
        catch (error) {
            return false;
        }
    }
    function isValidPublicKey(publicKey, isCompressed) {
        const { publicKey: comp, publicKeyUncompressed } = lengths;
        try {
            const l = publicKey.length;
            if (isCompressed === true && l !== comp)
                return false;
            if (isCompressed === false && l !== publicKeyUncompressed)
                return false;
            return !!Point.fromBytes(publicKey);
        }
        catch (error) {
            return false;
        }
    }
    /**
     * Produces cryptographically secure secret key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    function randomSecretKey(seed = randomBytes_(lengths.seed)) {
        return mapHashToField(_abytes2(seed, lengths.seed, 'seed'), Fn.ORDER);
    }
    /**
     * Computes public key for a secret key. Checks for validity of the secret key.
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */
    function getPublicKey(secretKey, isCompressed = true) {
        return Point.BASE.multiply(_normFnElement(Fn, secretKey)).toBytes(isCompressed);
    }
    function keygen(seed) {
        const secretKey = randomSecretKey(seed);
        return { secretKey, publicKey: getPublicKey(secretKey) };
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */
    function isProbPub(item) {
        if (typeof item === 'bigint')
            return false;
        if (item instanceof Point)
            return true;
        const { secretKey, publicKey, publicKeyUncompressed } = lengths;
        if (Fn.allowedLengths || secretKey === publicKey)
            return undefined;
        const l = ensureBytes('key', item).length;
        return l === publicKey || l === publicKeyUncompressed;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from secret key A and public key B.
     * Checks: 1) secret key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */
    function getSharedSecret(secretKeyA, publicKeyB, isCompressed = true) {
        if (isProbPub(secretKeyA) === true)
            throw new Error('first arg must be private key');
        if (isProbPub(publicKeyB) === false)
            throw new Error('second arg must be public key');
        const s = _normFnElement(Fn, secretKeyA);
        const b = Point.fromHex(publicKeyB); // checks for being on-curve
        return b.multiply(s).toBytes(isCompressed);
    }
    const utils = {
        isValidSecretKey,
        isValidPublicKey,
        randomSecretKey,
        // TODO: remove
        isValidPrivateKey: isValidSecretKey,
        randomPrivateKey: randomSecretKey,
        normPrivateKeyToScalar: (key) => _normFnElement(Fn, key),
        precompute(windowSize = 8, point = Point.BASE) {
            return point.precompute(windowSize, false);
        },
    };
    return Object.freeze({ getPublicKey, getSharedSecret, keygen, Point, utils, lengths });
}
/**
 * Creates ECDSA signing interface for given elliptic curve `Point` and `hash` function.
 * We need `hash` for 2 features:
 * 1. Message prehash-ing. NOT used if `sign` / `verify` are called with `prehash: false`
 * 2. k generation in `sign`, using HMAC-drbg(hash)
 *
 * ECDSAOpts are only rarely needed.
 *
 * @example
 * ```js
 * const p256_Point = weierstrass(...);
 * const p256_sha256 = ecdsa(p256_Point, sha256);
 * const p256_sha224 = ecdsa(p256_Point, sha224);
 * const p256_sha224_r = ecdsa(p256_Point, sha224, { randomBytes: (length) => { ... } });
 * ```
 */
function ecdsa(Point, hash, ecdsaOpts = {}) {
    ahash(hash);
    _validateObject(ecdsaOpts, {}, {
        hmac: 'function',
        lowS: 'boolean',
        randomBytes: 'function',
        bits2int: 'function',
        bits2int_modN: 'function',
    });
    const randomBytes$1 = ecdsaOpts.randomBytes || randomBytes;
    const hmac$1 = ecdsaOpts.hmac ||
        ((key, ...msgs) => hmac(hash, key, concatBytes(...msgs)));
    const { Fp, Fn } = Point;
    const { ORDER: CURVE_ORDER, BITS: fnBits } = Fn;
    const { keygen, getPublicKey, getSharedSecret, utils, lengths } = ecdh(Point, ecdsaOpts);
    const defaultSigOpts = {
        prehash: false,
        lowS: typeof ecdsaOpts.lowS === 'boolean' ? ecdsaOpts.lowS : false,
        format: undefined, //'compact' as ECDSASigFormat,
        extraEntropy: false,
    };
    const defaultSigOpts_format = 'compact';
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> _1n$1;
        return number > HALF;
    }
    function validateRS(title, num) {
        if (!Fn.isValidNot0(num))
            throw new Error(`invalid signature ${title}: out of range 1..Point.Fn.ORDER`);
        return num;
    }
    function validateSigLength(bytes, format) {
        validateSigFormat(format);
        const size = lengths.signature;
        const sizer = format === 'compact' ? size : format === 'recovered' ? size + 1 : undefined;
        return _abytes2(bytes, sizer, `${format} signature`);
    }
    /**
     * ECDSA signature with its (r, s) properties. Supports compact, recovered & DER representations.
     */
    class Signature {
        constructor(r, s, recovery) {
            this.r = validateRS('r', r); // r in [1..N-1];
            this.s = validateRS('s', s); // s in [1..N-1];
            if (recovery != null)
                this.recovery = recovery;
            Object.freeze(this);
        }
        static fromBytes(bytes, format = defaultSigOpts_format) {
            validateSigLength(bytes, format);
            let recid;
            if (format === 'der') {
                const { r, s } = DER.toSig(_abytes2(bytes));
                return new Signature(r, s);
            }
            if (format === 'recovered') {
                recid = bytes[0];
                format = 'compact';
                bytes = bytes.subarray(1);
            }
            const L = Fn.BYTES;
            const r = bytes.subarray(0, L);
            const s = bytes.subarray(L, L * 2);
            return new Signature(Fn.fromBytes(r), Fn.fromBytes(s), recid);
        }
        static fromHex(hex, format) {
            return this.fromBytes(hexToBytes(hex), format);
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(messageHash) {
            const FIELD_ORDER = Fp.ORDER;
            const { r, s, recovery: rec } = this;
            if (rec == null || ![0, 1, 2, 3].includes(rec))
                throw new Error('recovery id invalid');
            // ECDSA recovery is hard for cofactor > 1 curves.
            // In sign, `r = q.x mod n`, and here we recover q.x from r.
            // While recovering q.x >= n, we need to add r+n for cofactor=1 curves.
            // However, for cofactor>1, r+n may not get q.x:
            // r+n*i would need to be done instead where i is unknown.
            // To easily get i, we either need to:
            // a. increase amount of valid recid values (4, 5...); OR
            // b. prohibit non-prime-order signatures (recid > 1).
            const hasCofactor = CURVE_ORDER * _2n$2 < FIELD_ORDER;
            if (hasCofactor && rec > 1)
                throw new Error('recovery id is ambiguous for h>1 curve');
            const radj = rec === 2 || rec === 3 ? r + CURVE_ORDER : r;
            if (!Fp.isValid(radj))
                throw new Error('recovery id 2 or 3 invalid');
            const x = Fp.toBytes(radj);
            const R = Point.fromBytes(concatBytes(pprefix((rec & 1) === 0), x));
            const ir = Fn.inv(radj); // r^-1
            const h = bits2int_modN(ensureBytes('msgHash', messageHash)); // Truncate hash
            const u1 = Fn.create(-h * ir); // -hr^-1
            const u2 = Fn.create(s * ir); // sr^-1
            // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1). unsafe is fine: there is no private data.
            const Q = Point.BASE.multiplyUnsafe(u1).add(R.multiplyUnsafe(u2));
            if (Q.is0())
                throw new Error('point at infinify');
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        toBytes(format = defaultSigOpts_format) {
            validateSigFormat(format);
            if (format === 'der')
                return hexToBytes(DER.hexFromSig(this));
            const r = Fn.toBytes(this.r);
            const s = Fn.toBytes(this.s);
            if (format === 'recovered') {
                if (this.recovery == null)
                    throw new Error('recovery bit must be present');
                return concatBytes(Uint8Array.of(this.recovery), r, s);
            }
            return concatBytes(r, s);
        }
        toHex(format) {
            return bytesToHex(this.toBytes(format));
        }
        // TODO: remove
        assertValidity() { }
        static fromCompact(hex) {
            return Signature.fromBytes(ensureBytes('sig', hex), 'compact');
        }
        static fromDER(hex) {
            return Signature.fromBytes(ensureBytes('sig', hex), 'der');
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, Fn.neg(this.s), this.recovery) : this;
        }
        toDERRawBytes() {
            return this.toBytes('der');
        }
        toDERHex() {
            return bytesToHex(this.toBytes('der'));
        }
        toCompactRawBytes() {
            return this.toBytes('compact');
        }
        toCompactHex() {
            return bytesToHex(this.toBytes('compact'));
        }
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = ecdsaOpts.bits2int ||
        function bits2int_def(bytes) {
            // Our custom check "just in case", for protection against DoS
            if (bytes.length > 8192)
                throw new Error('input is too large');
            // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
            // for some cases, since bytes.length * 8 is not actual bitLength.
            const num = bytesToNumberBE(bytes); // check for == u8 done here
            const delta = bytes.length * 8 - fnBits; // truncate to nBitLength leftmost bits
            return delta > 0 ? num >> BigInt(delta) : num;
        };
    const bits2int_modN = ecdsaOpts.bits2int_modN ||
        function bits2int_modN_def(bytes) {
            return Fn.create(bits2int(bytes)); // can't use bytesToNumberBE here
        };
    // Pads output with zero as per spec
    const ORDER_MASK = bitMask(fnBits);
    /** Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`. */
    function int2octets(num) {
        // IMPORTANT: the check ensures working for case `Fn.BYTES != Fn.BITS * 8`
        aInRange('num < 2^' + fnBits, num, _0n$1, ORDER_MASK);
        return Fn.toBytes(num);
    }
    function validateMsgAndHash(message, prehash) {
        _abytes2(message, undefined, 'message');
        return prehash ? _abytes2(hash(message), undefined, 'prehashed message') : message;
    }
    /**
     * Steps A, D of RFC6979 3.2.
     * Creates RFC6979 seed; converts msg/privKey to numbers.
     * Used only in sign, not in verify.
     *
     * Warning: we cannot assume here that message has same amount of bytes as curve order,
     * this will be invalid at least for P521. Also it can be bigger for P224 + SHA256.
     */
    function prepSig(message, privateKey, opts) {
        if (['recovered', 'canonical'].some((k) => k in opts))
            throw new Error('sign() legacy options not supported');
        const { lowS, prehash, extraEntropy } = validateSigOpts(opts, defaultSigOpts);
        message = validateMsgAndHash(message, prehash); // RFC6979 3.2 A: h1 = H(m)
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with fnBits % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(message);
        const d = _normFnElement(Fn, privateKey); // validate secret key, convert to bigint
        const seedArgs = [int2octets(d), int2octets(h1int)];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (extraEntropy != null && extraEntropy !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            // gen random bytes OR pass as-is
            const e = extraEntropy === true ? randomBytes$1(lengths.secretKey) : extraEntropy;
            seedArgs.push(ensureBytes('extraEntropy', e)); // check for being bytes
        }
        const seed = concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        // To transform k => Signature:
        // q = k⋅G
        // r = q.x mod n
        // s = k^-1(m + rd) mod n
        // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
        // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
        // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            // Important: all mod() calls here must be done over N
            const k = bits2int(kBytes); // mod n, not mod p
            if (!Fn.isValidNot0(k))
                return; // Valid scalars (including k) must be in 1..N-1
            const ik = Fn.inv(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = k⋅G
            const r = Fn.create(q.x); // r = q.x mod n
            if (r === _0n$1)
                return;
            const s = Fn.create(ik * Fn.create(m + r * d)); // Not using blinding here, see comment above
            if (s === _0n$1)
                return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & _1n$1); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = Fn.neg(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return { seed, k2sig };
    }
    /**
     * Signs message hash with a secret key.
     *
     * ```
     * sign(m, d) where
     *   k = rfc6979_hmac_drbg(m, d)
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr) / k mod n
     * ```
     */
    function sign(message, secretKey, opts = {}) {
        message = ensureBytes('message', message);
        const { seed, k2sig } = prepSig(message, secretKey, opts); // Steps A, D of RFC6979 3.2.
        const drbg = createHmacDrbg(hash.outputLen, Fn.BYTES, hmac$1);
        const sig = drbg(seed, k2sig); // Steps B, C, D, E, F, G
        return sig;
    }
    function tryParsingSig(sg) {
        // Try to deduce format
        let sig = undefined;
        const isHex = typeof sg === 'string' || isBytes(sg);
        const isObj = !isHex &&
            sg !== null &&
            typeof sg === 'object' &&
            typeof sg.r === 'bigint' &&
            typeof sg.s === 'bigint';
        if (!isHex && !isObj)
            throw new Error('invalid signature, expected Uint8Array, hex string or Signature instance');
        if (isObj) {
            sig = new Signature(sg.r, sg.s);
        }
        else if (isHex) {
            try {
                sig = Signature.fromBytes(ensureBytes('sig', sg), 'der');
            }
            catch (derError) {
                if (!(derError instanceof DER.Err))
                    throw derError;
            }
            if (!sig) {
                try {
                    sig = Signature.fromBytes(ensureBytes('sig', sg), 'compact');
                }
                catch (error) {
                    return false;
                }
            }
        }
        if (!sig)
            return false;
        return sig;
    }
    /**
     * Verifies a signature against message and public key.
     * Rejects lowS signatures by default: see {@link ECDSAVerifyOpts}.
     * Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   u1 = hs^-1 mod n
     *   u2 = rs^-1 mod n
     *   R = u1⋅G + u2⋅P
     *   mod(R.x, n) == r
     * ```
     */
    function verify(signature, message, publicKey, opts = {}) {
        const { lowS, prehash, format } = validateSigOpts(opts, defaultSigOpts);
        publicKey = ensureBytes('publicKey', publicKey);
        message = validateMsgAndHash(ensureBytes('message', message), prehash);
        if ('strict' in opts)
            throw new Error('options.strict was renamed to lowS');
        const sig = format === undefined
            ? tryParsingSig(signature)
            : Signature.fromBytes(ensureBytes('sig', signature), format);
        if (sig === false)
            return false;
        try {
            const P = Point.fromBytes(publicKey);
            if (lowS && sig.hasHighS())
                return false;
            const { r, s } = sig;
            const h = bits2int_modN(message); // mod n, not mod p
            const is = Fn.inv(s); // s^-1 mod n
            const u1 = Fn.create(h * is); // u1 = hs^-1 mod n
            const u2 = Fn.create(r * is); // u2 = rs^-1 mod n
            const R = Point.BASE.multiplyUnsafe(u1).add(P.multiplyUnsafe(u2)); // u1⋅G + u2⋅P
            if (R.is0())
                return false;
            const v = Fn.create(R.x); // v = r.x mod n
            return v === r;
        }
        catch (e) {
            return false;
        }
    }
    function recoverPublicKey(signature, message, opts = {}) {
        const { prehash } = validateSigOpts(opts, defaultSigOpts);
        message = validateMsgAndHash(message, prehash);
        return Signature.fromBytes(signature, 'recovered').recoverPublicKey(message).toBytes();
    }
    return Object.freeze({
        keygen,
        getPublicKey,
        getSharedSecret,
        utils,
        lengths,
        Point,
        sign,
        verify,
        recoverPublicKey,
        Signature,
        hash,
    });
}
function _weierstrass_legacy_opts_to_new(c) {
    const CURVE = {
        a: c.a,
        b: c.b,
        p: c.Fp.ORDER,
        n: c.n,
        h: c.h,
        Gx: c.Gx,
        Gy: c.Gy,
    };
    const Fp = c.Fp;
    let allowedLengths = c.allowedPrivateKeyLengths
        ? Array.from(new Set(c.allowedPrivateKeyLengths.map((l) => Math.ceil(l / 2))))
        : undefined;
    const Fn = Field(CURVE.n, {
        BITS: c.nBitLength,
        allowedLengths: allowedLengths,
        modFromBytes: c.wrapPrivateKey,
    });
    const curveOpts = {
        Fp,
        Fn,
        allowInfinityPoint: c.allowInfinityPoint,
        endo: c.endo,
        isTorsionFree: c.isTorsionFree,
        clearCofactor: c.clearCofactor,
        fromBytes: c.fromBytes,
        toBytes: c.toBytes,
    };
    return { CURVE, curveOpts };
}
function _ecdsa_legacy_opts_to_new(c) {
    const { CURVE, curveOpts } = _weierstrass_legacy_opts_to_new(c);
    const ecdsaOpts = {
        hmac: c.hmac,
        randomBytes: c.randomBytes,
        lowS: c.lowS,
        bits2int: c.bits2int,
        bits2int_modN: c.bits2int_modN,
    };
    return { CURVE, curveOpts, hash: c.hash, ecdsaOpts };
}
function _ecdsa_new_output_to_legacy(c, _ecdsa) {
    const Point = _ecdsa.Point;
    return Object.assign({}, _ecdsa, {
        ProjectivePoint: Point,
        CURVE: Object.assign({}, c, nLength(Point.Fn.ORDER, Point.Fn.BITS)),
    });
}
// _ecdsa_legacy
function weierstrass(c) {
    const { CURVE, curveOpts, hash, ecdsaOpts } = _ecdsa_legacy_opts_to_new(c);
    const Point = weierstrassN(CURVE, curveOpts);
    const signs = ecdsa(Point, hash, ecdsaOpts);
    return _ecdsa_new_output_to_legacy(c, signs);
}

/**
 * Utilities for short weierstrass curves, combined with noble-hashes.
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
/** @deprecated use new `weierstrass()` and `ecdsa()` methods */
function createCurve(curveDef, defHash) {
    const create = (hash) => weierstrass({ ...curveDef, hash: hash });
    return { ...create(defHash), create };
}

/**
 * SECG secp256k1. See [pdf](https://www.secg.org/sec2-v2.pdf).
 *
 * Belongs to Koblitz curves: it has efficiently-computable GLV endomorphism ψ,
 * check out {@link EndomorphismOpts}. Seems to be rigid (not backdoored).
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// Seems like generator was produced from some seed:
// `Point.BASE.multiply(Point.Fn.inv(2n, N)).toAffine().x`
// // gives short x 0x3b78ce563f89a0ed9414f5aa28ad0d96d6795f9c63n
const secp256k1_CURVE = {
    p: BigInt('0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f'),
    n: BigInt('0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141'),
    h: BigInt(1),
    a: BigInt(0),
    b: BigInt(7),
    Gx: BigInt('0x79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798'),
    Gy: BigInt('0x483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8'),
};
const secp256k1_ENDO = {
    beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
    basises: [
        [BigInt('0x3086d221a7d46bcde86c90e49284eb15'), -BigInt('0xe4437ed6010e88286f547fa90abfe4c3')],
        [BigInt('0x114ca50f7a8e2f3f657c1108d9d44cfd8'), BigInt('0x3086d221a7d46bcde86c90e49284eb15')],
    ],
};
const _2n$1 = /* @__PURE__ */ BigInt(2);
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */
function sqrtMod(y) {
    const P = secp256k1_CURVE.p;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = (y * y * y) % P; // x^3, 11
    const b3 = (b2 * b2 * y) % P; // x^7
    const b6 = (pow2(b3, _3n, P) * b3) % P;
    const b9 = (pow2(b6, _3n, P) * b3) % P;
    const b11 = (pow2(b9, _2n$1, P) * b2) % P;
    const b22 = (pow2(b11, _11n, P) * b11) % P;
    const b44 = (pow2(b22, _22n, P) * b22) % P;
    const b88 = (pow2(b44, _44n, P) * b44) % P;
    const b176 = (pow2(b88, _88n, P) * b88) % P;
    const b220 = (pow2(b176, _44n, P) * b44) % P;
    const b223 = (pow2(b220, _3n, P) * b3) % P;
    const t1 = (pow2(b223, _23n, P) * b22) % P;
    const t2 = (pow2(t1, _6n, P) * b2) % P;
    const root = pow2(t2, _2n$1, P);
    if (!Fpk1.eql(Fpk1.sqr(root), y))
        throw new Error('Cannot find square root');
    return root;
}
const Fpk1 = Field(secp256k1_CURVE.p, { sqrt: sqrtMod });
/**
 * secp256k1 curve, ECDSA and ECDH methods.
 *
 * Field: `2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n`
 *
 * @example
 * ```js
 * import { secp256k1 } from '@noble/curves/secp256k1';
 * const { secretKey, publicKey } = secp256k1.keygen();
 * const msg = new TextEncoder().encode('hello');
 * const sig = secp256k1.sign(msg, secretKey);
 * const isValid = secp256k1.verify(sig, msg, publicKey) === true;
 * ```
 */
const secp256k1 = createCurve({ ...secp256k1_CURVE, Fp: Fpk1, lowS: true, endo: secp256k1_ENDO }, sha256);

function encodeAddress(key, ss58Format = defaults$1.prefix) {
    // decode it, this means we can re-encode an address
    const u8a = decodeAddress(key);
    if ((ss58Format < 0) || (ss58Format > 16383 && !ss58Exceptions.includes(ss58Format)) || [46, 47].includes(ss58Format)) {
        throw new Error('Out of range ss58Format specified');
    }
    else if (!defaults$1.allowedDecodedLengths.includes(u8a.length)) {
        throw new Error(`Expected a valid key to convert, with length ${defaults$1.allowedDecodedLengths.join(', ')}`);
    }
    const input = u8aConcat(ss58Format < 64
        ? [ss58Format]
        : [
            ((ss58Format & 0b0000_0000_1111_1100) >> 2) | 0b0100_0000,
            (ss58Format >> 8) | ((ss58Format & 0b0000_0000_0000_0011) << 6)
        ], u8a);
    return base58Encode(u8aConcat(input, sshash(input).subarray(0, [32, 33].includes(u8a.length) ? 2 : 1)));
}
const ss58Exceptions = [29972];

/**
 * SHA3 (keccak) hash function, based on a new "Sponge function" design.
 * Different from older hashes, the internal state is bigger than output size.
 *
 * Check out [FIPS-202](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.202.pdf),
 * [Website](https://keccak.team/keccak.html),
 * [the differences between SHA-3 and Keccak](https://crypto.stackexchange.com/questions/15727/what-are-the-key-differences-between-the-draft-sha-3-standard-and-the-keccak-sub).
 *
 * Check out `sha3-addons` module for cSHAKE, k12, and others.
 * @module
 */
// No __PURE__ annotations in sha3 header:
// EVERYTHING is in fact used on every export.
// Various per round constants calculations
const _0n = BigInt(0);
const _1n = BigInt(1);
const _2n = BigInt(2);
const _7n$1 = BigInt(7);
const _256n$1 = BigInt(256);
const _0x71n = BigInt(0x71);
const SHA3_PI = [];
const SHA3_ROTL = [];
const _SHA3_IOTA = [];
for (let round = 0, R = _1n, x = 1, y = 0; round < 24; round++) {
    // Pi
    [x, y] = [y, (2 * x + 3 * y) % 5];
    SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    SHA3_ROTL.push((((round + 1) * (round + 2)) / 2) % 64);
    // Iota
    let t = _0n;
    for (let j = 0; j < 7; j++) {
        R = ((R << _1n) ^ ((R >> _7n$1) * _0x71n)) % _256n$1;
        if (R & _2n)
            t ^= _1n << ((_1n << /* @__PURE__ */ BigInt(j)) - _1n);
    }
    _SHA3_IOTA.push(t);
}
const IOTAS = split(_SHA3_IOTA, true);
const SHA3_IOTA_H = IOTAS[0];
const SHA3_IOTA_L = IOTAS[1];
// Left rotation (without 0, 32, 64)
const rotlH = (h, l, s) => (s > 32 ? rotlBH(h, l, s) : rotlSH(h, l, s));
const rotlL = (h, l, s) => (s > 32 ? rotlBL(h, l, s) : rotlSL(h, l, s));
/** `keccakf1600` internal function, additionally allows to adjust round count. */
function keccakP(s, rounds = 24) {
    const B = new Uint32Array(5 * 2);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for (let round = 24 - rounds; round < 24; round++) {
        // Theta θ
        for (let x = 0; x < 10; x++)
            B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for (let x = 0; x < 10; x += 2) {
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for (let y = 0; y < 50; y += 10) {
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for (let t = 0; t < 24; t++) {
            const shift = SHA3_ROTL[t];
            const Th = rotlH(curH, curL, shift);
            const Tl = rotlL(curH, curL, shift);
            const PI = SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for (let y = 0; y < 50; y += 10) {
            for (let x = 0; x < 10; x++)
                B[x] = s[y + x];
            for (let x = 0; x < 10; x++)
                s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= SHA3_IOTA_H[round];
        s[1] ^= SHA3_IOTA_L[round];
    }
    clean(B);
}
/** Keccak sponge function. */
class Keccak extends Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24) {
        super();
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        this.enableXOF = false;
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        // Can be passed from user as dkLen
        anumber(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        // 0 < blockLen < 200
        if (!(0 < blockLen && blockLen < 200))
            throw new Error('only keccak-f1600 function is supported');
        this.state = new Uint8Array(200);
        this.state32 = u32$1(this.state);
    }
    clone() {
        return this._cloneInto();
    }
    keccak() {
        swap32IfBE(this.state32);
        keccakP(this.state32, this.rounds);
        swap32IfBE(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        aexists(this);
        data = toBytes(data);
        abytes(data);
        const { blockLen, state } = this;
        const len = data.length;
        for (let pos = 0; pos < len;) {
            const take = Math.min(blockLen - this.pos, len - pos);
            for (let i = 0; i < take; i++)
                state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen)
                this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished)
            return;
        this.finished = true;
        const { state, suffix, pos, blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1)
            this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        aexists(this, false);
        abytes(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen } = this;
        for (let pos = 0, len = out.length; pos < len;) {
            if (this.posOut >= blockLen)
                this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF)
            throw new Error('XOF is not possible for this instance');
        return this.writeInto(out);
    }
    xof(bytes) {
        anumber(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        aoutput(out, this);
        if (this.finished)
            throw new Error('digest() was already called');
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        clean(this.state);
    }
    _cloneInto(to) {
        const { blockLen, suffix, outputLen, rounds, enableXOF } = this;
        to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const gen = (suffix, blockLen, outputLen) => createHasher(() => new Keccak(blockLen, suffix, outputLen));
/** keccak-256 hash function. Different from SHA3-256. */
const keccak_256 = /* @__PURE__ */ (() => gen(0x01, 136, 256 / 8))();
/** keccak-512 hash function. */
const keccak_512 = /* @__PURE__ */ (() => gen(0x01, 72, 512 / 8))();

/**
 * @name keccakAsU8a
 * @summary Creates a keccak Uint8Array from the input.
 * @description
 * From either a `string` or a `Buffer` input, create the keccak and return the result as a `Uint8Array`.
 * @example
 * <BR>
 *
 * ```javascript
 * import { keccakAsU8a } from '@polkadot/util-crypto';
 *
 * keccakAsU8a('123'); // => Uint8Array
 * ```
 */
const keccakAsU8a = /*#__PURE__*/ createDualHasher({ 256: keccak256, 512: keccak512 }, { 256: keccak_256, 512: keccak_512 });

function secp256k1Expand(publicKey, onlyJs) {
    if (![33, 65].includes(publicKey.length)) {
        throw new Error(`Invalid publicKey provided, received ${publicKey.length} bytes input`);
    }
    if (publicKey.length === 65) {
        return publicKey.subarray(1);
    }
    if (!hasBigInt || (isReady())) {
        return secp256k1Expand$1(publicKey).subarray(1);
    }
    const { px, py } = secp256k1.ProjectivePoint.fromHex(publicKey);
    return u8aConcat(bnToU8a(px, BN_BE_256_OPTS), bnToU8a(py, BN_BE_256_OPTS));
}

function getH160(u8a) {
    if ([33, 65].includes(u8a.length)) {
        u8a = keccakAsU8a(secp256k1Expand(u8a));
    }
    return u8a.slice(-20);
}
function ethereumEncode(addressOrPublic) {
    if (!addressOrPublic) {
        return '0x';
    }
    const u8aAddress = u8aToU8a(addressOrPublic);
    if (![20, 32, 33, 65].includes(u8aAddress.length)) {
        throw new Error(`Invalid address or publicKey provided, received ${u8aAddress.length} bytes input`);
    }
    const address = u8aToHex(getH160(u8aAddress), -1, false);
    const hash = u8aToHex(keccakAsU8a(address), -1, false);
    let result = '';
    for (let i = 0; i < 40; i++) {
        result = `${result}${parseInt(hash[i], 16) > 7 ? address[i].toUpperCase() : address[i]}`;
    }
    return `0x${result}`;
}

function isInvalidChar(char, byte) {
    return char !== (byte > 7
        ? char.toUpperCase()
        : char.toLowerCase());
}
function isEthereumChecksum(_address) {
    const address = _address.replace('0x', '');
    const hash = u8aToHex(keccakAsU8a(address.toLowerCase()), -1, false);
    for (let i = 0; i < 40; i++) {
        if (isInvalidChar(address[i], parseInt(hash[i], 16))) {
            return false;
        }
    }
    return true;
}

function isEthereumAddress(address) {
    if (!address || address.length !== 42 || !isHex(address)) {
        return false;
    }
    else if (/^(0x)?[0-9a-f]{40}$/.test(address) || /^(0x)?[0-9A-F]{40}$/.test(address)) {
        return true;
    }
    return isEthereumChecksum(address);
}

const P64_1 = BigInt$1('11400714785074694791');
const P64_2 = BigInt$1('14029467366897019727');
const P64_3 = BigInt$1('1609587929392839161');
const P64_4 = BigInt$1('9650029242287828579');
const P64_5 = BigInt$1('2870177450012600261');
const U64 = BigInt$1('0xffffffffffffffff');
const _7n = BigInt$1(7);
const _11n = BigInt$1(11);
const _12n = BigInt$1(12);
const _16n = BigInt$1(16);
const _18n = BigInt$1(18);
const _23n = BigInt$1(23);
const _27n = BigInt$1(27);
const _29n = BigInt$1(29);
const _31n = BigInt$1(31);
const _32n = BigInt$1(32);
const _33n = BigInt$1(33);
const _64n = BigInt$1(64);
const _256n = BigInt$1(256);
function rotl(a, b) {
    const c = a & U64;
    return ((c << b) | (c >> (_64n - b))) & U64;
}
function fromU8a(u8a, p, count) {
    const bigints = new Array(count);
    let offset = 0;
    for (let i = 0; i < count; i++, offset += 2) {
        bigints[i] = BigInt$1(u8a[p + offset] | (u8a[p + 1 + offset] << 8));
    }
    let result = _0n$5;
    for (let i = count - 1; i >= 0; i--) {
        result = (result << _16n) + bigints[i];
    }
    return result;
}
function init(seed, input) {
    const state = {
        seed,
        u8a: new Uint8Array(32),
        u8asize: 0,
        v1: seed + P64_1 + P64_2,
        v2: seed + P64_2,
        v3: seed,
        v4: seed - P64_1
    };
    if (input.length < 32) {
        state.u8a.set(input);
        state.u8asize = input.length;
        return state;
    }
    const limit = input.length - 32;
    let p = 0;
    if (limit >= 0) {
        const adjustV = (v) => P64_1 * rotl(v + P64_2 * fromU8a(input, p, 4), _31n);
        do {
            state.v1 = adjustV(state.v1);
            p += 8;
            state.v2 = adjustV(state.v2);
            p += 8;
            state.v3 = adjustV(state.v3);
            p += 8;
            state.v4 = adjustV(state.v4);
            p += 8;
        } while (p <= limit);
    }
    if (p < input.length) {
        state.u8a.set(input.subarray(p, input.length));
        state.u8asize = input.length - p;
    }
    return state;
}
function xxhash64(input, initSeed) {
    const { seed, u8a, u8asize, v1, v2, v3, v4 } = init(BigInt$1(initSeed), input);
    let p = 0;
    let h64 = U64 & (BigInt$1(input.length) + (input.length >= 32
        ? (((((((((rotl(v1, _1n$5) + rotl(v2, _7n) + rotl(v3, _12n) + rotl(v4, _18n)) ^ (P64_1 * rotl(v1 * P64_2, _31n))) * P64_1 + P64_4) ^ (P64_1 * rotl(v2 * P64_2, _31n))) * P64_1 + P64_4) ^ (P64_1 * rotl(v3 * P64_2, _31n))) * P64_1 + P64_4) ^ (P64_1 * rotl(v4 * P64_2, _31n))) * P64_1 + P64_4)
        : (seed + P64_5)));
    while (p <= (u8asize - 8)) {
        h64 = U64 & (P64_4 + P64_1 * rotl(h64 ^ (P64_1 * rotl(P64_2 * fromU8a(u8a, p, 4), _31n)), _27n));
        p += 8;
    }
    if ((p + 4) <= u8asize) {
        h64 = U64 & (P64_3 + P64_2 * rotl(h64 ^ (P64_1 * fromU8a(u8a, p, 2)), _23n));
        p += 4;
    }
    while (p < u8asize) {
        h64 = U64 & (P64_1 * rotl(h64 ^ (P64_5 * BigInt$1(u8a[p++])), _11n));
    }
    h64 = U64 & (P64_2 * (h64 ^ (h64 >> _33n)));
    h64 = U64 & (P64_3 * (h64 ^ (h64 >> _29n)));
    h64 = U64 & (h64 ^ (h64 >> _32n));
    const result = new Uint8Array(8);
    for (let i = 7; i >= 0; i--) {
        result[i] = Number(h64 % _256n);
        h64 = h64 / _256n;
    }
    return result;
}

/**
 * @name xxhashAsU8a
 * @summary Creates a xxhash64 u8a from the input.
 * @description
 * From either a `string`, `Uint8Array` or a `Buffer` input, create the xxhash64 and return the result as a `Uint8Array` with the specified `bitLength`.
 * @example
 * <BR>
 *
 * ```javascript
 * import { xxhashAsU8a } from '@polkadot/util-crypto';
 *
 * xxhashAsU8a('abc'); // => 0x44bc2cf5ad770999
 * ```
 */
function xxhashAsU8a(data, bitLength = 64, onlyJs) {
    const rounds = Math.ceil(bitLength / 64);
    const u8a = u8aToU8a(data);
    if (!hasBigInt || (!onlyJs && isReady())) {
        return twox(u8a, rounds);
    }
    const result = new Uint8Array(rounds * 8);
    for (let seed = 0; seed < rounds; seed++) {
        result.set(xxhash64(u8a, seed).reverse(), seed * 8);
    }
    return result;
}

const UNKNOWN = -99999;
function extend(that, name, value) {
    Object.defineProperty(that, name, {
        configurable: true,
        enumerable: false,
        value
    });
}
/**
 * @name RpcError
 * @summary Extension to the basic JS Error.
 * @description
 * The built-in JavaScript Error class is extended by adding a code to allow for Error categorization. In addition to the normal `stack`, `message`, the numeric `code` and `data` (any types) parameters are available on the object.
 * @example
 * <BR>
 *
 * ```javascript
 * const { RpcError } from '@polkadot/util');
 *
 * throw new RpcError('some message', RpcError.CODES.METHOD_NOT_FOUND); // => error.code = -32601
 * ```
 */
class RpcError extends Error {
    code;
    data;
    message;
    name;
    stack;
    constructor(message = '', code = UNKNOWN, data) {
        super();
        extend(this, 'message', String(message));
        extend(this, 'name', this.constructor.name);
        extend(this, 'data', data);
        extend(this, 'code', code);
        if (isFunction$1(Error.captureStackTrace)) {
            Error.captureStackTrace(this, this.constructor);
        }
        else {
            const { stack } = new Error(message);
            stack && extend(this, 'stack', stack);
        }
    }
    static CODES = {
        ASSERT: -90009,
        INVALID_JSONRPC: -99998,
        METHOD_NOT_FOUND: -32601, // Rust client
        UNKNOWN
    };
}

function formatErrorData(data) {
    if (isUndefined(data)) {
        return '';
    }
    const formatted = `: ${isString(data)
        ? data.replace(/Error\("/g, '').replace(/\("/g, '(').replace(/"\)/g, ')').replace(/\(/g, ', ').replace(/\)/g, '')
        : stringify(data)}`;
    // We need some sort of cut-off here since these can be very large and
    // very nested, pick a number and trim the result display to it
    return formatted.length <= 256
        ? formatted
        : `${formatted.substring(0, 255)}…`;
}
function checkError(error) {
    if (error) {
        const { code, data, message } = error;
        throw new RpcError(`${code}: ${message}${formatErrorData(data)}`, code, data);
    }
}
/** @internal */
class RpcCoder {
    #id = 0;
    decodeResponse(response) {
        if (!response || response.jsonrpc !== '2.0') {
            throw new Error('Invalid jsonrpc field in decoded object');
        }
        const isSubscription = !isUndefined(response.params) && !isUndefined(response.method);
        if (!isNumber(response.id) &&
            (!isSubscription || (!isNumber(response.params.subscription) &&
                !isString(response.params.subscription)))) {
            throw new Error('Invalid id field in decoded object');
        }
        checkError(response.error);
        if (response.result === undefined && !isSubscription) {
            throw new Error('No result found in jsonrpc response');
        }
        if (isSubscription) {
            checkError(response.params.error);
            return response.params.result;
        }
        return response.result;
    }
    encodeJson(method, params) {
        const [id, data] = this.encodeObject(method, params);
        return [id, stringify(data)];
    }
    encodeObject(method, params) {
        const id = ++this.#id;
        return [id, {
                id,
                jsonrpc: '2.0',
                method,
                params
            }];
    }
}

const WS_URL = 'ws://127.0.0.1:9944';
var defaults = {
    WS_URL
};

const DEFAULT_CAPACITY = 1024;
const DEFAULT_TTL = 30000; // 30 seconds
const MAX_TTL = 1800_000; // 30 minutes
const DISABLED_TTL = 31_536_000_000;
class LRUNode {
    key;
    #expires;
    #ttl;
    createdAt;
    next;
    prev;
    constructor(key, ttl) {
        this.key = key;
        this.#ttl = ttl;
        this.#expires = Date.now() + ttl;
        this.createdAt = Date.now();
        this.next = this.prev = this;
    }
    refresh() {
        this.#expires = Date.now() + this.#ttl;
    }
    get expiry() {
        return this.#expires;
    }
}
class LRUCache {
    capacity;
    #data = new Map();
    #refs = new Map();
    #length = 0;
    #head;
    #tail;
    #ttl;
    constructor(capacity = DEFAULT_CAPACITY, ttl = DEFAULT_TTL) {
        // Validate capacity
        if (!Number.isInteger(capacity) || capacity < 0) {
            throw new Error(`LRUCache initialization error: 'capacity' must be a non-negative integer. Received: ${capacity}`);
        }
        // Validate ttl
        if (ttl !== null && (!Number.isFinite(ttl) || ttl < 0 || ttl > MAX_TTL)) {
            throw new Error(`LRUCache initialization error: 'ttl' must be between 0 and ${MAX_TTL} ms or null to disable. Received: ${ttl}`);
        }
        this.capacity = capacity;
        ttl ? this.#ttl = ttl : this.#ttl = DISABLED_TTL;
        this.#head = this.#tail = new LRUNode('<empty>', this.#ttl);
    }
    get ttl() {
        return this.#ttl;
    }
    get length() {
        return this.#length;
    }
    get lengthData() {
        return this.#data.size;
    }
    get lengthRefs() {
        return this.#refs.size;
    }
    entries() {
        const keys = this.keys();
        const count = keys.length;
        const entries = new Array(count);
        for (let i = 0; i < count; i++) {
            const key = keys[i];
            entries[i] = [key, this.#data.get(key)];
        }
        return entries;
    }
    keys() {
        const keys = [];
        if (this.#length) {
            let curr = this.#head;
            while (curr !== this.#tail) {
                keys.push(curr.key);
                curr = curr.next;
            }
            keys.push(curr.key);
        }
        return keys;
    }
    get(key) {
        const data = this.#data.get(key);
        if (data) {
            this.#toHead(key);
            // Evict TTL once data is refreshed
            this.#evictTTL();
            return data;
        }
        this.#evictTTL();
        return null;
    }
    set(key, value) {
        if (this.#data.has(key)) {
            this.#toHead(key);
        }
        else {
            const node = new LRUNode(key, this.#ttl);
            this.#refs.set(node.key, node);
            if (this.length === 0) {
                this.#head = this.#tail = node;
            }
            else {
                this.#head.prev = node;
                node.next = this.#head;
                this.#head = node;
            }
            if (this.#length === this.capacity) {
                this.#data.delete(this.#tail.key);
                this.#refs.delete(this.#tail.key);
                this.#tail = this.#tail.prev;
                this.#tail.next = this.#head;
            }
            else {
                this.#length += 1;
            }
        }
        // Evict TTL once data is refreshed or added
        this.#evictTTL();
        this.#data.set(key, value);
    }
    #evictTTL() {
        // Find last node to keep
        // traverse map to find the expired nodes
        while (this.#tail.expiry && this.#tail.expiry < Date.now() && this.#length > 0) {
            this.#refs.delete(this.#tail.key);
            this.#data.delete(this.#tail.key);
            this.#length -= 1;
            this.#tail = this.#tail.prev;
            this.#tail.next = this.#head;
        }
        if (this.#length === 0) {
            this.#head = this.#tail = new LRUNode('<empty>', this.#ttl);
        }
    }
    #toHead(key) {
        const ref = this.#refs.get(key);
        if (ref && ref !== this.#head) {
            ref.refresh();
            ref.prev.next = ref.next;
            ref.next.prev = ref.prev;
            ref.next = this.#head;
            this.#head.prev = ref;
            this.#head = ref;
        }
    }
}

const WebSocket = xglobal.WebSocket;

const known = {
    1000: 'Normal Closure',
    1001: 'Going Away',
    1002: 'Protocol Error',
    1003: 'Unsupported Data',
    1004: '(For future)',
    1005: 'No Status Received',
    1006: 'Abnormal Closure',
    1007: 'Invalid frame payload data',
    1008: 'Policy Violation',
    1009: 'Message too big',
    1010: 'Missing Extension',
    1011: 'Internal Error',
    1012: 'Service Restart',
    1013: 'Try Again Later',
    1014: 'Bad Gateway',
    1015: 'TLS Handshake'
};
function getWSErrorString(code) {
    if (code >= 0 && code <= 999) {
        return '(Unused)';
    }
    else if (code >= 1016) {
        if (code <= 1999) {
            return '(For WebSocket standard)';
        }
        else if (code <= 2999) {
            return '(For WebSocket extensions)';
        }
        else if (code <= 3999) {
            return '(For libraries and frameworks)';
        }
        else if (code <= 4999) {
            return '(For applications)';
        }
    }
    return known[code] || '(Unknown)';
}

const ALIASES = {
    chain_finalisedHead: 'chain_finalizedHead',
    chain_subscribeFinalisedHeads: 'chain_subscribeFinalizedHeads',
    chain_unsubscribeFinalisedHeads: 'chain_unsubscribeFinalizedHeads'
};
const RETRY_DELAY = 2_500;
const DEFAULT_TIMEOUT_MS = 60 * 1000;
const TIMEOUT_INTERVAL = 5_000;
const l$b = logger('api-ws');
/** @internal Clears a Record<*> of all keys, optionally with all callback on clear */
function eraseRecord(record, cb) {
    Object.keys(record).forEach((key) => {
        if (cb) {
            cb(record[key]);
        }
        delete record[key];
    });
}
/** @internal Creates a default/empty stats object */
function defaultEndpointStats() {
    return { bytesRecv: 0, bytesSent: 0, cached: 0, errors: 0, requests: 0, subscriptions: 0, timeout: 0 };
}
/**
 * # @polkadot/rpc-provider/ws
 *
 * @name WsProvider
 *
 * @description The WebSocket Provider allows sending requests using WebSocket to a WebSocket RPC server TCP port. Unlike the [[HttpProvider]], it does support subscriptions and allows listening to events such as new blocks or balance changes.
 *
 * @example
 * <BR>
 *
 * ```javascript
 * import Api from '@polkadot/api/promise';
 * import { WsProvider } from '@polkadot/rpc-provider/ws';
 *
 * const provider = new WsProvider('ws://127.0.0.1:9944');
 * const api = new Api(provider);
 * ```
 *
 * @see [[HttpProvider]]
 */
class WsProvider {
    #callCache;
    #coder;
    #endpoints;
    #headers;
    #eventemitter;
    #handlers = {};
    #isReadyPromise;
    #stats;
    #waitingForId = {};
    #cacheCapacity;
    #ttl;
    #autoConnectMs;
    #endpointIndex;
    #endpointStats;
    #isConnected = false;
    #subscriptions = {};
    #timeoutId = null;
    #websocket;
    #timeout;
    /**
     * @param {string | string[]} endpoint The endpoint url. Usually `ws://ip:9944` or `wss://ip:9944`, may provide an array of endpoint strings.
     * @param {number | false} autoConnectMs Whether to connect automatically or not (default). Provided value is used as a delay between retries.
     * @param {Record<string, string>} headers The headers provided to the underlying WebSocket
     * @param {number} [timeout] Custom timeout value used per request . Defaults to `DEFAULT_TIMEOUT_MS`
     * @param {number} [cacheCapacity] Custom size of the WsProvider LRUCache. Defaults to `DEFAULT_CAPACITY` (1024)
     * @param {number} [cacheTtl] Custom TTL of the WsProvider LRUCache. Determines how long an object can live in the cache. Defaults to DEFAULT_TTL` (30000)
     */
    constructor(endpoint = defaults.WS_URL, autoConnectMs = RETRY_DELAY, headers = {}, timeout, cacheCapacity, cacheTtl) {
        const endpoints = Array.isArray(endpoint)
            ? endpoint
            : [endpoint];
        if (endpoints.length === 0) {
            throw new Error('WsProvider requires at least one Endpoint');
        }
        endpoints.forEach((endpoint) => {
            if (!/^(wss|ws):\/\//.test(endpoint)) {
                throw new Error(`Endpoint should start with 'ws://', received '${endpoint}'`);
            }
        });
        const ttl = cacheTtl === undefined ? DEFAULT_TTL : cacheTtl;
        this.#callCache = new LRUCache(cacheCapacity === 0 ? 0 : cacheCapacity || DEFAULT_CAPACITY, ttl);
        this.#ttl = cacheTtl;
        this.#cacheCapacity = cacheCapacity || DEFAULT_CAPACITY;
        this.#eventemitter = new EventEmitter();
        this.#autoConnectMs = autoConnectMs || 0;
        this.#coder = new RpcCoder();
        this.#endpointIndex = -1;
        this.#endpoints = endpoints;
        this.#headers = headers;
        this.#websocket = null;
        this.#stats = {
            active: { requests: 0, subscriptions: 0 },
            total: defaultEndpointStats()
        };
        this.#endpointStats = defaultEndpointStats();
        this.#timeout = timeout || DEFAULT_TIMEOUT_MS;
        if (autoConnectMs && autoConnectMs > 0) {
            this.connectWithRetry().catch(noop$1);
        }
        this.#isReadyPromise = new Promise((resolve) => {
            this.#eventemitter.once('connected', () => {
                resolve(this);
            });
        });
    }
    /**
     * @summary `true` when this provider supports subscriptions
     */
    get hasSubscriptions() {
        return true;
    }
    /**
     * @summary `true` when this provider supports clone()
     */
    get isClonable() {
        return true;
    }
    /**
     * @summary Whether the node is connected or not.
     * @return {boolean} true if connected
     */
    get isConnected() {
        return this.#isConnected;
    }
    /**
     * @description Promise that resolves the first time we are connected and loaded
     */
    get isReady() {
        return this.#isReadyPromise;
    }
    get endpoint() {
        return this.#endpoints[this.#endpointIndex];
    }
    /**
     * @description Returns a clone of the object
     */
    clone() {
        return new WsProvider(this.#endpoints);
    }
    selectEndpointIndex(endpoints) {
        return (this.#endpointIndex + 1) % endpoints.length;
    }
    /**
     * @summary Manually connect
     * @description The [[WsProvider]] connects automatically by default, however if you decided otherwise, you may
     * connect manually using this method.
     */
    // eslint-disable-next-line @typescript-eslint/require-await
    async connect() {
        if (this.#websocket) {
            throw new Error('WebSocket is already connected');
        }
        try {
            this.#endpointIndex = this.selectEndpointIndex(this.#endpoints);
            // the as here is Deno-specific - not available on the globalThis
            this.#websocket = typeof xglobal.WebSocket !== 'undefined' && isChildClass(xglobal.WebSocket, WebSocket)
                ? new WebSocket(this.endpoint)
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - WS may be an instance of ws, which supports options
                : new WebSocket(this.endpoint, undefined, {
                    headers: this.#headers
                });
            if (this.#websocket) {
                this.#websocket.onclose = this.#onSocketClose;
                this.#websocket.onerror = this.#onSocketError;
                this.#websocket.onmessage = this.#onSocketMessage;
                this.#websocket.onopen = this.#onSocketOpen;
            }
            // timeout any handlers that have not had a response
            this.#timeoutId = setInterval(() => this.#timeoutHandlers(), TIMEOUT_INTERVAL);
        }
        catch (error) {
            l$b.error(error);
            this.#emit('error', error);
            throw error;
        }
    }
    /**
     * @description Connect, never throwing an error, but rather forcing a retry
     */
    async connectWithRetry() {
        if (this.#autoConnectMs > 0) {
            try {
                await this.connect();
            }
            catch {
                setTimeout(() => {
                    this.connectWithRetry().catch(noop$1);
                }, this.#autoConnectMs);
            }
        }
    }
    /**
     * @description Manually disconnect from the connection, clearing auto-connect logic
     */
    // eslint-disable-next-line @typescript-eslint/require-await
    async disconnect() {
        // switch off autoConnect, we are in manual mode now
        this.#autoConnectMs = 0;
        try {
            if (this.#websocket) {
                // 1000 - Normal closure; the connection successfully completed
                this.#websocket.close(1000);
            }
        }
        catch (error) {
            l$b.error(error);
            this.#emit('error', error);
            throw error;
        }
    }
    /**
     * @description Returns the connection stats
     */
    get stats() {
        return {
            active: {
                requests: Object.keys(this.#handlers).length,
                subscriptions: Object.keys(this.#subscriptions).length
            },
            total: this.#stats.total
        };
    }
    /**
    * @description Returns the connection stats
    */
    get ttl() {
        return this.#ttl;
    }
    get endpointStats() {
        return this.#endpointStats;
    }
    /**
     * @summary Listens on events after having subscribed using the [[subscribe]] function.
     * @param  {ProviderInterfaceEmitted} type Event
     * @param  {ProviderInterfaceEmitCb}  sub  Callback
     * @return unsubscribe function
     */
    on(type, sub) {
        this.#eventemitter.on(type, sub);
        return () => {
            this.#eventemitter.removeListener(type, sub);
        };
    }
    /**
     * @summary Send JSON data using WebSockets to configured HTTP Endpoint or queue.
     * @param method The RPC methods to execute
     * @param params Encoded parameters as applicable for the method
     * @param subscription Subscription details (internally used)
     */
    send(method, params, isCacheable, subscription) {
        this.#endpointStats.requests++;
        this.#stats.total.requests++;
        const [id, body] = this.#coder.encodeJson(method, params);
        if (this.#cacheCapacity === 0) {
            return this.#send(id, body, method, params, subscription);
        }
        const cacheKey = isCacheable ? `${method}::${stringify(params)}` : '';
        let resultPromise = isCacheable
            ? this.#callCache.get(cacheKey)
            : null;
        if (!resultPromise) {
            resultPromise = this.#send(id, body, method, params, subscription);
            if (isCacheable) {
                this.#callCache.set(cacheKey, resultPromise);
            }
        }
        else {
            this.#endpointStats.cached++;
            this.#stats.total.cached++;
        }
        return resultPromise;
    }
    async #send(id, body, method, params, subscription) {
        return new Promise((resolve, reject) => {
            try {
                if (!this.isConnected || this.#websocket === null) {
                    throw new Error('WebSocket is not connected');
                }
                const callback = (error, result) => {
                    error
                        ? reject(error)
                        : resolve(result);
                };
                l$b.debug(() => ['calling', method, body]);
                this.#handlers[id] = {
                    callback,
                    method,
                    params,
                    start: Date.now(),
                    subscription
                };
                const bytesSent = body.length;
                this.#endpointStats.bytesSent += bytesSent;
                this.#stats.total.bytesSent += bytesSent;
                this.#websocket.send(body);
            }
            catch (error) {
                this.#endpointStats.errors++;
                this.#stats.total.errors++;
                const rpcError = error;
                const failedRequest = `\nFailed WS Request: ${JSON.stringify({ method, params })}`;
                // Provide WS Request alongside the error
                rpcError.message = `${rpcError.message}${failedRequest}`;
                reject(rpcError);
            }
        });
    }
    /**
     * @name subscribe
     * @summary Allows subscribing to a specific event.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * const provider = new WsProvider('ws://127.0.0.1:9944');
     * const rpc = new Rpc(provider);
     *
     * rpc.state.subscribeStorage([[storage.system.account, <Address>]], (_, values) => {
     *   console.log(values)
     * }).then((subscriptionId) => {
     *   console.log('balance changes subscription id: ', subscriptionId)
     * })
     * ```
     */
    subscribe(type, method, params, callback) {
        this.#endpointStats.subscriptions++;
        this.#stats.total.subscriptions++;
        // subscriptions are not cached, LRU applies to .at(<blockHash>) only
        return this.send(method, params, false, { callback, type });
    }
    /**
     * @summary Allows unsubscribing to subscriptions made with [[subscribe]].
     */
    async unsubscribe(type, method, id) {
        const subscription = `${type}::${id}`;
        // FIXME This now could happen with re-subscriptions. The issue is that with a re-sub
        // the assigned id now does not match what the API user originally received. It has
        // a slight complication in solving - since we cannot rely on the send id, but rather
        // need to find the actual subscription id to map it
        if (isUndefined(this.#subscriptions[subscription])) {
            l$b.debug(() => `Unable to find active subscription=${subscription}`);
            return false;
        }
        delete this.#subscriptions[subscription];
        try {
            return this.isConnected && !isNull(this.#websocket)
                ? this.send(method, [id])
                : true;
        }
        catch {
            return false;
        }
    }
    #emit = (type, ...args) => {
        this.#eventemitter.emit(type, ...args);
    };
    #onSocketClose = (event) => {
        const error = new Error(`disconnected from ${this.endpoint}: ${event.code}:: ${event.reason || getWSErrorString(event.code)}`);
        if (this.#autoConnectMs > 0) {
            l$b.error(error.message);
        }
        this.#isConnected = false;
        if (this.#websocket) {
            this.#websocket.onclose = null;
            this.#websocket.onerror = null;
            this.#websocket.onmessage = null;
            this.#websocket.onopen = null;
            this.#websocket = null;
        }
        if (this.#timeoutId) {
            clearInterval(this.#timeoutId);
            this.#timeoutId = null;
        }
        // reject all hanging requests
        eraseRecord(this.#handlers, (h) => {
            try {
                h.callback(error, undefined);
            }
            catch (err) {
                // does not throw
                l$b.error(err);
            }
        });
        eraseRecord(this.#waitingForId);
        // Reset stats for active endpoint
        this.#endpointStats = defaultEndpointStats();
        this.#emit('disconnected');
        if (this.#autoConnectMs > 0) {
            setTimeout(() => {
                this.connectWithRetry().catch(noop$1);
            }, this.#autoConnectMs);
        }
    };
    #onSocketError = (error) => {
        l$b.debug(() => ['socket error', error]);
        this.#emit('error', error);
    };
    #onSocketMessage = (message) => {
        l$b.debug(() => ['received', message.data]);
        const bytesRecv = message.data.length;
        this.#endpointStats.bytesRecv += bytesRecv;
        this.#stats.total.bytesRecv += bytesRecv;
        const response = JSON.parse(message.data);
        return isUndefined(response.method)
            ? this.#onSocketMessageResult(response)
            : this.#onSocketMessageSubscribe(response);
    };
    #onSocketMessageResult = (response) => {
        const handler = this.#handlers[response.id];
        if (!handler) {
            l$b.debug(() => `Unable to find handler for id=${response.id}`);
            return;
        }
        try {
            const { method, params, subscription } = handler;
            const result = this.#coder.decodeResponse(response);
            // first send the result - in case of subs, we may have an update
            // immediately if we have some queued results already
            handler.callback(null, result);
            if (subscription) {
                const subId = `${subscription.type}::${result}`;
                this.#subscriptions[subId] = objectSpread({}, subscription, {
                    method,
                    params
                });
                // if we have a result waiting for this subscription already
                if (this.#waitingForId[subId]) {
                    this.#onSocketMessageSubscribe(this.#waitingForId[subId]);
                }
            }
        }
        catch (error) {
            this.#endpointStats.errors++;
            this.#stats.total.errors++;
            handler.callback(error, undefined);
        }
        delete this.#handlers[response.id];
    };
    #onSocketMessageSubscribe = (response) => {
        if (!response.method) {
            throw new Error('No method found in JSONRPC response');
        }
        const method = ALIASES[response.method] || response.method;
        const subId = `${method}::${response.params.subscription}`;
        const handler = this.#subscriptions[subId];
        if (!handler) {
            // store the JSON, we could have out-of-order subid coming in
            this.#waitingForId[subId] = response;
            l$b.debug(() => `Unable to find handler for subscription=${subId}`);
            return;
        }
        // housekeeping
        delete this.#waitingForId[subId];
        try {
            const result = this.#coder.decodeResponse(response);
            handler.callback(null, result);
        }
        catch (error) {
            this.#endpointStats.errors++;
            this.#stats.total.errors++;
            handler.callback(error, undefined);
        }
    };
    #onSocketOpen = () => {
        if (this.#websocket === null) {
            throw new Error('WebSocket cannot be null in onOpen');
        }
        l$b.debug(() => ['connected to', this.endpoint]);
        this.#isConnected = true;
        this.#resubscribe();
        this.#emit('connected');
        return true;
    };
    #resubscribe = () => {
        const subscriptions = this.#subscriptions;
        this.#subscriptions = {};
        Promise.all(Object.keys(subscriptions).map(async (id) => {
            const { callback, method, params, type } = subscriptions[id];
            // only re-create subscriptions which are not in author (only area where
            // transactions are created, i.e. submissions such as 'author_submitAndWatchExtrinsic'
            // are not included (and will not be re-broadcast)
            if (type.startsWith('author_')) {
                return;
            }
            try {
                await this.subscribe(type, method, params, callback);
            }
            catch (error) {
                l$b.error(error);
            }
        })).catch(l$b.error);
    };
    #timeoutHandlers = () => {
        const now = Date.now();
        const ids = Object.keys(this.#handlers);
        for (let i = 0, count = ids.length; i < count; i++) {
            const handler = this.#handlers[ids[i]];
            if ((now - handler.start) > this.#timeout) {
                try {
                    handler.callback(new Error(`No response received from RPC endpoint in ${this.#timeout / 1000}s`), undefined);
                }
                catch {
                    // ignore
                }
                this.#endpointStats.timeout++;
                this.#stats.total.timeout++;
                delete this.#handlers[ids[i]];
            }
        }
    };
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
    function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
    function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function isFunction(value) {
    return typeof value === 'function';
}

function createErrorClass(createImpl) {
    var _super = function (instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

var UnsubscriptionError = createErrorClass(function (_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors
            ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ')
            : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});

function arrRemove(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

var Subscription = (function () {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function () {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) {
                    try {
                        for (var _parentage_1 = __values(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()) {
                            var parent_1 = _parentage_1_1.value;
                            parent_1.remove(this);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                else {
                    _parentage.remove(this);
                }
            }
            var initialFinalizer = this.initialTeardown;
            if (isFunction(initialFinalizer)) {
                try {
                    initialFinalizer();
                }
                catch (e) {
                    errors = e instanceof UnsubscriptionError ? e.errors : [e];
                }
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for (var _finalizers_1 = __values(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()) {
                        var finalizer = _finalizers_1_1.value;
                        try {
                            execFinalizer(finalizer);
                        }
                        catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof UnsubscriptionError) {
                                errors = __spreadArray(__spreadArray([], __read(errors)), __read(err.errors));
                            }
                            else {
                                errors.push(err);
                            }
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
            if (errors) {
                throw new UnsubscriptionError(errors);
            }
        }
    };
    Subscription.prototype.add = function (teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) {
                execFinalizer(teardown);
            }
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) {
                        return;
                    }
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function (parent) {
        var _parentage = this._parentage;
        return _parentage === parent || (Array.isArray(_parentage) && _parentage.includes(parent));
    };
    Subscription.prototype._addParent = function (parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [_parentage, parent] : parent;
    };
    Subscription.prototype._removeParent = function (parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) {
            this._parentage = null;
        }
        else if (Array.isArray(_parentage)) {
            arrRemove(_parentage, parent);
        }
    };
    Subscription.prototype.remove = function (teardown) {
        var _finalizers = this._finalizers;
        _finalizers && arrRemove(_finalizers, teardown);
        if (teardown instanceof Subscription) {
            teardown._removeParent(this);
        }
    };
    Subscription.EMPTY = (function () {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    })();
    return Subscription;
}());
var EMPTY_SUBSCRIPTION = Subscription.EMPTY;
function isSubscription(value) {
    return (value instanceof Subscription ||
        (value && 'closed' in value && isFunction(value.remove) && isFunction(value.add) && isFunction(value.unsubscribe)));
}
function execFinalizer(finalizer) {
    if (isFunction(finalizer)) {
        finalizer();
    }
    else {
        finalizer.unsubscribe();
    }
}

var config = {
    Promise: undefined};

var timeoutProvider = {
    setTimeout: function (handler, timeout) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        return setTimeout.apply(void 0, __spreadArray([handler, timeout], __read(args)));
    },
    clearTimeout: function (handle) {
        return (clearTimeout)(handle);
    },
    delegate: undefined,
};

function reportUnhandledError(err) {
    timeoutProvider.setTimeout(function () {
        {
            throw err;
        }
    });
}

function noop() { }

function errorContext(cb) {
    {
        cb();
    }
}

var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if (isSubscription(destination)) {
                destination.add(_this);
            }
        }
        else {
            _this.destination = EMPTY_OBSERVER;
        }
        return _this;
    }
    Subscriber.create = function (next, error, complete) {
        return new SafeSubscriber(next, error, complete);
    };
    Subscriber.prototype.next = function (value) {
        if (this.isStopped) ;
        else {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (this.isStopped) ;
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function () {
        if (this.isStopped) ;
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        try {
            this.destination.error(err);
        }
        finally {
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function () {
        try {
            this.destination.complete();
        }
        finally {
            this.unsubscribe();
        }
    };
    return Subscriber;
}(Subscription));
var ConsumerObserver = (function () {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function (value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) {
            try {
                partialObserver.next(value);
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
    };
    ConsumerObserver.prototype.error = function (err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) {
            try {
                partialObserver.error(err);
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
        else {
            handleUnhandledError(err);
        }
    };
    ConsumerObserver.prototype.complete = function () {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) {
            try {
                partialObserver.complete();
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
    };
    return ConsumerObserver;
}());
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if (isFunction(observerOrNext) || !observerOrNext) {
            partialObserver = {
                next: (observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined),
                error: error !== null && error !== void 0 ? error : undefined,
                complete: complete !== null && complete !== void 0 ? complete : undefined,
            };
        }
        else {
            {
                partialObserver = observerOrNext;
            }
        }
        _this.destination = new ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}(Subscriber));
function handleUnhandledError(error) {
    {
        reportUnhandledError(error);
    }
}
function defaultErrorHandler(err) {
    throw err;
}
var EMPTY_OBSERVER = {
    closed: true,
    next: noop,
    error: defaultErrorHandler,
    complete: noop,
};

var observable = (function () { return (typeof Symbol === 'function' && Symbol.observable) || '@@observable'; })();

function identity$1(x) {
    return x;
}

function pipeFromArray(fns) {
    if (fns.length === 0) {
        return identity$1;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}

var Observable = (function () {
    function Observable(subscribe) {
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var _this = this;
        var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new SafeSubscriber(observerOrNext, error, complete);
        errorContext(function () {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator
                ?
                    operator.call(subscriber, source)
                : source
                    ?
                        _this._subscribe(subscriber)
                    :
                        _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var subscriber = new SafeSubscriber({
                next: function (value) {
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve,
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[observable] = function () {
        return this;
    };
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        return pipeFromArray(operations)(this);
    };
    Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return (value = x); }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
function getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : config.Promise) !== null && _a !== void 0 ? _a : Promise;
}
function isObserver(value) {
    return value && isFunction(value.next) && isFunction(value.error) && isFunction(value.complete);
}
function isSubscriber(value) {
    return (value && value instanceof Subscriber) || (isObserver(value) && isSubscription(value));
}

function hasLift(source) {
    return isFunction(source === null || source === void 0 ? void 0 : source.lift);
}
function operate(init) {
    return function (source) {
        if (hasLift(source)) {
            return source.lift(function (liftedSource) {
                try {
                    return init(liftedSource, this);
                }
                catch (err) {
                    this.error(err);
                }
            });
        }
        throw new TypeError('Unable to lift unknown Observable type');
    };
}

function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
    return new OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
}
var OperatorSubscriber = (function (_super) {
    __extends(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext
            ? function (value) {
                try {
                    onNext(value);
                }
                catch (err) {
                    destination.error(err);
                }
            }
            : _super.prototype._next;
        _this._error = onError
            ? function (err) {
                try {
                    onError(err);
                }
                catch (err) {
                    destination.error(err);
                }
                finally {
                    this.unsubscribe();
                }
            }
            : _super.prototype._error;
        _this._complete = onComplete
            ? function () {
                try {
                    onComplete();
                }
                catch (err) {
                    destination.error(err);
                }
                finally {
                    this.unsubscribe();
                }
            }
            : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function () {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 ? void 0 : _a.call(this));
        }
    };
    return OperatorSubscriber;
}(Subscriber));

function refCount() {
    return operate(function (source, subscriber) {
        var connection = null;
        source._refCount++;
        var refCounter = createOperatorSubscriber(subscriber, undefined, undefined, undefined, function () {
            if (!source || source._refCount <= 0 || 0 < --source._refCount) {
                connection = null;
                return;
            }
            var sharedConnection = source._connection;
            var conn = connection;
            connection = null;
            if (sharedConnection && (!conn || sharedConnection === conn)) {
                sharedConnection.unsubscribe();
            }
            subscriber.unsubscribe();
        });
        source.subscribe(refCounter);
        if (!refCounter.closed) {
            connection = source.connect();
        }
    });
}

var ConnectableObservable = (function (_super) {
    __extends(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._subject = null;
        _this._refCount = 0;
        _this._connection = null;
        if (hasLift(source)) {
            _this.lift = source.lift;
        }
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype._teardown = function () {
        this._refCount = 0;
        var _connection = this._connection;
        this._subject = this._connection = null;
        _connection === null || _connection === void 0 ? void 0 : _connection.unsubscribe();
    };
    ConnectableObservable.prototype.connect = function () {
        var _this = this;
        var connection = this._connection;
        if (!connection) {
            connection = this._connection = new Subscription();
            var subject_1 = this.getSubject();
            connection.add(this.source.subscribe(createOperatorSubscriber(subject_1, undefined, function () {
                _this._teardown();
                subject_1.complete();
            }, function (err) {
                _this._teardown();
                subject_1.error(err);
            }, function () { return _this._teardown(); })));
            if (connection.closed) {
                this._connection = null;
                connection = Subscription.EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return refCount()(this);
    };
    return ConnectableObservable;
}(Observable));

var ObjectUnsubscribedError = createErrorClass(function (_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});

var Subject = (function (_super) {
    __extends(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function () {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
    };
    Subject.prototype.next = function (value) {
        var _this = this;
        errorContext(function () {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) {
                    _this.currentObservers = Array.from(_this.observers);
                }
                try {
                    for (var _b = __values(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var observer = _c.value;
                        observer.next(value);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        });
    };
    Subject.prototype.error = function (err) {
        var _this = this;
        errorContext(function () {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while (observers.length) {
                    observers.shift().error(err);
                }
            }
        });
    };
    Subject.prototype.complete = function () {
        var _this = this;
        errorContext(function () {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while (observers.length) {
                    observers.shift().complete();
                }
            }
        });
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function () {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function (subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function (subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function (subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) {
            return EMPTY_SUBSCRIPTION;
        }
        this.currentObservers = null;
        observers.push(subscriber);
        return new Subscription(function () {
            _this.currentObservers = null;
            arrRemove(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function (subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) {
            subscriber.error(thrownError);
        }
        else if (isStopped) {
            subscriber.complete();
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(Observable));
var AnonymousSubject = (function (_super) {
    __extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function (value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function (err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function () {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : EMPTY_SUBSCRIPTION;
    };
    return AnonymousSubject;
}(Subject));

var BehaviorSubject = (function (_super) {
    __extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) {
            throw thrownError;
        }
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, (this._value = value));
    };
    return BehaviorSubject;
}(Subject));

var dateTimestampProvider = {
    now: function () {
        return (dateTimestampProvider.delegate || Date).now();
    },
    delegate: undefined,
};

var ReplaySubject = (function (_super) {
    __extends(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) { _bufferSize = Infinity; }
        if (_windowTime === void 0) { _windowTime = Infinity; }
        if (_timestampProvider === void 0) { _timestampProvider = dateTimestampProvider; }
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function (value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function (subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for (var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2) {
            subscriber.next(copy[i]);
        }
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function () {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for (var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2) {
                last = i;
            }
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}(Subject));

var Action = (function (_super) {
    __extends(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function (state, delay) {
        return this;
    };
    return Action;
}(Subscription));

var intervalProvider = {
    setInterval: function (handler, timeout) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        return setInterval.apply(void 0, __spreadArray([handler, timeout], __read(args)));
    },
    clearInterval: function (handle) {
        return (clearInterval)(handle);
    },
    delegate: undefined,
};

var AsyncAction = (function (_super) {
    __extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        var _a;
        if (delay === void 0) { delay = 0; }
        if (this.closed) {
            return this;
        }
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, _id, delay) {
        if (delay === void 0) { delay = 0; }
        return intervalProvider.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (_scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay != null && this.delay === delay && this.pending === false) {
            return id;
        }
        if (id != null) {
            intervalProvider.clearInterval(id);
        }
        return undefined;
    };
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function () {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            arrRemove(actions, this);
            if (id != null) {
                this.id = this.recycleAsyncId(scheduler, id, null);
            }
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}(Action));

var nextHandle = 1;
var resolved;
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
var Immediate = {
    setImmediate: function (cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        if (!resolved) {
            resolved = Promise.resolve();
        }
        resolved.then(function () { return findAndClearHandle(handle) && cb(); });
        return handle;
    },
    clearImmediate: function (handle) {
        findAndClearHandle(handle);
    },
};

var setImmediate = Immediate.setImmediate, clearImmediate = Immediate.clearImmediate;
var immediateProvider = {
    setImmediate: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (setImmediate).apply(void 0, __spreadArray([], __read(args)));
    },
    clearImmediate: function (handle) {
        return (clearImmediate)(handle);
    },
    delegate: undefined,
};

var AsapAction = (function (_super) {
    __extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = immediateProvider.setImmediate(scheduler.flush.bind(scheduler, undefined)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        var _a;
        if (delay === void 0) { delay = 0; }
        if (delay != null ? delay > 0 : this.delay > 0) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        var actions = scheduler.actions;
        if (id != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
            immediateProvider.clearImmediate(id);
            if (scheduler._scheduled === id) {
                scheduler._scheduled = undefined;
            }
        }
        return undefined;
    };
    return AsapAction;
}(AsyncAction));

var Scheduler = (function () {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) { now = Scheduler.now; }
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) { delay = 0; }
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = dateTimestampProvider.now;
    return Scheduler;
}());

var AsyncScheduler = (function (_super) {
    __extends(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) { now = Scheduler.now; }
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if ((error = action.execute(action.state, action.delay))) {
                break;
            }
        } while ((action = actions.shift()));
        this._active = false;
        if (error) {
            while ((action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(Scheduler));

var AsapScheduler = (function (_super) {
    __extends(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function (action) {
        this._active = true;
        var flushId = this._scheduled;
        this._scheduled = undefined;
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
            if ((error = action.execute(action.state, action.delay))) {
                break;
            }
        } while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
            while ((action = actions[0]) && action.id === flushId && actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsapScheduler;
}(AsyncScheduler));

var asapScheduler = new AsapScheduler(AsapAction);

var EMPTY = new Observable(function (subscriber) { return subscriber.complete(); });

function isScheduler(value) {
    return value && isFunction(value.schedule);
}

function last(arr) {
    return arr[arr.length - 1];
}
function popResultSelector(args) {
    return isFunction(last(args)) ? args.pop() : undefined;
}
function popScheduler(args) {
    return isScheduler(last(args)) ? args.pop() : undefined;
}

var isArrayLike$1 = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });

function isPromise(value) {
    return isFunction(value === null || value === void 0 ? void 0 : value.then);
}

function isInteropObservable(input) {
    return isFunction(input[observable]);
}

function isAsyncIterable(obj) {
    return Symbol.asyncIterator && isFunction(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

function createInvalidObservableTypeError(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
var iterator = getSymbolIterator();

function isIterable(input) {
    return isFunction(input === null || input === void 0 ? void 0 : input[iterator]);
}

function readableStreamLikeToAsyncGenerator(readableStream) {
    return __asyncGenerator(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 9, 10]);
                    _b.label = 2;
                case 2:
                    return [4, __await(reader.read())];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [3, 5];
                    return [4, __await(void 0)];
                case 4: return [2, _b.sent()];
                case 5: return [4, __await(value)];
                case 6: return [4, _b.sent()];
                case 7:
                    _b.sent();
                    return [3, 2];
                case 8: return [3, 10];
                case 9:
                    reader.releaseLock();
                    return [7];
                case 10: return [2];
            }
        });
    });
}
function isReadableStreamLike(obj) {
    return isFunction(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

function innerFrom(input) {
    if (input instanceof Observable) {
        return input;
    }
    if (input != null) {
        if (isInteropObservable(input)) {
            return fromInteropObservable(input);
        }
        if (isArrayLike$1(input)) {
            return fromArrayLike(input);
        }
        if (isPromise(input)) {
            return fromPromise(input);
        }
        if (isAsyncIterable(input)) {
            return fromAsyncIterable(input);
        }
        if (isIterable(input)) {
            return fromIterable(input);
        }
        if (isReadableStreamLike(input)) {
            return fromReadableStreamLike(input);
        }
    }
    throw createInvalidObservableTypeError(input);
}
function fromInteropObservable(obj) {
    return new Observable(function (subscriber) {
        var obs = obj[observable]();
        if (isFunction(obs.subscribe)) {
            return obs.subscribe(subscriber);
        }
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function fromArrayLike(array) {
    return new Observable(function (subscriber) {
        for (var i = 0; i < array.length && !subscriber.closed; i++) {
            subscriber.next(array[i]);
        }
        subscriber.complete();
    });
}
function fromPromise(promise) {
    return new Observable(function (subscriber) {
        promise
            .then(function (value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function (err) { return subscriber.error(err); })
            .then(null, reportUnhandledError);
    });
}
function fromIterable(iterable) {
    return new Observable(function (subscriber) {
        var e_1, _a;
        try {
            for (var iterable_1 = __values(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()) {
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) {
                    return;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        subscriber.complete();
    });
}
function fromAsyncIterable(asyncIterable) {
    return new Observable(function (subscriber) {
        process$1(asyncIterable, subscriber).catch(function (err) { return subscriber.error(err); });
    });
}
function fromReadableStreamLike(readableStream) {
    return fromAsyncIterable(readableStreamLikeToAsyncGenerator(readableStream));
}
function process$1(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return __awaiter(this, void 0, void 0, function () {
        var value, e_2_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, 6, 11]);
                    asyncIterable_1 = __asyncValues(asyncIterable);
                    _b.label = 1;
                case 1: return [4, asyncIterable_1.next()];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [3, 4];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) {
                        return [2];
                    }
                    _b.label = 3;
                case 3: return [3, 1];
                case 4: return [3, 11];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = { error: e_2_1 };
                    return [3, 11];
                case 6:
                    _b.trys.push([6, , 9, 10]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [3, 8];
                    return [4, _a.call(asyncIterable_1)];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8: return [3, 10];
                case 9:
                    if (e_2) throw e_2.error;
                    return [7];
                case 10: return [7];
                case 11:
                    subscriber.complete();
                    return [2];
            }
        });
    });
}

function executeSchedule(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) { delay = 0; }
    if (repeat === void 0) { repeat = false; }
    var scheduleSubscription = scheduler.schedule(function () {
        work();
        if (repeat) {
            parentSubscription.add(this.schedule(null, delay));
        }
        else {
            this.unsubscribe();
        }
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) {
        return scheduleSubscription;
    }
}

function observeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return operate(function (source, subscriber) {
        source.subscribe(createOperatorSubscriber(subscriber, function (value) { return executeSchedule(subscriber, scheduler, function () { return subscriber.next(value); }, delay); }, function () { return executeSchedule(subscriber, scheduler, function () { return subscriber.complete(); }, delay); }, function (err) { return executeSchedule(subscriber, scheduler, function () { return subscriber.error(err); }, delay); }));
    });
}

function subscribeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return operate(function (source, subscriber) {
        subscriber.add(scheduler.schedule(function () { return source.subscribe(subscriber); }, delay));
    });
}

function scheduleObservable(input, scheduler) {
    return innerFrom(input).pipe(subscribeOn(scheduler), observeOn(scheduler));
}

function schedulePromise(input, scheduler) {
    return innerFrom(input).pipe(subscribeOn(scheduler), observeOn(scheduler));
}

function scheduleArray(input, scheduler) {
    return new Observable(function (subscriber) {
        var i = 0;
        return scheduler.schedule(function () {
            if (i === input.length) {
                subscriber.complete();
            }
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) {
                    this.schedule();
                }
            }
        });
    });
}

function scheduleIterable(input, scheduler) {
    return new Observable(function (subscriber) {
        var iterator$1;
        executeSchedule(subscriber, scheduler, function () {
            iterator$1 = input[iterator]();
            executeSchedule(subscriber, scheduler, function () {
                var _a;
                var value;
                var done;
                try {
                    (_a = iterator$1.next(), value = _a.value, done = _a.done);
                }
                catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) {
                    subscriber.complete();
                }
                else {
                    subscriber.next(value);
                }
            }, 0, true);
        });
        return function () { return isFunction(iterator$1 === null || iterator$1 === void 0 ? void 0 : iterator$1.return) && iterator$1.return(); };
    });
}

function scheduleAsyncIterable(input, scheduler) {
    if (!input) {
        throw new Error('Iterable cannot be null');
    }
    return new Observable(function (subscriber) {
        executeSchedule(subscriber, scheduler, function () {
            var iterator = input[Symbol.asyncIterator]();
            executeSchedule(subscriber, scheduler, function () {
                iterator.next().then(function (result) {
                    if (result.done) {
                        subscriber.complete();
                    }
                    else {
                        subscriber.next(result.value);
                    }
                });
            }, 0, true);
        });
    });
}

function scheduleReadableStreamLike(input, scheduler) {
    return scheduleAsyncIterable(readableStreamLikeToAsyncGenerator(input), scheduler);
}

function scheduled(input, scheduler) {
    if (input != null) {
        if (isInteropObservable(input)) {
            return scheduleObservable(input, scheduler);
        }
        if (isArrayLike$1(input)) {
            return scheduleArray(input, scheduler);
        }
        if (isPromise(input)) {
            return schedulePromise(input, scheduler);
        }
        if (isAsyncIterable(input)) {
            return scheduleAsyncIterable(input, scheduler);
        }
        if (isIterable(input)) {
            return scheduleIterable(input, scheduler);
        }
        if (isReadableStreamLike(input)) {
            return scheduleReadableStreamLike(input, scheduler);
        }
    }
    throw createInvalidObservableTypeError(input);
}

function from(input, scheduler) {
    return scheduler ? scheduled(input, scheduler) : innerFrom(input);
}

function of() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = popScheduler(args);
    return from(args, scheduler);
}

var EmptyError = createErrorClass(function (_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = 'EmptyError';
        this.message = 'no elements in sequence';
    };
});

function firstValueFrom(source, config) {
    return new Promise(function (resolve, reject) {
        var subscriber = new SafeSubscriber({
            next: function (value) {
                resolve(value);
                subscriber.unsubscribe();
            },
            error: reject,
            complete: function () {
                {
                    reject(new EmptyError());
                }
            },
        });
        source.subscribe(subscriber);
    });
}

function map(project, thisArg) {
    return operate(function (source, subscriber) {
        var index = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

var isArray$1 = Array.isArray;
function callOrApply(fn, args) {
    return isArray$1(args) ? fn.apply(void 0, __spreadArray([], __read(args))) : fn(args);
}
function mapOneOrManyArgs(fn) {
    return map(function (args) { return callOrApply(fn, args); });
}

var isArray = Array.isArray;
var getPrototypeOf = Object.getPrototypeOf, objectProto = Object.prototype, getKeys = Object.keys;
function argsArgArrayOrObject(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if (isArray(first_1)) {
            return { args: first_1, keys: null };
        }
        if (isPOJO(first_1)) {
            var keys = getKeys(first_1);
            return {
                args: keys.map(function (key) { return first_1[key]; }),
                keys: keys,
            };
        }
    }
    return { args: args, keys: null };
}
function isPOJO(obj) {
    return obj && typeof obj === 'object' && getPrototypeOf(obj) === objectProto;
}

function createObject(keys, values) {
    return keys.reduce(function (result, key, i) { return ((result[key] = values[i]), result); }, {});
}

function combineLatest() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = popScheduler(args);
    var resultSelector = popResultSelector(args);
    var _a = argsArgArrayOrObject(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) {
        return from([], scheduler);
    }
    var result = new Observable(combineLatestInit(observables, scheduler, keys
        ?
            function (values) { return createObject(keys, values); }
        :
            identity$1));
    return resultSelector ? result.pipe(mapOneOrManyArgs(resultSelector)) : result;
}
function combineLatestInit(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) { valueTransform = identity$1; }
    return function (subscriber) {
        maybeSchedule(scheduler, function () {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function (i) {
                maybeSchedule(scheduler, function () {
                    var source = from(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe(createOperatorSubscriber(subscriber, function (value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) {
                            subscriber.next(valueTransform(values.slice()));
                        }
                    }, function () {
                        if (!--active) {
                            subscriber.complete();
                        }
                    }));
                }, subscriber);
            };
            for (var i = 0; i < length; i++) {
                _loop_1(i);
            }
        }, subscriber);
    };
}
function maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) {
        executeSchedule(subscription, scheduler, execute);
    }
    else {
        execute();
    }
}

function mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function () {
        if (isComplete && !buffer.length && !active) {
            subscriber.complete();
        }
    };
    var outerNext = function (value) { return (active < concurrent ? doInnerSub(value) : buffer.push(value)); };
    var doInnerSub = function (value) {
        active++;
        var innerComplete = false;
        innerFrom(project(value, index++)).subscribe(createOperatorSubscriber(subscriber, function (innerValue) {
            {
                subscriber.next(innerValue);
            }
        }, function () {
            innerComplete = true;
        }, undefined, function () {
            if (innerComplete) {
                try {
                    active--;
                    var _loop_1 = function () {
                        var bufferedValue = buffer.shift();
                        if (innerSubScheduler) ;
                        else {
                            doInnerSub(bufferedValue);
                        }
                    };
                    while (buffer.length && active < concurrent) {
                        _loop_1();
                    }
                    checkComplete();
                }
                catch (err) {
                    subscriber.error(err);
                }
            }
        }));
    };
    source.subscribe(createOperatorSubscriber(subscriber, outerNext, function () {
        isComplete = true;
        checkComplete();
    }));
    return function () {
    };
}

function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Infinity; }
    if (isFunction(resultSelector)) {
        return mergeMap(function (a, i) { return map(function (b, ii) { return resultSelector(a, b, i, ii); })(innerFrom(project(a, i))); }, concurrent);
    }
    else if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return operate(function (source, subscriber) { return mergeInternals(source, subscriber, project, concurrent); });
}

function mergeAll(concurrent) {
    return mergeMap(identity$1, concurrent);
}

function concatAll() {
    return mergeAll(1);
}

function concat() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return concatAll()(from(args, popScheduler(args)));
}

function catchError(selector) {
    return operate(function (source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe(createOperatorSubscriber(subscriber, undefined, undefined, function (err) {
            handledResult = innerFrom(selector(err, catchError(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            }
            else {
                syncUnsub = true;
            }
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}

function scanInternals(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
    return function (source, subscriber) {
        var hasState = hasSeed;
        var state = seed;
        var index = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            var i = index++;
            state = hasState
                ?
                    accumulator(state, value, i)
                :
                    ((hasState = true), value);
        }, (function () {
                hasState && subscriber.next(state);
                subscriber.complete();
            })));
    };
}

function reduce(accumulator, seed) {
    return operate(scanInternals(accumulator, seed, arguments.length >= 2, false, true));
}

var arrReducer = function (arr, value) { return (arr.push(value), arr); };
function toArray() {
    return operate(function (source, subscriber) {
        reduce(arrReducer, [])(source).subscribe(subscriber);
    });
}

function fromSubscribable(subscribable) {
    return new Observable(function (subscriber) { return subscribable.subscribe(subscriber); });
}

var DEFAULT_CONFIG = {
    connector: function () { return new Subject(); },
};
function connect(selector, config) {
    if (config === void 0) { config = DEFAULT_CONFIG; }
    var connector = config.connector;
    return operate(function (source, subscriber) {
        var subject = connector();
        innerFrom(selector(fromSubscribable(subject))).subscribe(subscriber);
        subscriber.add(source.subscribe(subject));
    });
}

function defaultIfEmpty(defaultValue) {
    return operate(function (source, subscriber) {
        var hasValue = false;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            hasValue = true;
            subscriber.next(value);
        }, function () {
            if (!hasValue) {
                subscriber.next(defaultValue);
            }
            subscriber.complete();
        }));
    });
}

function take(count) {
    return count <= 0
        ?
            function () { return EMPTY; }
        : operate(function (source, subscriber) {
            var seen = 0;
            source.subscribe(createOperatorSubscriber(subscriber, function (value) {
                if (++seen <= count) {
                    subscriber.next(value);
                    if (count <= seen) {
                        subscriber.complete();
                    }
                }
            }));
        });
}

function distinctUntilChanged(comparator, keySelector) {
    if (keySelector === void 0) { keySelector = identity$1; }
    comparator = comparator !== null && comparator !== void 0 ? comparator : defaultCompare;
    return operate(function (source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function defaultCompare(a, b) {
    return a === b;
}

function throwIfEmpty(errorFactory) {
    if (errorFactory === void 0) { errorFactory = defaultErrorFactory; }
    return operate(function (source, subscriber) {
        var hasValue = false;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            hasValue = true;
            subscriber.next(value);
        }, function () { return (hasValue ? subscriber.complete() : subscriber.error(errorFactory())); }));
    });
}
function defaultErrorFactory() {
    return new EmptyError();
}

function first(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function (source) {
        return source.pipe(identity$1, take(1), hasDefaultValue ? defaultIfEmpty(defaultValue) : throwIfEmpty(function () { return new EmptyError(); }));
    };
}

function multicast(subjectOrSubjectFactory, selector) {
    var subjectFactory = isFunction(subjectOrSubjectFactory) ? subjectOrSubjectFactory : function () { return subjectOrSubjectFactory; };
    if (isFunction(selector)) {
        return connect(selector, {
            connector: subjectFactory,
        });
    }
    return function (source) { return new ConnectableObservable(source, subjectFactory); };
}

function publishReplay(bufferSize, windowTime, selectorOrScheduler, timestampProvider) {
    var selector = isFunction(selectorOrScheduler) ? selectorOrScheduler : undefined;
    return function (source) { return multicast(new ReplaySubject(bufferSize, windowTime, timestampProvider), selector)(source); };
}

function startWith() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    var scheduler = popScheduler(values);
    return operate(function (source, subscriber) {
        (scheduler ? concat(values, source, scheduler) : concat(values, source)).subscribe(subscriber);
    });
}

function switchMap(project, resultSelector) {
    return operate(function (source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function () { return isComplete && !innerSubscriber && subscriber.complete(); };
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            innerSubscriber === null || innerSubscriber === void 0 ? void 0 : innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            innerFrom(project(value, outerIndex)).subscribe((innerSubscriber = createOperatorSubscriber(subscriber, function (innerValue) { return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue); }, function () {
                innerSubscriber = null;
                checkComplete();
            })));
        }, function () {
            isComplete = true;
            checkComplete();
        }));
    });
}

function tap(observerOrNext, error, complete) {
    var tapObserver = isFunction(observerOrNext) || error || complete
        ?
            { next: observerOrNext, error: error, complete: complete }
        : observerOrNext;
    return tapObserver
        ? operate(function (source, subscriber) {
            var _a;
            (_a = tapObserver.subscribe) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
            var isUnsub = true;
            source.subscribe(createOperatorSubscriber(subscriber, function (value) {
                var _a;
                (_a = tapObserver.next) === null || _a === void 0 ? void 0 : _a.call(tapObserver, value);
                subscriber.next(value);
            }, function () {
                var _a;
                isUnsub = false;
                (_a = tapObserver.complete) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
                subscriber.complete();
            }, function (err) {
                var _a;
                isUnsub = false;
                (_a = tapObserver.error) === null || _a === void 0 ? void 0 : _a.call(tapObserver, err);
                subscriber.error(err);
            }, function () {
                var _a, _b;
                if (isUnsub) {
                    (_a = tapObserver.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
                }
                (_b = tapObserver.finalize) === null || _b === void 0 ? void 0 : _b.call(tapObserver);
            }));
        })
        :
            identity$1;
}

const l$a = /*#__PURE__*/ logger('api/util');

function filterEvents(txHash, { block: { extrinsics, header } }, allEvents, status) {
    // extrinsics to hashes
    for (const [txIndex, x] of extrinsics.entries()) {
        if (x.hash.eq(txHash)) {
            return {
                blockNumber: isCompact(header.number) ? header.number.unwrap() : header.number,
                events: allEvents.filter(({ phase }) => phase.isApplyExtrinsic &&
                    phase.asApplyExtrinsic.eqn(txIndex)),
                txIndex
            };
        }
    }
    // if we do get the block after finalized, it _should_ be there
    // only warn on filtering with isInBlock (finalization finalizes after)
    if (status.isInBlock) {
        const allHashes = extrinsics.map((x) => x.hash.toHex());
        l$a.warn(`block ${header.hash.toHex()}: Unable to find extrinsic ${txHash.toHex()} inside ${allHashes.join(', ')}`);
    }
    return {};
}

function isKeyringPair(account) {
    return isFunction$1(account.sign);
}

/* eslint-disable sort-keys */
const AllHashers = {
    Blake2_128: null, // eslint-disable-line camelcase
    Blake2_256: null, // eslint-disable-line camelcase
    Blake2_128Concat: null, // eslint-disable-line camelcase
    Twox128: null,
    Twox256: null,
    Twox64Concat: null,
    // new in v11
    Identity: null
};

const META_V1_TO_V2 = {
    metadata: {
        description: 'Returns the metadata of a runtime',
        params: [],
        type: 'OpaqueMetadata'
    }
};
const runtime$z = {
    Metadata: [
        {
            methods: {
                metadata_at_version: {
                    description: 'Returns the metadata at a given version.',
                    params: [
                        {
                            name: 'version',
                            type: 'u32'
                        }
                    ],
                    type: 'Option<OpaqueMetadata>'
                },
                metadata_versions: {
                    description: 'Returns the supported metadata versions.',
                    params: [],
                    type: 'Vec<u32>'
                },
                ...META_V1_TO_V2
            },
            version: 2
        },
        {
            methods: {
                ...META_V1_TO_V2
            },
            version: 1
        }
    ]
};

const v9 = {
    // v9
    ErrorMetadataV9: {
        name: 'Text',
        docs: 'Vec<Text>'
    },
    EventMetadataV9: {
        name: 'Text',
        args: 'Vec<Type>',
        docs: 'Vec<Text>'
    },
    FunctionArgumentMetadataV9: {
        name: 'Text',
        type: 'Type'
    },
    FunctionMetadataV9: {
        name: 'Text',
        args: 'Vec<FunctionArgumentMetadataV9>',
        docs: 'Vec<Text>'
    },
    MetadataV9: {
        modules: 'Vec<ModuleMetadataV9>'
    },
    ModuleConstantMetadataV9: {
        name: 'Text',
        type: 'Type',
        value: 'Bytes',
        docs: 'Vec<Text>'
    },
    ModuleMetadataV9: {
        name: 'Text',
        storage: 'Option<StorageMetadataV9>',
        calls: 'Option<Vec<FunctionMetadataV9>>',
        events: 'Option<Vec<EventMetadataV9>>',
        constants: 'Vec<ModuleConstantMetadataV9>',
        errors: 'Vec<ErrorMetadataV9>'
    },
    StorageEntryMetadataV9: {
        name: 'Text',
        modifier: 'StorageEntryModifierV9',
        type: 'StorageEntryTypeV9',
        fallback: 'Bytes',
        docs: 'Vec<Text>'
    },
    StorageEntryModifierV9: {
        _enum: ['Optional', 'Default', 'Required']
    },
    StorageEntryTypeV9: {
        _enum: {
            Plain: 'Type',
            Map: {
                hasher: 'StorageHasherV9',
                key: 'Type',
                value: 'Type',
                linked: 'bool'
            },
            DoubleMap: {
                hasher: 'StorageHasherV9',
                key1: 'Type',
                key2: 'Type',
                value: 'Type',
                key2Hasher: 'StorageHasherV9'
            }
        }
    },
    StorageHasherV9: {
        _enum: {
            Blake2_128: null, // eslint-disable-line camelcase
            Blake2_256: null, // eslint-disable-line camelcase
            Twox128: null,
            Twox256: null,
            Twox64Concat: null
        }
    },
    StorageMetadataV9: {
        prefix: 'Text',
        items: 'Vec<StorageEntryMetadataV9>'
    }
};

const v10 = {
    // v10
    ErrorMetadataV10: 'ErrorMetadataV9',
    EventMetadataV10: 'EventMetadataV9',
    FunctionArgumentMetadataV10: 'FunctionArgumentMetadataV9',
    FunctionMetadataV10: 'FunctionMetadataV9',
    MetadataV10: {
        modules: 'Vec<ModuleMetadataV10>'
    },
    ModuleConstantMetadataV10: 'ModuleConstantMetadataV9',
    ModuleMetadataV10: {
        name: 'Text',
        storage: 'Option<StorageMetadataV10>',
        calls: 'Option<Vec<FunctionMetadataV10>>',
        events: 'Option<Vec<EventMetadataV10>>',
        constants: 'Vec<ModuleConstantMetadataV10>',
        errors: 'Vec<ErrorMetadataV10>'
    },
    StorageEntryModifierV10: 'StorageEntryModifierV9',
    StorageEntryMetadataV10: {
        name: 'Text',
        modifier: 'StorageEntryModifierV10',
        type: 'StorageEntryTypeV10',
        fallback: 'Bytes',
        docs: 'Vec<Text>'
    },
    StorageEntryTypeV10: {
        _enum: {
            Plain: 'Type',
            Map: {
                hasher: 'StorageHasherV10',
                key: 'Type',
                value: 'Type',
                linked: 'bool'
            },
            DoubleMap: {
                hasher: 'StorageHasherV10',
                key1: 'Type',
                key2: 'Type',
                value: 'Type',
                key2Hasher: 'StorageHasherV10'
            }
        }
    },
    StorageMetadataV10: {
        prefix: 'Text',
        items: 'Vec<StorageEntryMetadataV10>'
    },
    StorageHasherV10: {
        _enum: {
            Blake2_128: null, // eslint-disable-line camelcase
            Blake2_256: null, // eslint-disable-line camelcase
            Blake2_128Concat: null, // eslint-disable-line camelcase
            Twox128: null,
            Twox256: null,
            Twox64Concat: null
        }
    }
};

const v11 = {
    // v11
    ErrorMetadataV11: 'ErrorMetadataV10',
    EventMetadataV11: 'EventMetadataV10',
    ExtrinsicMetadataV11: {
        version: 'u8',
        signedExtensions: 'Vec<Text>'
    },
    FunctionArgumentMetadataV11: 'FunctionArgumentMetadataV10',
    FunctionMetadataV11: 'FunctionMetadataV10',
    MetadataV11: {
        modules: 'Vec<ModuleMetadataV11>',
        extrinsic: 'ExtrinsicMetadataV11'
    },
    ModuleConstantMetadataV11: 'ModuleConstantMetadataV10',
    ModuleMetadataV11: {
        name: 'Text',
        storage: 'Option<StorageMetadataV11>',
        calls: 'Option<Vec<FunctionMetadataV11>>',
        events: 'Option<Vec<EventMetadataV11>>',
        constants: 'Vec<ModuleConstantMetadataV11>',
        errors: 'Vec<ErrorMetadataV11>'
    },
    StorageEntryModifierV11: 'StorageEntryModifierV10',
    StorageEntryMetadataV11: {
        name: 'Text',
        modifier: 'StorageEntryModifierV11',
        type: 'StorageEntryTypeV11',
        fallback: 'Bytes',
        docs: 'Vec<Text>'
    },
    StorageEntryTypeV11: {
        _enum: {
            Plain: 'Type',
            Map: {
                hasher: 'StorageHasherV11',
                key: 'Type',
                value: 'Type',
                linked: 'bool'
            },
            DoubleMap: {
                hasher: 'StorageHasherV11',
                key1: 'Type',
                key2: 'Type',
                value: 'Type',
                key2Hasher: 'StorageHasherV11'
            }
        }
    },
    StorageMetadataV11: {
        prefix: 'Text',
        items: 'Vec<StorageEntryMetadataV11>'
    },
    StorageHasherV11: {
        _enum: AllHashers
    }
};

const v12 = {
    // v12
    ErrorMetadataV12: 'ErrorMetadataV11',
    EventMetadataV12: 'EventMetadataV11',
    ExtrinsicMetadataV12: 'ExtrinsicMetadataV11',
    FunctionArgumentMetadataV12: 'FunctionArgumentMetadataV11',
    FunctionMetadataV12: 'FunctionMetadataV11',
    MetadataV12: {
        modules: 'Vec<ModuleMetadataV12>',
        extrinsic: 'ExtrinsicMetadataV12'
    },
    ModuleConstantMetadataV12: 'ModuleConstantMetadataV11',
    ModuleMetadataV12: {
        name: 'Text',
        storage: 'Option<StorageMetadataV12>',
        calls: 'Option<Vec<FunctionMetadataV12>>',
        events: 'Option<Vec<EventMetadataV12>>',
        constants: 'Vec<ModuleConstantMetadataV12>',
        errors: 'Vec<ErrorMetadataV12>',
        index: 'u8'
    },
    StorageEntryModifierV12: 'StorageEntryModifierV11',
    StorageEntryMetadataV12: 'StorageEntryMetadataV11',
    StorageEntryTypeV12: 'StorageEntryTypeV11',
    StorageMetadataV12: 'StorageMetadataV11',
    StorageHasherV12: 'StorageHasherV11'
};

const v13 = {
    // v13
    ErrorMetadataV13: 'ErrorMetadataV12',
    EventMetadataV13: 'EventMetadataV12',
    ExtrinsicMetadataV13: 'ExtrinsicMetadataV12',
    FunctionArgumentMetadataV13: 'FunctionArgumentMetadataV12',
    FunctionMetadataV13: 'FunctionMetadataV12',
    MetadataV13: {
        modules: 'Vec<ModuleMetadataV13>',
        extrinsic: 'ExtrinsicMetadataV13'
    },
    ModuleConstantMetadataV13: 'ModuleConstantMetadataV12',
    ModuleMetadataV13: {
        name: 'Text',
        storage: 'Option<StorageMetadataV13>',
        calls: 'Option<Vec<FunctionMetadataV13>>',
        events: 'Option<Vec<EventMetadataV13>>',
        constants: 'Vec<ModuleConstantMetadataV13>',
        errors: 'Vec<ErrorMetadataV13>',
        index: 'u8'
    },
    StorageEntryModifierV13: 'StorageEntryModifierV12',
    StorageEntryMetadataV13: {
        name: 'Text',
        modifier: 'StorageEntryModifierV13',
        type: 'StorageEntryTypeV13',
        fallback: 'Bytes',
        docs: 'Vec<Text>'
    },
    StorageEntryTypeV13: {
        _enum: {
            Plain: 'Type',
            Map: {
                hasher: 'StorageHasherV13',
                key: 'Type',
                value: 'Type',
                linked: 'bool'
            },
            DoubleMap: {
                hasher: 'StorageHasherV13',
                key1: 'Type',
                key2: 'Type',
                value: 'Type',
                key2Hasher: 'StorageHasherV13'
            },
            NMap: {
                keyVec: 'Vec<Type>',
                hashers: 'Vec<StorageHasherV13>',
                value: 'Type'
            }
        }
    },
    StorageMetadataV13: {
        prefix: 'Text',
        items: 'Vec<StorageEntryMetadataV13>'
    },
    StorageHasherV13: 'StorageHasherV12'
};

/* eslint-disable sort-keys */
const Si1Variant = {
    name: 'Text',
    fields: 'Vec<Si1Field>',
    index: 'u8',
    docs: 'Vec<Text>'
};
const v1$1 = {
    Si1Field: {
        name: 'Option<Text>',
        type: 'Si1LookupTypeId',
        typeName: 'Option<Text>',
        docs: 'Vec<Text>'
    },
    Si1LookupTypeId: 'Compact<u32>',
    Si1Path: 'Si0Path',
    Si1Type: {
        path: 'Si1Path',
        params: 'Vec<Si1TypeParameter>',
        def: 'Si1TypeDef',
        docs: 'Vec<Text>'
    },
    Si1TypeDef: {
        _enum: {
            Composite: 'Si1TypeDefComposite',
            Variant: 'Si1TypeDefVariant',
            Sequence: 'Si1TypeDefSequence',
            Array: 'Si1TypeDefArray',
            Tuple: 'Si1TypeDefTuple',
            Primitive: 'Si1TypeDefPrimitive',
            Compact: 'Si1TypeDefCompact',
            BitSequence: 'Si1TypeDefBitSequence',
            // NOTE: This is specific to the implementation for pre-v14 metadata
            // compatibility (always keep this as the last entry in the enum)
            HistoricMetaCompat: 'Type'
        }
    },
    Si1TypeDefArray: {
        len: 'u32',
        type: 'Si1LookupTypeId'
    },
    Si1TypeDefBitSequence: {
        bitStoreType: 'Si1LookupTypeId',
        bitOrderType: 'Si1LookupTypeId'
    },
    Si1TypeDefCompact: {
        type: 'Si1LookupTypeId'
    },
    Si1TypeDefComposite: {
        fields: 'Vec<Si1Field>'
    },
    Si1TypeDefPrimitive: 'Si0TypeDefPrimitive',
    Si1TypeDefSequence: {
        type: 'Si1LookupTypeId'
    },
    Si1TypeDefTuple: 'Vec<Si1LookupTypeId>',
    Si1TypeParameter: {
        name: 'Text',
        type: 'Option<Si1LookupTypeId>'
    },
    Si1TypeDefVariant: {
        variants: 'Vec<Si1Variant>'
    },
    Si1Variant
};

const v14 = {
    // registry
    PortableTypeV14: {
        id: 'Si1LookupTypeId',
        type: 'Si1Type'
    },
    // compatibility with earlier layouts, i.e. don't break previous users
    ErrorMetadataV14: {
        ...Si1Variant,
        args: 'Vec<Type>'
    },
    EventMetadataV14: {
        ...Si1Variant,
        args: 'Vec<Type>'
    },
    FunctionArgumentMetadataV14: {
        name: 'Text',
        type: 'Type',
        typeName: 'Option<Type>'
    },
    FunctionMetadataV14: {
        ...Si1Variant,
        args: 'Vec<FunctionArgumentMetadataV14>'
    },
    // V14
    ExtrinsicMetadataV14: {
        type: 'SiLookupTypeId',
        version: 'u8',
        signedExtensions: 'Vec<SignedExtensionMetadataV14>'
    },
    MetadataV14: {
        lookup: 'PortableRegistry',
        pallets: 'Vec<PalletMetadataV14>',
        extrinsic: 'ExtrinsicMetadataV14',
        type: 'SiLookupTypeId'
    },
    PalletCallMetadataV14: {
        type: 'SiLookupTypeId'
    },
    PalletConstantMetadataV14: {
        name: 'Text',
        type: 'SiLookupTypeId',
        value: 'Bytes',
        docs: 'Vec<Text>'
    },
    PalletErrorMetadataV14: {
        type: 'SiLookupTypeId'
    },
    PalletEventMetadataV14: {
        type: 'SiLookupTypeId'
    },
    PalletMetadataV14: {
        name: 'Text',
        storage: 'Option<PalletStorageMetadataV14>',
        calls: 'Option<PalletCallMetadataV14>',
        events: 'Option<PalletEventMetadataV14>',
        constants: 'Vec<PalletConstantMetadataV14>',
        errors: 'Option<PalletErrorMetadataV14>',
        index: 'u8'
    },
    PalletStorageMetadataV14: {
        prefix: 'Text',
        // NOTE: Renamed from entries
        items: 'Vec<StorageEntryMetadataV14>'
    },
    SignedExtensionMetadataV14: {
        identifier: 'Text',
        type: 'SiLookupTypeId',
        additionalSigned: 'SiLookupTypeId'
    },
    StorageEntryMetadataV14: {
        name: 'Text',
        modifier: 'StorageEntryModifierV14',
        type: 'StorageEntryTypeV14',
        fallback: 'Bytes',
        docs: 'Vec<Text>'
    },
    StorageEntryModifierV14: 'StorageEntryModifierV13',
    StorageEntryTypeV14: {
        _enum: {
            Plain: 'SiLookupTypeId',
            Map: {
                hashers: 'Vec<StorageHasherV14>',
                key: 'SiLookupTypeId', // NOTE: Renamed from "keys"
                value: 'SiLookupTypeId'
            }
        }
    },
    StorageHasherV14: 'StorageHasherV13'
};

const v15 = {
    // new/adjusted in v15
    CustomMetadata15: {
        map: 'BTreeMap<Text, CustomValueMetadata15>'
    },
    CustomValueMetadata15: {
        type: 'SiLookupTypeId',
        value: 'Bytes'
    },
    ExtrinsicMetadataV15: {
        version: 'u8',
        addressType: 'SiLookupTypeId',
        callType: 'SiLookupTypeId',
        signatureType: 'SiLookupTypeId',
        extraType: 'SiLookupTypeId',
        signedExtensions: 'Vec<SignedExtensionMetadataV14>'
    },
    OuterEnums15: {
        callType: 'SiLookupTypeId',
        eventType: 'SiLookupTypeId',
        errorType: 'SiLookupTypeId'
    },
    PalletMetadataV15: {
        name: 'Text',
        storage: 'Option<PalletStorageMetadataV14>',
        calls: 'Option<PalletCallMetadataV14>',
        events: 'Option<PalletEventMetadataV14>',
        constants: 'Vec<PalletConstantMetadataV14>',
        errors: 'Option<PalletErrorMetadataV14>',
        index: 'u8',
        docs: 'Vec<Text>'
    },
    RuntimeApiMetadataV15: {
        name: 'Text',
        methods: 'Vec<RuntimeApiMethodMetadataV15>',
        docs: 'Vec<Text>'
    },
    RuntimeApiMethodMetadataV15: {
        name: 'Text',
        inputs: 'Vec<RuntimeApiMethodParamMetadataV15>',
        output: 'SiLookupTypeId',
        docs: 'Vec<Text>'
    },
    RuntimeApiMethodParamMetadataV15: {
        name: 'Text',
        type: 'SiLookupTypeId'
    },
    // actual v15 definition
    MetadataV15: {
        lookup: 'PortableRegistry',
        pallets: 'Vec<PalletMetadataV15>',
        extrinsic: 'ExtrinsicMetadataV15',
        type: 'SiLookupTypeId',
        apis: 'Vec<RuntimeApiMetadataV15>',
        outerEnums: 'OuterEnums15',
        custom: 'CustomMetadata15'
    }
};

const v16 = {
    // actual v16 definition
    MetadataV16: {
        lookup: 'PortableRegistry',
        pallets: 'Vec<PalletMetadataV16>',
        extrinsic: 'ExtrinsicMetadataV16',
        apis: 'Vec<RuntimeApiMetadataV16>',
        outerEnums: 'OuterEnums15',
        custom: 'CustomMetadata15'
    },
    // ---- Pallet definitions ----
    PalletMetadataV16: {
        name: 'Text',
        storage: 'Option<PalletStorageMetadataV16>',
        calls: 'Option<PalletCallMetadataV16>',
        events: 'Option<PalletEventMetadataV16>',
        constants: 'Vec<PalletConstantMetadataV16>',
        errors: 'Option<PalletErrorMetadataV16>',
        associatedTypes: 'Vec<PalletAssociatedTypeMetadataV16>',
        viewFunctions: 'Vec<PalletViewFunctionMetadataV16>',
        index: 'u8',
        docs: 'Vec<Text>',
        // Deprecation info
        deprecationInfo: 'ItemDeprecationInfoV16'
    },
    PalletStorageMetadataV16: {
        prefix: 'Text',
        items: 'Vec<StorageEntryMetadataV16>'
    },
    StorageEntryMetadataV16: {
        name: 'Text',
        modifier: 'StorageEntryModifierV14',
        type: 'StorageEntryTypeV14',
        fallback: 'Bytes',
        docs: 'Vec<Text>',
        deprecationInfo: 'ItemDeprecationInfoV16'
    },
    ItemDeprecationInfoV16: {
        _enum: {
            // Item is not deprecated.
            NotDeprecated: 'Null',
            // Item is fully deprecated without a note.
            DeprecatedWithoutNote: 'Null',
            // Item is fully deprecated with a note and an optional `since` field.
            Deprecated: {
                // Note explaining the deprecation
                note: 'Text',
                // Optional value for noting the version when the deprecation occurred.
                since: 'Option<Text>'
            }
        }
    },
    PalletCallMetadataV16: {
        type: 'SiLookupTypeId',
        // Deprecation status of the pallet call
        deprecationInfo: 'EnumDeprecationInfoV16'
    },
    // Deprecation information for enums in which specific variants can be deprecated.
    // If the map is empty, then nothing is deprecated.
    EnumDeprecationInfoV16: 'BTreeMap<u8, VariantDeprecationInfoV16>',
    VariantDeprecationInfoV16: {
        _enum: {
            // Dummy variant, just here to force DeprecatedWithoutNote
            // to have index 1 and Deprecated to have index 2
            DummyVariant: 'Null',
            // Variant is deprecated without a note.
            DeprecatedWithoutNote: 'Null',
            // Variant is deprecated with a note and an optional `since` field.
            Deprecated: {
                // Note explaining the deprecation
                note: 'Text',
                // Optional value for noting the version when the deprecation occurred.
                since: 'Option<Text>'
            }
        }
    },
    PalletEventMetadataV16: {
        type: 'SiLookupTypeId',
        // Deprecation info
        deprecationInfo: 'EnumDeprecationInfoV16'
    },
    PalletConstantMetadataV16: {
        name: 'Text',
        type: 'SiLookupTypeId',
        value: 'Bytes',
        docs: 'Vec<Text>',
        // Deprecation info
        deprecationInfo: 'ItemDeprecationInfoV16'
    },
    PalletErrorMetadataV16: {
        type: 'SiLookupTypeId',
        // Deprecation info
        deprecationInfo: 'EnumDeprecationInfoV16'
    },
    PalletAssociatedTypeMetadataV16: {
        name: 'Text',
        type: 'SiLookupTypeId',
        docs: 'Vec<Text>'
    },
    PalletViewFunctionMetadataV16: {
        id: '[u8; 32]',
        // Method name.
        name: 'Text',
        // Method par  ameters.
        inputs: 'Vec<RuntimeApiMethodParamMetadataV15>',
        // Method output.
        output: 'SiLookupTypeId',
        // Method documentation.
        docs: 'Vec<T::String>',
        // Deprecation info
        deprecationInfo: 'ItemDeprecationInfoV16'
    },
    // ---- Extrinsic definitions ----
    ExtrinsicMetadataV16: {
        // Extrinsic versions supported by the runtime.
        versions: 'Vec<u8>',
        // The type of the address that signs the extrinsic
        addressType: 'SiLookupTypeId',
        // The type of the outermost Call enum.
        callType: 'SiLookupTypeId',
        // The type of the extrinsic's signature.
        signatureType: 'SiLookupTypeId',
        // A mapping of supported transaction extrinsic versions to their respective transaction extension indexes.
        //
        // For each supported version number, list the indexes, in order, of the extensions used.
        transactionExtensionsByVersion: 'BTreeMap<u8, Vec<Compact<u32>>>',
        // The transaction extensions in the order they appear in the extrinsic.
        transactionExtensions: 'Vec<TransactionExtensionMetadataV16>'
    },
    TransactionExtensionMetadataV16: {
        // The unique transaction extension identifier, which may be different from the type name.
        identifier: 'Text',
        // The type of the transaction extension, with the data to be included in the extrinsic.
        type: 'SiLookupTypeId',
        // The type of the implicit data, with the data to be included in the signed payload.
        implicit: 'SiLookupTypeId'
    },
    // ---- Runtime Api definitions ----
    RuntimeApiMetadataV16: {
        name: 'Text',
        methods: 'Vec<RuntimeApiMethodMetadataV16>',
        docs: 'Vec<Text>',
        // Runtime API version.
        version: 'Compact<u32>',
        // Deprecation info
        deprecationInfo: 'ItemDeprecationInfoV16'
    },
    RuntimeApiMethodMetadataV16: {
        name: 'Text',
        inputs: 'Vec<RuntimeApiMethodParamMetadataV15>',
        output: 'SiLookupTypeId',
        docs: 'Vec<Text>',
        // Deprecation info
        deprecationInfo: 'ItemDeprecationInfoV16'
    }
};

var definitions$1c = {
    rpc: {},
    runtime: runtime$z,
    types: {
        // all known
        ...v9,
        ...v10,
        ...v11,
        ...v12,
        ...v13,
        ...v14,
        ...v15,
        ...v16,
        // latest mappings
        // NOTE: For v15, we only added the runtime defintions,
        // hence latest for most pointing to the previous V14
        ErrorMetadataLatest: 'ErrorMetadataV14',
        EventMetadataLatest: 'EventMetadataV14',
        ExtrinsicMetadataLatest: 'ExtrinsicMetadataV16',
        FunctionArgumentMetadataLatest: 'FunctionArgumentMetadataV14',
        FunctionMetadataLatest: 'FunctionMetadataV14',
        MetadataLatest: 'MetadataV16',
        PalletCallMetadataLatest: 'PalletCallMetadataV16',
        PalletConstantMetadataLatest: 'PalletConstantMetadataV16',
        PalletErrorMetadataLatest: 'PalletErrorMetadataV16',
        PalletEventMetadataLatest: 'PalletEventMetadataV16',
        PalletMetadataLatest: 'PalletMetadataV16',
        PalletStorageMetadataLatest: 'PalletStorageMetadataV16',
        PortableType: 'PortableTypeV14',
        RuntimeApiMetadataLatest: 'RuntimeApiMetadataV16',
        SignedExtensionMetadataLatest: 'SignedExtensionMetadataV14',
        TransactionExtensionMetadataLatest: 'TransactionExtensionMetadataV16',
        StorageEntryMetadataLatest: 'StorageEntryMetadataV16',
        StorageEntryModifierLatest: 'StorageEntryModifierV14',
        StorageEntryTypeLatest: 'StorageEntryTypeV14',
        StorageHasher: 'StorageHasherV14',
        // additional types
        OpaqueMetadata: 'Opaque<Bytes>',
        // the enum containing all the mappings
        MetadataAll: {
            _enum: {
                V0: 'DoNotConstruct<MetadataV0>',
                V1: 'DoNotConstruct<MetadataV1>',
                V2: 'DoNotConstruct<MetadataV2>',
                V3: 'DoNotConstruct<MetadataV3>',
                V4: 'DoNotConstruct<MetadataV4>',
                V5: 'DoNotConstruct<MetadataV5>',
                V6: 'DoNotConstruct<MetadataV6>',
                V7: 'DoNotConstruct<MetadataV7>',
                V8: 'DoNotConstruct<MetadataV8>',
                // First version on Kusama in V9, dropping will be problematic
                V9: 'MetadataV9',
                V10: 'MetadataV10',
                V11: 'MetadataV11',
                V12: 'MetadataV12',
                V13: 'MetadataV13',
                V14: 'MetadataV14',
                V15: 'MetadataV15',
                V16: 'MetadataV16'
            }
        }
    }
};

const CORE_V1_TO_V4 = {
    execute_block: {
        description: 'Execute the given block.',
        params: [
            {
                name: 'block',
                type: 'Block'
            }
        ],
        type: 'Null'
    }
};
const CORE_V1_TO_V2 = {
    version: {
        description: 'Returns the version of the runtime.',
        params: [],
        type: 'RuntimeVersionPre3'
    }
};
const CORE_V2_TO_V4 = {
    initialize_block: {
        description: 'Initialize a block with the given header.',
        params: [
            {
                name: 'header',
                type: 'Header'
            }
        ],
        type: 'Null'
    }
};
const CORE_V4_VERSION = {
    version: {
        description: 'Returns the version of the runtime.',
        params: [],
        type: 'RuntimeVersion'
    }
};
const CORE_V4_TO_V5 = {
    ...CORE_V1_TO_V4,
    initialize_block: {
        description: 'Initialize a block with the given header.',
        params: [
            {
                name: 'header',
                type: 'Header'
            }
        ],
        type: 'ExtrinsicInclusionMode'
    }
};
const runtime$y = {
    Core: [
        {
            methods: {
                ...CORE_V4_VERSION,
                ...CORE_V4_TO_V5
            },
            version: 5
        },
        {
            methods: {
                ...CORE_V4_VERSION,
                ...CORE_V1_TO_V4,
                ...CORE_V2_TO_V4
            },
            version: 4
        },
        {
            methods: {
                version: {
                    description: 'Returns the version of the runtime.',
                    params: [],
                    type: 'RuntimeVersionPre4'
                },
                ...CORE_V1_TO_V4,
                ...CORE_V2_TO_V4
            },
            version: 3
        },
        {
            methods: {
                ...CORE_V1_TO_V2,
                ...CORE_V1_TO_V4,
                ...CORE_V2_TO_V4
            },
            version: 2
        },
        {
            methods: {
                initialise_block: {
                    description: 'Initialize a block with the given header.',
                    params: [
                        {
                            name: 'header',
                            type: 'Header'
                        }
                    ],
                    type: 'Null'
                },
                ...CORE_V1_TO_V2,
                ...CORE_V1_TO_V4
            },
            version: 1
        }
    ]
};

const numberTypes = {
    Fixed64: 'Int<64, Fixed64>',
    FixedI64: 'Int<64, FixedI64>',
    FixedU64: 'UInt<64, FixedU64>',
    Fixed128: 'Int<128, Fixed128>',
    FixedI128: 'Int<128, FixedI128>',
    FixedU128: 'UInt<128, FixedU128>',
    I32F32: 'Int<64, I32F32>',
    U32F32: 'UInt<64, U32F32>',
    PerU16: 'UInt<16, PerU16>',
    Perbill: 'UInt<32, Perbill>',
    Percent: 'UInt<8, Percent>',
    Permill: 'UInt<32, Permill>',
    Perquintill: 'UInt<64, Perquintill>'
};
const knownOrigins = {
    //
    // (1) Defaults from Substrate
    //
    Council: 'CollectiveOrigin',
    System: 'SystemOrigin',
    TechnicalCommittee: 'CollectiveOrigin',
    //
    // (2) Defaults from Polkadot
    //
    Xcm: 'XcmOrigin',
    XcmPallet: 'XcmOrigin',
    //
    // (3) Defaults from Acala
    //
    Authority: 'AuthorityOrigin',
    GeneralCouncil: 'CollectiveOrigin'
};
var definitions$1b = {
    rpc: {},
    runtime: runtime$y,
    types: {
        ...numberTypes,
        AccountId: 'AccountId32',
        AccountId20: 'GenericEthereumAccountId',
        AccountId32: 'GenericAccountId32',
        AccountId33: 'GenericAccountId33',
        AccountIdOf: 'AccountId',
        AccountIndex: 'GenericAccountIndex',
        Address: 'MultiAddress',
        AssetId: 'u32',
        Balance: 'UInt<128, Balance>',
        BalanceOf: 'Balance',
        Block: 'GenericBlock',
        BlockNumber: 'u32',
        BlockNumberFor: 'BlockNumber',
        BlockNumberOf: 'BlockNumber',
        Call: 'GenericCall',
        CallHash: 'Hash',
        CallHashOf: 'CallHash',
        ChangesTrieConfiguration: {
            digestInterval: 'u32',
            digestLevels: 'u32'
        },
        ChangesTrieSignal: {
            _enum: {
                NewConfiguration: 'Option<ChangesTrieConfiguration>'
            }
        },
        ConsensusEngineId: 'GenericConsensusEngineId',
        CodecHash: 'Hash',
        CrateVersion: {
            major: 'u16',
            minor: 'u8',
            patch: 'u8'
        },
        Digest: {
            logs: 'Vec<DigestItem>'
        },
        DigestItem: {
            _enum: {
                Other: 'Bytes', // 0
                AuthoritiesChange: 'Vec<AuthorityId>', // 1
                ChangesTrieRoot: 'Hash', // 2
                SealV0: 'SealV0', // 3
                Consensus: 'Consensus', // 4
                Seal: 'Seal', // 5
                PreRuntime: 'PreRuntime', // 6
                ChangesTrieSignal: 'ChangesTrieSignal', // 7
                RuntimeEnvironmentUpdated: 'Null' // 8
            }
        },
        ExtrinsicsWeight: {
            normal: 'Weight',
            operational: 'Weight'
        },
        H32: '[u8; 4; H32]',
        H64: '[u8; 8; H64]',
        H128: '[u8; 16; H128]',
        H160: '[u8; 20; H160]',
        H256: '[u8; 32; H256]',
        H512: '[u8; 64; H512]',
        H1024: '[u8; 128; H1024]',
        H2048: '[u8; 256; H2048]',
        Hash: 'H256',
        Header: {
            parentHash: 'Hash',
            number: 'Compact<BlockNumber>',
            stateRoot: 'Hash',
            extrinsicsRoot: 'Hash',
            digest: 'Digest'
        },
        HeaderPartial: {
            parentHash: 'Hash',
            // since we only parse JSON with this, having non-compact works
            number: 'BlockNumber'
        },
        IndicesLookupSource: 'GenericLookupSource',
        Index: 'u32',
        Justification: '(ConsensusEngineId, EncodedJustification)',
        EncodedJustification: 'Bytes',
        Justifications: 'Vec<Justification>',
        KeyValue: '(StorageKey, StorageData)',
        KeyTypeId: 'u32',
        LockIdentifier: '[u8; 8]',
        LookupSource: 'MultiAddress',
        LookupTarget: 'AccountId',
        ModuleId: 'LockIdentifier',
        MultiAddress: 'GenericMultiAddress',
        MultiSigner: {
            _enum: {
                Ed25519: '[u8; 32]',
                Sr25519: '[u8; 32]',
                Ecdsa: '[u8; 33]'
            }
        },
        Moment: 'UInt<64, Moment>',
        OpaqueCall: 'Bytes',
        Origin: 'DoNotConstruct<Origin>',
        OriginCaller: {
            _enum: {
                // this should be dynamically built from the actual modules, based on index
                System: 'SystemOrigin'
            }
        },
        PalletId: 'LockIdentifier',
        PalletsOrigin: 'OriginCaller',
        PalletVersion: {
            major: 'u16',
            minor: 'u8',
            patch: 'u8'
        },
        Pays: {
            _enum: ['Yes', 'No']
        },
        Phantom: 'Null',
        PhantomData: 'Null',
        Releases: {
            _enum: ['V1', 'V2', 'V3', 'V4', 'V5', 'V6', 'V7', 'V8', 'V9', 'V10']
        },
        RuntimeCall: 'Call',
        RuntimeEvent: 'Event',
        RuntimeDbWeight: {
            read: 'Weight',
            write: 'Weight'
        },
        SignedBlock: 'SignedBlockWithJustifications',
        SignedBlockWithJustification: {
            block: 'Block',
            justification: 'Option<EncodedJustification>'
        },
        SignedBlockWithJustifications: {
            block: 'Block',
            justifications: 'Option<Justifications>'
        },
        Slot: 'u64',
        SlotDuration: 'u64',
        StorageData: 'Bytes',
        StorageInfo: {
            palletName: 'Bytes',
            storage_name: 'Bytes',
            prefix: 'Bytes',
            maxValues: 'Option<u32>',
            maxSize: 'Option<u32>'
        },
        StorageProof: {
            trieNodes: 'Vec<Bytes>'
        },
        TransactionPriority: 'u64',
        TransactionLongevity: 'u64',
        TransactionTag: 'Bytes',
        TransactionInfo: {
            _alias: {
                dataSize: 'size'
            },
            chunkRoot: 'H256',
            contentHash: 'H256',
            dataSize: 'u32',
            blockChunks: 'u32'
        },
        TransactionStorageProof: {
            chunk: 'Vec<u8>',
            proof: 'Vec<Vec<u8>>'
        },
        ValidatorId: 'AccountId',
        ValidatorIdOf: 'ValidatorId',
        WeightV0: 'u32',
        WeightV1: 'u64',
        WeightV2: {
            refTime: 'Compact<u64>',
            proofSize: 'Compact<u64>'
        },
        Weight: 'WeightV2',
        WeightMultiplier: 'Fixed64',
        // digest
        PreRuntime: '(ConsensusEngineId, Bytes)',
        SealV0: '(u64, Signature)',
        Seal: '(ConsensusEngineId, Bytes)',
        Consensus: '(ConsensusEngineId, Bytes)',
        // Type when core initialize_block went from v4 to v5
        ExtrinsicInclusionMode: {
            _enum: ['AllExtrinsics', 'OnlyInherents']
        }
    }
};

/* eslint-disable sort-keys */
const v0$1 = {
    Si0Field: {
        name: 'Option<Text>',
        type: 'Si0LookupTypeId',
        typeName: 'Option<Text>',
        docs: 'Vec<Text>'
    },
    Si0LookupTypeId: 'u32',
    Si0Path: 'Vec<Text>',
    Si0Type: {
        path: 'Si0Path',
        params: 'Vec<Si0LookupTypeId>',
        def: 'Si0TypeDef'
    },
    Si0TypeDef: {
        _enum: {
            Composite: 'Si0TypeDefComposite',
            Variant: 'Si0TypeDefVariant',
            Sequence: 'Si0TypeDefSequence',
            Array: 'Si0TypeDefArray',
            Tuple: 'Si0TypeDefTuple',
            Primitive: 'Si0TypeDefPrimitive',
            Compact: 'Si0TypeDefCompact',
            Phantom: 'Si0TypeDefPhantom',
            BitSequence: 'Si0TypeDefBitSequence'
        }
    },
    Si0TypeDefArray: {
        len: 'u32',
        type: 'Si0LookupTypeId'
    },
    Si0TypeDefBitSequence: {
        bitStoreType: 'Si0LookupTypeId',
        bitOrderType: 'Si0LookupTypeId'
    },
    Si0TypeDefCompact: {
        type: 'Si0LookupTypeId'
    },
    Si0TypeDefComposite: {
        fields: 'Vec<Si0Field>'
    },
    Si0TypeDefPhantom: 'Null',
    Si0TypeDefVariant: {
        variants: 'Vec<Si0Variant>'
    },
    Si0TypeDefPrimitive: {
        _enum: ['Bool', 'Char', 'Str', 'U8', 'U16', 'U32', 'U64', 'U128', 'U256', 'I8', 'I16', 'I32', 'I64', 'I128', 'I256']
    },
    Si0TypeDefSequence: {
        type: 'Si0LookupTypeId'
    },
    Si0TypeDefTuple: 'Vec<Si0LookupTypeId>',
    Si0TypeParameter: {
        name: 'Text',
        type: 'Option<Si0LookupTypeId>'
    },
    Si0Variant: {
        name: 'Text',
        fields: 'Vec<Si0Field>',
        index: 'Option<u8>',
        discriminant: 'Option<u64>',
        docs: 'Vec<Text>'
    }
};

/* eslint-disable sort-keys */
var definitions$1a = {
    rpc: {},
    types: {
        ...v0$1,
        ...v1$1,
        // latest mappings
        SiField: 'Si1Field',
        SiLookupTypeId: 'Si1LookupTypeId',
        SiPath: 'Si1Path',
        SiType: 'Si1Type',
        SiTypeDef: 'Si1TypeDef',
        SiTypeDefArray: 'Si1TypeDefArray',
        SiTypeDefBitSequence: 'Si1TypeDefBitSequence',
        SiTypeDefCompact: 'Si1TypeDefCompact',
        SiTypeDefComposite: 'Si1TypeDefComposite',
        SiTypeDefPrimitive: 'Si1TypeDefPrimitive',
        SiTypeDefSequence: 'Si1TypeDefSequence',
        SiTypeDefTuple: 'Si1TypeDefTuple',
        SiTypeParameter: 'Si1TypeParameter',
        SiTypeDefVariant: 'Si1TypeDefVariant',
        SiVariant: 'Si1Variant'
    }
};

const runtime$x = {
    AssetConversionApi: [
        {
            methods: {
                get_reserves: {
                    description: 'Get pool reserves',
                    params: [
                        {
                            name: 'asset1',
                            type: 'StagingXcmV3MultiLocation'
                        },
                        {
                            name: 'asset2',
                            type: 'StagingXcmV3MultiLocation'
                        }
                    ],
                    type: 'Option<(Balance,Balance)>'
                },
                quote_price_exact_tokens_for_tokens: {
                    description: 'Quote price: exact tokens for tokens',
                    params: [
                        {
                            name: 'asset1',
                            type: 'StagingXcmV3MultiLocation'
                        },
                        {
                            name: 'asset2',
                            type: 'StagingXcmV3MultiLocation'
                        },
                        {
                            name: 'amount',
                            type: 'u128'
                        },
                        {
                            name: 'include_fee',
                            type: 'bool'
                        }
                    ],
                    type: 'Option<(Balance)>'
                },
                quote_price_tokens_for_exact_tokens: {
                    description: 'Quote price: tokens for exact tokens',
                    params: [
                        {
                            name: 'asset1',
                            type: 'StagingXcmV3MultiLocation'
                        },
                        {
                            name: 'asset2',
                            type: 'StagingXcmV3MultiLocation'
                        },
                        {
                            name: 'amount',
                            type: 'u128'
                        },
                        {
                            name: 'include_fee',
                            type: 'bool'
                        }
                    ],
                    type: 'Option<(Balance)>'
                }
            },
            version: 1
        }
    ]
};

var definitions$19 = {
    rpc: {},
    runtime: runtime$x,
    types: {
        TAssetConversion: 'Option<MultiLocation>'
    }
};

const runtime$w = {
    AssetsApi: [
        {
            methods: {
                account_balances: {
                    description: 'Return the current set of authorities.',
                    params: [
                        {
                            name: 'account',
                            type: 'AccountId'
                        }
                    ],
                    type: 'Vec<(u32, TAssetBalance)>'
                }
            },
            version: 1
        }
    ]
};

var definitions$18 = {
    rpc: {},
    runtime: runtime$w,
    types: {
        AssetApprovalKey: {
            owner: 'AccountId',
            delegate: 'AccountId'
        },
        AssetApproval: {
            amount: 'TAssetBalance',
            deposit: 'TAssetDepositBalance'
        },
        AssetBalance: {
            balance: 'TAssetBalance',
            isFrozen: 'bool',
            isSufficient: 'bool'
        },
        AssetDestroyWitness: {
            accounts: 'Compact<u32>',
            sufficients: 'Compact<u32>',
            approvals: 'Compact<u32>'
        },
        AssetDetails: {
            owner: 'AccountId',
            issuer: 'AccountId',
            admin: 'AccountId',
            freezer: 'AccountId',
            supply: 'TAssetBalance',
            deposit: 'TAssetDepositBalance',
            minBalance: 'TAssetBalance',
            isSufficient: 'bool',
            accounts: 'u32',
            sufficients: 'u32',
            approvals: 'u32',
            isFrozen: 'bool'
        },
        AssetMetadata: {
            deposit: 'TAssetDepositBalance',
            name: 'Vec<u8>',
            symbol: 'Vec<u8>',
            decimals: 'u8',
            isFrozen: 'bool'
        },
        TAssetBalance: 'u64',
        TAssetDepositBalance: 'BalanceOf'
    }
};

const runtime$v = {
    AuraApi: [
        {
            methods: {
                authorities: {
                    description: 'Return the current set of authorities.',
                    params: [],
                    type: 'Vec<AuthorityId>'
                },
                slot_duration: {
                    description: 'Returns the slot duration for Aura.',
                    params: [],
                    type: 'SlotDuration'
                }
            },
            version: 1
        }
    ]
};

var definitions$17 = {
    rpc: {},
    runtime: runtime$v,
    types: {
        RawAuraPreDigest: {
            slotNumber: 'u64'
        }
    }
};

var definitions$16 = {
    rpc: {},
    types: {
        UncleEntryItem: {
            _enum: {
                InclusionHeight: 'BlockNumber',
                Uncle: '(Hash, Option<AccountId>)'
            }
        }
    }
};

const rpc$g = {
    epochAuthorship: {
        description: 'Returns data about which slots (primary or secondary) can be claimed in the current epoch with the keys in the keystore',
        isUnsafe: true,
        params: [],
        type: 'HashMap<AuthorityId, EpochAuthorship>'
    }
};

const V1_V2_SHARED = {
    current_epoch: {
        description: 'Returns information regarding the current epoch.',
        params: [],
        type: 'Epoch'
    },
    current_epoch_start: {
        description: 'Returns the slot that started the current epoch.',
        params: [],
        type: 'Slot'
    },
    generate_key_ownership_proof: {
        description: 'Generates a proof of key ownership for the given authority in the current epoch.',
        params: [
            {
                name: 'slot',
                type: 'Slot'
            },
            {
                name: 'authorityId',
                type: 'AuthorityId'
            }
        ],
        type: 'Option<OpaqueKeyOwnershipProof>'
    },
    next_epoch: {
        description: 'Returns information regarding the next epoch (which was already previously announced).',
        params: [],
        type: 'Epoch'
    },
    submit_report_equivocation_unsigned_extrinsic: {
        description: 'Submits an unsigned extrinsic to report an equivocation.',
        params: [
            {
                name: 'equivocationProof',
                type: 'BabeEquivocationProof'
            },
            {
                name: 'keyOwnerProof',
                type: 'OpaqueKeyOwnershipProof'
            }
        ],
        type: 'Option<Null>'
    }
};
const runtime$u = {
    BabeApi: [
        {
            methods: {
                configuration: {
                    description: 'Return the genesis configuration for BABE. The configuration is only read on genesis.',
                    params: [],
                    type: 'BabeGenesisConfiguration'
                },
                ...V1_V2_SHARED
            },
            version: 2
        },
        {
            methods: {
                configuration: {
                    description: 'Return the configuration for BABE. Version 1.',
                    params: [],
                    type: 'BabeGenesisConfigurationV1'
                },
                ...V1_V2_SHARED
            },
            version: 1
        }
    ]
};

var definitions$15 = {
    rpc: rpc$g,
    runtime: runtime$u,
    types: {
        AllowedSlots: {
            _enum: ['PrimarySlots', 'PrimaryAndSecondaryPlainSlots', 'PrimaryAndSecondaryVRFSlots']
        },
        BabeAuthorityWeight: 'u64',
        BabeEpochConfiguration: {
            c: '(u64, u64)',
            allowedSlots: 'AllowedSlots'
        },
        BabeBlockWeight: 'u32',
        BabeEquivocationProof: {
            offender: 'AuthorityId',
            slotNumber: 'SlotNumber',
            firstHeader: 'Header',
            secondHeader: 'Header'
        },
        BabeGenesisConfiguration: {
            slotDuration: 'u64',
            epochLength: 'u64',
            c: '(u64, u64)',
            genesisAuthorities: 'Vec<(AuthorityId, BabeAuthorityWeight)>',
            randomness: 'Randomness',
            allowedSlots: 'AllowedSlots'
        },
        BabeGenesisConfigurationV1: {
            slotDuration: 'u64',
            epochLength: 'u64',
            c: '(u64, u64)',
            genesisAuthorities: 'Vec<(AuthorityId, BabeAuthorityWeight)>',
            randomness: 'Randomness',
            secondarySlots: 'bool'
        },
        BabeWeight: 'u64',
        MaybeRandomness: 'Option<Randomness>',
        MaybeVrf: 'Option<VrfData>',
        Epoch: {
            epochIndex: 'u64',
            startSlot: 'Slot',
            duration: 'u64',
            authorities: 'Vec<(AuthorityId, BabeAuthorityWeight)>',
            randomness: 'Hash', // [u8; VRF_OUTPUT_LENGTH],
            config: 'BabeEpochConfiguration'
        },
        EpochAuthorship: {
            primary: 'Vec<u64>',
            secondary: 'Vec<u64>',
            secondary_vrf: 'Vec<u64>'
        },
        NextConfigDescriptor: {
            _enum: {
                V0: 'Null',
                V1: 'NextConfigDescriptorV1'
            }
        },
        NextConfigDescriptorV1: {
            c: '(u64, u64)',
            allowedSlots: 'AllowedSlots'
        },
        OpaqueKeyOwnershipProof: 'Bytes',
        Randomness: 'Hash', // [u8; RANDOMNESS_LENGTH],
        RawBabePreDigest: {
            _enum: {
                Phantom: 'Null', // index starts at 1... empty slot at 0
                Primary: 'RawBabePreDigestPrimary',
                SecondaryPlain: 'RawBabePreDigestSecondaryPlain',
                SecondaryVRF: 'RawBabePreDigestSecondaryVRF'
            }
        },
        RawBabePreDigestPrimary: {
            authorityIndex: 'u32', // AuthorityIndex (also in aura)
            slotNumber: 'SlotNumber',
            vrfOutput: 'VrfOutput',
            vrfProof: 'VrfProof'
        },
        RawBabePreDigestSecondaryPlain: {
            authorityIndex: 'u32', // AuthorityIndex (also in aura)
            slotNumber: 'SlotNumber'
        },
        RawBabePreDigestSecondaryVRF: {
            authorityIndex: 'u32',
            slotNumber: 'SlotNumber',
            vrfOutput: 'VrfOutput',
            vrfProof: 'VrfProof'
        },
        RawBabePreDigestTo159: {
            _enum: {
                Primary: 'RawBabePreDigestPrimaryTo159',
                Secondary: 'RawBabePreDigestSecondaryTo159'
            }
        },
        RawBabePreDigestPrimaryTo159: {
            authorityIndex: 'u32',
            slotNumber: 'SlotNumber',
            weight: 'BabeBlockWeight',
            vrfOutput: 'VrfOutput',
            vrfProof: 'VrfProof'
        },
        RawBabePreDigestSecondaryTo159: {
            authorityIndex: 'u32',
            slotNumber: 'SlotNumber',
            weight: 'BabeBlockWeight'
        },
        // a cross old/new compatible version of the digest, that is _only_ useful
        // for partial parsing and extraction of the author. This assumes that all
        // entries has the authorityIndex in the first position - and that it is all
        // we are interested in
        RawBabePreDigestCompat: {
            _enum: {
                Zero: 'u32',
                One: 'u32',
                Two: 'u32',
                Three: 'u32'
            }
        },
        SlotNumber: 'u64',
        VrfData: '[u8; 32]',
        VrfOutput: '[u8; 32]',
        VrfProof: '[u8; 64]'
    }
};

var definitions$14 = {
    rpc: {},
    types: {
        AccountData: {
            free: 'Balance',
            reserved: 'Balance',
            miscFrozen: 'Balance',
            feeFrozen: 'Balance'
        },
        BalanceLockTo212: {
            id: 'LockIdentifier',
            amount: 'Balance',
            until: 'BlockNumber',
            reasons: 'WithdrawReasons'
        },
        BalanceLock: {
            id: 'LockIdentifier',
            amount: 'Balance',
            reasons: 'Reasons'
        },
        BalanceStatus: {
            _enum: ['Free', 'Reserved']
        },
        Reasons: {
            _enum: ['Fee', 'Misc', 'All']
        },
        ReserveData: {
            id: 'ReserveIdentifier',
            amount: 'Balance'
        },
        ReserveIdentifier: '[u8; 8]',
        VestingSchedule: {
            offset: 'Balance',
            perBlock: 'Balance',
            startingBlock: 'BlockNumber'
        },
        WithdrawReasons: {
            _set: {
                TransactionPayment: 0b0000_0001,
                Transfer: 0b0000_0010,
                Reserve: 0b0000_0100,
                Fee: 0b0000_1000,
                Tip: 0b0001_0000
            }
        }
    }
};

const rpc$f = {
    getFinalizedHead: {
        description: 'Returns hash of the latest BEEFY finalized block as seen by this client.',
        params: [],
        type: 'H256'
    },
    subscribeJustifications: {
        description: 'Returns the block most recently finalized by BEEFY, alongside its justification.',
        params: [],
        pubsub: [
            'justifications',
            'subscribeJustifications',
            'unsubscribeJustifications'
        ],
        type: 'BeefyVersionedFinalityProof'
    }
};

const BEEFY_V3 = {
    beefy_genesis: {
        description: 'Return the block number where BEEFY consensus is enabled/started',
        params: [],
        type: 'Option<BlockNumber>'
    },
    generate_key_ownership_proof: {
        description: 'Generates a proof of key ownership for the given authority in the given set.',
        params: [
            {
                name: 'setId',
                type: 'ValidatorSetId'
            },
            {
                name: 'authorityId',
                type: 'AuthorityId'
            }
        ],
        type: 'Option<OpaqueKeyOwnershipProof>'
    },
    validator_set: {
        description: 'Return the current active BEEFY validator set',
        params: [],
        type: 'Option<ValidatorSet>'
    }
};
const BEEFY_V1_V3 = {
    ...BEEFY_V3,
    submit_report_equivocation_unsigned_extrinsic: {
        description: 'Submits an unsigned extrinsic to report an equivocation.',
        params: [
            {
                name: 'equivocationProof',
                type: 'BeefyEquivocationProof'
            },
            {
                name: 'keyOwnerProof',
                type: 'OpaqueKeyOwnershipProof'
            }
        ],
        type: 'Option<Null>'
    }
};
const BEEFY_V4 = {
    ...BEEFY_V3,
    submit_report_double_voting_unsigned_extrinsic: {
        description: 'Submits an unsigned extrinsic to report a double voting equivocation.',
        params: [
            {
                name: 'equivocationProof',
                type: 'SpConsensusBeefyDoubleVotingProof'
            },
            {
                name: 'keyOwnerProof',
                type: 'OpaqueKeyOwnershipProof'
            }
        ],
        type: 'Option<Null>'
    }
};
const BEEFY_MMR_V1 = {
    authority_set_proof: {
        description: 'Return the currently active BEEFY authority set proof.',
        params: [],
        type: 'BeefyAuthoritySet'
    },
    next_authority_set_proof: {
        description: 'Return the next/queued BEEFY authority set proof.',
        params: [],
        type: 'BeefyNextAuthoritySet'
    }
};
const runtime$t = {
    BeefyApi: [
        {
            methods: BEEFY_V4,
            version: 4
        },
        {
            methods: BEEFY_V1_V3,
            version: 3
        },
        {
            methods: BEEFY_V1_V3,
            version: 2
        },
        {
            methods: BEEFY_V1_V3,
            version: 1
        }
    ],
    BeefyMmrApi: [
        {
            methods: BEEFY_MMR_V1,
            version: 1
        }
    ]
};

var definitions$13 = {
    rpc: rpc$f,
    runtime: runtime$t,
    types: {
        BeefyAuthoritySet: {
            id: 'u64',
            len: 'u32',
            root: 'H256'
        },
        BeefyCommitment: {
            payload: 'BeefyPayload',
            blockNumber: 'BlockNumber',
            validatorSetId: 'ValidatorSetId'
        },
        BeefyId: '[u8; 33]',
        BeefyEquivocationProof: {
            first: 'BeefyVoteMessage',
            second: 'BeefyVoteMessage'
        },
        BeefyCompactSignedCommitment: {
            commitment: 'BeefyCommitment',
            signaturesFrom: 'Vec<u8>',
            validatorSetLen: 'u32',
            signaturesCompact: 'Vec<EcdsaSignature>'
        },
        BeefySignedCommitment: {
            commitment: 'BeefyCommitment',
            signatures: 'Vec<Option<EcdsaSignature>>'
        },
        BeefyVersionedFinalityProof: {
            _enum: {
                V0: 'Null',
                V1: 'BeefyCompactSignedCommitment'
            }
        },
        BeefyNextAuthoritySet: {
            id: 'u64',
            len: 'u32',
            root: 'H256'
        },
        BeefyPayload: 'Vec<(BeefyPayloadId, Bytes)>',
        BeefyPayloadId: '[u8;2]',
        BeefyVoteMessage: {
            commitment: 'BeefyCommitment',
            id: 'AuthorityId',
            signature: 'Signature'
        },
        MmrRootHash: 'H256',
        ValidatorSetId: 'u64',
        ValidatorSet: {
            validators: 'Vec<AuthorityId>',
            id: 'ValidatorSetId'
        }
    }
};

const runtime$s = {
    Benchmark: [
        {
            methods: {
                benchmark_metadata: {
                    description: 'Get the benchmark metadata available for this runtime.',
                    params: [
                        {
                            name: 'extra',
                            type: 'bool'
                        }
                    ],
                    type: '(Vec<BenchmarkList>, Vec<StorageInfo>)'
                },
                dispatch_benchmark: {
                    description: 'Dispatch the given benchmark.',
                    params: [
                        {
                            name: 'config',
                            type: 'BenchmarkConfig'
                        }
                    ],
                    type: 'Result<Vec<BenchmarkBatch>, Text>'
                }
            },
            version: 1
        }
    ]
};

var definitions$12 = {
    rpc: {},
    runtime: runtime$s,
    types: {
        BenchmarkBatch: {
            pallet: 'Text',
            instance: 'Text',
            benchmark: 'Text',
            results: 'Vec<BenchmarkResult>'
        },
        BenchmarkConfig: {
            pallet: 'Bytes',
            benchmark: 'Bytes',
            selectedComponents: 'Vec<(BenchmarkParameter, u32)>',
            verify: 'bool',
            internalRepeats: 'u32'
        },
        BenchmarkList: {
            pallet: 'Bytes',
            instance: 'Bytes',
            benchmarks: 'Vec<BenchmarkMetadata>'
        },
        BenchmarkMetadata: {
            name: 'Bytes',
            components: 'Vec<(BenchmarkParameter, u32, u32)>'
        },
        BenchmarkParameter: {
            _enum: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
        },
        BenchmarkResult: {
            components: 'Vec<(BenchmarkParameter, u32)>',
            extrinsicTime: 'u128',
            storageRootTime: 'u128',
            reads: 'u32',
            repeatReads: 'u32',
            writes: 'u32',
            repeatWrites: 'u32',
            proofSize: 'u32',
            benchKeys: 'Vec<(Vec<u8>, u32, u32, bool)>'
        }
    }
};

const BB_V2_TO_V4 = {
    // this was removed after V4
    random_seed: {
        description: 'Generate a random seed.',
        params: [],
        type: 'Hash'
    }
};
const BB_V2_TO_V5 = {
    apply_extrinsic: {
        description: 'Apply the given extrinsic.',
        params: [
            {
                name: 'extrinsic',
                type: 'Extrinsic'
            }
        ],
        type: 'ApplyExtrinsicResultPre6'
    }
};
const BB_V2_TO_V6 = {
    check_inherents: {
        description: 'Check that the inherents are valid.',
        params: [
            {
                name: 'block',
                type: 'Block'
            },
            {
                name: 'data',
                type: 'InherentData'
            }
        ],
        type: 'CheckInherentsResult'
    },
    inherent_extrinsics: {
        description: 'Generate inherent extrinsics.',
        params: [
            {
                name: 'inherent',
                type: 'InherentData'
            }
        ],
        type: 'Vec<Extrinsic>'
    }
};
const BB_V3_TO_V6 = {
    // renamed in v3 from finalize_block
    finalize_block: {
        description: 'Finish the current block.',
        params: [],
        type: 'Header'
    }
};
const runtime$r = {
    BlockBuilder: [
        {
            methods: {
                apply_extrinsic: {
                    description: 'Apply the given extrinsic.',
                    params: [
                        {
                            name: 'extrinsic',
                            type: 'Extrinsic'
                        }
                    ],
                    type: 'ApplyExtrinsicResult'
                },
                ...BB_V2_TO_V6,
                ...BB_V3_TO_V6
            },
            version: 6
        },
        {
            methods: {
                // apply_extrinsic result changed in 6
                ...BB_V2_TO_V5,
                ...BB_V2_TO_V6,
                ...BB_V3_TO_V6
            },
            version: 5
        },
        {
            methods: {
                // random_seed removed
                ...BB_V2_TO_V4,
                ...BB_V2_TO_V5,
                ...BB_V2_TO_V6,
                ...BB_V3_TO_V6
            },
            version: 4
        },
        {
            methods: {
                // finalize_block renamed
                ...BB_V2_TO_V4,
                ...BB_V2_TO_V6,
                ...BB_V3_TO_V6
            },
            version: 3
        },
        {
            methods: {
                finalise_block: {
                    description: 'Finish the current block.',
                    params: [],
                    type: 'Header'
                },
                ...BB_V2_TO_V4,
                ...BB_V2_TO_V6
            },
            version: 2
        }
    ]
};

var definitions$11 = {
    rpc: {},
    runtime: runtime$r,
    types: {
        CheckInherentsResult: {
            okay: 'bool',
            fatalError: 'bool',
            errors: 'InherentData'
        },
        InherentData: {
            data: 'BTreeMap<InherentIdentifier, Bytes>'
        },
        InherentIdentifier: '[u8; 8]'
    }
};

var definitions$10 = {
    rpc: {},
    types: {
        CollectiveOrigin: {
            _enum: {
                Members: '(MemberCount, MemberCount)',
                Member: 'AccountId'
            }
        },
        MemberCount: 'u32',
        ProposalIndex: 'u32',
        VotesTo230: {
            index: 'ProposalIndex',
            threshold: 'MemberCount',
            ayes: 'Vec<AccountId>',
            nays: 'Vec<AccountId>'
        },
        Votes: {
            index: 'ProposalIndex',
            threshold: 'MemberCount',
            ayes: 'Vec<AccountId>',
            nays: 'Vec<AccountId>',
            end: 'BlockNumber'
        }
    }
};

var definitions$$ = {
    rpc: {},
    types: {
        AuthorityId: 'AccountId',
        RawVRFOutput: '[u8; 32]'
    }
};

const rpc$e = {
    call: {
        deprecated: 'Use the runtime interface `api.call.contractsApi.call` instead',
        description: 'Executes a call to a contract',
        params: [
            {
                name: 'callRequest',
                type: 'ContractCallRequest'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'ContractExecResult'
    },
    getStorage: {
        deprecated: 'Use the runtime interface `api.call.contractsApi.getStorage` instead',
        description: 'Returns the value under a specified storage key in a contract',
        params: [
            {
                name: 'address',
                type: 'AccountId'
            },
            {
                name: 'key',
                type: 'H256'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'Option<Bytes>'
    },
    instantiate: {
        deprecated: 'Use the runtime interface `api.call.contractsApi.instantiate` instead',
        description: 'Instantiate a new contract',
        params: [
            {
                name: 'request',
                type: 'InstantiateRequestV1'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'ContractInstantiateResult'
    },
    rentProjection: {
        deprecated: 'Not available in newer versions of the contracts interfaces',
        description: 'Returns the projected time a given contract will be able to sustain paying its rent',
        params: [
            {
                name: 'address',
                type: 'AccountId'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'Option<BlockNumber>'
    },
    uploadCode: {
        deprecated: 'Use the runtime interface `api.call.contractsApi.uploadCode` instead',
        description: 'Upload new code without instantiating a contract from it',
        // The RPC here is terribly misnamed - somebody forgot how the RPCs
        // are actually done, ie. <module>_<camelCasedMethod>
        endpoint: 'contracts_upload_code',
        params: [
            {
                name: 'uploadRequest',
                type: 'CodeUploadRequest'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'CodeUploadResult'
    }
};

const SHARED_V1_V2 = {
    get_storage: {
        description: 'Query a given storage key in a given contract.',
        params: [
            {
                name: 'address',
                type: 'AccountId'
            },
            {
                name: 'key',
                type: 'Bytes'
            }
        ],
        type: 'Option<Bytes>'
    },
    upload_code: {
        description: 'Upload new code without instantiating a contract from it.',
        params: [
            {
                name: 'origin',
                type: 'AccountId'
            },
            {
                name: 'code',
                type: 'Bytes'
            },
            {
                name: 'storageDepositLimit',
                type: 'Option<Balance>'
            }
        ],
        type: 'CodeUploadResult'
    }
};
const runtime$q = {
    ContractsApi: [
        {
            methods: {
                call: {
                    description: 'Perform a call from a specified account to a given contract.',
                    params: [
                        {
                            name: 'origin',
                            type: 'AccountId'
                        },
                        {
                            name: 'dest',
                            type: 'AccountId'
                        },
                        {
                            name: 'value',
                            type: 'Balance'
                        },
                        {
                            name: 'gasLimit',
                            type: 'Option<WeightV2>'
                        },
                        {
                            name: 'storageDepositLimit',
                            type: 'Option<Balance>'
                        },
                        {
                            name: 'inputData',
                            type: 'Vec<u8>'
                        }
                    ],
                    type: 'ContractExecResult'
                },
                instantiate: {
                    description: 'Instantiate a new contract.',
                    params: [
                        {
                            name: 'origin',
                            type: 'AccountId'
                        },
                        {
                            name: 'value',
                            type: 'Balance'
                        },
                        {
                            name: 'gasLimit',
                            type: 'Option<WeightV2>'
                        },
                        {
                            name: 'storageDepositLimit',
                            type: 'Option<Balance>'
                        },
                        {
                            name: 'code',
                            type: 'CodeSource'
                        },
                        {
                            name: 'data',
                            type: 'Bytes'
                        },
                        {
                            name: 'salt',
                            type: 'Bytes'
                        }
                    ],
                    type: 'ContractInstantiateResult'
                },
                ...SHARED_V1_V2
            },
            version: 2
        },
        {
            methods: {
                call: {
                    description: 'Perform a call from a specified account to a given contract.',
                    params: [
                        {
                            name: 'origin',
                            type: 'AccountId'
                        },
                        {
                            name: 'dest',
                            type: 'AccountId'
                        },
                        {
                            name: 'value',
                            type: 'Balance'
                        },
                        {
                            name: 'gasLimit',
                            type: 'u64'
                        },
                        {
                            name: 'storageDepositLimit',
                            type: 'Option<Balance>'
                        },
                        {
                            name: 'inputData',
                            type: 'Vec<u8>'
                        }
                    ],
                    type: 'ContractExecResultU64'
                },
                instantiate: {
                    description: 'Instantiate a new contract.',
                    params: [
                        {
                            name: 'origin',
                            type: 'AccountId'
                        },
                        {
                            name: 'value',
                            type: 'Balance'
                        },
                        {
                            name: 'gasLimit',
                            type: 'u64'
                        },
                        {
                            name: 'storageDepositLimit',
                            type: 'Option<Balance>'
                        },
                        {
                            name: 'code',
                            type: 'CodeSource'
                        },
                        {
                            name: 'data',
                            type: 'Bytes'
                        },
                        {
                            name: 'salt',
                            type: 'Bytes'
                        }
                    ],
                    type: 'ContractInstantiateResultU64'
                },
                ...SHARED_V1_V2
            },
            version: 1
        }
    ]
};

var definitions$_ = {
    rpc: rpc$e,
    runtime: runtime$q,
    types: {
        AliveContractInfo: {
            trieId: 'TrieId',
            storageSize: 'u32',
            pairCount: 'u32',
            codeHash: 'CodeHash',
            rentAllowance: 'Balance',
            rentPaid: 'Balance',
            deductBlock: 'BlockNumber',
            lastWrite: 'Option<BlockNumber>',
            _reserved: 'Option<Null>'
        },
        CodeHash: 'Hash',
        CodeSource: {
            _enum: {
                Upload: 'Bytes',
                Existing: 'Hash'
            }
        },
        CodeUploadRequest: {
            origin: 'AccountId',
            code: 'Bytes',
            storageDepositLimit: 'Option<Balance>'
        },
        CodeUploadResult: 'Result<CodeUploadResultValue, DispatchError>',
        CodeUploadResultValue: {
            codeHash: 'CodeHash',
            deposit: 'Balance'
        },
        ContractCallRequest: {
            origin: 'AccountId',
            dest: 'AccountId',
            value: 'Balance',
            gasLimit: 'u64',
            storageDepositLimit: 'Option<Balance>',
            inputData: 'Bytes'
        },
        ContractExecResultSuccessTo255: {
            status: 'u8',
            data: 'Raw'
        },
        ContractExecResultTo255: {
            _enum: {
                Success: 'ContractExecResultSuccessTo255',
                Error: 'Null'
            }
        },
        ContractExecResultSuccessTo260: {
            flags: 'ContractReturnFlags',
            data: 'Bytes',
            gasConsumed: 'u64'
        },
        ContractExecResultTo260: {
            _enum: {
                Success: 'ContractExecResultSuccessTo260',
                Error: 'Null'
            }
        },
        ContractExecResultOk: {
            flags: 'ContractReturnFlags',
            data: 'Bytes'
        },
        ContractExecResultResult: 'Result<ContractExecResultOk, DispatchError>',
        ContractExecResultTo267: {
            gasConsumed: 'u64',
            debugMessage: 'Text',
            result: 'ContractExecResultResult'
        },
        ContractExecResult: {
            gasConsumed: 'Weight',
            gasRequired: 'Weight',
            storageDeposit: 'StorageDeposit',
            debugMessage: 'Text',
            result: 'ContractExecResultResult'
        },
        ContractExecResultU64: {
            gasConsumed: 'u64',
            gasRequired: 'u64',
            storageDeposit: 'StorageDeposit',
            debugMessage: 'Text',
            result: 'ContractExecResultResult'
        },
        ContractInfo: {
            _enum: {
                Alive: 'AliveContractInfo',
                Tombstone: 'TombstoneContractInfo'
            }
        },
        ContractCallFlags: {
            _set: {
                _bitLength: 32,
                ForwardInput: 0b0000_0001,
                CloneInput: 0b0000_0010,
                TailCall: 0b0000_0100,
                AllowReentry: 0b0000_1000
            }
        },
        ContractReturnFlags: {
            _set: {
                _bitLength: 32,
                Revert: 0x0000_0001
            }
        },
        ContractStorageKey: '[u8; 32]',
        DeletedContract: {
            pairCount: 'u32',
            trieId: 'TrieId'
        },
        ExecReturnValue: {
            flags: 'ContractReturnFlags',
            data: 'Bytes'
        },
        Gas: 'u64',
        HostFnWeightsTo264: {
            caller: 'Weight',
            address: 'Weight',
            gasLeft: 'Weight',
            balance: 'Weight',
            valueTransferred: 'Weight',
            minimumBalance: 'Weight',
            tombstoneDeposit: 'Weight',
            rentAllowance: 'Weight',
            blockNumber: 'Weight',
            now: 'Weight',
            weightToFee: 'Weight',
            gas: 'Weight',
            input: 'Weight',
            inputPerByte: 'Weight',
            return: 'Weight',
            returnPerByte: 'Weight',
            terminate: 'Weight',
            restoreTo: 'Weight',
            restoreToPerDelta: 'Weight',
            random: 'Weight',
            depositEvent: 'Weight',
            depositEventPerTopic: 'Weight',
            depositEventPerByte: 'Weight',
            setRentAllowance: 'Weight',
            setStorage: 'Weight',
            setStoragePerByte: 'Weight',
            clearStorage: 'Weight',
            getStorage: 'Weight',
            getStoragePerByte: 'Weight',
            transfer: 'Weight',
            call: 'Weight',
            callTransferSurcharge: 'Weight',
            callPerInputByte: 'Weight',
            callPerOutputByte: 'Weight',
            instantiate: 'Weight',
            instantiatePerInputByte: 'Weight',
            instantiatePerOutputByte: 'Weight',
            hashSha2256: 'Weight',
            hashSha2256PerByte: 'Weight',
            hashKeccak256: 'Weight',
            hashKeccak256PerByte: 'Weight',
            hashBlake2256: 'Weight',
            hashBlake2256PerByte: 'Weight',
            hashBlake2128: 'Weight',
            hashBlake2128PerByte: 'Weight'
        },
        HostFnWeights: {
            caller: 'Weight',
            address: 'Weight',
            gasLeft: 'Weight',
            balance: 'Weight',
            valueTransferred: 'Weight',
            minimumBalance: 'Weight',
            tombstoneDeposit: 'Weight',
            rentAllowance: 'Weight',
            blockNumber: 'Weight',
            now: 'Weight',
            weightToFee: 'Weight',
            gas: 'Weight',
            input: 'Weight',
            inputPerByte: 'Weight',
            return: 'Weight',
            returnPerByte: 'Weight',
            terminate: 'Weight',
            terminatePerCodeByte: 'Weight',
            restoreTo: 'Weight',
            restoreToPerCallerCodeByte: 'Weight',
            restoreToPerTombstoneCodeByte: 'Weight',
            restoreToPerDelta: 'Weight',
            random: 'Weight',
            depositEvent: 'Weight',
            depositEventPerTopic: 'Weight',
            depositEventPerByte: 'Weight',
            setRentAllowance: 'Weight',
            setStorage: 'Weight',
            setStoragePerByte: 'Weight',
            clearStorage: 'Weight',
            getStorage: 'Weight',
            getStoragePerByte: 'Weight',
            transfer: 'Weight',
            call: 'Weight',
            callPerCodeByte: 'Weight',
            callTransferSurcharge: 'Weight',
            callPerInputByte: 'Weight',
            callPerOutputByte: 'Weight',
            instantiate: 'Weight',
            instantiatePerCodeByte: 'Weight',
            instantiatePerInputByte: 'Weight',
            instantiatePerOutputByte: 'Weight',
            instantiatePerSaltByte: 'Weight',
            hashSha2256: 'Weight',
            hashSha2256PerByte: 'Weight',
            hashKeccak256: 'Weight',
            hashKeccak256PerByte: 'Weight',
            hashBlake2256: 'Weight',
            hashBlake2256PerByte: 'Weight',
            hashBlake2128: 'Weight',
            hashBlake2128PerByte: 'Weight',
            rentParams: 'Weight'
        },
        InstantiateRequestV1: {
            origin: 'AccountId',
            value: 'Balance',
            gasLimit: 'Gas',
            code: 'Bytes',
            data: 'Bytes',
            salt: 'Bytes'
        },
        InstantiateRequestV2: {
            _fallback: 'InstantiateRequestV1',
            origin: 'AccountId',
            value: 'Balance',
            gasLimit: 'Gas',
            storageDepositLimit: 'Option<Balance>',
            code: 'Bytes',
            data: 'Bytes',
            salt: 'Bytes'
        },
        InstantiateRequest: {
            _fallback: 'InstantiateRequestV2',
            origin: 'AccountId',
            value: 'Balance',
            gasLimit: 'Gas',
            storageDepositLimit: 'Option<Balance>',
            code: 'CodeSource',
            data: 'Bytes',
            salt: 'Bytes'
        },
        ContractInstantiateResultTo267: 'Result<InstantiateReturnValueTo267, Null>',
        ContractInstantiateResultTo299: 'Result<InstantiateReturnValueOk, Null>',
        ContractInstantiateResult: {
            gasConsumed: 'WeightV2',
            gasRequired: 'WeightV2',
            storageDeposit: 'StorageDeposit',
            debugMessage: 'Text',
            result: 'InstantiateReturnValue'
        },
        ContractInstantiateResultU64: {
            // only this one can fail, the current version (above) _should_ be correctly
            // versioned now, aka no more deprecated RPCs involved, only runtime calls
            _fallback: 'ContractInstantiateResultTo299',
            gasConsumed: 'u64',
            gasRequired: 'u64',
            storageDeposit: 'StorageDeposit',
            debugMessage: 'Text',
            result: 'InstantiateReturnValue'
        },
        InstantiateReturnValueTo267: {
            result: 'ExecReturnValue',
            accountId: 'AccountId',
            rentProjection: 'Option<RentProjection>'
        },
        InstantiateReturnValueOk: {
            result: 'ExecReturnValue',
            accountId: 'AccountId'
        },
        InstantiateReturnValue: 'Result<InstantiateReturnValueOk, DispatchError>',
        InstructionWeights: {
            i64const: 'u32',
            i64load: 'u32',
            i64store: 'u32',
            select: 'u32',
            rIf: 'u32',
            br: 'u32',
            brIf: 'u32',
            brIable: 'u32',
            brIablePerEntry: 'u32',
            call: 'u32',
            callIndirect: 'u32',
            callIndirectPerParam: 'u32',
            localGet: 'u32',
            localSet: 'u32',
            local_tee: 'u32',
            globalGet: 'u32',
            globalSet: 'u32',
            memoryCurrent: 'u32',
            memoryGrow: 'u32',
            i64clz: 'u32',
            i64ctz: 'u32',
            i64popcnt: 'u32',
            i64eqz: 'u32',
            i64extendsi32: 'u32',
            i64extendui32: 'u32',
            i32wrapi64: 'u32',
            i64eq: 'u32',
            i64ne: 'u32',
            i64lts: 'u32',
            i64ltu: 'u32',
            i64gts: 'u32',
            i64gtu: 'u32',
            i64les: 'u32',
            i64leu: 'u32',
            i64ges: 'u32',
            i64geu: 'u32',
            i64add: 'u32',
            i64sub: 'u32',
            i64mul: 'u32',
            i64divs: 'u32',
            i64divu: 'u32',
            i64rems: 'u32',
            i64remu: 'u32',
            i64and: 'u32',
            i64or: 'u32',
            i64xor: 'u32',
            i64shl: 'u32',
            i64shrs: 'u32',
            i64shru: 'u32',
            i64rotl: 'u32',
            i64rotr: 'u32'
        },
        LimitsTo264: {
            eventTopics: 'u32',
            stackHeight: 'u32',
            globals: 'u32',
            parameters: 'u32',
            memoryPages: 'u32',
            tableSize: 'u32',
            brTableSize: 'u32',
            subjectLen: 'u32',
            codeSize: 'u32'
        },
        Limits: {
            eventTopics: 'u32',
            stackHeight: 'u32',
            globals: 'u32',
            parameters: 'u32',
            memoryPages: 'u32',
            tableSize: 'u32',
            brTableSize: 'u32',
            subjectLen: 'u32'
        },
        PrefabWasmModule: {
            scheduleVersion: 'Compact<u32>',
            initial: 'Compact<u32>',
            maximum: 'Compact<u32>',
            refcount: 'Compact<u64>',
            _reserved: 'Option<Null>',
            code: 'Bytes',
            originalCodeLen: 'u32'
        },
        RentProjection: {
            _enum: {
                EvictionAt: 'BlockNumber',
                NoEviction: 'Null'
            }
        },
        ScheduleTo212: {
            version: 'u32',
            putCodePerByteCost: 'Gas',
            growMemCost: 'Gas',
            regularOpCost: 'Gas',
            returnDataPerByteCost: 'Gas',
            eventDataPerByteCost: 'Gas',
            eventPerTopicCost: 'Gas',
            eventBaseCost: 'Gas',
            sandboxDataReadCost: 'Gas',
            sandboxDataWriteCost: 'Gas',
            maxEventTopics: 'u32',
            maxStackHeight: 'u32',
            maxMemoryPages: 'u32',
            enablePrintln: 'bool',
            maxSubjectLen: 'u32'
        },
        ScheduleTo258: {
            version: 'u32',
            putCodePerByteCost: 'Gas',
            growMemCost: 'Gas',
            regularOpCost: 'Gas',
            returnDataPerByteCost: 'Gas',
            eventDataPerByteCost: 'Gas',
            eventPerTopicCost: 'Gas',
            eventBaseCost: 'Gas',
            sandboxDataReadCost: 'Gas',
            sandboxDataWriteCost: 'Gas',
            transferCost: 'Gas',
            maxEventTopics: 'u32',
            maxStackHeight: 'u32',
            maxMemoryPages: 'u32',
            enablePrintln: 'bool',
            maxSubjectLen: 'u32'
        },
        ScheduleTo264: {
            version: 'u32',
            enablePrintln: 'bool',
            limits: 'LimitsTo264',
            instructionWeights: 'InstructionWeights',
            hostFnWeights: 'HostFnWeightsTo264'
        },
        Schedule: {
            version: 'u32',
            enablePrintln: 'bool',
            limits: 'Limits',
            instructionWeights: 'InstructionWeights',
            hostFnWeights: 'HostFnWeights'
        },
        SeedOf: 'Hash',
        StorageDeposit: {
            _enum: {
                Refund: 'Balance',
                Charge: 'Balance'
            }
        },
        TombstoneContractInfo: 'Hash',
        TrieId: 'Bytes'
    }
};

const AllConvictions = [
    // 0.1x votes, unlocked.
    'None',
    // 1x votes, locked for an enactment period following a successful vote.
    'Locked1x',
    // 2x votes, locked for 2x enactment periods following a successful vote.
    'Locked2x',
    // 3x votes, locked for 4x...
    'Locked3x',
    // 4x votes, locked for 8x...
    'Locked4x',
    // 5x votes, locked for 16x...
    'Locked5x',
    // 6x votes, locked for 32x...
    'Locked6x'
];
var definitions$Z = {
    rpc: {},
    types: {
        AccountVote: {
            _enum: {
                Standard: 'AccountVoteStandard',
                Split: 'AccountVoteSplit'
            }
        },
        AccountVoteSplit: {
            aye: 'Balance',
            nay: 'Balance'
        },
        AccountVoteStandard: {
            vote: 'Vote',
            balance: 'Balance'
        },
        Conviction: {
            _enum: AllConvictions
        },
        Delegations: {
            votes: 'Balance',
            capital: 'Balance'
        },
        PreimageStatus: {
            _enum: {
                Missing: 'BlockNumber',
                Available: 'PreimageStatusAvailable'
            }
        },
        PreimageStatusAvailable: {
            data: 'Bytes',
            provider: 'AccountId',
            deposit: 'Balance',
            since: 'BlockNumber',
            expiry: 'Option<BlockNumber>'
        },
        PriorLock: '(BlockNumber, Balance)',
        PropIndex: 'u32',
        Proposal: 'Call',
        ProxyState: {
            _enum: {
                Open: 'AccountId',
                Active: 'AccountId'
            }
        },
        ReferendumIndex: 'u32',
        ReferendumInfoTo239: {
            end: 'BlockNumber',
            proposalHash: 'Hash',
            threshold: 'VoteThreshold',
            delay: 'BlockNumber'
        },
        ReferendumInfo: {
            _enum: {
                Ongoing: 'ReferendumStatus',
                Finished: 'ReferendumInfoFinished'
            }
        },
        ReferendumInfoFinished: {
            approved: 'bool',
            end: 'BlockNumber'
        },
        ReferendumStatus: {
            end: 'BlockNumber',
            proposalHash: 'Hash',
            threshold: 'VoteThreshold',
            delay: 'BlockNumber',
            tally: 'Tally'
        },
        Tally: {
            ayes: 'Balance',
            nays: 'Balance',
            turnout: 'Balance'
        },
        Voting: {
            _enum: {
                Direct: 'VotingDirect',
                Delegating: 'VotingDelegating'
            }
        },
        VotingDirect: {
            votes: 'Vec<VotingDirectVote>',
            delegations: 'Delegations',
            prior: 'PriorLock'
        },
        VotingDirectVote: '(ReferendumIndex, AccountVote)',
        VotingDelegating: {
            balance: 'Balance',
            target: 'AccountId',
            conviction: 'Conviction',
            delegations: 'Delegations',
            prior: 'PriorLock'
        }
    }
};

const rpc$d = {
    getBlockStats: {
        description: 'Reexecute the specified `block_hash` and gather statistics while doing so',
        isUnsafe: true,
        params: [
            {
                isHistoric: true,
                name: 'at',
                type: 'Hash'
            }
        ],
        type: 'Option<BlockStats>'
    }
};

var definitions$Y = {
    rpc: rpc$d,
    types: {
        BlockStats: {
            witnessLen: 'u64',
            witnessCompactLen: 'u64',
            blockLen: 'u64',
            blockNumExtrinsics: 'u64'
        }
    }
};

const runtime$p = {
    AuthorityDiscoveryApi: [
        {
            methods: {
                authorities: {
                    description: 'Retrieve authority identifiers of the current and next authority set.',
                    params: [],
                    type: 'Vec<AuthorityId>'
                }
            },
            version: 1
        }
    ]
};

var definitions$X = {
    rpc: {},
    runtime: runtime$p,
    types: {}
};

var definitions$W = {
    rpc: {},
    types: {
        ApprovalFlag: 'u32',
        DefunctVoter: {
            who: 'AccountId',
            voteCount: 'Compact<u32>',
            candidateCount: 'Compact<u32>'
        },
        Renouncing: {
            _enum: {
                Member: 'Null',
                RunnerUp: 'Null',
                Candidate: 'Compact<u32>'
            }
        },
        SetIndex: 'u32',
        Vote: 'GenericVote',
        VoteIndex: 'u32',
        VoterInfo: {
            lastActive: 'VoteIndex',
            lastWin: 'VoteIndex',
            pot: 'Balance',
            stake: 'Balance'
        },
        VoteThreshold: {
            _enum: [
                'Super Majority Approve',
                'Super Majority Against',
                'Simple Majority'
            ]
        }
    }
};

const rpc$c = {
    createBlock: {
        description: 'Instructs the manual-seal authorship task to create a new block',
        params: [
            {
                name: 'createEmpty',
                type: 'bool'
            },
            {
                name: 'finalize',
                type: 'bool'
            },
            {
                isOptional: true,
                name: 'parentHash',
                type: 'BlockHash'
            }
        ],
        type: 'CreatedBlock'
    },
    finalizeBlock: {
        description: 'Instructs the manual-seal authorship task to finalize a block',
        params: [
            {
                name: 'hash',
                type: 'BlockHash'
            },
            {
                isOptional: true,
                name: 'justification',
                type: 'Justification'
            }
        ],
        type: 'bool'
    }
};

var definitions$V = {
    rpc: rpc$c,
    types: {
        CreatedBlock: {
            _alias: {
                blockHash: 'hash'
            },
            blockHash: 'BlockHash',
            aux: 'ImportedAux'
        },
        ImportedAux: {
            headerOnly: 'bool',
            clearJustificationRequests: 'bool',
            needsJustification: 'bool',
            badJustification: 'bool',
            needsFinalityProof: 'bool',
            isNewBest: 'bool'
        }
    }
};

var definitions$U = {
    rpc: {},
    types: {
        EvmAccount: {
            nonce: 'u256',
            balance: 'u256'
        },
        EvmCallInfo: {
            exitReason: 'ExitReason',
            value: 'Bytes',
            usedGas: 'U256',
            logs: 'Vec<EvmLog>'
        },
        EvmCreateInfo: {
            exitReason: 'ExitReason',
            value: 'H160',
            usedGas: 'U256',
            logs: 'Vec<EvmLog>'
        },
        EvmCallInfoV2: {
            exitReason: 'ExitReason',
            value: 'Bytes',
            usedGas: 'U256',
            weightInfo: 'Option<EvmWeightInfo>',
            logs: 'Vec<EvmLog>'
        },
        EvmCreateInfoV2: {
            exitReason: 'ExitReason',
            value: 'H160',
            usedGas: 'U256',
            weightInfo: 'Option<EvmWeightInfo>',
            logs: 'Vec<EvmLog>'
        },
        EvmLog: {
            address: 'H160',
            topics: 'Vec<H256>',
            data: 'Bytes'
        },
        EvmVicinity: {
            gasPrice: 'u256',
            origin: 'H160'
        },
        EvmWeightInfo: {
            refTimeLimit: 'Option<u64>',
            proofSizeLimit: 'Option<u64>',
            refTimeUsage: 'Option<u64>',
            proofSizeUsage: 'Option<u64>'
        },
        ExitError: {
            _enum: {
                StackUnderflow: 'Null',
                StackOverflow: 'Null',
                InvalidJump: 'Null',
                InvalidRange: 'Null',
                DesignatedInvalid: 'Null',
                CallTooDeep: 'Null',
                CreateCollision: 'Null',
                CreateContractLimit: 'Null',
                OutOfOffset: 'Null',
                OutOfGas: 'Null',
                OutOfFund: 'Null',
                PCUnderflow: 'Null',
                CreateEmpty: 'Null',
                Other: 'Text'
            }
        },
        ExitFatal: {
            _enum: {
                NotSupported: 'Null',
                UnhandledInterrupt: 'Null',
                CallErrorAsFatal: 'ExitError',
                Other: 'Text'
            }
        },
        ExitReason: {
            _enum: {
                Succeed: 'ExitSucceed',
                Error: 'ExitError',
                Revert: 'ExitRevert',
                Fatal: 'ExitFatal'
            }
        },
        ExitRevert: {
            _enum: ['Reverted']
        },
        ExitSucceed: {
            _enum: ['Stopped', 'Returned', 'Suicided']
        }
    }
};

var definitions$T = {
    rpc: {},
    types: {
        Extrinsic: 'GenericExtrinsic',
        ExtrinsicEra: 'GenericExtrinsicEra',
        ExtrinsicPayload: 'GenericExtrinsicPayload',
        ExtrinsicSignature: 'MultiSignature',
        ExtrinsicV4: 'GenericExtrinsicV4',
        ExtrinsicPayloadV4: 'GenericExtrinsicPayloadV4',
        ExtrinsicSignatureV4: 'GenericExtrinsicSignatureV4',
        ExtrinsicUnknown: 'GenericExtrinsicUnknown',
        ExtrinsicPayloadUnknown: 'GenericExtrinsicPayloadUnknown',
        ExtrinsicV5: 'GenericExtrinsicV5',
        ExtrinsicPayloadV5: 'GenericExtrinsicPayloadV5',
        ExtrinsicSignatureV5: 'GenericExtrinsicSignatureV5',
        // eras
        Era: 'ExtrinsicEra',
        ImmortalEra: 'GenericImmortalEra',
        MortalEra: 'GenericMortalEra',
        // signatures & signer
        AnySignature: 'H512',
        MultiSignature: {
            _enum: {
                Ed25519: 'Ed25519Signature',
                Sr25519: 'Sr25519Signature',
                Ecdsa: 'EcdsaSignature'
            }
        },
        Signature: 'H512',
        SignerPayload: 'GenericSignerPayload',
        EcdsaSignature: '[u8; 65]',
        Ed25519Signature: 'H512',
        Sr25519Signature: 'H512'
    }
};

const runtime$o = {
    FungiblesApi: [
        {
            methods: {
                query_account_balances: {
                    description: 'Returns the list of all `MultiAsset` that an `AccountId` has',
                    params: [
                        {
                            name: 'account',
                            type: 'AccountId'
                        }
                    ],
                    type: 'Result<Vec<XcmV3MultiAsset>, FungiblesAccessError>'
                }
            },
            version: 1
        },
        {
            methods: {
                query_account_balances: {
                    description: 'Returns the list of all `MultiAsset` that an `AccountId` has',
                    params: [
                        {
                            name: 'account',
                            type: 'AccountId'
                        }
                    ],
                    type: 'Result<XcmVersionedAssets, FungiblesAccessError>'
                }
            },
            version: 2
        }
    ]
};

var definitions$S = {
    rpc: {},
    runtime: runtime$o,
    types: {
        FungiblesAccessError: {
            _enum: ['AssetIdConversionFailed', 'AmountToBalanceConversionFailed']
        }
    }
};

var definitions$R = {
    rpc: {},
    types: {
        AssetOptions: {
            initalIssuance: 'Compact<Balance>',
            permissions: 'PermissionLatest'
        },
        Owner: {
            _enum: {
                None: 'Null',
                Address: 'AccountId'
            }
        },
        PermissionsV1: {
            update: 'Owner',
            mint: 'Owner',
            burn: 'Owner'
        },
        PermissionVersions: {
            _enum: {
                V1: 'PermissionsV1'
            }
        },
        PermissionLatest: 'PermissionsV1'
    }
};

const runtime$n = {
    GenesisBuilder: [
        {
            methods: {
                build_config: {
                    description: 'Build `RuntimeGenesisConfig` from a JSON blob not using any defaults and store it in the storage.',
                    params: [
                        {
                            name: 'json',
                            type: 'Vec<u8>'
                        }
                    ],
                    type: 'Result<(), GenesisBuildErr>'
                },
                create_default_config: {
                    description: 'Creates the default `RuntimeGenesisConfig` and returns it as a JSON blob.',
                    params: [],
                    type: 'Vec<u8>'
                }
            },
            version: 1
        }
    ]
};

var definitions$Q = {
    rpc: {},
    runtime: runtime$n,
    types: {
        GenesisBuildErr: 'Text'
    }
};

var definitions$P = {
    rpc: {},
    types: {
        ActiveGilt: {
            proportion: 'Perquintill',
            amount: 'Balance',
            who: 'AccountId',
            expiry: 'BlockNumber'
        },
        ActiveGiltsTotal: {
            frozen: 'Balance',
            proportion: 'Perquintill',
            index: 'ActiveIndex',
            target: 'Perquintill'
        },
        ActiveIndex: 'u32',
        GiltBid: {
            amount: 'Balance',
            who: 'AccountId'
        }
    }
};

const rpc$b = {
    proveFinality: {
        description: 'Prove finality for the given block number, returning the Justification for the last block in the set.',
        params: [
            {
                name: 'blockNumber',
                type: 'BlockNumber'
            }
        ],
        type: 'Option<EncodedFinalityProofs>'
    },
    roundState: {
        description: 'Returns the state of the current best round state as well as the ongoing background rounds',
        params: [],
        type: 'ReportedRoundStates'
    },
    subscribeJustifications: {
        description: 'Subscribes to grandpa justifications',
        params: [],
        pubsub: [
            'justifications',
            'subscribeJustifications',
            'unsubscribeJustifications'
        ],
        type: 'JustificationNotification'
    }
};

const GRANDPA_V2_V3 = {
    generate_key_ownership_proof: {
        description: 'Generates a proof of key ownership for the given authority in the given set.',
        params: [
            {
                name: 'setId',
                type: 'SetId'
            },
            {
                name: 'authorityId',
                type: 'AuthorityId'
            }
        ],
        type: 'Option<OpaqueKeyOwnershipProof>'
    },
    grandpa_authorities: {
        description: 'Get the current GRANDPA authorities and weights. This should not change except for when changes are scheduled and the corresponding delay has passed.',
        params: [],
        type: 'AuthorityList'
    },
    submit_report_equivocation_unsigned_extrinsic: {
        description: 'Submits an unsigned extrinsic to report an equivocation.',
        params: [
            {
                name: 'equivocationProof',
                type: 'GrandpaEquivocationProof'
            },
            {
                name: 'keyOwnerProof',
                type: 'OpaqueKeyOwnershipProof'
            }
        ],
        type: 'Option<Null>'
    }
};
const runtime$m = {
    GrandpaApi: [
        {
            methods: {
                current_set_id: {
                    description: 'Get current GRANDPA authority set id.',
                    params: [],
                    type: 'SetId'
                },
                ...GRANDPA_V2_V3
            },
            version: 3
        },
        {
            methods: GRANDPA_V2_V3,
            version: 2
        }
    ]
};

var definitions$O = {
    rpc: rpc$b,
    runtime: runtime$m,
    types: {
        AuthorityIndex: 'u64',
        AuthorityList: 'Vec<NextAuthority>',
        AuthoritySet: {
            currentAuthorities: 'AuthorityList',
            setId: 'u64',
            pendingStandardChanges: 'ForkTreePendingChange',
            pendingForcedChanges: 'Vec<PendingChange>',
            authoritySetChanges: 'AuthoritySetChanges'
        },
        ForkTreePendingChange: {
            roots: 'Vec<ForkTreePendingChangeNode>',
            bestFinalizedNumber: 'Option<BlockNumber>'
        },
        ForkTreePendingChangeNode: {
            hash: 'BlockHash',
            number: 'BlockNumber',
            data: 'PendingChange', // actual data, here PendingChange
            children: 'Vec<ForkTreePendingChangeNode>'
        },
        AuthoritySetChange: '(U64, BlockNumber)',
        AuthoritySetChanges: 'Vec<AuthoritySetChange>',
        AuthorityWeight: 'u64',
        DelayKind: {
            _enum: {
                Finalized: 'Null',
                Best: 'DelayKindBest'
            }
        },
        DelayKindBest: {
            medianLastFinalized: 'BlockNumber'
        },
        EncodedFinalityProofs: 'Bytes',
        GrandpaEquivocation: {
            _enum: {
                Prevote: 'GrandpaEquivocationValue',
                Precommit: 'GrandpaEquivocationValue'
            }
        },
        GrandpaEquivocationProof: {
            setId: 'SetId',
            equivocation: 'GrandpaEquivocation'
        },
        GrandpaEquivocationValue: {
            roundNumber: 'u64',
            identity: 'AuthorityId',
            first: '(GrandpaPrevote, AuthoritySignature)',
            second: '(GrandpaPrevote, AuthoritySignature)'
        },
        GrandpaPrevote: {
            targetHash: 'Hash',
            targetNumber: 'BlockNumber'
        },
        GrandpaCommit: {
            targetHash: 'BlockHash',
            targetNumber: 'BlockNumber',
            precommits: 'Vec<GrandpaSignedPrecommit>'
        },
        GrandpaPrecommit: {
            targetHash: 'BlockHash',
            targetNumber: 'BlockNumber'
        },
        GrandpaSignedPrecommit: {
            precommit: 'GrandpaPrecommit',
            signature: 'AuthoritySignature',
            id: 'AuthorityId'
        },
        GrandpaJustification: {
            round: 'u64',
            commit: 'GrandpaCommit',
            votesAncestries: 'Vec<Header>'
        },
        JustificationNotification: 'Bytes',
        KeyOwnerProof: 'MembershipProof',
        NextAuthority: '(AuthorityId, AuthorityWeight)',
        PendingChange: {
            nextAuthorities: 'AuthorityList',
            delay: 'BlockNumber',
            canonHeight: 'BlockNumber',
            canonHash: 'BlockHash',
            delayKind: 'DelayKind'
        },
        PendingPause: {
            scheduledAt: 'BlockNumber',
            delay: 'BlockNumber'
        },
        PendingResume: {
            scheduledAt: 'BlockNumber',
            delay: 'BlockNumber'
        },
        Precommits: {
            currentWeight: 'u32',
            missing: 'BTreeSet<AuthorityId>'
        },
        Prevotes: {
            currentWeight: 'u32',
            missing: 'BTreeSet<AuthorityId>'
        },
        ReportedRoundStates: {
            setId: 'u32',
            best: 'RoundState',
            background: 'Vec<RoundState>'
        },
        RoundState: {
            round: 'u32',
            totalWeight: 'u32',
            thresholdWeight: 'u32',
            prevotes: 'Prevotes',
            precommits: 'Precommits'
        },
        SetId: 'u64',
        StoredPendingChange: {
            scheduledAt: 'BlockNumber',
            delay: 'BlockNumber',
            nextAuthorities: 'AuthorityList'
        },
        StoredState: {
            _enum: {
                Live: 'Null',
                PendingPause: 'PendingPause',
                Paused: 'Null',
                PendingResume: 'PendingResume'
            }
        }
    }
};

var definitions$N = {
    rpc: {},
    types: {
        IdentityFields: {
            _set: {
                _bitLength: 64,
                // Mapped here to 32 bits, in Rust these are 64-bit values
                Display: 0b00000000_00000000_00000000_0000_0001,
                Legal: 0b00000000_00000000_00000000_0000_0010,
                Web: 0b00000000_00000000_00000000_0000_0100,
                Riot: 0b00000000_00000000_00000000_0000_1000,
                Email: 0b00000000_00000000_00000000_0001_0000,
                PgpFingerprint: 0b00000000_00000000_00000000_0010_0000,
                Image: 0b00000000_00000000_00000000_0100_0000,
                Twitter: 0b00000000_00000000_00000000_1000_0000
            }
        },
        IdentityInfoAdditional: '(Data, Data)',
        IdentityInfoTo198: {
            additional: 'Vec<IdentityInfoAdditional>',
            display: 'Data',
            legal: 'Data',
            web: 'Data',
            riot: 'Data',
            email: 'Data',
            pgpFingerprint: 'Option<H160>',
            image: 'Data'
        },
        IdentityInfo: {
            _fallback: 'IdentityInfoTo198',
            additional: 'Vec<IdentityInfoAdditional>',
            display: 'Data',
            legal: 'Data',
            web: 'Data',
            riot: 'Data',
            email: 'Data',
            pgpFingerprint: 'Option<H160>',
            image: 'Data',
            twitter: 'Data'
        },
        IdentityJudgement: {
            _enum: {
                Unknown: 'Null',
                FeePaid: 'Balance',
                Reasonable: 'Null',
                KnownGood: 'Null',
                OutOfDate: 'Null',
                LowQuality: 'Null',
                Erroneous: 'Null'
            }
        },
        RegistrationJudgement: '(RegistrarIndex, IdentityJudgement)',
        RegistrationTo198: {
            judgements: 'Vec<RegistrationJudgement>',
            deposit: 'Balance',
            info: 'IdentityInfoTo198'
        },
        Registration: {
            _fallback: 'RegistrationTo198',
            judgements: 'Vec<RegistrationJudgement>',
            deposit: 'Balance',
            info: 'IdentityInfo'
        },
        RegistrarIndex: 'u32',
        RegistrarInfo: {
            account: 'AccountId',
            fee: 'Balance',
            fields: 'IdentityFields'
        }
    }
};

var definitions$M = {
    rpc: {},
    types: {
        AuthIndex: 'u32',
        AuthoritySignature: 'Signature',
        Heartbeat: {
            blockNumber: 'BlockNumber',
            networkState: 'OpaqueNetworkState',
            sessionIndex: 'SessionIndex',
            authorityIndex: 'AuthIndex',
            validatorsLen: 'u32'
        },
        HeartbeatTo244: {
            blockNumber: 'BlockNumber',
            networkState: 'OpaqueNetworkState',
            sessionIndex: 'SessionIndex',
            authorityIndex: 'AuthIndex'
        },
        OpaqueMultiaddr: 'Opaque<Bytes>',
        OpaquePeerId: 'Opaque<Bytes>',
        OpaqueNetworkState: {
            peerId: 'OpaquePeerId',
            externalAddresses: 'Vec<OpaqueMultiaddr>'
        }
    }
};

var definitions$L = {
    rpc: {},
    types: {
        CallIndex: '(u8, u8)',
        LotteryConfig: {
            price: 'Balance',
            start: 'BlockNumber',
            length: 'BlockNumber',
            delay: 'BlockNumber',
            repeat: 'bool'
        }
    }
};

const runtime$l = {
    MixnetApi: [
        {
            methods: {
                current_mixnodes: {
                    description: 'Get the index and phase of the current session.',
                    params: [],
                    type: 'Result<Mixnode, MixnodesErr>'
                },
                maybe_register: {
                    description: 'Try to register a mixnode for the next session.',
                    params: [
                        {
                            name: 'session_index',
                            type: 'u32'
                        },
                        {
                            name: 'mixnode',
                            type: 'Mixnode'
                        }
                    ],
                    type: 'bool'
                },
                prev_mixnodes: {
                    description: 'Get the index and phase of the current session.',
                    params: [],
                    type: 'Result<Mixnode, MixnodesErr>'
                },
                session_status: {
                    description: 'Get the index and phase of the current session.',
                    params: [],
                    type: 'SessionStatus'
                }
            },
            version: 1
        }
    ]
};

var definitions$K = {
    rpc: {},
    runtime: runtime$l,
    types: {
        Mixnode: {
            externalAddresses: 'Vec<Bytes>',
            kxPublic: '[u8; 32]',
            peerId: '[u8; 32]'
        },
        MixnodesErr: {
            _enum: {
                InsufficientRegistrations: {
                    min: 'u32',
                    num: 'u32'
                }
            }
        },
        SessionPhase: {
            _enum: ['CoverToCurrent', 'RequestsToCurrent', 'CoverToPrev', 'DisconnectFromPrev']
        },
        SessionStatus: {
            currentIndex: 'u32',
            phase: 'SessionPhase'
        }
    }
};

const rpc$a = {
    generateProof: {
        description: 'Generate MMR proof for the given block numbers.',
        params: [
            {
                name: 'blockNumbers',
                type: 'Vec<u64>'
            },
            {
                isOptional: true,
                name: 'bestKnownBlockNumber',
                type: 'u64'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'MmrLeafBatchProof'
    },
    root: {
        description: 'Get the MMR root hash for the current best block.',
        params: [
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'MmrHash'
    },
    verifyProof: {
        description: 'Verify an MMR proof',
        params: [
            {
                name: 'proof',
                type: 'MmrLeafBatchProof'
            }
        ],
        type: 'bool'
    },
    verifyProofStateless: {
        description: 'Verify an MMR proof statelessly given an mmr_root',
        params: [
            {
                name: 'root',
                type: 'MmrHash'
            },
            {
                name: 'proof',
                type: 'MmrLeafBatchProof'
            }
        ],
        type: 'bool'
    }
};

const MMR_V2 = {
    generate_proof: {
        description: 'Generate MMR proof for the given block numbers.',
        params: [
            {
                name: 'blockNumbers',
                type: 'Vec<BlockNumber>'
            },
            {
                name: 'bestKnownBlockNumber',
                type: 'Option<BlockNumber>'
            }
        ],
        type: 'Result<(Vec<MmrEncodableOpaqueLeaf>, MmrBatchProof), MmrError>'
    },
    mmr_leaf_count: {
        description: 'Return the number of MMR blocks in the chain.',
        params: [],
        type: 'Result<U64, MmrError>'
    },
    mmr_root: {
        description: 'Return the on-chain MMR root hash.',
        params: [],
        type: 'Result<Hash, MmrError>'
    },
    verify_proof: {
        description: 'Verify MMR proof against on-chain MMR.',
        params: [
            {
                name: 'leaves',
                type: 'Vec<MmrEncodableOpaqueLeaf>'
            },
            {
                name: 'proof',
                type: 'MmrBatchProof'
            }
        ],
        type: 'Result<(), MmrError>'
    },
    verify_proof_stateless: {
        description: 'Verify MMR proof against given root hash.',
        params: [
            {
                name: 'root',
                type: 'Hash'
            },
            {
                name: 'leaves',
                type: 'Vec<MmrEncodableOpaqueLeaf>'
            },
            {
                name: 'proof',
                type: 'MmrBatchProof'
            }
        ],
        type: 'Result<(), MmrError>'
    }
};
const MMR_V1 = {
    generate_batch_proof: {
        description: 'Generate MMR proof for a series of leaves under given indices.',
        params: [
            {
                name: 'leafIndices',
                type: 'Vec<MmrLeafIndex>'
            }
        ],
        type: 'Result<(Vec<MmrEncodableOpaqueLeaf>, MmrBatchProof), MmrError>'
    },
    generate_proof: {
        description: 'Generate MMR proof for a leaf under given index.',
        params: [
            {
                name: 'leafIndex',
                type: 'MmrLeafIndex'
            }
        ],
        type: 'Result<(MmrEncodableOpaqueLeaf, MmrProof), MmrError>'
    },
    mmr_root: {
        description: 'Return the on-chain MMR root hash.',
        params: [],
        type: 'Result<Hash, MmrError>'
    },
    verify_batch_proof: {
        description: 'Verify MMR proof against on-chain MMR for a batch of leaves.',
        params: [
            {
                name: 'leaves',
                type: 'Vec<MmrEncodableOpaqueLeaf>'
            },
            {
                name: 'proof',
                type: 'MmrBatchProof'
            }
        ],
        type: 'Result<(), MmrError>'
    },
    verify_batch_proof_stateless: {
        description: 'Verify MMR proof against given root hash or a batch of leaves.',
        params: [
            {
                name: 'root',
                type: 'Hash'
            },
            {
                name: 'leaves',
                type: 'Vec<MmrEncodableOpaqueLeaf>'
            },
            {
                name: 'proof',
                type: 'MmrBatchProof'
            }
        ],
        type: 'Result<(), MmrError>'
    },
    verify_proof: {
        description: 'Verify MMR proof against on-chain MMR.',
        params: [
            {
                name: 'leaf',
                type: 'MmrEncodableOpaqueLeaf'
            },
            {
                name: 'proof',
                type: 'MmrProof'
            }
        ],
        type: 'Result<(), MmrError>'
    },
    verify_proof_stateless: {
        description: 'Verify MMR proof against given root hash.',
        params: [
            {
                name: 'root',
                type: 'Hash'
            },
            {
                name: 'leaf',
                type: 'MmrEncodableOpaqueLeaf'
            },
            {
                name: 'proof',
                type: 'MmrProof'
            }
        ],
        type: 'Result<(), MmrError>'
    }
};
const runtime$k = {
    MmrApi: [
        {
            methods: MMR_V2,
            version: 2
        },
        {
            methods: MMR_V1,
            version: 1
        }
    ]
};

var definitions$J = {
    rpc: rpc$a,
    runtime: runtime$k,
    types: {
        MmrBatchProof: {
            leafIndices: 'Vec<MmrLeafIndex>',
            leafCount: 'MmrNodeIndex',
            items: 'Vec<Hash>'
        },
        MmrEncodableOpaqueLeaf: 'Bytes',
        MmrError: {
            _enum: ['InvalidNumericOp', 'Push', 'GetRoot', 'Commit', 'GenerateProof', 'Verify', 'LeafNotFound', ' PalletNotIncluded', 'InvalidLeafIndex', 'InvalidBestKnownBlock']
        },
        MmrHash: 'Hash',
        MmrLeafBatchProof: {
            blockHash: 'BlockHash',
            leaves: 'Bytes',
            proof: 'Bytes'
        },
        MmrLeafIndex: 'u64',
        MmrLeafProof: {
            blockHash: 'BlockHash',
            leaf: 'Bytes',
            proof: 'Bytes'
        },
        MmrNodeIndex: 'u64',
        MmrProof: {
            leafIndex: 'MmrLeafIndex',
            leafCount: 'MmrNodeIndex',
            items: 'Vec<Hash>'
        }
    }
};

const runtime$j = {
    NftsApi: [
        {
            methods: {
                attribute: {
                    description: 'An attribute',
                    params: [
                        {
                            name: 'collection',
                            type: 'NftCollectionId'
                        },
                        {
                            name: 'item',
                            type: 'NftItemId'
                        },
                        {
                            name: 'key',
                            type: 'Bytes'
                        }
                    ],
                    type: 'Option<Bytes>'
                },
                collection_attribute: {
                    description: 'A collection attribute',
                    params: [
                        {
                            name: 'collection',
                            type: 'NftCollectionId'
                        },
                        {
                            name: 'key',
                            type: 'Bytes'
                        }
                    ],
                    type: 'Option<Bytes>'
                },
                collection_owner: {
                    description: 'A collection owner',
                    params: [
                        {
                            name: 'collection',
                            type: 'NftCollectionId'
                        }
                    ],
                    type: 'Option<AccountId>'
                },
                custom_attribute: {
                    description: 'A custom attribute',
                    params: [
                        {
                            name: 'account',
                            type: 'AccountId'
                        },
                        {
                            name: 'collection',
                            type: 'NftCollectionId'
                        },
                        {
                            name: 'item',
                            type: 'NftItemId'
                        },
                        {
                            name: 'key',
                            type: 'Bytes'
                        }
                    ],
                    type: 'Option<Bytes>'
                },
                owner: {
                    description: 'Collection owner',
                    params: [
                        {
                            name: 'collection',
                            type: 'NftCollectionId'
                        },
                        {
                            name: 'item',
                            type: 'NftItemId'
                        }
                    ],
                    type: 'Option<AccountId>'
                },
                system_attribute: {
                    description: 'System attribute',
                    params: [
                        {
                            name: 'collection',
                            type: 'NftCollectionId'
                        },
                        {
                            name: 'item',
                            type: 'NftItemId'
                        },
                        {
                            name: 'key',
                            type: 'Bytes'
                        }
                    ],
                    type: 'Option<Bytes>'
                }
            },
            version: 1
        }
    ]
};

var definitions$I = {
    rpc: {},
    runtime: runtime$j,
    types: {
        NftCollectionId: 'u32',
        NftItemId: 'u32'
    }
};

const runtime$i = {
    NominationPoolsApi: [
        {
            methods: {
                balance_to_points: {
                    description: 'Returns the equivalent points of `new_funds` for a given pool.',
                    params: [
                        {
                            name: 'poolId',
                            type: 'NpPoolId'
                        },
                        {
                            name: 'newFunds',
                            type: 'Balance'
                        }
                    ],
                    type: 'Balance'
                },
                pending_rewards: {
                    description: 'Returns the pending rewards for the given member.',
                    params: [
                        {
                            name: 'member',
                            type: 'AccountId'
                        }
                    ],
                    type: 'Balance'
                },
                points_to_balance: {
                    description: 'Returns the equivalent balance of `points` for a given pool.',
                    params: [
                        {
                            name: 'poolId',
                            type: 'NpPoolId'
                        },
                        {
                            name: 'points',
                            type: 'Balance'
                        }
                    ],
                    type: 'Balance'
                }
            },
            version: 1
        }
    ]
};

var definitions$H = {
    rpc: {},
    runtime: runtime$i,
    types: {
        NpApiError: {
            _enum: ['MemberNotFound', 'OverflowInPendingRewards']
        },
        NpPoolId: 'u32'
    }
};

var definitions$G = {
    rpc: {},
    types: {
        DeferredOffenceOf: '(Vec<OffenceDetails>, Vec<Perbill>, SessionIndex)',
        Kind: '[u8; 16]',
        OffenceDetails: {
            offender: 'Offender',
            reporters: 'Vec<Reporter>'
        },
        Offender: 'IdentificationTuple',
        OpaqueTimeSlot: 'Bytes',
        ReportIdOf: 'Hash',
        Reporter: 'AccountId'
    }
};

const runtime$h = {
    DifficultyApi: [
        {
            methods: {
                difficulty: {
                    description: 'Return the target difficulty of the next block.',
                    params: [],
                    // This is Difficulty in the original, however this is chain-specific
                    type: 'Raw'
                }
            },
            version: 1
        }
    ],
    TimestampApi: [
        {
            methods: {
                timestamp: {
                    description: 'API necessary for timestamp-based difficulty adjustment algorithms.',
                    params: [],
                    type: 'Moment'
                }
            },
            version: 1
        }
    ]
};

var definitions$F = {
    rpc: {},
    runtime: runtime$h,
    types: {}
};

var definitions$E = {
    rpc: {},
    types: {
        ProxyDefinition: {
            delegate: 'AccountId',
            proxyType: 'ProxyType',
            delay: 'BlockNumber'
        },
        ProxyType: {
            _enum: ['Any', 'NonTransfer', 'Governance', 'Staking']
        },
        ProxyAnnouncement: {
            real: 'AccountId',
            callHash: 'Hash',
            height: 'BlockNumber'
        }
    }
};

var definitions$D = {
    rpc: {},
    types: {
        ActiveRecovery: {
            created: 'BlockNumber',
            deposit: 'Balance',
            friends: 'Vec<AccountId>'
        },
        RecoveryConfig: {
            delayPeriod: 'BlockNumber',
            deposit: 'Balance',
            friends: 'Vec<AccountId>',
            threshold: 'u16'
        }
    }
};

var definitions$C = {
    rpc: {},
    types: {
        Period: '(BlockNumber, u32)',
        Priority: 'u8',
        SchedulePeriod: 'Period',
        SchedulePriority: 'Priority',
        Scheduled: {
            maybeId: 'Option<Bytes>',
            priority: 'SchedulePriority',
            call: 'Call',
            maybePeriodic: 'Option<SchedulePeriod>',
            origin: 'PalletsOrigin'
        },
        ScheduledTo254: {
            maybeId: 'Option<Bytes>',
            priority: 'SchedulePriority',
            call: 'Call',
            maybePeriodic: 'Option<SchedulePeriod>'
        },
        TaskAddress: '(BlockNumber, u32)'
    }
};

const runtime$g = {
    SessionKeys: [
        {
            methods: {
                decode_session_keys: {
                    description: 'Decode the given public session keys.',
                    params: [
                        {
                            name: 'encoded',
                            type: 'Bytes'
                        }
                    ],
                    type: 'Option<Vec<(Bytes, KeyTypeId)>>'
                },
                generate_session_keys: {
                    description: 'Generate a set of session keys with optionally using the given seed.',
                    params: [
                        {
                            name: 'seed',
                            type: 'Option<Bytes>'
                        }
                    ],
                    type: 'Bytes'
                }
            },
            version: 1
        }
    ]
};

const keyTypes = {
    // key for beefy
    BeefyKey: '[u8; 33]',
    // default to Substrate master defaults, 4 keys (polkadot master, 5 keys)
    Keys: 'SessionKeys4',
    SessionKeys1: '(AccountId)',
    SessionKeys2: '(AccountId, AccountId)',
    SessionKeys3: '(AccountId, AccountId, AccountId)',
    SessionKeys4: '(AccountId, AccountId, AccountId, AccountId)',
    SessionKeys5: '(AccountId, AccountId, AccountId, AccountId, AccountId)',
    SessionKeys6: '(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId)',
    SessionKeys6B: '(AccountId, AccountId, AccountId, AccountId, AccountId, BeefyKey)',
    SessionKeys7: '(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId)',
    SessionKeys7B: '(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, BeefyKey)',
    SessionKeys8: '(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId)',
    SessionKeys8B: '(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, BeefyKey)',
    SessionKeys9: '(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId)',
    SessionKeys9B: '(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, BeefyKey)',
    SessionKeys10: '(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId)',
    SessionKeys10B: '(AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, AccountId, BeefyKey)'
};
var definitions$B = {
    rpc: {},
    runtime: runtime$g,
    types: {
        ...keyTypes,
        FullIdentification: 'Exposure',
        IdentificationTuple: '(ValidatorId, FullIdentification)',
        MembershipProof: {
            session: 'SessionIndex',
            trieNodes: 'Vec<Bytes>',
            validatorCount: 'ValidatorCount'
        },
        SessionIndex: 'u32',
        ValidatorCount: 'u32'
    }
};

var definitions$A = {
    rpc: {},
    types: {
        Bid: {
            who: 'AccountId',
            kind: 'BidKind',
            value: 'Balance'
        },
        BidKind: {
            _enum: {
                Deposit: 'Balance',
                Vouch: '(AccountId, Balance)'
            }
        },
        // a society-specific Judgement (not the same as identity Judgement)
        SocietyJudgement: {
            _enum: ['Rebid', 'Reject', 'Approve']
        },
        // a society-specific Vote
        SocietyVote: {
            _enum: ['Skeptic', 'Reject', 'Approve']
        },
        StrikeCount: 'u32',
        VouchingStatus: {
            _enum: ['Vouching', 'Banned']
        }
    }
};

const runtime$f = {
    StakingApi: [
        {
            methods: {
                nominations_quota: {
                    description: 'Returns the nominations quota for a nominator with a given balance.',
                    params: [
                        {
                            name: 'balance',
                            type: 'Balance'
                        }
                    ],
                    type: 'u32'
                }
            },
            version: 1
        }
    ]
};

const deprecated = {
    Points: 'u32',
    EraPoints: {
        total: 'Points',
        individual: 'Vec<Points>'
    }
};
const phragmen = {
    CompactAssignments: 'CompactAssignmentsWith16',
    CompactAssignmentsWith16: {
        votes1: 'Vec<(NominatorIndexCompact, ValidatorIndexCompact)>',
        votes2: 'Vec<(NominatorIndexCompact, CompactScoreCompact, ValidatorIndexCompact)>',
        votes3: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 2], ValidatorIndexCompact)>',
        votes4: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 3], ValidatorIndexCompact)>',
        votes5: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 4], ValidatorIndexCompact)>',
        votes6: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 5], ValidatorIndexCompact)>',
        votes7: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 6], ValidatorIndexCompact)>',
        votes8: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 7], ValidatorIndexCompact)>',
        votes9: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 8], ValidatorIndexCompact)>',
        votes10: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 9], ValidatorIndexCompact)>',
        votes11: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 10], ValidatorIndexCompact)>',
        votes12: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 11], ValidatorIndexCompact)>',
        votes13: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 12], ValidatorIndexCompact)>',
        votes14: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 13], ValidatorIndexCompact)>',
        votes15: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 14], ValidatorIndexCompact)>',
        votes16: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 15], ValidatorIndexCompact)>'
    },
    CompactAssignmentsWith24: {
        votes1: 'Vec<(NominatorIndexCompact, ValidatorIndexCompact)>',
        votes2: 'Vec<(NominatorIndexCompact, CompactScoreCompact, ValidatorIndexCompact)>',
        votes3: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 2], ValidatorIndexCompact)>',
        votes4: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 3], ValidatorIndexCompact)>',
        votes5: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 4], ValidatorIndexCompact)>',
        votes6: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 5], ValidatorIndexCompact)>',
        votes7: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 6], ValidatorIndexCompact)>',
        votes8: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 7], ValidatorIndexCompact)>',
        votes9: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 8], ValidatorIndexCompact)>',
        votes10: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 9], ValidatorIndexCompact)>',
        votes11: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 10], ValidatorIndexCompact)>',
        votes12: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 11], ValidatorIndexCompact)>',
        votes13: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 12], ValidatorIndexCompact)>',
        votes14: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 13], ValidatorIndexCompact)>',
        votes15: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 14], ValidatorIndexCompact)>',
        votes16: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 15], ValidatorIndexCompact)>',
        votes17: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 16], ValidatorIndexCompact)>',
        votes18: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 17], ValidatorIndexCompact)>',
        votes19: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 18], ValidatorIndexCompact)>',
        votes20: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 19], ValidatorIndexCompact)>',
        votes21: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 20], ValidatorIndexCompact)>',
        votes22: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 21], ValidatorIndexCompact)>',
        votes23: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 22], ValidatorIndexCompact)>',
        votes24: 'Vec<(NominatorIndexCompact, [CompactScoreCompact; 23], ValidatorIndexCompact)>'
    },
    CompactAssignmentsTo265: 'CompactAssignmentsWith16',
    CompactAssignmentsTo257: {
        votes1: 'Vec<(NominatorIndex, [CompactScore; 0], ValidatorIndex)>',
        votes2: 'Vec<(NominatorIndex, [CompactScore; 1], ValidatorIndex)>',
        votes3: 'Vec<(NominatorIndex, [CompactScore; 2], ValidatorIndex)>',
        votes4: 'Vec<(NominatorIndex, [CompactScore; 3], ValidatorIndex)>',
        votes5: 'Vec<(NominatorIndex, [CompactScore; 4], ValidatorIndex)>',
        votes6: 'Vec<(NominatorIndex, [CompactScore; 5], ValidatorIndex)>',
        votes7: 'Vec<(NominatorIndex, [CompactScore; 6], ValidatorIndex)>',
        votes8: 'Vec<(NominatorIndex, [CompactScore; 7], ValidatorIndex)>',
        votes9: 'Vec<(NominatorIndex, [CompactScore; 8], ValidatorIndex)>',
        votes10: 'Vec<(NominatorIndex, [CompactScore; 9], ValidatorIndex)>',
        votes11: 'Vec<(NominatorIndex, [CompactScore; 10], ValidatorIndex)>',
        votes12: 'Vec<(NominatorIndex, [CompactScore; 11], ValidatorIndex)>',
        votes13: 'Vec<(NominatorIndex, [CompactScore; 12], ValidatorIndex)>',
        votes14: 'Vec<(NominatorIndex, [CompactScore; 13], ValidatorIndex)>',
        votes15: 'Vec<(NominatorIndex, [CompactScore; 14], ValidatorIndex)>',
        votes16: 'Vec<(NominatorIndex, [CompactScore; 15], ValidatorIndex)>'
    },
    CompactScore: '(ValidatorIndex, OffchainAccuracy)',
    CompactScoreCompact: '(ValidatorIndexCompact, OffchainAccuracyCompact)',
    ElectionCompute: {
        // in previous versions the last entry was "AuthorityId"
        // (since no data attached, and it is via SCALE can rename)
        _enum: ['OnChain', 'Signed', 'Unsigned']
    },
    ElectionPhase: {
        _enum: {
            Off: null,
            Signed: null,
            Unsigned: '(bool, BlockNumber)',
            Emergency: null
        }
    },
    ElectionResult: {
        compute: 'ElectionCompute',
        slotStake: 'Balance',
        electedStashes: 'Vec<AccountId>',
        exposures: 'Vec<(AccountId, Exposure)>'
    },
    ElectionResultToSpec10: {
        electedStashes: 'Vec<AccountId>',
        exposures: 'Vec<(AccountId, Exposure<AccountId, Balance>)>',
        compute: 'ElectionCompute'
    },
    ElectionScore: '[u128; 3]',
    ElectionSize: {
        validators: 'Compact<ValidatorIndex>',
        nominators: 'Compact<NominatorIndex>'
    },
    ElectionStatus: {
        _enum: {
            Close: 'Null',
            Open: 'BlockNumber'
        }
    },
    ExtendedBalance: 'u128',
    RawSolution: 'RawSolutionWith16',
    RawSolutionWith16: {
        compact: 'CompactAssignmentsWith16',
        score: 'ElectionScore',
        round: 'u32'
    },
    RawSolutionWith24: {
        compact: 'CompactAssignmentsWith24',
        score: 'ElectionScore',
        round: 'u32'
    },
    RawSolutionTo265: 'RawSolutionWith16',
    ReadySolution: {
        supports: 'SolutionSupports',
        score: 'ElectionScore',
        compute: 'ElectionCompute'
    },
    RoundSnapshot: {
        voters: 'Vec<(AccountId, VoteWeight, Vec<AccountId>)>',
        targets: 'Vec<AccountId>'
    },
    SeatHolder: {
        who: 'AccountId',
        stake: 'Balance',
        deposit: 'Balance'
    },
    SignedSubmission: {
        _fallback: 'SignedSubmissionTo276',
        who: 'AccountId',
        deposit: 'Balance',
        solution: 'RawSolution',
        reward: 'Balance'
    },
    SignedSubmissionTo276: {
        who: 'AccountId',
        deposit: 'Balance',
        solution: 'RawSolution'
    },
    SignedSubmissionOf: 'SignedSubmission',
    SolutionOrSnapshotSize: {
        voters: 'Compact<u32>',
        targets: 'Compact<u32>'
    },
    SolutionSupport: {
        total: 'ExtendedBalance',
        voters: 'Vec<(AccountId, ExtendedBalance)>'
    },
    SolutionSupports: 'Vec<(AccountId, SolutionSupport)>',
    Supports: 'SolutionSupports',
    SubmissionIndicesOf: 'BTreeMap<ElectionScore, u32>',
    Voter: {
        votes: 'Vec<AccountId>',
        stake: 'Balance',
        deposit: 'Balance'
    },
    VoteWeight: 'u64'
};
var definitions$z = {
    rpc: {},
    runtime: runtime$f,
    types: {
        ...deprecated,
        ...phragmen,
        ActiveEraInfo: {
            index: 'EraIndex',
            start: 'Option<Moment>'
        },
        EraIndex: 'u32',
        EraRewardPoints: {
            total: 'RewardPoint',
            individual: 'BTreeMap<AccountId, RewardPoint>'
        },
        EraRewards: {
            total: 'u32',
            rewards: 'Vec<u32>'
        },
        Exposure: {
            total: 'Compact<Balance>',
            own: 'Compact<Balance>',
            others: 'Vec<IndividualExposure>'
        },
        Forcing: {
            _enum: [
                'NotForcing',
                'ForceNew',
                'ForceNone',
                'ForceAlways'
            ]
        },
        IndividualExposure: {
            who: 'AccountId',
            value: 'Compact<Balance>'
        },
        KeyType: 'AccountId',
        MomentOf: 'Moment',
        Nominations: {
            targets: 'Vec<AccountId>',
            submittedIn: 'EraIndex',
            suppressed: 'bool'
        },
        NominatorIndex: 'u32',
        NominatorIndexCompact: 'Compact<NominatorIndex>',
        OffchainAccuracy: 'PerU16',
        OffchainAccuracyCompact: 'Compact<OffchainAccuracy>',
        PhragmenScore: '[u128; 3]',
        Points: 'u32',
        RewardDestination: {
            _enum: {
                Staked: 'Null',
                Stash: 'Null',
                Controller: 'Null',
                Account: 'AccountId',
                None: 'Null'
            }
        },
        RewardPoint: 'u32',
        SlashJournalEntry: {
            who: 'AccountId',
            amount: 'Balance',
            ownSlash: 'Balance'
        },
        SlashingSpansTo204: {
            spanIndex: 'SpanIndex',
            lastStart: 'EraIndex',
            prior: 'Vec<EraIndex>'
        },
        SlashingSpans: {
            spanIndex: 'SpanIndex',
            lastStart: 'EraIndex',
            lastNonzeroSlash: 'EraIndex',
            prior: 'Vec<EraIndex>'
        },
        SpanIndex: 'u32',
        SpanRecord: {
            slashed: 'Balance',
            paidOut: 'Balance'
        },
        StakingLedgerTo223: {
            stash: 'AccountId',
            total: 'Compact<Balance>',
            active: 'Compact<Balance>',
            unlocking: 'Vec<UnlockChunk>'
        },
        StakingLedgerTo240: {
            _fallback: 'StakingLedgerTo223',
            stash: 'AccountId',
            total: 'Compact<Balance>',
            active: 'Compact<Balance>',
            unlocking: 'Vec<UnlockChunk>',
            lastReward: 'Option<EraIndex>'
        },
        StakingLedger: {
            stash: 'AccountId',
            total: 'Compact<Balance>',
            active: 'Compact<Balance>',
            unlocking: 'Vec<UnlockChunk>',
            claimedRewards: 'Vec<EraIndex>'
        },
        UnappliedSlashOther: '(AccountId, Balance)',
        UnappliedSlash: {
            validator: 'AccountId',
            own: 'Balance',
            others: 'Vec<UnappliedSlashOther>',
            reporters: 'Vec<AccountId>',
            payout: 'Balance'
        },
        UnlockChunk: {
            value: 'Compact<Balance>',
            era: 'Compact<BlockNumber>'
        },
        ValidatorIndex: 'u16',
        ValidatorIndexCompact: 'Compact<ValidatorIndex>',
        ValidatorPrefs: 'ValidatorPrefsWithBlocked',
        ValidatorPrefsWithCommission: {
            commission: 'Compact<Perbill>'
        },
        ValidatorPrefsWithBlocked: {
            commission: 'Compact<Perbill>',
            blocked: 'bool'
        },
        ValidatorPrefsTo196: {
            validatorPayment: 'Compact<Balance>'
        },
        ValidatorPrefsTo145: {
            unstakeThreshold: 'Compact<u32>',
            validatorPayment: 'Compact<Balance>'
        }
    }
};

const runtime$e = {
    ValidateStatement: [
        {
            methods: {
                valdate_statement: {
                    description: 'Validate the statement.',
                    params: [
                        {
                            name: 'source',
                            type: 'StatementStoreStatementSource'
                        },
                        {
                            name: 'statement',
                            type: 'SpStatementStoreStatement'
                        }
                    ],
                    type: 'Result<StatementStoreValidStatement, StatementStoreInvalidStatement>'
                }
            },
            version: 1
        }
    ]
};

var definitions$y = {
    rpc: {},
    runtime: runtime$e,
    types: {
        StatementStoreStatementSource: {
            _enum: ['Chain', 'Network', 'Local']
        },
        StatementStoreValidStatement: {
            maxCount: 'u32',
            maxSize: 'u32'
        },
        StatementStoreInvalidStatement: {
            _enum: ['BadProof', 'NoProof', 'InternalError']
        }
    }
};

var definitions$x = {
    rpc: {},
    types: {
        WeightToFeeCoefficient: {
            coeffInteger: 'Balance',
            coeffFrac: 'Perbill',
            negative: 'bool',
            degree: 'u8'
        }
    }
};

const rpc$9 = {
    genSyncSpec: {
        description: 'Returns the json-serialized chainspec running the node, with a sync state.',
        endpoint: 'sync_state_genSyncSpec',
        params: [
            {
                name: 'raw',
                type: 'bool'
            }
        ],
        type: 'Json'
    }
};

var definitions$w = {
    rpc: rpc$9,
    types: {}
};

const rpc$8 = {
    accountNextIndex: {
        alias: ['account_nextIndex'],
        description: 'Retrieves the next accountIndex as available on the node',
        params: [
            {
                name: 'accountId',
                type: 'AccountId'
            }
        ],
        type: 'Index'
    },
    addLogFilter: {
        description: 'Adds the supplied directives to the current log filter',
        isUnsafe: true,
        params: [
            {
                name: 'directives',
                type: 'Text'
            }
        ],
        type: 'Null'
    },
    addReservedPeer: {
        description: 'Adds a reserved peer',
        isUnsafe: true,
        params: [
            {
                name: 'peer',
                type: 'Text'
            }
        ],
        type: 'Text'
    },
    chain: {
        description: 'Retrieves the chain',
        params: [],
        type: 'Text'
    },
    chainType: {
        description: 'Retrieves the chain type',
        params: [],
        type: 'ChainType'
    },
    dryRun: {
        alias: ['system_dryRunAt'],
        description: 'Dry run an extrinsic at a given block',
        isUnsafe: true,
        params: [
            {
                name: 'extrinsic',
                type: 'Bytes'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'ApplyExtrinsicResult'
    },
    health: {
        description: 'Return health status of the node',
        noErrorLog: true,
        params: [],
        type: 'Health'
    },
    localListenAddresses: {
        description: 'The addresses include a trailing /p2p/ with the local PeerId, and are thus suitable to be passed to addReservedPeer or as a bootnode address for example',
        params: [],
        type: 'Vec<Text>'
    },
    localPeerId: {
        description: 'Returns the base58-encoded PeerId of the node',
        params: [],
        type: 'Text'
    },
    name: {
        description: 'Retrieves the node name',
        params: [],
        type: 'Text'
    },
    networkState: {
        alias: ['system_unstable_networkState'],
        description: 'Returns current state of the network',
        isUnsafe: true,
        params: [],
        type: 'NetworkState'
    },
    nodeRoles: {
        description: 'Returns the roles the node is running as',
        params: [],
        type: 'Vec<NodeRole>'
    },
    peers: {
        description: 'Returns the currently connected peers',
        isUnsafe: true,
        params: [],
        type: 'Vec<PeerInfo>'
    },
    properties: {
        description: 'Get a custom set of properties as a JSON object, defined in the chain spec',
        params: [],
        type: 'ChainProperties'
    },
    removeReservedPeer: {
        description: 'Remove a reserved peer',
        isUnsafe: true,
        params: [
            {
                name: 'peerId',
                type: 'Text'
            }
        ],
        type: 'Text'
    },
    reservedPeers: {
        description: 'Returns the list of reserved peers',
        params: [],
        type: 'Vec<Text>'
    },
    resetLogFilter: {
        description: 'Resets the log filter to Substrate defaults',
        isUnsafe: true,
        params: [],
        type: 'Null'
    },
    syncState: {
        description: 'Returns the state of the syncing of the node',
        params: [],
        type: 'SyncState'
    },
    version: {
        description: 'Retrieves the version of the node',
        params: [],
        type: 'Text'
    }
};

const runtime$d = {
    AccountNonceApi: [
        {
            methods: {
                account_nonce: {
                    description: 'The API to query account nonce (aka transaction index)',
                    params: [
                        {
                            name: 'accountId',
                            type: 'AccountId'
                        }
                    ],
                    type: 'Index'
                }
            },
            version: 1
        }
    ]
};

var definitions$v = {
    rpc: rpc$8,
    runtime: runtime$d,
    types: {
        AccountInfo: 'AccountInfoWithTripleRefCount',
        AccountInfoWithRefCountU8: {
            nonce: 'Index',
            refcount: 'u8',
            data: 'AccountData'
        },
        AccountInfoWithRefCount: {
            _fallback: 'AccountInfoWithRefCountU8',
            nonce: 'Index',
            refcount: 'RefCount',
            data: 'AccountData'
        },
        AccountInfoWithDualRefCount: {
            _fallback: 'AccountInfoWithRefCount',
            nonce: 'Index',
            consumers: 'RefCount',
            providers: 'RefCount',
            data: 'AccountData'
        },
        // original naming
        AccountInfoWithProviders: 'AccountInfoWithDualRefCount',
        AccountInfoWithTripleRefCount: {
            _fallback: 'AccountInfoWithDualRefCount',
            nonce: 'Index',
            consumers: 'RefCount',
            providers: 'RefCount',
            sufficients: 'RefCount',
            data: 'AccountData'
        },
        ApplyExtrinsicResult: 'Result<DispatchOutcome, TransactionValidityError>',
        ApplyExtrinsicResultPre6: 'Result<DispatchOutcomePre6, TransactionValidityError>',
        ArithmeticError: {
            _enum: [
                'Underflow',
                'Overflow',
                'DivisionByZero'
            ]
        },
        BlockLength: {
            max: 'PerDispatchClassU32'
        },
        BlockWeights: {
            baseBlock: 'Weight',
            maxBlock: 'Weight',
            perClass: 'PerDispatchClassWeightsPerClass'
        },
        ChainProperties: 'GenericChainProperties',
        ChainType: {
            _enum: {
                Development: 'Null',
                Local: 'Null',
                Live: 'Null',
                Custom: 'Text'
            }
        },
        ConsumedWeight: 'PerDispatchClassWeight',
        DigestOf: 'Digest',
        DispatchClass: {
            _enum: ['Normal', 'Operational', 'Mandatory']
        },
        DispatchError: {
            _enum: {
                Other: 'Null',
                CannotLookup: 'Null',
                BadOrigin: 'Null',
                Module: 'DispatchErrorModule',
                ConsumerRemaining: 'Null',
                NoProviders: 'Null',
                TooManyConsumers: 'Null',
                Token: 'TokenError',
                Arithmetic: 'ArithmeticError',
                Transactional: 'TransactionalError',
                Exhausted: 'Null',
                Corruption: 'Null',
                Unavailable: 'Null'
            }
        },
        DispatchErrorPre6: {
            _enum: {
                Other: 'Null',
                CannotLookup: 'Null',
                BadOrigin: 'Null',
                Module: 'DispatchErrorModulePre6',
                ConsumerRemaining: 'Null',
                NoProviders: 'Null',
                TooManyConsumers: 'Null',
                Token: 'TokenError',
                Arithmetic: 'ArithmeticError',
                Transactional: 'TransactionalError'
            }
        },
        DispatchErrorPre6First: {
            // The enum was modified mid-flight, affecting asset chains -
            // https://github.com/paritytech/substrate/pull/10382/files#diff-e4e016b33a82268b6208dc974eea841bad47597865a749fee2f937eb6fdf67b4R498
            _enum: {
                Other: 'Null',
                CannotLookup: 'Null',
                BadOrigin: 'Null',
                Module: 'DispatchErrorModulePre6',
                ConsumerRemaining: 'Null',
                NoProviders: 'Null',
                Token: 'TokenError',
                Arithmetic: 'ArithmeticError',
                Transactional: 'TransactionalError'
            }
        },
        DispatchErrorModuleU8: {
            index: 'u8',
            error: 'u8'
        },
        DispatchErrorModuleU8a: {
            index: 'u8',
            error: '[u8; 4]'
        },
        DispatchErrorModule: 'DispatchErrorModuleU8a',
        DispatchErrorModulePre6: 'DispatchErrorModuleU8',
        DispatchErrorTo198: {
            module: 'Option<u8>',
            error: 'u8'
        },
        DispatchInfo: {
            weight: 'Weight',
            class: 'DispatchClass',
            paysFee: 'Pays'
        },
        DispatchInfoTo190: {
            weight: 'Weight',
            class: 'DispatchClass'
        },
        DispatchInfoTo244: {
            weight: 'Weight',
            class: 'DispatchClass',
            paysFee: 'bool'
        },
        DispatchOutcome: 'Result<(), DispatchError>',
        DispatchOutcomePre6: 'Result<(), DispatchErrorPre6>',
        DispatchResult: 'Result<(), DispatchError>',
        DispatchResultOf: 'DispatchResult',
        DispatchResultTo198: 'Result<(), Text>',
        Event: 'GenericEvent',
        EventId: '[u8; 2]',
        EventIndex: 'u32',
        EventRecord: {
            phase: 'Phase',
            event: 'Event',
            topics: 'Vec<Hash>'
        },
        Health: {
            peers: 'u64',
            isSyncing: 'bool',
            shouldHavePeers: 'bool'
        },
        InvalidTransaction: {
            _enum: {
                Call: 'Null',
                Payment: 'Null',
                Future: 'Null',
                Stale: 'Null',
                BadProof: 'Null',
                AncientBirthBlock: 'Null',
                ExhaustsResources: 'Null',
                Custom: 'u8',
                BadMandatory: 'Null',
                MandatoryDispatch: 'Null',
                BadSigner: 'Null'
            }
        },
        Key: 'Bytes',
        LastRuntimeUpgradeInfo: {
            specVersion: 'Compact<u32>',
            specName: 'Text'
        },
        NetworkState: {
            peerId: 'Text',
            listenedAddresses: 'Vec<Text>',
            externalAddresses: 'Vec<Text>',
            connectedPeers: 'HashMap<Text, Peer>',
            notConnectedPeers: 'HashMap<Text, NotConnectedPeer>',
            averageDownloadPerSec: 'u64',
            averageUploadPerSec: 'u64',
            peerset: 'NetworkStatePeerset'
        },
        NetworkStatePeerset: {
            messageQueue: 'u64',
            nodes: 'HashMap<Text, NetworkStatePeersetInfo>'
        },
        NetworkStatePeersetInfo: {
            connected: 'bool',
            reputation: 'i32'
        },
        NodeRole: {
            _enum: {
                Full: 'Null',
                LightClient: 'Null',
                Authority: 'Null',
                UnknownRole: 'u8'
            }
        },
        NotConnectedPeer: {
            knownAddresses: 'Vec<Text>',
            latestPingTime: 'Option<PeerPing>',
            versionString: 'Option<Text>'
        },
        Peer: {
            enabled: 'bool',
            endpoint: 'PeerEndpoint',
            knownAddresses: 'Vec<Text>',
            latestPingTime: 'PeerPing',
            open: 'bool',
            versionString: 'Text'
        },
        PeerEndpoint: {
            listening: 'PeerEndpointAddr'
        },
        PeerEndpointAddr: {
            _alias: {
                localAddr: 'local_addr',
                sendBackAddr: 'send_back_addr'
            },
            localAddr: 'Text',
            sendBackAddr: 'Text'
        },
        PeerPing: {
            nanos: 'u64',
            secs: 'u64'
        },
        PeerInfo: {
            peerId: 'Text',
            roles: 'Text',
            protocolVersion: 'u32',
            bestHash: 'Hash',
            bestNumber: 'BlockNumber'
        },
        PerDispatchClassU32: {
            normal: 'u32',
            operational: 'u32',
            mandatory: 'u32'
        },
        PerDispatchClassWeight: {
            normal: 'Weight',
            operational: 'Weight',
            mandatory: 'Weight'
        },
        PerDispatchClassWeightsPerClass: {
            normal: 'WeightPerClass',
            operational: 'WeightPerClass',
            mandatory: 'WeightPerClass'
        },
        Phase: {
            _enum: {
                ApplyExtrinsic: 'u32',
                Finalization: 'Null',
                Initialization: 'Null'
            }
        },
        RawOrigin: {
            _enum: {
                Root: 'Null',
                Signed: 'AccountId',
                None: 'Null'
            }
        },
        RefCount: 'u32',
        RefCountTo259: 'u8',
        SyncState: {
            startingBlock: 'BlockNumber',
            currentBlock: 'BlockNumber',
            highestBlock: 'Option<BlockNumber>'
        },
        SystemOrigin: 'RawOrigin',
        TokenError: {
            _enum: [
                'NoFunds',
                'WouldDie',
                'BelowMinimum',
                'CannotCreate',
                'UnknownAsset',
                'Frozen',
                'Unsupported',
                // these are dropped, but still in older versions
                // (if this adjusts, will need to take a re-look)
                'Underflow',
                'Overflow'
            ]
        },
        TransactionValidityError: {
            _enum: {
                Invalid: 'InvalidTransaction',
                Unknown: 'UnknownTransaction'
            }
        },
        TransactionalError: {
            _enum: [
                'LimitReached',
                'NoLayer'
            ]
        },
        UnknownTransaction: {
            _enum: {
                CannotLookup: 'Null',
                NoUnsignedValidator: 'Null',
                Custom: 'u8'
            }
        },
        WeightPerClass: {
            baseExtrinsic: 'Weight',
            maxExtrinsic: 'Option<Weight>',
            maxTotal: 'Option<Weight>',
            reserved: 'Option<Weight>'
        }
    }
};

var definitions$u = {
    rpc: {},
    types: {
        Bounty: {
            proposer: 'AccountId',
            value: 'Balance',
            fee: 'Balance',
            curatorDeposit: 'Balance',
            bond: 'Balance',
            status: 'BountyStatus'
        },
        BountyIndex: 'u32',
        BountyStatus: {
            _enum: {
                Proposed: 'Null',
                Approved: 'Null',
                Funded: 'Null',
                CuratorProposed: 'BountyStatusCuratorProposed',
                Active: 'BountyStatusActive',
                PendingPayout: 'BountyStatusPendingPayout'
            }
        },
        BountyStatusActive: {
            curator: 'AccountId',
            updateDue: 'BlockNumber'
        },
        BountyStatusCuratorProposed: {
            curator: 'AccountId'
        },
        BountyStatusPendingPayout: {
            curator: 'AccountId',
            beneficiary: 'AccountId',
            unlockAt: 'BlockNumber'
        },
        OpenTip: {
            reason: 'Hash',
            who: 'AccountId',
            finder: 'AccountId',
            deposit: 'Balance',
            closes: 'Option<BlockNumber>',
            tips: 'Vec<OpenTipTip>',
            findersFee: 'bool'
        },
        OpenTipTo225: {
            reason: 'Hash',
            who: 'AccountId',
            finder: 'Option<OpenTipFinderTo225>',
            closes: 'Option<BlockNumber>',
            tips: 'Vec<OpenTipTip>'
        },
        OpenTipFinderTo225: '(AccountId, Balance)',
        OpenTipTip: '(AccountId, Balance)',
        TreasuryProposal: {
            proposer: 'AccountId',
            value: 'Balance',
            beneficiary: 'AccountId',
            bond: 'Balance'
        }
    }
};

var definitions$t = {
    rpc: {},
    types: {
        Multiplier: 'Fixed128'
    }
};

const runtime$c = {
    TaggedTransactionQueue: [
        {
            methods: {
                validate_transaction: {
                    description: 'Validate the transaction.',
                    params: [
                        {
                            name: 'source',
                            type: 'TransactionSource'
                        },
                        {
                            name: 'tx',
                            type: 'Extrinsic'
                        },
                        {
                            name: 'blockHash',
                            type: 'BlockHash'
                        }
                    ],
                    type: 'TransactionValidity'
                }
            },
            version: 3
        },
        {
            methods: {
                validate_transaction: {
                    description: 'Validate the transaction.',
                    params: [
                        {
                            name: 'source',
                            type: 'TransactionSource'
                        },
                        {
                            name: 'tx',
                            type: 'Extrinsic'
                        }
                    ],
                    type: 'TransactionValidity'
                }
            },
            version: 2
        },
        {
            methods: {
                validate_transaction: {
                    description: 'Validate the transaction.',
                    params: [
                        {
                            name: 'tx',
                            type: 'Extrinsic'
                        }
                    ],
                    type: 'TransactionValidity'
                }
            },
            version: 1
        }
    ]
};

var definitions$s = {
    rpc: {},
    runtime: runtime$c,
    types: {
        TransactionSource: {
            _enum: ['InBlock', 'Local', 'External']
        },
        TransactionValidity: 'Result<ValidTransaction, TransactionValidityError>',
        ValidTransaction: {
            priority: 'TransactionPriority',
            requires: 'Vec<TransactionTag>',
            provides: 'Vec<TransactionTag>',
            longevity: 'TransactionLongevity',
            propagate: 'bool'
        }
    }
};

var definitions$r = {
    rpc: {},
    types: {
        ClassId: 'u32',
        InstanceId: 'u32',
        DepositBalance: 'Balance',
        DepositBalanceOf: 'Balance',
        ClassDetails: {
            owner: 'AccountId',
            issuer: 'AccountId',
            admin: 'AccountId',
            freezer: 'AccountId',
            totalDeposit: 'DepositBalance',
            freeHolding: 'bool',
            instances: 'u32',
            instanceMetadatas: 'u32',
            attributes: 'u32',
            isFrozen: 'bool'
        },
        DestroyWitness: {
            instances: 'Compact<u32>',
            instanceMetadatas: 'Compact<u32>',
            attributes: 'Compact<u32>'
        },
        InstanceDetails: {
            owner: 'AccountId',
            approved: 'Option<AccountId>',
            isFrozen: 'bool',
            deposit: 'DepositBalance'
        },
        ClassMetadata: {
            deposit: 'DepositBalance',
            data: 'Vec<u8>',
            isFrozen: 'bool'
        },
        InstanceMetadata: {
            deposit: 'DepositBalance',
            data: 'Vec<u8>',
            isFrozen: 'bool'
        }
    }
};

var definitions$q = {
    rpc: {},
    types: {
        Multisig: {
            when: 'Timepoint',
            deposit: 'Balance',
            depositor: 'AccountId',
            approvals: 'Vec<AccountId>'
        },
        Timepoint: {
            height: 'BlockNumber',
            index: 'u32'
        }
    }
};

var definitions$p = {
    rpc: {},
    types: {
        VestingInfo: {
            locked: 'Balance',
            perBlock: 'Balance',
            startingBlock: 'BlockNumber'
        }
    }
};

var definitions$o = {
    rpc: {},
    types: {
        BlockAttestations: {
            receipt: 'CandidateReceipt',
            valid: 'Vec<AccountId>',
            invalid: 'Vec<AccountId>'
        },
        IncludedBlocks: {
            actualNumber: 'BlockNumber',
            session: 'SessionIndex',
            randomSeed: 'H256',
            activeParachains: 'Vec<ParaId>',
            paraBlocks: 'Vec<Hash>'
        },
        MoreAttestations: {}
    }
};

var definitions$n = {
    rpc: {},
    types: {
        BridgedBlockHash: 'H256',
        BridgedBlockNumber: 'BlockNumber',
        BridgedHeader: 'Header',
        BridgeMessageId: '(LaneId, MessageNonce)',
        CallOrigin: {
            _enum: {
                SourceRoot: 'Null',
                TargetAccount: '(AccountId, MultiSigner, MultiSignature)',
                SourceAccount: 'AccountId'
            }
        },
        ChainId: '[u8; 4]',
        DeliveredMessages: {
            begin: 'MessageNonce',
            end: 'MessageNonce',
            // pub type DispatchResultsBitVec = BitVec<Msb0, u8>;
            dispatchResults: 'BitVec'
        },
        DispatchFeePayment: {
            _enum: ['AtSourceChain', 'AtTargetChain']
        },
        InboundLaneData: {
            relayers: 'Vec<UnrewardedRelayer>',
            lastConfirmedNonce: 'MessageNonce'
        },
        InboundRelayer: 'AccountId',
        InitializationData: {
            header: 'Header',
            authorityList: 'AuthorityList',
            setId: 'SetId',
            isHalted: 'bool'
        },
        LaneId: '[u8; 4]',
        MessageData: {
            payload: 'Bytes',
            fee: 'Balance'
        },
        MessagesDeliveryProofOf: {
            bridgedHeaderHash: 'BlockHash',
            storageProof: 'Vec<Bytes>',
            lane: 'LaneId'
        },
        MessageKey: {
            laneId: 'LaneId',
            nonce: 'MessageNonce'
        },
        MessageNonce: 'u64',
        MessagesProofOf: {
            bridgedHeaderHash: 'BridgedBlockHash',
            storageProof: 'Vec<Bytes>',
            lane: 'LaneId',
            noncesStart: 'MessageNonce',
            noncesEnd: 'MessageNonce'
        },
        OperatingMode: {
            _enum: ['Normal', 'RejectingOutboundMessages', 'Halted']
        },
        OutboundLaneData: {
            oldestUnprunedNonce: 'MessageNonce',
            latestReceivedNonce: 'MessageNonce',
            latestGeneratedNonce: 'MessageNonce'
        },
        OutboundMessageFee: 'Balance',
        OutboundPayload: {
            specVersion: 'u32',
            weight: 'Weight',
            origin: 'CallOrigin',
            dispatchFeePayment: 'DispatchFeePayment',
            call: 'Bytes'
        },
        Parameter: 'Null',
        RelayerId: 'AccountId',
        UnrewardedRelayer: {
            relayer: 'RelayerId',
            messages: 'DeliveredMessages'
        },
        UnrewardedRelayersState: {
            unrewardedRelayer_Entries: 'MessageNonce',
            messagesInOldestEntry: 'MessageNonce',
            totalMessages: 'MessageNonce'
        }
    }
};

var definitions$m = {
    rpc: {},
    types: {
        StatementKind: {
            _enum: ['Regular', 'Saft']
        }
    }
};

var definitions$l = {
    rpc: {},
    types: {
        FundIndex: 'u32',
        LastContribution: {
            _enum: {
                Never: 'Null',
                PreEnding: 'u32',
                Ending: 'BlockNumber'
            }
        },
        FundInfo: {
            depositor: 'AccountId',
            verifier: 'Option<MultiSigner>',
            deposit: 'Balance',
            raised: 'Balance',
            end: 'BlockNumber',
            cap: 'Balance',
            lastContribution: 'LastContribution',
            firstPeriod: 'LeasePeriod',
            lastPeriod: 'LeasePeriod',
            trieIndex: 'TrieIndex'
        },
        TrieIndex: 'u32'
    }
};

const runtime$b = {
    AuraUnincludedSegmentApi: [
        {
            methods: {
                can_build_upon: {
                    description: 'Whether it is legal to extend the chain',
                    params: [
                        {
                            name: 'includedHash',
                            type: 'BlockHash'
                        },
                        {
                            name: 'slot',
                            type: 'Slot'
                        }
                    ],
                    type: 'bool'
                }
            },
            version: 1
        }
    ],
    CollectCollationInfo: [
        {
            methods: {
                collect_collation_info: {
                    description: 'Collect information about a collation.',
                    params: [
                        {
                            name: 'header',
                            type: 'Header'
                        }
                    ],
                    type: 'CollationInfo'
                }
            },
            version: 2
        },
        {
            methods: {
                collect_collation_info: {
                    description: 'Collect information about a collation.',
                    params: [],
                    type: 'CollationInfoV1'
                }
            },
            version: 1
        }
    ]
};

const dmpQueue = {
    CollationInfo: {
        upwardMessages: 'Vec<UpwardMessage>',
        horizontalMessages: 'Vec<OutboundHrmpMessage>',
        newValidationCode: 'Option<ValidationCode>',
        processedDownwardMessages: 'u32',
        hrmpWatermark: 'RelayBlockNumber',
        headData: 'HeadData'
    },
    CollationInfoV1: {
        upwardMessages: 'Vec<UpwardMessage>',
        horizontalMessages: 'Vec<OutboundHrmpMessage>',
        newValidationCode: 'Option<ValidationCode>',
        processedDownwardMessages: 'u32',
        hrmpWatermark: 'RelayBlockNumber'
    },
    ConfigData: {
        maxIndividual: 'Weight'
    },
    MessageId: '[u8; 32]',
    OverweightIndex: 'u64',
    PageCounter: 'u32',
    PageIndexData: {
        beginUsed: 'PageCounter',
        endUsed: 'PageCounter',
        overweightCount: 'OverweightIndex'
    }
};
var definitions$k = {
    rpc: {},
    runtime: runtime$b,
    types: dmpQueue
};

const finalityV1 = {
    methods: {
        best_finalized: {
            description: 'Returns number and hash of the best finalized header known to the bridge module.',
            params: [],
            type: '(BlockNumber, Hash)'
        }
    },
    version: 1
};
const runtime$a = {
    KusamaFinalityApi: [finalityV1],
    PolkadotFinalityApi: [finalityV1],
    RococoFinalityApi: [finalityV1],
    WestendFinalityApi: [finalityV1]
};

var definitions$j = {
    rpc: {},
    runtime: runtime$a,
    types: {}
};

/* eslint-disable sort-keys */
var hrmpTypes = {
    HrmpChannel: {
        maxCapacity: 'u32',
        maxTotalSize: 'u32',
        maxMessageSize: 'u32',
        msgCount: 'u32',
        totalSize: 'u32',
        mqcHead: 'Option<Hash>',
        senderDeposit: 'Balance',
        recipientDeposit: 'Balance'
    },
    HrmpChannelId: {
        sender: 'u32',
        receiver: 'u32'
    },
    HrmpOpenChannelRequest: {
        confirmed: 'bool',
        age: 'SessionIndex',
        senderDeposit: 'Balance',
        maxMessageSize: 'u32',
        maxCapacity: 'u32',
        maxTotalSize: 'u32'
    }
};

const PH_V1_TO_V2 = {
    assumed_validation_data: {
        description: 'Returns the persisted validation data for the given `ParaId` along with the corresponding validation code hash.',
        params: [
            {
                name: 'paraId',
                type: 'ParaId'
            },
            {
                name: 'hash',
                type: 'Hash'
            }
        ],
        type: 'Option<(PersistedValidationData, ValidationCodeHash)>'
    },
    availability_cores: {
        description: 'Yields information on all availability cores as relevant to the child block.',
        params: [],
        type: 'Vec<CoreState>'
    },
    candidate_events: {
        description: 'Get a vector of events concerning candidates that occurred within a block.',
        params: [],
        type: 'Vec<CandidateEvent>'
    },
    candidate_pending_availability: {
        description: 'Get the receipt of a candidate pending availability.',
        params: [
            {
                name: 'paraId',
                type: 'ParaId'
            }
        ],
        type: 'Option<CommittedCandidateReceipt>'
    },
    check_validation_outputs: {
        description: 'Checks if the given validation outputs pass the acceptance criteria.',
        params: [
            {
                name: 'paraId',
                type: 'ParaId'
            },
            {
                name: 'outputs',
                type: 'CandidateCommitments'
            }
        ],
        type: 'bool'
    },
    dmq_contents: {
        description: 'Get all the pending inbound messages in the downward message queue for a para.',
        params: [
            {
                name: 'paraId',
                type: 'ParaId'
            }
        ],
        type: 'Vec<InboundDownwardMessage>'
    },
    inbound_hrmp_channels_contents: {
        description: 'Get the contents of all channels addressed to the given recipient.',
        params: [
            {
                name: 'paraId',
                type: 'ParaId'
            }
        ],
        type: 'Vec<InboundHrmpMessage>'
    },
    on_chain_votes: {
        description: 'Scrape dispute relevant from on-chain, backing votes and resolved disputes.',
        params: [],
        type: 'Option<ScrapedOnChainVotes>'
    },
    persisted_validation_data: {
        description: 'Yields the persisted validation data for the given `ParaId` along with an assumption that should be used if the para currently occupies a core.',
        params: [
            {
                name: 'paraId',
                type: 'ParaId'
            },
            {
                name: 'assumption',
                type: 'OccupiedCoreAssumption'
            }
        ],
        type: 'Option<PersistedValidationData>'
    },
    session_index_for_child: {
        description: 'Returns the session index expected at a child of the block.',
        params: [],
        type: 'SessionIndex'
    },
    validation_code: {
        description: 'Fetch the validation code used by a para, making the given `OccupiedCoreAssumption`.',
        params: [
            {
                name: 'paraId',
                type: 'ParaId'
            },
            {
                name: 'assumption',
                type: 'OccupiedCoreAssumption'
            }
        ],
        type: 'Option<ValidationCode>'
    },
    validation_code_by_hash: {
        description: 'Get the validation code from its hash.',
        params: [
            {
                name: 'hash',
                type: 'ValidationCodeHash'
            }
        ],
        type: 'Option<ValidationCode>'
    },
    validator_groups: {
        description: 'Returns the validator groups and rotation info localized based on the hypothetical child of a block whose state  this is invoked on',
        params: [],
        type: '(Vec<Vec<ParaValidatorIndex>>, GroupRotationInfo)'
    },
    validators: {
        description: 'Get the current validators.',
        params: [],
        type: 'Vec<ValidatorId>'
    }
};
const PH_V2_TO_V3 = {
    pvfs_require_precheck: {
        description: 'Returns code hashes of PVFs that require pre-checking by validators in the active set.',
        params: [],
        type: 'Vec<ValidationCodeHash>'
    },
    session_info: {
        description: 'Get the session info for the given session, if stored.',
        params: [
            {
                name: 'index',
                type: 'SessionIndex'
            }
        ],
        type: 'Option<SessionInfo>'
    },
    submit_pvf_check_statement: {
        description: 'Submits a PVF pre-checking statement into the transaction pool.',
        params: [
            {
                name: 'stmt',
                type: 'PvfCheckStatement'
            },
            {
                name: 'signature',
                type: 'ValidatorSignature'
            }
        ],
        type: 'Null'
    },
    validation_code_hash: {
        description: 'Fetch the hash of the validation code used by a para, making the given `OccupiedCoreAssumption`.',
        params: [
            {
                name: 'paraId',
                type: 'ParaId'
            },
            {
                name: 'assumption',
                type: 'OccupiedCoreAssumption'
            }
        ],
        type: 'Option<ValidationCodeHash>'
    }
};
const PH_V3 = {
    disputes: {
        description: 'Returns all onchain disputes.',
        params: [],
        type: 'Vec<(SessionIndex, CandidateHash, DisputeState)>'
    }
};
const PH_V4 = {
    session_executor_params: {
        description: 'Returns execution parameters for the session.',
        params: [
            {
                name: 'sessionIndex',
                type: 'SessionIndex'
            }
        ],
        type: 'Option<ExecutorParams>'
    }
};
const PH_V5 = {
    key_ownership_proof: {
        description: 'Returns a merkle proof of a validator session key',
        params: [
            {
                name: 'validatorId',
                type: 'ValidatorId'
            }
        ],
        type: 'Option<OpaqueKeyOwnershipProof>'
    },
    submit_report_dispute_lost: {
        description: 'Submit an unsigned extrinsic to slash validators who lost a dispute about a candidate of a past session',
        params: [
            {
                name: 'disputeProof',
                type: 'DisputeProof'
            },
            {
                name: 'keyOwnershipProof',
                type: 'OpaqueKeyOwnershipProof'
            }
        ],
        type: 'Option<Null>'
    },
    unapplied_slashes: {
        description: 'Returns a list of validators that lost a past session dispute and need to be slashed',
        params: [],
        type: 'Vec<(SessionIndex, CandidateHash, PendingSlashes)>'
    }
};
const PH_V6 = {
    minimum_backing_votes: {
        description: 'Get the minimum number of backing votes for a parachain candidate. This is a staging method! Do not use on production runtimes!',
        params: [],
        type: 'u32'
    }
};
const PH_V7 = {
    async_backing_params: {
        description: 'Returns candidate\'s acceptance limitations for asynchronous backing for a relay parent',
        params: [],
        type: 'AsyncBackingParams'
    },
    para_backing_state: {
        description: 'Returns the state of parachain backing for a given para',
        params: [
            {
                name: 'paraId',
                type: 'ParaId'
            }
        ],
        type: 'Option<BackingState>'
    }
};
const PH_V8 = {
    disabled_validators: {
        description: 'Returns a list of all disabled validators at the given block',
        params: [],
        type: 'ValidatorIndex'
    }
};
const PH_V9 = {
    node_features: {
        description: 'Get node features. This is a staging method! Do not use on production runtimes!',
        params: [],
        type: 'NodeFeatures'
    }
};
const PH_V10 = {
    approval_voting_params: {
        description: 'Approval voting configuration parameters',
        params: [],
        type: 'ApprovalVotingParams'
    }
};
const PH_V11 = {
    claim_queue: {
        description: 'Claim queue',
        params: [],
        type: 'BTreeMap<CoreIndex, Vec<u32>>'
    }
};
const runtime$9 = {
    ParachainHost: [
        {
            methods: {
                ...PH_V1_TO_V2,
                ...PH_V2_TO_V3,
                ...PH_V3,
                ...PH_V4,
                ...PH_V5,
                ...PH_V6,
                ...PH_V7,
                ...PH_V8,
                ...PH_V9,
                ...PH_V10,
                ...PH_V11
            },
            version: 11
        },
        {
            methods: {
                ...PH_V1_TO_V2,
                ...PH_V2_TO_V3,
                ...PH_V3,
                ...PH_V4,
                ...PH_V5,
                ...PH_V6,
                ...PH_V7,
                ...PH_V8,
                ...PH_V9,
                ...PH_V10
            },
            version: 10
        },
        {
            methods: {
                ...PH_V1_TO_V2,
                ...PH_V2_TO_V3,
                ...PH_V3,
                ...PH_V4,
                ...PH_V5,
                ...PH_V6,
                ...PH_V7,
                ...PH_V8,
                ...PH_V9
            },
            version: 9
        },
        {
            methods: {
                ...PH_V1_TO_V2,
                ...PH_V2_TO_V3,
                ...PH_V3,
                ...PH_V4,
                ...PH_V5,
                ...PH_V6,
                ...PH_V7,
                ...PH_V8
            },
            version: 8
        },
        {
            methods: {
                ...PH_V1_TO_V2,
                ...PH_V2_TO_V3,
                ...PH_V3,
                ...PH_V4,
                ...PH_V5,
                ...PH_V6,
                ...PH_V7
            },
            version: 7
        },
        {
            methods: {
                ...PH_V1_TO_V2,
                ...PH_V2_TO_V3,
                ...PH_V3,
                ...PH_V4,
                ...PH_V5,
                ...PH_V6
            },
            version: 6
        },
        {
            methods: {
                ...PH_V1_TO_V2,
                ...PH_V2_TO_V3,
                ...PH_V3,
                ...PH_V4,
                ...PH_V5
            },
            version: 5
        },
        {
            methods: {
                ...PH_V1_TO_V2,
                ...PH_V2_TO_V3,
                ...PH_V3,
                ...PH_V4
            },
            version: 4
        },
        {
            methods: {
                ...PH_V1_TO_V2,
                ...PH_V2_TO_V3,
                ...PH_V3
            },
            version: 3
        },
        {
            methods: {
                ...PH_V1_TO_V2,
                ...PH_V2_TO_V3
            },
            version: 2
        },
        {
            methods: {
                session_info: {
                    description: 'Get the session info for the given session, if stored.',
                    params: [
                        {
                            name: 'index',
                            type: 'SessionIndex'
                        }
                    ],
                    type: 'Option<OldV1SessionInfo>'
                },
                ...PH_V1_TO_V2
            },
            version: 1
        }
    ]
};

/* eslint-disable sort-keys */
const SlotRange10 = {
    _enum: ['ZeroZero', 'ZeroOne', 'ZeroTwo', 'ZeroThree', 'OneOne', 'OneTwo', 'OneThree', 'TwoTwo', 'TwoThree', 'ThreeThree']
};
const SlotRange = {
    _enum: ['ZeroZero', 'ZeroOne', 'ZeroTwo', 'ZeroThree', 'ZeroFour', 'ZeroFive', 'ZeroSix', 'ZeroSeven', 'OneOne', 'OneTwo', 'OneThree', 'OneFour', 'OneFive', 'OneSix', 'OneSeven', 'TwoTwo', 'TwoThree', 'TwoFour', 'TwoFive', 'TwoSix', 'TwoSeven', 'ThreeThree', 'ThreeFour', 'ThreeFive', 'ThreeSix', 'ThreeSeven', 'FourFour', 'FourFive', 'FourSix', 'FourSeven', 'FiveFive', 'FiveSix', 'FiveSeven', 'SixSix', 'SixSeven', 'SevenSeven']
};
const oldTypes = {
    Bidder: {
        _enum: {
            New: 'NewBidder',
            Existing: 'ParaId'
        }
    },
    IncomingParachain: {
        _enum: {
            Unset: 'NewBidder',
            Fixed: 'IncomingParachainFixed',
            Deploy: 'IncomingParachainDeploy'
        }
    },
    IncomingParachainDeploy: {
        code: 'ValidationCode',
        initialHeadData: 'HeadData'
    },
    IncomingParachainFixed: {
        codeHash: 'Hash',
        codeSize: 'u32',
        initialHeadData: 'HeadData'
    },
    NewBidder: {
        who: 'AccountId',
        sub: 'SubId'
    },
    SubId: 'u32'
};
var slotTypes = {
    ...oldTypes,
    AuctionIndex: 'u32',
    LeasePeriod: 'BlockNumber',
    LeasePeriodOf: 'BlockNumber',
    SlotRange10,
    SlotRange,
    WinningData10: `[WinningDataEntry; ${SlotRange10._enum.length}]`,
    WinningData: `[WinningDataEntry; ${SlotRange._enum.length}]`,
    WinningDataEntry: 'Option<(AccountId, ParaId, BalanceOf)>',
    WinnersData10: 'Vec<WinnersDataTuple10>',
    WinnersData: 'Vec<WinnersDataTuple>',
    WinnersDataTuple10: '(AccountId, ParaId, BalanceOf, SlotRange10)',
    WinnersDataTuple: '(AccountId, ParaId, BalanceOf, SlotRange)'
};

const proposeTypes = {
    ParachainProposal: {
        proposer: 'AccountId',
        genesisHead: 'HeadData',
        validators: 'Vec<ValidatorId>',
        name: 'Bytes',
        balance: 'Balance'
    },
    RegisteredParachainInfo: {
        validators: 'Vec<ValidatorId>',
        proposer: 'AccountId'
    }
};
const cumulusTypes = {
    ServiceQuality: {
        _enum: ['Ordered', 'Fast']
    }
};
const disputeTypes = {
    DisputeLocation: {
        _enum: ['Local', 'Remote']
    },
    DisputeResult: {
        _enum: ['Valid', 'Invalid']
    },
    DisputeState: {
        validatorsFor: 'BitVec',
        validatorsAgainst: 'BitVec',
        start: 'BlockNumber',
        concludedAt: 'Option<BlockNumber>'
    },
    DisputeStatement: {
        _enum: {
            Valid: 'ValidDisputeStatementKind',
            Invalid: 'InvalidDisputeStatementKind'
        }
    },
    DisputeStatementSet: {
        candidateHash: 'CandidateHash',
        session: 'SessionIndex',
        statements: 'Vec<(DisputeStatement, ParaValidatorIndex, ValidatorSignature)>'
    },
    ExecutorParam: {
        _enum: {
            Phantom: 'Null', // index starts at 1... empty slot at 0
            MaxMemoryPages: 'u32',
            StackLogicalMax: 'u32',
            StackNativeMax: 'u32',
            PrecheckingMaxMemory: 'u64',
            PvfPrepTimeout: '(PvfPrepTimeoutKind, u64)',
            PvfExecTimeout: '(PvfExecTimeoutKind, u64)'
        }
    },
    ExecutorParamsHash: 'Hash',
    ExecutorParams: 'Vec<ExecutorParam>',
    ExplicitDisputeStatement: {
        valid: 'bool',
        candidateHash: 'CandidateHash',
        session: 'SessionIndex'
    },
    InvalidDisputeStatementKind: {
        _enum: ['Explicit']
    },
    MultiDisputeStatementSet: 'Vec<DisputeStatementSet>',
    PvfExecTimeoutKind: {
        _enum: ['Backing', 'Approval']
    },
    PvfPrepTimeoutKind: {
        _enum: ['Precheck', 'Lenient']
    },
    ValidDisputeStatementKind: {
        _enum: {
            Explicit: 'Null',
            BackingSeconded: 'Hash',
            BackingValid: 'Hash',
            ApprovalChecking: 'Null'
        }
    }
};
var definitions$i = {
    rpc: {},
    runtime: runtime$9,
    types: {
        ...cumulusTypes,
        ...disputeTypes,
        ...hrmpTypes,
        ...proposeTypes,
        ...slotTypes,
        AbridgedCandidateReceipt: {
            parachainIndex: 'ParaId',
            relayParent: 'Hash',
            headData: 'HeadData',
            collator: 'CollatorId',
            signature: 'CollatorSignature',
            povBlockHash: 'Hash',
            commitments: 'CandidateCommitments'
        },
        AbridgedHostConfiguration: {
            maxCodeSize: 'u32',
            maxHeadDataSize: 'u32',
            maxUpwardQueueCount: 'u32',
            maxUpwardQueueSize: 'u32',
            maxUpwardMessageSize: 'u32',
            maxUpwardMessageNumPerCandidate: 'u32',
            hrmpMaxMessageNumPerCandidate: 'u32',
            validationUpgradeFrequency: 'BlockNumber',
            validationUpgradeDelay: 'BlockNumber'
        },
        AbridgedHrmpChannel: {
            maxCapacity: 'u32',
            maxTotalSize: 'u32',
            maxMessageSize: 'u32',
            msgCount: 'u32',
            totalSize: 'u32',
            mqcHead: 'Option<Hash>'
        },
        ApprovalVotingParams: {
            maxApprovalCoalesceCount: 'u32'
        },
        AssignmentId: 'AccountId',
        AssignmentKind: {
            _enum: {
                Parachain: 'Null',
                Parathread: '(CollatorId, u32)'
            }
        },
        AsyncBackingParams: {
            maxCandidateDepth: 'u32',
            allowedAncestryLen: 'u32'
        },
        AttestedCandidate: {
            candidate: 'AbridgedCandidateReceipt',
            validityVotes: 'Vec<ValidityAttestation>',
            validatorIndices: 'BitVec'
        },
        AuthorityDiscoveryId: 'AccountId',
        AvailabilityBitfield: 'BitVec',
        AvailabilityBitfieldRecord: {
            bitfield: 'AvailabilityBitfield',
            submittedTt: 'BlockNumber'
        },
        BackedCandidate: {
            candidate: 'CommittedCandidateReceipt',
            validityVotes: 'Vec<ValidityAttestation>',
            validatorIndices: 'BitVec'
        },
        BackingState: {
            constraints: 'Constraints',
            pendingAvailability: 'Vec<CandidatePendingAvailability>'
        },
        BufferedSessionChange: {
            applyAt: 'BlockNumber',
            validators: 'Vec<ValidatorId>',
            queued: 'Vec<ValidatorId>',
            sessionIndex: 'SessionIndex'
        },
        CandidateCommitments: {
            upwardMessages: 'Vec<UpwardMessage>',
            horizontalMessages: 'Vec<OutboundHrmpMessage>',
            newValidationCode: 'Option<ValidationCode>',
            headData: 'HeadData',
            processedDownwardMessages: 'u32',
            hrmpWatermark: 'BlockNumber'
        },
        CandidateDescriptor: {
            paraId: 'ParaId',
            relayParent: 'RelayChainHash',
            collatorId: 'CollatorId',
            persistedValidationDataHash: 'Hash',
            povHash: 'Hash',
            erasureRoot: 'Hash',
            signature: 'CollatorSignature',
            paraHead: 'Hash',
            validationCodeHash: 'ValidationCodeHash'
        },
        CandidateEvent: {
            _enum: {
                CandidateBacked: '(CandidateReceipt, HeadData, CoreIndex, GroupIndex)',
                CandidateIncluded: '(CandidateReceipt, HeadData, CoreIndex, GroupIndex)',
                CandidateTimedOut: '(CandidateReceipt, HeadData, CoreIndex)'
            }
        },
        CandidateHash: 'Hash',
        CandidateInfo: {
            who: 'AccountId',
            deposit: 'Balance'
        },
        CandidatePendingAvailability: {
            core: 'CoreIndex',
            hash: 'CandidateHash',
            descriptor: 'CandidateDescriptor',
            availabilityVotes: 'BitVec',
            backers: 'BitVec',
            relayParentNumber: 'BlockNumber',
            backedInNumber: 'BlockNumber',
            backingGroup: 'GroupIndex'
        },
        CandidateReceipt: {
            descriptor: 'CandidateDescriptor',
            commitmentsHash: 'Hash'
        },
        GlobalValidationData: {
            maxCodeSize: 'u32',
            maxHeadDataSize: 'u32',
            blockNumber: 'BlockNumber'
        },
        CollatorId: 'H256',
        CollatorSignature: 'Signature',
        CommittedCandidateReceipt: {
            descriptor: 'CandidateDescriptor',
            commitments: 'CandidateCommitments'
        },
        Constraints: {
            minRelayParentNumber: 'BlockNumber',
            maxPovSize: 'u32',
            maxCodeSize: 'u32',
            umpRemaining: 'u32',
            umpRemainingBytes: 'u32',
            maxUmpNumPerCandidate: 'u32',
            dmpRemainingMessages: 'Vec<BlockNumber>',
            hrmpInbound: 'InboundHrmpLimitations',
            hrmpChannelsOut: 'HashMap<ParaId, OutboundHrmpChannelLimitations>',
            maxHrmpNumPerCandidate: 'u32',
            requiredParent: 'HeadData',
            validationCodeHash: 'ValidationCodeHash',
            upgradeRestriction: 'Option<UpgradeRestriction>',
            futureValidationCode: 'Option<(BlockNumber, ValidationCodeHash)>'
        },
        CoreAssignment: {
            core: 'CoreIndex',
            paraId: 'ParaId',
            kind: 'AssignmentKind',
            groupIdx: 'GroupIndex'
        },
        CoreIndex: 'u32',
        CoreOccupied: {
            _enum: {
                Parathread: 'ParathreadEntry',
                Parachain: 'Null'
            }
        },
        CoreState: {
            _enum: {
                Occupied: 'OccupiedCore',
                Scheduled: 'ScheduledCore',
                Free: 'Null'
            }
        },
        DisputeProof: {
            timeSlot: 'DisputesTimeSlot',
            kind: 'SlashingOffenceKind',
            validatorIndex: 'ValidatorIndex',
            validatorId: 'ValidatorId'
        },
        DisputesTimeSlot: {
            sessionIndex: 'SessionIndex',
            candidateHash: 'CandidateHash'
        },
        DoubleVoteReport: {
            identity: 'ValidatorId',
            first: '(Statement, ValidatorSignature)',
            second: '(Statement, ValidatorSignature)',
            proof: 'MembershipProof',
            signingContext: 'SigningContext'
        },
        DownwardMessage: 'Bytes',
        GroupIndex: 'u32',
        GroupRotationInfo: {
            sessionStartBlock: 'BlockNumber',
            groupRotationFrequency: 'BlockNumber',
            now: 'BlockNumber'
        },
        GlobalValidationSchedule: {
            maxCodeSize: 'u32',
            maxHeadDataSize: 'u32',
            blockNumber: 'BlockNumber'
        },
        HeadData: 'Bytes',
        HostConfiguration: {
            maxCodeSize: 'u32',
            maxHeadDataSize: 'u32',
            maxUpwardQueueCount: 'u32',
            maxUpwardQueueSize: 'u32',
            maxUpwardMessageSize: 'u32',
            maxUpwardMessageNumPerCandidate: 'u32',
            hrmpMaxMessageNumPerCandidate: 'u32',
            validationUpgradeFrequency: 'BlockNumber',
            validationUpgradeDelay: 'BlockNumber',
            maxPovSize: 'u32',
            maxDownwardMessageSize: 'u32',
            preferredDispatchableUpwardMessagesStepWeight: 'Weight',
            hrmpMaxParachainOutboundChannels: 'u32',
            hrmpMaxParathreadOutboundChannels: 'u32',
            hrmpOpenRequestTtl: 'u32',
            hrmpSenderDeposit: 'Balance',
            hrmpRecipientDeposit: 'Balance',
            hrmpChannelMaxCapacity: 'u32',
            hrmpChannelMaxTotalSize: 'u32',
            hrmpMaxParachainInboundChannels: 'u32',
            hrmpMaxParathreadInboundChannels: 'u32',
            hrmpChannelMaxMessageSize: 'u32',
            codeRetentionPeriod: 'BlockNumber',
            parathreadCores: 'u32',
            parathreadRetries: 'u32',
            groupRotationFrequency: 'BlockNumber',
            chainAvailabilityPeriod: 'BlockNumber',
            threadAvailabilityPeriod: 'BlockNumber',
            schedulingLookahead: 'u32',
            maxValidatorsPerCore: 'Option<u32>',
            maxValidators: 'Option<u32>',
            disputePeriod: 'SessionIndex',
            disputePostConclusionAcceptancePeriod: 'BlockNumber',
            disputeMaxSpamSlots: 'u32',
            disputeConclusionByTimeOutPeriod: 'BlockNumber',
            noShowSlots: 'u32',
            nDelayTranches: 'u32',
            zerothDelayTrancheWidth: 'u32',
            neededApprovals: 'u32',
            relayVrfModuloSamples: 'u32'
        },
        InboundDownwardMessage: {
            pubSentAt: 'BlockNumber',
            pubMsg: 'DownwardMessage'
        },
        InboundHrmpMessage: {
            sentAt: 'BlockNumber',
            data: 'Bytes'
        },
        InboundHrmpLimitations: {
            validWatermarks: 'Vec<BlockNumber>'
        },
        InboundHrmpMessages: 'Vec<InboundHrmpMessage>',
        LocalValidationData: {
            parentHead: 'HeadData',
            balance: 'Balance',
            codeUpgradeAllowed: 'Option<BlockNumber>'
        },
        MessageIngestionType: {
            downwardMessages: 'Vec<InboundDownwardMessage>',
            horizontalMessages: 'BTreeMap<ParaId, InboundHrmpMessages>'
        },
        MessageQueueChain: 'RelayChainHash',
        NodeFeatures: 'BitVec',
        OccupiedCore: {
            nextUpOnAvailable: 'Option<ScheduledCore>',
            occupiedSince: 'BlockNumber',
            timeOutAt: 'BlockNumber',
            nextUpOnTimeOut: 'Option<ScheduledCore>',
            availability: 'BitVec',
            groupResponsible: 'GroupIndex',
            candidateHash: 'CandidateHash',
            candidateDescriptor: 'CandidateDescriptor'
        },
        OccupiedCoreAssumption: {
            _enum: ['Included,', 'TimedOut', 'Free']
        },
        OutboundHrmpChannelLimitations: {
            bytesRemaining: 'u32',
            messagesRemaining: 'u32'
        },
        OutboundHrmpMessage: {
            recipient: 'u32',
            data: 'Bytes'
        },
        PendingSlashes: {
            _alias: {
                slashKeys: 'keys'
            },
            slashKeys: 'BTreeMap<ValidatorIndex, ValidatorId>',
            kind: 'SlashingOffenceKind'
        },
        ParachainDispatchOrigin: {
            _enum: ['Signed', 'Parachain', 'Root']
        },
        ParachainInherentData: {
            validationData: 'PersistedValidationData',
            relayChainState: 'StorageProof',
            downwardMessages: 'Vec<InboundDownwardMessage>',
            horizontalMessages: 'BTreeMap<ParaId, VecInboundHrmpMessage>'
        },
        ParachainsInherentData: {
            bitfields: 'SignedAvailabilityBitfields',
            backedCandidates: 'Vec<BackedCandidate>',
            disputes: 'MultiDisputeStatementSet',
            parentHeader: 'Header'
        },
        ParaGenesisArgs: {
            genesisHead: 'Bytes',
            validationCode: 'Bytes',
            parachain: 'bool'
        },
        ParaId: 'u32',
        ParaInfo: {
            manager: 'AccountId',
            deposit: 'Balance',
            locked: 'bool'
        },
        ParaLifecycle: {
            _enum: ['Onboarding', 'Parathread', 'Parachain', 'UpgradingToParachain', 'DowngradingToParathread', 'OutgoingParathread', 'OutgoingParachain']
        },
        ParaPastCodeMeta: {
            upgradeTimes: 'Vec<ReplacementTimes>',
            lastPruned: 'Option<BlockNumber>'
        },
        ParaScheduling: {
            _enum: ['Always', 'Dynamic']
        },
        ParathreadClaim: '(ParaId, CollatorId)',
        ParathreadClaimQueue: {
            queue: 'Vec<QueuedParathread>',
            nextCoreOffset: 'u32'
        },
        ParathreadEntry: {
            claim: 'ParathreadClaim',
            retries: 'u32'
        },
        ParaValidatorIndex: 'u32',
        PersistedValidationData: {
            parentHead: 'HeadData',
            relayParentNumber: 'RelayChainBlockNumber',
            relayParentStorageRoot: 'Hash',
            maxPovSize: 'u32'
        },
        PvfCheckStatement: {
            accept: 'bool',
            subject: 'ValidationCodeHash',
            sessionIndex: 'SessionIndex',
            validatorIndex: 'ParaValidatorIndex'
        },
        QueuedParathread: {
            claim: 'ParathreadEntry',
            coreOffset: 'u32'
        },
        RelayBlockNumber: 'u32',
        RelayChainBlockNumber: 'RelayBlockNumber',
        RelayHash: 'Hash',
        RelayChainHash: 'RelayHash',
        Remark: '[u8; 32]',
        ReplacementTimes: {
            expectedAt: 'BlockNumber',
            activatedAt: 'BlockNumber'
        },
        Retriable: {
            _enum: {
                Never: 'Null',
                WithRetries: 'u32'
            }
        },
        ScheduledCore: {
            paraId: 'ParaId',
            collator: 'Option<CollatorId>'
        },
        Scheduling: {
            _enum: ['Always', 'Dynamic']
        },
        ScrapedOnChainVotes: {
            session: 'SessionIndex',
            backingValidatorsPerCandidate: 'Vec<(CandidateReceipt, Vec<(ParaValidatorIndex, ValidityAttestation)>)>',
            disputes: 'MultiDisputeStatementSet'
        },
        SessionInfo: {
            activeValidatorIndices: 'Vec<ParaValidatorIndex>',
            randomSeed: '[u8; 32]',
            disputePeriod: 'SessionIndex',
            validators: 'Vec<ValidatorId>',
            discoveryKeys: 'Vec<AuthorityDiscoveryId>',
            assignmentKeys: 'Vec<AssignmentId>',
            validatorGroups: 'Vec<Vec<ValidatorIndex>>',
            nCores: 'u32',
            zerothDelayTrancheWidth: 'u32',
            relayVrfModuloSamples: 'u32',
            nDelayTranches: 'u32',
            noShowSlots: 'u32',
            neededApprovals: 'u32'
        },
        OldV1SessionInfo: {
            validators: 'Vec<ValidatorId>',
            discoveryKeys: 'Vec<AuthorityDiscoveryId>',
            assignmentKeys: 'Vec<AssignmentId>',
            validatorGroups: 'Vec<Vec<ParaValidatorIndex>>',
            nCores: 'u32',
            zerothDelayTrancheWidth: 'u32',
            relayVrfModuloSamples: 'u32',
            nDelayTranches: 'u32',
            noShowSlots: 'u32',
            neededApprovals: 'u32'
        },
        SessionInfoValidatorGroup: 'Vec<ParaValidatorIndex>',
        SignedAvailabilityBitfield: {
            payload: 'BitVec',
            validatorIndex: 'ParaValidatorIndex',
            signature: 'ValidatorSignature'
        },
        SignedAvailabilityBitfields: 'Vec<SignedAvailabilityBitfield>',
        SigningContext: {
            sessionIndex: 'SessionIndex',
            parentHash: 'Hash'
        },
        SlashingOffenceKind: {
            _enum: ['ForInvalid', 'AgainstValid']
        },
        Statement: {
            _enum: {
                Never: 'Null', // starts at 1
                Candidate: 'Hash',
                Valid: 'Hash',
                Invalid: 'Hash'
            }
        },
        TransientValidationData: {
            maxCodeSize: 'u32',
            maxHeadDataSize: 'u32',
            balance: 'Balance',
            codeUpgradeAllowed: 'Option<BlockNumber>',
            dmqLength: 'u32'
        },
        UpgradeGoAhead: {
            _enum: ['Abort', 'GoAhead']
        },
        UpgradeRestriction: {
            _enum: ['Present']
        },
        UpwardMessage: 'Bytes',
        ValidationFunctionParams: {
            maxCodeSize: 'u32',
            relayChainHeight: 'RelayChainBlockNumber',
            codeUpgradeAllowed: 'Option<RelayChainBlockNumber>'
        },
        ValidationCode: 'Bytes',
        ValidationCodeHash: 'Hash',
        ValidationData: {
            persisted: 'PersistedValidationData',
            transient: 'TransientValidationData'
        },
        ValidationDataType: {
            validationData: 'ValidationData',
            relayChainState: 'Vec<Bytes>'
        },
        ValidatorSignature: 'Signature',
        ValidityAttestation: {
            _enum: {
                Never: 'Null', // starts at 1
                Implicit: 'ValidatorSignature',
                Explicit: 'ValidatorSignature'
            }
        },
        MessagingStateSnapshot: {
            relayDispatchQueueSize: '(u32, u32)',
            egressChannels: 'Vec<MessagingStateSnapshotEgressEntry>'
        },
        MessagingStateSnapshotEgressEntry: '(ParaId, AbridgedHrmpChannel)',
        SystemInherentData: 'ParachainInherentData',
        VecInboundHrmpMessage: 'Vec<InboundHrmpMessage>'
    }
};

var definitions$h = {
    rpc: {},
    types: {
        Approvals: '[bool; 4]'
    }
};

var definitions$g = {
    rpc: {},
    types: {
        AccountStatus: {
            validity: 'AccountValidity',
            freeBalance: 'Balance',
            lockedBalance: 'Balance',
            signature: 'Vec<u8>',
            vat: 'Permill'
        },
        AccountValidity: {
            _enum: ['Invalid', 'Initiated', 'Pending', 'ValidLow', 'ValidHigh', 'Completed']
        }
    }
};

const runtime$8 = {
    DryRunApi: [
        {
            methods: {
                dry_run_call: {
                    description: 'Dry run call',
                    params: [
                        {
                            name: 'origin',
                            type: 'OriginCaller'
                        },
                        {
                            name: 'call',
                            type: 'RuntimeCall'
                        }
                    ],
                    type: 'Result<CallDryRunEffects, XcmDryRunApiError>'
                },
                dry_run_xcm: {
                    description: 'Dry run XCM program',
                    params: [
                        {
                            name: 'originLocation',
                            type: 'VersionedMultiLocation'
                        },
                        {
                            name: 'xcm',
                            type: 'VersionedXcm'
                        }
                    ],
                    type: 'Result<XcmDryRunEffects, XcmDryRunApiError>'
                }
            },
            version: 1
        },
        {
            methods: {
                dry_run_call: {
                    description: 'Dry run call',
                    params: [
                        {
                            name: 'origin',
                            type: 'OriginCaller'
                        },
                        {
                            name: 'call',
                            type: 'RuntimeCall'
                        },
                        {
                            name: 'resultXcmsVersion',
                            type: 'u32'
                        }
                    ],
                    type: 'Result<CallDryRunEffects, XcmDryRunApiError>'
                },
                dry_run_xcm: {
                    description: 'Dry run XCM program',
                    params: [
                        {
                            name: 'originLocation',
                            type: 'VersionedMultiLocation'
                        },
                        {
                            name: 'xcm',
                            type: 'VersionedXcm'
                        }
                    ],
                    type: 'Result<XcmDryRunEffects, XcmDryRunApiError>'
                }
            },
            version: 2
        }
    ]
};

var definitions$f = {
    rpc: {},
    runtime: runtime$8,
    types: {
        PostDispatchInfo: {
            actualWeight: 'Option<Weight>',
            paysFee: 'Pays'
        },
        DispatchResultWithPostInfo: 'Result<PostDispatchInfo, DispatchError>',
        CallDryRunEffects: {
            executionResult: 'DispatchResultWithPostInfo',
            emittedEvents: 'Vec<Event>',
            localXcm: 'Option<VersionedXcm>',
            forwardedXcms: 'Vec<(VersionedMultiLocation, Vec<VersionedXcm>)>'
        },
        XcmDryRunEffects: {
            executionResult: 'OutcomeV4',
            emittedEvents: 'Vec<Event>',
            forwardedXcms: 'Vec<(VersionedMultiLocation, Vec<VersionedXcm>)>'
        },
        XcmDryRunApiError: {
            _enum: [
                'Unimplemented',
                'VersionedConversionFailed'
            ]
        }
    }
};

var TypeDefInfo;
(function (TypeDefInfo) {
    TypeDefInfo[TypeDefInfo["BTreeMap"] = 0] = "BTreeMap";
    TypeDefInfo[TypeDefInfo["BTreeSet"] = 1] = "BTreeSet";
    TypeDefInfo[TypeDefInfo["Compact"] = 2] = "Compact";
    TypeDefInfo[TypeDefInfo["DoNotConstruct"] = 3] = "DoNotConstruct";
    TypeDefInfo[TypeDefInfo["Enum"] = 4] = "Enum";
    TypeDefInfo[TypeDefInfo["HashMap"] = 5] = "HashMap";
    TypeDefInfo[TypeDefInfo["Int"] = 6] = "Int";
    TypeDefInfo[TypeDefInfo["Linkage"] = 7] = "Linkage";
    TypeDefInfo[TypeDefInfo["Null"] = 8] = "Null";
    TypeDefInfo[TypeDefInfo["Option"] = 9] = "Option";
    TypeDefInfo[TypeDefInfo["Plain"] = 10] = "Plain";
    TypeDefInfo[TypeDefInfo["Range"] = 11] = "Range";
    TypeDefInfo[TypeDefInfo["RangeInclusive"] = 12] = "RangeInclusive";
    TypeDefInfo[TypeDefInfo["Result"] = 13] = "Result";
    TypeDefInfo[TypeDefInfo["Set"] = 14] = "Set";
    TypeDefInfo[TypeDefInfo["Si"] = 15] = "Si";
    TypeDefInfo[TypeDefInfo["Struct"] = 16] = "Struct";
    TypeDefInfo[TypeDefInfo["Tuple"] = 17] = "Tuple";
    TypeDefInfo[TypeDefInfo["UInt"] = 18] = "UInt";
    TypeDefInfo[TypeDefInfo["Vec"] = 19] = "Vec";
    TypeDefInfo[TypeDefInfo["VecFixed"] = 20] = "VecFixed";
    TypeDefInfo[TypeDefInfo["WrapperKeepOpaque"] = 21] = "WrapperKeepOpaque";
    TypeDefInfo[TypeDefInfo["WrapperOpaque"] = 22] = "WrapperOpaque";
})(TypeDefInfo || (TypeDefInfo = {}));

function hasEq(o) {
    return isFunction$1(o.eq);
}

function compareArray(a, b) {
    if (Array.isArray(b)) {
        return (a.length === b.length) && isUndefined(a.find((v, index) => hasEq(v)
            ? !v.eq(b[index])
            : v !== b[index]));
    }
    return false;
}

/**
 * @name AbstractArray
 * @description
 * This manages codec arrays. It is an extension to Array, providing
 * specific encoding/decoding on top of the base type.
 * @noInheritDoc
 */
class AbstractArray extends Array {
    registry;
    createdAtHash;
    initialU8aLength;
    isStorageFallback;
    /**
     * @description This ensures that operators such as clice, filter, map, etc. return
     * new Array instances (without this we need to apply overrides)
     */
    static get [Symbol.species]() {
        return Array;
    }
    constructor(registry, length) {
        super(length);
        this.registry = registry;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        // We need to loop through all entries since they may have a variable length themselves,
        // e.g. when a Vec or Compact is contained withing, it has a variable length based on data
        const count = this.length;
        let total = compactToU8a(count).length;
        for (let i = 0; i < count; i++) {
            total += this[i].encodedLength;
        }
        return total;
    }
    /**
     * @description returns a hash of the contents
     */
    get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value
     */
    get isEmpty() {
        return this.length === 0;
    }
    /**
     * @description The length of the value
     */
    get length() {
        // only included here since we ignore inherited docs
        return super.length;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        return compareArray(this, other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        return {
            inner: this.inspectInner(),
            outer: [compactToU8a(this.length)]
        };
    }
    /**
     * @internal
     * @description Internal per-item inspection of internal values
     */
    inspectInner() {
        const count = this.length;
        const inner = new Array(count);
        for (let i = 0; i < count; i++) {
            inner[i] = this[i].inspect();
        }
        return inner;
    }
    /**
     * @description Converts the Object to an standard JavaScript Array
     */
    toArray() {
        return Array.from(this);
    }
    /**
     * @description Returns a hex string representation of the value
     */
    toHex() {
        return u8aToHex(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman(isExtended, disableAscii) {
        const count = this.length;
        const result = new Array(count);
        for (let i = 0; i < count; i++) {
            result[i] = this[i] && this[i].toHuman(isExtended, disableAscii);
        }
        return result;
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        const count = this.length;
        const result = new Array(count);
        for (let i = 0; i < count; i++) {
            // We actually log inside the U8a decoding and use JSON.stringify(...), which
            // means that the Vec may be partially populated (same applies to toHuman, same check)
            result[i] = this[i] && this[i].toJSON();
        }
        return result;
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive(disableAscii) {
        const count = this.length;
        const result = new Array(count);
        for (let i = 0; i < count; i++) {
            result[i] = this[i] && this[i].toPrimitive(disableAscii);
        }
        return result;
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        const count = this.length;
        const result = new Array(count);
        for (let i = 0; i < count; i++) {
            result[i] = this[i].toString();
        }
        return `[${result.join(', ')}]`;
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8a(isBare) {
        const encoded = this.toU8aInner();
        return isBare
            ? u8aConcatStrict(encoded)
            : u8aConcatStrict([compactToU8a(this.length), ...encoded]);
    }
    /**
     * @internal
     * @description Internal per-item SCALE encoding of contained values
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8aInner(isBare) {
        const count = this.length;
        const encoded = new Array(count);
        for (let i = 0; i < count; i++) {
            encoded[i] = this[i].toU8a(isBare);
        }
        return encoded;
    }
}

/**
 * @name Base
 * @description A type extends the Base class, when it holds a value
 */
class AbstractBase {
    registry;
    createdAtHash;
    initialU8aLength;
    isStorageFallback;
    #raw;
    constructor(registry, value, initialU8aLength) {
        this.initialU8aLength = initialU8aLength;
        this.#raw = value;
        this.registry = registry;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        return this.toU8a().length;
    }
    /**
     * @description returns a hash of the contents
     */
    get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description returns the inner (wrapped value)
     */
    get inner() {
        return this.#raw;
    }
    /**
     * @description Checks if the value is an empty value
     */
    get isEmpty() {
        return this.#raw.isEmpty;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        return this.#raw.eq(other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        return this.#raw.inspect();
    }
    /**
     * @description Returns a hex string representation of the value. isLe returns a LE (number-only) representation
     */
    toHex(isLe) {
        return this.#raw.toHex(isLe);
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman(isExtended, disableAscii) {
        return this.#raw.toHuman(isExtended, disableAscii);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        return this.#raw.toJSON();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive(disableAscii) {
        return this.#raw.toPrimitive(disableAscii);
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        return this.#raw.toString();
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8a(isBare) {
        return this.#raw.toU8a(isBare);
    }
    /**
     * @description Returns the inner wrapped value (equivalent to valueOf)
     */
    unwrap() {
        return this.#raw;
    }
    /**
     * @description Returns the inner wrapped value
     */
    valueOf() {
        return this.#raw;
    }
}

const DEFAULT_UINT_BITS = 64;
const MAX_NUMBER_BITS = 52;
const MUL_P = new BN(1_00_00);
const FORMATTERS = [
    ['Perquintill', BN_QUINTILL],
    ['Perbill', BN_BILLION],
    ['Permill', BN_MILLION],
    ['Percent', BN_HUNDRED]
];
function isToBn(value) {
    return isFunction$1(value.toBn);
}
function toPercentage(value, divisor) {
    return `${(value.mul(MUL_P).div(divisor).toNumber() / 100).toFixed(2)}%`;
}
/** @internal */
function decodeAbstractInt(value, isNegative) {
    if (isNumber(value)) {
        if (!Number.isInteger(value) || value > Number.MAX_SAFE_INTEGER || value < Number.MIN_SAFE_INTEGER) {
            throw new Error('Number needs to be an integer <= Number.MAX_SAFE_INTEGER, i.e. 2 ^ 53 - 1');
        }
        return value;
    }
    else if (isString(value)) {
        if (isHex(value, -1, true)) {
            return hexToBn(value, { isLe: false, isNegative }).toString();
        }
        if (value.includes('.') || value.includes(',') || value.includes('e')) {
            throw new Error('String should not contain decimal points or scientific notation');
        }
        return value;
    }
    else if (isBn(value) || isBigInt(value)) {
        return value.toString();
    }
    else if (isObject(value)) {
        if (isToBn(value)) {
            return value.toBn().toString();
        }
        // Allow the construction from an object with a single top-level key. This means that
        // single key objects can be treated equivalently to numbers, assuming they meet the
        // specific requirements. (This is useful in Weights 1.5 where Objects are compact)
        const keys = Object.keys(value);
        if (keys.length !== 1) {
            throw new Error('Unable to construct number from multi-key object');
        }
        return decodeAbstractInt(value[keys[0]], isNegative);
    }
    else if (!value) {
        return 0;
    }
    throw new Error(`Unable to create BN from unknown type ${typeof value}`);
}
/**
 * @name AbstractInt
 * @ignore
 * @noInheritDoc
 */
class AbstractInt extends BN {
    registry;
    encodedLength;
    isUnsigned;
    createdAtHash;
    initialU8aLength;
    isStorageFallback;
    #bitLength;
    constructor(registry, value = 0, bitLength = DEFAULT_UINT_BITS, isSigned = false) {
        // Construct via a string/number, which will be passed in the BN constructor.
        // It would be ideal to actually return a BN, but there is an issue:
        // https://github.com/indutny/bn.js/issues/206
        super(
        // shortcut isU8a as used in SCALE decoding
        isU8a(value)
            ? bitLength <= 48
                ? u8aToNumber(value.subarray(0, bitLength / 8), { isNegative: isSigned })
                : u8aToBn(value.subarray(0, bitLength / 8), { isLe: true, isNegative: isSigned }).toString()
            : decodeAbstractInt(value, isSigned));
        this.registry = registry;
        this.#bitLength = bitLength;
        this.encodedLength = this.#bitLength / 8;
        this.initialU8aLength = this.#bitLength / 8;
        this.isUnsigned = !isSigned;
        const isNegative = this.isNeg();
        const maxBits = bitLength - (isSigned && !isNegative ? 1 : 0);
        if (isNegative && !isSigned) {
            throw new Error(`${this.toRawType()}: Negative number passed to unsigned type`);
        }
        else if (super.bitLength() > maxBits) {
            throw new Error(`${this.toRawType()}: Input too large. Found input with ${super.bitLength()} bits, expected ${maxBits}`);
        }
    }
    /**
     * @description returns a hash of the contents
     */
    get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is a zero value (align elsewhere)
     */
    get isEmpty() {
        return this.isZero();
    }
    /**
     * @description Returns the number of bits in the value
     */
    bitLength() {
        return this.#bitLength;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    eq(other) {
        // Here we are actually overriding the built-in .eq to take care of both
        // number and BN inputs (no `.eqn` needed) - numbers will be converted
        return super.eq(isHex(other)
            ? hexToBn(other.toString(), { isLe: false, isNegative: !this.isUnsigned })
            : bnToBn(other));
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        return {
            outer: [this.toU8a()]
        };
    }
    /**
     * @description True if this value is the max of the type
     */
    isMax() {
        const u8a = this.toU8a().filter((b) => b === 0xff);
        return u8a.length === (this.#bitLength / 8);
    }
    /**
     * @description Returns a BigInt representation of the number
     */
    toBigInt() {
        return BigInt(this.toString());
    }
    /**
     * @description Returns the BN representation of the number. (Compatibility)
     */
    toBn() {
        return this;
    }
    /**
     * @description Returns a hex string representation of the value
     */
    toHex(isLe = false) {
        // For display/JSON, this is BE, for compare, use isLe
        return bnToHex(this, {
            bitLength: this.bitLength(),
            isLe,
            isNegative: !this.isUnsigned
        });
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman(_isExpanded) {
        const rawType = this.toRawType();
        if (rawType === 'Balance') {
            return this.isMax()
                ? 'everything'
                // FIXME In the case of multiples we need some way of detecting which instance this belongs
                // to. as it stands we will always format (incorrectly) against the first token defined
                : formatBalance(this, { decimals: this.registry.chainDecimals[0], withSi: true, withUnit: this.registry.chainTokens[0] });
        }
        const [, divisor] = FORMATTERS.find(([type]) => type === rawType) || [];
        return divisor
            ? toPercentage(this, divisor)
            : formatNumber(this);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON(onlyHex = false) {
        // FIXME this return type should by string | number, however BN returns string
        // Options here are
        //   - super.bitLength() - the actual used bits, use hex when close to MAX_SAFE_INTEGER
        //   - this.#bitLength - the max used bits, use hex when larger than native Rust type
        return onlyHex || (this.#bitLength > 128) || (super.bitLength() > MAX_NUMBER_BITS)
            ? this.toHex()
            : this.toNumber();
    }
    /**
     * @description Returns the value in a primitive form, either number when <= 52 bits, or string otherwise
     */
    toPrimitive() {
        return super.bitLength() > MAX_NUMBER_BITS
            ? this.toString()
            : this.toNumber();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        // NOTE In the case of balances, which have a special meaning on the UI
        // and can be interpreted differently, return a specific value for it so
        // underlying it always matches (no matter which length it actually is)
        return this instanceof this.registry.createClassUnsafe('Balance')
            ? 'Balance'
            : `${this.isUnsigned ? 'u' : 'i'}${this.bitLength()}`;
    }
    /**
     * @description Returns the string representation of the value
     * @param base The base to use for the conversion
     */
    toString(base) {
        // only included here since we do not inherit docs
        return super.toString(base);
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     */
    toU8a(_isBare) {
        return bnToU8a(this, {
            bitLength: this.bitLength(),
            isLe: true,
            isNegative: !this.isUnsigned
        });
    }
}

function hasMismatch(a, b) {
    return isUndefined(a) || (hasEq(a)
        ? !a.eq(b)
        : a !== b);
}
function notEntry(value) {
    return !Array.isArray(value) || value.length !== 2;
}
function compareMapArray(a, b) {
    // equal number of entries and each entry in the array should match
    return (a.size === b.length) && !b.some((e) => notEntry(e) ||
        hasMismatch(a.get(e[0]), e[1]));
}
function compareMap(a, b) {
    if (Array.isArray(b)) {
        return compareMapArray(a, b);
    }
    else if (b instanceof Map) {
        return compareMapArray(a, [...b.entries()]);
    }
    else if (isObject(b)) {
        return compareMapArray(a, Object.entries(b));
    }
    return false;
}

function compareSetArray(a, b) {
    // equal number of entries and each entry in the array should match
    return (a.size === b.length) && !b.some((e) => !a.has(e));
}
function compareSet(a, b) {
    if (Array.isArray(b)) {
        return compareSetArray(a, b);
    }
    else if (b instanceof Set) {
        return compareSetArray(a, [...b.values()]);
    }
    else if (isObject(b)) {
        return compareSetArray(a, Object.values(b));
    }
    return false;
}

const MAX_DEPTH = 1024;
/** @internal */
function isComplexType(Type) {
    const typeName = Type.name?.toLowerCase() || '';
    return ['enum', 'hashmap', 'linkage', 'null', 'option', 'range', 'rangeinclusive', 'result', 'struct', 'tuple', 'vec', 'vecfixed'].includes(typeName);
}
/** @internal */
function formatFailure(registry, fn, _result, { message }, u8a, i, count, Type, key) {
    let type = '';
    try {
        type = `: ${new Type(registry).toRawType()}`;
    }
    catch {
        // ignore
    }
    // This is extra debugging info (we most-probably want this in in some way, shape or form,
    // but at this point not quite sure how to include and format it (it can be quite massive)
    // console.error(JSON.stringify(result, null, 2));
    return `${fn}: failed at ${u8aToHex(u8a.subarray(0, 16))}…${key ? ` on ${key}` : ''} (index ${i + 1}/${count})${type}:: ${message}`;
}
/**
 * @internal
 *
 * Given an u8a, and an array of Type constructors, decode the u8a against the
 * types, and return an array of decoded values.
 *
 * @param u8a - The u8a to decode.
 * @param result - The result array (will be returned with values pushed)
 * @param types - The array of CodecClass to decode the U8a against.
 */
function decodeU8a$7(registry, result, u8a, [Types, keys]) {
    const count = result.length;
    let offset = 0;
    let i = 0;
    try {
        while (i < count) {
            const value = new Types[i](registry, u8a.subarray(offset));
            offset += value.initialU8aLength || value.encodedLength;
            result[i] = value;
            i++;
        }
    }
    catch (error) {
        throw new Error(formatFailure(registry, 'decodeU8a', result, error, u8a.subarray(offset), i, count, Types[i], keys[i]));
    }
    return [result, offset];
}
/**
 * @internal
 *
 * Split from decodeU8a since this is specialized to zip returns ... while we duplicate, this
 * is all on the hot-path, so it is not great, however there is (some) method behind the madness
 */
function decodeU8aStruct(registry, result, u8a, [Types, keys]) {
    const count = result.length;
    let offset = 0;
    let i = 0;
    if (count > MAX_DEPTH && isComplexType(Types[i])) {
        throw new Error(`decodeU8aStruct: Maximum depth exceeded, received ${count} elements, limit ${MAX_DEPTH}`);
    }
    try {
        while (i < count) {
            const value = new Types[i](registry, u8a.subarray(offset));
            offset += value.initialU8aLength || value.encodedLength;
            result[i] = [keys[i], value];
            i++;
        }
    }
    catch (error) {
        throw new Error(formatFailure(registry, 'decodeU8aStruct', result, error, u8a.subarray(offset), i, count, Types[i], keys[i]));
    }
    return [result, offset];
}
/**
 * @internal
 *
 * Split from decodeU8a since this is specialized to 1 instance ... while we duplicate, this
 * is all on the hot-path, so it is not great, however there is (some) method behind the madness
 */
function decodeU8aVec(registry, result, u8a, startAt, Type) {
    const count = result.length;
    if (count > MAX_DEPTH && isComplexType(Type)) {
        throw new Error(`decodeU8aVec: Maximum depth exceeded, received ${count} elements, limit ${MAX_DEPTH}`);
    }
    let offset = startAt;
    let i = 0;
    try {
        while (i < count) {
            const value = new Type(registry, u8a.subarray(offset));
            offset += value.initialU8aLength || value.encodedLength;
            result[i] = value;
            i++;
        }
    }
    catch (error) {
        throw new Error(formatFailure(registry, 'decodeU8aVec', result, error, u8a.subarray(offset), i, count, Type));
    }
    return [offset, offset - startAt];
}

const BOUNDED = ['BTreeMap', 'BTreeSet', 'HashMap', 'Vec'];
const ALLOWED_BOXES = BOUNDED.concat(['Compact', 'DoNotConstruct', 'Int', 'Linkage', 'Range', 'RangeInclusive', 'Result', 'Opaque', 'Option', 'UInt', 'WrapperKeepOpaque', 'WrapperOpaque']);
const BOX_PRECEDING = ['<', '(', '[', '"', ',', ' ']; // start of vec, tuple, fixed array, part of struct def or in tuple
const mappings = [
    // alias <T::InherentOfflineReport as InherentOfflineReport>::Inherent -> InherentOfflineReport
    alias('<T::InherentOfflineReport as InherentOfflineReport>::Inherent', 'InherentOfflineReport', false),
    alias('VecDeque<', 'Vec<', false),
    // <T::Balance as HasCompact>
    cleanupCompact(),
    // Change BoundedVec<Type, Size> to Vec<Type>
    removeExtensions('Bounded', true),
    // Change WeakVec<Type> to Vec<Type>
    removeExtensions('Weak', false),
    // Remove all the trait prefixes
    removeTraits(),
    // remove PairOf<T> -> (T, T)
    removePairOf(),
    // remove boxing, `Box<Proposal>` -> `Proposal`
    removeWrap('Box<'),
    // remove generics, `MisbehaviorReport<Hash, BlockNumber>` -> `MisbehaviorReport`
    removeGenerics(),
    // alias String -> Text (compat with jsonrpc methods)
    alias('String', 'Text'),
    // alias Vec<u8> -> Bytes
    alias('Vec<u8>', 'Bytes'),
    alias('&\\[u8\\]', 'Bytes'),
    alias("&'static\\[u8\\]", 'Bytes'),
    // alias RawAddress -> Address
    alias('RawAddress', 'Address'),
    // lookups, mapped to Address/AccountId as appropriate in runtime
    alias('Lookup::Source', 'LookupSource'),
    alias('Lookup::Target', 'LookupTarget'),
    // HACK duplication between contracts & primitives, however contracts prefixed with exec
    alias('exec::StorageKey', 'ContractStorageKey'),
    // flattens tuples with one value, `(AccountId)` -> `AccountId`
    flattenSingleTuple(),
    // converts ::Type to Type, <T as Trait<I>>::Proposal -> Proposal
    removeColons(),
    // remove all trailing spaces - this should always be the last
    trim()
];
function trim() {
    return (value) => value.trim();
}
function findClosing(value, start) {
    let depth = 0;
    for (let i = start, count = value.length; i < count; i++) {
        if (value[i] === '>') {
            if (!depth) {
                return i;
            }
            depth--;
        }
        else if (value[i] === '<') {
            depth++;
        }
    }
    throw new Error(`Unable to find closing matching <> on '${value}' (start ${start})`);
}
function alias(src, dest, withChecks = true) {
    const from = new RegExp(`(^${src}|${BOX_PRECEDING.map((box) => `\\${box}${src}`).join('|')})`, 'g');
    const to = (src) => {
        from.lastIndex = 0;
        return withChecks && BOX_PRECEDING.includes(src[0])
            ? `${src[0]}${dest}`
            : dest;
    };
    return (value) => value.replace(from, to);
}
function cleanupCompact() {
    return (value) => {
        if (value.includes(' as HasCompact')) {
            for (let i = 0, count = value.length; i < count; i++) {
                if (value[i] === '<') {
                    const end = findClosing(value, i + 1) - 14;
                    if (value.substring(end, end + 14) === ' as HasCompact') {
                        value = `Compact<${value.substring(i + 1, end)}>`;
                    }
                }
            }
        }
        return value;
    };
}
function flattenSingleTuple() {
    const from1 = /,\)/g;
    const from2 = /\(([^,]+)\)/;
    return (value) => {
        from1.lastIndex = 0;
        return value
            // tuples may have trailing commas, e.g. (u32, BlockNumber, )
            .replace(from1, ')')
            // change (u32) -> u32
            .replace(from2, '$1');
    };
}
function replaceTagWith(value, matcher, replacer) {
    let index = -1;
    while (true) {
        index = value.indexOf(matcher, index + 1);
        if (index === -1) {
            return value;
        }
        const start = index + matcher.length;
        const end = findClosing(value, start);
        value = `${value.substring(0, index)}${replacer(value.substring(start, end))}${value.substring(end + 1)}`;
    }
}
function removeExtensions(type, isSized) {
    return (value) => {
        for (let i = 0, count = BOUNDED.length; i < count; i++) {
            const tag = BOUNDED[i];
            value = replaceTagWith(value, `${type}${tag}<`, (v) => {
                const parts = v
                    .split(',')
                    .map((s) => s.trim())
                    .filter((s) => s);
                if (isSized) {
                    parts.pop();
                }
                return `${tag}<${parts.join(',')}>`;
            });
        }
        return value;
    };
}
function removeColons() {
    return (value) => {
        let index = 0;
        while (index !== -1) {
            index = value.indexOf('::');
            if (index === 0) {
                value = value.substring(2);
            }
            else if (index !== -1) {
                let start = index;
                while (start !== -1 && !BOX_PRECEDING.includes(value[start])) {
                    start--;
                }
                value = `${value.substring(0, start + 1)}${value.substring(index + 2)}`;
            }
        }
        return value;
    };
}
function removeGenerics() {
    return (value) => {
        for (let i = 0, count = value.length; i < count; i++) {
            if (value[i] === '<') {
                // check against the allowed wrappers, be it Vec<..>, Option<...> ...
                const box = ALLOWED_BOXES.find((box) => {
                    const start = i - box.length;
                    return ((start >= 0 &&
                        value.substring(start, i) === box) && (
                    // make sure it is stand-alone, i.e. don't catch ElectionResult<...> as Result<...>
                    start === 0 ||
                        BOX_PRECEDING.includes(value[start - 1])));
                });
                // we have not found anything, unwrap generic innards
                if (!box) {
                    const end = findClosing(value, i + 1);
                    value = `${value.substring(0, i)}${value.substring(end + 1)}`;
                }
            }
        }
        return value;
    };
}
function removePairOf() {
    const replacer = (v) => `(${v},${v})`;
    return (value) => replaceTagWith(value, 'PairOf<', replacer);
}
function removeTraits() {
    const from1 = /\s/g;
    const from2 = /(T|Self)::/g;
    const from3 = /<(T|Self)asTrait>::/g;
    const from4 = /<Tas[a-z]+::Trait>::/g;
    const from5 = /<LookupasStaticLookup>/g;
    const from6 = /::Type/g;
    return (value) => {
        from1.lastIndex = 0;
        from2.lastIndex = 0;
        from3.lastIndex = 0;
        from4.lastIndex = 0;
        from5.lastIndex = 0;
        from6.lastIndex = 0;
        return value
            // remove all whitespaces
            .replace(from1, '')
            // anything `T::<type>` to end up as `<type>`
            .replace(from2, '')
            // replace `<T as Trait>::` (whitespaces were removed above)
            .replace(from3, '')
            // replace `<T as something::Trait>::` (whitespaces were removed above)
            .replace(from4, '')
            // replace <Lookup as StaticLookup>
            .replace(from5, 'Lookup')
            // replace `<...>::Type`
            .replace(from6, '');
    };
}
function removeWrap(check) {
    const replacer = (v) => v;
    return (value) => replaceTagWith(value, check, replacer);
}
const sanitizeMap = new Map();
function sanitize(value) {
    const startValue = value.toString();
    const memoized = sanitizeMap.get(startValue);
    if (memoized) {
        return memoized;
    }
    let result = startValue;
    for (let i = 0, count = mappings.length; i < count; i++) {
        result = mappings[i](result);
    }
    sanitizeMap.set(startValue, result);
    return result;
}

/** @internal **/
function isArrayLike(arg) {
    return arg instanceof Uint8Array || Array.isArray(arg);
}
/** @internal **/
function isEnum(arg) {
    return isCodec(arg) && isNumber(arg.index) && isCodec(arg.value);
}
/** @internal **/
function isOption(arg) {
    return isCodec(arg) && isBoolean(arg.isSome) && isCodec(arg.value);
}
/** @internal */
function isNumberLike(arg) {
    return isNumber(arg) || isBn(arg) || isBigInt(arg);
}
/** @internal */
function sortArray(a, b) {
    // Vec, Tuple, Bytes etc.
    let sortRes = 0;
    const minLen = Math.min(a.length, b.length);
    for (let i = 0; i < minLen; ++i) {
        sortRes = sortAsc(a[i], b[i]);
        if (sortRes !== 0) {
            return sortRes;
        }
    }
    return a.length - b.length;
}
/** @internal */
function checkForDuplicates(container, seen, arg) {
    // Convert the value to hex.
    if (isCodec(arg)) {
        const hex = arg.toHex();
        // Check if we have seen the value.
        if (seen.has(hex)) {
            // Duplicates are not allowed.
            throw new Error(`Duplicate value in ${container}: ${stringify(arg)}`);
        }
        seen.add(hex);
    }
    return true;
}
/**
* Sort keys/values of BTreeSet/BTreeMap in ascending order for encoding compatibility with Rust's BTreeSet/BTreeMap
* (https://doc.rust-lang.org/stable/std/collections/struct.BTreeSet.html)
* (https://doc.rust-lang.org/stable/std/collections/struct.BTreeMap.html)
*/
function sortAsc(a, b) {
    if (isNumberLike(a) && isNumberLike(b)) {
        return bnToBn(a).cmp(bnToBn(b));
    }
    else if (a instanceof Map && b instanceof Map) {
        return sortAsc(Array.from(a.values()), Array.from(b.values()));
    }
    else if (isEnum(a) && isEnum(b)) {
        return sortAsc(a.index, b.index) || sortAsc(a.value, b.value);
    }
    else if (isOption(a) && isOption(b)) {
        return sortAsc(a.isNone ? 0 : 1, b.isNone ? 0 : 1) || sortAsc(a.value, b.value);
    }
    else if (isArrayLike(a) && isArrayLike(b)) {
        return sortArray(a, b);
    }
    else if (isCodec(a) && isCodec(b)) {
        // Text, Bool etc.
        return sortAsc(a.toU8a(true), b.toU8a(true));
    }
    throw new Error(`Attempting to sort unrecognized values: ${stringify(a)} (typeof ${typeof a}) <-> ${stringify(b)} (typeof ${typeof b})`);
}
function sortSet(set) {
    const seen = new Set();
    return new Set(Array.from(set).filter((value) => checkForDuplicates('BTreeSet', seen, value)).sort(sortAsc));
}
function sortMap(map) {
    const seen = new Set();
    return new Map(Array.from(map.entries()).filter(([key]) => checkForDuplicates('BTreeMap', seen, key)).sort(([keyA], [keyB]) => sortAsc(keyA, keyB)));
}

/**
 * @internal
 * From a type string or class, return the associated type class
 */
function typeToConstructor(registry, type) {
    return typeof type === 'function'
        ? type
        : registry.createClassUnsafe(type);
}
/**
 * @internal
 * Takes an input array of types and returns the associated classes for it
*/
function typesToConstructors(registry, types) {
    const count = types.length;
    const result = new Array(count);
    for (let i = 0; i < count; i++) {
        result[i] = typeToConstructor(registry, types[i]);
    }
    return result;
}
/**
 * @internal
 * Takes an input map of the form `{ [string]: string | CodecClass }` and returns a map of `{ [string]: CodecClass }`
 */
function mapToTypeMap(registry, input) {
    const entries = Object.entries(input);
    const count = entries.length;
    const output = [new Array(count), new Array(count)];
    for (let i = 0; i < count; i++) {
        output[1][i] = entries[i][0];
        output[0][i] = typeToConstructor(registry, entries[i][1]);
    }
    return output;
}

function typesToMap(registry, [Types, keys]) {
    const result = {};
    for (let i = 0, count = keys.length; i < count; i++) {
        result[keys[i]] = registry.getClassName(Types[i]) || new Types[i](registry).toRawType();
    }
    return result;
}

function decodeCompact(registry, Type, value) {
    if (isU8a(value)) {
        const [decodedLength, bn] = (value[0] & 0b11) < 0b11
            ? compactFromU8aLim(value)
            : compactFromU8a(value);
        return [new Type(registry, bn), decodedLength];
    }
    else if (value instanceof Compact) {
        const raw = value.unwrap();
        return raw instanceof Type
            ? [raw, 0]
            : [new Type(registry, raw), 0];
    }
    else if (value instanceof Type) {
        return [value, 0];
    }
    return [new Type(registry, value), 0];
}
/**
 * @name Compact
 * @description
 * A compact length-encoding codec wrapper. It performs the same function as Length, however
 * differs in that it uses a variable number of bytes to do the actual encoding. This is mostly
 * used by other types to add length-prefixed encoding, or in the case of wrapped types, taking
 * a number and making the compact representation thereof
 */
class Compact {
    registry;
    createdAtHash;
    initialU8aLength;
    isStorageFallback;
    #Type;
    #raw;
    constructor(registry, Type, value = 0, { definition, setDefinition = identity$2 } = {}) {
        this.registry = registry;
        this.#Type = definition || setDefinition(typeToConstructor(registry, Type));
        const [raw, decodedLength] = decodeCompact(registry, this.#Type, value);
        this.initialU8aLength = decodedLength;
        this.#raw = raw;
    }
    static with(Type) {
        let definition;
        // eslint-disable-next-line no-return-assign
        const setDefinition = (d) => (definition = d);
        return class extends Compact {
            constructor(registry, value) {
                super(registry, Type, value, { definition, setDefinition });
            }
        };
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        return this.toU8a().length;
    }
    /**
     * @description returns a hash of the contents
     */
    get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value
     */
    get isEmpty() {
        return this.#raw.isEmpty;
    }
    /**
     * @description Returns the number of bits in the value
     */
    bitLength() {
        return this.#raw.bitLength();
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        return this.#raw.eq(other instanceof Compact
            ? other.#raw
            : other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        return {
            outer: [this.toU8a()]
        };
    }
    /**
     * @description Returns a BigInt representation of the number
     */
    toBigInt() {
        return this.#raw.toBigInt();
    }
    /**
     * @description Returns the BN representation of the number
     */
    toBn() {
        return this.#raw.toBn();
    }
    /**
     * @description Returns a hex string representation of the value. isLe returns a LE (number-only) representation
     */
    toHex(isLe) {
        return this.#raw.toHex(isLe);
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman(isExtended, disableAscii) {
        return this.#raw.toHuman(isExtended, disableAscii);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        return this.#raw.toJSON();
    }
    /**
     * @description Returns the number representation for the value
     */
    toNumber() {
        return this.#raw.toNumber();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive(disableAscii) {
        return this.#raw.toPrimitive(disableAscii);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return `Compact<${this.registry.getClassName(this.#Type) || this.#raw.toRawType()}>`;
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        return this.#raw.toString();
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     */
    toU8a(_isBare) {
        return compactToU8a(this.#raw.toBn());
    }
    /**
     * @description Returns the embedded [[UInt]] or [[Moment]] value
     */
    unwrap() {
        return this.#raw;
    }
}

/**
 * @name DoNotConstruct
 * @description
 * An unknown type that fails on construction with the type info
 */
class DoNotConstruct {
    registry;
    createdAtHash;
    isStorageFallback;
    #neverError;
    constructor(registry, typeName = 'DoNotConstruct') {
        this.registry = registry;
        this.#neverError = new Error(`DoNotConstruct: Cannot construct unknown type ${typeName}`);
        throw this.#neverError;
    }
    static with(typeName) {
        return class extends DoNotConstruct {
            constructor(registry) {
                super(registry, typeName);
            }
        };
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        throw this.#neverError;
    }
    /**
     * @description returns a hash of the contents
     */
    get hash() {
        throw this.#neverError;
    }
    /**
     * @description Checks if the value is an empty value (always true)
     */
    get isEmpty() {
        throw this.#neverError;
    }
    /**
     * @description Unimplemented
     */
    eq() {
        throw this.#neverError;
    }
    /**
     * @description Unimplemented
     */
    inspect() {
        throw this.#neverError;
    }
    /**
     * @description Unimplemented
     */
    toHex() {
        throw this.#neverError;
    }
    /**
     * @description Unimplemented
     */
    toHuman() {
        throw this.#neverError;
    }
    /**
     * @description Unimplemented
     */
    toJSON() {
        throw this.#neverError;
    }
    /**
     * @description Unimplemented
     */
    toPrimitive() {
        throw this.#neverError;
    }
    /**
     * @description Unimplemented
     */
    toRawType() {
        throw this.#neverError;
    }
    /**
     * @description Unimplemented
     */
    toString() {
        throw this.#neverError;
    }
    /**
     * @description Unimplemented
     */
    toU8a() {
        throw this.#neverError;
    }
}

/**
 * @name Null
 * @description
 * Implements a type that does not contain anything (apart from `null`)
 */
class Null {
    encodedLength = 0;
    isEmpty = true;
    registry;
    createdAtHash;
    initialU8aLength = 0;
    isStorageFallback;
    constructor(registry) {
        this.registry = registry;
    }
    /**
     * @description returns a hash of the contents
     */
    get hash() {
        throw new Error('.hash is not implemented on Null');
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        return other instanceof Null || isNull(other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        return {};
    }
    /**
     * @description Returns a hex string representation of the value
     */
    toHex() {
        return '0x';
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman() {
        return this.toJSON();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        return null;
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive() {
        return null;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'Null';
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        return '';
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     */
    toU8a(_isBare) {
        return new Uint8Array();
    }
}

function isRustEnum$1(def) {
    const defValues = Object.values(def);
    if (defValues.some((v) => isNumber(v))) {
        if (!defValues.every((v) => isNumber(v) && v >= 0 && v <= 255)) {
            throw new Error('Invalid number-indexed enum definition');
        }
        return false;
    }
    return true;
}
function extractDef(registry, _def) {
    const def = {};
    let isBasic;
    let isIndexed;
    if (Array.isArray(_def)) {
        for (let i = 0, count = _def.length; i < count; i++) {
            def[_def[i]] = { Type: Null, index: i };
        }
        isBasic = true;
        isIndexed = false;
    }
    else if (isRustEnum$1(_def)) {
        const [Types, keys] = mapToTypeMap(registry, _def);
        for (let i = 0, count = keys.length; i < count; i++) {
            def[keys[i]] = { Type: Types[i], index: i };
        }
        isBasic = !Object.values(def).some(({ Type }) => Type !== Null);
        isIndexed = false;
    }
    else {
        const entries = Object.entries(_def);
        for (let i = 0, count = entries.length; i < count; i++) {
            const [key, index] = entries[i];
            def[key] = { Type: Null, index };
        }
        isBasic = true;
        isIndexed = true;
    }
    return {
        def,
        isBasic,
        isIndexed
    };
}
function getEntryType(def, checkIdx) {
    const values = Object.values(def);
    for (let i = 0, count = values.length; i < count; i++) {
        const { Type, index } = values[i];
        if (index === checkIdx) {
            return Type;
        }
    }
    throw new Error(`Unable to create Enum via index ${checkIdx}, in ${Object.keys(def).join(', ')}`);
}
function createFromU8a(registry, def, index, value) {
    const Type = getEntryType(def, index);
    return {
        index,
        value: new Type(registry, value)
    };
}
function createFromValue(registry, def, index = 0, value) {
    const Type = getEntryType(def, index);
    return {
        index,
        value: value instanceof Type
            ? value
            : new Type(registry, value)
    };
}
function decodeFromJSON(registry, def, key, value) {
    // JSON comes in the form of { "<type (camelCase)>": "<value for type>" }, here we
    // additionally force to lower to ensure forward compat
    const keys = Object.keys(def).map((k) => k.toLowerCase());
    const keyLower = key.toLowerCase();
    const index = keys.indexOf(keyLower);
    if (index === -1) {
        throw new Error(`Cannot map Enum JSON, unable to find '${key}' in ${keys.join(', ')}`);
    }
    try {
        return createFromValue(registry, def, Object.values(def)[index].index, value);
    }
    catch (error) {
        throw new Error(`Enum(${key}):: ${error.message}`);
    }
}
function decodeEnum(registry, def, value, index) {
    // NOTE We check the index path first, before looking at values - this allows treating
    // the optional indexes before anything else, more-specific > less-specific
    if (isNumber(index)) {
        return createFromValue(registry, def, index, value);
    }
    else if (isU8a(value) || isHex(value)) {
        const u8a = u8aToU8a(value);
        // nested, we don't want to match isObject below
        if (u8a.length) {
            return createFromU8a(registry, def, u8a[0], u8a.subarray(1));
        }
    }
    else if (value instanceof Enum) {
        return createFromValue(registry, def, value.index, value.value);
    }
    else if (isNumber(value)) {
        return createFromValue(registry, def, value);
    }
    else if (isString(value)) {
        return decodeFromJSON(registry, def, value.toString());
    }
    else if (isObject(value)) {
        const key = Object.keys(value)[0];
        return decodeFromJSON(registry, def, key, value[key]);
    }
    // Worst-case scenario, return the first with default
    return createFromValue(registry, def, Object.values(def)[0].index);
}
/**
 * @name Enum
 * @description
 * This implements an enum, that based on the value wraps a different type. It is effectively
 * an extension to enum where the value type is determined by the actual index.
 */
class Enum {
    registry;
    createdAtHash;
    initialU8aLength;
    isStorageFallback;
    #def;
    #entryIndex;
    #indexes;
    #isBasic;
    #isIndexed;
    #raw;
    constructor(registry, Types, value, index, { definition, setDefinition = identity$2 } = {}) {
        const { def, isBasic, isIndexed } = definition || setDefinition(extractDef(registry, Types));
        // shortcut isU8a as used in SCALE decoding
        const decoded = isU8a(value) && value.length && !isNumber(index)
            ? createFromU8a(registry, def, value[0], value.subarray(1))
            : decodeEnum(registry, def, value, index);
        this.registry = registry;
        this.#def = def;
        this.#isBasic = isBasic;
        this.#isIndexed = isIndexed;
        this.#indexes = Object.values(def).map(({ index }) => index);
        this.#entryIndex = this.#indexes.indexOf(decoded.index);
        this.#raw = decoded.value;
        if (this.#raw.initialU8aLength) {
            this.initialU8aLength = 1 + this.#raw.initialU8aLength;
        }
    }
    static with(Types) {
        let definition;
        // eslint-disable-next-line no-return-assign
        const setDefinition = (d) => definition = d;
        return class extends Enum {
            static {
                const keys = Array.isArray(Types)
                    ? Types
                    : Object.keys(Types);
                const count = keys.length;
                const asKeys = new Array(count);
                const isKeys = new Array(count);
                for (let i = 0; i < count; i++) {
                    const name = stringPascalCase(keys[i]);
                    asKeys[i] = `as${name}`;
                    isKeys[i] = `is${name}`;
                }
                objectProperties(this.prototype, isKeys, (_, i, self) => self.type === keys[i]);
                objectProperties(this.prototype, asKeys, (k, i, self) => {
                    if (self.type !== keys[i]) {
                        throw new Error(`Cannot convert '${self.type}' via ${k}`);
                    }
                    return self.value;
                });
            }
            constructor(registry, value, index) {
                super(registry, Types, value, index, { definition, setDefinition });
            }
        };
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        return 1 + this.#raw.encodedLength;
    }
    /**
     * @description returns a hash of the contents
     */
    get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description The index of the enum value
     */
    get index() {
        return this.#indexes[this.#entryIndex];
    }
    /**
     * @description The value of the enum
     */
    get inner() {
        return this.#raw;
    }
    /**
     * @description true if this is a basic enum (no values)
     */
    get isBasic() {
        return this.#isBasic;
    }
    /**
     * @description Checks if the value is an empty value
     */
    get isEmpty() {
        return this.#raw.isEmpty;
    }
    /**
     * @description Checks if the Enum points to a [[Null]] type
     */
    get isNone() {
        return this.#raw instanceof Null;
    }
    /**
     * @description The available keys for this enum
     */
    get defIndexes() {
        return this.#indexes;
    }
    /**
     * @description The available keys for this enum
     */
    get defKeys() {
        return Object.keys(this.#def);
    }
    /**
     * @description The name of the type this enum value represents
     */
    get type() {
        return this.defKeys[this.#entryIndex];
    }
    /**
     * @description The value of the enum
     */
    get value() {
        return this.#raw;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        // cater for the case where we only pass the enum index
        if (isU8a(other)) {
            return !this.toU8a().some((entry, index) => entry !== other[index]);
        }
        else if (isNumber(other)) {
            return this.toNumber() === other;
        }
        else if (this.#isBasic && isString(other)) {
            return this.type === other;
        }
        else if (isHex(other)) {
            return this.toHex() === other;
        }
        else if (other instanceof Enum) {
            return this.index === other.index && this.value.eq(other.value);
        }
        else if (isObject(other)) {
            return this.value.eq(other[this.type]);
        }
        // compare the actual wrapper value
        return this.value.eq(other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        if (this.#isBasic) {
            return { outer: [new Uint8Array([this.index])] };
        }
        const { inner, outer = [] } = this.#raw.inspect();
        return {
            inner,
            outer: [new Uint8Array([this.index]), ...outer]
        };
    }
    /**
     * @description Returns a hex string representation of the value
     */
    toHex() {
        return u8aToHex(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman(isExtended, disableAscii) {
        return this.#isBasic || this.isNone
            ? this.type
            : { [this.type]: this.#raw.toHuman(isExtended, disableAscii) };
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        return this.#isBasic
            ? this.type
            : { [stringCamelCase(this.type)]: this.#raw.toJSON() };
    }
    /**
     * @description Returns the number representation for the value
     */
    toNumber() {
        return this.index;
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive(disableAscii) {
        return this.#isBasic
            ? this.type
            : { [stringCamelCase(this.type)]: this.#raw.toPrimitive(disableAscii) };
    }
    /**
     * @description Returns a raw struct representation of the enum types
     */
    _toRawStruct() {
        if (this.#isBasic) {
            return this.#isIndexed
                ? this.defKeys.reduce((out, key, index) => {
                    out[key] = this.#indexes[index];
                    return out;
                }, {})
                : this.defKeys;
        }
        const entries = Object.entries(this.#def);
        return typesToMap(this.registry, entries.reduce((out, [key, { Type }], i) => {
            out[0][i] = Type;
            out[1][i] = key;
            return out;
        }, [new Array(entries.length), new Array(entries.length)]));
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return stringify({ _enum: this._toRawStruct() });
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        return this.isNone
            ? this.type
            : stringify(this.toJSON());
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8a(isBare) {
        return isBare
            ? this.#raw.toU8a(isBare)
            : u8aConcatStrict([
                new Uint8Array([this.index]),
                this.#raw.toU8a(isBare)
            ]);
    }
}

/**
 * @name Int
 * @description
 * A generic signed integer codec. For Substrate all numbers are Little Endian encoded,
 * this handles the encoding and decoding of those numbers. Upon construction
 * the bitLength is provided and any additional use keeps the number to this
 * length. This extends `BN`, so all methods available on a normal `BN` object
 * is available here.
 * @noInheritDoc
 */
class Int extends AbstractInt {
    constructor(registry, value = 0, bitLength) {
        super(registry, value, bitLength, true);
    }
    static with(bitLength, typeName) {
        return class extends Int {
            constructor(registry, value) {
                super(registry, value, bitLength);
            }
            toRawType() {
                return typeName || super.toRawType();
            }
        };
    }
}

class None extends Null {
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'None';
    }
}
/** @internal */
function decodeOption(registry, Type, value) {
    if (value instanceof Type) {
        // don't re-create, use as it (which also caters for derived types)
        return value;
    }
    else if (value instanceof Option) {
        if (value.value instanceof Type) {
            // same instance, return it
            return value.value;
        }
        else if (value.isNone) {
            // internal is None, we are also none
            return new None(registry);
        }
        // convert the actual value into known
        return new Type(registry, value.value);
    }
    else if (isNull(value) || isUndefined(value) || value === '0x' || value instanceof None) {
        // anything empty we pass as-is
        return new None(registry);
    }
    else if (isU8a(value)) {
        // the isU8a check happens last in the if-tree - since the wrapped value
        // may be an instance of it, so Type and Option checks go in first
        return !value.length || value[0] === 0
            ? new None(registry)
            : new Type(registry, value.subarray(1));
    }
    return new Type(registry, value);
}
/**
 * @name Option
 * @description
 * An Option is an optional field. Basically the first byte indicates that there is
 * is value to follow. If the byte is `1` there is an actual value. So the Option
 * implements that - decodes, checks for optionality and wraps the required structure
 * with a value if/as required/found.
 */
class Option {
    registry;
    createdAtHash;
    initialU8aLength;
    isStorageFallback;
    #Type;
    #raw;
    constructor(registry, typeName, value, { definition, setDefinition = identity$2 } = {}) {
        const Type = definition || setDefinition(typeToConstructor(registry, typeName));
        const decoded = isU8a(value) && value.length && !isCodec(value)
            ? value[0] === 0
                ? new None(registry)
                : new Type(registry, value.subarray(1))
            : decodeOption(registry, Type, value);
        this.registry = registry;
        this.#Type = Type;
        this.#raw = decoded;
        if (decoded?.initialU8aLength) {
            this.initialU8aLength = 1 + decoded.initialU8aLength;
        }
    }
    static with(Type) {
        let definition;
        const setDefinition = (d) => {
            definition = d;
            return d;
        };
        return class extends Option {
            constructor(registry, value) {
                super(registry, Type, value, { definition, setDefinition });
            }
        };
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        // boolean byte (has value, doesn't have) along with wrapped length
        return 1 + this.#raw.encodedLength;
    }
    /**
     * @description returns a hash of the contents
     */
    get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the Option has no value
     */
    get isEmpty() {
        return this.isNone;
    }
    /**
     * @description Checks if the Option has no value
     */
    get isNone() {
        return this.#raw instanceof None;
    }
    /**
     * @description Checks if the Option has a value
     */
    get isSome() {
        return !this.isNone;
    }
    /**
     * @description The actual value for the Option
     */
    get value() {
        return this.#raw;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        if (other instanceof Option) {
            return (this.isSome === other.isSome) && this.value.eq(other.value);
        }
        return this.value.eq(other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        if (this.isNone) {
            return { outer: [new Uint8Array([0])] };
        }
        const { inner, outer = [] } = this.#raw.inspect();
        return {
            inner,
            outer: [new Uint8Array([1]), ...outer]
        };
    }
    /**
     * @description Returns a hex string representation of the value
     */
    toHex() {
        // This attempts to align with the JSON encoding - actually in this case
        // the isSome value is correct, however the `isNone` may be problematic
        return this.isNone
            ? '0x'
            : u8aToHex(this.toU8a().subarray(1));
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman(isExtended, disableAscii) {
        return this.#raw.toHuman(isExtended, disableAscii);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        return this.isNone
            ? null
            : this.#raw.toJSON();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive(disableAscii) {
        return this.isNone
            ? null
            : this.#raw.toPrimitive(disableAscii);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType(isBare) {
        const wrapped = this.registry.getClassName(this.#Type) || new this.#Type(this.registry).toRawType();
        return isBare
            ? wrapped
            : `Option<${wrapped}>`;
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        return this.#raw.toString();
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8a(isBare) {
        if (isBare) {
            return this.#raw.toU8a(true);
        }
        const u8a = new Uint8Array(this.encodedLength);
        if (this.isSome) {
            u8a.set([1]);
            u8a.set(this.#raw.toU8a(), 1);
        }
        return u8a;
    }
    /**
     * @description Returns the value that the Option represents (if available), throws if null
     */
    unwrap() {
        if (this.isNone) {
            throw new Error('Option: unwrapping a None value');
        }
        return this.#raw;
    }
    /**
     * @description Returns the value that the Option represents (if available) or defaultValue if none
     * @param defaultValue The value to return if the option isNone
     */
    unwrapOr(defaultValue) {
        return this.isSome
            ? this.unwrap()
            : defaultValue;
    }
    /**
     * @description Returns the value that the Option represents (if available) or defaultValue if none
     * @param defaultValue The value to return if the option isNone
     */
    unwrapOrDefault() {
        return this.isSome
            ? this.unwrap()
            : new this.#Type(this.registry);
    }
}

/**
 * @name Result
 * @description
 * A Result maps to the Rust Result type, that can either wrap a success or error value
 */
class Result extends Enum {
    constructor(registry, Ok, Err, value) {
        // NOTE This is order-dependent, Ok (with index 0) needs to be first
        // eslint-disable-next-line sort-keys
        super(registry, { Ok, Err }, value);
    }
    static with(Types) {
        return class extends Result {
            constructor(registry, value) {
                super(registry, Types.Ok, Types.Err, value);
            }
        };
    }
    /**
     * @description Returns the wrapper Err value (if isErr)
     */
    get asErr() {
        if (!this.isErr) {
            throw new Error('Cannot extract Err value from Ok result, check isErr first');
        }
        return this.value;
    }
    /**
     * @description Returns the wrapper Ok value (if isOk)
     */
    get asOk() {
        if (!this.isOk) {
            throw new Error('Cannot extract Ok value from Err result, check isOk first');
        }
        return this.value;
    }
    /**
     * @description Checks if the Result has no value
     */
    get isEmpty() {
        return this.isOk && this.value.isEmpty;
    }
    /**
     * @description Checks if the Result wraps an Err value
     */
    get isErr() {
        return !this.isOk;
    }
    /**
     * @description Checks if the Result wraps an Ok value
     */
    get isOk() {
        return this.index === 0;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        const Types = this._toRawStruct();
        return `Result<${Types.Ok},${Types.Err}>`;
    }
}

/** @internal */
function decodeTuple(registry, result, value, Classes) {
    if (Array.isArray(value)) {
        const Types = Classes[0];
        for (let i = 0, count = Types.length; i < count; i++) {
            try {
                const entry = value?.[i];
                result[i] = entry instanceof Types[i]
                    ? entry
                    : new Types[i](registry, entry);
            }
            catch (error) {
                throw new Error(`Tuple: failed on ${i}:: ${error.message}`);
            }
        }
        return [result, 0];
    }
    else if (isHex(value)) {
        return decodeU8a$7(registry, result, u8aToU8a(value), Classes);
    }
    else if (!value || !result.length) {
        const Types = Classes[0];
        for (let i = 0, count = Types.length; i < count; i++) {
            result[i] = new Types[i](registry);
        }
        return [result, 0];
    }
    throw new Error(`Expected array input to Tuple decoding, found ${typeof value}: ${stringify(value)}`);
}
/**
 * @name Tuple
 * @description
 * A Tuple defines an anonymous fixed-length array, where each element has its
 * own type. It extends the base JS `Array` object.
 */
class Tuple extends AbstractArray {
    #Types;
    constructor(registry, Types, value, { definition, setDefinition = identity$2 } = {}) {
        const Classes = definition || setDefinition(Array.isArray(Types)
            ? [typesToConstructors(registry, Types), []]
            : isFunction$1(Types) || isString(Types)
                ? [[typeToConstructor(registry, Types)], []]
                : mapToTypeMap(registry, Types));
        super(registry, Classes[0].length);
        this.initialU8aLength = (isU8a(value)
            ? decodeU8a$7(registry, this, value, Classes)
            : decodeTuple(registry, this, value, Classes))[1];
        this.#Types = Classes;
    }
    static with(Types) {
        let definition;
        // eslint-disable-next-line no-return-assign
        const setDefinition = (d) => definition = d;
        return class extends Tuple {
            constructor(registry, value) {
                super(registry, Types, value, { definition, setDefinition });
            }
        };
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        let total = 0;
        for (let i = 0, count = this.length; i < count; i++) {
            total += this[i].encodedLength;
        }
        return total;
    }
    /**
     * @description The types definition of the tuple
     */
    get Types() {
        return this.#Types[1].length
            ? this.#Types[1]
            : this.#Types[0].map((T) => new T(this.registry).toRawType());
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        return {
            inner: this.inspectInner()
        };
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        const types = this.#Types[0].map((T) => this.registry.getClassName(T) || new T(this.registry).toRawType());
        return `(${types.join(',')})`;
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        // Overwrite the default toString representation of Array.
        return stringify(this.toJSON());
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8a(isBare) {
        return u8aConcatStrict(this.toU8aInner(isBare));
    }
}

/**
 * @name UInt
 * @description
 * A generic unsigned integer codec. For Substrate all numbers are Little Endian encoded,
 * this handles the encoding and decoding of those numbers. Upon construction
 * the bitLength is provided and any additional use keeps the number to this
 * length. This extends `BN`, so all methods available on a normal `BN` object
 * is available here.
 * @noInheritDoc
 */
class UInt extends AbstractInt {
    static with(bitLength, typeName) {
        return class extends UInt {
            constructor(registry, value) {
                super(registry, value, bitLength);
            }
            toRawType() {
                return typeName || super.toRawType();
            }
        };
    }
}

const MAX_LENGTH$2 = 512 * 1024;
const l$9 = logger('Vec');
function decodeVecLength(value) {
    if (Array.isArray(value)) {
        return [value, value.length, 0];
    }
    else if (isU8a(value) || isHex(value)) {
        const u8a = u8aToU8a(value);
        const [startAt, length] = compactFromU8aLim(u8a);
        if (length > MAX_LENGTH$2) {
            throw new Error(`Vec length ${length.toString()} exceeds ${MAX_LENGTH$2}`);
        }
        return [u8a, length, startAt];
    }
    else if (!value) {
        return [null, 0, 0];
    }
    throw new Error(`Expected array/hex input to Vec<*> decoding, found ${typeof value}: ${stringify(value)}`);
}
function decodeVec(registry, result, value, startAt, Type) {
    if (Array.isArray(value)) {
        const count = result.length;
        for (let i = 0; i < count; i++) {
            // 26/08/2022 this is actually a false positive - after recent eslint upgdates
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const entry = value[i];
            try {
                result[i] = entry instanceof Type
                    ? entry
                    : new Type(registry, entry);
            }
            catch (error) {
                l$9.error(`Unable to decode on index ${i}`, error.message);
                throw error;
            }
        }
        return [0, 0];
    }
    else if (!value) {
        return [0, 0];
    }
    // we don't need more checks, we already limited it via the length decoding
    return decodeU8aVec(registry, result, u8aToU8a(value), startAt, Type);
}
/**
 * @name Vec
 * @description
 * This manages codec arrays. Internally it keeps track of the length (as decoded) and allows
 * construction with the passed `Type` in the constructor. It is an extension to Array, providing
 * specific encoding/decoding on top of the base type.
 */
class Vec extends AbstractArray {
    #Type;
    constructor(registry, Type, value = [], { definition, setDefinition = identity$2 } = {}) {
        const [decodeFrom, length, startAt] = decodeVecLength(value);
        super(registry, length);
        this.#Type = definition || setDefinition(typeToConstructor(registry, Type));
        this.initialU8aLength = (isU8a(decodeFrom)
            ? decodeU8aVec(registry, this, decodeFrom, startAt, this.#Type)
            : decodeVec(registry, this, decodeFrom, startAt, this.#Type))[0];
    }
    static with(Type) {
        let definition;
        // eslint-disable-next-line no-return-assign
        const setDefinition = (d) => (definition = d);
        return class extends Vec {
            constructor(registry, value) {
                super(registry, Type, value, { definition, setDefinition });
            }
        };
    }
    /**
     * @description The type for the items
     */
    get Type() {
        return this.#Type.name;
    }
    /**
     * @description Finds the index of the value in the array
     */
    indexOf(other) {
        // convert type first, this removes overhead from the eq
        const check = other instanceof this.#Type
            ? other
            : new this.#Type(this.registry, other);
        for (let i = 0, count = this.length; i < count; i++) {
            if (check.eq(this[i])) {
                return i;
            }
        }
        return -1;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return `Vec<${this.registry.getClassName(this.#Type) || new this.#Type(this.registry).toRawType()}>`;
    }
}

/**
 * @name VecFixed
 * @description
 * This manages codec arrays of a fixed length
 */
class VecFixed extends AbstractArray {
    #Type;
    constructor(registry, Type, length, value = [], { definition, setDefinition = identity$2 } = {}) {
        super(registry, length);
        this.#Type = definition || setDefinition(typeToConstructor(registry, Type));
        this.initialU8aLength = (isU8a(value)
            ? decodeU8aVec(registry, this, value, 0, this.#Type)
            : decodeVec(registry, this, value, 0, this.#Type))[1];
    }
    static with(Type, length) {
        let definition;
        // eslint-disable-next-line no-return-assign
        const setDefinition = (d) => (definition = d);
        return class extends VecFixed {
            constructor(registry, value) {
                super(registry, Type, length, value, { definition, setDefinition });
            }
        };
    }
    /**
     * @description The type for the items
     */
    get Type() {
        return new this.#Type(this.registry).toRawType();
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        let total = 0;
        for (let i = 0, count = this.length; i < count; i++) {
            total += this[i].encodedLength;
        }
        return total;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        return {
            inner: this.inspectInner()
        };
    }
    toU8a() {
        // we override, we don't add the length prefix for ourselves, and at the same time we
        // ignore isBare on entries, since they should be properly encoded at all times
        const encoded = this.toU8aInner();
        return encoded.length
            ? u8aConcatStrict(encoded)
            : new Uint8Array([]);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return `[${this.Type};${this.length}]`;
    }
}

/**
 * @name Raw
 * @description
 * A basic wrapper around Uint8Array, with no frills and no fuss. It does differ
 * from other implementations where it will consume the full Uint8Array as passed to it.
 * As such it is meant to be subclassed where the wrapper takes care of the
 * actual lengths instead of used directly.
 * @noInheritDoc
 */
class Raw extends Uint8Array {
    registry;
    createdAtHash;
    initialU8aLength;
    isStorageFallback;
    /**
     * @description This ensures that operators such as clice, filter, map, etc. return
     * new Array instances (without this we need to apply overrides)
     */
    static get [Symbol.species]() {
        return Uint8Array;
    }
    constructor(registry, value, initialU8aLength) {
        super(u8aToU8a(value));
        this.registry = registry;
        this.initialU8aLength = initialU8aLength;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        return this.length;
    }
    /**
     * @description returns a hash of the contents
     */
    get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Returns true if the wrapped value contains only ASCII printable characters
     */
    get isAscii() {
        return isAscii(this);
    }
    /**
     * @description Returns true if the type wraps an empty/default all-0 value
     */
    get isEmpty() {
        return !this.length || isUndefined(this.find((b) => !!b));
    }
    /**
     * @description Returns true if the wrapped value contains only utf8 characters
     */
    get isUtf8() {
        return isUtf8(this);
    }
    /**
     * @description Returns the number of bits in the value
     */
    bitLength() {
        return this.length * 8;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        if (other instanceof Uint8Array) {
            return (this.length === other.length) &&
                !this.some((b, index) => b !== other[index]);
        }
        return this.eq(u8aToU8a(other));
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        return {
            outer: [this.toU8a()]
        };
    }
    /**
     * @description Returns a hex string representation of the value
     */
    toHex() {
        return u8aToHex(this);
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman(_isExtended, disableAscii) {
        return this.toPrimitive(disableAscii);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        return this.toHex();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive(disableAscii) {
        if (!disableAscii && this.isAscii) {
            const text = this.toUtf8();
            // ensure we didn't end up with multibyte codepoints
            if (isAscii(text)) {
                return text;
            }
        }
        return this.toJSON();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'Raw';
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        return this.toHex();
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     */
    toU8a(_isBare) {
        return Uint8Array.from(this);
    }
    /**
     * @description Returns the wrapped data as a UTF-8 string
     */
    toUtf8() {
        if (!this.isUtf8) {
            throw new Error('The character sequence is not a valid Utf8 string');
        }
        return u8aToString(this);
    }
}

/** @internal */
function decodeBitVecU8a(value) {
    if (!value?.length) {
        return [0, new Uint8Array()];
    }
    // handle all other Uint8Array inputs, these do have a length prefix which is the number of bits encoded
    const [offset, length] = compactFromU8aLim(value);
    const total = offset + Math.ceil(length / 8);
    if (total > value.length) {
        throw new Error(`BitVec: required length less than remainder, expected at least ${total}, found ${value.length}`);
    }
    return [length, value.subarray(offset, total)];
}
/** @internal */
function decodeBitVec(value) {
    if (Array.isArray(value) || isString(value)) {
        const u8a = u8aToU8a(value);
        return [u8a.length * 8, u8a];
    }
    return decodeBitVecU8a(value);
}
/**
 * @name BitVec
 * @description
 * A BitVec that represents an array of bits. The bits are however stored encoded. The difference between this
 * and a normal Bytes would be that the length prefix indicates the number of bits encoded, not the bytes
 */
class BitVec extends Raw {
    #decodedLength;
    #isMsb;
    // In lieu of having the Msb/Lsb identifiers passed through, we default to assuming
    // we are dealing with Lsb, which is the default (as of writing) BitVec format used
    // in the Polkadot code (this only affects the toHuman displays)
    constructor(registry, value, isMsb = false) {
        const [decodedLength, u8a] = decodeBitVec(value);
        super(registry, u8a);
        this.#decodedLength = decodedLength;
        this.#isMsb = isMsb;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        return this.length + compactToU8a(this.#decodedLength).length;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        return {
            outer: [compactToU8a(this.#decodedLength), super.toU8a()]
        };
    }
    /**
     * @description Creates a boolean array of the bit values
     */
    toBoolArray() {
        const map = [...this.toU8a(true)].map((v) => [
            !!(v & 0b1000_0000),
            !!(v & 0b0100_0000),
            !!(v & 0b0010_0000),
            !!(v & 0b0001_0000),
            !!(v & 0b0000_1000),
            !!(v & 0b0000_0100),
            !!(v & 0b0000_0010),
            !!(v & 0b0000_0001)
        ]);
        const count = map.length;
        const result = new Array(8 * count);
        for (let i = 0; i < count; i++) {
            const off = i * 8;
            const v = map[i];
            for (let j = 0; j < 8; j++) {
                result[off + j] = this.#isMsb
                    ? v[j]
                    : v[7 - j];
            }
        }
        return result;
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman() {
        return `0b${[...this.toU8a(true)]
            .map((d) => `00000000${d.toString(2)}`.slice(-8))
            .map((s) => this.#isMsb ? s : s.split('').reverse().join(''))
            .join('_')}`;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'BitVec';
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8a(isBare) {
        const bitVec = super.toU8a(isBare);
        return isBare
            ? bitVec
            : u8aConcatStrict([compactToU8a(this.#decodedLength), bitVec]);
    }
}

function noopSetDefinition(d) {
    return d;
}
/** @internal */
function decodeStructFromObject(registry, [Types, keys], value, jsonMap) {
    let jsonObj;
    const typeofArray = Array.isArray(value);
    const typeofMap = value instanceof Map;
    const count = keys.length;
    if (!typeofArray && !typeofMap && !isObject(value)) {
        throw new Error(`Struct: Cannot decode value ${stringify(value)} (typeof ${typeof value}), expected an input object, map or array`);
    }
    else if (typeofArray && value.length !== count) {
        throw new Error(`Struct: Unable to map ${stringify(value)} array to object with known keys ${keys.join(', ')}`);
    }
    const raw = new Array(count);
    for (let i = 0; i < count; i++) {
        const key = keys[i];
        const jsonKey = jsonMap.get(key) || key;
        const Type = Types[i];
        let assign;
        try {
            if (typeofArray) {
                assign = value[i];
            }
            else if (typeofMap) {
                assign = jsonKey && value.get(jsonKey);
            }
            else {
                assign = jsonKey && Object.prototype.hasOwnProperty.call(value, jsonKey) ? value[jsonKey] : undefined;
                if (isUndefined(assign)) {
                    if (isUndefined(jsonObj)) {
                        const entries = Object.entries(value);
                        jsonObj = {};
                        for (let e = 0, ecount = entries.length; e < ecount; e++) {
                            if (Object.prototype.hasOwnProperty.call(value, entries[e][0])) {
                                jsonObj[stringCamelCase(entries[e][0])] = entries[e][1];
                            }
                        }
                    }
                    assign = jsonKey && Object.prototype.hasOwnProperty.call(jsonObj, jsonKey) ? jsonObj[jsonKey] : undefined;
                }
            }
            raw[i] = [
                key,
                assign instanceof Type
                    ? assign
                    : new Type(registry, assign)
            ];
        }
        catch (error) {
            let type = Type.name;
            try {
                type = new Type(registry).toRawType();
            }
            catch {
                // ignore
            }
            throw new Error(`Struct: failed on ${jsonKey}: ${type}:: ${error.message}`);
        }
    }
    return [raw, 0];
}
/**
 * @name Struct
 * @description
 * A Struct defines an Object with key-value pairs - where the values are Codec values. It removes
 * a lot of repetition from the actual coding, define a structure type, pass it the key/Codec
 * values in the constructor and it manages the decoding. It is important that the constructor
 * values matches 100% to the order in th Rust code, i.e. don't go crazy and make it alphabetical,
 * it needs to decoded in the specific defined order.
 * @noInheritDoc
 */
class Struct extends Map {
    registry;
    createdAtHash;
    initialU8aLength;
    isStorageFallback;
    #jsonMap;
    #Types;
    constructor(registry, Types, value, jsonMap = new Map(), { definition, setDefinition = noopSetDefinition } = {}) {
        const typeMap = definition || setDefinition(mapToTypeMap(registry, Types));
        const [decoded, decodedLength] = isU8a(value) || isHex(value)
            ? decodeU8aStruct(registry, new Array(typeMap[0].length), u8aToU8a(value), typeMap)
            : value instanceof Struct
                ? [value, 0]
                : decodeStructFromObject(registry, typeMap, value || {}, jsonMap);
        super(decoded);
        this.initialU8aLength = decodedLength;
        this.registry = registry;
        this.#jsonMap = jsonMap;
        this.#Types = typeMap;
    }
    static with(Types, jsonMap) {
        let definition;
        // eslint-disable-next-line no-return-assign
        const setDefinition = (d) => definition = d;
        return class extends Struct {
            static {
                const keys = Object.keys(Types);
                objectProperties(this.prototype, keys, (k, _, self) => self.get(k));
            }
            constructor(registry, value) {
                super(registry, Types, value, jsonMap, { definition, setDefinition });
            }
        };
    }
    /**
     * @description The available keys for this struct
     */
    get defKeys() {
        return this.#Types[1];
    }
    /**
     * @description Checks if the value is an empty value '{}'
     */
    get isEmpty() {
        return [...this.keys()].length === 0;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        let total = 0;
        for (const v of this.values()) {
            total += v.encodedLength;
        }
        return total;
    }
    /**
     * @description returns a hash of the contents
     */
    get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Returns the Type description of the structure
     */
    get Type() {
        const result = {};
        const [Types, keys] = this.#Types;
        for (let i = 0, count = keys.length; i < count; i++) {
            result[keys[i]] = new Types[i](this.registry).toRawType();
        }
        return result;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        return compareMap(this, other);
    }
    /**
     * @description Returns a specific names entry in the structure
     * @param key The name of the entry to retrieve
     */
    get(key) {
        return super.get(key);
    }
    /**
     * @description Returns the values of a member at a specific index (Rather use get(name) for performance)
     */
    getAtIndex(index) {
        return this.toArray()[index];
    }
    /**
     * @description Returns the a types value by name
     */
    getT(key) {
        return super.get(key);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect(isBare) {
        const inner = [];
        for (const [k, v] of this.entries()) {
            inner.push({
                ...v.inspect(!isBare || isBoolean(isBare)
                    ? isBare
                    : isBare[k]),
                name: stringCamelCase(k)
            });
        }
        return {
            inner
        };
    }
    /**
     * @description Converts the Object to an standard JavaScript Array
     */
    toArray() {
        return [...this.values()];
    }
    /**
     * @description Returns a hex string representation of the value
     */
    toHex() {
        return u8aToHex(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman(isExtended, disableAscii) {
        const json = {};
        for (const [k, v] of this.entries()) {
            json[k] = v.toHuman(isExtended, disableAscii);
        }
        return json;
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        const json = {};
        for (const [k, v] of this.entries()) {
            // Here we pull out the entry against the JSON mapping (if supplied)
            // since this representation goes over RPC and needs to be correct
            json[(this.#jsonMap.get(k) || k)] = v.toJSON();
        }
        return json;
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive(disableAscii) {
        const json = {};
        for (const [k, v] of this.entries()) {
            json[k] = v.toPrimitive(disableAscii);
        }
        return json;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return stringify(typesToMap(this.registry, this.#Types));
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        return stringify(this.toJSON());
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8a(isBare) {
        const encoded = [];
        for (const [k, v] of this.entries()) {
            encoded.push(v.toU8a(!isBare || isBoolean(isBare)
                ? isBare
                : isBare[k]));
        }
        return u8aConcatStrict(encoded);
    }
}

const l$8 = logger('Map');
/** @internal */
function decodeMapFromU8a(registry, KeyClass, ValClass, u8a) {
    const output = new Map();
    const [offset, count] = compactFromU8aLim(u8a);
    const types = [];
    for (let i = 0; i < count; i++) {
        types.push(KeyClass, ValClass);
    }
    const [values, decodedLength] = decodeU8a$7(registry, new Array(types.length), u8a.subarray(offset), [types, []]);
    for (let i = 0, count = values.length; i < count; i += 2) {
        output.set(values[i], values[i + 1]);
    }
    return [KeyClass, ValClass, output, offset + decodedLength];
}
/** @internal */
function decodeMapFromMap(registry, KeyClass, ValClass, value) {
    const output = new Map();
    for (const [key, val] of value.entries()) {
        const isComplex = KeyClass.prototype instanceof AbstractArray ||
            KeyClass.prototype instanceof Struct ||
            KeyClass.prototype instanceof Enum;
        try {
            output.set(key instanceof KeyClass
                ? key
                : new KeyClass(registry, isComplex && typeof key === 'string' ? JSON.parse(key) : key), val instanceof ValClass
                ? val
                : new ValClass(registry, val));
        }
        catch (error) {
            l$8.error('Failed to decode key or value:', error.message);
            throw error;
        }
    }
    return [KeyClass, ValClass, output, 0];
}
/**
 * Decode input to pass into constructor.
 *
 * @param KeyClass - Type of the map key
 * @param ValClass - Type of the map value
 * @param value - Value to decode, one of:
 * - null
 * - undefined
 * - hex
 * - Uint8Array
 * - Map<any, any>, where both key and value types are either
 *   constructors or decodeable values for their types.
 * @param jsonMap
 * @internal
 */
function decodeMap(registry, keyType, valType, value) {
    const KeyClass = typeToConstructor(registry, keyType);
    const ValClass = typeToConstructor(registry, valType);
    if (!value) {
        return [KeyClass, ValClass, new Map(), 0];
    }
    else if (isU8a(value) || isHex(value)) {
        return decodeMapFromU8a(registry, KeyClass, ValClass, u8aToU8a(value));
    }
    else if (value instanceof Map) {
        return decodeMapFromMap(registry, KeyClass, ValClass, value);
    }
    else if (isObject(value)) {
        return decodeMapFromMap(registry, KeyClass, ValClass, new Map(Object.entries(value)));
    }
    throw new Error('Map: cannot decode type');
}
class CodecMap extends Map {
    registry;
    createdAtHash;
    initialU8aLength;
    isStorageFallback;
    #KeyClass;
    #ValClass;
    #type;
    constructor(registry, keyType, valType, rawValue, type = 'HashMap') {
        const [KeyClass, ValClass, decoded, decodedLength] = decodeMap(registry, keyType, valType, rawValue);
        super(type === 'BTreeMap' ? sortMap(decoded) : decoded);
        this.registry = registry;
        this.initialU8aLength = decodedLength;
        this.#KeyClass = KeyClass;
        this.#ValClass = ValClass;
        this.#type = type;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        let len = compactToU8a(this.size).length;
        for (const [k, v] of this.entries()) {
            len += k.encodedLength + v.encodedLength;
        }
        return len;
    }
    /**
     * @description Returns a hash of the value
     */
    get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value
     */
    get isEmpty() {
        return this.size === 0;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        return compareMap(this, other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        const inner = [];
        for (const [k, v] of this.entries()) {
            inner.push(k.inspect());
            inner.push(v.inspect());
        }
        return {
            inner,
            outer: [compactToU8a(this.size)]
        };
    }
    /**
     * @description Returns a hex string representation of the value. isLe returns a LE (number-only) representation
     */
    toHex() {
        return u8aToHex(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman(isExtended, disableAscii) {
        const json = {};
        for (const [k, v] of this.entries()) {
            json[k instanceof Raw && !disableAscii && k.isAscii
                ? k.toUtf8()
                : k.toString()] = v.toHuman(isExtended, disableAscii);
        }
        return json;
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        const json = {};
        for (const [k, v] of this.entries()) {
            json[k.toString()] = v.toJSON();
        }
        return json;
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive(disableAscii) {
        const json = {};
        for (const [k, v] of this.entries()) {
            json[k instanceof Raw && !disableAscii && k.isAscii
                ? k.toUtf8()
                : k.toString()] = v.toPrimitive(disableAscii);
        }
        return json;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return `${this.#type}<${this.registry.getClassName(this.#KeyClass) || new this.#KeyClass(this.registry).toRawType()},${this.registry.getClassName(this.#ValClass) || new this.#ValClass(this.registry).toRawType()}>`;
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        return stringify(this.toJSON());
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8a(isBare) {
        const encoded = [];
        if (!isBare) {
            encoded.push(compactToU8a(this.size));
        }
        for (const [k, v] of this.entries()) {
            encoded.push(k.toU8a(isBare), v.toU8a(isBare));
        }
        return u8aConcatStrict(encoded);
    }
}

class BTreeMap extends CodecMap {
    static with(keyType, valType) {
        return class extends BTreeMap {
            constructor(registry, value) {
                super(registry, keyType, valType, value, 'BTreeMap');
            }
        };
    }
}

const l$7 = logger('BTreeSet');
/** @internal */
function decodeSetFromU8a(registry, ValClass, u8a) {
    const output = new Set();
    const [offset, count] = compactFromU8aLim(u8a);
    const result = new Array(count);
    const [decodedLength] = decodeU8aVec(registry, result, u8a, offset, ValClass);
    for (let i = 0; i < count; i++) {
        output.add(result[i]);
    }
    return [ValClass, output, decodedLength];
}
/** @internal */
function decodeSetFromSet(registry, ValClass, value) {
    const output = new Set();
    value.forEach((val) => {
        try {
            output.add((val instanceof ValClass) ? val : new ValClass(registry, val));
        }
        catch (error) {
            l$7.error('Failed to decode key or value:', error.message);
            throw error;
        }
    });
    return [ValClass, output, 0];
}
/**
 * Decode input to pass into constructor.
 *
 * @param ValClass - Type of the map value
 * @param value - Value to decode, one of:
 * - null
 * - undefined
 * - hex
 * - Uint8Array
 * - Set<any>, where both key and value types are either
 *   constructors or decodeable values for their types.
 * @param jsonSet
 * @internal
 */
function decodeSet$1(registry, valType, value) {
    const ValClass = typeToConstructor(registry, valType);
    if (!value) {
        return [ValClass, new Set(), 0];
    }
    else if (isU8a(value) || isHex(value)) {
        return decodeSetFromU8a(registry, ValClass, u8aToU8a(value));
    }
    else if (Array.isArray(value) || value instanceof Set) {
        return decodeSetFromSet(registry, ValClass, value);
    }
    throw new Error('BTreeSet: cannot decode type');
}
class BTreeSet extends Set {
    registry;
    createdAtHash;
    initialU8aLength;
    isStorageFallback;
    #ValClass;
    constructor(registry, valType, rawValue) {
        const [ValClass, values, decodedLength] = decodeSet$1(registry, valType, rawValue);
        super(sortSet(values));
        this.registry = registry;
        this.initialU8aLength = decodedLength;
        this.#ValClass = ValClass;
    }
    static with(valType) {
        return class extends BTreeSet {
            constructor(registry, value) {
                super(registry, valType, value);
            }
        };
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        let len = compactToU8a(this.size).length;
        for (const v of this.values()) {
            len += v.encodedLength;
        }
        return len;
    }
    /**
     * @description Returns a hash of the value
     */
    get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value
     */
    get isEmpty() {
        return this.size === 0;
    }
    /**
     * @description The actual set values as a string[]
     */
    get strings() {
        return [...super.values()].map((v) => v.toString());
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        return compareSet(this, other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        const inner = [];
        for (const v of this.values()) {
            inner.push(v.inspect());
        }
        return {
            inner,
            outer: [compactToU8a(this.size)]
        };
    }
    /**
     * @description Returns a hex string representation of the value. isLe returns a LE (number-only) representation
     */
    toHex() {
        return u8aToHex(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman(isExtended, disableAscii) {
        const json = [];
        for (const v of this.values()) {
            json.push(v.toHuman(isExtended, disableAscii));
        }
        return json;
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        const json = [];
        for (const v of this.values()) {
            json.push(v.toJSON());
        }
        return json;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return `BTreeSet<${this.registry.getClassName(this.#ValClass) || new this.#ValClass(this.registry).toRawType()}>`;
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive(disableAscii) {
        const json = [];
        for (const v of this.values()) {
            json.push(v.toPrimitive(disableAscii));
        }
        return json;
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        return stringify(this.toJSON());
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8a(isBare) {
        const encoded = [];
        if (!isBare) {
            encoded.push(compactToU8a(this.size));
        }
        for (const v of this.values()) {
            encoded.push(v.toU8a(isBare));
        }
        return u8aConcatStrict(encoded);
    }
}

const MAX_LENGTH$1 = 10 * 1024 * 1024;
/** @internal */
function decodeBytesU8a(value) {
    if (!value.length) {
        return [new Uint8Array(), 0];
    }
    // handle all other Uint8Array inputs, these do have a length prefix
    const [offset, length] = compactFromU8aLim(value);
    const total = offset + length;
    if (length > MAX_LENGTH$1) {
        throw new Error(`Bytes length ${length.toString()} exceeds ${MAX_LENGTH$1}`);
    }
    else if (total > value.length) {
        throw new Error(`Bytes: required length less than remainder, expected at least ${total}, found ${value.length}`);
    }
    return [value.subarray(offset, total), total];
}
/**
 * @name Bytes
 * @description
 * A Bytes wrapper for Vec<u8>. The significant difference between this and a normal Uint8Array
 * is that this version allows for length-encoding. (i.e. it is a variable-item codec, the same
 * as what is found in [[Text]] and [[Vec]])
 */
class Bytes extends Raw {
    constructor(registry, value) {
        const [u8a, decodedLength] = isU8a(value) && !(value instanceof Raw)
            ? decodeBytesU8a(value)
            : Array.isArray(value) || isString(value)
                ? [u8aToU8a(value), 0]
                : [value, 0];
        super(registry, u8a, decodedLength);
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        return this.length + compactToU8a(this.length).length;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect(isBare) {
        const clength = compactToU8a(this.length);
        return {
            outer: isBare
                ? [super.toU8a()]
                : this.length
                    ? [clength, super.toU8a()]
                    : [clength]
        };
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'Bytes';
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8a(isBare) {
        return isBare
            ? super.toU8a(isBare)
            : compactAddLength(this);
    }
}

class HashMap extends CodecMap {
    static with(keyType, valType) {
        return class extends HashMap {
            constructor(registry, value) {
                super(registry, keyType, valType, value);
            }
        };
    }
}

/**
 * @name bool
 * @description
 * Representation for a boolean value in the system. It extends the base JS `Boolean` class
 * @noInheritDoc
 */
class bool extends Boolean {
    registry;
    createdAtHash;
    initialU8aLength = 1;
    isStorageFallback;
    constructor(registry, value = false) {
        super(isU8a(value)
            ? value[0] === 1
            : value instanceof Boolean
                ? value.valueOf()
                : !!value);
        this.registry = registry;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        return 1 | 0;
    }
    /**
     * @description returns a hash of the contents
     */
    get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value (true when it wraps false/default)
     */
    get isEmpty() {
        return this.isFalse;
    }
    /**
     * @description Checks if the value is an empty value (always false)
     */
    get isFalse() {
        return !this.isTrue;
    }
    /**
     * @description Checks if the value is an empty value (always false)
     */
    get isTrue() {
        return this.valueOf();
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        return this.valueOf() === (other instanceof Boolean
            ? other.valueOf()
            : other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        return {
            outer: [this.toU8a()]
        };
    }
    /**
     * @description Returns a hex string representation of the value
     */
    toHex() {
        return u8aToHex(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman() {
        return this.toJSON();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        return this.valueOf();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive() {
        return this.toJSON();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'bool';
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        return this.toJSON().toString();
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     */
    toU8a(_isBare) {
        return new Uint8Array([this.valueOf() ? 1 : 0]);
    }
}

function decodeU8a$6(registry, value) {
    // Encoded as -
    //  - 0 = None
    //  - 1 = True
    //  - 2 = False
    return value[0] === 0
        ? null
        : new bool(registry, value[0] === 1);
}
/**
 * @name OptionBool
 * @description A specific implementation of Option<bool> than allows for single-byte encoding
 */
class OptionBool extends Option {
    constructor(registry, value) {
        super(registry, bool, isU8a(value) || isHex(value)
            ? decodeU8a$6(registry, u8aToU8a(value))
            : value);
        this.initialU8aLength = 1;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        return 1 | 0;
    }
    /**
     * @description Checks if the value is an empty value (always false)
     */
    get isFalse() {
        return this.isSome
            ? !this.value.valueOf()
            : false;
    }
    /**
     * @description Checks if the value is an empty value (always false)
     */
    get isTrue() {
        return this.isSome
            ? this.value.valueOf()
            : false;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        return { outer: [this.toU8a()] };
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType(isBare) {
        return isBare
            ? 'bool'
            : 'Option<bool>';
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8a(isBare) {
        if (isBare) {
            return super.toU8a(true);
        }
        return this.isSome
            ? new Uint8Array([this.isTrue ? 1 : 2])
            : new Uint8Array([0]);
    }
}

/**
 * @name Range
 * @description
 * Rust `Range<T>` representation
 */
class Range extends Tuple {
    #rangeName;
    constructor(registry, Type, value, { rangeName = 'Range' } = {}) {
        super(registry, [Type, Type], value);
        this.#rangeName = rangeName;
    }
    static with(Type) {
        return class extends Range {
            constructor(registry, value) {
                super(registry, Type, value);
            }
        };
    }
    /**
     * @description Returns the starting range value
     */
    get start() {
        return this[0];
    }
    /**
     * @description Returns the ending range value
     */
    get end() {
        return this[1];
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return `${this.#rangeName}<${this.start.toRawType()}>`;
    }
}

class RangeInclusive extends Range {
    constructor(registry, Type, value) {
        super(registry, Type, value, { rangeName: 'RangeInclusive' });
    }
    static with(Type) {
        return class extends RangeInclusive {
            constructor(registry, value) {
                super(registry, Type, value);
            }
        };
    }
}

const MAX_LENGTH = 128 * 1024;
/** @internal */
function decodeText(value) {
    if (isU8a(value)) {
        if (!value.length) {
            return ['', 0];
        }
        // for Raw, the internal buffer does not have an internal length
        // (the same applies in e.g. Bytes, where length is added at encoding-time)
        if (value instanceof Raw) {
            return [u8aToString(value), 0];
        }
        const [offset, length] = compactFromU8aLim(value);
        const total = offset + length;
        if (length > MAX_LENGTH) {
            throw new Error(`Text: length ${length.toString()} exceeds ${MAX_LENGTH}`);
        }
        else if (total > value.length) {
            throw new Error(`Text: required length less than remainder, expected at least ${total}, found ${value.length}`);
        }
        return [u8aToString(value.subarray(offset, total)), total];
    }
    else if (isHex(value)) {
        return [u8aToString(hexToU8a(value)), 0];
    }
    return [value ? value.toString() : '', 0];
}
/**
 * @name Text
 * @description
 * This is a string wrapper, along with the length. It is used both for strings as well
 * as items such as documentation. It simply extends the standard JS `String` built-in
 * object, inheriting all methods exposed from `String`.
 * @noInheritDoc
 */
class Text extends String {
    registry;
    createdAtHash;
    initialU8aLength;
    isStorageFallback;
    #override = null;
    constructor(registry, value) {
        const [str, decodedLength] = decodeText(value);
        super(str);
        this.registry = registry;
        this.initialU8aLength = decodedLength;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        return this.toU8a().length;
    }
    /**
     * @description returns a hash of the contents
     */
    get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value
     */
    get isEmpty() {
        return this.length === 0;
    }
    /**
     * @description The length of the value
     */
    get length() {
        // only included here since we ignore inherited docs
        return super.length;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        return isString(other)
            ? this.toString() === other.toString()
            : false;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        const value = stringToU8a(super.toString());
        return {
            outer: value.length
                ? [compactToU8a(value.length), value]
                : [compactToU8a(value.length)]
        };
    }
    /**
     * @description Set an override value for this
     */
    setOverride(override) {
        this.#override = override;
    }
    /**
     * @description Returns a hex string representation of the value
     */
    toHex() {
        // like with Vec<u8>, when we are encoding to hex, we don't actually add
        // the length prefix (it is already implied by the actual string length)
        return u8aToHex(this.toU8a(true));
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman() {
        return this.toJSON();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        return this.toString();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive() {
        return this.toJSON();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'Text';
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        return this.#override || super.toString();
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8a(isBare) {
        // NOTE Here we use the super toString (we are not taking overrides into account,
        // rather encoding the original value the string was constructed with)
        const encoded = stringToU8a(super.toString());
        return isBare
            ? encoded
            : compactAddLength(encoded);
    }
}

/**
 * @name Type
 * @description
 * This is a extended version of Text, specifically to handle types. Here we rely fully
 * on what Text provides us, however we also adjust the types received from the runtime,
 * i.e. we remove the `T::` prefixes found in some types for consistency across implementation.
 */
class Type extends Text {
    constructor(registry, value = '') {
        super(registry, value);
        this.setOverride(sanitize(this.toString()));
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'Type';
    }
}

/** @internal */
function decodeU8aFixed(value, bitLength) {
    const u8a = u8aToU8a(value);
    const byteLength = bitLength / 8;
    if (!u8a.length) {
        return [new Uint8Array(byteLength), 0];
    }
    if (isU8a(value) ? u8a.length < byteLength : u8a.length !== byteLength) {
        throw new Error(`Expected input with ${byteLength} bytes (${bitLength} bits), found ${u8a.length} bytes`);
    }
    return [u8a.subarray(0, byteLength), byteLength];
}
/**
 * @name U8aFixed
 * @description
 * A U8a that manages a a sequence of bytes up to the specified bitLength. Not meant
 * to be used directly, rather is should be subclassed with the specific lengths.
 */
class U8aFixed extends Raw {
    constructor(registry, value = new Uint8Array(), bitLength = 256) {
        const [u8a, decodedLength] = decodeU8aFixed(value, bitLength);
        super(registry, u8a, decodedLength);
    }
    static with(bitLength, typeName) {
        return class extends U8aFixed {
            constructor(registry, value) {
                super(registry, value, bitLength);
            }
            toRawType() {
                return typeName || super.toRawType();
            }
        };
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return `[u8;${this.length}]`;
    }
}

function decodeRaw(registry, typeName, value) {
    const Type = typeToConstructor(registry, typeName);
    if (isU8a(value) || isHex(value)) {
        try {
            const [, u8a] = isHex(value)
                ? [0, u8aToU8a(value)]
                : (value instanceof Raw)
                    ? [0, value.subarray()]
                    : compactStripLength(value);
            return [Type, new Type(registry, u8a), value];
        }
        catch {
            return [Type, null, value];
        }
    }
    const instance = new Type(registry, value);
    return [Type, instance, compactAddLength(instance.toU8a())];
}
class WrapperKeepOpaque extends Bytes {
    #Type;
    #decoded;
    #opaqueName;
    constructor(registry, typeName, value, { opaqueName = 'WrapperKeepOpaque' } = {}) {
        const [Type, decoded, u8a] = decodeRaw(registry, typeName, value);
        super(registry, u8a);
        this.#Type = Type;
        this.#decoded = decoded;
        this.#opaqueName = opaqueName;
    }
    static with(Type) {
        return class extends WrapperKeepOpaque {
            constructor(registry, value) {
                super(registry, Type, value);
            }
        };
    }
    /**
     * @description Checks if the wrapper is decodable
     */
    get isDecoded() {
        return !!this.#decoded;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        return this.#decoded
            ? {
                inner: [this.#decoded.inspect()],
                outer: [compactToU8a(this.length)]
            }
            : {
                outer: [compactToU8a(this.length), this.toU8a(true)]
            };
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman(isExtended, disableAscii) {
        return this.#decoded
            ? this.#decoded.toHuman(isExtended, disableAscii)
            : super.toHuman(isExtended, disableAscii);
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive(disableAscii) {
        return this.#decoded
            ? this.#decoded.toPrimitive(disableAscii)
            : super.toPrimitive(disableAscii);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return `${this.#opaqueName}<${this.registry.getClassName(this.#Type) || (this.#decoded ? this.#decoded.toRawType() : new this.#Type(this.registry).toRawType())}>`;
    }
    /**
     * @description Converts the Object to to a string (either decoded or bytes)
     */
    toString() {
        return this.#decoded
            ? this.#decoded.toString()
            : super.toString();
    }
    /**
     * @description Returns the decoded that the WrapperKeepOpaque represents (if available), throws if non-decodable
     */
    unwrap() {
        if (!this.#decoded) {
            throw new Error(`${this.#opaqueName}: unwrapping an undecodable value`);
        }
        return this.#decoded;
    }
}

class WrapperOpaque extends WrapperKeepOpaque {
    constructor(registry, typeName, value) {
        super(registry, typeName, value, { opaqueName: 'WrapperOpaque' });
    }
    static with(Type) {
        return class extends WrapperOpaque {
            constructor(registry, value) {
                super(registry, Type, value);
            }
        };
    }
    /**
     * @description The inner value for this wrapper, in all cases it _should_ be decodable (unlike KeepOpaque)
     */
    get inner() {
        return this.unwrap();
    }
}

/**
 * @name Float
 * @description
 * A Codec wrapper for F32 & F64 values. You generally don't want to be using
 * f32/f64 in your runtime, operations on fixed points numbers are preferable. This class
 * was explicitly added since scale-codec has a flag that enables this and it is available
 * in some eth_* RPCs
 */
class Float extends Number {
    encodedLength;
    registry;
    createdAtHash;
    initialU8aLength;
    isStorageFallback;
    #bitLength;
    constructor(registry, value, { bitLength = 32 } = {}) {
        super(isU8a(value) || isHex(value)
            ? value.length === 0
                ? 0
                : u8aToFloat(u8aToU8a(value), { bitLength })
            : (value || 0));
        this.#bitLength = bitLength;
        this.encodedLength = bitLength / 8;
        this.initialU8aLength = this.encodedLength;
        this.registry = registry;
    }
    static with(bitLength) {
        return class extends Float {
            constructor(registry, value) {
                super(registry, value, { bitLength });
            }
        };
    }
    /**
     * @description returns a hash of the contents
     */
    get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Returns true if the type wraps an empty/default all-0 value
     */
    get isEmpty() {
        return this.valueOf() === 0;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        return this.valueOf() === Number(other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        return {
            outer: [this.toU8a()]
        };
    }
    /**
     * @description Returns a hex string representation of the value
     */
    toHex() {
        return u8aToHex(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman() {
        return this.toString();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        // Not sure if this is actually a hex or a string value
        // (would need to check against RPCs to see the result here)
        return this.toHex();
    }
    /**
     * @description Returns the number representation (Same as valueOf)
     */
    toNumber() {
        return this.valueOf();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive() {
        return this.toNumber();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return `f${this.#bitLength}`;
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     */
    toU8a(_isBare) {
        return floatToU8a(this, {
            bitLength: this.#bitLength
        });
    }
}

/** @internal */
function decodeJson(value) {
    return Object.entries(value || {});
}
/**
 * @name Json
 * @description
 * Wraps the a JSON structure retrieve via RPC. It extends the standard JS Map with. While it
 * implements a Codec, it is limited in that it can only be used with input objects via RPC,
 * i.e. no hex decoding. Unlike a struct, this waps a JSON object with unknown keys
 * @noInheritDoc
 */
class Json extends Map {
    registry;
    createdAtHash;
    initialU8aLength;
    isStorageFallback;
    constructor(registry, value) {
        const decoded = decodeJson(value);
        super(decoded);
        this.registry = registry;
        objectProperties(this, decoded.map(([k]) => k), (k) => this.get(k));
    }
    /**
     * @description Always 0, never encodes as a Uint8Array
     */
    get encodedLength() {
        return 0 | 0;
    }
    /**
     * @description returns a hash of the contents
     */
    get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value
     */
    get isEmpty() {
        return [...this.keys()].length === 0;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        return compareMap(this, other);
    }
    /**
     * @description Returns a typed value from the internal map
     */
    getT(key) {
        return this.get(key);
    }
    /**
     * @description Unimplemented, will throw
     */
    inspect() {
        throw new Error('Unimplemented');
    }
    /**
     * @description Unimplemented, will throw
     */
    toHex() {
        throw new Error('Unimplemented');
    }
    /**
     * @description Converts the Object to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman() {
        return [...this.entries()].reduce((json, [key, value]) => {
            json[key] = isFunction$1(value?.toHuman)
                ? value.toHuman()
                : value;
            return json;
        }, {});
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        return [...this.entries()].reduce((json, [key, value]) => {
            json[key] = value;
            return json;
        }, {});
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive(disableAscii) {
        return [...this.entries()].reduce((json, [key, value]) => {
            json[key] = isFunction$1(value.toPrimitive)
                ? value.toPrimitive(disableAscii)
                : value;
            return json;
        }, {});
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'Json';
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        return stringify(this.toJSON());
    }
    /**
     * @description Unimplemented, will throw
     */
    toU8a(_isBare) {
        throw new Error('Unimplemented');
    }
}

function encodeSet(setValues, values) {
    const encoded = new BN(0);
    for (let i = 0, count = values.length; i < count; i++) {
        encoded.ior(bnToBn(setValues[values[i]] || 0));
    }
    return encoded;
}
/** @internal */
function decodeSetArray(setValues, values) {
    const count = values.length;
    const result = new Array(count);
    for (let i = 0; i < count; i++) {
        const key = values[i];
        if (isUndefined(setValues[key])) {
            throw new Error(`Set: Invalid key '${key}' passed to Set, allowed ${Object.keys(setValues).join(', ')}`);
        }
        result[i] = key;
    }
    return result;
}
/** @internal */
function decodeSetNumber(setValues, _value) {
    const bn = bnToBn(_value);
    const keys = Object.keys(setValues);
    const result = [];
    for (let i = 0, count = keys.length; i < count; i++) {
        const key = keys[i];
        if (bn.and(bnToBn(setValues[key])).eq(bnToBn(setValues[key]))) {
            result.push(key);
        }
    }
    const computed = encodeSet(setValues, result);
    if (!bn.eq(computed)) {
        throw new Error(`Set: Mismatch decoding '${bn.toString()}', computed as '${computed.toString()}' with ${result.join(', ')}`);
    }
    return result;
}
/** @internal */
function decodeSet(setValues, value = 0, bitLength) {
    if (bitLength % 8 !== 0) {
        throw new Error(`Expected valid bitLength, power of 8, found ${bitLength}`);
    }
    const byteLength = bitLength / 8;
    if (isU8a(value)) {
        return value.length === 0
            ? []
            : decodeSetNumber(setValues, u8aToBn(value.subarray(0, byteLength), { isLe: true }));
    }
    else if (isString(value)) {
        return decodeSet(setValues, u8aToU8a(value), byteLength);
    }
    else if (value instanceof Set || Array.isArray(value)) {
        const input = Array.isArray(value)
            ? value
            : [...value.values()];
        return decodeSetArray(setValues, input);
    }
    return decodeSetNumber(setValues, value);
}
/**
 * @name Set
 * @description
 * An Set is an array of string values, represented an an encoded type by
 * a bitwise representation of the values.
 */
class CodecSet extends Set {
    registry;
    createdAtHash;
    initialU8aLength;
    isStorageFallback;
    #allowed;
    #byteLength;
    constructor(registry, setValues, value, bitLength = 8) {
        super(decodeSet(setValues, value, bitLength));
        this.registry = registry;
        this.#allowed = setValues;
        this.#byteLength = bitLength / 8;
    }
    static with(values, bitLength) {
        return class extends CodecSet {
            static {
                const keys = Object.keys(values);
                const count = keys.length;
                const isKeys = new Array(count);
                for (let i = 0; i < count; i++) {
                    isKeys[i] = `is${stringPascalCase(keys[i])}`;
                }
                objectProperties(this.prototype, isKeys, (_, i, self) => self.strings.includes(keys[i]));
            }
            constructor(registry, value) {
                super(registry, values, value, bitLength);
            }
        };
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        return this.#byteLength;
    }
    /**
     * @description returns a hash of the contents
     */
    get hash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description true is the Set contains no values
     */
    get isEmpty() {
        return this.size === 0;
    }
    /**
     * @description The actual set values as a string[]
     */
    get strings() {
        return [...super.values()];
    }
    /**
     * @description The encoded value for the set members
     */
    get valueEncoded() {
        return encodeSet(this.#allowed, this.strings);
    }
    /**
     * @description adds a value to the Set (extended to allow for validity checking)
     */
    add = (key) => {
        // ^^^ add = () property done to assign this instance's this, otherwise Set.add creates "some" chaos
        // we have the isUndefined(this._setValues) in here as well, add is used internally
        // in the Set constructor (so it is undefined at this point, and should allow)
        if (this.#allowed && isUndefined(this.#allowed[key])) {
            throw new Error(`Set: Invalid key '${key}' on add`);
        }
        super.add(key);
        return this;
    };
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        if (Array.isArray(other)) {
            // we don't actually care about the order, sort the values
            return compareArray(this.strings.sort(), other.sort());
        }
        else if (other instanceof Set) {
            return this.eq([...other.values()]);
        }
        else if (isNumber(other) || isBn(other)) {
            return this.valueEncoded.eq(bnToBn(other));
        }
        return false;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        return {
            outer: [this.toU8a()]
        };
    }
    /**
     * @description Returns a hex string representation of the value
     */
    toHex() {
        return u8aToHex(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman() {
        return this.toJSON();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        return this.strings;
    }
    /**
     * @description The encoded value for the set members
     */
    toNumber() {
        return this.valueEncoded.toNumber();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive() {
        return this.toJSON();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return stringify({ _set: this.#allowed });
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        return `[${this.strings.join(', ')}]`;
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     */
    toU8a(_isBare) {
        return bnToU8a(this.valueEncoded, {
            bitLength: this.#byteLength * 8,
            isLe: true
        });
    }
}

/**
 * @name f32
 * @description
 * A 32-bit float
 */
class f32 extends Float.with(32) {
    // NOTE without this, we cannot properly determine extensions
    __FloatType = 'f32';
}

/**
 * @name f64
 * @description
 * A 64-bit float
 */
class f64 extends Float.with(64) {
    // NOTE without this, we cannot properly determine extensions
    __FloatType = 'f64';
}

/**
 * @name i8
 * @description
 * An 8-bit signed integer
 */
class i8 extends Int.with(8) {
    // NOTE without this, we cannot properly determine extensions
    __IntType = 'i8';
}

/**
 * @name i16
 * @description
 * A 16-bit signed integer
 */
class i16 extends Int.with(16) {
    // NOTE without this, we cannot properly determine extensions
    __IntType = 'i16';
}

/**
 * @name i32
 * @description
 * A 32-bit signed integer
 */
class i32 extends Int.with(32) {
    // NOTE without this, we cannot properly determine extensions
    __IntType = 'i32';
}

/**
 * @name i64
 * @description
 * A 64-bit signed integer
 */
class i64 extends Int.with(64) {
    // NOTE without this, we cannot properly determine extensions
    __IntType = 'i64';
}

/**
 * @name i128
 * @description
 * A 128-bit signed integer
 */
class i128 extends Int.with(128) {
    // NOTE without this, we cannot properly determine extensions
    __IntType = 'i128';
}

/**
 * @name i256
 * @description
 * A 256-bit signed integer
 */
class i256 extends Int.with(256) {
    // NOTE without this, we cannot properly determine extensions
    __IntType = 'i256';
}

/**
 * @name ISize
 * @description
 * A System default signed number, typically used in RPC to report non-consensus
 * data. It is a wrapper for [[I32]] as a WASM default (as generated by Rust bindings).
 * It is not to be used, since it creates consensus mismatches.
 */
class isize extends i32 {
    constructor(registry, value) {
        super(registry, value);
        throw new Error('The `isize` type should not be used. Since it is platform-specific, it creates incompatibilities between native (generally i64) and WASM (always i32) code. Use one of the `i32` or `i64` types explicitly.');
    }
}

/**
 * @name u8
 * @description
 * An 8-bit unsigned integer
 */
class u8 extends UInt.with(8) {
    // NOTE without this, we cannot properly determine extensions
    __UIntType = 'u8';
}

/**
 * @name u16
 * @description
 * A 16-bit unsigned integer
 */
class u16 extends UInt.with(16) {
    // NOTE without this, we cannot properly determine extensions
    __UIntType = 'u16';
}

/**
 * @name u32
 * @description
 * A 32-bit unsigned integer
 */
class u32 extends UInt.with(32) {
    // NOTE without this, we cannot properly determine extensions
    __UIntType = 'u32';
}

/**
 * @name u64
 * @description
 * A 64-bit unsigned integer
 */
class u64 extends UInt.with(64) {
    // NOTE without this, we cannot properly determine extensions
    __UIntType = 'u64';
}

/**
 * @name u128
 * @description
 * A 128-bit unsigned integer
 */
class u128 extends UInt.with(128) {
    // NOTE without this, we cannot properly determine extensions
    __UIntType = 'u128';
}

/**
 * @name u256
 * @description
 * A 256-bit unsigned integer
 */
class u256 extends UInt.with(256) {
    // NOTE without this, we cannot properly determine extensions
    __UIntType = 'u256';
}

/**
 * @name USize
 * @description
 * A System default unsigned number, typically used in RPC to report non-consensus
 * data. It is a wrapper for [[U32]] as a WASM default (as generated by Rust bindings).
 * It is not to be used, since it created consensus mismatches.
 */
class usize extends u32 {
    constructor(registry, value) {
        super(registry, value);
        throw new Error('The `usize` type should not be used. Since it is platform-specific, it creates incompatibilities between native (generally u64) and WASM (always u32) code. Use one of the `u32` or `u64` types explicitly.');
    }
}

function typeSplit(type) {
    const result = [];
    // these are the depths of the various tokens: <, [, {, (
    let c = 0;
    let f = 0;
    let s = 0;
    let t = 0;
    // current start position
    let start = 0;
    for (let i = 0, count = type.length; i < count; i++) {
        switch (type[i]) {
            // if we are not nested, add the type
            case ',': {
                if (!(c || f || s || t)) {
                    result.push(type.substring(start, i).trim());
                    start = i + 1;
                }
                break;
            }
            // adjust compact/vec (and friends) depth
            case '<':
                c++;
                break;
            case '>':
                c--;
                break;
            // adjust fixed vec depths
            case '[':
                f++;
                break;
            case ']':
                f--;
                break;
            // adjust struct depth
            case '{':
                s++;
                break;
            case '}':
                s--;
                break;
            // adjust tuple depth
            case '(':
                t++;
                break;
            case ')':
                t--;
                break;
        }
    }
    // ensure we have all the terminators taken care of
    if (c || f || s || t) {
        throw new Error(`Invalid definition (missing terminators) found in ${type}`);
    }
    // the final leg of the journey
    result.push(type.substring(start, type.length).trim());
    return result;
}

const KNOWN_INTERNALS = ['_alias', '_fallback'];
function getTypeString(typeOrObj) {
    return isString(typeOrObj)
        ? typeOrObj.toString()
        : stringify(typeOrObj);
}
function isRustEnum(details) {
    const values = Object.values(details);
    if (values.some((v) => isNumber(v))) {
        if (!values.every((v) => isNumber(v) && v >= 0 && v <= 255)) {
            throw new Error('Invalid number-indexed enum definition');
        }
        return false;
    }
    return true;
}
function _decodeEnum(value, details, count, fallbackType) {
    value.info = TypeDefInfo.Enum;
    value.fallbackType = fallbackType;
    // not as pretty, but remain compatible with oo7 for both struct and Array types
    if (Array.isArray(details)) {
        value.sub = details.map((name, index) => ({
            index,
            info: TypeDefInfo.Plain,
            name,
            type: 'Null'
        }));
    }
    else if (isRustEnum(details)) {
        value.sub = Object.entries(details).map(([name, typeOrObj], index) => objectSpread({}, getTypeDef(getTypeString(typeOrObj || 'Null'), { name }, count), { index }));
    }
    else {
        value.sub = Object.entries(details).map(([name, index]) => ({
            index,
            info: TypeDefInfo.Plain,
            name,
            type: 'Null'
        }));
    }
    return value;
}
function _decodeSet(value, details, fallbackType) {
    value.info = TypeDefInfo.Set;
    value.fallbackType = fallbackType;
    value.length = details._bitLength;
    value.sub = Object
        .entries(details)
        .filter(([name]) => !name.startsWith('_'))
        .map(([name, index]) => ({
        index,
        info: TypeDefInfo.Plain,
        name,
        type: 'Null'
    }));
    return value;
}
function _decodeStruct(value, type, _, count) {
    const parsed = JSON.parse(type);
    const keys = Object.keys(parsed);
    if (parsed._enum) {
        return _decodeEnum(value, parsed._enum, count, parsed._fallback);
    }
    else if (parsed._set) {
        return _decodeSet(value, parsed._set, parsed._fallback);
    }
    value.alias = parsed._alias
        ? new Map(Object.entries(parsed._alias))
        : undefined;
    value.fallbackType = parsed._fallback;
    value.sub = keys
        .filter((name) => !KNOWN_INTERNALS.includes(name))
        .map((name) => getTypeDef(getTypeString(parsed[name]), { name }, count));
    return value;
}
function _decodeFixedVec(value, type, _, count) {
    const max = type.length - 1;
    let index = -1;
    let inner = 0;
    for (let i = 1; (i < max) && (index === -1); i++) {
        switch (type[i]) {
            case ';': {
                if (inner === 0) {
                    index = i;
                }
                break;
            }
            case '[':
            case '(':
            case '<':
                inner++;
                break;
            case ']':
            case ')':
            case '>':
                inner--;
                break;
        }
    }
    if (index === -1) {
        throw new Error(`${type}: Unable to extract location of ';'`);
    }
    const vecType = type.substring(1, index);
    const [strLength, displayName] = type.substring(index + 1, max).split(';');
    const length = parseInt(strLength.trim(), 10);
    if (length > 2048) {
        throw new Error(`${type}: Only support for [Type; <length>], where length <= 2048`);
    }
    value.displayName = displayName;
    value.length = length;
    value.sub = getTypeDef(vecType, {}, count);
    return value;
}
function _decodeTuple(value, _, subType, count) {
    value.sub = subType.length === 0
        ? []
        : typeSplit(subType).map((inner) => getTypeDef(inner, {}, count));
    return value;
}
function _decodeAnyInt(value, type, _, clazz) {
    const [strLength, displayName] = type.substring(clazz.length + 1, type.length - 1).split(',');
    const length = parseInt(strLength.trim(), 10);
    if ((length > 8192) || (length % 8)) {
        throw new Error(`${type}: Only support for ${clazz}<bitLength>, where length <= 8192 and a power of 8, found ${length}`);
    }
    value.displayName = displayName;
    value.length = length;
    return value;
}
function _decodeInt(value, type, subType) {
    return _decodeAnyInt(value, type, subType, 'Int');
}
function _decodeUInt(value, type, subType) {
    return _decodeAnyInt(value, type, subType, 'UInt');
}
function _decodeDoNotConstruct(value, type, _) {
    const NAME_LENGTH = 'DoNotConstruct'.length;
    value.displayName = type.substring(NAME_LENGTH + 1, type.length - 1);
    return value;
}
function hasWrapper(type, [start, end]) {
    return (type.startsWith(start)) && (type.slice(-1 * end.length) === end);
}
const nestedExtraction = [
    ['[', ']', TypeDefInfo.VecFixed, _decodeFixedVec],
    ['{', '}', TypeDefInfo.Struct, _decodeStruct],
    ['(', ')', TypeDefInfo.Tuple, _decodeTuple],
    // the inner for these are the same as tuple, multiple values
    ['BTreeMap<', '>', TypeDefInfo.BTreeMap, _decodeTuple],
    ['HashMap<', '>', TypeDefInfo.HashMap, _decodeTuple],
    ['Int<', '>', TypeDefInfo.Int, _decodeInt],
    ['Result<', '>', TypeDefInfo.Result, _decodeTuple],
    ['UInt<', '>', TypeDefInfo.UInt, _decodeUInt],
    ['DoNotConstruct<', '>', TypeDefInfo.DoNotConstruct, _decodeDoNotConstruct]
];
const wrappedExtraction = [
    ['BTreeSet<', '>', TypeDefInfo.BTreeSet],
    ['Compact<', '>', TypeDefInfo.Compact],
    ['Linkage<', '>', TypeDefInfo.Linkage],
    ['Opaque<', '>', TypeDefInfo.WrapperOpaque],
    ['Option<', '>', TypeDefInfo.Option],
    ['Range<', '>', TypeDefInfo.Range],
    ['RangeInclusive<', '>', TypeDefInfo.RangeInclusive],
    ['Vec<', '>', TypeDefInfo.Vec],
    ['WrapperKeepOpaque<', '>', TypeDefInfo.WrapperKeepOpaque],
    ['WrapperOpaque<', '>', TypeDefInfo.WrapperOpaque]
];
function extractSubType(type, [start, end]) {
    return type.substring(start.length, type.length - end.length);
}
function getTypeDef(_type, { displayName, name } = {}, count = 0) {
    // create the type via Type, allowing types to be sanitized
    const type = sanitize(_type);
    const value = { displayName, info: TypeDefInfo.Plain, name, type };
    if (++count > 64) {
        throw new Error('getTypeDef: Maximum nested limit reached');
    }
    const nested = nestedExtraction.find((nested) => hasWrapper(type, nested));
    if (nested) {
        value.info = nested[2];
        return nested[3](value, type, extractSubType(type, nested), count);
    }
    const wrapped = wrappedExtraction.find((wrapped) => hasWrapper(type, wrapped));
    if (wrapped) {
        value.info = wrapped[2];
        value.sub = getTypeDef(extractSubType(type, wrapped), {}, count);
    }
    return value;
}

function getTypeDefType({ lookupName, type }) {
    return lookupName || type;
}
function getSubDefArray(value) {
    if (!Array.isArray(value.sub)) {
        throw new Error(`Expected subtype as TypeDef[] in ${stringify(value)}`);
    }
    return value.sub;
}
function getSubDef(value) {
    if (!value.sub || Array.isArray(value.sub)) {
        throw new Error(`Expected subtype as TypeDef in ${stringify(value)}`);
    }
    return value.sub;
}
function getSubType(value) {
    return getTypeDefType(getSubDef(value));
}
function getTypeClassMap(value) {
    const subs = getSubDefArray(value);
    const map = {};
    for (let i = 0, count = subs.length; i < count; i++) {
        const sub = subs[i];
        if (!sub.name) {
            throw new Error(`No name found in definition ${stringify(sub)}`);
        }
        map[sub.name] = getTypeDefType(sub);
    }
    return map;
}
function getTypeClassArray(value) {
    return getSubDefArray(value).map(getTypeDefType);
}
function createInt(Clazz, { displayName, length }) {
    if (!isNumber(length)) {
        throw new Error(`Expected bitLength information for ${displayName || Clazz.constructor.name}<bitLength>`);
    }
    return Clazz.with(length, displayName);
}
function createHashMap(Clazz, value) {
    const [keyType, valueType] = getTypeClassArray(value);
    return Clazz.with(keyType, valueType);
}
function createWithSub(Clazz, value) {
    return Clazz.with(getSubType(value));
}
const infoMapping = {
    [TypeDefInfo.BTreeMap]: (_registry, value) => createHashMap(BTreeMap, value),
    [TypeDefInfo.BTreeSet]: (_registry, value) => createWithSub(BTreeSet, value),
    [TypeDefInfo.Compact]: (_registry, value) => createWithSub(Compact, value),
    [TypeDefInfo.DoNotConstruct]: (_registry, value) => DoNotConstruct.with(value.displayName || value.type),
    [TypeDefInfo.Enum]: (_registry, value) => {
        const subs = getSubDefArray(value);
        return Enum.with(subs.every(({ type }) => type === 'Null')
            ? subs.reduce((out, { index, name }, count) => {
                if (!name) {
                    throw new Error('No name found in sub definition');
                }
                out[name] = index || count;
                return out;
            }, {})
            : getTypeClassMap(value));
    },
    [TypeDefInfo.HashMap]: (_registry, value) => createHashMap(HashMap, value),
    [TypeDefInfo.Int]: (_registry, value) => createInt(Int, value),
    // We have circular deps between Linkage & Struct
    [TypeDefInfo.Linkage]: (_registry, value) => {
        const type = `Option<${getSubType(value)}>`;
        // eslint-disable-next-line sort-keys
        const Clazz = Struct.with({ previous: type, next: type });
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        Clazz.prototype.toRawType = function () {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
            return `Linkage<${this.next.toRawType(true)}>`;
        };
        return Clazz;
    },
    [TypeDefInfo.Null]: (_registry, _value) => Null,
    [TypeDefInfo.Option]: (_registry, value) => {
        if (!value.sub || Array.isArray(value.sub)) {
            throw new Error('Expected type information for Option');
        }
        // NOTE This is opt-in (unhandled), not by default
        // if (value.sub.type === 'bool') {
        //   return OptionBool;
        // }
        return createWithSub(Option, value);
    },
    [TypeDefInfo.Plain]: (registry, value) => registry.getOrUnknown(value.type),
    [TypeDefInfo.Range]: (_registry, value) => createWithSub(Range, value),
    [TypeDefInfo.RangeInclusive]: (_registry, value) => createWithSub(RangeInclusive, value),
    [TypeDefInfo.Result]: (_registry, value) => {
        const [Ok, Err] = getTypeClassArray(value);
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return Result.with({ Err, Ok });
    },
    [TypeDefInfo.Set]: (_registry, value) => CodecSet.with(getSubDefArray(value).reduce((result, { index, name }) => {
        if (!name || !isNumber(index)) {
            throw new Error('No name found in sub definition');
        }
        result[name] = index;
        return result;
    }, {}), value.length),
    [TypeDefInfo.Si]: (registry, value) => getTypeClass(registry, registry.lookup.getTypeDef(value.type)),
    [TypeDefInfo.Struct]: (_registry, value) => Struct.with(getTypeClassMap(value), value.alias),
    [TypeDefInfo.Tuple]: (_registry, value) => Tuple.with(getTypeClassArray(value)),
    [TypeDefInfo.UInt]: (_registry, value) => createInt(UInt, value),
    [TypeDefInfo.Vec]: (_registry, { sub }) => {
        if (!sub || Array.isArray(sub)) {
            throw new Error('Expected type information for vector');
        }
        return (sub.type === 'u8'
            ? Bytes
            : Vec.with(getTypeDefType(sub)));
    },
    [TypeDefInfo.VecFixed]: (_registry, { displayName, length, sub }) => {
        if (!isNumber(length) || !sub || Array.isArray(sub)) {
            throw new Error('Expected length & type information for fixed vector');
        }
        return (sub.type === 'u8'
            ? U8aFixed.with((length * 8), displayName)
            : VecFixed.with(getTypeDefType(sub), length));
    },
    [TypeDefInfo.WrapperKeepOpaque]: (_registry, value) => createWithSub(WrapperKeepOpaque, value),
    [TypeDefInfo.WrapperOpaque]: (_registry, value) => createWithSub(WrapperOpaque, value)
};
function constructTypeClass(registry, typeDef) {
    try {
        const Type = infoMapping[typeDef.info](registry, typeDef);
        if (!Type) {
            throw new Error('No class created');
        }
        // don't clobber any existing
        if (!Type.__fallbackType && typeDef.fallbackType) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore ...this is the only place we we actually assign this...
            Type.__fallbackType = typeDef.fallbackType;
        }
        return Type;
    }
    catch (error) {
        throw new Error(`Unable to construct class from ${stringify(typeDef)}: ${error.message}`);
    }
}
function getTypeClass(registry, typeDef) {
    return registry.getUnsafe(typeDef.type, false, typeDef);
}
function createClassUnsafe(registry, type) {
    return (
    // just retrieve via name, no creation via typeDef
    registry.getUnsafe(type) ||
        // we don't have an existing type, create the class via typeDef
        getTypeClass(registry, registry.isLookupType(type)
            ? registry.lookup.getTypeDef(type)
            : getTypeDef(type)));
}

function checkInstance(created, matcher) {
    const u8a = created.toU8a();
    const rawType = created.toRawType();
    const isOk = (
    // full match, all ok
    u8aEq(u8a, matcher) ||
        (
        // on a length-prefixed type, just check the actual length
        ['Bytes', 'Text', 'Type'].includes(rawType) &&
            matcher.length === created.length) ||
        (
        // when the created is empty and matcher is also empty, let it slide...
        created.isEmpty &&
            matcher.every((v) => !v)));
    if (!isOk) {
        throw new Error(`${rawType}:: Decoded input doesn't match input, received ${u8aToHex(matcher, 512)} (${matcher.length} bytes), created ${u8aToHex(u8a, 512)} (${u8a.length} bytes)`);
    }
}
function checkPedantic(created, [value]) {
    if (isU8a(value)) {
        checkInstance(created, value);
    }
    else if (isHex(value)) {
        checkInstance(created, u8aToU8a(value));
    }
}
function initType(registry, Type, params = [], { blockHash, isFallback, isOptional, isPedantic } = {}) {
    const created = new (isOptional
        ? Option.with(Type)
        : Type)(registry, ...params);
    isPedantic && checkPedantic(created, params);
    if (blockHash) {
        created.createdAtHash = createTypeUnsafe(registry, 'BlockHash', [blockHash]);
    }
    if (isFallback) {
        created.isStorageFallback = true;
    }
    return created;
}
function createTypeUnsafe(registry, type, params = [], options = {}) {
    let Clazz = null;
    let firstError = null;
    try {
        Clazz = createClassUnsafe(registry, type);
        return initType(registry, Clazz, params, options);
    }
    catch (error) {
        firstError = new Error(`createType(${type}):: ${error.message}`);
    }
    if (Clazz?.__fallbackType) {
        try {
            Clazz = createClassUnsafe(registry, Clazz.__fallbackType);
            return initType(registry, Clazz, params, options);
        }
        catch {
            // swallow, we will throw the first error again
        }
    }
    throw firstError;
}

const stringIdentity = (value) => value.toString();
const INFO_WRAP = ['BTreeMap', 'BTreeSet', 'Compact', 'HashMap', 'Option', 'Result', 'Vec'];
function paramsNotation(outer, inner, transform = stringIdentity) {
    return `${outer}${inner
        ? `<${(Array.isArray(inner) ? inner : [inner]).map(transform).join(', ')}>`
        : ''}`;
}
function encodeWithParams(registry, typeDef, outer) {
    const { info, sub } = typeDef;
    switch (info) {
        case TypeDefInfo.BTreeMap:
        case TypeDefInfo.BTreeSet:
        case TypeDefInfo.Compact:
        case TypeDefInfo.HashMap:
        case TypeDefInfo.Linkage:
        case TypeDefInfo.Option:
        case TypeDefInfo.Range:
        case TypeDefInfo.RangeInclusive:
        case TypeDefInfo.Result:
        case TypeDefInfo.Vec:
        case TypeDefInfo.WrapperKeepOpaque:
        case TypeDefInfo.WrapperOpaque:
            return paramsNotation(outer, sub, (p) => encodeTypeDef(registry, p));
    }
    throw new Error(`Unable to encode ${stringify(typeDef)} with params`);
}
function encodeSubTypes(registry, sub, asEnum, extra) {
    const names = sub.map(({ name }) => name);
    if (!names.every((n) => !!n)) {
        throw new Error(`Subtypes does not have consistent names, ${names.join(', ')}`);
    }
    const inner = objectSpread({}, extra);
    for (let i = 0, count = sub.length; i < count; i++) {
        const def = sub[i];
        if (!def.name) {
            throw new Error(`No name found in ${stringify(def)}`);
        }
        inner[def.name] = encodeTypeDef(registry, def);
    }
    return stringify(asEnum
        ? { _enum: inner }
        : inner);
}
const encoders = {
    [TypeDefInfo.BTreeMap]: (registry, typeDef) => encodeWithParams(registry, typeDef, 'BTreeMap'),
    [TypeDefInfo.BTreeSet]: (registry, typeDef) => encodeWithParams(registry, typeDef, 'BTreeSet'),
    [TypeDefInfo.Compact]: (registry, typeDef) => encodeWithParams(registry, typeDef, 'Compact'),
    [TypeDefInfo.DoNotConstruct]: (registry, { displayName, lookupIndex, lookupName }) => `DoNotConstruct<${lookupName || displayName || (isUndefined(lookupIndex) ? 'Unknown' : registry.createLookupType(lookupIndex))}>`,
    [TypeDefInfo.Enum]: (registry, { sub }) => {
        if (!Array.isArray(sub)) {
            throw new Error('Unable to encode Enum type');
        }
        // c-like enums have all Null entries
        // TODO We need to take the disciminant into account and auto-add empty entries
        return sub.every(({ type }) => type === 'Null')
            ? stringify({ _enum: sub.map(({ name }, index) => `${name || `Empty${index}`}`) })
            : encodeSubTypes(registry, sub, true);
    },
    [TypeDefInfo.HashMap]: (registry, typeDef) => encodeWithParams(registry, typeDef, 'HashMap'),
    [TypeDefInfo.Int]: (_registry, { length = 32 }) => `Int<${length}>`,
    [TypeDefInfo.Linkage]: (registry, typeDef) => encodeWithParams(registry, typeDef, 'Linkage'),
    [TypeDefInfo.Null]: (_registry, _typeDef) => 'Null',
    [TypeDefInfo.Option]: (registry, typeDef) => encodeWithParams(registry, typeDef, 'Option'),
    [TypeDefInfo.Plain]: (_registry, { displayName, type }) => displayName || type,
    [TypeDefInfo.Range]: (registry, typeDef) => encodeWithParams(registry, typeDef, 'Range'),
    [TypeDefInfo.RangeInclusive]: (registry, typeDef) => encodeWithParams(registry, typeDef, 'RangeInclusive'),
    [TypeDefInfo.Result]: (registry, typeDef) => encodeWithParams(registry, typeDef, 'Result'),
    [TypeDefInfo.Set]: (_registry, { length = 8, sub }) => {
        if (!Array.isArray(sub)) {
            throw new Error('Unable to encode Set type');
        }
        return stringify({
            _set: sub.reduce((all, { index, name }, count) => objectSpread(all, { [`${name || `Unknown${index || count}`}`]: index || count }), { _bitLength: length || 8 })
        });
    },
    [TypeDefInfo.Si]: (_registry, { lookupName, type }) => lookupName || type,
    [TypeDefInfo.Struct]: (registry, { alias, sub }) => {
        if (!Array.isArray(sub)) {
            throw new Error('Unable to encode Struct type');
        }
        return encodeSubTypes(registry, sub, false, alias
            ? {
                _alias: [...alias.entries()].reduce((all, [k, v]) => objectSpread(all, { [k]: v }), {})
            }
            : {});
    },
    [TypeDefInfo.Tuple]: (registry, { sub }) => {
        if (!Array.isArray(sub)) {
            throw new Error('Unable to encode Tuple type');
        }
        return `(${sub.map((type) => encodeTypeDef(registry, type)).join(',')})`;
    },
    [TypeDefInfo.UInt]: (_registry, { length = 32 }) => `UInt<${length}>`,
    [TypeDefInfo.Vec]: (registry, typeDef) => encodeWithParams(registry, typeDef, 'Vec'),
    [TypeDefInfo.VecFixed]: (_registry, { length, sub }) => {
        if (!isNumber(length) || !sub || Array.isArray(sub)) {
            throw new Error('Unable to encode VecFixed type');
        }
        return `[${sub.type};${length}]`;
    },
    [TypeDefInfo.WrapperKeepOpaque]: (registry, typeDef) => encodeWithParams(registry, typeDef, 'WrapperKeepOpaque'),
    [TypeDefInfo.WrapperOpaque]: (registry, typeDef) => encodeWithParams(registry, typeDef, 'WrapperOpaque')
};
function encodeType(registry, typeDef, withLookup = true) {
    return withLookup && typeDef.lookupName
        ? typeDef.lookupName
        : encoders[typeDef.info](registry, typeDef);
}
function encodeTypeDef(registry, typeDef) {
    // In the case of contracts we do have the unfortunate situation where the displayName would
    // refer to "Option" when it is an option. For these, string it out, only using when actually
    // not a top-level element to be used
    return (typeDef.displayName && !INFO_WRAP.some((i) => typeDef.displayName === i))
        ? typeDef.displayName
        : encodeType(registry, typeDef);
}
function withTypeString(registry, typeDef) {
    return objectSpread({}, typeDef, {
        type: encodeType(registry, typeDef, false)
    });
}

const XCM_MAPPINGS = ['AssetInstance', 'Fungibility', 'Junction', 'Junctions', 'MultiAsset', 'MultiAssetFilter', 'MultiLocation', 'Response', 'WildFungibility', 'WildMultiAsset', 'Xcm', 'XcmError'];
function mapXcmTypes(version) {
    return XCM_MAPPINGS.reduce((all, key) => objectSpread(all, { [key]: `${key}${version}` }), {});
}

const v0 = {
    FungibilityV0: 'FungibilityV1',
    WildFungibilityV0: 'WildFungibilityV1',
    AssetInstanceV0: {
        _enum: {
            Undefined: 'Null',
            Index8: 'u8',
            Index16: 'Compact<u16>',
            Index32: 'Compact<u32>',
            Index64: 'Compact<u64>',
            Index128: 'Compact<u128>',
            Array4: '[u8; 4]',
            Array8: '[u8; 8]',
            Array16: '[u8; 16]',
            Array32: '[u8; 32]',
            Blob: 'Vec<u8>'
        }
    },
    JunctionV0: {
        _enum: {
            Parent: 'Null',
            Parachain: 'Compact<u32>',
            AccountId32: {
                network: 'NetworkId',
                id: 'AccountId'
            },
            AccountIndex64: {
                network: 'NetworkId',
                index: 'Compact<u64>'
            },
            AccountKey20: {
                network: 'NetworkId',
                key: '[u8; 20]'
            },
            PalletInstance: 'u8',
            GeneralIndex: 'Compact<u128>',
            GeneralKey: 'Vec<u8>',
            OnlyChild: 'Null',
            Plurality: {
                id: 'BodyId',
                part: 'BodyPart'
            }
        }
    },
    MultiAssetV0: {
        _enum: {
            None: 'Null',
            All: 'Null',
            AllFungible: 'Null',
            AllNonFungible: 'Null',
            AllAbstractFungible: 'Vec<u8>',
            AllAbstractNonFungible: 'Vec<u8>',
            AllConcreteFungible: 'MultiLocationV0',
            AllConcreteNonFungible: 'MultiLocationV0',
            AbstractFungible: {
                id: 'Vec<u8>',
                instance: 'Compact<u128>'
            },
            AbstractNonFungible: {
                class: 'Vec<u8>',
                instance: 'AssetInstanceV0'
            },
            ConcreteFungible: {
                id: 'MultiLocationV0',
                amount: 'Compact<u128>'
            },
            ConcreteNonFungible: {
                class: 'MultiLocationV0',
                instance: 'AssetInstanceV0'
            }
        }
    },
    MultiLocationV0: {
        _enum: {
            Here: 'Null',
            X1: 'JunctionV0',
            X2: '(JunctionV0, JunctionV0)',
            X3: '(JunctionV0, JunctionV0, JunctionV0)',
            X4: '(JunctionV0, JunctionV0, JunctionV0, JunctionV0)',
            X5: '(JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0)',
            X6: '(JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0)',
            X7: '(JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0)',
            X8: '(JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0, JunctionV0)'
        }
    },
    OriginKindV0: {
        _enum: ['Native', 'SovereignAccount', 'Superuser', 'Xcm']
    },
    ResponseV0: {
        _enum: {
            Assets: 'Vec<MultiAssetV0>'
        }
    },
    XcmV0: {
        _enum: {
            WithdrawAsset: {
                assets: 'Vec<MultiAssetV0>',
                effects: 'Vec<XcmOrderV0>'
            },
            ReserveAssetDeposit: {
                assets: 'Vec<MultiAssetV0>',
                effects: 'Vec<XcmOrderV0>'
            },
            ReceiveTeleportedAsset: {
                assets: 'Vec<MultiAssetV0>',
                effects: 'Vec<XcmOrderV0>'
            },
            QueryResponse: {
                queryId: 'Compact<u64>',
                response: 'ResponseV0'
            },
            TransferAsset: {
                assets: 'Vec<MultiAssetV0>',
                dest: 'MultiLocationV0'
            },
            TransferReserveAsset: {
                assets: 'Vec<MultiAssetV0>',
                dest: 'MultiLocationV0',
                effects: 'Vec<XcmOrderV0>'
            },
            Transact: {
                originType: 'XcmOriginKind',
                requireWeightAtMost: 'u64',
                call: 'DoubleEncodedCall'
            },
            HrmpNewChannelOpenRequest: {
                sender: 'Compact<u32>',
                maxMessageSize: 'Compact<u32>',
                maxCapacity: 'Compact<u32>'
            },
            HrmpChannelAccepted: {
                recipient: 'Compact<u32>'
            },
            HrmpChannelClosing: {
                initiator: 'Compact<u32>',
                sender: 'Compact<u32>',
                recipient: 'Compact<u32>'
            },
            RelayedFrom: {
                who: 'MultiLocationV0',
                message: 'XcmV0'
            }
        }
    },
    XcmErrorV0: {
        _enum: {
            Undefined: 'Null',
            Overflow: 'Null',
            Unimplemented: 'Null',
            UnhandledXcmVersion: 'Null',
            UnhandledXcmMessage: 'Null',
            UnhandledEffect: 'Null',
            EscalationOfPrivilege: 'Null',
            UntrustedReserveLocation: 'Null',
            UntrustedTeleportLocation: 'Null',
            DestinationBufferOverflow: 'Null',
            SendFailed: 'Null',
            CannotReachDestination: '(MultiLocation, Xcm)',
            MultiLocationFull: 'Null',
            FailedToDecode: 'Null',
            BadOrigin: 'Null',
            ExceedsMaxMessageSize: 'Null',
            FailedToTransactAsset: 'Null',
            WeightLimitReached: 'Weight',
            Wildcard: 'Null',
            TooMuchWeightRequired: 'Null',
            NotHoldingFees: 'Null',
            WeightNotComputable: 'Null',
            Barrier: 'Null',
            NotWithdrawable: 'Null',
            LocationCannotHold: 'Null',
            TooExpensive: 'Null',
            AssetNotFound: 'Null',
            RecursionLimitReached: 'Null'
        }
    },
    XcmOrderV0: {
        _enum: {
            Null: 'Null',
            DepositAsset: {
                assets: 'Vec<MultiAssetV0>',
                dest: 'MultiLocationV0'
            },
            DepositReserveAsset: {
                assets: 'Vec<MultiAssetV0>',
                dest: 'MultiLocationV0',
                effects: 'Vec<XcmOrderV0>'
            },
            ExchangeAsset: {
                give: 'Vec<MultiAssetV0>',
                receive: 'Vec<MultiAssetV0>'
            },
            InitiateReserveWithdraw: {
                assets: 'Vec<MultiAssetV0>',
                reserve: 'MultiLocationV0',
                effects: 'Vec<XcmOrderV0>'
            },
            InitiateTeleport: {
                assets: 'Vec<MultiAssetV0>',
                dest: 'MultiLocationV0',
                effects: 'Vec<XcmOrderV0>'
            },
            QueryHolding: {
                queryId: 'Compact<u64>',
                dest: 'MultiLocationV0',
                assets: 'Vec<MultiAssetV0>'
            },
            BuyExecution: {
                fees: 'MultiAssetV0',
                weight: 'u64',
                debt: 'u64',
                haltOnError: 'bool',
                xcm: 'Vec<XcmV0>'
            }
        }
    }
};

const v1 = {
    AssetInstanceV1: {
        _enum: {
            Undefined: 'Null',
            Index: 'Compact<u128>',
            Array4: '[u8; 4]',
            Array8: '[u8; 8]',
            Array16: '[u8; 16]',
            Array32: '[u8; 32]',
            Blob: 'Bytes'
        }
    },
    FungibilityV1: {
        _enum: {
            Fungible: 'Compact<u128>',
            NonFungible: 'AssetInstanceV1'
        }
    },
    JunctionV1: {
        _enum: {
            Parachain: 'Compact<u32>',
            AccountId32: {
                network: 'NetworkId',
                id: 'AccountId'
            },
            AccountIndex64: {
                network: 'NetworkId',
                index: 'Compact<u64>'
            },
            AccountKey20: {
                network: 'NetworkId',
                key: '[u8; 20]'
            },
            PalletInstance: 'u8',
            GeneralIndex: 'Compact<u128>',
            GeneralKey: 'Vec<u8>',
            OnlyChild: 'Null',
            Plurality: {
                id: 'BodyId',
                part: 'BodyPart'
            }
        }
    },
    JunctionsV1: {
        _enum: {
            Here: 'Null',
            X1: 'JunctionV1',
            X2: '(JunctionV1, JunctionV1)',
            X3: '(JunctionV1, JunctionV1, JunctionV1)',
            X4: '(JunctionV1, JunctionV1, JunctionV1, JunctionV1)',
            X5: '(JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1)',
            X6: '(JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1)',
            X7: '(JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1)',
            X8: '(JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1, JunctionV1)'
        }
    },
    MultiAssetsV1: 'Vec<MultiAssetV1>',
    MultiAssetV1: {
        id: 'XcmAssetId',
        fungibility: 'FungibilityV1'
    },
    MultiAssetFilterV1: {
        _enum: {
            Definite: 'MultiAssetsV1',
            Wild: 'WildMultiAssetV1'
        }
    },
    MultiLocationV1: {
        parents: 'u8',
        interior: 'JunctionsV1'
    },
    OriginKindV1: 'OriginKindV0',
    ResponseV1: {
        _enum: {
            Assets: 'MultiAssetsV1'
        }
    },
    WildFungibilityV1: {
        _enum: ['Fungible', 'NonFungible']
    },
    WildMultiAssetV1: {
        _enum: {
            All: 'Null',
            AllOf: {
                id: 'XcmAssetId',
                fungibility: 'WildFungibilityV1'
            }
        }
    },
    XcmV1: {
        _enum: {
            WithdrawAsset: {
                assets: 'MultiAssetsV1',
                effects: 'Vec<XcmOrderV1>'
            },
            ReserveAssetDeposit: {
                assets: 'MultiAssetsV1',
                effects: 'Vec<XcmOrderV1>'
            },
            ReceiveTeleportedAsset: {
                assets: 'MultiAssetsV1',
                effects: 'Vec<XcmOrderV1>'
            },
            QueryResponse: {
                queryId: 'Compact<u64>',
                response: 'ResponseV1'
            },
            TransferAsset: {
                assets: 'MultiAssetsV1',
                dest: 'MultiLocationV1'
            },
            TransferReserveAsset: {
                assets: 'MultiAssetsV1',
                dest: 'MultiLocationV1',
                effects: 'Vec<XcmOrderV1>'
            },
            Transact: {
                originType: 'XcmOriginKind',
                requireWeightAtMost: 'u64',
                call: 'DoubleEncodedCall'
            },
            HrmpNewChannelOpenRequest: {
                sender: 'Compact<u32>',
                maxMessageSize: 'Compact<u32>',
                maxCapacity: 'Compact<u32>'
            },
            HrmpChannelAccepted: {
                recipient: 'Compact<u32>'
            },
            HrmpChannelClosing: {
                initiator: 'Compact<u32>',
                sender: 'Compact<u32>',
                recipient: 'Compact<u32>'
            },
            RelayedFrom: {
                who: 'MultiLocationV1',
                message: 'XcmV1'
            }
        }
    },
    XcmErrorV1: {
        _enum: {
            Undefined: 'Null',
            Overflow: 'Null',
            Unimplemented: 'Null',
            UnhandledXcmVersion: 'Null',
            UnhandledXcmMessage: 'Null',
            UnhandledEffect: 'Null',
            EscalationOfPrivilege: 'Null',
            UntrustedReserveLocation: 'Null',
            UntrustedTeleportLocation: 'Null',
            DestinationBufferOverflow: 'Null',
            SendFailed: 'Null',
            CannotReachDestination: '(MultiLocationV1, XcmV1)',
            MultiLocationFull: 'Null',
            FailedToDecode: 'Null',
            BadOrigin: 'Null',
            ExceedsMaxMessageSize: 'Null',
            FailedToTransactAsset: 'Null',
            WeightLimitReached: 'Weight',
            Wildcard: 'Null',
            TooMuchWeightRequired: 'Null',
            NotHoldingFees: 'Null',
            WeightNotComputable: 'Null',
            Barrier: 'Null',
            NotWithdrawable: 'Null',
            LocationCannotHold: 'Null',
            TooExpensive: 'Null',
            AssetNotFound: 'Null',
            DestinationUnsupported: 'Null',
            RecursionLimitReached: 'Null'
        }
    },
    XcmOrderV1: {
        _enum: {
            Noop: 'Null',
            DepositAsset: {
                assets: 'MultiAssetFilterV1',
                maxAssets: 'u32',
                beneficiary: 'MultiLocationV1'
            },
            DepositReserveAsset: {
                assets: 'MultiAssetFilterV1',
                maxAssets: 'u32',
                dest: 'MultiLocationV1',
                effects: 'Vec<XcmOrderV1>'
            },
            ExchangeAsset: {
                give: 'MultiAssetFilterV1',
                receive: 'MultiAssetsV1'
            },
            InitiateReserveWithdraw: {
                assets: 'MultiAssetFilterV1',
                reserve: 'MultiLocationV1',
                effects: 'Vec<XcmOrderV1>'
            },
            InitiateTeleport: {
                assets: 'MultiAssetFilterV1',
                dest: 'MultiLocationV1',
                effects: 'Vec<XcmOrderV1>'
            },
            QueryHolding: {
                queryId: 'Compact<u64>',
                dest: 'MultiLocationV1',
                assets: 'MultiAssetFilterV1'
            },
            BuyExecution: {
                fees: 'MultiAssetV1',
                weight: 'u64',
                debt: 'u64',
                haltOnError: 'bool',
                instructions: 'Vec<XcmV1>'
            }
        }
    }
};

const v2 = {
    AssetIdV2: {
        _enum: {
            Concrete: 'MultiLocationV2',
            Abstract: 'Bytes'
        }
    },
    AssetInstanceV2: {
        _enum: {
            Undefined: 'Null',
            Index: 'Compact<u128>',
            Array4: '[u8;4]',
            Array8: '[u8;8]',
            Array16: '[u8;16]',
            Array32: '[u8;32]',
            Blob: 'Bytes'
        }
    },
    BodyIdV2: {
        _enum: {
            Unit: 'Null',
            Named: 'Bytes',
            Index: 'Compact<u32>',
            Executive: 'Null',
            Technical: 'Null',
            Legislative: 'Null',
            Judicial: 'Null',
            Defense: 'Null',
            Administration: 'Null',
            Treasury: 'Null'
        }
    },
    BodyPartV2: {
        _enum: {
            Voice: 'Null',
            Members: {
                count: 'Compact<u32>'
            },
            Fraction: {
                nom: 'Compact<u32>',
                denom: 'Compact<u32>'
            },
            AtLeastProportion: {
                nom: 'Compact<u32>',
                denom: 'Compact<u32>'
            },
            MoreThanProportion: {
                nom: 'Compact<u32>',
                denom: 'Compact<u32>'
            }
        }
    },
    NetworkIdV2: {
        _enum: {
            Any: 'Null',
            Named: 'Bytes',
            Polkadot: 'Null',
            Kusama: 'Null'
        }
    },
    JunctionV2: {
        _enum: {
            Parachain: 'Compact<u32>',
            AccountId32: {
                network: 'NetworkIdV2',
                id: '[u8; 32]'
            },
            AccountIndex64: {
                network: 'NetworkIdV2',
                index: 'Compact<u64>'
            },
            AccountKey20: {
                network: 'NetworkIdV2',
                key: '[u8; 20]'
            },
            PalletInstance: 'u8',
            GeneralIndex: 'Compact<u128>',
            GeneralKey: 'Bytes',
            OnlyChild: 'Null',
            Plurality: {
                id: 'BodyIdV2',
                part: 'BodyPartV2'
            }
        }
    },
    JunctionsV2: {
        _enum: {
            Here: 'Null',
            X1: 'JunctionV2',
            X2: '(JunctionV2, JunctionV2)',
            X3: '(JunctionV2, JunctionV2, JunctionV2)',
            X4: '(JunctionV2, JunctionV2, JunctionV2, JunctionV2)',
            X5: '(JunctionV2, JunctionV2, JunctionV2, JunctionV2, JunctionV2)',
            X6: '(JunctionV2, JunctionV2, JunctionV2, JunctionV2, JunctionV2, JunctionV2)',
            X7: '(JunctionV2, JunctionV2, JunctionV2, JunctionV2, JunctionV2, JunctionV2, JunctionV2)',
            X8: '(JunctionV2, JunctionV2, JunctionV2, JunctionV2, JunctionV2, JunctionV2, JunctionV2, JunctionV2)'
        }
    },
    FungibilityV2: {
        _enum: {
            Fungible: 'Compact<u128>',
            NonFungible: 'AssetInstanceV2'
        }
    },
    InteriorMultiLocationV2: 'JunctionsV2',
    MultiAssetV2: {
        id: 'AssetIdV2',
        fun: 'FungibilityV2'
    },
    MultiAssetsV2: 'Vec<MultiAssetV2>',
    MultiAssetFilterV2: {
        _enum: {
            Definite: 'MultiAssetsV2',
            Wild: 'WildMultiAssetV2'
        }
    },
    MultiLocationV2: {
        parents: 'u8',
        interior: 'JunctionsV2'
    },
    OriginKindV2: {
        _enum: {
            Native: 'Null',
            SovereignAccount: 'Null',
            Superuser: 'Null',
            Xcm: 'Null'
        }
    },
    WildFungibilityV2: {
        _enum: {
            Fungible: 'Null',
            NonFungible: 'Null'
        }
    },
    ResponseV2: {
        _enum: {
            Null: 'Null',
            Assets: 'MultiAssetsV2',
            ExecutionResult: 'Option<(u32, XcmErrorV2)>',
            Version: 'u32'
        }
    },
    ResponseV2Error: '(u32, XcmErrorV2)',
    WeightLimitV2: {
        _enum: {
            Unlimited: 'Null',
            Limited: 'Compact<u64>'
        }
    },
    InstructionV2: {
        _enum: {
            WithdrawAsset: 'MultiAssetsV2',
            ReserveAssetDeposited: 'MultiAssetsV2',
            ReceiveTeleportedAsset: 'MultiAssetsV2',
            QueryResponse: {
                queryId: 'Compact<u64>',
                response: 'ResponseV2',
                maxWeight: 'Compact<u64>'
            },
            TransferAsset: {
                assets: 'MultiAssetsV2',
                beneficiary: 'MultiLocationV2'
            },
            TransferReserveAsset: {
                assets: 'MultiAssetsV2',
                dest: 'MultiLocationV2',
                xcm: 'XcmV2'
            },
            Transact: {
                originType: 'XcmOriginKind',
                requireWeightAtMost: 'Compact<u64>',
                call: 'DoubleEncodedCall'
            },
            HrmpNewChannelOpenRequest: {
                sender: 'Compact<u32>',
                maxMessageSize: 'Compact<u32>',
                maxCapacity: 'Compact<u32>'
            },
            HrmpChannelAccepted: {
                recipient: 'Compact<u32>'
            },
            HrmpChannelClosing: {
                initiator: 'Compact<u32>',
                sender: 'Compact<u32>',
                recipient: 'Compact<u32>'
            },
            ClearOrigin: 'Null',
            DescendOrigin: 'InteriorMultiLocationV2',
            ReportError: {
                queryId: 'Compact<u64>',
                dest: 'MultiLocationV2',
                maxResponseWeight: 'Compact<u64>'
            },
            DepositAsset: {
                assets: 'MultiAssetFilterV2',
                maxAssets: 'Compact<u32>',
                beneficiary: 'MultiLocationV2'
            },
            DepositReserveAsset: {
                assets: 'MultiAssetFilterV2',
                maxAssets: 'Compact<u32>',
                dest: 'MultiLocationV2',
                xcm: 'XcmV2'
            },
            ExchangeAsset: {
                give: 'MultiAssetFilterV2',
                receive: 'MultiAssetsV2'
            },
            InitiateReserveWithdraw: {
                assets: 'MultiAssetFilterV2',
                reserve: 'MultiLocationV2',
                xcm: 'XcmV2'
            },
            InitiateTeleport: {
                assets: 'MultiAssetFilterV2',
                dest: 'MultiLocationV2',
                xcm: 'XcmV2'
            },
            QueryHolding: {
                queryId: 'Compact<u64>',
                dest: 'MultiLocationV2',
                assets: 'MultiAssetFilterV2',
                maxResponseWeight: 'Compact<u64>'
            },
            BuyExecution: {
                fees: 'MultiAssetV2',
                weightLimit: 'WeightLimitV2'
            },
            RefundSurplus: 'Null',
            SetErrorHandler: 'XcmV2<RuntimeCall>',
            SetAppendix: 'XcmV2<RuntimeCall>',
            ClearError: 'Null',
            ClaimAsset: {
                assets: 'MultiAssetsV2',
                ticket: 'MultiLocationV2'
            },
            Trap: 'Compact<u64>',
            SubscribeVersion: {
                queryId: 'Compact<u64>',
                maxResponseWeight: 'Compact<u64>'
            },
            UnsubscribeVersion: 'Null'
        }
    },
    WildMultiAssetV2: {
        _enum: {
            All: 'Null',
            AllOf: {
                id: 'AssetIdV2',
                fun: 'WildFungibilityV2'
            }
        }
    },
    XcmV2: 'Vec<InstructionV2>',
    XcmErrorV2: {
        _enum: {
            Overflow: 'Null',
            Unimplemented: 'Null',
            UntrustedReserveLocation: 'Null',
            UntrustedTeleportLocation: 'Null',
            MultiLocationFull: 'Null',
            MultiLocationNotInvertible: 'Null',
            BadOrigin: 'Null',
            InvalidLocation: 'Null',
            AssetNotFound: 'Null',
            FailedToTransactAsset: 'Null',
            NotWithdrawable: 'Null',
            LocationCannotHold: 'Null',
            ExceedsMaxMessageSize: 'Null',
            DestinationUnsupported: 'Null',
            Transport: 'Null',
            Unroutable: 'Null',
            UnknownClaim: 'Null',
            FailedToDecode: 'Null',
            MaxWeightInvalid: 'Null',
            NotHoldingFees: 'Null',
            TooExpensive: 'Null',
            Trap: 'u64',
            UnhandledXcmVersion: 'Null',
            WeightLimitReached: 'Weight',
            Barrier: 'Null',
            WeightNotComputable: 'Null'
        }
    }
};

const v3 = {
    AssetIdV3: {
        _enum: {
            Concrete: 'MultiLocationV3',
            Abstract: 'Bytes'
        }
    },
    BodyIdV3: {
        _enum: {
            Unit: 'Null',
            Moniker: '[u8;4]',
            Index: 'Compact<u32>',
            Executive: 'Null',
            Technical: 'Null',
            Legislative: 'Null',
            Judicial: 'Null',
            Defense: 'Null',
            Administration: 'Null',
            Treasury: 'Null'
        }
    },
    BodyPartV3: {
        _enum: {
            Voice: 'Null',
            Members: {
                count: 'Compact<u32>'
            },
            Fraction: {
                nom: 'Compact<u32>',
                denom: 'Compact<u32>'
            },
            AtLeastProportion: {
                nom: 'Compact<u32>',
                denom: 'Compact<u32>'
            },
            MoreThanProportion: {
                nom: 'Compact<u32>',
                denom: 'Compact<u32>'
            }
        }
    },
    AssetInstanceV3: {
        _enum: {
            Undefined: 'Null',
            Index: 'Compact<u128>',
            Array4: '[u8;4]',
            Array8: '[u8;8]',
            Array16: '[u8;16]',
            Array32: '[u8;32]'
        }
    },
    FungibilityV3: {
        _enum: {
            Fungible: 'Compact<u128>',
            NonFungible: 'AssetInstanceV3'
        }
    },
    InteriorMultiLocationV3: 'JunctionsV3',
    JunctionV3: {
        _enum: {
            Parachain: 'Compact<u32>',
            AccountId32: {
                network: 'Option<NetworkIdV3>',
                id: '[u8;32]'
            },
            AccountIndex64: {
                network: 'Option<NetworkIdV3>',
                index: 'Compact<u64>'
            },
            AccountKey20: {
                network: 'Option<NetworkIdV3>',
                key: '[u8;20]'
            },
            PalletInstance: 'u8',
            GeneralIndex: 'Compact<u128>',
            GeneralKey: {
                length: 'u8',
                data: '[u8;32]'
            },
            OnlyChild: 'Null',
            Plurality: {
                id: 'BodyIdV3',
                part: 'BodyPartV3'
            },
            GlobalConsensus: 'NetworkIdV3'
        }
    },
    JunctionsV3: {
        _enum: {
            Here: 'Null',
            X1: 'JunctionV3',
            X2: '(JunctionV3, JunctionV3)',
            X3: '(JunctionV3, JunctionV3, JunctionV3)',
            X4: '(JunctionV3, JunctionV3, JunctionV3, JunctionV3)',
            X5: '(JunctionV3, JunctionV3, JunctionV3, JunctionV3, JunctionV3)',
            X6: '(JunctionV3, JunctionV3, JunctionV3, JunctionV3, JunctionV3, JunctionV3)',
            X7: '(JunctionV3, JunctionV3, JunctionV3, JunctionV3, JunctionV3, JunctionV3, JunctionV3)',
            X8: '(JunctionV3, JunctionV3, JunctionV3, JunctionV3, JunctionV3, JunctionV3, JunctionV3, JunctionV3)'
        }
    },
    MaybeErrorCodeV3: {
        _enum: {
            Success: 'Null',
            Error: 'Bytes',
            TruncatedError: 'Bytes'
        }
    },
    MaxPalletsInfo: 'u32',
    MultiAssetV3: {
        id: 'AssetIdV3',
        fun: 'FungibilityV3'
    },
    MultiAssetsV3: 'Vec<MultiAssetV3>',
    MultiAssetFilterV3: {
        _enum: {
            Definite: 'MultiAssetsV3',
            Wild: 'WildMultiAssetV3'
        }
    },
    MultiLocationV3: {
        parents: 'u8',
        interior: 'JunctionsV3'
    },
    MaxPalletNameLen: 'u32',
    NetworkIdV3: {
        _enum: {
            ByGenesis: '[u8;32]',
            ByFork: {
                blockNumber: 'u64',
                blockHash: '[u8;32]'
            },
            Polkadot: 'Null',
            Kusama: 'Null',
            Westend: 'Null',
            Rococo: 'Null',
            Wococo: 'Null',
            Ethereum: {
                chainId: 'Compact<u64>'
            },
            BitcoinCore: 'Null',
            BitcoinCash: 'Null',
            PolkadotBulletin: 'Null'
        }
    },
    OriginKindV3: 'OriginKindV2',
    PalletInfoV3: {
        index: 'Compact<u32>',
        name: 'Bytes',
        moduleName: 'Bytes',
        major: 'Compact<u32>',
        minor: 'Compact<u32>',
        patch: 'Compact<u32>'
    },
    WildFungibilityV3: 'WildFungibilityV2',
    QueryResponseInfoV3: {
        destination: 'MultiLocationV3',
        queryId: 'Compact<u64>',
        maxWeight: 'WeightV2'
    },
    ResponseV3: {
        _enum: {
            Null: 'Null',
            Assets: 'MultiAssetsV3',
            ExecutionResult: 'Option<(u32,XcmErrorV3)>',
            Version: 'u32',
            PalletsInfo: 'Vec<PalletInfoV3>',
            DispatchResult: 'MaybeErrorCodeV3'
        }
    },
    XcmErrorV3: {
        _enum: {
            Overflow: 'Null',
            Unimplemented: 'Null',
            UntrustedReserveLocation: 'Null',
            UntrustedTeleportLocation: 'Null',
            LocationFull: 'Null',
            LocationNotInvertible: 'Null',
            BadOrigin: 'Null',
            InvalidLocation: 'Null',
            AssetNotFound: 'Null',
            FailedToTransactAsset: 'Null',
            NotWithdrawable: 'Null',
            LocationCannotHold: 'Null',
            ExceedsMaxMessageSize: 'Null',
            DestinationUnsupported: 'Null',
            Transport: 'Null',
            Unroutable: 'Null',
            UnknownClaim: 'Null',
            FailedToDecode: 'Null',
            MaxWeightInvalid: 'Null',
            NotHoldingFees: 'Null',
            TooExpensive: 'Null',
            Trap: 'u64',
            ExpectationFalse: 'Null',
            PalletNotFound: 'Null',
            NameMismatch: 'Null',
            VersionIncompatible: 'Null',
            HoldingWouldOverflow: 'Null',
            ExportError: 'Null',
            ReanchorFailed: 'Null',
            NoDeal: 'Null',
            FeesNotMet: 'Null',
            LockError: 'Null',
            NoPermission: 'Null',
            Unanchored: 'Null',
            NotDepositable: 'Null',
            UnhandledXcmVersion: 'Null',
            WeightLimitReached: 'WeightV2',
            Barrier: 'Null',
            ExceedsStackLimit: 'Null'
        }
    },
    ResponseV3Error: '(u32, XcmErrorV3)',
    ResponseV3Result: 'Option<(u32, ResponseV3Error)>',
    WeightLimitV3: {
        _enum: {
            Unlimited: 'Null',
            Limited: 'WeightV2'
        }
    },
    InstructionV3: {
        _enum: {
            WithdrawAsset: 'MultiAssetsV3',
            ReserveAssetDeposited: 'MultiAssetsV3',
            ReceiveTeleportedAsset: 'MultiAssetsV3',
            QueryResponse: {
                queryId: 'Compact<u64>',
                response: 'ResponseV3',
                maxWeight: 'WeightV2',
                querier: 'Option<MultiLocationV3>'
            },
            TransferAsset: {
                assets: 'MultiAssetsV3',
                beneficiary: 'MultiLocationV3'
            },
            TransferReserveAsset: {
                assets: 'MultiAssetsV3',
                dest: 'MultiLocationV3',
                xcm: 'XcmV3'
            },
            Transact: {
                originKind: 'XcmOriginKind',
                requireWeightAtMost: 'WeightV2',
                call: 'DoubleEncodedCall'
            },
            HrmpNewChannelOpenRequest: {
                sender: 'Compact<u32>',
                maxMessageSize: 'Compact<u32>',
                maxCapacity: 'Compact<u32>'
            },
            HrmpChannelAccepted: {
                recipient: 'Compact<u32>'
            },
            HrmpChannelClosing: {
                initiator: 'Compact<u32>',
                sender: 'Compact<u32>',
                recipient: 'Compact<u32>'
            },
            ClearOrigin: 'Null',
            DescendOrigin: 'JunctionsV3',
            ReportError: 'QueryResponseInfoV3',
            DepositAsset: {
                assets: 'MultiAssetFilterV3',
                beneficiary: 'MultiLocationV3'
            },
            DepositReserveAsset: {
                assets: 'MultiAssetFilterV3',
                dest: 'MultiLocationV3',
                xcm: 'XcmV3'
            },
            ExchangeAsset: {
                give: 'MultiAssetFilterV3',
                want: 'MultiAssetsV3',
                maximal: 'bool'
            },
            InitiateReserveWithdraw: {
                assets: 'MultiAssetFilterV3',
                reserve: 'MultiLocationV3',
                xcm: 'XcmV3'
            },
            InitiateTeleport: {
                assets: 'MultiAssetFilterV3',
                dest: 'MultiLocationV3',
                xcm: 'XcmV3'
            },
            ReportHolding: {
                responseInfo: 'QueryResponseInfoV3',
                assets: 'MultiAssetFilterV3'
            },
            BuyExecution: {
                fees: 'MultiAssetV3',
                weightLimit: 'WeightLimitV3'
            },
            RefundSurplus: 'Null',
            SetErrorHandler: 'XcmV3<RuntimeCall>',
            SetAppendix: 'XcmV3<RuntimeCall>',
            ClearError: 'Null',
            ClaimAsset: {
                assets: 'MultiAssetsV3',
                ticket: 'MultiLocationV3'
            },
            Trap: 'Compact<u64>',
            SubscribeVersion: {
                queryId: 'Compact<u64>',
                maxResponseWeight: 'WeightV2'
            },
            UnsubscribeVersion: 'Null',
            BurnAsset: 'MultiAssetsV3',
            ExpectAsset: 'MultiAssetsV3',
            ExpectOrigin: 'Option<MultiLocationV3>',
            ExpectError: 'Option<(u32, XcmErrorV3)>',
            ExpectTransactStatus: 'MaybeErrorCodeV3',
            QueryPallet: {
                moduleName: 'Vec<u8>',
                responseInfo: 'QueryResponseInfoV3'
            },
            ExpectPallet: {
                index: 'Compact<u32>',
                name: 'Vec<u8>',
                moduleName: 'Vec<u8>',
                crateMajor: 'Compact<u32>',
                minCrateMinor: 'Compact<u32>'
            },
            ReportTransactStatus: 'QueryResponseInfoV3',
            ClearTransactStatus: 'Null',
            UniversalOrigin: 'JunctionV3',
            ExportMessage: {
                network: 'NetworkIdV3',
                destination: 'JunctionsV3',
                xcm: 'XcmV3'
            },
            LockAsset: {
                asset: 'MultiAssetV3',
                unlocker: 'MultiLocationV3'
            },
            UnlockAsset: {
                asset: 'MultiAssetV3',
                target: 'MultiLocationV3'
            },
            NoteUnlockable: {
                asset: 'MultiAssetV3',
                owner: 'MultiLocationV3'
            },
            RequestUnlock: {
                asset: 'MultiAssetV3',
                locker: 'MultiLocationV3'
            },
            SetFeesMode: {
                jitWithdraw: 'bool'
            },
            SetTopic: '[u8; 32]',
            ClearTopic: 'Null',
            AliasOrigin: 'MultiLocationV3',
            UnpaidExecution: {
                weightLimit: 'WeightLimitV3',
                checkOrigin: 'Option<MultiLocationV3>'
            }
        }
    },
    WildMultiAssetV3: {
        _enum: {
            All: 'Null',
            AllOf: {
                id: 'AssetIdV3',
                fun: 'WildFungibilityV2'
            },
            AllCounted: 'Compact<u32>',
            AllOfCounted: {
                id: 'AssetIdV3',
                fun: 'WildFungibilityV2',
                count: 'Compact<u32>'
            }
        }
    },
    VersionV3: 'u32',
    XcmV3: 'Vec<InstructionV3>'
};

const v4 = {
    AssetIdV4: 'MultiLocationV4',
    AssetInstanceV4: {
        _enum: {
            Undefined: 'Null',
            Index: 'Compact<u128>',
            Array4: '[u8;4]',
            Array8: '[u8;8]',
            Array16: '[u8;16]',
            Array32: '[u8;32]'
        }
    },
    FungibilityV4: {
        _enum: {
            Fungible: 'Compact<u128>',
            NonFungible: 'AssetInstanceV4'
        }
    },
    UncheckedFungibilityV4: {
        _enum: {
            Fungible: 'Compact<u128>',
            NonFungible: 'AssetInstanceV4'
        }
    },
    JunctionV4: {
        _enum: {
            Parachain: 'Compact<u32>',
            AccountId32: {
                network: 'Option<NetworkIdV4>',
                id: '[u8;32]'
            },
            AccountIndex64: {
                network: 'Option<NetworkIdV4>',
                index: 'Compact<u64>'
            },
            AccountKey20: {
                network: 'Option<NetworkIdV4>',
                key: '[u8;20]'
            },
            PalletInstance: 'u8',
            GeneralIndex: 'Compact<u128>',
            GeneralKey: {
                length: 'u8',
                data: '[u8;32]'
            },
            OnlyChild: 'Null',
            Plurality: {
                id: 'BodyIdV3',
                part: 'BodyPartV3'
            },
            GlobalConsensus: 'NetworkIdV4'
        }
    },
    JunctionsV4: {
        _enum: {
            Here: 'Null',
            X1: '[JunctionV4;1]',
            X2: '[JunctionV4;2]',
            X3: '[JunctionV4;3]',
            X4: '[JunctionV4;4]',
            X5: '[JunctionV4;5]',
            X6: '[JunctionV4;6]',
            X7: '[JunctionV4;7]',
            X8: '[JunctionV4;8]'
        }
    },
    MaxPalletsInfo: 'u32',
    NetworkIdV4: 'NetworkIdV3',
    MultiAssetV4: {
        id: 'AssetIdV4',
        fun: 'FungibilityV4'
    },
    MultiAssetsV4: 'Vec<MultiAssetV4>',
    MultiAssetFilterV4: {
        _enum: {
            Definite: 'MultiAssetsV4',
            Wild: 'WildMultiAssetV4'
        }
    },
    MultiLocationV4: {
        parents: 'u8',
        interior: 'JunctionsV4'
    },
    OriginKindV4: 'XcmOriginKind',
    PalletInfoV4: 'PalletInfoV3',
    WildFungibilityV4: 'WildFungibilityV2',
    QueryResponseInfoV4: {
        destination: 'MultiLocationV4',
        queryId: 'Compact<u64>',
        maxWeight: 'WeightV2'
    },
    ResponseV4: {
        _enum: {
            Null: 'Null',
            Assets: 'MultiAssetsV4',
            ExecutionResult: 'Option<(u32, XcmErrorV3)>',
            Version: 'u32',
            PalletsInfo: 'Vec<PalletInfoV4>',
            DispatchResult: 'MaybeErrorCodeV3'
        }
    },
    InstructionV4: {
        _enum: {
            WithdrawAsset: 'MultiAssetsV4',
            ReserveAssetDeposited: 'MultiAssetsV4',
            ReceiveTeleportedAsset: 'MultiAssetsV4',
            QueryResponse: {
                queryId: 'Compact<u64>',
                response: 'ResponseV4',
                maxWeight: 'WeightV2',
                querier: 'Option<MultiLocationV4>'
            },
            TransferAsset: {
                assets: 'MultiAssetsV4',
                beneficiary: 'MultiLocationV4'
            },
            TransferReserveAsset: {
                assets: 'MultiAssetsV4',
                dest: 'MultiLocationV4',
                xcm: 'XcmV4'
            },
            Transact: {
                originKind: 'OriginKindV4',
                requireWeightAtMost: 'WeightV2',
                call: 'DoubleEncodedCall'
            },
            HrmpNewChannelOpenRequest: {
                sender: 'Compact<u32>',
                maxMessageSize: 'Compact<u32>',
                maxCapacity: 'Compact<u32>'
            },
            HrmpChannelAccepted: {
                recipient: 'Compact<u32>'
            },
            HrmpChannelClosing: {
                initiator: 'Compact<u32>',
                sender: 'Compact<u32>',
                recipient: 'Compact<u32>'
            },
            ClearOrigin: 'Null',
            DescendOrigin: 'JunctionsV4',
            ReportError: 'QueryResponseInfoV4',
            DepositAsset: {
                assets: 'MultiAssetFilterV4',
                beneficiary: 'MultiLocationV4'
            },
            DepositReserveAsset: {
                assets: 'MultiAssetFilterV4',
                dest: 'MultiLocationV4',
                xcm: 'XcmV4'
            },
            ExchangeAsset: {
                give: 'MultiAssetFilterV4',
                want: 'MultiAssetsV4',
                maximal: 'bool'
            },
            InitiateReserveWithdraw: {
                assets: 'MultiAssetFilterV4',
                reserve: 'MultiLocationV4',
                xcm: 'XcmV4'
            },
            InitiateTeleport: {
                assets: 'MultiAssetFilterV4',
                dest: 'MultiLocationV4',
                xcm: 'XcmV4'
            },
            ReportHolding: {
                responseInfo: 'QueryResponseInfoV4',
                assets: 'MultiAssetFilterV4'
            },
            BuyExecution: {
                fees: 'MultiAssetV4',
                weightLimit: 'WeightLimitV3'
            },
            RefundSurplus: 'Null',
            SetErrorHandler: 'XcmV4',
            SetAppendix: 'XcmV4',
            ClearError: 'Null',
            ClaimAsset: {
                assets: 'MultiAssetsV4',
                ticket: 'MultiLocationV4'
            },
            Trap: 'Compact<u64>',
            SubscribeVersion: {
                queryId: 'Compact<u64>',
                maxResponseWeight: 'WeightV2'
            },
            UnsubscribeVersion: 'Null',
            BurnAsset: 'MultiAssetsV4',
            ExpectAsset: 'MultiAssetsV4',
            ExpectOrigin: 'Option<MultiLocationV4>',
            ExpectError: 'Option<(u32, XcmErrorV3)>',
            ExpectTransactStatus: 'MaybeErrorCodeV3',
            QueryPallet: {
                moduleName: 'Vec<u8>',
                responseInfo: 'QueryResponseInfoV4'
            },
            ExpectPallet: {
                index: 'Compact<u32>',
                name: 'Vec<u8>',
                moduleName: 'Vec<u8>',
                crateMajor: 'Compact<u32>',
                minCrateMinor: 'Compact<u32>'
            },
            ReportTransactStatus: 'QueryResponseInfoV4',
            ClearTransactStatus: 'Null',
            UniversalOrigin: 'JunctionV4',
            ExportMessage: {
                network: 'NetworkIdV4',
                destination: 'JunctionsV4',
                xcm: 'XcmV4'
            },
            LockAsset: {
                asset: 'MultiAssetV4',
                unlocker: 'MultiLocationV4'
            },
            UnlockAsset: {
                asset: 'MultiAssetV4',
                target: 'MultiLocationV4'
            },
            NoteUnlockable: {
                asset: 'MultiAssetV4',
                owner: 'MultiLocationV4'
            },
            RequestUnlock: {
                asset: 'MultiAssetV4',
                locker: 'MultiLocationV4'
            },
            SetFeesMode: {
                jitWithdraw: 'bool'
            },
            SetTopic: '[u8;32]',
            ClearTopic: 'Null',
            AliasOrigin: 'MultiLocationV4',
            UnpaidExecution: {
                weightLimit: 'WeightLimitV3',
                checkOrigin: 'Option<MultiLocationV4>'
            }
        }
    },
    OutcomeV4: {
        _enum: {
            Complete: {
                used: 'WeightV2'
            },
            Incomplete: {
                used: 'WeightV2',
                error: 'XcmErrorV3'
            },
            Error: {
                error: 'XcmErrorV3'
            }
        }
    },
    WildMultiAssetV4: {
        _enum: {
            All: 'Null',
            AllOf: {
                id: 'AssetIdV4',
                fun: 'WildFungibilityV4'
            },
            AllCounted: 'Compact<u32>',
            AllOfCounted: {
                id: 'AssetIdV4',
                fun: 'WildFungibilityV4',
                count: 'Compact<u32>'
            }
        }
    },
    VersionV4: 'u32',
    XcmV4: 'Vec<InstructionV4>',
    XcmErrorV4: 'XcmErrorV3'
};

const v5 = {
    AssetIdV5: 'MultiLocationV5',
    AssetInstanceV5: {
        _enum: {
            Undefined: 'Null',
            Index: 'Compact<u128>',
            Array4: '[u8;4]',
            Array8: '[u8;8]',
            Array16: '[u8;16]',
            Array32: '[u8;32]'
        }
    },
    // Maps to xcmV5::Asset but we keep the prefix 'Multi'
    // to keep consistency with the rest of the code base.
    MultiAssetV5: {
        id: 'AssetIdV5',
        fun: 'FungibilityV5'
    },
    MultiAssetsV5: 'Vec<MultiAssetV5>',
    WildMultiAssetV5: {
        _enum: {
            All: 'Null',
            AllOf: {
                id: 'AssetIdV5',
                fun: 'WildFungibilityV5'
            },
            AllCounted: 'Compact<u32>',
            AllOfCounted: {
                id: 'AssetIdV5',
                fun: 'WildFungibilityV5',
                count: 'Compact<u32>'
            }
        }
    },
    MultiAssetFilterV5: {
        _enum: {
            Definite: 'MultiAssetsV5',
            Wild: 'WildMultiAssetV5'
        }
    },
    MultiAssetTransferFilterV5: {
        _enum: {
            Teleport: 'MultiAssetFilterV5',
            ReserveDeposit: 'MultiAssetFilterV5',
            ReserveWithdraw: 'MultiAssetFilterV5'
        }
    },
    FungibilityV5: {
        _enum: {
            Fungible: 'Compact<u128>',
            NonFungible: 'AssetInstanceV5'
        }
    },
    UncheckedFungibilityV5: {
        _enum: {
            Fungible: 'Compact<u128>',
            NonFungible: 'AssetInstanceV5'
        }
    },
    WildFungibilityV5: 'WildFungibilityV2',
    JunctionV5: {
        _enum: {
            Parachain: 'Compact<u32>',
            AccountId32: {
                network: 'Option<NetworkIdV5>',
                id: '[u8;32]'
            },
            AccountIndex64: {
                network: 'Option<NetworkIdV5>',
                index: 'Compact<u64>'
            },
            AccountKey20: {
                network: 'Option<NetworkIdV5>',
                key: '[u8;20]'
            },
            PalletInstance: 'u8',
            GeneralIndex: 'Compact<u128>',
            GeneralKey: {
                length: 'u8',
                data: '[u8;32]'
            },
            OnlyChild: 'Null',
            Plurality: {
                id: 'BodyIdV3',
                part: 'BodyPartV3'
            },
            GlobalConsensus: 'NetworkIdV5'
        }
    },
    NetworkIdV5: {
        _enum: {
            ByGenesis: '[u8;32]',
            ByFork: {
                blockNumber: 'u64',
                blockHash: '[u8;32]'
            },
            Polkadot: 'Null',
            Kusama: 'Null',
            Ethereum: {
                chainId: 'Compact<u64>'
            },
            BitcoinCore: 'Null',
            BitcoinCash: 'Null',
            PolkadotBulletin: 'Null'
        }
    },
    JunctionsV5: {
        _enum: {
            Here: 'Null',
            X1: '[JunctionV5;1]',
            X2: '[JunctionV5;2]',
            X3: '[JunctionV5;3]',
            X4: '[JunctionV5;4]',
            X5: '[JunctionV5;5]',
            X6: '[JunctionV5;6]',
            X7: '[JunctionV5;7]',
            X8: '[JunctionV5;8]'
        }
    },
    MultiLocationV5: {
        parents: 'u8',
        interior: 'JunctionsV5'
    },
    InteriorMultiLocationV5: 'JunctionsV5',
    XcmV5: 'Vec<InstructionV5>',
    PalletInfoV5: 'PalletInfoV3',
    ResponseV5: {
        _enum: {
            Null: 'Null',
            Assets: 'MultiAssetsV5',
            ExecutionResult: 'Option<(u32, XcmErrorV3)>',
            Version: 'u32',
            PalletsInfo: 'Vec<PalletInfoV5>',
            DispatchResult: 'MaybeErrorCodeV3'
        }
    },
    QueryResponseInfoV5: {
        destination: 'MultiLocationV5',
        queryId: 'Compact<u64>',
        maxWeight: 'WeightV2'
    },
    InstructionV5: {
        _enum: {
            WithdrawAsset: 'MultiAssetsV5',
            ReserveAssetDeposited: 'MultiAssetsV5',
            ReceiveTeleportedAsset: 'MultiAssetsV5',
            QueryResponse: {
                queryId: 'Compact<u64>',
                response: 'ResponseV5',
                maxWeight: 'WeightV2',
                querier: 'Option<MultiLocationV5>'
            },
            TransferAsset: {
                assets: 'MultiAssetsV5',
                beneficiary: 'MultiLocationV5'
            },
            TransferReserveAsset: {
                assets: 'MultiAssetsV5',
                dest: 'MultiLocationV5',
                xcm: 'XcmV5'
            },
            Transact: {
                originKind: 'OriginKindV4',
                requireWeightAtMost: 'WeightV2',
                call: 'DoubleEncodedCall'
            },
            HrmpNewChannelOpenRequest: {
                sender: 'Compact<u32>',
                maxMessageSize: 'Compact<u32>',
                maxCapacity: 'Compact<u32>'
            },
            HrmpChannelAccepted: {
                recipient: 'Compact<u32>'
            },
            HrmpChannelClosing: {
                initiator: 'Compact<u32>',
                sender: 'Compact<u32>',
                recipient: 'Compact<u32>'
            },
            ClearOrigin: 'Null',
            DescendOrigin: 'InteriorMultiLocationV5',
            ReportError: 'QueryResponseInfoV4',
            DepositAsset: {
                assets: 'MultiAssetFilterV5',
                beneficiary: 'MultiLocationV5'
            },
            DepositReserveAsset: {
                assets: 'MultiAssetFilterV5',
                dest: 'MultiLocationV5',
                xcm: 'XcmV5'
            },
            ExchangeAsset: {
                give: 'MultiAssetFilterV5',
                want: 'MultiAssetsV5',
                maximal: 'bool'
            },
            InitiateReserveWithdraw: {
                assets: 'MultiAssetFilterV5',
                reserve: 'MultiLocationV5',
                xcm: 'XcmV5'
            },
            InitiateTeleport: {
                assets: 'MultiAssetFilterV5',
                dest: 'MultiLocationV5',
                xcm: 'XcmV5'
            },
            ReportHolding: {
                responseInfo: 'QueryResponseInfoV4',
                assets: 'MultiAssetFilterV5'
            },
            BuyExecution: {
                fees: 'MultiAssetV4',
                weightLimit: 'WeightLimitV3'
            },
            RefundSurplus: 'Null',
            SetErrorHandler: 'XcmV5',
            SetAppendix: 'XcmV5',
            ClearError: 'Null',
            ClaimAsset: {
                assets: 'MultiAssetsV5',
                ticket: 'MultiLocationV5'
            },
            Trap: 'Compact<u64>',
            SubscribeVersion: {
                queryId: 'Compact<u64>',
                maxResponseWeight: 'WeightV2'
            },
            UnsubscribeVersion: 'Null',
            BurnAsset: 'MultiAssetsV5',
            ExpectAsset: 'MultiAssetsV5',
            ExpectOrigin: 'Option<MultiLocationV5>',
            ExpectError: 'Option<(u32, XcmErrorV3)>',
            ExpectTransactStatus: 'MaybeErrorCodeV3',
            QueryPallet: {
                moduleName: 'Vec<u8>',
                responseInfo: 'QueryResponseInfoV4'
            },
            ExpectPallet: {
                index: 'Compact<u32>',
                name: 'Vec<u8>',
                moduleName: 'Vec<u8>',
                crateMajor: 'Compact<u32>',
                minCrateMinor: 'Compact<u32>'
            },
            ReportTransactStatus: 'QueryResponseInfoV4',
            ClearTransactStatus: 'Null',
            UniversalOrigin: 'JunctionV5',
            ExportMessage: {
                network: 'NetworkIdV5',
                destination: 'InteriorMultiLocationV5',
                xcm: 'XcmV5'
            },
            LockAsset: {
                asset: 'MultiAssetV5',
                unlocker: 'MultiLocationV5'
            },
            UnlockAsset: {
                asset: 'MultiAssetV5',
                target: 'MultiLocationV5'
            },
            NoteUnlockable: {
                asset: 'MultiAssetV5',
                owner: 'MultiLocationV5'
            },
            RequestUnlock: {
                asset: 'MultiAssetV5',
                locker: 'MultiLocationV5'
            },
            SetFeesMode: {
                jitWithdraw: 'bool'
            },
            SetTopic: '[u8;32]',
            ClearTopic: 'Null',
            AliasOrigin: 'MultiLocationV5',
            UnpaidExecution: {
                weightLimit: 'WeightLimitV3',
                checkOrigin: 'Option<MultiLocationV5>'
            },
            PayFees: {
                asset: 'MultiAssetV5'
            },
            InitiateTransfer: {
                destination: 'MultiLocationV5',
                remoteFees: 'Option<MultiAssetTransferFilterV5>',
                preserveOrigin: 'bool',
                assets: 'Vec<MultiAssetTransferFilterV5>',
                remoteXcm: 'XcmV5'
            },
            ExecuteWithOrigin: {
                descendant_origin: 'Option<InteriorMultiLocationV5>',
                xcm: 'XcmV5'
            },
            SetHints: {
                hints: 'Vec<HintV5>'
            }
        }
    },
    HintV5: {
        _enum: {
            AssetClaimer: {
                location: 'MultiLocationV5'
            }
        }
    },
    XcmErrorV5: 'XcmErrorV3'
};

const XCM_LATEST = 'V5';
const xcm = {
    XcmOrigin: {
        _enum: {
            Xcm: 'MultiLocation'
        }
    },
    XcmpMessageFormat: {
        _enum: ['ConcatenatedVersionedXcm', 'ConcatenatedEncodedBlob', 'Signals']
    },
    XcmAssetId: {
        _enum: {
            Concrete: 'MultiLocation',
            Abstract: 'Bytes'
        }
    },
    InboundStatus: {
        _enum: ['Ok', 'Suspended']
    },
    OutboundStatus: {
        _enum: ['Ok', 'Suspended']
    },
    MultiAssets: 'Vec<MultiAsset>'
};
const location = {
    BodyId: {
        _enum: {
            Unit: 'Null',
            Named: 'Vec<u8>',
            Index: 'Compact<u32>',
            Executive: 'Null',
            Technical: 'Null',
            Legislative: 'Null',
            Judicial: 'Null'
        }
    },
    BodyPart: {
        _enum: {
            Voice: 'Null',
            Members: 'Compact<u32>',
            Fraction: {
                nom: 'Compact<u32>',
                denom: 'Compact<u32>'
            },
            AtLeastProportion: {
                nom: 'Compact<u32>',
                denom: 'Compact<u32>'
            },
            MoreThanProportion: {
                nom: 'Compact<u32>',
                denom: 'Compact<u32>'
            }
        }
    },
    InteriorMultiLocation: 'Junctions',
    NetworkId: {
        _enum: {
            Any: 'Null',
            Named: 'Vec<u8>',
            Polkadot: 'Null',
            Kusama: 'Null'
        }
    }
};
var definitions$e = {
    rpc: {},
    types: {
        ...location,
        ...xcm,
        ...v0,
        ...v1,
        ...v2,
        ...v3,
        ...v4,
        ...v5,
        ...mapXcmTypes(XCM_LATEST),
        DoubleEncodedCall: {
            encoded: 'Bytes'
        },
        XcmOriginKind: {
            _enum: ['Native', 'SovereignAccount', 'Superuser', 'Xcm']
        },
        Outcome: {
            _enum: {
                Complete: 'Weight',
                Incomplete: '(Weight, XcmErrorV0)',
                Error: 'XcmErrorV0'
            }
        },
        QueryId: 'u64',
        QueryStatus: {
            _enum: {
                Pending: {
                    responder: 'VersionedMultiLocation',
                    maybeNotify: 'Option<(u8, u8)>',
                    timeout: 'BlockNumber'
                },
                Ready: {
                    response: 'VersionedResponse',
                    at: 'BlockNumber'
                }
            }
        },
        QueueConfigData: {
            suspendThreshold: 'u32',
            dropThreshold: 'u32',
            resumeThreshold: 'u32',
            thresholdWeight: 'Weight',
            weightRestrictDecay: 'Weight'
        },
        VersionMigrationStage: {
            _enum: {
                MigrateSupportedVersion: 'Null',
                MigrateVersionNotifiers: 'Null',
                NotifyCurrentTargets: 'Option<Bytes>',
                MigrateAndNotifyOldTargets: 'Null'
            }
        },
        VersionedMultiAsset: {
            _enum: {
                V0: 'MultiAssetV0',
                V1: 'MultiAssetV1',
                V2: 'MultiAssetV2',
                V3: 'MultiAssetV3',
                V4: 'MultiAssetV4',
                V5: 'MultiAssetV5'
            }
        },
        VersionedMultiAssets: {
            _enum: {
                V0: 'Vec<MultiAssetV0>',
                V1: 'MultiAssetsV1',
                V2: 'MultiAssetsV2',
                V3: 'MultiAssetsV3',
                V4: 'MultiAssetsV4',
                V5: 'MultiAssetsV5'
            }
        },
        VersionedMultiLocation: {
            _enum: {
                V0: 'MultiLocationV0',
                V1: 'MultiLocationV1',
                V2: 'MultiLocationV2',
                V3: 'MultiLocationV3',
                V4: 'MultiLocationV4',
                v5: 'MultiLocationV5'
            }
        },
        VersionedResponse: {
            V0: 'ResponseV0',
            V1: 'ResponseV1',
            V2: 'ResponseV2',
            V3: 'ResponseV3',
            V4: 'ResponseV4',
            V5: 'ResponseV5'
        },
        VersionedXcm: {
            _enum: {
                V0: 'XcmV0',
                V1: 'XcmV1',
                V2: 'XcmV2',
                V3: 'XcmV3',
                V4: 'XcmV4',
                V5: 'XcmV5'
            }
        },
        XcmVersion: 'u32'
    }
};

const runtime$7 = {
    XcmPaymentApi: [
        {
            methods: {
                query_acceptable_payment_assets: {
                    description: 'The API to query acceptable payment assets',
                    params: [
                        {
                            name: 'version',
                            type: 'u32'
                        }
                    ],
                    type: 'Result<Vec<XcmVersionedAssetId>, XcmPaymentApiError>'
                },
                query_weight_to_asset_fee: {
                    description: '',
                    params: [
                        {
                            name: 'weight',
                            type: 'WeightV2'
                        },
                        {
                            name: 'asset',
                            type: 'XcmVersionedAssetId'
                        }
                    ],
                    type: 'Result<u128, XcmPaymentApiError>'
                },
                query_xcm_weight: {
                    description: '',
                    params: [
                        {
                            name: 'message',
                            type: 'XcmVersionedXcm'
                        }
                    ],
                    type: 'Result<WeightV2, XcmPaymentApiError>'
                }
            },
            version: 1
        }
    ]
};

var definitions$d = {
    rpc: {},
    runtime: runtime$7,
    types: {
        XcmPaymentApiError: {
            _enum: [
                'Unimplemented',
                'VersionedConversionFailed',
                'WeightNotComputable',
                'UnhandledXcmVersion',
                'AssetNotFound'
            ]
        }
    }
};

const runtime$6 = {
    LocationToAccountApi: [
        {
            methods: {
                convert_location: {
                    description: 'Converts `Location` to `AccountId`',
                    params: [
                        {
                            name: 'location',
                            type: 'XcmVersionedLocation'
                        }
                    ],
                    type: 'Result<AccountId, Error>'
                }
            },
            version: 1
        }
    ]
};

var definitions$c = {
    rpc: {},
    runtime: runtime$6,
    types: {
        Error: {
            _enum: ['Unsupported', 'VersionedConversionFailed']
        }
    }
};

/* eslint-disable sort-keys */
const layout = {
    ContractCryptoHasher: {
        _enum: ['Blake2x256', 'Sha2x256', 'Keccak256']
    },
    ContractDiscriminant: 'u32',
    ContractLayoutArray: {
        offset: 'ContractLayoutKey',
        len: 'u32',
        cellsPerElem: 'u64',
        layout: 'ContractStorageLayout'
    },
    ContractLayoutCell: {
        key: 'ContractLayoutKey',
        ty: 'SiLookupTypeId'
    },
    ContractLayoutEnum: {
        dispatchKey: 'ContractLayoutKey',
        variants: 'BTreeMap<ContractDiscriminant, ContractLayoutStruct>'
    },
    ContractLayoutHash: {
        offset: 'ContractLayoutKey',
        strategy: 'ContractLayoutHashingStrategy',
        layout: 'ContractStorageLayout'
    },
    ContractLayoutHashingStrategy: {
        hasher: 'ContractCryptoHasher',
        postfix: 'Vec<u8>',
        prefix: 'Vec<u8>'
    },
    ContractLayoutKey: '[u8; 32]',
    ContractLayoutStruct: {
        fields: 'Vec<ContractLayoutStructField>'
    },
    ContractLayoutStructField: {
        layout: 'ContractStorageLayout',
        name: 'Text'
    },
    ContractStorageLayout: {
        _enum: {
            Cell: 'ContractLayoutCell',
            Hash: 'ContractLayoutHash',
            Array: 'ContractLayoutArray',
            Struct: 'ContractLayoutStruct',
            Enum: 'ContractLayoutEnum'
        }
    }
};
const spec = {
    ContractConstructorSpecV0: {
        name: 'Text',
        selector: 'ContractSelector',
        args: 'Vec<ContractMessageParamSpecV0>',
        docs: 'Vec<Text>'
    },
    ContractConstructorSpecV1: {
        name: 'Vec<Text>',
        selector: 'ContractSelector',
        args: 'Vec<ContractMessageParamSpecV0>',
        docs: 'Vec<Text>'
    },
    ContractConstructorSpecV2: {
        label: 'Text',
        selector: 'ContractSelector',
        args: 'Vec<ContractMessageParamSpecV2>',
        docs: 'Vec<Text>'
    },
    ContractConstructorSpecV3: {
        label: 'Text',
        selector: 'ContractSelector',
        payable: 'bool',
        args: 'Vec<ContractMessageParamSpecV2>',
        docs: 'Vec<Text>'
    },
    ContractConstructorSpecV4: {
        label: 'Text',
        selector: 'ContractSelector',
        payable: 'bool',
        args: 'Vec<ContractMessageParamSpecV2>',
        docs: 'Vec<Text>',
        default: 'bool',
        returnType: 'Option<ContractTypeSpec>'
    },
    ContractContractSpecV0: {
        constructors: 'Vec<ContractConstructorSpecV0>',
        messages: 'Vec<ContractMessageSpecV0>',
        events: 'Vec<ContractEventSpecV0>',
        docs: 'Vec<Text>'
    },
    ContractContractSpecV1: {
        constructors: 'Vec<ContractConstructorSpecV1>',
        messages: 'Vec<ContractMessageSpecV1>',
        events: 'Vec<ContractEventSpecV1>',
        docs: 'Vec<Text>'
    },
    ContractContractSpecV2: {
        constructors: 'Vec<ContractConstructorSpecV2>',
        messages: 'Vec<ContractMessageSpecV2>',
        events: 'Vec<ContractEventSpecV2>',
        docs: 'Vec<Text>'
    },
    ContractContractSpecV3: {
        constructors: 'Vec<ContractConstructorSpecV3>',
        messages: 'Vec<ContractMessageSpecV2>',
        events: 'Vec<ContractEventSpecV2>',
        docs: 'Vec<Text>'
    },
    ContractContractSpecV4: {
        constructors: 'Vec<ContractConstructorSpecV4>',
        messages: 'Vec<ContractMessageSpecV3>',
        events: 'Vec<ContractEventSpecV2>',
        docs: 'Vec<Text>',
        environment: 'ContractEnvironmentV4'
    },
    ContractContractSpecV5: {
        constructors: 'Vec<ContractConstructorSpecV4>',
        messages: 'Vec<ContractMessageSpecV3>',
        events: 'Vec<ContractEventSpecV3>',
        docs: 'Vec<Text>',
        environment: 'ContractEnvironmentV4'
    },
    ContractContractSpecV6: {
        constructors: 'Vec<ContractConstructorSpecV4>',
        messages: 'Vec<ContractMessageSpecV3>',
        events: 'Vec<ContractEventSpecV3>',
        docs: 'Vec<Text>',
        environment: 'ContractEnvironmentV4'
    },
    ContractDisplayName: 'SiPath',
    ContractEventParamSpecV0: {
        name: 'Text',
        indexed: 'bool',
        type: 'ContractTypeSpec',
        docs: 'Vec<Text>'
    },
    ContractEventParamSpecV2: {
        label: 'Text',
        indexed: 'bool',
        type: 'ContractTypeSpec',
        docs: 'Vec<Text>'
    },
    ContractEventSpecV0: {
        name: 'Text',
        args: 'Vec<ContractEventParamSpecV0>',
        docs: 'Vec<Text>'
    },
    ContractEventSpecV1: {
        name: 'Text',
        args: 'Vec<ContractEventParamSpecV0>',
        docs: 'Vec<Text>'
    },
    ContractEventSpecV2: {
        label: 'Text',
        args: 'Vec<ContractEventParamSpecV2>',
        docs: 'Vec<Text>'
    },
    ContractEventSpecV3: {
        label: 'Text',
        args: 'Vec<ContractEventParamSpecV2>',
        docs: 'Vec<Text>',
        module_path: 'Text',
        signature_topic: 'Option<[u8; 32]>'
    },
    ContractMessageParamSpecV0: {
        name: 'Text',
        type: 'ContractTypeSpec'
    },
    ContractMessageParamSpecV2: {
        label: 'Text',
        type: 'ContractTypeSpec'
    },
    ContractMessageSpecV0: {
        name: 'Text',
        selector: 'ContractSelector',
        mutates: 'bool',
        payable: 'bool',
        args: 'Vec<ContractMessageParamSpecV0>',
        returnType: 'Option<ContractTypeSpec>',
        docs: 'Vec<Text>'
    },
    ContractMessageSpecV1: {
        name: 'Vec<Text>',
        selector: 'ContractSelector',
        mutates: 'bool',
        payable: 'bool',
        args: 'Vec<ContractMessageParamSpecV0>',
        returnType: 'Option<ContractTypeSpec>',
        docs: 'Vec<Text>'
    },
    ContractMessageSpecV2: {
        label: 'Text',
        selector: 'ContractSelector',
        mutates: 'bool',
        payable: 'bool',
        args: 'Vec<ContractMessageParamSpecV2>',
        returnType: 'Option<ContractTypeSpec>',
        docs: 'Vec<Text>'
    },
    ContractMessageSpecV3: {
        label: 'Text',
        selector: 'ContractSelector',
        mutates: 'bool',
        payable: 'bool',
        args: 'Vec<ContractMessageParamSpecV2>',
        returnType: 'Option<ContractTypeSpec>',
        docs: 'Vec<Text>',
        default: 'bool'
    },
    ContractSelector: '[u8; 4]',
    ContractTypeSpec: {
        type: 'SiLookupTypeId',
        displayName: 'ContractDisplayName'
    }
};
const latest = {
    ContractConstructorSpecLatest: 'ContractConstructorSpecV4',
    ContractEventSpecLatest: 'ContractEventSpecV3',
    ContractEventParamSpecLatest: 'ContractEventParamSpecV2',
    ContractMessageParamSpecLatest: 'ContractMessageParamSpecV2',
    ContractMessageSpecLatest: 'ContractMessageSpecV3',
    ContractMetadataLatest: 'ContractMetadataV6'
};
var definitions$b = {
    rpc: {},
    types: {
        ...layout,
        ...spec,
        ...latest,
        ContractProjectInfo: {
            source: 'ContractProjectSource',
            contract: 'ContractProjectContract'
        },
        ContractReviveProjectInfo: {
            source: 'ContractReviveProjectSource',
            contract: 'ContractProjectContract'
        },
        ContractMetadataV0: {
            metadataVersion: 'Text',
            types: 'Vec<Si0Type>',
            spec: 'ContractContractSpecV0'
        },
        ContractMetadataV1: {
            types: 'Vec<PortableType>',
            spec: 'ContractContractSpecV1'
        },
        ContractMetadataV2: {
            types: 'Vec<PortableType>',
            spec: 'ContractContractSpecV2'
        },
        ContractMetadataV3: {
            types: 'Vec<PortableType>',
            spec: 'ContractContractSpecV3'
        },
        ContractMetadataV4: {
            types: 'Vec<PortableType>',
            spec: 'ContractContractSpecV4',
            version: 'Text'
        },
        ContractMetadataV5: {
            types: 'Vec<PortableType>',
            spec: 'ContractContractSpecV5',
            version: 'u64'
        },
        ContractMetadataV6: {
            types: 'Vec<PortableType>',
            spec: 'ContractContractSpecV6',
            version: 'u64'
        },
        ContractMetadata: {
            _enum: {
                V0: 'ContractMetadataV0',
                V1: 'ContractMetadataV1',
                V2: 'ContractMetadataV2',
                V3: 'ContractMetadataV3',
                V4: 'ContractMetadataV4',
                V5: 'ContractMetadataV5',
                V6: 'ContractMetadataV6'
            }
        },
        ContractProjectV0: {
            metadataVersion: 'Text',
            source: 'ContractProjectSource',
            contract: 'ContractProjectContract',
            types: 'Vec<Si0Type>',
            spec: 'ContractContractSpecV0'
        },
        ContractProject: '(ContractProjectInfo, ContractMetadata)',
        ContractProjectContract: {
            _alias: {
                docs: 'documentation'
            },
            name: 'Text',
            version: 'Text',
            authors: 'Vec<Text>',
            description: 'Option<Text>',
            docs: 'Option<Text>',
            repository: 'Option<Text>',
            homepage: 'Option<Text>',
            license: 'Option<Text>'
        },
        ContractProjectSource: {
            _alias: {
                wasmHash: 'hash'
            },
            wasmHash: '[u8; 32]',
            language: 'Text',
            compiler: 'Text',
            wasm: 'Raw'
        },
        ContractReviveProjectSource: {
            _alias: {
                wasmHash: 'hash',
                wasm: 'contract_binary'
            },
            wasmHash: '[u8; 32]',
            language: 'Text',
            compiler: 'Text',
            wasm: 'Raw'
        },
        ContractEnvironmentV4: {
            _alias: {
                hashType: 'hash'
            },
            // NOTE These are not marked optional in the Rust code, however since we
            // convert from older versions to newer, we may not have these fields.
            // The Option<...> works since our inputs are always JSON, so it will
            // be None when not specified.
            //
            // Additionally we don't mark the full structure as Option, rather we
            // do it on a per-field basis since fields may be added as the versions
            // progress.
            accountId: 'Option<ContractTypeSpec>',
            balance: 'Option<ContractTypeSpec>',
            blockNumber: 'Option<ContractTypeSpec>',
            hashType: 'Option<ContractTypeSpec>',
            timestamp: 'Option<ContractTypeSpec>',
            maxEventTopics: 'Option<u32>'
        }
    }
};

const netRpc = {
    listening: {
        aliasSection: 'net',
        description: 'Returns true if client is actively listening for network connections. Otherwise false.',
        params: [],
        type: 'bool'
    },
    peerCount: {
        aliasSection: 'net',
        description: 'Returns number of peers connected to node.',
        params: [],
        type: 'Text'
    },
    version: {
        aliasSection: 'net',
        description: 'Returns protocol version.',
        params: [],
        type: 'Text'
    }
};
const web3Rpc = {
    clientVersion: {
        aliasSection: 'web3',
        description: 'Returns current client version.',
        params: [],
        type: 'Text'
    },
    sha3: {
        aliasSection: 'web3',
        description: 'Returns sha3 of the given data',
        params: [{ name: 'data', type: 'Bytes' }],
        type: 'H256'
    }
};
const rpc$7 = {
    ...netRpc,
    ...web3Rpc,
    accounts: {
        description: 'Returns accounts list.',
        params: [],
        type: 'Vec<H160>'
    },
    blockNumber: {
        description: 'Returns the blockNumber',
        params: [],
        type: 'U256'
    },
    call: {
        description: 'Call contract, returning the output data.',
        params: [
            {
                name: 'request',
                type: 'EthCallRequest'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'number',
                type: 'BlockNumber'
            }
        ],
        type: 'Bytes'
    },
    chainId: {
        description: 'Returns the chain ID used for transaction signing at the current best block. None is returned if not available.',
        params: [],
        type: 'U64'
    },
    coinbase: {
        description: 'Returns block author.',
        params: [],
        type: 'H160'
    },
    estimateGas: {
        description: 'Estimate gas needed for execution of given contract.',
        params: [
            {
                name: 'request',
                type: 'EthCallRequest'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'number',
                type: 'BlockNumber'
            }
        ],
        type: 'U256'
    },
    feeHistory: {
        description: 'Returns fee history for given block count & reward percentiles',
        params: [
            {
                name: 'blockCount',
                type: 'U256'
            },
            {
                name: 'newestBlock',
                type: 'BlockNumber'
            },
            {
                name: 'rewardPercentiles',
                type: 'Option<Vec<f64>>'
            }
        ],
        type: 'EthFeeHistory'
    },
    gasPrice: {
        description: 'Returns current gas price.',
        params: [],
        type: 'U256'
    },
    getBalance: {
        description: 'Returns balance of the given account.',
        params: [
            {
                name: 'address',
                type: 'H160'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'number',
                type: 'BlockNumber'
            }
        ],
        type: 'U256'
    },
    getBlockByHash: {
        description: 'Returns block with given hash.',
        params: [
            {
                name: 'hash',
                type: 'H256'
            },
            {
                name: 'full',
                type: 'bool'
            }
        ],
        type: 'Option<EthRichBlock>'
    },
    getBlockByNumber: {
        description: 'Returns block with given number.',
        params: [
            {
                name: 'block',
                type: 'BlockNumber'
            },
            { name: 'full', type: 'bool' }
        ],
        type: 'Option<EthRichBlock>'
    },
    getBlockTransactionCountByHash: {
        description: 'Returns the number of transactions in a block with given hash.',
        params: [
            {
                name: 'hash',
                type: 'H256'
            }
        ],
        type: 'U256'
    },
    getBlockTransactionCountByNumber: {
        description: 'Returns the number of transactions in a block with given block number.',
        params: [
            {
                name: 'block',
                type: 'BlockNumber'
            }
        ],
        type: 'U256'
    },
    getCode: {
        description: 'Returns the code at given address at given time (block number).',
        params: [
            {
                name: 'address',
                type: 'H160'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'number',
                type: 'BlockNumber'
            }
        ],
        type: 'Bytes'
    },
    getFilterChanges: {
        description: 'Returns filter changes since last poll.',
        params: [
            {
                name: 'index',
                type: 'U256'
            }
        ],
        type: 'EthFilterChanges'
    },
    getFilterLogs: {
        description: 'Returns all logs matching given filter (in a range \'from\' - \'to\').',
        params: [
            {
                name: 'index',
                type: 'U256'
            }
        ],
        type: 'Vec<EthLog>'
    },
    getLogs: {
        description: 'Returns logs matching given filter object.',
        params: [
            {
                name: 'filter',
                type: 'EthFilter'
            }
        ],
        type: 'Vec<EthLog>'
    },
    getProof: {
        description: 'Returns proof for account and storage.',
        params: [
            {
                name: 'address',
                type: 'H160'
            },
            {
                name: 'storageKeys',
                type: 'Vec<H256>'
            },
            {
                name: 'number',
                type: 'BlockNumber'
            }
        ],
        type: 'EthAccount'
    },
    getStorageAt: {
        description: 'Returns content of the storage at given address.',
        params: [
            {
                name: 'address',
                type: 'H160'
            },
            {
                name: 'index',
                type: 'U256'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'number',
                type: 'BlockNumber'
            }
        ],
        type: 'H256'
    },
    getTransactionByBlockHashAndIndex: {
        description: 'Returns transaction at given block hash and index.',
        params: [
            {
                name: 'hash',
                type: 'H256'
            },
            {
                name: 'index',
                type: 'U256'
            }
        ],
        type: 'EthTransaction'
    },
    getTransactionByBlockNumberAndIndex: {
        description: 'Returns transaction by given block number and index.',
        params: [
            {
                name: 'number',
                type: 'BlockNumber'
            },
            {
                name: 'index',
                type: 'U256'
            }
        ],
        type: 'EthTransaction'
    },
    getTransactionByHash: {
        description: 'Get transaction by its hash.',
        params: [
            {
                name: 'hash',
                type: 'H256'
            }
        ],
        type: 'EthTransaction'
    },
    getTransactionCount: {
        description: 'Returns the number of transactions sent from given address at given time (block number).',
        params: [
            {
                name: 'address',
                type: 'H160'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'number',
                type: 'BlockNumber'
            }
        ],
        type: 'U256'
    },
    getTransactionReceipt: {
        description: 'Returns transaction receipt by transaction hash.',
        params: [
            {
                name: 'hash',
                type: 'H256'
            }
        ],
        type: 'EthReceipt'
    },
    getUncleByBlockHashAndIndex: {
        description: 'Returns an uncles at given block and index.',
        params: [
            {
                name: 'hash',
                type: 'H256'
            },
            {
                name: 'index',
                type: 'U256'
            }
        ],
        type: 'EthRichBlock'
    },
    getUncleByBlockNumberAndIndex: {
        description: 'Returns an uncles at given block and index.',
        params: [
            {
                name: 'number',
                type: 'BlockNumber'
            },
            {
                name: 'index',
                type: 'U256'
            }
        ],
        type: 'EthRichBlock'
    },
    getUncleCountByBlockHash: {
        description: 'Returns the number of uncles in a block with given hash.',
        params: [
            {
                name: 'hash',
                type: 'H256'
            }
        ],
        type: 'U256'
    },
    getUncleCountByBlockNumber: {
        description: 'Returns the number of uncles in a block with given block number.',
        params: [
            {
                name: 'number',
                type: 'BlockNumber'
            }
        ],
        type: 'U256'
    },
    getWork: {
        description: 'Returns the hash of the current block, the seedHash, and the boundary condition to be met.',
        params: [],
        type: 'EthWork'
    },
    hashrate: {
        description: 'Returns the number of hashes per second that the node is mining with.',
        params: [],
        type: 'U256'
    },
    maxPriorityFeePerGas: {
        description: 'Returns max priority fee per gas',
        params: [],
        type: 'U256'
    },
    mining: {
        description: 'Returns true if client is actively mining new blocks.',
        params: [],
        type: 'bool'
    },
    newBlockFilter: {
        description: 'Returns id of new block filter.',
        params: [],
        type: 'U256'
    },
    newFilter: {
        description: 'Returns id of new filter.',
        params: [
            {
                name: 'filter',
                type: 'EthFilter'
            }
        ],
        type: 'U256'
    },
    newPendingTransactionFilter: {
        description: 'Returns id of new block filter.',
        params: [],
        type: 'U256'
    },
    protocolVersion: {
        description: 'Returns protocol version encoded as a string (quotes are necessary).',
        params: [],
        type: 'u64'
    },
    sendRawTransaction: {
        description: 'Sends signed transaction, returning its hash.',
        params: [
            {
                name: 'bytes',
                type: 'Bytes'
            }
        ],
        type: 'H256'
    },
    sendTransaction: {
        description: 'Sends transaction; will block waiting for signer to return the transaction hash',
        params: [
            {
                name: 'tx',
                type: 'EthTransactionRequest'
            }
        ],
        type: 'H256'
    },
    submitHashrate: {
        description: 'Used for submitting mining hashrate.',
        params: [
            {
                name: 'index',
                type: 'U256'
            },
            {
                name: 'hash',
                type: 'H256'
            }
        ],
        type: 'bool'
    },
    submitWork: {
        description: 'Used for submitting a proof-of-work solution.',
        params: [
            {
                name: 'nonce',
                type: 'H64'
            },
            {
                name: 'headerHash',
                type: 'H256'
            },
            {
                name: 'mixDigest',
                type: 'H256'
            }
        ],
        type: 'bool'
    },
    subscribe: {
        description: 'Subscribe to Eth subscription.',
        params: [
            { name: 'kind', type: 'EthSubKind' },
            {
                isOptional: true,
                name: 'params',
                type: 'EthSubParams'
            }
        ],
        pubsub: [
            'subscription',
            'subscribe',
            'unsubscribe'
        ],
        type: 'Null'
    },
    syncing: {
        description: 'Returns an object with data about the sync status or false.',
        params: [],
        type: 'EthSyncStatus'
    },
    uninstallFilter: {
        description: 'Uninstalls filter.',
        params: [
            {
                name: 'index',
                type: 'U256'
            }
        ],
        type: 'bool'
    }
};

const ethMethodsV4 = {
    account_basic: {
        description: 'Returns pallet_evm::Accounts by address.',
        params: [
            {
                name: 'address',
                type: 'H160'
            }
        ],
        type: 'EvmAccount'
    },
    account_code_at: {
        description: 'For a given account address, returns pallet_evm::AccountCodes.',
        params: [
            {
                name: 'address',
                type: 'H160'
            }
        ],
        type: 'Bytes'
    },
    author: {
        description: 'Returns the converted FindAuthor::find_author authority id.',
        params: [],
        type: 'H160'
    },
    call: {
        description: 'Returns a frame_ethereum::call response. If `estimate` is true,',
        params: [
            {
                name: 'from',
                type: 'H160'
            },
            {
                name: 'to',
                type: 'H160'
            },
            {
                name: 'data',
                type: 'Vec<u8>'
            },
            {
                name: 'value',
                type: 'U256'
            },
            {
                name: 'gasLimit',
                type: 'U256'
            },
            {
                name: 'maxFeePerGas',
                type: 'Option<U256>'
            },
            {
                name: 'maxPriorityFeePerGas',
                type: 'Option<U256>'
            },
            {
                name: 'nonce',
                type: 'Option<U256>'
            },
            {
                name: 'estimate',
                type: 'bool'
            },
            {
                name: 'accessList',
                type: 'Option<Vec<(H160, Vec<H256>)>>'
            }
        ],
        type: 'Result<EvmCallInfo, DispatchError>'
    },
    chain_id: {
        description: 'Returns runtime defined pallet_evm::ChainId.',
        params: [],
        type: 'u64'
    },
    create: {
        description: 'Returns a frame_ethereum::call response. If `estimate` is true,',
        params: [
            {
                name: 'from',
                type: 'H160'
            },
            {
                name: 'data',
                type: 'Vec<u8>'
            },
            {
                name: 'value',
                type: 'U256'
            },
            {
                name: 'gasLimit',
                type: 'U256'
            },
            {
                name: 'maxFeePerGas',
                type: 'Option<U256>'
            },
            {
                name: 'maxPriorityFeePerGas',
                type: 'Option<U256>'
            },
            {
                name: 'nonce',
                type: 'Option<U256>'
            },
            {
                name: 'estimate',
                type: 'bool'
            },
            {
                name: 'accessList',
                type: 'Option<Vec<(H160, Vec<H256>)>>'
            }
        ],
        type: 'Result<EvmCreateInfo, DispatchError>'
    },
    current_all: {
        description: 'Return all the current data for a block in a single runtime call.',
        params: [],
        type: '(Option<BlockV2>, Option<Vec<EthReceiptV3>>, Option<Vec<EthTransactionStatus>>)'
    },
    current_block: {
        description: 'Return the current block.',
        params: [],
        type: 'BlockV2'
    },
    current_receipts: {
        description: 'Return the current receipt.',
        params: [],
        type: 'Option<Vec<EthReceiptV3>>'
    },
    current_transaction_statuses: {
        description: 'Return the current transaction status.',
        params: [],
        type: 'Option<Vec<EthTransactionStatus>>'
    },
    elasticity: {
        description: 'Return the elasticity multiplier.',
        params: [],
        type: 'Option<Permill>'
    },
    extrinsic_filter: {
        description: 'Receives a `Vec<OpaqueExtrinsic>` and filters all the ethereum transactions.',
        params: [
            {
                name: 'xts',
                type: 'Vec<Extrinsic>'
            }
        ],
        type: 'Vec<TransactionV2>'
    },
    gas_price: {
        description: 'Returns FixedGasPrice::min_gas_price',
        params: [],
        type: 'u256'
    },
    storage_at: {
        description: 'For a given account address and index, returns pallet_evm::AccountStorages.',
        params: [
            {
                name: 'address',
                type: 'H160'
            },
            {
                name: 'index',
                type: 'u256'
            }
        ],
        type: 'H256'
    }
};
const ethMethodsV5 = {
    call: {
        description: 'Returns a frame_ethereum::call response. If `estimate` is true,',
        params: [
            {
                name: 'from',
                type: 'H160'
            },
            {
                name: 'to',
                type: 'H160'
            },
            {
                name: 'data',
                type: 'Vec<u8>'
            },
            {
                name: 'value',
                type: 'U256'
            },
            {
                name: 'gasLimit',
                type: 'U256'
            },
            {
                name: 'maxFeePerGas',
                type: 'Option<U256>'
            },
            {
                name: 'maxPriorityFeePerGas',
                type: 'Option<U256>'
            },
            {
                name: 'nonce',
                type: 'Option<U256>'
            },
            {
                name: 'estimate',
                type: 'bool'
            },
            {
                name: 'accessList',
                type: 'Option<Vec<(H160, Vec<H256>)>>'
            }
        ],
        type: 'Result<EvmCallInfoV2, DispatchError>'
    },
    create: {
        description: 'Returns a frame_ethereum::call response. If `estimate` is true,',
        params: [
            {
                name: 'from',
                type: 'H160'
            },
            {
                name: 'data',
                type: 'Vec<u8>'
            },
            {
                name: 'value',
                type: 'U256'
            },
            {
                name: 'gasLimit',
                type: 'U256'
            },
            {
                name: 'maxFeePerGas',
                type: 'Option<U256>'
            },
            {
                name: 'maxPriorityFeePerGas',
                type: 'Option<U256>'
            },
            {
                name: 'nonce',
                type: 'Option<U256>'
            },
            {
                name: 'estimate',
                type: 'bool'
            },
            {
                name: 'accessList',
                type: 'Option<Vec<(H160, Vec<H256>)>>'
            }
        ],
        type: 'Result<EvmCreateInfoV2, DispatchError>'
    }
};
const runtime$5 = {
    ConvertTransactionRuntimeApi: [
        {
            methods: {
                convert_transaction: {
                    description: 'Converts an Ethereum-style transaction to Extrinsic',
                    params: [
                        {
                            name: 'transaction',
                            type: 'TransactionV2'
                        }
                    ],
                    type: 'Extrinsic'
                }
            },
            version: 2
        },
        {
            methods: {
                convert_transaction: {
                    description: 'Converts an Ethereum-style transaction to Extrinsic',
                    params: [
                        {
                            name: 'transaction',
                            type: 'TransactionV3'
                        }
                    ],
                    type: 'Extrinsic'
                }
            },
            version: 3
        }
    ],
    DebugRuntimeApi: [
        {
            methods: {
                trace_block: {
                    description: 'Trace all block extrinsics',
                    params: [
                        {
                            name: 'extrinsics',
                            type: 'Vec<Extrinsic>'
                        },
                        {
                            name: 'knownTransactions',
                            type: 'Vec<H256>'
                        }
                    ],
                    type: 'Result<(), DispatchError>'
                },
                trace_transaction: {
                    description: 'Trace transaction extrinsics',
                    params: [
                        {
                            name: 'extrinsics',
                            type: 'Vec<Extrinsic>'
                        },
                        {
                            name: 'transaction',
                            type: 'EthTransaction'
                        }
                    ],
                    type: 'Result<(), DispatchError>'
                }
            },
            version: 4
        }
    ],
    EthereumRuntimeRPCApi: [
        {
            methods: {
                ...ethMethodsV4
            },
            version: 4
        },
        {
            methods: {
                ...ethMethodsV4,
                ...ethMethodsV5
            },
            version: 5
        }
    ]
};

const V0 = {
    BlockV0: {
        header: 'EthHeader',
        transactions: 'Vec<TransactionV0>',
        ommers: 'Vec<EthHeader>'
    },
    LegacyTransaction: {
        nonce: 'U256',
        gasPrice: 'U256',
        gasLimit: 'U256',
        action: 'EthTransactionAction',
        value: 'U256',
        input: 'Bytes',
        signature: 'EthLegacyTransactionSignature'
    },
    TransactionV0: 'LegacyTransaction'
};
const V1 = {
    BlockV1: {
        header: 'EthHeader',
        transactions: 'Vec<TransactionV1>',
        ommers: 'Vec<EthHeader>'
    },
    EIP2930Transaction: {
        chainId: 'u64',
        nonce: 'U256',
        gasPrice: 'U256',
        gasLimit: 'U256',
        action: 'EthTransactionAction',
        value: 'U256',
        input: 'Bytes',
        accessList: 'EthAccessList',
        signature: 'EthTransactionSignature'
    },
    TransactionV1: {
        _enum: {
            Legacy: 'LegacyTransaction',
            EIP2930: 'EIP2930Transaction'
        }
    }
};
const V2 = {
    BlockV2: {
        header: 'EthHeader',
        transactions: 'Vec<TransactionV2>',
        ommers: 'Vec<EthHeader>'
    },
    EIP1559Transaction: {
        chainId: 'u64',
        nonce: 'U256',
        maxPriorityFeePerGas: 'U256',
        maxFeePerGas: 'U256',
        gasLimit: 'U256',
        action: 'EthTransactionAction',
        value: 'U256',
        input: 'Bytes',
        accessList: 'EthAccessList',
        signature: 'EthTransactionSignature'
    },
    TransactionV2: {
        _enum: {
            Legacy: 'LegacyTransaction',
            EIP2930: 'EIP2930Transaction',
            EIP1559: 'EIP1559Transaction'
        }
    }
};
const V3 = {
    BlockV3: {
        header: 'EthHeader',
        transactions: 'Vec<TransactionV3>',
        ommers: 'Vec<EthHeader>'
    },
    EIP7702Transaction: {
        chainId: 'u64',
        nonce: 'U256',
        maxPriorityFeePerGas: 'U256',
        maxFeePerGas: 'U256',
        gasLimit: 'U256',
        destination: 'EthTransactionAction',
        value: 'U256',
        data: 'Bytes',
        accessList: 'EthAccessList',
        authorizationList: 'EthAuthorizationList',
        signature: 'EthTransactionSignature'
    },
    TransactionV3: {
        _enum: {
            Legacy: 'LegacyTransaction',
            EIP2930: 'EIP2930Transaction',
            EIP1559: 'EIP1559Transaction',
            EIP7702: 'EIP7702Transaction'
        }
    }
};
const types = {
    ...V0,
    ...V1,
    ...V2,
    ...V3,
    EthereumAccountId: 'GenericEthereumAccountId',
    EthereumAddress: 'GenericEthereumAccountId',
    EthereumLookupSource: 'GenericEthereumLookupSource',
    EthereumSignature: '[u8; 65]',
    EthAccessListItem: {
        address: 'EthAddress',
        slots: 'Vec<H256>'
    },
    EthAccessList: 'Vec<EthAccessListItem>',
    EthAuthorizationList: 'Vec<EthAuthorizationListItem>',
    EthAuthorizationListItem: {
        chainId: 'u64',
        address: 'H160',
        nonce: 'U256',
        signature: 'EthAuthorizationSignature'
    },
    EthAuthorizationSignature: {
        oddYParity: 'bool',
        r: 'H256',
        s: 'H256'
    },
    EthAccount: {
        address: 'EthAddress',
        balance: 'U256',
        nonce: 'U256',
        codeHash: 'H256',
        storageHash: 'H256',
        accountProof: 'Vec<Bytes>',
        storageProof: 'Vec<EthStorageProof>'
    },
    EthAddress: 'H160',
    EthBlock: {
        header: 'EthHeader',
        transactions: 'Vec<EthTransaction>',
        ommers: 'Vec<EthHeader>'
    },
    EthHeader: {
        parentHash: 'H256',
        ommersHash: 'H256',
        beneficiary: 'EthAddress',
        stateRoot: 'H256',
        transactionsRoot: 'H256',
        receiptsRoot: 'H256',
        logsBloom: 'EthBloom',
        difficulty: 'U256',
        number: 'U256',
        gasLimit: 'U256',
        gasUsed: 'U256',
        timestamp: 'u64',
        extraData: 'Bytes',
        mixMash: 'H256',
        nonce: 'H64'
    },
    EthRichBlock: {
        _alias: {
            blockHash: 'hash',
            blockSize: 'size'
        },
        blockHash: 'Option<H256>',
        parentHash: 'H256',
        sha3Uncles: 'H256',
        author: 'EthAddress',
        miner: 'EthAddress',
        stateRoot: 'H256',
        transactionsRoot: 'H256',
        receiptsRoot: 'H256',
        number: 'Option<U256>',
        gasUsed: 'U256',
        gasLimit: 'U256',
        extraData: 'Bytes',
        logsBloom: 'EthBloom',
        timestamp: 'U256',
        difficulty: 'U256',
        totalDifficulty: 'Option<U256>',
        sealFields: 'Vec<Bytes>',
        uncles: 'Vec<H256>',
        transactions: 'Vec<EthTransaction>',
        blockSize: 'Option<U256>'
    },
    EthBloom: 'H2048',
    EthCallRequest: {
        from: 'Option<EthAddress>',
        to: 'Option<EthAddress>',
        gasPrice: 'Option<U256>',
        gas: 'Option<U256>',
        value: 'Option<U256>',
        data: 'Option<Bytes>',
        nonce: 'Option<U256>'
    },
    EthFeeHistory: {
        oldestBlock: 'U256',
        baseFeePerGas: 'Vec<U256>',
        gasUsedRatio: 'Vec<f64>',
        reward: 'Option<Vec<Vec<U256>>>'
    },
    EthFilter: {
        fromBlock: 'Option<BlockNumber>',
        toBlock: 'Option<BlockNumber>',
        blockHash: 'Option<H256>',
        address: 'Option<EthFilterAddress>',
        topics: 'Option<EthFilterTopic>'
    },
    EthFilterAddress: {
        _enum: {
            Single: 'EthAddress',
            Multiple: 'Vec<EthAddress>',
            Null: 'Null'
        }
    },
    EthFilterChanges: {
        _enum: {
            Logs: 'Vec<EthLog>',
            Hashes: 'Vec<H256>',
            Empty: 'Null'
        }
    },
    EthFilterTopic: {
        _enum: {
            Single: 'EthFilterTopicInner',
            Multiple: 'Vec<EthFilterTopicInner>',
            Null: 'Null'
        }
    },
    EthFilterTopicEntry: 'Option<H256>',
    EthFilterTopicInner: {
        _enum: {
            Single: 'EthFilterTopicEntry',
            Multiple: 'Vec<EthFilterTopicEntry>',
            Null: 'Null'
        }
    },
    EthRichHeader: {
        _alias: {
            blockHash: 'hash',
            blockSize: 'size'
        },
        blockHash: 'Option<H256>',
        parentHash: 'H256',
        sha3Uncles: 'H256',
        author: 'EthAddress',
        miner: 'EthAddress',
        stateRoot: 'H256',
        transactionsRoot: 'H256',
        receiptsRoot: 'H256',
        number: 'Option<U256>',
        gasUsed: 'U256',
        gasLimit: 'U256',
        extraData: 'Bytes',
        logsBloom: 'EthBloom',
        timestamp: 'U256',
        difficulty: 'U256',
        sealFields: 'Vec<Bytes>',
        blockSize: 'Option<U256>'
    },
    EthLog: {
        address: 'EthAddress',
        topics: 'Vec<H256>',
        data: 'Bytes',
        blockHash: 'Option<H256>',
        blockNumber: 'Option<U256>',
        transactionHash: 'Option<H256>',
        transactionIndex: 'Option<U256>',
        logIndex: 'Option<U256>',
        transactionLogIndex: 'Option<U256>',
        removed: 'bool'
    },
    EthReceipt: {
        transactionHash: 'Option<H256>',
        transactionIndex: 'Option<U256>',
        blockHash: 'Option<H256>',
        from: 'Option<EthAddress>',
        to: 'Option<EthAddress>',
        blockNumber: 'Option<U256>',
        cumulativeGasUsed: 'U256',
        gasUsed: 'Option<U256>',
        contractAddress: 'Option<EthAddress>',
        logs: 'Vec<EthLog>',
        root: 'Option<H256>',
        logsBloom: 'EthBloom',
        statusCode: 'Option<U64>'
    },
    // not convinced, however the original commit matches, so... (maybe V3 is incorrect?)
    EthReceiptV0: 'EthReceipt',
    EthReceiptV3: 'EthReceipt',
    EthReceiptV4: 'EthReceipt',
    EthStorageProof: {
        key: 'U256',
        value: 'U256',
        proof: 'Vec<Bytes>'
    },
    EthSubKind: {
        _enum: ['newHeads', 'logs', 'newPendingTransactions', 'syncing']
    },
    EthSubParams: {
        _enum: {
            None: 'Null',
            Logs: 'EthFilter'
        }
    },
    EthSubResult: {
        _enum: {
            Header: 'EthRichHeader',
            Log: 'EthLog',
            TransactionHash: 'H256',
            SyncState: 'EthSyncStatus'
        }
    },
    EthSyncInfo: {
        startingBlock: 'U256',
        currentBlock: 'U256',
        highestBlock: 'U256',
        warpChunksAmount: 'Option<U256>',
        warpChunksProcessed: 'Option<U256>'
    },
    EthSyncStatus: {
        _enum: {
            Info: 'EthSyncInfo',
            None: 'Null'
        }
    },
    EthTransaction: {
        hash: 'H256',
        nonce: 'U256',
        blockHash: 'Option<H256>',
        blockNumber: 'Option<U256>',
        transactionIndex: 'Option<U256>',
        from: 'H160',
        to: 'Option<H160>',
        value: 'U256',
        gasPrice: 'Option<U256>',
        maxFeePerGas: 'Option<U256>',
        maxPriorityFeePerGas: 'Option<U256>',
        gas: 'U256',
        input: 'Bytes',
        creates: 'Option<H160>',
        raw: 'Bytes',
        publicKey: 'Option<H512>',
        chainId: 'Option<U64>',
        standardV: 'U256',
        v: 'U256',
        r: 'U256',
        s: 'U256',
        accessList: 'Option<Vec<EthAccessListItem>>',
        transactionType: 'Option<U256>'
    },
    EthLegacyTransactionSignature: {
        v: 'u64',
        r: 'H256',
        s: 'H256'
    },
    EthTransactionSignature: {
        oddYParity: 'bool',
        r: 'H256',
        s: 'H256'
    },
    EthTransactionAction: {
        _enum: {
            Call: 'H160',
            Create: 'Null'
        }
    },
    EthTransactionCondition: {
        _enum: {
            block: 'u64',
            time: 'u64'
        }
    },
    EthTransactionRequest: {
        from: 'Option<EthAddress>',
        to: 'Option<EthAddress>',
        gasPrice: 'Option<U256>',
        gas: 'Option<U256>',
        value: 'Option<U256>',
        data: 'Option<Bytes>',
        nonce: 'Option<U256>'
    },
    EthTransactionStatus: {
        transactionHash: 'H256',
        transactionIndex: 'u32',
        from: 'EthAddress',
        to: 'Option<EthAddress>',
        contractAddress: 'Option<EthAddress>',
        logs: 'Vec<EthLog>',
        logsBloom: 'EthBloom'
    },
    EthWork: {
        powHash: 'H256',
        seedHash: 'H256',
        target: 'H256',
        number: 'Option<u64>'
    }
};
var definitions$a = { rpc: rpc$7, runtime: runtime$5, types };

const runtime$4 = {
    // deprecated, the NimbusApi is current - this is for backwards compat
    AuthorFilterAPI: [
        {
            methods: {
                can_author: {
                    description: 'The runtime api used to predict whether an author will be eligible in the given slot',
                    params: [
                        {
                            name: 'author',
                            type: 'AccountId'
                        },
                        {
                            name: 'relayParent',
                            type: 'u32'
                        },
                        {
                            name: 'parentHeader',
                            type: 'Header'
                        }
                    ],
                    type: 'bool'
                }
            },
            version: 2
        },
        {
            methods: {
                can_author: {
                    description: 'The runtime api used to predict whether an author will be eligible in the given slot',
                    params: [
                        {
                            name: 'author',
                            type: 'AccountId'
                        },
                        {
                            name: 'relayParent',
                            type: 'u32'
                        }
                    ],
                    type: 'bool'
                }
            },
            version: 1
        }
    ],
    NimbusApi: [
        {
            methods: {
                can_author: {
                    description: 'The runtime api used to predict whether a Nimbus author will be eligible in the given slot',
                    params: [
                        {
                            name: 'author',
                            type: 'AccountId'
                        },
                        {
                            name: 'relayParent',
                            type: 'u32'
                        },
                        {
                            name: 'parentHeader',
                            type: 'Header'
                        }
                    ],
                    type: 'bool'
                }
            },
            version: 1
        }
    ]
};

var definitions$9 = {
    rpc: {},
    runtime: runtime$4,
    types: {}
};

const runtime$3 = {
    // https://github.com/open-web3-stack/open-runtime-module-library/blob/b57f88b39cd547e2fb51727d8bb9bcc64fddf8b5/oracle/rpc/runtime-api/src/lib.rs#L12-L21
    OracleApi: [
        {
            methods: {
                get_all_values: {
                    description: 'Retrieves all values',
                    params: [
                        {
                            name: 'providerId',
                            // This is a Codec type
                            type: 'Raw'
                        }
                    ],
                    // This won't actually work as expected - since we have
                    // no information about the actual Raw sizes, we cannot
                    // handle it in this format (it would need an override
                    // for the specific Codec). So return the Raw value.
                    // type: 'Vec<(Raw, Option<Raw>)>'
                    type: 'Raw'
                },
                get_value: {
                    description: 'Retrieves a single value',
                    params: [
                        {
                            name: 'providerId',
                            // This is a Codec type
                            type: 'Raw'
                        },
                        {
                            name: 'key',
                            // This is a Codec type
                            type: 'Raw'
                        }
                    ],
                    // This is an Option<Codec> type
                    type: 'Option<Raw>'
                }
            },
            version: 1
        }
    ]
};

var definitions$8 = {
    rpc: {},
    runtime: runtime$3,
    types: {}
};

const runtime$2 = {
    // https://github.com/open-web3-stack/open-runtime-module-library/blob/b57f88b39cd547e2fb51727d8bb9bcc64fddf8b5/tokens/rpc/runtime-api/src/lib.rs#L11-L18
    TokensApi: [
        {
            methods: {
                query_existential_deposit: {
                    description: 'Query the existential amount for a specific currency',
                    params: [
                        {
                            name: 'currencyId',
                            // This is CurrencyId, as per the return value, we are unsure
                            // if this is specialized and/or global to the chain or not
                            type: 'Raw'
                        }
                    ],
                    // This is Balance - since we don't understand enough about the way
                    // in which this is used, we default to u128 here (it certainly could
                    // be a specialized type that doesn't map to the on-chain Balance)
                    type: 'u128'
                }
            },
            version: 1
        }
    ]
};

var definitions$7 = {
    rpc: {},
    runtime: runtime$2,
    types: {}
};

const rpc$6 = {
    methods: {
        description: 'Retrieves the list of RPC methods that are exposed by the node',
        params: [],
        type: 'RpcMethods'
    }
};

var definitions$6 = {
    rpc: rpc$6,
    types: {
        RpcMethods: {
            version: 'u32',
            methods: 'Vec<Text>'
        }
    }
};

const rpc$5 = {
    hasKey: {
        description: 'Returns true if the keystore has private keys for the given public key and key type.',
        isUnsafe: true,
        params: [
            {
                name: 'publicKey',
                type: 'Bytes'
            },
            {
                name: 'keyType',
                type: 'Text'
            }
        ],
        type: 'bool'
    },
    hasSessionKeys: {
        description: 'Returns true if the keystore has private keys for the given session public keys.',
        isUnsafe: true,
        params: [
            {
                name: 'sessionKeys',
                type: 'Bytes'
            }
        ],
        type: 'bool'
    },
    insertKey: {
        description: 'Insert a key into the keystore.',
        isUnsafe: true,
        params: [
            {
                name: 'keyType',
                type: 'Text'
            },
            {
                name: 'suri',
                type: 'Text'
            },
            {
                name: 'publicKey',
                type: 'Bytes'
            }
        ],
        type: 'Bytes'
    },
    pendingExtrinsics: {
        description: 'Returns all pending extrinsics, potentially grouped by sender',
        params: [],
        type: 'Vec<Extrinsic>'
    },
    removeExtrinsic: {
        description: 'Remove given extrinsic from the pool and temporarily ban it to prevent reimporting',
        isUnsafe: true,
        params: [
            {
                name: 'bytesOrHash',
                type: 'Vec<ExtrinsicOrHash>'
            }
        ],
        type: 'Vec<Hash>'
    },
    rotateKeys: {
        description: 'Generate new session keys and returns the corresponding public keys',
        isUnsafe: true,
        params: [],
        type: 'Bytes'
    },
    submitAndWatchExtrinsic: {
        description: 'Submit and subscribe to watch an extrinsic until unsubscribed',
        isSigned: true,
        params: [
            {
                name: 'extrinsic',
                type: 'Extrinsic'
            }
        ],
        pubsub: [
            'extrinsicUpdate',
            'submitAndWatchExtrinsic',
            'unwatchExtrinsic'
        ],
        type: 'ExtrinsicStatus'
    },
    submitExtrinsic: {
        description: 'Submit a fully formatted extrinsic for block inclusion',
        isSigned: true,
        params: [
            {
                name: 'extrinsic',
                type: 'Extrinsic'
            }
        ],
        type: 'Hash'
    }
};

var definitions$5 = {
    rpc: rpc$5,
    types: {
        ExtrinsicOrHash: {
            _enum: {
                Hash: 'Hash',
                Extrinsic: 'Bytes'
            }
        },
        ExtrinsicStatus: {
            _enum: {
                Future: 'Null',
                Ready: 'Null',
                Broadcast: 'Vec<Text>',
                InBlock: 'Hash',
                Retracted: 'Hash',
                FinalityTimeout: 'Hash',
                Finalized: 'Hash',
                Usurped: 'Hash',
                Dropped: 'Null',
                Invalid: 'Null'
            }
        }
    }
};

const rpc$4 = {
    getBlock: {
        description: 'Get header and body of a relay chain block',
        params: [
            {
                isHistoric: true,
                isOptional: true,
                name: 'hash',
                type: 'BlockHash'
            }
        ],
        type: 'SignedBlock'
    },
    getBlockHash: {
        description: 'Get the block hash for a specific block',
        params: [
            {
                isOptional: true,
                name: 'blockNumber',
                type: 'BlockNumber'
            }
        ],
        type: 'BlockHash'
    },
    getFinalizedHead: {
        alias: ['chain_getFinalisedHead'],
        description: 'Get hash of the last finalized block in the canon chain',
        params: [],
        type: 'BlockHash'
    },
    getHeader: {
        alias: ['chain_getHead'],
        description: 'Retrieves the header for a specific block',
        params: [
            {
                isHistoric: true,
                isOptional: true,
                name: 'hash',
                type: 'BlockHash'
            }
        ],
        type: 'Header'
    },
    subscribeAllHeads: {
        description: 'Retrieves the newest header via subscription',
        params: [],
        pubsub: [
            'allHead',
            'subscribeAllHeads',
            'unsubscribeAllHeads'
        ],
        type: 'Header'
    },
    subscribeFinalizedHeads: {
        alias: ['chain_subscribeFinalisedHeads', 'chain_unsubscribeFinalisedHeads'],
        description: 'Retrieves the best finalized header via subscription',
        params: [],
        pubsub: [
            'finalizedHead',
            'subscribeFinalizedHeads',
            'unsubscribeFinalizedHeads'
        ],
        type: 'Header'
    },
    subscribeNewHeads: {
        alias: ['chain_unsubscribeNewHeads', 'subscribe_newHead', 'unsubscribe_newHead'],
        description: 'Retrieves the best header via subscription',
        params: [],
        // NOTE These still has the aliassed version, compatible with 1.x
        pubsub: [
            'newHead',
            'subscribeNewHead',
            'unsubscribeNewHead'
        ],
        type: 'Header'
    }
};

var definitions$4 = {
    rpc: rpc$4,
    types: {
        BlockHash: 'Hash'
    }
};

const rpc$3 = {
    getKeys: {
        description: 'Returns the keys with prefix from a child storage, leave empty to get all the keys',
        params: [
            {
                name: 'childKey',
                type: 'PrefixedStorageKey'
            },
            {
                name: 'prefix',
                type: 'StorageKey'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'Hash'
            }
        ],
        type: 'Vec<StorageKey>'
    },
    getKeysPaged: {
        alias: ['childstate_getKeysPagedAt'],
        description: 'Returns the keys with prefix from a child storage with pagination support',
        params: [
            {
                name: 'childKey',
                type: 'PrefixedStorageKey'
            },
            {
                name: 'prefix',
                type: 'StorageKey'
            },
            {
                name: 'count',
                type: 'u32'
            },
            {
                isOptional: true,
                name: 'startKey',
                type: 'StorageKey'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'Hash'
            }
        ],
        type: 'Vec<StorageKey>'
    },
    getStorage: {
        description: 'Returns a child storage entry at a specific block state',
        params: [
            {
                name: 'childKey',
                type: 'PrefixedStorageKey'
            },
            {
                name: 'key',
                type: 'StorageKey'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'Hash'
            }
        ],
        type: 'Option<StorageData>'
    },
    getStorageEntries: {
        description: 'Returns child storage entries for multiple keys at a specific block state',
        params: [
            {
                name: 'childKey',
                type: 'PrefixedStorageKey'
            },
            {
                name: 'keys',
                type: 'Vec<StorageKey>'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'Hash'
            }
        ],
        type: 'Vec<Option<StorageData>>'
    },
    getStorageHash: {
        description: 'Returns the hash of a child storage entry at a block state',
        params: [
            {
                name: 'childKey',
                type: 'PrefixedStorageKey'
            },
            {
                name: 'key',
                type: 'StorageKey'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'Hash'
            }
        ],
        type: 'Option<Hash>'
    },
    getStorageSize: {
        description: 'Returns the size of a child storage entry at a block state',
        params: [
            {
                name: 'childKey',
                type: 'PrefixedStorageKey'
            },
            {
                name: 'key',
                type: 'StorageKey'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'Hash'
            }
        ],
        type: 'Option<u64>'
    }
};

var definitions$3 = {
    rpc: rpc$3,
    types: {
        // StorageKey extends Bytes
        PrefixedStorageKey: 'StorageKey'
    }
};

const rpc$2 = {
    localStorageClear: {
        description: 'Clear offchain local storage under given key and prefix',
        isUnsafe: true,
        params: [
            {
                name: 'kind',
                type: 'StorageKind'
            },
            {
                name: 'key',
                type: 'Bytes'
            }
        ],
        type: 'Null'
    },
    localStorageGet: {
        description: 'Get offchain local storage under given key and prefix',
        isUnsafe: true,
        params: [
            {
                name: 'kind',
                type: 'StorageKind'
            },
            {
                name: 'key',
                type: 'Bytes'
            }
        ],
        type: 'Option<Bytes>'
    },
    localStorageSet: {
        description: 'Set offchain local storage under given key and prefix',
        isUnsafe: true,
        params: [
            {
                name: 'kind',
                type: 'StorageKind'
            },
            {
                name: 'key',
                type: 'Bytes'
            },
            {
                name: 'value',
                type: 'Bytes'
            }
        ],
        type: 'Null'
    }
};

const runtime$1 = {
    OffchainWorkerApi: [
        {
            methods: {
                offchain_worker: {
                    description: 'Starts the off-chain task for given block header.',
                    params: [
                        {
                            name: 'header',
                            type: 'Header'
                        }
                    ],
                    type: 'Null'
                }
            },
            version: 2
        },
        {
            methods: {
                offchain_worker: {
                    description: 'Starts the off-chain task for given block header.',
                    params: [
                        {
                            name: 'number',
                            type: 'BlockNumber'
                        }
                    ],
                    type: 'Null'
                }
            },
            version: 1
        }
    ]
};

var definitions$2 = {
    rpc: rpc$2,
    runtime: runtime$1,
    types: {
        StorageKind: {
            _enum: {
                PERSISTENT: 1,
                LOCAL: 2
            }
        }
    }
};

const rpc$1 = {
    queryFeeDetails: {
        // NOTE: Not deprecated (yet) in Substrate, but it is the intent to do so
        deprecated: 'Use `api.call.transactionPaymentApi.queryFeeDetails` instead',
        description: 'Query the detailed fee of a given encoded extrinsic',
        params: [
            {
                name: 'extrinsic',
                type: 'Bytes'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'FeeDetails'
    },
    queryInfo: {
        // NOTE: Not deprecated (yet) in Substrate, but it is the intent to do so
        deprecated: 'Use `api.call.transactionPaymentApi.queryInfo` instead',
        description: 'Retrieves the fee information for an encoded extrinsic',
        params: [
            {
                name: 'extrinsic',
                type: 'Bytes'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        // NOTE: Stuck on V1 forever (at least for the time being)
        type: 'RuntimeDispatchInfoV1'
    }
};

const V1_TO_V4_SHARED_PAY = {
    query_fee_details: {
        description: 'The transaction fee details',
        params: [
            {
                name: 'uxt',
                type: 'Extrinsic'
            },
            {
                name: 'len',
                type: 'u32'
            }
        ],
        type: 'FeeDetails'
    }
};
const V1_TO_V3_SHARED_CALL = {
    query_call_fee_details: {
        description: 'The call fee details',
        params: [
            {
                name: 'call',
                type: 'Call'
            },
            {
                name: 'len',
                type: 'u32'
            }
        ],
        type: 'FeeDetails'
    }
};
const V2_TO_V4_SHARED_PAY = {
    query_info: {
        description: 'The transaction info',
        params: [
            {
                name: 'uxt',
                type: 'Extrinsic'
            },
            {
                name: 'len',
                type: 'u32'
            }
        ],
        type: 'RuntimeDispatchInfo'
    }
};
const V2_V3_SHARED_CALL = {
    query_call_info: {
        description: 'The call info',
        params: [
            {
                name: 'call',
                type: 'Call'
            },
            {
                name: 'len',
                type: 'u32'
            }
        ],
        type: 'RuntimeDispatchInfo'
    }
};
const V3_SHARED_PAY_CALL = {
    query_length_to_fee: {
        description: 'Query the output of the current LengthToFee given some input',
        params: [
            {
                name: 'length',
                type: 'u32'
            }
        ],
        type: 'Balance'
    },
    query_weight_to_fee: {
        description: 'Query the output of the current WeightToFee given some input',
        params: [
            {
                name: 'weight',
                type: 'Weight'
            }
        ],
        type: 'Balance'
    }
};
const runtime = {
    TransactionPaymentApi: [
        {
            // V4 is equivalent to V3 (V4 just dropped all V1 references)
            methods: {
                ...V3_SHARED_PAY_CALL,
                ...V2_TO_V4_SHARED_PAY,
                ...V1_TO_V4_SHARED_PAY
            },
            version: 4
        },
        {
            methods: {
                ...V3_SHARED_PAY_CALL,
                ...V2_TO_V4_SHARED_PAY,
                ...V1_TO_V4_SHARED_PAY
            },
            version: 3
        },
        {
            methods: {
                ...V2_TO_V4_SHARED_PAY,
                ...V1_TO_V4_SHARED_PAY
            },
            version: 2
        },
        {
            methods: {
                query_info: {
                    description: 'The transaction info',
                    params: [
                        {
                            name: 'uxt',
                            type: 'Extrinsic'
                        },
                        {
                            name: 'len',
                            type: 'u32'
                        }
                    ],
                    // NOTE: _Should_ be V1 (as per current Substrate), however the interface was
                    // changed mid-flight between versions. So we have some of each depending on
                    // runtime. (We do detect the weight type, so correct)
                    type: 'RuntimeDispatchInfo'
                },
                ...V1_TO_V4_SHARED_PAY
            },
            version: 1
        }
    ],
    TransactionPaymentCallApi: [
        {
            methods: {
                ...V3_SHARED_PAY_CALL,
                ...V2_V3_SHARED_CALL,
                ...V1_TO_V3_SHARED_CALL
            },
            version: 3
        },
        {
            methods: {
                ...V2_V3_SHARED_CALL,
                ...V1_TO_V3_SHARED_CALL
            },
            version: 2
        },
        {
            methods: {
                CALL: {
                    description: 'The call info',
                    params: [
                        {
                            name: 'call',
                            type: 'Call'
                        },
                        {
                            name: 'len',
                            type: 'u32'
                        }
                    ],
                    // NOTE: As per the above comment, the below is correct according to Substrate, but
                    // _may_ yield fallback decoding on some versions of the runtime
                    type: 'RuntimeDispatchInfo'
                },
                ...V1_TO_V3_SHARED_CALL
            },
            version: 1
        }
    ]
};

var definitions$1 = {
    rpc: rpc$1,
    runtime,
    types: {
        FeeDetails: {
            inclusionFee: 'Option<InclusionFee>'
            // skipped in serde
            // tip: 'Balance'
        },
        InclusionFee: {
            baseFee: 'Balance',
            lenFee: 'Balance',
            adjustedWeightFee: 'Balance'
        },
        RuntimeDispatchInfo: {
            weight: 'Weight',
            class: 'DispatchClass',
            partialFee: 'Balance'
        },
        RuntimeDispatchInfoV1: {
            weight: 'WeightV1',
            class: 'DispatchClass',
            partialFee: 'Balance'
        },
        RuntimeDispatchInfoV2: {
            weight: 'WeightV2',
            class: 'DispatchClass',
            partialFee: 'Balance'
        }
    }
};

const rpc = {
    call: {
        alias: ['state_callAt'],
        description: 'Perform a call to a builtin on the chain',
        params: [
            {
                name: 'method',
                type: 'Text'
            },
            {
                name: 'data',
                type: 'Bytes'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'Bytes'
    },
    getChildKeys: {
        description: 'Retrieves the keys with prefix of a specific child storage',
        params: [
            {
                name: 'childStorageKey',
                type: 'StorageKey'
            },
            {
                name: 'childDefinition',
                type: 'StorageKey'
            },
            {
                name: 'childType',
                type: 'u32'
            },
            {
                name: 'key',
                type: 'StorageKey'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'Vec<StorageKey>'
    },
    getChildReadProof: {
        description: 'Returns proof of storage for child key entries at a specific block state.',
        params: [
            {
                name: 'childStorageKey',
                type: 'PrefixedStorageKey'
            },
            {
                name: 'keys',
                type: 'Vec<StorageKey>'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'ReadProof'
    },
    getChildStorage: {
        description: 'Retrieves the child storage for a key',
        params: [
            {
                name: 'childStorageKey',
                type: 'StorageKey'
            },
            {
                name: 'childDefinition',
                type: 'StorageKey'
            },
            {
                name: 'childType',
                type: 'u32'
            },
            {
                name: 'key',
                type: 'StorageKey'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'StorageData'
    },
    getChildStorageHash: {
        description: 'Retrieves the child storage hash',
        params: [
            {
                name: 'childStorageKey',
                type: 'StorageKey'
            },
            {
                name: 'childDefinition',
                type: 'StorageKey'
            },
            {
                name: 'childType',
                type: 'u32'
            },
            {
                name: 'key',
                type: 'StorageKey'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'Hash'
    },
    getChildStorageSize: {
        description: 'Retrieves the child storage size',
        params: [
            {
                name: 'childStorageKey',
                type: 'StorageKey'
            },
            {
                name: 'childDefinition',
                type: 'StorageKey'
            },
            {
                name: 'childType',
                type: 'u32'
            },
            {
                name: 'key',
                type: 'StorageKey'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'u64'
    },
    getKeys: {
        deprecated: 'Use `api.rpc.state.getKeysPaged` to retrieve keys',
        description: 'Retrieves the keys with a certain prefix',
        params: [
            {
                name: 'key',
                type: 'StorageKey'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'Vec<StorageKey>'
    },
    getKeysPaged: {
        alias: ['state_getKeysPagedAt'],
        description: 'Returns the keys with prefix with pagination support.',
        params: [
            {
                name: 'key',
                type: 'StorageKey'
            },
            {
                name: 'count',
                type: 'u32'
            },
            {
                isOptional: true,
                name: 'startKey',
                type: 'StorageKey'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'Vec<StorageKey>'
    },
    getMetadata: {
        description: 'Returns the runtime metadata',
        params: [
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'Metadata'
    },
    getPairs: {
        deprecated: 'Use `api.rpc.state.getKeysPaged` to retrieve keys',
        description: 'Returns the keys with prefix, leave empty to get all the keys (deprecated: Use getKeysPaged)',
        isUnsafe: true,
        params: [
            {
                name: 'prefix',
                type: 'StorageKey'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'Vec<KeyValue>'
    },
    getReadProof: {
        description: 'Returns proof of storage entries at a specific block state',
        params: [
            {
                name: 'keys',
                type: 'Vec<StorageKey>'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'ReadProof'
    },
    getRuntimeVersion: {
        alias: ['chain_getRuntimeVersion'],
        description: 'Get the runtime version',
        params: [
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'RuntimeVersion'
    },
    getStorage: {
        alias: ['state_getStorageAt'],
        description: 'Retrieves the storage for a key',
        params: [
            {
                name: 'key',
                type: 'StorageKey'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'StorageData'
    },
    getStorageHash: {
        alias: ['state_getStorageHashAt'],
        description: 'Retrieves the storage hash',
        params: [
            {
                name: 'key',
                type: 'StorageKey'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'Hash'
    },
    getStorageSize: {
        alias: ['state_getStorageSizeAt'],
        description: 'Retrieves the storage size',
        params: [
            {
                name: 'key',
                type: 'StorageKey'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'u64'
    },
    queryStorage: {
        description: 'Query historical storage entries (by key) starting from a start block',
        isUnsafe: true,
        params: [
            {
                name: 'keys',
                type: 'Vec<StorageKey>'
            },
            {
                name: 'fromBlock',
                type: 'Hash'
            },
            {
                isOptional: true,
                name: 'toBlock',
                type: 'BlockHash'
            }
        ],
        type: 'Vec<StorageChangeSet>'
    },
    queryStorageAt: {
        description: 'Query storage entries (by key) starting at block hash given as the second parameter',
        params: [
            {
                name: 'keys',
                type: 'Vec<StorageKey>'
            },
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'Vec<StorageChangeSet>'
    },
    subscribeRuntimeVersion: {
        alias: ['chain_subscribeRuntimeVersion', 'chain_unsubscribeRuntimeVersion'],
        description: 'Retrieves the runtime version via subscription',
        params: [],
        pubsub: [
            'runtimeVersion',
            'subscribeRuntimeVersion',
            'unsubscribeRuntimeVersion'
        ],
        type: 'RuntimeVersion'
    },
    subscribeStorage: {
        description: 'Subscribes to storage changes for the provided keys',
        // NOTE Just marking it here to follow the logic - this is unsafe when no
        // keys are provided (i.e. subscribing to all), generally this is used
        // extensively with normal subscriptions
        // isUnsafe: true,
        params: [
            {
                isOptional: true,
                name: 'keys',
                type: 'Vec<StorageKey>'
            }
        ],
        pubsub: [
            'storage',
            'subscribeStorage',
            'unsubscribeStorage'
        ],
        type: 'StorageChangeSet'
    },
    traceBlock: {
        description: 'Provides a way to trace the re-execution of a single block',
        isUnsafe: true,
        params: [
            {
                name: 'block',
                type: 'Hash'
            },
            {
                name: 'targets',
                type: 'Option<Text>'
            },
            {
                name: 'storageKeys',
                type: 'Option<Text>'
            },
            {
                name: 'methods',
                type: 'Option<Text>'
            }
        ],
        type: 'TraceBlockResponse'
    },
    trieMigrationStatus: {
        description: 'Check current migration state',
        isUnsafe: true,
        params: [
            {
                isHistoric: true,
                isOptional: true,
                name: 'at',
                type: 'BlockHash'
            }
        ],
        type: 'MigrationStatusResult'
    }
};

var definitions = {
    rpc,
    types: {
        ApiId: '[u8; 8]',
        BlockTrace: {
            blockHash: 'Text',
            parentHash: 'Text',
            tracingTargets: 'Text',
            storageKeys: 'Text',
            spans: 'Vec<BlockTraceSpan>',
            events: 'Vec<BlockTraceEvent>'
        },
        BlockTraceEvent: {
            target: 'Text',
            data: 'BlockTraceEventData',
            parentId: 'Option<u64>'
        },
        BlockTraceEventData: {
            stringValues: 'HashMap<Text, Text>'
        },
        BlockTraceSpan: {
            id: 'u64',
            parentId: 'Option<u64>',
            name: 'Text',
            target: 'Text',
            wasm: 'bool'
        },
        KeyValueOption: '(StorageKey, Option<StorageData>)',
        MigrationStatusResult: {
            topRemainingToMigrate: 'u64',
            childRemainingToMigrate: 'u64'
        },
        ReadProof: {
            at: 'Hash',
            proof: 'Vec<Bytes>'
        },
        RuntimeVersionApi: '(ApiId, u32)',
        RuntimeVersion: {
            specName: 'Text',
            implName: 'Text',
            authoringVersion: 'u32',
            specVersion: 'u32',
            implVersion: 'u32',
            apis: 'Vec<RuntimeVersionApi>',
            transactionVersion: 'u32',
            stateVersion: 'u8'
        },
        RuntimeVersionPre4: {
            specName: 'Text',
            implName: 'Text',
            authoringVersion: 'u32',
            specVersion: 'u32',
            implVersion: 'u32',
            apis: 'Vec<RuntimeVersionApi>',
            transactionVersion: 'u32'
        },
        RuntimeVersionPre3: {
            specName: 'Text',
            implName: 'Text',
            authoringVersion: 'u32',
            specVersion: 'u32',
            implVersion: 'u32',
            apis: 'Vec<RuntimeVersionApi>'
        },
        RuntimeVersionPartial: {
            specName: 'Text',
            specVersion: 'u32',
            apis: 'Vec<RuntimeVersionApi>'
        },
        SpecVersion: 'u32',
        StorageChangeSet: {
            block: 'Hash',
            changes: 'Vec<KeyValueOption>'
        },
        TraceBlockResponse: {
            _enum: {
                TraceError: 'TraceError',
                BlockTrace: 'BlockTrace'
            }
        },
        TraceError: {
            error: 'Text'
        }
    }
};

var typeDefinitions = /*#__PURE__*/Object.freeze({
	__proto__: null,
	assetConversion: definitions$19,
	assets: definitions$18,
	attestations: definitions$o,
	aura: definitions$17,
	author: definitions$5,
	authorship: definitions$16,
	babe: definitions$15,
	balances: definitions$14,
	beefy: definitions$13,
	benchmark: definitions$12,
	blockbuilder: definitions$11,
	bridges: definitions$n,
	chain: definitions$4,
	childstate: definitions$3,
	claims: definitions$m,
	collective: definitions$10,
	consensus: definitions$$,
	contracts: definitions$_,
	contractsAbi: definitions$b,
	crowdloan: definitions$l,
	cumulus: definitions$k,
	democracy: definitions$Z,
	dev: definitions$Y,
	discovery: definitions$X,
	dryRunApi: definitions$f,
	elections: definitions$W,
	engine: definitions$V,
	eth: definitions$a,
	evm: definitions$U,
	extrinsics: definitions$T,
	finality: definitions$j,
	fungibles: definitions$S,
	genericAsset: definitions$R,
	genesisBuilder: definitions$Q,
	gilt: definitions$P,
	grandpa: definitions$O,
	identity: definitions$N,
	imOnline: definitions$M,
	lottery: definitions$L,
	metadata: definitions$1c,
	mixnet: definitions$K,
	mmr: definitions$J,
	nfts: definitions$I,
	nimbus: definitions$9,
	nompools: definitions$H,
	offchain: definitions$2,
	offences: definitions$G,
	ormlOracle: definitions$8,
	ormlTokens: definitions$7,
	parachains: definitions$i,
	payment: definitions$1,
	poll: definitions$h,
	pow: definitions$F,
	proxy: definitions$E,
	purchase: definitions$g,
	recovery: definitions$D,
	rpc: definitions$6,
	runtime: definitions$1b,
	scaleInfo: definitions$1a,
	scheduler: definitions$C,
	session: definitions$B,
	society: definitions$A,
	staking: definitions$z,
	state: definitions,
	statement: definitions$y,
	support: definitions$x,
	syncstate: definitions$w,
	system: definitions$v,
	treasury: definitions$u,
	txpayment: definitions$t,
	txqueue: definitions$s,
	uniques: definitions$r,
	utility: definitions$q,
	vesting: definitions$p,
	xcm: definitions$e,
	xcmPaymentApi: definitions$d,
	xcmRuntimeApi: definitions$c
});

const jsonrpc = {};
Object.keys(typeDefinitions).forEach((s) => Object.entries(typeDefinitions[s].rpc || {}).forEach(([method, def]) => {
    // allow for section overrides
    const section = def.aliasSection || s;
    if (!jsonrpc[section]) {
        jsonrpc[section] = {};
    }
    jsonrpc[section][method] = objectSpread({}, def, {
        isSubscription: !!def.pubsub,
        jsonrpc: `${section}_${method}`,
        method,
        section
    });
}));

const l$6 = logger('PortableRegistry');
const TYPE_UNWRAP = { toNumber: () => -1 };
const PRIMITIVE_ALIAS = {
    Char: 'u32', // Rust char is 4-bytes
    Str: 'Text'
};
const PATHS_ALIAS = splitNamespace([
    // full matching on exact names...
    // these are well-known types with additional encoding
    'sp_core::crypto::AccountId32',
    'sp_runtime::generic::era::Era',
    'sp_runtime::multiaddress::MultiAddress',
    // ethereum overrides (Frontier, Moonbeam, Polkadot claims)
    'fp_account::AccountId20',
    'account::AccountId20',
    'polkadot_runtime_common::claims::EthereumAddress',
    // weights 2 is a structure, however for 1.5. with a single field it
    // should be flatenned (can appear in Compact<Weight> extrinsics)
    'frame_support::weights::weight_v2::Weight',
    'sp_weights::weight_v2::Weight',
    // wildcard matching in place...
    // these have a specific encoding or logic, use a wildcard for {pallet, darwinia}_democracy
    '*_democracy::vote::Vote',
    '*_conviction_voting::vote::Vote',
    '*_identity::types::Data',
    // these are opaque Vec<u8> wrappers
    'sp_core::OpaqueMetadata',
    'sp_core::OpaquePeerId',
    'sp_core::offchain::OpaqueMultiaddr',
    // shorten some well-known types
    'primitive_types::*',
    'sp_arithmetic::per_things::*',
    // runtime
    '*_runtime::RuntimeCall',
    '*_runtime::RuntimeEvent',
    // ink!
    'ink::env::types::*',
    'ink::primitives::types::*',
    'ink_env::types::*',
    'ink_primitives::types::*'
]);
const PATHS_SET = splitNamespace([
    'pallet_identity::types::BitFlags'
]);
const BITVEC_NS_LSB = ['bitvec::order::Lsb0', 'BitOrderLsb0'];
const BITVEC_NS_MSB = ['bitvec::order::Msb0', 'BitOrderMsb0'];
const BITVEC_NS = [...BITVEC_NS_LSB, ...BITVEC_NS_MSB];
const WRAPPERS = ['BoundedBTreeMap', 'BoundedBTreeSet', 'BoundedVec', 'Box', 'BTreeMap', 'BTreeSet', 'Cow', 'Option', 'Range', 'RangeInclusive', 'Result', 'WeakBoundedVec', 'WrapperKeepOpaque', 'WrapperOpaque'];
const RESERVED = [
    // JS reserved words
    'entries', 'keys', 'new', 'size',
    // exposed by all Codec objects
    'hash', 'registry'
];
const PATH_RM_INDEX_1 = ['generic', 'misc', 'pallet', 'traits', 'types'];
/** @internal Converts a Text[] into string[] (used as part of definitions) */
function sanitizeDocs(docs) {
    const count = docs.length;
    const result = new Array(count);
    for (let i = 0; i < count; i++) {
        result[i] = docs[i].toString();
    }
    return result;
}
/** @internal Split a namespace with :: into individual parts */
function splitNamespace(values) {
    const count = values.length;
    const result = new Array(count);
    for (let i = 0; i < count; i++) {
        result[i] = values[i].split('::');
    }
    return result;
}
/** @internal Match a namespace based on parts (alongside wildcards) */
function matchParts(first, second) {
    return first.length === second.length && first.every((a, index) => {
        const b = second[index].toString();
        if ((a === '*') || (a === b)) {
            return true;
        }
        if (a.includes('*') && a.includes('_') && b.includes('_')) {
            let suba = a.split('_');
            let subb = b.split('_');
            // match initial *'s to multiples if we have a match for the other
            if (suba[0] === '*') {
                const indexOf = subb.indexOf(suba[1]);
                if (indexOf !== -1) {
                    suba = suba.slice(1);
                    subb = subb.slice(indexOf);
                }
            }
            // check for * matches at the end, adjust accordingly
            if ((suba.length === 2) && (suba[1] === '*') && (suba[0] === subb[0])) {
                return true;
            }
            return matchParts(suba, subb);
        }
        return false;
    });
}
/** @internal check if the path matches the PATHS_ALIAS (with wildcards) */
function getAliasPath({ def, path }) {
    // specific logic for weights - we override when non-complex struct
    // (as applied in Weight 1.5 where we also have `Compact<{ refTime: u64 }>)
    if (['frame_support::weights::weight_v2::Weight', 'sp_weights::weight_v2::Weight'].includes(path.join('::'))) {
        return !def.isComposite || def.asComposite.fields.length === 1
            ? 'WeightV1'
            : null;
    }
    // TODO We need to handle ink! Balance in some way
    return path.length && PATHS_ALIAS.some((a) => matchParts(a, path))
        ? path[path.length - 1].toString()
        : null;
}
/** @internal Converts a type name into a JS-API compatible name */
function extractNameFlat(portable, lookupIndex, params, path, isInternal = false) {
    const count = path.length;
    // if we have no path or determined as a wrapper, we just skip it
    if (count === 0 || WRAPPERS.includes(path[count - 1].toString())) {
        return null;
    }
    const camels = new Array(count);
    const lowers = new Array(count);
    // initially just create arrays of the camelCase and lowercase path
    // parts - we will check these to extract the final values. While
    // we have 2 loops here, we also don't do the same operation twice
    for (let i = 0; i < count; i++) {
        const c = stringPascalCase(isInternal
            ? path[i].replace('pallet_', '')
            : path[i]);
        const l = c.toLowerCase();
        camels[i] = c;
        lowers[i] = l;
    }
    let name = '';
    for (let i = 0; i < count; i++) {
        const l = lowers[i];
        // Remove ::{generic, misc, pallet, traits, types}::
        if (i !== 1 || !PATH_RM_INDEX_1.includes(l)) {
            // sp_runtime::generic::digest::Digest -> sp_runtime::generic::Digest
            // sp_runtime::multiaddress::MultiAddress -> sp_runtime::MultiAddress
            if (l !== lowers[i + 1]) {
                name += camels[i];
            }
        }
    }
    // do magic for RawOrigin lookup, e.g. pallet_collective::RawOrigin
    if (camels[1] === 'RawOrigin' && count === 2 && params.length === 2 && params[1].type.isSome) {
        const instanceType = portable[params[1].type.unwrap().toNumber()];
        if (instanceType.type.path.length === 2) {
            name = `${name}${instanceType.type.path[1].toString()}`;
        }
    }
    return { lookupIndex, name, params };
}
/** @internal Alias for extractNameFlat with PortableType as a last parameter */
function extractName(portable, lookupIndex, { type: { params, path } }) {
    return extractNameFlat(portable, lookupIndex, params, path);
}
/** @internal Check for dupes from a specific index onwards */
function nextDupeMatches(name, startAt, names) {
    const result = [names[startAt]];
    for (let i = startAt + 1, count = names.length; i < count; i++) {
        const v = names[i];
        if (v.name === name) {
            result.push(v);
        }
    }
    return result;
}
/** @internal Checks to see if a type is a full duplicate (with all params matching) */
function rewriteDupes(input, rewrite) {
    const count = input.length;
    for (let i = 0; i < count; i++) {
        const a = input[i];
        for (let j = i + 1; j < count; j++) {
            const b = input[j];
            // if the indexes are not the same and the names match, we have a dupe
            if (a.lookupIndex !== b.lookupIndex && a.name === b.name) {
                return false;
            }
        }
    }
    // add all the adjusted values to the rewite map
    for (let i = 0; i < count; i++) {
        const p = input[i];
        rewrite[p.lookupIndex] = p.name;
    }
    return true;
}
/** @internal Find duplicates and adjust the names based on parameters */
function removeDupeNames(lookup, portable, names) {
    const rewrite = {};
    return names
        .map((original, startAt) => {
        const { lookupIndex, name, params } = original;
        if (!name) {
            // the name is empty (this is not expected, but have a failsafe)
            return null;
        }
        else if (rewrite[lookupIndex]) {
            // we have already rewritten this one, we can skip it
            return original;
        }
        // those where the name is matching starting from this index
        const allSame = nextDupeMatches(name, startAt, names);
        // we only have one, so all ok
        if (allSame.length === 1) {
            return original;
        }
        // are there param differences between matching names
        const anyDiff = allSame.some((o) => params.length !== o.params.length ||
            params.some((p, index) => !p.name.eq(o.params[index].name) ||
                p.type.unwrapOr(TYPE_UNWRAP).toNumber() !== o.params[index].type.unwrapOr(TYPE_UNWRAP).toNumber()));
        // everything matches, we can combine these
        if (!anyDiff) {
            return original;
        }
        // TODO We probably want to attach all the indexes with differences,
        // not just the first
        // find the first parameter that yields differences
        const paramIdx = params.findIndex(({ type }, index) => allSame.every(({ params }, aIndex) => params[index].type.isSome && (aIndex === 0 ||
            !params[index].type.eq(type))));
        // No param found that is different
        if (paramIdx === -1) {
            return original;
        }
        // see if using the param type helps
        const sameCount = allSame.length;
        const adjusted = new Array(sameCount);
        // loop through all, specifically checking that index where the
        // first param yields differences
        for (let i = 0; i < sameCount; i++) {
            const { lookupIndex, name, params } = allSame[i];
            const { def, path } = lookup.getSiType(params[paramIdx].type.unwrap());
            // if it is not a primitive and it doesn't have a path, we really cannot
            // do anything at this point
            if (!def.isPrimitive && !path.length) {
                return null;
            }
            adjusted[i] = {
                lookupIndex,
                name: def.isPrimitive
                    ? `${name}${def.asPrimitive.toString()}`
                    : `${name}${path[path.length - 1].toString()}`
            };
        }
        // check to see if the adjusted names have no issues
        if (rewriteDupes(adjusted, rewrite)) {
            return original;
        }
        // TODO This is duplicated from the section just above...
        // ... we certainly need a better solution here
        //
        // Last-ditch effort to use the full type path - ugly
        // loop through all, specifically checking that index where the
        // first param yields differences
        for (let i = 0; i < sameCount; i++) {
            const { lookupIndex, name, params } = allSame[i];
            const { def, path } = lookup.getSiType(params[paramIdx].type.unwrap());
            const flat = extractNameFlat(portable, lookupIndex, params, path, true);
            if (def.isPrimitive || !flat) {
                return null;
            }
            adjusted[i] = {
                lookupIndex,
                name: `${name}${flat.name}`
            };
        }
        // check to see if the adjusted names have no issues
        if (rewriteDupes(adjusted, rewrite)) {
            return original;
        }
        return null;
    })
        .filter((n) => !!n)
        .map(({ lookupIndex, name, params }) => ({
        lookupIndex,
        name: rewrite[lookupIndex] || name,
        params
    }));
}
/** @internal Detect on-chain types (AccountId/Signature) as set as the default */
function registerTypes(lookup, lookups, names, params) {
    // Register the types we extracted
    lookup.registry.register(lookups);
    // Try and extract the AccountId/Address/Signature type from UncheckedExtrinsic
    if (params.SpRuntimeUncheckedExtrinsic) {
        // Address, Call, Signature, Extra
        const [addrParam, , sigParam] = params.SpRuntimeUncheckedExtrinsic;
        const siAddress = lookup.getSiType(addrParam.type.unwrap());
        const siSignature = lookup.getSiType(sigParam.type.unwrap());
        const nsSignature = siSignature.path.join('::');
        let nsAccountId = siAddress.path.join('::');
        const isMultiAddress = nsAccountId === 'sp_runtime::multiaddress::MultiAddress';
        // With multiaddress, we check the first type param again
        if (isMultiAddress) {
            // AccountId, AccountIndex
            const [idParam] = siAddress.params;
            nsAccountId = lookup.getSiType(idParam.type.unwrap()).path.join('::');
        }
        lookup.registry.register({
            // known: account::AccountId20, fp_account::AccountId20, primitive_types::H160
            AccountId: nsAccountId.endsWith('::AccountId20') || nsAccountId.endsWith('::H160')
                ? 'AccountId20'
                : 'AccountId32',
            Address: isMultiAddress
                ? 'MultiAddress'
                : 'AccountId',
            ExtrinsicSignature: ['sp_runtime::MultiSignature'].includes(nsSignature)
                ? 'MultiSignature'
                : names[sigParam.type.unwrap().toNumber()] || 'MultiSignature'
        });
    }
}
/**
 * @internal Extracts aliases based on what we know the runtime config looks like in a
 * Substrate chain. Specifically we want to have access to the Call and Event params
 **/
function extractAliases(params, isContract) {
    const hasParams = Object.keys(params).some((k) => !k.startsWith('Pallet'));
    const alias = {};
    if (params.SpRuntimeUncheckedExtrinsic) {
        // Address, Call, Signature, Extra
        const [, { type }] = params.SpRuntimeUncheckedExtrinsic;
        alias[type.unwrap().toNumber()] = 'Call';
    }
    else if (hasParams && !isContract) {
        l$6.warn('Unable to determine runtime Call type, cannot inspect sp_runtime::generic::unchecked_extrinsic::UncheckedExtrinsic');
    }
    if (params.FrameSystemEventRecord) {
        // Event, Topic
        const [{ type }] = params.FrameSystemEventRecord;
        alias[type.unwrap().toNumber()] = 'Event';
    }
    else if (hasParams && !isContract) {
        l$6.warn('Unable to determine runtime Event type, cannot inspect frame_system::EventRecord');
    }
    return alias;
}
/** @internal Extracts all the intreresting type information for this registry */
function extractTypeInfo(lookup, portable) {
    const nameInfo = [];
    const types = {};
    for (let i = 0, count = portable.length; i < count; i++) {
        const type = portable[i];
        const lookupIndex = type.id.toNumber();
        const extracted = extractName(portable, lookupIndex, portable[i]);
        if (extracted) {
            nameInfo.push(extracted);
        }
        types[lookupIndex] = type;
    }
    const lookups = {};
    const names = {};
    const params = {};
    const dedup = removeDupeNames(lookup, portable, nameInfo);
    for (let i = 0, count = dedup.length; i < count; i++) {
        const { lookupIndex, name, params: p } = dedup[i];
        names[lookupIndex] = name;
        lookups[name] = lookup.registry.createLookupType(lookupIndex);
        params[name] = p;
    }
    return { lookups, names, params, types };
}
class PortableRegistry extends Struct {
    #alias;
    #lookups;
    #names;
    #params;
    #typeDefs = {};
    #types;
    constructor(registry, value, isContract) {
        // const timeStart = performance.now()
        super(registry, {
            types: 'Vec<PortableType>'
        }, value);
        const { lookups, names, params, types } = extractTypeInfo(this, this.types);
        this.#alias = extractAliases(params, isContract);
        this.#lookups = lookups;
        this.#names = names;
        this.#params = params;
        this.#types = types;
        // console.log('PortableRegistry', `${(performance.now() - timeStart).toFixed(2)}ms`)
    }
    /**
     * @description Returns all the available type names for this chain
     **/
    get names() {
        return Object.values(this.#names).sort();
    }
    /**
     * @description Returns all the available parameterized types for this chain
     **/
    get paramTypes() {
        return this.#params;
    }
    /**
     * @description The types of the registry
     */
    get types() {
        return this.getT('types');
    }
    /**
     * @description Register all available types into the registry (generally for internal usage)
     */
    register() {
        registerTypes(this, this.#lookups, this.#names, this.#params);
    }
    /**
     * @description Returns the name for a specific lookup
     */
    getName(lookupId) {
        return this.#names[this.#getLookupId(lookupId)];
    }
    /**
     * @description Finds a specific type in the registry
     */
    getSiType(lookupId) {
        // NOTE catch-22 - this may already be used as part of the constructor, so
        // ensure that we have actually initialized it correctly
        const found = (this.#types || this.types)[this.#getLookupId(lookupId)];
        if (!found) {
            throw new Error(`PortableRegistry: Unable to find type with lookupId ${lookupId.toString()}`);
        }
        return found.type;
    }
    /**
     * @description Lookup the type definition for the index
     */
    getTypeDef(lookupId) {
        const lookupIndex = this.#getLookupId(lookupId);
        if (!this.#typeDefs[lookupIndex]) {
            const lookupName = this.#names[lookupIndex];
            const empty = {
                info: TypeDefInfo.DoNotConstruct,
                lookupIndex,
                lookupName,
                type: this.registry.createLookupType(lookupIndex)
            };
            // Set named items since we will get into circular lookups along the way
            if (lookupName) {
                this.#typeDefs[lookupIndex] = empty;
            }
            const extracted = this.#extract(this.getSiType(lookupId), lookupIndex);
            // For non-named items, we only set this right at the end
            if (!lookupName) {
                this.#typeDefs[lookupIndex] = empty;
            }
            Object.keys(extracted).forEach((k) => {
                if (k !== 'lookupName' || extracted[k]) {
                    // these are safe since we are looking through the keys as set
                    this.#typeDefs[lookupIndex][k] = extracted[k];
                }
            });
            // don't set lookupName on lower-level, we want to always direct to the type
            if (extracted.info === TypeDefInfo.Plain) {
                this.#typeDefs[lookupIndex].lookupNameRoot = this.#typeDefs[lookupIndex].lookupName;
                delete this.#typeDefs[lookupIndex].lookupName;
            }
        }
        return this.#typeDefs[lookupIndex];
    }
    /**
     * @description For a specific field, perform adjustments to not have built-in conflicts
     */
    sanitizeField(name) {
        let nameField = null;
        let nameOrig = null;
        if (name.isSome) {
            nameField = stringCamelCase(name.unwrap());
            if (nameField.includes('#')) {
                nameOrig = nameField;
                nameField = nameOrig.replace(/#/g, '_');
            }
            else if (RESERVED.includes(nameField)) {
                nameOrig = nameField;
                nameField = `${nameField}_`;
            }
        }
        return [nameField, nameOrig];
    }
    /** @internal Creates a TypeDef based on an internal lookupId */
    #createSiDef(lookupId) {
        const typeDef = this.getTypeDef(lookupId);
        const lookupIndex = lookupId.toNumber();
        // Setup for a lookup on complex types
        return [TypeDefInfo.DoNotConstruct, TypeDefInfo.Enum, TypeDefInfo.Struct].includes(typeDef.info) && typeDef.lookupName
            ? {
                docs: typeDef.docs,
                info: TypeDefInfo.Si,
                lookupIndex,
                lookupName: this.#names[lookupIndex],
                type: this.registry.createLookupType(lookupId)
            }
            : typeDef;
    }
    /** @internal Converts a lookupId input to the actual lookup index */
    #getLookupId(lookupId) {
        if (isString(lookupId)) {
            if (!this.registry.isLookupType(lookupId)) {
                throw new Error(`PortableRegistry: Expected a lookup string type, found ${lookupId}`);
            }
            return parseInt(lookupId.replace('Lookup', ''), 10);
        }
        else if (isNumber(lookupId)) {
            return lookupId;
        }
        return lookupId.toNumber();
    }
    /** @internal Converts a type into a TypeDef for Codec usage */
    #extract(type, lookupIndex) {
        const namespace = type.path.join('::');
        let typeDef;
        const aliasType = this.#alias[lookupIndex] || getAliasPath(type);
        try {
            if (aliasType) {
                typeDef = this.#extractAliasPath(lookupIndex, aliasType);
            }
            else {
                switch (type.def.type) {
                    case 'Array':
                        typeDef = this.#extractArray(lookupIndex, type.def.asArray);
                        break;
                    case 'BitSequence':
                        typeDef = this.#extractBitSequence(lookupIndex, type.def.asBitSequence);
                        break;
                    case 'Compact':
                        typeDef = this.#extractCompact(lookupIndex, type.def.asCompact);
                        break;
                    case 'Composite':
                        typeDef = this.#extractComposite(lookupIndex, type, type.def.asComposite);
                        break;
                    case 'HistoricMetaCompat':
                        typeDef = this.#extractHistoric(lookupIndex, type.def.asHistoricMetaCompat);
                        break;
                    case 'Primitive':
                        typeDef = this.#extractPrimitive(lookupIndex, type);
                        break;
                    case 'Sequence':
                        typeDef = this.#extractSequence(lookupIndex, type.def.asSequence);
                        break;
                    case 'Tuple':
                        typeDef = this.#extractTuple(lookupIndex, type.def.asTuple);
                        break;
                    case 'Variant':
                        typeDef = this.#extractVariant(lookupIndex, type, type.def.asVariant);
                        break;
                    default: assertUnreachable(type.def.type);
                }
            }
        }
        catch (error) {
            throw new Error(`PortableRegistry: ${lookupIndex}${namespace ? ` (${namespace})` : ''}: Error extracting ${stringify(type)}: ${error.message}`);
        }
        return objectSpread({
            docs: sanitizeDocs(type.docs),
            namespace
        }, typeDef);
    }
    /** @internal Extracts a ScaleInfo Array into TypeDef.VecFixed */
    #extractArray(_, { len, type }) {
        const length = len.toNumber();
        if (length > 2048) {
            throw new Error('Only support for [Type; <length>], where length <= 2048');
        }
        return withTypeString(this.registry, {
            info: TypeDefInfo.VecFixed,
            length,
            sub: this.#createSiDef(type)
        });
    }
    /** @internal Extracts a ScaleInfo BitSequence into TypeDef.Plain */
    #extractBitSequence(_, { bitOrderType, bitStoreType }) {
        // With the v3 of scale-info this swapped around, but obviously the decoder cannot determine
        // the order. With that in-mind, we apply a detection for LSb0/Msb and set accordingly
        const a = this.#createSiDef(bitOrderType);
        const b = this.#createSiDef(bitStoreType);
        const [bitOrder, bitStore] = BITVEC_NS.includes(a.namespace || '')
            ? [a, b]
            : [b, a];
        if (!bitOrder.namespace || !BITVEC_NS.includes(bitOrder.namespace)) {
            throw new Error(`Unexpected bitOrder found as ${bitOrder.namespace || '<unknown>'}`);
        }
        else if (bitStore.info !== TypeDefInfo.Plain || bitStore.type !== 'u8') {
            throw new Error(`Only u8 bitStore is currently supported, found ${bitStore.type}`);
        }
        BITVEC_NS_LSB.includes(bitOrder.namespace);
        return {
            info: TypeDefInfo.Plain,
            type: 'BitVec'
        };
    }
    /** @internal Extracts a ScaleInfo Compact into TypeDef.Compact */
    #extractCompact(_, { type }) {
        return withTypeString(this.registry, {
            info: TypeDefInfo.Compact,
            sub: this.#createSiDef(type)
        });
    }
    /** @internal Extracts a ScaleInfo Composite into TypeDef.{BTree*, Range*, Wrapper*} */
    #extractComposite(lookupIndex, { params, path }, { fields }) {
        if (path.length) {
            const pathFirst = path[0].toString();
            const pathLast = path[path.length - 1].toString();
            if (path.length === 1 && pathFirst === 'BTreeMap') {
                if (params.length !== 2) {
                    throw new Error(`BTreeMap requires 2 parameters, found ${params.length}`);
                }
                return withTypeString(this.registry, {
                    info: TypeDefInfo.BTreeMap,
                    sub: params.map(({ type }) => this.#createSiDef(type.unwrap()))
                });
            }
            else if (path.length === 1 && pathFirst === 'BTreeSet') {
                if (params.length !== 1) {
                    throw new Error(`BTreeSet requires 1 parameter, found ${params.length}`);
                }
                return withTypeString(this.registry, {
                    info: TypeDefInfo.BTreeSet,
                    sub: this.#createSiDef(params[0].type.unwrap())
                });
            }
            else if (['Range', 'RangeInclusive'].includes(pathFirst)) {
                if (params.length !== 1) {
                    throw new Error(`Range requires 1 parameter, found ${params.length}`);
                }
                return withTypeString(this.registry, {
                    info: pathFirst === 'Range'
                        ? TypeDefInfo.Range
                        : TypeDefInfo.RangeInclusive,
                    sub: this.#createSiDef(params[0].type.unwrap()),
                    type: pathFirst
                });
            }
            else if (['WrapperKeepOpaque', 'WrapperOpaque'].includes(pathLast)) {
                if (params.length !== 1) {
                    throw new Error(`WrapperOpaque requires 1 parameter, found ${params.length}`);
                }
                return withTypeString(this.registry, {
                    info: pathLast === 'WrapperKeepOpaque'
                        ? TypeDefInfo.WrapperKeepOpaque
                        : TypeDefInfo.WrapperOpaque,
                    sub: this.#createSiDef(params[0].type.unwrap()),
                    type: pathLast
                });
            }
        }
        return PATHS_SET.some((p) => matchParts(p, path))
            ? this.#extractCompositeSet(lookupIndex, params, fields)
            : this.#extractFields(lookupIndex, fields);
    }
    /** @internal Extracts a ScaleInfo CompositeSet into TypeDef.Set */
    #extractCompositeSet(_, params, fields) {
        if (params.length !== 1 || fields.length !== 1) {
            throw new Error('Set handling expects param/field as single entries');
        }
        return withTypeString(this.registry, {
            info: TypeDefInfo.Set,
            length: this.registry.createTypeUnsafe(this.registry.createLookupType(fields[0].type), []).bitLength(),
            sub: this.getSiType(params[0].type.unwrap()).def.asVariant.variants.map(({ index, name }) => ({
                // This will be an issue > 2^53 - 1 ... don't have those (yet)
                index: index.toNumber(),
                info: TypeDefInfo.Plain,
                name: name.toString(),
                type: 'Null'
            }))
        });
    }
    /** @internal Extracts ScaleInfo enum/struct fields into TypeDef.{Struct, Tuple} */
    #extractFields(lookupIndex, fields) {
        let isStruct = true;
        let isTuple = true;
        const count = fields.length;
        for (let f = 0; f < count; f++) {
            const { name } = fields[f];
            isStruct = isStruct && name.isSome;
            isTuple = isTuple && name.isNone;
        }
        if (!isTuple && !isStruct) {
            throw new Error('Invalid fields type detected, expected either Tuple (all unnamed) or Struct (all named)');
        }
        if (count === 0) {
            return {
                info: TypeDefInfo.Null,
                type: 'Null'
            };
        }
        else if (isTuple && count === 1) {
            const typeDef = this.#createSiDef(fields[0].type);
            return objectSpread({}, typeDef, lookupIndex === -1
                ? null
                : {
                    lookupIndex,
                    lookupName: this.#names[lookupIndex],
                    lookupNameRoot: typeDef.lookupName
                }, fields[0].typeName.isSome
                ? { typeName: sanitize(fields[0].typeName.unwrap()) }
                : null);
        }
        const [sub, alias] = this.#extractFieldsAlias(fields);
        return withTypeString(this.registry, objectSpread({
            info: isTuple // Tuple check first
                ? TypeDefInfo.Tuple
                : TypeDefInfo.Struct,
            sub
        }, alias.size
            ? { alias }
            : null, lookupIndex === -1
            ? null
            : {
                lookupIndex,
                lookupName: this.#names[lookupIndex]
            }));
    }
    /** @internal Apply field aliassed (with no JS conflicts) */
    #extractFieldsAlias(fields) {
        const alias = new Map();
        const count = fields.length;
        const sub = new Array(count);
        for (let i = 0; i < count; i++) {
            const { docs, name, type, typeName } = fields[i];
            const typeDef = this.#createSiDef(type);
            if (name.isNone) {
                sub[i] = typeDef;
            }
            else {
                const [nameField, nameOrig] = this.sanitizeField(name);
                if (nameField && nameOrig) {
                    alias.set(nameField, nameOrig);
                }
                sub[i] = objectSpread({
                    docs: sanitizeDocs(docs),
                    name: nameField
                }, typeDef, typeName.isSome
                    ? { typeName: sanitize(typeName.unwrap()) }
                    : null);
            }
        }
        return [sub, alias];
    }
    /** @internal Extracts an internal Historic (pre V14) type  */
    #extractHistoric(_, type) {
        return objectSpread({
            displayName: type.toString(),
            isFromSi: true
        }, getTypeDef(type));
    }
    /** @internal Extracts a ScaleInfo Primitive into TypeDef.Plain */
    #extractPrimitive(_, type) {
        const typeStr = type.def.asPrimitive.type.toString();
        return {
            info: TypeDefInfo.Plain,
            type: PRIMITIVE_ALIAS[typeStr] || typeStr.toLowerCase()
        };
    }
    /** @internal Applies an alias path onto the TypeDef */
    #extractAliasPath(_, type) {
        return {
            info: TypeDefInfo.Plain,
            type
        };
    }
    /** @internal Extracts a ScaleInfo Sequence into TypeDef.Vec (with Bytes shortcut) */
    #extractSequence(lookupIndex, { type }) {
        const sub = this.#createSiDef(type);
        if (sub.type === 'u8') {
            return {
                info: TypeDefInfo.Plain,
                type: 'Bytes'
            };
        }
        return withTypeString(this.registry, {
            info: TypeDefInfo.Vec,
            lookupIndex,
            lookupName: this.#names[lookupIndex],
            sub
        });
    }
    /** @internal Extracts a ScaleInfo Tuple into TypeDef.Tuple */
    #extractTuple(lookupIndex, ids) {
        if (ids.length === 0) {
            return {
                info: TypeDefInfo.Null,
                type: 'Null'
            };
        }
        else if (ids.length === 1) {
            return this.getTypeDef(ids[0]);
        }
        const sub = ids.map((t) => this.#createSiDef(t));
        return withTypeString(this.registry, {
            info: TypeDefInfo.Tuple,
            lookupIndex,
            lookupName: this.#names[lookupIndex],
            sub
        });
    }
    /** @internal Extracts a ScaleInfo Variant into TypeDef.{Option, Result, Enum} */
    #extractVariant(lookupIndex, { params, path }, { variants }) {
        if (path.length) {
            const specialVariant = path[0].toString();
            if (specialVariant === 'Option') {
                if (params.length !== 1) {
                    throw new Error(`Option requires 1 parameter, found ${params.length}`);
                }
                // NOTE This is opt-in (unhandled), not by default
                // if (sub.type === 'bool') {
                //   return withTypeString(this.registry, {
                //     info: TypeDefInfo.Plain,
                //     type: 'OptionBool'
                //   });
                // }
                return withTypeString(this.registry, {
                    info: TypeDefInfo.Option,
                    sub: this.#createSiDef(params[0].type.unwrap())
                });
            }
            else if (specialVariant === 'Result') {
                if (params.length !== 2) {
                    throw new Error(`Result requires 2 parameters, found ${params.length}`);
                }
                return withTypeString(this.registry, {
                    info: TypeDefInfo.Result,
                    sub: params.map(({ type }, index) => objectSpread({
                        name: ['Ok', 'Error'][index]
                    }, this.#createSiDef(type.unwrap())))
                });
            }
        }
        if (variants.length === 0) {
            return {
                info: TypeDefInfo.Null,
                type: 'Null'
            };
        }
        return this.#extractVariantEnum(lookupIndex, variants);
    }
    /** @internal Extracts a ScaleInfo Variant into TypeDef.Enum */
    #extractVariantEnum(lookupIndex, variants) {
        const sub = [];
        // we may get entries out of order, arrange them first before creating with gaps filled
        // NOTE: Since we mutate, use a copy of the array as an input
        variants
            .slice()
            .sort((a, b) => a.index.cmp(b.index))
            .forEach(({ fields, index: bnIndex, name }) => {
            const index = bnIndex.toNumber();
            while (sub.length !== index) {
                sub.push({
                    index: sub.length,
                    info: TypeDefInfo.Null,
                    name: `__Unused${sub.length}`,
                    type: 'Null'
                });
            }
            sub.push(objectSpread(this.#extractFields(-1, fields), {
                index,
                name: name.toString()
            }));
        });
        return withTypeString(this.registry, {
            info: TypeDefInfo.Enum,
            lookupIndex,
            lookupName: this.#names[lookupIndex],
            sub
        });
    }
}

/** @internal */
function flattenUniq(list, result = []) {
    for (let i = 0, count = list.length; i < count; i++) {
        const entry = list[i];
        if (Array.isArray(entry)) {
            flattenUniq(entry, result);
        }
        else {
            result.push(entry);
        }
    }
    return [...new Set(result)];
}

function getSiName(lookup, type) {
    const typeDef = lookup.getTypeDef(type);
    return typeDef.lookupName || typeDef.type;
}

function extractSubSingle(_, { sub }) {
    const { lookupName, type } = sub;
    return extractTypes$1([lookupName || type]);
}
function extractSubArray(_, { sub }) {
    return extractTypes$1(sub.map(({ lookupName, type }) => lookupName || type));
}
function unhandled(type, { info }) {
    throw new Error(`Unhandled: Unable to create and validate type from ${type} (info=${TypeDefInfo[info]})`);
}
const mapping = {
    [TypeDefInfo.BTreeMap]: extractSubArray,
    [TypeDefInfo.BTreeSet]: extractSubSingle,
    [TypeDefInfo.Compact]: extractSubSingle,
    [TypeDefInfo.DoNotConstruct]: unhandled,
    [TypeDefInfo.Enum]: extractSubArray,
    [TypeDefInfo.HashMap]: extractSubArray,
    [TypeDefInfo.Int]: unhandled,
    [TypeDefInfo.Linkage]: extractSubSingle,
    [TypeDefInfo.Null]: unhandled,
    [TypeDefInfo.Option]: extractSubSingle,
    [TypeDefInfo.Plain]: (_, typeDef) => typeDef.lookupName || typeDef.type,
    [TypeDefInfo.Range]: extractSubSingle,
    [TypeDefInfo.RangeInclusive]: extractSubSingle,
    [TypeDefInfo.Result]: extractSubArray,
    [TypeDefInfo.Set]: extractSubArray,
    [TypeDefInfo.Si]: unhandled,
    [TypeDefInfo.Struct]: extractSubArray,
    [TypeDefInfo.Tuple]: extractSubArray,
    [TypeDefInfo.UInt]: unhandled,
    [TypeDefInfo.Vec]: extractSubSingle,
    [TypeDefInfo.VecFixed]: extractSubSingle,
    [TypeDefInfo.WrapperKeepOpaque]: extractSubSingle,
    [TypeDefInfo.WrapperOpaque]: extractSubSingle
};
/** @internal */
function extractTypes$1(types) {
    const count = types.length;
    const result = new Array(count);
    for (let i = 0; i < count; i++) {
        const type = types[i];
        const typeDef = getTypeDef(type);
        result[i] = mapping[typeDef.info](type, typeDef);
    }
    return result;
}

const l$5 = logger('metadata');
/** @internal */
function validateTypes(registry, throwError, types) {
    const missing = flattenUniq(extractTypes$1(types))
        .filter((type) => !registry.hasType(type) &&
        !registry.isLookupType(type))
        .sort();
    if (missing.length !== 0) {
        const message = `Unknown types found, no types for ${missing.join(', ')}`;
        if (throwError) {
            throw new Error(message);
        }
        else {
            l$5.warn(message);
        }
    }
    return types;
}

/** @internal */
function extractTypes(lookup, types) {
    return types.map(({ type }) => lookup.getTypeDef(type).type);
}
/** @internal */
function extractFieldTypes(lookup, type) {
    return lookup.getSiType(type).def.asVariant.variants.map(({ fields }) => extractTypes(lookup, fields));
}
/** @internal */
function getPalletNames({ lookup, pallets }) {
    return pallets.reduce((all, { calls, constants, events, storage }) => {
        all.push([extractTypes(lookup, constants)]);
        if (calls.isSome) {
            all.push(extractFieldTypes(lookup, calls.unwrap().type));
        }
        if (events.isSome) {
            all.push(extractFieldTypes(lookup, events.unwrap().type));
        }
        if (storage.isSome) {
            all.push(storage.unwrap().items.map(({ type }) => {
                if (type.isPlain) {
                    return [lookup.getTypeDef(type.asPlain).type];
                }
                const { hashers, key, value } = type.asMap;
                return hashers.length === 1
                    ? [
                        lookup.getTypeDef(value).type,
                        lookup.getTypeDef(key).type
                    ]
                    : [
                        lookup.getTypeDef(value).type,
                        ...lookup.getSiType(key).def.asTuple.map((t) => lookup.getTypeDef(t).type)
                    ];
            }));
        }
        return all;
    }, []);
}
/** @internal */
function getUniqTypes(registry, meta, throwError) {
    return validateTypes(registry, throwError, flattenUniq(getPalletNames(meta)));
}

function trimDocs(docs) {
    const strings = docs.map((d) => d.toString().trim());
    const firstEmpty = strings.findIndex((d) => !d.length);
    return firstEmpty === -1
        ? strings
        : strings.slice(0, firstEmpty);
}
/** @internal */
function toCallsOnly(registry, { extrinsic, lookup, pallets }) {
    return registry.createTypeUnsafe('MetadataLatest', [{
            extrinsic,
            lookup: {
                types: lookup.types.map(({ id, type }) => registry.createTypeUnsafe('PortableType', [{
                        id,
                        type: objectSpread({}, type, { docs: trimDocs(type.docs) })
                    }]))
            },
            pallets: pallets.map(({ calls, index, name }) => ({
                calls: registry.createTypeUnsafe('Option<PalletCallMetadataLatest>', [calls.unwrapOr(null)]),
                index,
                name
            }))
        }]).toJSON();
}

/** @internal */
function unwrapStorageSi(type) {
    return type.isPlain
        ? type.asPlain
        : type.asMap.value;
}
/** @internal */
function unwrapStorageType(registry, type, isOptional) {
    const outputType = getSiName(registry.lookup, unwrapStorageSi(type));
    return isOptional
        ? `Option<${outputType}>`
        : outputType;
}

function lazyVariants(lookup, { type }, getName, creator) {
    const result = {};
    const variants = lookup.getSiType(type).def.asVariant.variants;
    for (let i = 0, count = variants.length; i < count; i++) {
        lazyMethod(result, variants[i], creator, getName, i);
    }
    return result;
}

const emptyCheck = {
    extrinsic: {},
    payload: {}
};

const polkadot = {
    LimitParathreadCommits: emptyCheck,
    OnlyStakingAndClaims: emptyCheck,
    PrevalidateAttests: emptyCheck,
    RestrictFunctionality: emptyCheck,
    TransactionCallFilter: emptyCheck,
    ValidateDoubleVoteReports: emptyCheck
};

const shell = {
    DisallowSigned: emptyCheck
};

const statemint = {
    ChargeAssetTxPayment: {
        extrinsic: {
            tip: 'Compact<Balance>',
            // eslint-disable-next-line sort-keys
            assetId: 'TAssetConversion'
        },
        payload: {}
    }
};

const CheckMetadataHash = {
    extrinsic: {
        mode: 'u8'
    },
    payload: {
        metadataHash: 'Option<[u8;32]>'
    }
};
const CheckMortality = {
    extrinsic: {
        era: 'ExtrinsicEra'
    },
    payload: {
        blockHash: 'Hash'
    }
};
const ChargeTransactionPayment = {
    extrinsic: {
        tip: 'Compact<Balance>'
    },
    payload: {}
};
const substrate$1 = {
    ChargeTransactionPayment,
    CheckBlockGasLimit: emptyCheck,
    CheckEra: CheckMortality,
    CheckGenesis: {
        extrinsic: {},
        payload: {
            genesisHash: 'Hash'
        }
    },
    CheckMetadataHash,
    CheckMortality,
    CheckNonZeroSender: emptyCheck,
    CheckNonce: {
        extrinsic: {
            nonce: 'Compact<Index>'
        },
        payload: {}
    },
    CheckSpecVersion: {
        extrinsic: {},
        payload: {
            specVersion: 'u32'
        }
    },
    CheckTxVersion: {
        extrinsic: {},
        payload: {
            transactionVersion: 'u32'
        }
    },
    CheckVersion: {
        extrinsic: {},
        payload: {
            specVersion: 'u32'
        }
    },
    CheckWeight: emptyCheck,
    LockStakingStatus: emptyCheck,
    SkipCheckIfFeeless: ChargeTransactionPayment,
    ValidateEquivocationReport: emptyCheck,
    WeightReclaim: emptyCheck
};

const allExtensions = objectSpread({}, substrate$1, polkadot, shell, statemint);
const fallbackExtensions = [
    'CheckVersion',
    'CheckGenesis',
    'CheckEra',
    'CheckNonce',
    'CheckWeight',
    'ChargeTransactionPayment',
    'CheckBlockGasLimit'
];
function findUnknownExtensions(extensions, userExtensions = {}) {
    const names = [...Object.keys(allExtensions), ...Object.keys(userExtensions)];
    return extensions.filter((k) => !names.includes(k));
}
function expandExtensionTypes(extensions, type, userExtensions = {}) {
    return extensions
        // Always allow user extensions first - these should provide overrides
        .map((k) => userExtensions[k] || allExtensions[k])
        .filter((info) => !!info)
        .reduce((result, info) => objectSpread(result, info[type]), {});
}

/** @internal */
function decodeEvent(registry, value) {
    if (!value?.length) {
        return { DataType: Null };
    }
    const index = value.subarray(0, 2);
    return {
        DataType: registry.findMetaEvent(index),
        value: {
            data: value.subarray(2),
            index
        }
    };
}
/**
 * @name GenericEventData
 * @description
 * Wrapper for the actual data that forms part of an [[Event]]
 */
class GenericEventData extends Tuple {
    #meta;
    #method;
    #names = null;
    #section;
    #typeDef;
    constructor(registry, value, meta, section = '<unknown>', method = '<unknown>') {
        const fields = meta?.fields || [];
        super(registry, fields.map(({ type }) => registry.createLookupType(type)), value);
        this.#meta = meta;
        this.#method = method;
        this.#section = section;
        this.#typeDef = fields.map(({ type }) => registry.lookup.getTypeDef(type));
        const names = fields
            .map(({ name }) => registry.lookup.sanitizeField(name)[0])
            .filter((n) => !!n);
        if (names.length === fields.length) {
            this.#names = names;
            objectProperties(this, names, (_, i) => this[i]);
        }
    }
    /**
     * @description The wrapped [[EventMetadata]]
     */
    get meta() {
        return this.#meta;
    }
    /**
     * @description The method as a string
     */
    get method() {
        return this.#method;
    }
    /**
     * @description The field names (as available)
     */
    get names() {
        return this.#names;
    }
    /**
     * @description The section as a string
     */
    get section() {
        return this.#section;
    }
    /**
     * @description The [[TypeDef]] for this event
     */
    get typeDef() {
        return this.#typeDef;
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman(isExtended, disableAscii) {
        if (this.#names !== null) {
            const json = {};
            for (let i = 0, count = this.#names.length; i < count; i++) {
                json[this.#names[i]] = this[i].toHuman(isExtended, disableAscii);
            }
            return json;
        }
        return super.toHuman(isExtended);
    }
}
/**
 * @name GenericEvent
 * @description
 * A representation of a system event. These are generated via the [[Metadata]] interfaces and
 * specific to a specific Substrate runtime
 */
class GenericEvent extends Struct {
    // Currently we _only_ decode from Uint8Array, since we expect it to
    // be used via EventRecord
    constructor(registry, _value) {
        const { DataType, value } = decodeEvent(registry, _value);
        super(registry, {
            index: 'EventId',
            // eslint-disable-next-line sort-keys
            data: DataType
        }, value);
    }
    /**
     * @description The wrapped [[EventData]]
     */
    get data() {
        return this.getT('data');
    }
    /**
     * @description The [[EventId]], identifying the raw event
     */
    get index() {
        return this.getT('index');
    }
    /**
     * @description The [[EventMetadata]] with the documentation
     */
    get meta() {
        return this.data.meta;
    }
    /**
     * @description The method string identifying the event
     */
    get method() {
        return this.data.method;
    }
    /**
     * @description The section string identifying the event
     */
    get section() {
        return this.data.section;
    }
    /**
     * @description The [[TypeDef]] for the event
     */
    get typeDef() {
        return this.data.typeDef;
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman(isExpanded, disableAscii) {
        return objectSpread({
            method: this.method,
            section: this.section
        }, isExpanded
            ? { docs: this.meta.docs.map((d) => d.toString()) }
            : null, super.toHuman(isExpanded, disableAscii));
    }
}

const BIT_SIGNED = 0b10000000;
const BIT_UNSIGNED = 0;
const EMPTY_U8A = new Uint8Array();
const IMMORTAL_ERA = new Uint8Array([0]);
const UNMASK_VERSION = 0b01111111;
const DEFAULT_PREAMBLE = 'bare';
const LATEST_EXTRINSIC_VERSION = 4;
const VERSION_MASK = 0b00111111;
const TYPE_MASK = 0b11000000;
const BARE_EXTRINSIC = 0b00000000;
const GENERAL_EXTRINSIC = 0b01000000;
const LOWEST_SUPPORTED_EXTRINSIC_FORMAT_VERSION = 4;

const VERSIONS$1 = [
    'ExtrinsicUnknown', // v0 is unknown
    'ExtrinsicUnknown',
    'ExtrinsicUnknown',
    'ExtrinsicUnknown',
    'ExtrinsicV4',
    'ExtrinsicV5'
];
const PREAMBLE = {
    bare: 'ExtrinsicV5',
    general: 'GeneralExtrinsic'
};
const PreambleMask = {
    bare: BARE_EXTRINSIC,
    general: GENERAL_EXTRINSIC
};
const preambleUnMask = {
    0: 'bare',
    // eslint-disable-next-line sort-keys
    64: 'general'
};
/** @internal */
function newFromValue(registry, value, version, preamble) {
    if (value instanceof GenericExtrinsic) {
        return value.unwrap();
    }
    const isSigned = (version & BIT_SIGNED) === BIT_SIGNED;
    const type = (version & VERSION_MASK) === 5 ? PREAMBLE[preamble] : VERSIONS$1[version & VERSION_MASK] || VERSIONS$1[0];
    // we cast here since the VERSION definition is incredibly broad - we don't have a
    // slice for "only add extrinsic types", and more string definitions become unwieldy
    return registry.createTypeUnsafe(type, [value, { isSigned, version }]);
}
/** @internal */
function decodeExtrinsic(registry, value, version = LOWEST_SUPPORTED_EXTRINSIC_FORMAT_VERSION, preamble = DEFAULT_PREAMBLE) {
    if (isU8a(value) || Array.isArray(value) || isHex(value)) {
        return decodeU8a$5(registry, u8aToU8a(value), version, preamble);
    }
    else if (value instanceof registry.createClassUnsafe('Call')) {
        return newFromValue(registry, { method: value }, version, preamble);
    }
    return newFromValue(registry, value, version, preamble);
}
/** @internal */
function decodeU8a$5(registry, value, version, preamble) {
    if (!value.length) {
        return newFromValue(registry, new Uint8Array(), version, preamble);
    }
    const [offset, length] = compactFromU8a(value);
    const total = offset + length.toNumber();
    if (total > value.length) {
        throw new Error(`Extrinsic: length less than remainder, expected at least ${total}, found ${value.length}`);
    }
    const data = value.subarray(offset, total);
    const unmaskedPreamble = data[0] & TYPE_MASK;
    if (preambleUnMask[`${unmaskedPreamble}`] === 'general') {
        // NOTE: GeneralExtrinsic needs to have the full data to validate the preamble and version
        return newFromValue(registry, value, data[0], preambleUnMask[`${unmaskedPreamble}`] || preamble);
    }
    else {
        return newFromValue(registry, data.subarray(1), data[0], preambleUnMask[`${unmaskedPreamble}`] || preamble);
    }
}
class ExtrinsicBase extends AbstractBase {
    #preamble;
    constructor(registry, value, initialU8aLength, preamble) {
        super(registry, value, initialU8aLength);
        const signKeys = Object.keys(registry.getSignedExtensionTypes());
        if (this.version === 5 && preamble !== 'general') {
            const getter = (key) => this.inner.signature[key];
            // This is on the abstract class, ensuring that hasOwnProperty operates
            // correctly, i.e. it needs to be on the base class exposing it
            for (let i = 0, count = signKeys.length; i < count; i++) {
                objectProperty(this, signKeys[i], getter);
            }
        }
        const unmaskedPreamble = this.type & TYPE_MASK;
        this.#preamble = preamble || preambleUnMask[`${unmaskedPreamble}`];
    }
    isGeneral() {
        return this.#preamble === 'general';
    }
    /**
     * @description The arguments passed to for the call, exposes args so it is compatible with [[Call]]
     */
    get args() {
        return this.method.args;
    }
    /**
     * @description The argument definitions, compatible with [[Call]]
     */
    get argsDef() {
        return this.method.argsDef;
    }
    /**
     * @description The actual `[sectionIndex, methodIndex]` as used in the Call
     */
    get callIndex() {
        return this.method.callIndex;
    }
    /**
     * @description The actual data for the Call
     */
    get data() {
        return this.method.data;
    }
    /**
     * @description The era for this extrinsic
     */
    get era() {
        return this.isGeneral()
            ? this.inner.era
            : this.inner.signature.era;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        return this.toU8a().length;
    }
    /**
     * @description `true` id the extrinsic is signed
     */
    get isSigned() {
        return this.isGeneral()
            ? false
            : this.inner.signature.isSigned;
    }
    /**
     * @description The length of the actual data, excluding prefix
     */
    get length() {
        return this.toU8a(true).length;
    }
    /**
     * @description The [[FunctionMetadataLatest]] that describes the extrinsic
     */
    get meta() {
        return this.method.meta;
    }
    /**
     * @description The [[Call]] this extrinsic wraps
     */
    get method() {
        return this.inner.method;
    }
    /**
     * @description The nonce for this extrinsic
     */
    get nonce() {
        return this.isGeneral()
            ? this.inner.nonce
            : this.inner.signature.nonce;
    }
    /**
     * @description The actual [[EcdsaSignature]], [[Ed25519Signature]] or [[Sr25519Signature]]
     */
    get signature() {
        if (this.isGeneral()) {
            throw new Error('Extrinsic: GeneralExtrinsic does not have signature implemented');
        }
        return this.inner.signature.signature;
    }
    /**
     * @description The [[Address]] that signed
     */
    get signer() {
        if (this.isGeneral()) {
            throw new Error('Extrinsic: GeneralExtrinsic does not have signer implemented');
        }
        return this.inner.signature.signer;
    }
    /**
     * @description Forwards compat
     */
    get tip() {
        return this.isGeneral()
            ? this.inner.tip
            : this.inner.signature.tip;
    }
    /**
     * @description Forward compat
     */
    get assetId() {
        return this.isGeneral()
            ? this.inner.assetId
            : this.inner.signature.assetId;
    }
    /**
     * @description Forward compat
     */
    get metadataHash() {
        return this.isGeneral()
            ? this.inner.metadataHash
            : this.inner.signature.metadataHash;
    }
    /**
     * @description Forward compat
     */
    get mode() {
        return this.isGeneral()
            ? this.inner.mode
            : this.inner.signature.mode;
    }
    /**
     * @description Returns the raw transaction version (not flagged with signing information)
    */
    get type() {
        return this.inner.version;
    }
    get inner() {
        return this.unwrap();
    }
    /**
     * @description Returns the encoded version flag
    */
    get version() {
        if (this.type <= LOWEST_SUPPORTED_EXTRINSIC_FORMAT_VERSION) {
            return this.type | (this.isSigned ? BIT_SIGNED : BIT_UNSIGNED);
        }
        else {
            if (this.isSigned) {
                throw new Error('Signed Extrinsics are currently only available for ExtrinsicV4');
            }
            return this.type | (this.isGeneral() ? PreambleMask.general : PreambleMask.bare);
        }
    }
    /**
     * @description Checks if the source matches this in type
     */
    is(other) {
        return this.method.is(other);
    }
    unwrap() {
        return super.unwrap();
    }
}
/**
 * @name GenericExtrinsic
 * @description
 * Representation of an Extrinsic in the system. It contains the actual call,
 * (optional) signature and encodes with an actual length prefix
 *
 * {@link https://github.com/paritytech/wiki/blob/master/Extrinsic.md#the-extrinsic-format-for-node}.
 *
 * Can be:
 * - signed, to create a transaction
 * - left as is, to create an inherent
 */
class GenericExtrinsic extends ExtrinsicBase {
    #hashCache;
    static LATEST_EXTRINSIC_VERSION = LATEST_EXTRINSIC_VERSION;
    constructor(registry, value, { preamble, version } = {}) {
        const versionsLength = registry.metadata.extrinsic.versions.length;
        // TODO: Once ExtrinsicV5 is fully supported update this to use the highest supported verion which is the last item of the array
        const supportedVersion = versionsLength ? registry.metadata.extrinsic.versions[0] : undefined;
        super(registry, decodeExtrinsic(registry, value, version || supportedVersion, preamble), undefined, preamble);
    }
    /**
     * @description returns a hash of the contents
     */
    get hash() {
        if (!this.#hashCache) {
            this.#hashCache = super.hash;
        }
        return this.#hashCache;
    }
    /**
     * @description Injects an already-generated signature into the extrinsic
     */
    addSignature(signer, signature, payload) {
        this.inner.addSignature(signer, signature, payload);
        this.#hashCache = undefined;
        return this;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        const encoded = u8aConcat(...this.toU8aInner());
        return {
            inner: this.isSigned
                ? this.inner.inspect().inner
                : this.inner.method.inspect().inner,
            outer: [compactToU8a(encoded.length), new Uint8Array([this.version])]
        };
    }
    /**
     * @description Sign the extrinsic with a specific keypair
     */
    sign(account, options) {
        this.inner.sign(account, options);
        this.#hashCache = undefined;
        return this;
    }
    /**
     * @describe Adds a fake signature to the extrinsic
     */
    signFake(signer, options) {
        this.inner.signFake(signer, options);
        this.#hashCache = undefined;
        return this;
    }
    /**
     * @description Returns a hex string representation of the value
     */
    toHex(isBare) {
        return u8aToHex(this.toU8a(isBare));
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman(isExpanded, disableAscii) {
        return objectSpread({}, {
            isSigned: this.isSigned,
            method: this.method.toHuman(isExpanded, disableAscii)
        }, this.isSigned
            ? {
                assetId: this.assetId ? this.assetId.toHuman(isExpanded, disableAscii) : null,
                era: this.era.toHuman(isExpanded, disableAscii),
                metadataHash: this.metadataHash ? this.metadataHash.toHex() : null,
                mode: this.mode ? this.mode.toHuman() : null,
                nonce: this.nonce.toHuman(isExpanded, disableAscii),
                signature: this.signature.toHex(),
                signer: this.signer.toHuman(isExpanded, disableAscii),
                tip: this.tip.toHuman(isExpanded, disableAscii)
            }
            : null);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        return this.toHex();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'Extrinsic';
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value is not length-prefixed
     */
    toU8a(isBare) {
        const encoded = u8aConcat(...this.toU8aInner());
        return isBare
            ? encoded
            : compactAddLength(encoded);
    }
    toU8aInner() {
        // we do not apply bare to the internal values, rather this only determines out length addition,
        // where we strip all lengths this creates an extrinsic that cannot be decoded
        return [
            new Uint8Array([this.version]),
            this.inner.toU8a()
        ];
    }
}

function getTrailingZeros(period) {
    const binary = period.toString(2);
    let index = 0;
    while (binary[binary.length - 1 - index] === '0') {
        index++;
    }
    return index;
}
/** @internal */
function decodeMortalEra(registry, value) {
    if (isU8a(value) || isHex(value) || Array.isArray(value)) {
        return decodeMortalU8a(registry, u8aToU8a(value));
    }
    else if (!value) {
        return [new u64(registry), new u64(registry)];
    }
    else if (isObject(value)) {
        return decodeMortalObject(registry, value);
    }
    throw new Error('Invalid data passed to Mortal era');
}
/** @internal */
function decodeMortalObject(registry, value) {
    const { current, period } = value;
    let calPeriod = Math.pow(2, Math.ceil(Math.log2(period)));
    calPeriod = Math.min(Math.max(calPeriod, 4), 1 << 16);
    const phase = current % calPeriod;
    const quantizeFactor = Math.max(calPeriod >> 12, 1);
    const quantizedPhase = phase / quantizeFactor * quantizeFactor;
    return [new u64(registry, calPeriod), new u64(registry, quantizedPhase)];
}
/** @internal */
function decodeMortalU8a(registry, value) {
    if (value.length === 0) {
        return [new u64(registry), new u64(registry)];
    }
    const first = u8aToBn(value.subarray(0, 1)).toNumber();
    const second = u8aToBn(value.subarray(1, 2)).toNumber();
    const encoded = first + (second << 8);
    const period = 2 << (encoded % (1 << 4));
    const quantizeFactor = Math.max(period >> 12, 1);
    const phase = (encoded >> 4) * quantizeFactor;
    if (period < 4 || phase >= period) {
        throw new Error('Invalid data passed to Mortal era');
    }
    return [new u64(registry, period), new u64(registry, phase)];
}
/** @internal */
function decodeExtrinsicEra(value = new Uint8Array()) {
    if (isU8a(value)) {
        return (!value.length || value[0] === 0)
            ? new Uint8Array([0])
            : new Uint8Array([1, value[0], value[1]]);
    }
    else if (!value) {
        return new Uint8Array([0]);
    }
    else if (value instanceof GenericExtrinsicEra) {
        return decodeExtrinsicEra(value.toU8a());
    }
    else if (isHex(value)) {
        return decodeExtrinsicEra(hexToU8a(value));
    }
    else if (isObject(value)) {
        const entries = Object.entries(value).map(([k, v]) => [k.toLowerCase(), v]);
        const mortal = entries.find(([k]) => k.toLowerCase() === 'mortalera');
        const immortal = entries.find(([k]) => k.toLowerCase() === 'immortalera');
        // this is to de-serialize from JSON
        return mortal
            ? { MortalEra: mortal[1] }
            : immortal
                ? { ImmortalEra: immortal[1] }
                : { MortalEra: value };
    }
    throw new Error('Invalid data passed to Era');
}
/**
 * @name ImmortalEra
 * @description
 * The ImmortalEra for an extrinsic
 */
class ImmortalEra extends Raw {
    constructor(registry, _value) {
        // For immortals, we always provide the known value (i.e. treated as a
        // constant no matter how it is constructed - it is a fixed structure)
        super(registry, IMMORTAL_ERA);
    }
}
/**
 * @name MortalEra
 * @description
 * The MortalEra for an extrinsic, indicating period and phase
 */
class MortalEra extends Tuple {
    constructor(registry, value) {
        super(registry, {
            period: u64,
            phase: u64
        }, decodeMortalEra(registry, value));
    }
    /**
     * @description Encoded length for mortals occupy 2 bytes, different from the actual Tuple since it is encoded. This is a shortcut fro `toU8a().length`
     */
    get encodedLength() {
        return 2 | 0;
    }
    /**
     * @description The period of this Mortal wraps as a [[U64]]
     */
    get period() {
        return this[0];
    }
    /**
     * @description The phase of this Mortal wraps as a [[U64]]
     */
    get phase() {
        return this[1];
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman() {
        return {
            period: formatNumber(this.period),
            phase: formatNumber(this.phase)
        };
    }
    /**
     * @description Returns a JSON representation of the actual value
     */
    toJSON() {
        return this.toHex();
    }
    /**
     * @description Encodes the value as a Uint8Array as per the parity-codec specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     * Period and phase are encoded:
     *   - The period of validity from the block hash found in the signing material.
     *   - The phase in the period that this transaction's lifetime begins (and, importantly,
     *     implies which block hash is included in the signature material). If the `period` is
     *     greater than 1 << 12, then it will be a factor of the times greater than 1<<12 that
     *     `period` is.
     */
    toU8a(_isBare) {
        const period = this.period.toNumber();
        const encoded = Math.min(15, Math.max(1, getTrailingZeros(period) - 1)) + ((this.phase.toNumber() / Math.max(period >> 12, 1)) << 4);
        return new Uint8Array([
            encoded & 0xff,
            encoded >> 8
        ]);
    }
    /**
     * @description Get the block number of the start of the era whose properties this object describes that `current` belongs to.
     */
    birth(current) {
        const phase = this.phase.toNumber();
        const period = this.period.toNumber();
        // FIXME No toNumber() here
        return (~~((Math.max(bnToBn(current).toNumber(), phase) - phase) / period) * period) + phase;
    }
    /**
     * @description Get the block number of the first block at which the era has ended.
     */
    death(current) {
        // FIXME No toNumber() here
        return this.birth(current) + this.period.toNumber();
    }
}
/**
 * @name GenericExtrinsicEra
 * @description
 * The era for an extrinsic, indicating either a mortal or immortal extrinsic
 */
class GenericExtrinsicEra extends Enum {
    constructor(registry, value) {
        super(registry, {
            ImmortalEra,
            MortalEra
        }, decodeExtrinsicEra(value));
    }
    /**
     * @description Override the encoded length method
     */
    get encodedLength() {
        return this.isImmortalEra
            ? this.asImmortalEra.encodedLength
            : this.asMortalEra.encodedLength;
    }
    /**
     * @description Returns the item as a [[ImmortalEra]]
     */
    get asImmortalEra() {
        if (!this.isImmortalEra) {
            throw new Error(`Cannot convert '${this.type}' via asImmortalEra`);
        }
        return this.inner;
    }
    /**
     * @description Returns the item as a [[MortalEra]]
     */
    get asMortalEra() {
        if (!this.isMortalEra) {
            throw new Error(`Cannot convert '${this.type}' via asMortalEra`);
        }
        return this.inner;
    }
    /**
     * @description `true` if Immortal
     */
    get isImmortalEra() {
        return this.index === 0;
    }
    /**
     * @description `true` if Mortal
     */
    get isMortalEra() {
        return this.index > 0;
    }
    /**
     * @description Encodes the value as a Uint8Array as per the parity-codec specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8a(isBare) {
        return this.isMortalEra
            ? this.asMortalEra.toU8a(isBare)
            : this.asImmortalEra.toU8a(isBare);
    }
}

const VERSIONS = [
    'ExtrinsicPayloadUnknown', // v0 is unknown
    'ExtrinsicPayloadUnknown',
    'ExtrinsicPayloadUnknown',
    'ExtrinsicPayloadUnknown',
    'ExtrinsicPayloadV4',
    'ExtrinsicPayloadV5'
];
const PREAMBLES = {
    bare: 'ExtrinsicPayloadV5',
    // Not supported yet
    general: 'ExtrinsicPayloadV5'
};
/**
 * HACK: In order to change the assetId from `number | object` to HexString (While maintaining the true type ie Option<TAssetConversion>),
 * to allow for easier generalization of the SignerPayloadJSON interface the below check is necessary. The ExtrinsicPayloadV4 class does not like
 * a value passed in as an Option, and can't decode it properly. Therefore, we ensure to convert the following below, and then pass the option as a unwrapped
 * JSON value.
 *
 * ref: https://github.com/polkadot-js/api/pull/5968
 * ref: https://github.com/polkadot-js/api/pull/5967
 */
function decodeAssetId(registry, payload) {
    const maybeAsset = payload?.assetId;
    if (maybeAsset && isHex(maybeAsset)) {
        const assetId = registry.createType('TAssetConversion', hexToU8a(maybeAsset));
        // we only want to adjust the payload if the hex passed has the option
        if (maybeAsset === '0x00' || maybeAsset === '0x01' + assetId.toHex().slice(2)) {
            return {
                ...payload,
                assetId: assetId.toJSON()
            };
        }
    }
    return payload;
}
/** @internal */
function decodeExtrinsicPayload(registry, value, version = LATEST_EXTRINSIC_VERSION, preamble = DEFAULT_PREAMBLE) {
    if (value instanceof GenericExtrinsicPayload) {
        return value.unwrap();
    }
    const extVersion = version === 5 ? PREAMBLES[preamble] : VERSIONS[version] || VERSIONS[0];
    const payload = decodeAssetId(registry, value);
    return registry.createTypeUnsafe(extVersion, [payload, { version }]);
}
/**
 * @name GenericExtrinsicPayload
 * @description
 * A signing payload for an [[Extrinsic]]. For the final encoding, it is variable length based
 * on the contents included
 */
class GenericExtrinsicPayload extends AbstractBase {
    constructor(registry, value, { preamble, version } = {}) {
        super(registry, decodeExtrinsicPayload(registry, value, version, preamble));
    }
    /**
     * @description The block [[BlockHash]] the signature applies to (mortal/immortal)
     */
    get blockHash() {
        return this.inner.blockHash;
    }
    /**
     * @description The [[ExtrinsicEra]]
     */
    get era() {
        return this.inner.era;
    }
    /**
     * @description The genesis block [[BlockHash]] the signature applies to
     */
    get genesisHash() {
        // NOTE only v3+
        return this.inner.genesisHash || this.registry.createTypeUnsafe('Hash', []);
    }
    /**
     * @description The [[Bytes]] contained in the payload
     */
    get method() {
        return this.inner.method;
    }
    /**
     * @description The [[Index]]
     */
    get nonce() {
        return this.inner.nonce;
    }
    /**
     * @description The specVersion as a [[u32]] for this payload
     */
    get specVersion() {
        // NOTE only v3+
        return this.inner.specVersion || this.registry.createTypeUnsafe('u32', []);
    }
    /**
     * @description The [[Balance]]
     */
    get tip() {
        // NOTE from v2+
        return this.inner.tip || this.registry.createTypeUnsafe('Compact<Balance>', []);
    }
    /**
     * @description The transaction version as a [[u32]] for this payload
     */
    get transactionVersion() {
        // NOTE only v4+
        return this.inner.transactionVersion || this.registry.createTypeUnsafe('u32', []);
    }
    /**
     * @description The (optional) asset id as a [[u32]] or [[MultiLocation]] for this payload
     */
    get assetId() {
        return this.inner.assetId;
    }
    /**
     * @description The (optional) [[Hash]] of the genesis metadata for this payload
     */
    get metadataHash() {
        return this.inner.metadataHash;
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        return this.inner.eq(other);
    }
    /**
     * @description Sign the payload with the keypair
     */
    sign(signerPair) {
        const signature = this.inner.sign(signerPair);
        // This is extensible, so we could quite readily extend to send back extra
        // information, such as for instance the payload, i.e. `payload: this.toHex()`
        // For the case here we sign via the extrinsic, we ignore the return, so generally
        // this is applicable for external signing
        return {
            signature: u8aToHex(signature)
        };
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman(isExtended, disableAscii) {
        return this.inner.toHuman(isExtended, disableAscii);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        return this.toHex();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'ExtrinsicPayload';
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        return this.toHex();
    }
    /**
     * @description Returns a serialized u8a form
     */
    toU8a(isBare) {
        // call our parent, with only the method stripped
        return super.toU8a(isBare ? { method: true } : false);
    }
}

/**
 * @name GenericExtrinsicPayloadUnknown
 * @description
 * A default handler for payloads where the version is not known (default throw)
 */
class GenericExtrinsicPayloadUnknown extends Struct {
    constructor(registry, _value, { version = 0 } = {}) {
        super(registry, {});
        throw new Error(`Unsupported extrinsic payload version ${version}`);
    }
}

/**
 * @name GenericExtrinsicUnknown
 * @description
 * A default handler for extrinsics where the version is not known (default throw)
 */
class GenericExtrinsicUnknown extends Struct {
    constructor(registry, _value, { isSigned = false, version = 0 } = {}) {
        super(registry, {});
        throw new Error(`Unsupported ${isSigned ? '' : 'un'}signed extrinsic version ${version & UNMASK_VERSION}`);
    }
}

const knownTypes = {
    address: 'Address',
    assetId: 'Option<TAssetConversion>',
    blockHash: 'Hash',
    blockNumber: 'BlockNumber',
    era: 'ExtrinsicEra',
    genesisHash: 'Hash',
    metadataHash: 'Option<[u8;32]>',
    method: 'Call',
    mode: 'u8',
    nonce: 'Compact<Index>',
    runtimeVersion: 'RuntimeVersion',
    signedExtensions: 'Vec<Text>',
    tip: 'Compact<Balance>',
    version: 'u8'
};
/**
 * @name GenericSignerPayload
 * @description
 * A generic signer payload that can be used for serialization between API and signer
 */
class GenericSignerPayload extends Struct {
    #extraTypes;
    constructor(registry, value) {
        const extensionTypes = objectSpread({}, registry.getSignedExtensionTypes(), registry.getSignedExtensionExtra());
        super(registry, objectSpread({}, extensionTypes, knownTypes, { withSignedTransaction: 'bool' }), value);
        this.#extraTypes = {};
        const getter = (key) => this.get(key);
        // add all extras that are not in the base types
        for (const [key, type] of Object.entries(extensionTypes)) {
            if (!knownTypes[key]) {
                this.#extraTypes[key] = type;
            }
            objectProperty(this, key, getter);
        }
    }
    get address() {
        return this.getT('address');
    }
    get blockHash() {
        return this.getT('blockHash');
    }
    get blockNumber() {
        return this.getT('blockNumber');
    }
    get era() {
        return this.getT('era');
    }
    get genesisHash() {
        return this.getT('genesisHash');
    }
    get method() {
        return this.getT('method');
    }
    get nonce() {
        return this.getT('nonce');
    }
    get runtimeVersion() {
        return this.getT('runtimeVersion');
    }
    get signedExtensions() {
        return this.getT('signedExtensions');
    }
    get tip() {
        return this.getT('tip');
    }
    get assetId() {
        return this.getT('assetId');
    }
    get version() {
        return this.getT('version');
    }
    get mode() {
        return this.getT('mode');
    }
    get metadataHash() {
        return this.getT('metadataHash');
    }
    get withSignedTransaction() {
        const val = this.getT('withSignedTransaction');
        return val.isTrue;
    }
    /**
     * @description Creates an representation of the structure as an ISignerPayload JSON
     */
    toPayload() {
        const result = {};
        const keys = Object.keys(this.#extraTypes);
        // add any explicit overrides we may have
        for (let i = 0, count = keys.length; i < count; i++) {
            const key = keys[i];
            const value = this.getT(key);
            // Don't include Option.isNone
            if (!(value instanceof Option) || value.isSome) {
                // NOTE In the spread below we convert (mostly) to Hex to align
                // with the typings. In the case of "unknown" fields, we use the
                // primitive toJSON conversion (which is serializable). Technically
                // we can include isNone in here as well ("null" is allowed), however
                // for empty fields we just skip it completely (historical compat)
                result[key] = value.toJSON();
            }
        }
        return objectSpread(result, {
            // the known defaults as managed explicitly and has different
            // formatting in cases, e.g. we mostly expose a hex format here
            address: this.address.toString(),
            assetId: this.assetId && this.assetId.isSome ? this.assetId.toHex() : null,
            blockHash: this.blockHash.toHex(),
            blockNumber: this.blockNumber.toHex(),
            era: this.era.toHex(),
            genesisHash: this.genesisHash.toHex(),
            metadataHash: this.metadataHash.isSome ? this.metadataHash.toHex() : null,
            method: this.method.toHex(),
            mode: this.mode.toNumber(),
            nonce: this.nonce.toHex(),
            signedExtensions: this.signedExtensions.map((e) => e.toString()),
            specVersion: this.runtimeVersion.specVersion.toHex(),
            tip: this.tip.toHex(),
            transactionVersion: this.runtimeVersion.transactionVersion.toHex(),
            version: this.version.toNumber(),
            withSignedTransaction: this.withSignedTransaction
        });
    }
    /**
     * @description Creates a representation of the payload in raw Exrinsic form
     */
    toRaw() {
        const payload = this.toPayload();
        const data = u8aToHex(this.registry
            .createTypeUnsafe('ExtrinsicPayload', [payload, { version: payload.version }])
            // NOTE Explicitly pass the bare flag so the method is encoded un-prefixed (non-decodable, for signing only)
            .toU8a({ method: true }));
        return {
            address: payload.address,
            data,
            type: 'payload'
        };
    }
}

const EXTRINSIC_VERSION$1 = 4;
/**
 * @name GenericExtrinsicV4
 * @description
 * The third generation of compact extrinsics
 */
class GenericExtrinsicV4 extends Struct {
    constructor(registry, value, { isSigned } = {}) {
        super(registry, {
            signature: 'ExtrinsicSignatureV4',
            // eslint-disable-next-line sort-keys
            method: 'Call'
        }, GenericExtrinsicV4.decodeExtrinsic(registry, value, isSigned));
    }
    /** @internal */
    static decodeExtrinsic(registry, value, isSigned = false) {
        if (value instanceof GenericExtrinsicV4) {
            return value;
        }
        else if (value instanceof registry.createClassUnsafe('Call')) {
            return { method: value };
        }
        else if (isU8a(value)) {
            // here we decode manually since we need to pull through the version information
            const signature = registry.createTypeUnsafe('ExtrinsicSignatureV4', [value, { isSigned }]);
            const method = registry.createTypeUnsafe('Call', [value.subarray(signature.encodedLength)]);
            return {
                method,
                signature
            };
        }
        return value || {};
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        return this.toU8a().length;
    }
    /**
     * @description The [[Call]] this extrinsic wraps
     */
    get method() {
        return this.getT('method');
    }
    /**
     * @description The [[ExtrinsicSignatureV4]]
     */
    get signature() {
        return this.getT('signature');
    }
    /**
     * @description The version for the signature
     */
    get version() {
        return EXTRINSIC_VERSION$1;
    }
    /**
     * @description Add an [[ExtrinsicSignatureV4]] to the extrinsic (already generated)
     */
    addSignature(signer, signature, payload) {
        this.signature.addSignature(signer, signature, payload);
        return this;
    }
    /**
     * @description Sign the extrinsic with a specific keypair
     */
    sign(account, options) {
        this.signature.sign(this.method, account, options);
        return this;
    }
    /**
     * @describe Adds a fake signature to the extrinsic
     */
    signFake(signer, options) {
        this.signature.signFake(this.method, signer, options);
        return this;
    }
}

function sign(_registry, signerPair, u8a, options) {
    const encoded = u8a.length > 256
        ? blake2AsU8a(u8a)
        : u8a;
    return signerPair.sign(encoded, options);
}

/**
 * @name GenericExtrinsicPayloadV4
 * @description
 * A signing payload for an [[Extrinsic]]. For the final encoding, it is
 * variable length based on the contents included
 */
class GenericExtrinsicPayloadV4 extends Struct {
    #signOptions;
    constructor(registry, value) {
        super(registry, objectSpread({ method: 'Bytes' }, registry.getSignedExtensionTypes(), registry.getSignedExtensionExtra()), decodeAssetId(registry, value));
        // Do detection for the type of extrinsic, in the case of MultiSignature
        // this is an enum, in the case of AnySignature, this is a Hash only
        // (which may be 64 or 65 bytes)
        this.#signOptions = {
            withType: registry.createTypeUnsafe('ExtrinsicSignature', []) instanceof Enum
        };
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        return super.inspect({ method: true });
    }
    /**
     * @description The block [[BlockHash]] the signature applies to (mortal/immortal)
     */
    get blockHash() {
        return this.getT('blockHash');
    }
    /**
     * @description The [[ExtrinsicEra]]
     */
    get era() {
        return this.getT('era');
    }
    /**
     * @description The genesis [[BlockHash]] the signature applies to (mortal/immortal)
     */
    get genesisHash() {
        return this.getT('genesisHash');
    }
    /**
     * @description The [[Bytes]] contained in the payload
     */
    get method() {
        return this.getT('method');
    }
    /**
     * @description The [[Index]]
     */
    get nonce() {
        return this.getT('nonce');
    }
    /**
     * @description The specVersion for this signature
     */
    get specVersion() {
        return this.getT('specVersion');
    }
    /**
     * @description The tip [[Balance]]
     */
    get tip() {
        return this.getT('tip');
    }
    /**
     * @description The transactionVersion for this signature
     */
    get transactionVersion() {
        return this.getT('transactionVersion');
    }
    /**
     * @description The (optional) asset id for this signature for chains that support transaction fees in assets
     */
    get assetId() {
        return this.getT('assetId');
    }
    /**
     * @description The (optional) asset id for this signature for chains that support transaction fees in assets
     */
    get metadataHash() {
        return this.getT('metadataHash');
    }
    /**
     * @description Sign the payload with the keypair
     */
    sign(signerPair) {
        // NOTE The `toU8a({ method: true })` argument is absolutely critical, we
        // don't want the method (Bytes) to have the length prefix included. This
        // means that the data-as-signed is un-decodable, but is also doesn't need
        // the extra information, only the pure data (and is not decoded) ...
        // The same applies to V1..V3, if we have a V5, carry this comment
        return sign(this.registry, signerPair, this.toU8a({ method: true }), this.#signOptions);
    }
}

const FAKE_SIGNATURE = new Uint8Array(256).fill(1);
function toAddress(registry, address) {
    return registry.createTypeUnsafe('Address', [isU8a(address) ? u8aToHex(address) : address]);
}
/**
 * @name GenericExtrinsicSignatureV4
 * @description
 * A container for the [[Signature]] associated with a specific [[Extrinsic]]
 */
class GenericExtrinsicSignatureV4 extends Struct {
    #signKeys;
    constructor(registry, value, { isSigned } = {}) {
        const signTypes = registry.getSignedExtensionTypes();
        super(registry, objectSpread(
        // eslint-disable-next-line sort-keys
        { signer: 'Address', signature: 'ExtrinsicSignature' }, signTypes), GenericExtrinsicSignatureV4.decodeExtrinsicSignature(value, isSigned));
        this.#signKeys = Object.keys(signTypes);
        objectProperties(this, this.#signKeys, (k) => this.get(k));
    }
    /** @internal */
    static decodeExtrinsicSignature(value, isSigned = false) {
        if (!value) {
            return EMPTY_U8A;
        }
        else if (value instanceof GenericExtrinsicSignatureV4) {
            return value;
        }
        return isSigned
            ? value
            : EMPTY_U8A;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        return this.isSigned
            ? super.encodedLength
            : 0;
    }
    /**
     * @description `true` if the signature is valid
     */
    get isSigned() {
        return !this.signature.isEmpty;
    }
    /**
     * @description The [[ExtrinsicEra]] (mortal or immortal) this signature applies to
     */
    get era() {
        return this.getT('era');
    }
    /**
     * @description The [[Index]] for the signature
     */
    get nonce() {
        return this.getT('nonce');
    }
    /**
     * @description The actual [[EcdsaSignature]], [[Ed25519Signature]] or [[Sr25519Signature]]
     */
    get signature() {
        // the second case here is when we don't have an enum signature, treat as raw
        return (this.multiSignature.value || this.multiSignature);
    }
    /**
     * @description The raw [[ExtrinsicSignature]]
     */
    get multiSignature() {
        return this.getT('signature');
    }
    /**
     * @description The [[Address]] that signed
     */
    get signer() {
        return this.getT('signer');
    }
    /**
     * @description The [[Balance]] tip
     */
    get tip() {
        return this.getT('tip');
    }
    /**
     * @description The [[u32]] or [[MultiLocation]] assetId
     */
    get assetId() {
        return this.getT('assetId');
    }
    /**
     * @description the [[u32]] mode
     */
    get mode() {
        return this.getT('mode');
    }
    /**
     * @description The [[Hash]] for the metadata
     */
    get metadataHash() {
        return this.getT('metadataHash');
    }
    _injectSignature(signer, signature, payload) {
        // use the fields exposed to guide the getters
        for (let i = 0, count = this.#signKeys.length; i < count; i++) {
            const k = this.#signKeys[i];
            const v = payload.get(k);
            if (!isUndefined(v)) {
                this.set(k, v);
            }
        }
        // additional fields (exposed in struct itself)
        this.set('signer', signer);
        this.set('signature', signature);
        return this;
    }
    /**
     * @description Adds a raw signature
     */
    addSignature(signer, signature, payload) {
        return this._injectSignature(toAddress(this.registry, signer), this.registry.createTypeUnsafe('ExtrinsicSignature', [signature]), new GenericExtrinsicPayloadV4(this.registry, payload));
    }
    /**
     * @description Creates a payload from the supplied options
     */
    createPayload(method, options) {
        const { era, runtimeVersion: { specVersion, transactionVersion } } = options;
        return new GenericExtrinsicPayloadV4(this.registry, objectSpread({}, options, {
            era: era || IMMORTAL_ERA,
            method: method.toHex(),
            specVersion,
            transactionVersion
        }));
    }
    /**
     * @description Generate a payload and applies the signature from a keypair
     */
    sign(method, account, options) {
        if (!account?.addressRaw) {
            throw new Error(`Expected a valid keypair for signing, found ${stringify(account)}`);
        }
        const payload = this.createPayload(method, options);
        return this._injectSignature(toAddress(this.registry, account.addressRaw), this.registry.createTypeUnsafe('ExtrinsicSignature', [payload.sign(account)]), payload);
    }
    /**
     * @description Generate a payload and applies a fake signature
     */
    signFake(method, address, options) {
        if (!address) {
            throw new Error(`Expected a valid address for signing, found ${stringify(address)}`);
        }
        const payload = this.createPayload(method, options);
        return this._injectSignature(toAddress(this.registry, address), this.registry.createTypeUnsafe('ExtrinsicSignature', [FAKE_SIGNATURE]), payload);
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8a(isBare) {
        return this.isSigned
            ? super.toU8a(isBare)
            : EMPTY_U8A;
    }
}

const EXTRINSIC_VERSION = 5;
/**
 * @name GenericExtrinsicV5
 * @description
 * The fourth generation of compact extrinsics
 */
class GenericExtrinsicV5 extends Struct {
    constructor(registry, value, { isSigned } = {}) {
        super(registry, {
            signature: 'ExtrinsicSignatureV5',
            // eslint-disable-next-line sort-keys
            method: 'Call'
        }, GenericExtrinsicV5.decodeExtrinsic(registry, value, isSigned));
    }
    /** @internal */
    static decodeExtrinsic(registry, value, isSigned = false) {
        if (value instanceof GenericExtrinsicV5) {
            return value;
        }
        else if (value instanceof registry.createClassUnsafe('Call')) {
            return { method: value };
        }
        else if (isU8a(value)) {
            // here we decode manually since we need to pull through the version information
            const signature = registry.createTypeUnsafe('ExtrinsicSignatureV5', [value, { isSigned }]);
            // We add 2 here since the length of the TransactionExtension Version needs to be accounted for
            const method = registry.createTypeUnsafe('Call', [value.subarray(signature.encodedLength)]);
            return {
                method,
                signature
            };
        }
        return value || {};
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        return this.toU8a().length;
    }
    /**
     * @description The [[Call]] this extrinsic wraps
     */
    get method() {
        return this.getT('method');
    }
    /**
     * @description The [[ExtrinsicSignatureV5]]
     */
    get signature() {
        return this.getT('signature');
    }
    /**
     * @description The version for the signature
     */
    get version() {
        return EXTRINSIC_VERSION;
    }
    /**
     * @description The [[Preamble]] for the extrinsic
     */
    get preamble() {
        return this.getT('preamble');
    }
    /**
     * @description Add an [[ExtrinsicSignatureV5]] to the extrinsic (already generated)
     *
     * [Disabled for ExtrinsicV5]
     */
    addSignature(_signer, _signature, _payload) {
        throw new Error('Extrinsic: ExtrinsicV5 does not include signing support');
    }
    /**
     * @description Sign the extrinsic with a specific keypair
     *
     * [Disabled for ExtrinsicV5]
     */
    sign(_account, _options) {
        throw new Error('Extrinsic: ExtrinsicV5 does not include signing support');
    }
    /**
     * @describe Adds a fake signature to the extrinsic
     *
     * [Disabled for ExtrinsicV5]
     */
    signFake(_signer, _options) {
        throw new Error('Extrinsic: ExtrinsicV5 does not include signing support');
    }
}

/**
 * @name GenericExtrinsicPayloadV5
 * @description
 * A signing payload for an [[Extrinsic]]. For the final encoding, it is
 * variable length based on the contents included
 */
class GenericExtrinsicPayloadV5 extends Struct {
    constructor(registry, value) {
        super(registry, objectSpread({ method: 'Bytes' }, registry.getSignedExtensionTypes(), registry.getSignedExtensionExtra()), value);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        return super.inspect({ method: true });
    }
    /**
     * @description The block [[BlockHash]] the signature applies to (mortal/immortal)
     */
    get blockHash() {
        return this.getT('blockHash');
    }
    /**
     * @description The [[ExtrinsicEra]]
     */
    get era() {
        return this.getT('era');
    }
    /**
     * @description The genesis [[BlockHash]] the signature applies to (mortal/immortal)
     */
    get genesisHash() {
        return this.getT('genesisHash');
    }
    /**
     * @description The [[Bytes]] contained in the payload
     */
    get method() {
        return this.getT('method');
    }
    /**
     * @description The [[Index]]
     */
    get nonce() {
        return this.getT('nonce');
    }
    /**
     * @description The specVersion for this signature
     */
    get specVersion() {
        return this.getT('specVersion');
    }
    /**
     * @description The tip [[Balance]]
     */
    get tip() {
        return this.getT('tip');
    }
    /**
     * @description The transactionVersion for this signature
     */
    get transactionVersion() {
        return this.getT('transactionVersion');
    }
    /**
     * @description The (optional) asset id for this signature for chains that support transaction fees in assets
     */
    get assetId() {
        return this.getT('assetId');
    }
    /**
     * @description The (optional) metadataHash proof for the CheckMetadataHash TransactionExtension
     */
    get metadataHash() {
        return this.getT('metadataHash');
    }
    /**
     * @description Sign the payload with the keypair
     *
     * [Disabled for ExtrinsicV5]
     */
    sign(_signerPair) {
        throw new Error('Extrinsic: ExtrinsicV5 does not include signing support');
    }
}

/**
 * @name GenericExtrinsicSignatureV5
 * @description
 * A container for the [[Signature]] associated with a specific [[Extrinsic]]
 */
class GenericExtrinsicSignatureV5 extends Struct {
    #signKeys;
    constructor(registry, value, { isSigned } = {}) {
        const signTypes = registry.getSignedExtensionTypes();
        super(registry, objectSpread(
        // eslint-disable-next-line sort-keys
        { signer: 'Address', signature: 'ExtrinsicSignature', transactionExtensionVersion: 'u8' }, signTypes), GenericExtrinsicSignatureV5.decodeExtrinsicSignature(value, isSigned));
        this.#signKeys = Object.keys(signTypes);
        objectProperties(this, this.#signKeys, (k) => this.get(k));
    }
    /** @internal */
    static decodeExtrinsicSignature(value, isSigned = false) {
        if (!value) {
            return EMPTY_U8A;
        }
        else if (value instanceof GenericExtrinsicSignatureV5) {
            return value;
        }
        return isSigned
            ? value
            : EMPTY_U8A;
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        return this.isSigned
            ? super.encodedLength
            : 0;
    }
    /**
     * @description `true` if the signature is valid
     */
    get isSigned() {
        return !this.signature.isEmpty;
    }
    /**
     * @description The [[ExtrinsicEra]] (mortal or immortal) this signature applies to
     */
    get era() {
        return this.getT('era');
    }
    /**
     * @description The [[Index]] for the signature
     */
    get nonce() {
        return this.getT('nonce');
    }
    /**
     * @description The actual [[EcdsaSignature]], [[Ed25519Signature]] or [[Sr25519Signature]]
     */
    get signature() {
        // the second case here is when we don't have an enum signature, treat as raw
        return (this.multiSignature.value || this.multiSignature);
    }
    /**
     * @description The raw [[ExtrinsicSignature]]
     */
    get multiSignature() {
        return this.getT('signature');
    }
    /**
     * @description The [[Address]] that signed
     */
    get signer() {
        return this.getT('signer');
    }
    /**
     * @description The [[Balance]] tip
     */
    get tip() {
        return this.getT('tip');
    }
    /**
     * @description The [[u32]] or [[MultiLocation]] assetId
     */
    get assetId() {
        return this.getT('assetId');
    }
    /**
     * @description the [[u32]] mode
     */
    get mode() {
        return this.getT('mode');
    }
    /**
     * @description The (optional)  [[Hash]] for the metadata proof
     */
    get metadataHash() {
        return this.getT('metadataHash');
    }
    /**
     * @description The [[u8]] for the TransactionExtension version
     */
    get transactionExtensionVersion() {
        return this.getT('transactionExtensionVersion');
    }
    /**
     * [Disabled for ExtrinsicV5]
     */
    _injectSignature(_signer, _signature, _payload) {
        throw new Error('Extrinsic: ExtrinsicV5 does not include signing support');
    }
    /**
     * @description Adds a raw signature
     *
     * [Disabled for ExtrinsicV5]
     */
    addSignature(_signer, _signature, _payload) {
        throw new Error('Extrinsic: ExtrinsicV5 does not include signing support');
    }
    /**
     * @description Creates a payload from the supplied options
     */
    createPayload(method, options) {
        const { era, runtimeVersion: { specVersion, transactionVersion } } = options;
        return new GenericExtrinsicPayloadV5(this.registry, objectSpread({}, options, {
            era: era || IMMORTAL_ERA,
            method: method.toHex(),
            specVersion,
            transactionVersion
        }));
    }
    /**
     * @description Generate a payload and applies the signature from a keypair
     *
     * [Disabled for ExtrinsicV5]
     */
    sign(_method, _account, _options) {
        throw new Error('Extrinsic: ExtrinsicV5 does not include signing support');
    }
    /**
     * @description Generate a payload and applies a fake signature
     *
     * [Disabled for ExtrinsicV5]
     */
    signFake(_method, _address, _options) {
        throw new Error('Extrinsic: ExtrinsicV5 does not include signing support');
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8a(isBare) {
        return this.isSigned
            ? super.toU8a(isBare)
            : EMPTY_U8A;
    }
}

function decodeU8a$4(u8a) {
    if (!u8a.length) {
        return new Uint8Array();
    }
    const [offset, length] = compactFromU8a(u8a);
    const total = offset + length.toNumber();
    if (total > u8a.length) {
        throw new Error(`Extrinsic: length less than remainder, expected at least ${total}, found ${u8a.length}`);
    }
    const data = u8a.subarray(offset, total);
    // 69 denotes 0b01000101 which is the version and preamble for this Extrinsic
    if (data[0] !== 69) {
        throw new Error(`Extrinsic: incorrect version for General Transactions, expected 5, found ${data[0] & UNMASK_VERSION}`);
    }
    return data.subarray(1);
}
class GeneralExtrinsic extends Struct {
    #version;
    #preamble;
    constructor(registry, value, opt) {
        const extTypes = registry.getSignedExtensionTypes();
        super(registry, objectSpread({
            transactionExtensionVersion: 'u8'
        }, extTypes, {
            method: 'Call'
        }), GeneralExtrinsic.decodeExtrinsic(registry, value));
        this.#version = opt?.version || 0b00000101;
        this.#preamble = 0b01000000;
    }
    static decodeExtrinsic(registry, value) {
        if (!value) {
            return EMPTY_U8A;
        }
        else if (value instanceof GeneralExtrinsic) {
            return value;
        }
        else if (isU8a(value) || Array.isArray(value) || isHex(value)) {
            return decodeU8a$4(u8aToU8a(value));
        }
        else if (isObject(value)) {
            const { payload, transactionExtensionVersion } = value;
            return objectSpread(payload || {}, {
                transactionExtensionVersion: transactionExtensionVersion || registry.getTransactionExtensionVersion()
            });
        }
        return {};
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        return super.encodedLength;
    }
    /**
     * @description The [[ExtrinsicEra]]
     */
    get era() {
        return this.getT('era');
    }
    /**
     * @description The [[Index]]
     */
    get nonce() {
        return this.getT('nonce');
    }
    /**
     * @description The tip [[Balance]]
     */
    get tip() {
        return this.getT('tip');
    }
    /**
     * @description The (optional) asset id for this signature for chains that support transaction fees in assets
     */
    get assetId() {
        return this.getT('assetId');
    }
    /**
     * @description The mode used for the CheckMetadataHash TransactionExtension
     */
    get mode() {
        return this.getT('mode');
    }
    /**
     * @description The (optional) [[Hash]] for the metadata proof
     */
    get metadataHash() {
        return this.getT('metadataHash');
    }
    /**
     * @description The version of the TransactionExtensions used in this extrinsic
     */
    get transactionExtensionVersion() {
        return this.getT('transactionExtensionVersion');
    }
    /**
     * @description The [[Call]] this extrinsic wraps
     */
    get method() {
        return this.getT('method');
    }
    /**
     * @description The extrinsic's version
     */
    get version() {
        return this.#version;
    }
    /**
     * @description The [[Preamble]] for the extrinsic
     */
    get preamble() {
        return this.#preamble;
    }
    toHex(isBare) {
        return u8aToHex(this.toU8a(isBare));
    }
    toU8a(isBare) {
        return isBare
            ? this.encode()
            : compactAddLength(this.encode());
    }
    toRawType() {
        return 'GeneralExt';
    }
    /**
     *
     * @description Returns an encoded GeneralExtrinsic
     */
    encode() {
        return u8aConcat(new Uint8Array([this.version | this.preamble]), super.toU8a());
    }
    signFake() {
        throw new Error('Extrinsic: Type GeneralExtrinsic does not have signFake implemented');
    }
    addSignature() {
        throw new Error('Extrinsic: Type GeneralExtrinsic does not have addSignature implemented');
    }
    sign() {
        throw new Error('Extrinsic: Type GeneralExtrinsic does not have sign implemented');
    }
    signature() {
        throw new Error('Extrinsic: Type GeneralExtrinsic does not have the signature getter');
    }
}

/** @internal */
function decodeAccountId$1(value) {
    if (isU8a(value) || Array.isArray(value)) {
        return u8aToU8a(value);
    }
    else if (!value) {
        return new Uint8Array();
    }
    else if (isHex(value)) {
        return hexToU8a(value);
    }
    else if (isString(value)) {
        return decodeAddress(value.toString());
    }
    throw new Error(`Unknown type passed to AccountId constructor, found typeof ${typeof value}`);
}
class BaseAccountId extends U8aFixed {
    constructor(registry, allowedBits = 256 | 264, value) {
        const decoded = decodeAccountId$1(value);
        const decodedBits = decoded.length * 8;
        // Part of stream containing >= 32 bytes or a all empty (defaults)
        if (decodedBits < allowedBits && decoded.some((b) => b)) {
            throw new Error(`Invalid AccountId provided, expected ${allowedBits >> 3} bytes, found ${decoded.length}`);
        }
        super(registry, decoded, allowedBits);
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        return super.eq(decodeAccountId$1(other));
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman() {
        return this.toJSON();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        return this.toString();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive() {
        return this.toJSON();
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        return encodeAddress(this, this.registry.chainSS58);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'AccountId';
    }
}
/**
 * @name GenericAccountId
 * @description
 * A wrapper around an AccountId/PublicKey representation. Since we are dealing with
 * underlying PublicKeys (32 bytes in length), we extend from U8aFixed which is
 * just a Uint8Array wrapper with a fixed length.
 * If constructed with an empty value ([], "", undefined) it will result in
 * the zero account 0x000...000.
 */
class GenericAccountId extends BaseAccountId {
    constructor(registry, value) {
        super(registry, 256, value);
    }
}
class GenericAccountId33 extends BaseAccountId {
    constructor(registry, value) {
        super(registry, 264, value);
    }
}

const PREFIX_1BYTE = 0xef;
const PREFIX_2BYTE = 0xfc;
const PREFIX_4BYTE = 0xfd;
const PREFIX_8BYTE = 0xfe;
const MAX_1BYTE = new BN(PREFIX_1BYTE);
const MAX_2BYTE = new BN(1).shln(16);
const MAX_4BYTE = new BN(1).shln(32);
/** @internal */
function decodeAccountIndex(value) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    if (value instanceof GenericAccountIndex) {
        // `value.toBn()` on AccountIndex returns a pure BN (i.e. not an
        // AccountIndex), which has the initial `toString()` implementation.
        return value.toBn();
    }
    else if (isBn(value) || isNumber(value) || isHex(value) || isU8a(value) || isBigInt(value)) {
        return value;
    }
    return decodeAccountIndex(decodeAddress(value));
}
/**
 * @name GenericAccountIndex
 * @description
 * A wrapper around an AccountIndex, which is a shortened, variable-length encoding
 * for an Account. We extends from [[U32]] to provide the number-like properties.
 */
class GenericAccountIndex extends u32 {
    constructor(registry, value = new BN(0)) {
        super(registry, decodeAccountIndex(value));
    }
    static calcLength(_value) {
        const value = bnToBn(_value);
        if (value.lte(MAX_1BYTE)) {
            return 1;
        }
        else if (value.lt(MAX_2BYTE)) {
            return 2;
        }
        else if (value.lt(MAX_4BYTE)) {
            return 4;
        }
        return 8;
    }
    static readLength(input) {
        const first = input[0];
        if (first === PREFIX_2BYTE) {
            return [1, 2];
        }
        else if (first === PREFIX_4BYTE) {
            return [1, 4];
        }
        else if (first === PREFIX_8BYTE) {
            return [1, 8];
        }
        return [0, 1];
    }
    static writeLength(input) {
        switch (input.length) {
            case 2: return new Uint8Array([PREFIX_2BYTE]);
            case 4: return new Uint8Array([PREFIX_4BYTE]);
            case 8: return new Uint8Array([PREFIX_8BYTE]);
            default: return new Uint8Array([]);
        }
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        // shortcut for BN or Number, don't create an object
        if (isBn(other) || isNumber(other)) {
            return super.eq(other);
        }
        // convert and compare
        return super.eq(this.registry.createTypeUnsafe('AccountIndex', [other]));
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman() {
        return this.toJSON();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        return this.toString();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive() {
        return this.toJSON();
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        const length = GenericAccountIndex.calcLength(this);
        return encodeAddress(this.toU8a().subarray(0, length), this.registry.chainSS58);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'AccountIndex';
    }
}

/**
 * @name GenericBlock
 * @description
 * A block encoded with header and extrinsics
 */
class GenericBlock extends Struct {
    constructor(registry, value) {
        super(registry, {
            header: 'Header',
            // eslint-disable-next-line sort-keys
            extrinsics: 'Vec<Extrinsic>'
        }, value);
    }
    /**
     * @description Encodes a content [[Hash]] for the block
     */
    get contentHash() {
        return this.registry.hash(this.toU8a());
    }
    /**
     * @description The [[Extrinsic]] contained in the block
     */
    get extrinsics() {
        return this.getT('extrinsics');
    }
    /**
     * @description Block/header [[Hash]]
     */
    get hash() {
        return this.header.hash;
    }
    /**
     * @description The [[Header]] of the block
     */
    get header() {
        return this.getT('header');
    }
}

/**
 * Get a mapping of `argument name -> argument type` for the function, from
 * its metadata.
 *
 * @param meta - The function metadata used to get the definition.
 * @internal
 */
function getArgsDef(registry, meta) {
    return meta.fields.reduce((result, { name, type }, index) => {
        result[name.unwrapOr(`param${index}`).toString()] = registry.createLookupType(type);
        return result;
    }, {});
}
/** @internal */
function decodeCallViaObject(registry, value, _meta) {
    // we only pass args/methodsIndex out
    const { args, callIndex } = value;
    // Get the correct lookupIndex
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    const lookupIndex = callIndex instanceof GenericCallIndex
        ? callIndex.toU8a()
        : callIndex;
    // Find metadata with callIndex
    const meta = _meta || registry.findMetaCall(lookupIndex).meta;
    return {
        args,
        argsDef: getArgsDef(registry, meta),
        callIndex,
        meta
    };
}
/** @internal */
function decodeCallViaU8a(registry, value, _meta) {
    // We need 2 bytes for the callIndex
    const callIndex = registry.firstCallIndex.slice();
    callIndex.set(value.subarray(0, 2), 0);
    // Find metadata with callIndex
    const meta = _meta || registry.findMetaCall(callIndex).meta;
    return {
        args: value.subarray(2),
        argsDef: getArgsDef(registry, meta),
        callIndex,
        meta
    };
}
/**
 * Decode input to pass into constructor.
 *
 * @param value - Value to decode, one of:
 * - hex
 * - Uint8Array
 * - {@see DecodeMethodInput}
 * @param _meta - Metadata to use, so that `injectMethods` lookup is not
 * necessary.
 * @internal
 */
function decodeCall(registry, value = new Uint8Array(), _meta) {
    if (isU8a(value) || isHex(value)) {
        return decodeCallViaU8a(registry, u8aToU8a(value), _meta);
    }
    else if (isObject(value) && value.callIndex && value.args) {
        return decodeCallViaObject(registry, value, _meta);
    }
    throw new Error(`Call: Cannot decode value '${value}' of type ${typeof value}`);
}
/**
 * @name GenericCallIndex
 * @description
 * A wrapper around the `[sectionIndex, methodIndex]` value that uniquely identifies a method
 */
class GenericCallIndex extends U8aFixed {
    constructor(registry, value) {
        super(registry, value, 16);
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive() {
        return this.toHex();
    }
}
/**
 * @name GenericCall
 * @description
 * Extrinsic function descriptor
 */
class GenericCall extends Struct {
    _meta;
    constructor(registry, value, meta) {
        const decoded = decodeCall(registry, value, meta);
        try {
            super(registry, {
                callIndex: GenericCallIndex,
                // eslint-disable-next-line sort-keys
                args: Struct.with(decoded.argsDef)
            }, decoded);
        }
        catch (error) {
            let method = 'unknown.unknown';
            try {
                const c = registry.findMetaCall(decoded.callIndex);
                method = `${c.section}.${c.method}`;
            }
            catch {
                // ignore
            }
            throw new Error(`Call: failed decoding ${method}:: ${error.message}`);
        }
        this._meta = decoded.meta;
    }
    /**
     * @description The arguments for the function call
     */
    get args() {
        return [...this.getT('args').values()];
    }
    /**
     * @description The argument definitions
     */
    get argsDef() {
        return getArgsDef(this.registry, this.meta);
    }
    /**
     * @description The argument entries
     */
    get argsEntries() {
        return [...this.getT('args').entries()];
    }
    /**
     * @description The encoded `[sectionIndex, methodIndex]` identifier
     */
    get callIndex() {
        return this.getT('callIndex').toU8a();
    }
    /**
     * @description The encoded data
     */
    get data() {
        return this.getT('args').toU8a();
    }
    /**
     * @description The [[FunctionMetadata]]
     */
    get meta() {
        return this._meta;
    }
    /**
     * @description Returns the name of the method
     */
    get method() {
        return this.registry.findMetaCall(this.callIndex).method;
    }
    /**
     * @description Returns the module containing the method
     */
    get section() {
        return this.registry.findMetaCall(this.callIndex).section;
    }
    /**
     * @description Checks if the source matches this in type
     */
    is(other) {
        return other.callIndex[0] === this.callIndex[0] && other.callIndex[1] === this.callIndex[1];
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman(isExpanded, disableAscii) {
        let call;
        try {
            call = this.registry.findMetaCall(this.callIndex);
        }
        catch {
            // swallow
        }
        return objectSpread({
            args: this.argsEntries.reduce((args, [n, a]) => objectSpread(args, { [n]: a.toHuman(isExpanded, disableAscii) }), {}),
            method: call?.method,
            section: call?.section
        }, isExpanded && call
            ? { docs: call.meta.docs.map((d) => d.toString()) }
            : null);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'Call';
    }
}

function createValue(registry, type, value, asArray = true) {
    // We detect codec here as well - when found, generally this is constructed from itself
    if (value && isFunction$1(value.unwrapOrDefault)) {
        return value;
    }
    return registry.createTypeUnsafe(type, [
        asArray
            ? isNull(value) || isUndefined(value)
                ? null
                : Array.isArray(value)
                    ? value
                    : [value]
            : value
    ]);
}
function decodeValue(registry, key, value) {
    return key === 'ss58Format'
        ? createValue(registry, 'Option<u32>', value, false)
        : key === 'tokenDecimals'
            ? createValue(registry, 'Option<Vec<u32>>', value)
            : key === 'tokenSymbol'
                ? createValue(registry, 'Option<Vec<Text>>', value)
                : key === 'isEthereum'
                    ? createValue(registry, 'Bool', value, false)
                    : value;
}
function decode(registry, value) {
    return (
    // allow decoding from a map as well (ourselves)
    value && isFunction$1(value.entries)
        ? [...value.entries()]
        : Object.entries(value || {})).reduce((all, [key, value]) => {
        all[key] = decodeValue(registry, key, value);
        return all;
    }, {
        isEthereum: registry.createTypeUnsafe('Bool', []),
        ss58Format: registry.createTypeUnsafe('Option<u32>', []),
        tokenDecimals: registry.createTypeUnsafe('Option<Vec<u32>>', []),
        tokenSymbol: registry.createTypeUnsafe('Option<Vec<Text>>', [])
    });
}
class GenericChainProperties extends Json {
    constructor(registry, value) {
        super(registry, decode(registry, value));
    }
    /**
     * @description The chain uses Ethereum addresses
     */
    get isEthereum() {
        return this.getT('isEthereum');
    }
    /**
     * @description The chain ss58Format
     */
    get ss58Format() {
        return this.getT('ss58Format');
    }
    /**
     * @description The decimals for each of the tokens
     */
    get tokenDecimals() {
        return this.getT('tokenDecimals');
    }
    /**
     * @description The symbols for the tokens
     */
    get tokenSymbol() {
        return this.getT('tokenSymbol');
    }
}

const CID_AURA = /*#__PURE__*/ stringToU8a('aura');
const CID_BABE = /*#__PURE__*/ stringToU8a('BABE');
const CID_GRPA = /*#__PURE__*/ stringToU8a('FRNK');
const CID_POW = /*#__PURE__*/ stringToU8a('pow_');
const CID_NMBS = /*#__PURE__*/ stringToU8a('nmbs');
function getAuraAuthor(registry, bytes, sessionValidators) {
    return sessionValidators[registry.createTypeUnsafe('RawAuraPreDigest', [bytes.toU8a(true)])
        .slotNumber
        .mod(new BN(sessionValidators.length))
        .toNumber()];
}
function getBabeAuthor(registry, bytes, sessionValidators) {
    const digest = registry.createTypeUnsafe('RawBabePreDigestCompat', [bytes.toU8a(true)]);
    return sessionValidators[digest.value.toNumber()];
}
function getBytesAsAuthor(registry, bytes) {
    return registry.createTypeUnsafe('AccountId', [bytes]);
}
/**
 * @name GenericConsensusEngineId
 * @description
 * A 4-byte identifier identifying the engine
 */
class GenericConsensusEngineId extends U8aFixed {
    constructor(registry, value) {
        super(registry, isNumber(value)
            ? bnToU8a(value, { isLe: false })
            : value, 32);
    }
    /**
     * @description `true` if the engine matches aura
     */
    get isAura() {
        return this.eq(CID_AURA);
    }
    /**
     * @description `true` is the engine matches babe
     */
    get isBabe() {
        return this.eq(CID_BABE);
    }
    /**
     * @description `true` is the engine matches grandpa
     */
    get isGrandpa() {
        return this.eq(CID_GRPA);
    }
    /**
     * @description `true` is the engine matches pow
     */
    get isPow() {
        return this.eq(CID_POW);
    }
    /**
     * @description `true` is the engine matches nimbus
     */
    get isNimbus() {
        return this.eq(CID_NMBS);
    }
    /**
     * @description From the input bytes, decode into an author
     */
    extractAuthor(bytes, sessionValidators) {
        if (sessionValidators?.length) {
            if (this.isAura) {
                return getAuraAuthor(this.registry, bytes, sessionValidators);
            }
            else if (this.isBabe) {
                return getBabeAuthor(this.registry, bytes, sessionValidators);
            }
        }
        // For pow & Nimbus, the bytes are the actual author
        if (this.isPow || this.isNimbus) {
            return getBytesAsAuthor(this.registry, bytes);
        }
        return undefined;
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman() {
        return this.toString();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'ConsensusEngineId';
    }
    /**
     * @description Override the default toString to return a 4-byte string
     */
    toString() {
        return this.isAscii
            ? u8aToString(this)
            : u8aToHex(this);
    }
}

const ACCOUNT_ID_PREFIX$1 = new Uint8Array([0xff]);
/** @internal */
function decodeString$1(registry, value) {
    const decoded = decodeAddress(value);
    return decoded.length === 32
        ? registry.createTypeUnsafe('AccountId', [decoded])
        : registry.createTypeUnsafe('AccountIndex', [u8aToBn(decoded)]);
}
/** @internal */
function decodeU8a$3(registry, value) {
    // This allows us to instantiate an address with a raw publicKey. Do this first before
    // we checking the first byte, otherwise we may split an already-existent valid address
    if (value.length === 32) {
        return registry.createTypeUnsafe('AccountId', [value]);
    }
    else if (value[0] === 0xff) {
        return registry.createTypeUnsafe('AccountId', [value.subarray(1)]);
    }
    const [offset, length] = GenericAccountIndex.readLength(value);
    return registry.createTypeUnsafe('AccountIndex', [u8aToBn(value.subarray(offset, offset + length))]);
}
/** @internal */
function decodeAddressOrIndex$1(registry, value) {
    return value instanceof GenericLookupSource
        ? value.inner
        : value instanceof GenericAccountId || value instanceof GenericAccountIndex
            ? value
            : isBn(value) || isNumber(value) || isBigInt(value)
                ? registry.createTypeUnsafe('AccountIndex', [value])
                : Array.isArray(value) || isHex(value) || isU8a(value)
                    ? decodeU8a$3(registry, u8aToU8a(value))
                    : decodeString$1(registry, value);
}
/**
 * @name LookupSource
 * @description
 * A wrapper around an AccountId and/or AccountIndex that is encoded with a prefix.
 * Since we are dealing with underlying publicKeys (or shorter encoded addresses),
 * we extend from Base with an AccountId/AccountIndex wrapper. Basically the Address
 * is encoded as `[ <prefix-byte>, ...publicKey/...bytes ]` as per spec
 */
class GenericLookupSource extends AbstractBase {
    constructor(registry, value = new Uint8Array()) {
        super(registry, decodeAddressOrIndex$1(registry, value));
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        const rawLength = this._rawLength;
        return rawLength + (
        // for 1 byte AccountIndexes, we are not adding a specific prefix
        rawLength > 1
            ? 1
            : 0);
    }
    /**
     * @description The length of the raw value, either AccountIndex or AccountId
     */
    get _rawLength() {
        return this.inner instanceof GenericAccountIndex
            ? GenericAccountIndex.calcLength(this.inner)
            : this.inner.encodedLength;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        const value = this.inner.toU8a().subarray(0, this._rawLength);
        return {
            outer: [
                new Uint8Array(this.inner instanceof GenericAccountIndex
                    ? GenericAccountIndex.writeLength(value)
                    : ACCOUNT_ID_PREFIX$1),
                value
            ]
        };
    }
    /**
     * @description Returns a hex string representation of the value
     */
    toHex() {
        return u8aToHex(this.toU8a());
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'Address';
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8a(isBare) {
        const encoded = this.inner.toU8a().subarray(0, this._rawLength);
        return isBare
            ? encoded
            : u8aConcat(this.inner instanceof GenericAccountIndex
                ? GenericAccountIndex.writeLength(encoded)
                : ACCOUNT_ID_PREFIX$1, encoded);
    }
}

function decodeU8a$2(registry, u8a) {
    if ([0, 32].includes(u8a.length)) {
        return { Id: u8a };
    }
    else if (u8a.length === 20) {
        return { Address20: u8a };
    }
    else if (u8a.length <= 8) {
        return { Index: registry.createTypeUnsafe('AccountIndex', [u8a]).toNumber() };
    }
    return u8a;
}
function decodeMultiAny(registry, value) {
    if (value instanceof GenericAccountId) {
        return { Id: value };
    }
    else if (isU8a(value)) {
        // NOTE This is after the AccountId check (which is U8a)
        return decodeU8a$2(registry, value);
    }
    else if (value instanceof GenericMultiAddress) {
        return value;
    }
    else if (value instanceof GenericAccountIndex || isBn(value) || isNumber(value)) {
        return { Index: isNumber(value) ? value : value.toNumber() };
    }
    else if (isString(value)) {
        return decodeU8a$2(registry, decodeAddress(value.toString()));
    }
    return value;
}
class GenericMultiAddress extends Enum {
    constructor(registry, value) {
        super(registry, {
            Id: 'AccountId',
            Index: 'Compact<AccountIndex>',
            Raw: 'Bytes',
            // eslint-disable-next-line sort-keys
            Address32: 'H256',
            // eslint-disable-next-line sort-keys
            Address20: 'H160'
        }, decodeMultiAny(registry, value));
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */
    inspect() {
        const { inner, outer = [] } = this.inner.inspect();
        return {
            inner,
            outer: [new Uint8Array([this.index]), ...outer]
        };
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        return this.value.toString();
    }
}

const AYE_BITS = 0b10000000;
const NAY_BITS = 0b00000000;
const CON_MASK = 0b01111111;
const DEF_CONV = 0b00000000; // the default conviction, None
/** @internal */
function decodeVoteBool(value) {
    return value
        ? new Uint8Array([AYE_BITS | DEF_CONV])
        : new Uint8Array([NAY_BITS]);
}
/** @internal */
function decodeVoteU8a(value) {
    return value.length
        ? value.subarray(0, 1)
        : new Uint8Array([NAY_BITS]);
}
/** @internal */
function decodeVoteType(registry, value) {
    return new Uint8Array([
        (new bool(registry, value.aye).isTrue
            ? AYE_BITS
            : NAY_BITS) |
            registry.createTypeUnsafe('Conviction', [value.conviction || DEF_CONV]).index
    ]);
}
/** @internal */
function decodeVote(registry, value) {
    if (isU8a(value)) {
        return decodeVoteU8a(value);
    }
    else if (isUndefined(value) || value instanceof Boolean || isBoolean(value)) {
        return decodeVoteBool(new bool(registry, value).isTrue);
    }
    else if (isNumber(value)) {
        return decodeVoteBool(value < 0);
    }
    return decodeVoteType(registry, value);
}
/**
 * @name GenericVote
 * @description
 * A number of lock periods, plus a vote, one way or the other.
 */
class GenericVote extends U8aFixed {
    #aye;
    #conviction;
    constructor(registry, value) {
        // decoded is just 1 byte
        // Aye: Most Significant Bit
        // Conviction: 0000 - 0101
        const decoded = decodeVote(registry, value);
        super(registry, decoded, 8);
        this.#aye = (decoded[0] & AYE_BITS) === AYE_BITS;
        this.#conviction = this.registry.createTypeUnsafe('Conviction', [decoded[0] & CON_MASK]);
    }
    /**
     * @description returns a V2 conviction
     */
    get conviction() {
        return this.#conviction;
    }
    /**
     * @description true if the wrapped value is a positive vote
     */
    get isAye() {
        return this.#aye;
    }
    /**
     * @description true if the wrapped value is a negative vote
     */
    get isNay() {
        return !this.isAye;
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman(isExpanded) {
        return {
            conviction: this.conviction.toHuman(isExpanded),
            vote: this.isAye ? 'Aye' : 'Nay'
        };
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive() {
        return {
            aye: this.isAye,
            conviction: this.conviction.toPrimitive()
        };
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'Vote';
    }
}

/** @internal */
function decodeAccountId(value) {
    if (isU8a(value) || Array.isArray(value)) {
        return u8aToU8a(value);
    }
    else if (isHex(value) || isEthereumAddress(value.toString())) {
        return hexToU8a(value.toString());
    }
    else if (isString(value)) {
        return u8aToU8a(value);
    }
    return value;
}
/**
 * @name GenericEthereumAccountId
 * @description
 * A wrapper around an Ethereum-compatible AccountId. Since we are dealing with
 * underlying addresses (20 bytes in length), we extend from U8aFixed which is
 * just a Uint8Array wrapper with a fixed length.
 */
class GenericEthereumAccountId extends U8aFixed {
    constructor(registry, value = new Uint8Array()) {
        super(registry, decodeAccountId(value), 160);
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */
    eq(other) {
        return !!other && super.eq(decodeAccountId(other));
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */
    toHuman() {
        return this.toJSON();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        return this.toString();
    }
    /**
     * @description Converts the value in a best-fit primitive form
     */
    toPrimitive() {
        return this.toJSON();
    }
    /**
     * @description Returns the string representation of the value
     */
    toString() {
        return ethereumEncode(this);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'AccountId';
    }
}

const ACCOUNT_ID_PREFIX = new Uint8Array([0xff]);
/** @internal */
function decodeString(registry, value) {
    const decoded = decodeAddress(value);
    return decoded.length === 20
        ? registry.createTypeUnsafe('EthereumAccountId', [decoded])
        : registry.createTypeUnsafe('AccountIndex', [u8aToBn(decoded)]);
}
/** @internal */
function decodeU8a$1(registry, value) {
    // This allows us to instantiate an address with a raw publicKey. Do this first before
    // we checking the first byte, otherwise we may split an already-existent valid address
    if (value.length === 20) {
        return registry.createTypeUnsafe('EthereumAccountId', [value]);
    }
    else if (value[0] === 0xff) {
        return registry.createTypeUnsafe('EthereumAccountId', [value.subarray(1)]);
    }
    const [offset, length] = GenericAccountIndex.readLength(value);
    return registry.createTypeUnsafe('AccountIndex', [u8aToBn(value.subarray(offset, offset + length))]);
}
function decodeAddressOrIndex(registry, value) {
    return value instanceof GenericEthereumLookupSource
        ? value.inner
        : value instanceof GenericEthereumAccountId || value instanceof GenericAccountIndex
            ? value
            : isU8a(value) || Array.isArray(value) || isHex(value)
                ? decodeU8a$1(registry, u8aToU8a(value))
                : isBn(value) || isNumber(value) || isBigInt(value)
                    ? registry.createTypeUnsafe('AccountIndex', [value])
                    : decodeString(registry, value);
}
/**
 * @name GenericEthereumLookupSource
 * @description
 * A wrapper around an EthereumAccountId and/or AccountIndex that is encoded with a prefix.
 * Since we are dealing with underlying publicKeys (or shorter encoded addresses),
 * we extend from Base with an AccountId/AccountIndex wrapper. Basically the Address
 * is encoded as `[ <prefix-byte>, ...publicKey/...bytes ]` as per spec
 */
class GenericEthereumLookupSource extends AbstractBase {
    constructor(registry, value = new Uint8Array()) {
        super(registry, decodeAddressOrIndex(registry, value));
    }
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get encodedLength() {
        const rawLength = this._rawLength;
        return rawLength + (
        // for 1 byte AccountIndexes, we are not adding a specific prefix
        rawLength > 1
            ? 1
            : 0);
    }
    /**
     * @description The length of the raw value, either AccountIndex or AccountId
     */
    get _rawLength() {
        return this.inner instanceof GenericAccountIndex
            ? GenericAccountIndex.calcLength(this.inner)
            : this.inner.encodedLength;
    }
    /**
     * @description Returns a hex string representation of the value
     */
    toHex() {
        return u8aToHex(this.toU8a());
    }
    /**
     * @description Returns the base runtime type name for this instance
     */
    toRawType() {
        return 'Address';
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    toU8a(isBare) {
        const encoded = this.inner.toU8a().subarray(0, this._rawLength);
        return isBare
            ? encoded
            : u8aConcat(this.inner instanceof GenericAccountIndex
                ? GenericAccountIndex.writeLength(encoded)
                : ACCOUNT_ID_PREFIX, encoded);
    }
}

/** @internal */
function decodeDataU8a(registry, value) {
    const indicator = value[0];
    if (!indicator) {
        return [undefined, undefined];
    }
    else if (indicator >= 1 && indicator <= 33) {
        const length = indicator - 1;
        const data = value.subarray(1, length + 1);
        // in this case, we are passing a Raw back (since we have no length)
        return [registry.createTypeUnsafe('Raw', [data]), 1];
    }
    else if (indicator >= 34 && indicator <= 37) {
        return [value.subarray(1, 32 + 1), indicator - 32]; // 34 becomes 2
    }
    throw new Error(`Unable to decode Data, invalid indicator byte ${indicator}`);
}
/** @internal */
function decodeData(registry, value) {
    if (isU8a(value) || isString(value)) {
        return decodeDataU8a(registry, u8aToU8a(value));
    }
    else if (!value) {
        return [undefined, undefined];
    }
    // assume we have an Enum or an  object input, handle this via the normal Enum decoding
    return [value, undefined];
}
/**
 * @name Data
 * @description
 * A [[Data]] container with node, raw or hashed data
 */
class Data extends Enum {
    constructor(registry, value) {
        super(registry, {
            None: 'Null', // 0
            Raw: 'Bytes', // 1
            // eslint-disable-next-line sort-keys
            BlakeTwo256: 'H256', // 2
            Sha256: 'H256', // 3
            // eslint-disable-next-line sort-keys
            Keccak256: 'H256', // 4
            ShaThree256: 'H256' // 5
        }, ...decodeData(registry, value));
        if (this.isRaw && this.asRaw.length > 32) {
            throw new Error('Data.Raw values are limited to a maximum length of 32 bytes');
        }
    }
    get asBlakeTwo256() {
        return this.value;
    }
    get asKeccak256() {
        return this.value;
    }
    get asRaw() {
        return this.value;
    }
    get asSha256() {
        return this.value;
    }
    get asShaThree256() {
        return this.value;
    }
    get isBlakeTwo256() {
        return this.index === 2;
    }
    get isKeccak256() {
        return this.index === 4;
    }
    get isNone() {
        return this.index === 0;
    }
    get isRaw() {
        return this.index === 1;
    }
    get isSha256() {
        return this.index === 3;
    }
    get isShaThree256() {
        return this.index === 5;
    }
    /**
     * @description The encoded length
     */
    get encodedLength() {
        return this.toU8a().length;
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     */
    toU8a() {
        if (this.index === 0) {
            return new Uint8Array(1);
        }
        else if (this.index === 1) {
            // don't add the length, just the data
            const data = this.value.toU8a(true);
            const length = Math.min(data.length, 32);
            const u8a = new Uint8Array(length + 1);
            u8a.set([length + 1], 0);
            u8a.set(data.subarray(0, length), 1);
            return u8a;
        }
        // otherwise we simply have a hash
        const u8a = new Uint8Array(33);
        u8a.set([this.index + 32], 0);
        u8a.set(this.value.toU8a(), 1);
        return u8a;
    }
}

const HASHER_MAP = {
    // opaque
    Blake2_128: [16, false], // eslint-disable-line camelcase
    Blake2_128Concat: [16, true], // eslint-disable-line camelcase
    Blake2_256: [32, false], // eslint-disable-line camelcase
    Identity: [0, true],
    Twox128: [16, false],
    Twox256: [32, false],
    Twox64Concat: [8, true]
};
/** @internal */
function decodeStorageKey(value) {
    if (isU8a(value) || !value || isString(value)) {
        // let Bytes handle these inputs
        return { key: value };
    }
    else if (value instanceof StorageKey) {
        return {
            key: value,
            method: value.method,
            section: value.section
        };
    }
    else if (isFunction$1(value)) {
        return {
            key: value(),
            method: value.method,
            section: value.section
        };
    }
    else if (Array.isArray(value)) {
        const [fn, args = []] = value;
        if (!isFunction$1(fn)) {
            throw new Error('Expected function input for key construction');
        }
        if (fn.meta && fn.meta.type.isMap) {
            const map = fn.meta.type.asMap;
            if (!Array.isArray(args) || args.length !== map.hashers.length) {
                throw new Error(`Expected an array of ${map.hashers.length} values as params to a Map query`);
            }
        }
        return {
            key: fn(...args),
            method: fn.method,
            section: fn.section
        };
    }
    throw new Error(`Unable to convert input ${value} to StorageKey`);
}
/** @internal */
function decodeHashers(registry, value, hashers) {
    // the storage entry is xxhashAsU8a(prefix, 128) + xxhashAsU8a(method, 128), 256 bits total
    let offset = 32;
    const count = hashers.length;
    const result = new Array(count);
    for (let i = 0; i < count; i++) {
        const [hasher, type] = hashers[i];
        const [hashLen, canDecode] = HASHER_MAP[hasher.type];
        const decoded = canDecode
            ? registry.createTypeUnsafe(getSiName(registry.lookup, type), [value.subarray(offset + hashLen)])
            : registry.createTypeUnsafe('Raw', [value.subarray(offset, offset + hashLen)]);
        offset += hashLen + (canDecode ? decoded.encodedLength : 0);
        result[i] = decoded;
    }
    return result;
}
/** @internal */
function decodeArgsFromMeta(registry, value, meta) {
    if (!meta || !meta.type.isMap) {
        return [];
    }
    const { hashers, key } = meta.type.asMap;
    const keys = hashers.length === 1
        ? [key]
        : registry.lookup.getSiType(key).def.asTuple;
    return decodeHashers(registry, value, hashers.map((h, i) => [h, keys[i]]));
}
/** @internal */
function getMeta(value) {
    if (value instanceof StorageKey) {
        return value.meta;
    }
    else if (isFunction$1(value)) {
        return value.meta;
    }
    else if (Array.isArray(value)) {
        const [fn] = value;
        return fn.meta;
    }
    return undefined;
}
/** @internal */
function getType(registry, value) {
    if (value instanceof StorageKey) {
        return value.outputType;
    }
    else if (isFunction$1(value)) {
        return unwrapStorageType(registry, value.meta.type);
    }
    else if (Array.isArray(value)) {
        const [fn] = value;
        if (fn.meta) {
            return unwrapStorageType(registry, fn.meta.type);
        }
    }
    // If we have no type set, default to Raw
    return 'Raw';
}
/**
 * @name StorageKey
 * @description
 * A representation of a storage key (typically hashed) in the system. It can be
 * constructed by passing in a raw key or a StorageEntry with (optional) arguments.
 */
class StorageKey extends Bytes {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore This is assigned via this.decodeArgsFromMeta()
    #args;
    #meta;
    #outputType;
    #method;
    #section;
    constructor(registry, value, override = {}) {
        const { key, method, section } = decodeStorageKey(value);
        super(registry, key);
        this.#outputType = getType(registry, value);
        // decode the args (as applicable based on the key and the hashers, after all init)
        this.setMeta(getMeta(value), override.section || section, override.method || method);
    }
    /**
     * @description Return the decoded arguments (applicable to map with decodable values)
     */
    get args() {
        return this.#args;
    }
    /**
     * @description The metadata or `undefined` when not available
     */
    get meta() {
        return this.#meta;
    }
    /**
     * @description The key method or `undefined` when not specified
     */
    get method() {
        return this.#method;
    }
    /**
     * @description The output type
     */
    get outputType() {
        return this.#outputType;
    }
    /**
     * @description The key section or `undefined` when not specified
     */
    get section() {
        return this.#section;
    }
    is(key) {
        return key.section === this.section && key.method === this.method;
    }
    /**
     * @description Sets the meta for this key
     */
    setMeta(meta, section, method) {
        this.#meta = meta;
        this.#method = method || this.#method;
        this.#section = section || this.#section;
        if (meta) {
            this.#outputType = unwrapStorageType(this.registry, meta.type);
        }
        try {
            this.#args = decodeArgsFromMeta(this.registry, this.toU8a(true), meta);
        }
        catch {
            // ignore...
        }
        return this;
    }
    /**
     * @description Returns the Human representation for this type
     */
    toHuman(_isExtended, disableAscii) {
        return this.#args.length
            ? this.#args.map((a) => a.toHuman(undefined, disableAscii))
            : super.toHuman(undefined, disableAscii);
    }
    /**
     * @description Returns the raw type for this
     */
    toRawType() {
        return 'StorageKey';
    }
}

var baseTypes = /*#__PURE__*/Object.freeze({
	__proto__: null,
	BitVec: BitVec,
	Bool: bool,
	Bytes: Bytes,
	Data: Data,
	F32: f32,
	F64: f64,
	GeneralExtrinsic: GeneralExtrinsic,
	GenericAccountId: GenericAccountId,
	GenericAccountId32: GenericAccountId,
	GenericAccountId33: GenericAccountId33,
	GenericAccountIndex: GenericAccountIndex,
	GenericAddress: GenericMultiAddress,
	GenericBlock: GenericBlock,
	GenericCall: GenericCall,
	GenericChainProperties: GenericChainProperties,
	GenericConsensusEngineId: GenericConsensusEngineId,
	GenericEthereumAccountId: GenericEthereumAccountId,
	GenericEthereumLookupSource: GenericEthereumLookupSource,
	GenericEvent: GenericEvent,
	GenericEventData: GenericEventData,
	GenericExtrinsic: GenericExtrinsic,
	GenericExtrinsicEra: GenericExtrinsicEra,
	GenericExtrinsicPayload: GenericExtrinsicPayload,
	GenericExtrinsicPayloadUnknown: GenericExtrinsicPayloadUnknown,
	GenericExtrinsicPayloadV4: GenericExtrinsicPayloadV4,
	GenericExtrinsicPayloadV5: GenericExtrinsicPayloadV5,
	GenericExtrinsicSignatureV4: GenericExtrinsicSignatureV4,
	GenericExtrinsicSignatureV5: GenericExtrinsicSignatureV5,
	GenericExtrinsicUnknown: GenericExtrinsicUnknown,
	GenericExtrinsicV4: GenericExtrinsicV4,
	GenericExtrinsicV5: GenericExtrinsicV5,
	GenericImmortalEra: ImmortalEra,
	GenericLookupSource: GenericLookupSource,
	GenericMortalEra: MortalEra,
	GenericMultiAddress: GenericMultiAddress,
	GenericSignerPayload: GenericSignerPayload,
	GenericVote: GenericVote,
	I128: i128,
	I16: i16,
	I256: i256,
	I32: i32,
	I64: i64,
	I8: i8,
	ISize: isize,
	Null: Null,
	OptionBool: OptionBool,
	StorageKey: StorageKey,
	Text: Text,
	Type: Type,
	U128: u128,
	U16: u16,
	U256: u256,
	U32: u32,
	U64: u64,
	U8: u8,
	USize: usize,
	bool: bool,
	f32: f32,
	f64: f64,
	i128: i128,
	i16: i16,
	i256: i256,
	i32: i32,
	i64: i64,
	i8: i8,
	isize: isize,
	u128: u128,
	u16: u16,
	u256: u256,
	u32: u32,
	u64: u64,
	u8: u8,
	usize: usize
});

function convert(fn) {
    return ({ name }) => fn(name);
}
const objectNameToCamel = /*#__PURE__*/ convert(stringCamelCase);
const objectNameToString = /*#__PURE__*/ convert((n) => n.toString());

function isTx(tx, callIndex) {
    return tx.callIndex[0] === callIndex[0] && tx.callIndex[1] === callIndex[1];
}
/** @internal */
function createUnchecked(registry, section, callIndex, callMetadata) {
    const expectedArgs = callMetadata.fields;
    const funcName = stringCamelCase(callMetadata.name);
    const extrinsicFn = (...args) => {
        if (expectedArgs.length !== args.length) {
            throw new Error(`Extrinsic ${section}.${funcName} expects ${expectedArgs.length} arguments, got ${args.length}.`);
        }
        return registry.createTypeUnsafe('Call', [{ args, callIndex }, callMetadata]);
    };
    extrinsicFn.is = (tx) => isTx(tx, callIndex);
    extrinsicFn.callIndex = callIndex;
    extrinsicFn.meta = callMetadata;
    extrinsicFn.method = funcName;
    extrinsicFn.section = section;
    extrinsicFn.toJSON = () => callMetadata.toJSON();
    return extrinsicFn;
}

function filterCallsSome({ calls }) {
    return calls.isSome;
}
function createCallFunction(registry, lookup, variant, sectionName, sectionIndex) {
    const { fields, index } = variant;
    const count = fields.length;
    const args = new Array(count);
    for (let i = 0; i < count; i++) {
        const { name, type, typeName } = fields[i];
        args[i] = objectSpread({
            name: stringCamelCase(name.unwrapOr(`param${i}`)),
            type: getSiName(lookup, type)
        }, typeName.isSome
            ? { typeName: typeName.unwrap() }
            : null);
    }
    return createUnchecked(registry, sectionName, new Uint8Array([sectionIndex, index.toNumber()]), registry.createTypeUnsafe('FunctionMetadataLatest', [objectSpread({ args }, variant)]));
}
/** @internal */
function decorateExtrinsics(registry, { lookup, pallets }, version) {
    const result = {};
    const filtered = pallets.filter(filterCallsSome);
    for (let i = 0, count = filtered.length; i < count; i++) {
        const { calls, index, name } = filtered[i];
        const sectionName = stringCamelCase(name);
        const sectionIndex = version >= 12 ? index.toNumber() : i;
        lazyMethod(result, sectionName, () => lazyVariants(lookup, calls.unwrap(), objectNameToCamel, (variant) => createCallFunction(registry, lookup, variant, sectionName, sectionIndex)));
    }
    return result;
}

/** @internal */
function createStorageHasher(registry, hasher) {
    // Blake2_128_Concat has been added at index 2, so we increment all the
    // indexes greater than 2
    if (hasher.toNumber() >= 2) {
        return registry.createTypeUnsafe('StorageHasherV10', [hasher.toNumber() + 1]);
    }
    return registry.createTypeUnsafe('StorageHasherV10', [hasher]);
}
/** @internal */
function createStorageType(registry, entryType) {
    if (entryType.isMap) {
        return [objectSpread({}, entryType.asMap, {
                hasher: createStorageHasher(registry, entryType.asMap.hasher)
            }), 1];
    }
    if (entryType.isDoubleMap) {
        return [objectSpread({}, entryType.asDoubleMap, {
                hasher: createStorageHasher(registry, entryType.asDoubleMap.hasher),
                key2Hasher: createStorageHasher(registry, entryType.asDoubleMap.key2Hasher)
            }), 2];
    }
    return [entryType.asPlain, 0];
}
/** @internal */
function convertModule(registry, mod) {
    const storage = mod.storage.unwrapOr(null);
    return registry.createTypeUnsafe('ModuleMetadataV10', [objectSpread({}, mod, {
            storage: storage
                ? objectSpread({}, storage, {
                    items: storage.items.map((item) => objectSpread({}, item, {
                        type: registry.createTypeUnsafe('StorageEntryTypeV10', createStorageType(registry, item.type))
                    }))
                })
                : null
        })]);
}
/** @internal */
function toV10(registry, { modules }) {
    return registry.createTypeUnsafe('MetadataV10', [{
            modules: modules.map((mod) => convertModule(registry, mod))
        }]);
}

/** @internal */
function toV11(registry, { modules }) {
    return registry.createTypeUnsafe('MetadataV11', [{
            // This is new in V11, pass V0 here - something non-existing, telling the API to use
            // the fallback for this information (on-chain detection)
            extrinsic: {
                signedExtensions: [],
                version: 0
            },
            modules
        }]);
}

/**
 * @internal
 **/
function toV12(registry, { extrinsic, modules }) {
    return registry.createTypeUnsafe('MetadataV12', [{
            extrinsic,
            modules: modules.map((mod) => registry.createTypeUnsafe('ModuleMetadataV12', [objectSpread({}, mod, { index: 255 })]))
        }]);
}

/**
 * @internal
 **/
function toV13(registry, v12) {
    return registry.createTypeUnsafe('MetadataV13', [v12]);
}

const typesAlias = {
    assets: {
        Approval: 'AssetApproval',
        ApprovalKey: 'AssetApprovalKey',
        Balance: 'TAssetBalance',
        DestroyWitness: 'AssetDestroyWitness'
    },
    babe: {
        EquivocationProof: 'BabeEquivocationProof'
    },
    balances: {
        Status: 'BalanceStatus'
    },
    beefy: {
        AuthorityId: 'BeefyId'
    },
    contracts: {
        StorageKey: 'ContractStorageKey'
    },
    electionProviderMultiPhase: {
        Phase: 'ElectionPhase'
    },
    ethereum: {
        Block: 'EthBlock',
        Header: 'EthHeader',
        Receipt: 'EthReceipt',
        Transaction: 'EthTransaction',
        TransactionStatus: 'EthTransactionStatus'
    },
    evm: {
        Account: 'EvmAccount',
        Log: 'EvmLog',
        Vicinity: 'EvmVicinity'
    },
    grandpa: {
        Equivocation: 'GrandpaEquivocation',
        EquivocationProof: 'GrandpaEquivocationProof'
    },
    identity: {
        Judgement: 'IdentityJudgement'
    },
    inclusion: {
        ValidatorIndex: 'ParaValidatorIndex'
    },
    paraDisputes: {
        ValidatorIndex: 'ParaValidatorIndex'
    },
    paraInclusion: {
        ValidatorIndex: 'ParaValidatorIndex'
    },
    paraScheduler: {
        ValidatorIndex: 'ParaValidatorIndex'
    },
    paraShared: {
        ValidatorIndex: 'ParaValidatorIndex'
    },
    parachains: {
        Id: 'ParaId'
    },
    parasDisputes: {
        ValidatorIndex: 'ParaValidatorIndex'
    },
    parasInclusion: {
        ValidatorIndex: 'ParaValidatorIndex'
    },
    parasScheduler: {
        ValidatorIndex: 'ParaValidatorIndex'
    },
    parasShared: {
        ValidatorIndex: 'ParaValidatorIndex'
    },
    proposeParachain: {
        Proposal: 'ParachainProposal'
    },
    proxy: {
        Announcement: 'ProxyAnnouncement'
    },
    scheduler: {
        ValidatorIndex: 'ParaValidatorIndex'
    },
    shared: {
        ValidatorIndex: 'ParaValidatorIndex'
    },
    society: {
        Judgement: 'SocietyJudgement',
        Vote: 'SocietyVote'
    },
    staking: {
        Compact: 'CompactAssignments'
    },
    treasury: {
        Proposal: 'TreasuryProposal'
    },
    xcm: {
        AssetId: 'XcmAssetId'
    },
    xcmPallet: {
        AssetId: 'XcmAssetId'
    }
};
/**
 * @description Get types for specific modules (metadata override)
 */
function getAliasTypes({ knownTypes }, section) {
    return {
        ...(typesAlias[section] ?? {}),
        ...(knownTypes.typesAlias?.[section] ?? {})
    };
}

const BOXES = [['<', '>'], ['<', ','], [',', '>'], ['(', ')'], ['(', ','], [',', ','], [',', ')']];
/**
 * Creates a compatible type mapping
 * @internal
 **/
function compatType(specs, _type) {
    const type = _type.toString();
    const index = specs.findIndex(({ def }) => def.HistoricMetaCompat === type);
    if (index !== -1) {
        return index;
    }
    return specs.push({
        def: {
            HistoricMetaCompat: type
        }
    }) - 1;
}
function compatTypes(specs, ...types) {
    for (let i = 0, count = types.length; i < count; i++) {
        compatType(specs, types[i]);
    }
}
function makeTupleType(specs, entries) {
    return specs.push({
        def: {
            Tuple: entries
        }
    }) - 1;
}
function makeVariantType(modName, variantType, specs, variants) {
    return specs.push({
        def: {
            Variant: { variants }
        },
        path: [`pallet_${modName.toString()}`, 'pallet', variantType]
    }) - 1;
}
/**
 * @internal
 * generate & register the OriginCaller type
 **/
function registerOriginCaller(registry, modules, metaVersion) {
    registry.register({
        OriginCaller: {
            _enum: modules
                .map((mod, index) => [
                mod.name.toString(),
                metaVersion >= 12
                    ? mod.index.toNumber()
                    : index
            ])
                .sort((a, b) => a[1] - b[1])
                .reduce((result, [name, index]) => {
                for (let i = Object.keys(result).length; i < index; i++) {
                    result[`Empty${i}`] = 'Null';
                }
                result[name] = knownOrigins[name] || 'Null';
                return result;
            }, {})
        }
    });
}
/**
 * Find and apply the correct type override
 * @internal
 **/
function setTypeOverride(sectionTypes, types) {
    types.forEach((type) => {
        const override = Object.keys(sectionTypes).find((aliased) => type.eq(aliased));
        if (override) {
            type.setOverride(sectionTypes[override]);
        }
        else {
            // FIXME: NOT happy with this approach, but gets over the initial hump cased by (Vec<Announcement>,BalanceOf)
            const orig = type.toString();
            const alias = Object
                .entries(sectionTypes)
                .reduce((result, [src, dst]) => BOXES.reduce((result, [a, z]) => result.replace(`${a}${src}${z}`, `${a}${dst}${z}`), result), orig);
            if (orig !== alias) {
                type.setOverride(alias);
            }
        }
    });
}
/**
 * Apply module-specific type overrides (always be done as part of toV14)
 * @internal
 **/
function convertCalls$1(specs, registry, modName, calls, sectionTypes) {
    const variants = calls.map(({ args, docs, name }, index) => {
        setTypeOverride(sectionTypes, args.map(({ type }) => type));
        return registry.createTypeUnsafe('SiVariant', [{
                docs,
                fields: args.map(({ name, type }) => registry.createTypeUnsafe('SiField', [{ name, type: compatType(specs, type) }])),
                index,
                name
            }]);
    });
    return registry.createTypeUnsafe('PalletCallMetadataV14', [{
            type: makeVariantType(modName, 'Call', specs, variants)
        }]);
}
/**
 * Apply module-specific type overrides (always be done as part of toV14)
 * @internal
 */
function convertConstants$1(specs, registry, constants, sectionTypes) {
    return constants.map(({ docs, name, type, value }) => {
        setTypeOverride(sectionTypes, [type]);
        return registry.createTypeUnsafe('PalletConstantMetadataV14', [{
                docs,
                name,
                type: compatType(specs, type),
                value
            }]);
    });
}
/**
 * Apply module-specific type overrides (always be done as part of toV14)
 * @internal
 */
function convertErrors(specs, registry, modName, errors, _sectionTypes) {
    const variants = errors.map(({ docs, name }, index) => registry.createTypeUnsafe('SiVariant', [{
            docs,
            fields: [],
            index,
            name
        }]));
    return registry.createTypeUnsafe('PalletErrorMetadataV14', [{
            type: makeVariantType(modName, 'Error', specs, variants)
        }]);
}
/**
 * Apply module-specific type overrides (always be done as part of toV14)
 * @internal
 **/
function convertEvents$1(specs, registry, modName, events, sectionTypes) {
    const variants = events.map(({ args, docs, name }, index) => {
        setTypeOverride(sectionTypes, args);
        return registry.createTypeUnsafe('SiVariant', [{
                docs,
                fields: args.map((t) => registry.createTypeUnsafe('SiField', [{ type: compatType(specs, t) }])),
                index,
                name
            }]);
    });
    return registry.createTypeUnsafe('PalletEventMetadataV14', [{
            type: makeVariantType(modName, 'Event', specs, variants)
        }]);
}
function createMapEntry(specs, registry, sectionTypes, { hashers, isLinked, isOptional, keys, value }) {
    setTypeOverride(sectionTypes, [value, ...(Array.isArray(keys) ? keys : [keys])]);
    return registry.createTypeUnsafe('StorageEntryTypeV14', [{
            Map: {
                hashers,
                key: hashers.length === 1
                    ? compatType(specs, keys[0])
                    : makeTupleType(specs, keys.map((t) => compatType(specs, t))),
                value: isLinked
                    // For previous-generation linked-map support, the actual storage result
                    // is a Tuple with the value and the Linkage (Option appears in teh value-part only)
                    ? compatType(specs, `(${isOptional ? `Option<${value.toString()}>` : value.toString()}, Linkage<${keys[0].toString()}>)`)
                    : compatType(specs, value)
            }
        }]);
}
/**
 * Apply module-specific storage type overrides (always part of toV14)
 * @internal
 **/
function convertStorage$1(specs, registry, { items, prefix }, sectionTypes) {
    return registry.createTypeUnsafe('PalletStorageMetadataV14', [{
            items: items.map(({ docs, fallback, modifier, name, type }) => {
                let entryType;
                if (type.isPlain) {
                    const plain = type.asPlain;
                    setTypeOverride(sectionTypes, [plain]);
                    entryType = registry.createTypeUnsafe('StorageEntryTypeV14', [{
                            Plain: compatType(specs, plain)
                        }]);
                }
                else if (type.isMap) {
                    const map = type.asMap;
                    entryType = createMapEntry(specs, registry, sectionTypes, {
                        hashers: [map.hasher],
                        isLinked: map.linked.isTrue,
                        isOptional: modifier.isOptional,
                        keys: [map.key],
                        value: map.value
                    });
                }
                else if (type.isDoubleMap) {
                    const dm = type.asDoubleMap;
                    entryType = createMapEntry(specs, registry, sectionTypes, {
                        hashers: [dm.hasher, dm.key2Hasher],
                        isLinked: false,
                        isOptional: modifier.isOptional,
                        keys: [dm.key1, dm.key2],
                        value: dm.value
                    });
                }
                else {
                    const nm = type.asNMap;
                    entryType = createMapEntry(specs, registry, sectionTypes, {
                        hashers: nm.hashers,
                        isLinked: false,
                        isOptional: modifier.isOptional,
                        keys: nm.keyVec,
                        value: nm.value
                    });
                }
                return registry.createTypeUnsafe('StorageEntryMetadataV14', [{
                        docs,
                        fallback,
                        modifier,
                        name,
                        type: entryType
                    }]);
            }),
            prefix
        }]);
}
/** @internal */
function convertExtrinsic(registry, { signedExtensions, version }) {
    return registry.createTypeUnsafe('ExtrinsicMetadataV14', [{
            signedExtensions: signedExtensions.map((identifier) => ({
                identifier,
                type: 0 // we don't map the fields at all
            })),
            type: 0, // Map to extrinsic like in v14?
            version
        }]);
}
/** @internal */
function createPallet(specs, registry, mod, { calls, constants, errors, events, storage }) {
    const sectionTypes = getAliasTypes(registry, stringCamelCase(mod.name));
    return registry.createTypeUnsafe('PalletMetadataV14', [{
            calls: calls && convertCalls$1(specs, registry, mod.name, calls, sectionTypes),
            constants: convertConstants$1(specs, registry, constants, sectionTypes),
            errors: errors && convertErrors(specs, registry, mod.name, errors),
            events: events && convertEvents$1(specs, registry, mod.name, events, sectionTypes),
            index: mod.index,
            name: mod.name,
            storage: storage && convertStorage$1(specs, registry, storage, sectionTypes)
        }]);
}
/**
 * Convert the Metadata to v14
 * @internal
 **/
function toV14(registry, v13, metaVersion) {
    const specs = [];
    // position 0 always has Null, additionally add internal defaults
    compatTypes(specs, 'Null', 'u8', 'u16', 'u32', 'u64');
    registerOriginCaller(registry, v13.modules, metaVersion);
    const extrinsic = convertExtrinsic(registry, v13.extrinsic);
    const pallets = v13.modules.map((mod) => createPallet(specs, registry, mod, {
        calls: mod.calls.unwrapOr(null),
        constants: mod.constants,
        errors: mod.errors.length ? mod.errors : null,
        events: mod.events.unwrapOr(null),
        storage: mod.storage.unwrapOr(null)
    }));
    return registry.createTypeUnsafe('MetadataV14', [{
            extrinsic,
            lookup: {
                types: specs.map((type, id) => registry.createTypeUnsafe('PortableType', [{ id, type }]))
            },
            pallets
        }]);
}

/**
 * Convert the Metadata to v15
 * @internal
 **/
function toV15(registry, v14, _) {
    // V15 is mostly equivalent to v14 however it does add
    //
    // 1. The top-level apis entry - it is assumed that in usage we would
    //    just check for all-empty (like this would construct)
    // 2. A docs param on the pallet itself
    // 3. Additional extrinsic parameters
    //
    // A straight conversion with createTypeUndafe magic fills in details
    // We need the UncheckedExtrinsic to extract the types, at least for v14
    // which does have these details embedded (previous-gen won't populate)
    const unchecked = v14.lookup.paramTypes.SpRuntimeUncheckedExtrinsic;
    return registry.createTypeUnsafe('MetadataV15', [
        objectSpread({}, v14, {
            extrinsic: registry.createTypeUnsafe('ExtrinsicMetadataV15', [
                objectSpread({}, v14.extrinsic, {
                    addressType: unchecked?.[0].type.unwrapOr(0),
                    callType: unchecked?.[1].type.unwrapOr(0),
                    extraType: unchecked?.[3].type.unwrapOr(0),
                    signatureType: unchecked?.[2].type.unwrapOr(0)
                })
            ]),
            outerEnums: registry.createTypeUnsafe('OuterEnums15', [{
                    // FIXME We need to extract & add the errorType in here
                    // (these doesn't seem to be an esay way to detect & extract it)
                    callType: unchecked?.[1].type.unwrapOr(0),
                    eventType: v14.lookup.paramTypes.FrameSystemEventRecord?.[0].type.unwrapOr(0)
                }])
        })
    ]);
}

function palletsFromV15(registry, palletV15) {
    const deprecationInfo = registry.createTypeUnsafe('ItemDeprecationInfoV16', ['NotDeprecated']);
    const associatedTypes = registry.createTypeUnsafe('Vec<PalletAssociatedTypeMetadataV16>', [[]]);
    const viewFunctions = registry.createTypeUnsafe('Vec<PalletViewFunctionMetadataV16>', [[]]);
    return registry.createTypeUnsafe('PalletMetadataV16', [
        objectSpread({}, palletV15, {
            associatedTypes,
            calls: palletV15.calls.isSome ? convertCalls(registry, palletV15.calls.unwrap()) : null,
            constants: convertConstants(registry, palletV15.constants),
            deprecationInfo,
            errors: palletV15.errors.isSome ? converErrors(registry, palletV15.errors.unwrap()) : null,
            events: palletV15.events.isSome ? convertEvents(registry, palletV15.events.unwrap()) : null,
            storage: palletV15.storage.isSome ? convertStorage(registry, palletV15.storage.unwrap()) : null,
            viewFunctions
        })
    ]);
}
function convertStorage(registry, storage) {
    const deprecationInfo = registry.createTypeUnsafe('ItemDeprecationInfoV16', ['NotDeprecated']);
    const items = storage.items.map((item) => registry.createTypeUnsafe('StorageEntryMetadataV16', [
        objectSpread({}, item, { deprecationInfo })
    ]));
    return registry.createTypeUnsafe('PalletStorageMetadataV16', [{
            items: registry.createTypeUnsafe('Vec<StorageEntryMetadataV16>', [items]),
            prefix: storage.prefix
        }]);
}
function convertCalls(registry, calls) {
    const deprecationInfo = registry.createTypeUnsafe('EnumDeprecationInfoV16', []);
    return registry.createTypeUnsafe('PalletCallMetadataV16', [{
            deprecationInfo,
            type: calls.type
        }]);
}
function convertEvents(registry, events) {
    const deprecationInfo = registry.createTypeUnsafe('EnumDeprecationInfoV16', []);
    return registry.createTypeUnsafe('PalletEventMetadataV16', [{
            deprecationInfo,
            type: events.type
        }]);
}
function convertConstants(registry, constants) {
    const deprecationInfo = registry.createTypeUnsafe('ItemDeprecationInfoV16', ['NotDeprecated']);
    return registry.createTypeUnsafe('Vec<PalletConstantMetadataV16>', [
        constants.map((constant) => registry.createTypeUnsafe('PalletConstantMetadataV16', [
            objectSpread({}, constant, { deprecationInfo })
        ]))
    ]);
}
function converErrors(registry, errors) {
    const deprecationInfo = registry.createTypeUnsafe('EnumDeprecationInfoV16', []);
    return registry.createTypeUnsafe('PalletErrorMetadataV16', [{
            deprecationInfo,
            type: errors.type
        }]);
}
function extrinsicFromV15(registry, extrinsicV15) {
    const transactionExtensions = extrinsicV15.signedExtensions.map(({ additionalSigned, identifier, type }) => registry.createTypeUnsafe('TransactionExtensionMetadataV16', [{
            identifier,
            implict: additionalSigned,
            type
        }]));
    const indexes = transactionExtensions.map((_, i) => registry.createTypeUnsafe('Compact<u32>', [i]));
    const transactionExtensionsByVersion = registry.createTypeUnsafe('BTreeMap<u8, Vec<Compact<u32>>>', [new Map([[registry.createTypeUnsafe('u8', [extrinsicV15.version]), registry.createTypeUnsafe('Vec<Compact<u32>>', [indexes])]])]);
    return registry.createTypeUnsafe('ExtrinsicMetadataV16', [
        {
            addressType: extrinsicV15.addressType,
            callType: extrinsicV15.callType,
            signatureType: extrinsicV15.signatureType,
            transactionExtensions,
            transactionExtensionsByVersion,
            versions: [extrinsicV15.version]
        }
    ]);
}
function apisFromV15(registry, runtimeApiV15) {
    const deprecationInfo = registry.createTypeUnsafe('ItemDeprecationInfoV16', ['NotDeprecated']);
    const methods = runtimeApiV15.methods.map((method) => registry.createTypeUnsafe('RuntimeApiMethodMetadataV16', [objectSpread({}, method, { deprecationInfo })]));
    return registry.createTypeUnsafe('RuntimeApiMetadataV16', [
        objectSpread({}, runtimeApiV15, {
            deprecationInfo,
            methods,
            version: registry.createTypeUnsafe('Compact<u32>', [0])
        })
    ]);
}
/**
 * Convert the Metadata to v16
 * @internal
 **/
function toV16(registry, v15, _) {
    const pallets = v15.pallets.map((pallet) => {
        return palletsFromV15(registry, pallet);
    });
    const extrinsic = extrinsicFromV15(registry, v15.extrinsic);
    const apis = v15.apis.map((runtimeApi) => apisFromV15(registry, runtimeApi));
    return registry.createTypeUnsafe('MetadataV16', [
        objectSpread({}, v15, {
            apis,
            extrinsic,
            pallets
        })
    ]);
}

/**
 * Convert the Metadata (which is an alias) to latest
 * @internal
 **/
function toLatest(_registry, v16, _metaVersion) {
    return v16;
}

const MAGIC_NUMBER = 0x6174656d; // `meta`, reversed for Little Endian encoding
class MagicNumber extends u32 {
    constructor(registry, value) {
        super(registry, value);
        if (!this.isEmpty && !this.eq(MAGIC_NUMBER)) {
            throw new Error(`MagicNumber mismatch: expected ${registry.createTypeUnsafe('u32', [MAGIC_NUMBER]).toHex()}, found ${this.toHex()}`);
        }
    }
}

const KNOWN_VERSIONS = [16, 15, 14, 13, 12, 11, 10, 9];
const LATEST_VERSION = KNOWN_VERSIONS[0];
const TO_CALLS_VERSION = 14; // LATEST_VERSION;

/**
 * @name MetadataVersioned
 * @description
 * The versioned runtime metadata as a decoded structure
 */
class MetadataVersioned extends Struct {
    #converted = new Map();
    constructor(registry, value) {
        // const timeStart = performance.now()
        super(registry, {
            magicNumber: MagicNumber,
            metadata: 'MetadataAll'
        }, value);
        // console.log('MetadataVersioned', `${(performance.now() - timeStart).toFixed(2)}ms`)
    }
    #assertVersion = (version) => {
        if (this.version > version) {
            throw new Error(`Cannot convert metadata from version ${this.version} to ${version}`);
        }
        return this.version === version;
    };
    #getVersion = (version, fromPrev) => {
        if (version !== 'latest' && this.#assertVersion(version)) {
            const asCurr = `asV${version}`;
            return this.#metadata()[asCurr];
        }
        if (!this.#converted.has(version)) {
            const asPrev = version === 'latest'
                ? `asV${LATEST_VERSION}`
                : `asV${(version - 1)}`;
            this.#converted.set(version, fromPrev(this.registry, this[asPrev], this.version));
        }
        return this.#converted.get(version);
    };
    /**
     * @description the metadata wrapped
     */
    #metadata = () => {
        return this.getT('metadata');
    };
    /**
     * @description Returns the wrapped metadata as a limited calls-only (latest) version
     */
    get asCallsOnly() {
        return new MetadataVersioned(this.registry, {
            magicNumber: this.magicNumber,
            metadata: this.registry.createTypeUnsafe('MetadataAll', [toCallsOnly(this.registry, this.asLatest), TO_CALLS_VERSION])
        });
    }
    /**
     * @description Returns the wrapped metadata as a V9 object
     */
    get asV9() {
        this.#assertVersion(9);
        return this.#metadata().asV9;
    }
    /**
     * @description Returns the wrapped values as a V10 object
     */
    get asV10() {
        return this.#getVersion(10, toV10);
    }
    /**
     * @description Returns the wrapped values as a V11 object
     */
    get asV11() {
        return this.#getVersion(11, toV11);
    }
    /**
     * @description Returns the wrapped values as a V12 object
     */
    get asV12() {
        return this.#getVersion(12, toV12);
    }
    /**
     * @description Returns the wrapped values as a V13 object
     */
    get asV13() {
        return this.#getVersion(13, toV13);
    }
    /**
     * @description Returns the wrapped values as a V14 object
     */
    get asV14() {
        return this.#getVersion(14, toV14);
    }
    /**
     * @description Returns the wrapped values as a V15 object
     */
    get asV15() {
        return this.#getVersion(15, toV15);
    }
    /**
    * @description Returns the wrapped values as a V16 object
    */
    get asV16() {
        return this.#getVersion(16, toV16);
    }
    /**
     * @description Returns the wrapped values as a latest version object
     */
    get asLatest() {
        return this.#getVersion('latest', toLatest);
    }
    /**
     * @description The magicNumber for the Metadata (known constant)
     */
    get magicNumber() {
        return this.getT('magicNumber');
    }
    /**
     * @description the metadata version this structure represents
     */
    get version() {
        return this.#metadata().index;
    }
    getUniqTypes(throwError) {
        return getUniqTypes(this.registry, this.asLatest, throwError);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */
    toJSON() {
        // HACK(y): ensure that we apply the aliases if we have not done so already, this is
        // needed to ensure we have the correct overrides (which is only applied in toLatest)
        // eslint-disable-next-line no-unused-expressions
        this.asLatest;
        return super.toJSON();
    }
}

const EMPTY_METADATA = new Uint8Array([0x6d, 0x65, 0x74, 0x61, 9]);
const VERSION_IDX = EMPTY_METADATA.length - 1;
/** @internal */
function decodeU8a(registry, u8a) {
    if (u8a.length === 0) {
        return EMPTY_METADATA;
    }
    else if (u8a[VERSION_IDX] === 9) {
        // This is an f-ing hack as a follow-up to another ugly hack
        // https://github.com/polkadot-js/api/commit/a9211690be6b68ad6c6dad7852f1665cadcfa5b2
        // when we fail on V9, try to re-parse it as v10...
        try {
            return new MetadataVersioned(registry, u8a);
        }
        catch {
            u8a[VERSION_IDX] = 10;
        }
    }
    return u8a;
}
/**
 * @name Metadata
 * @description
 * The versioned runtime metadata as a decoded structure
 */
class Metadata extends MetadataVersioned {
    constructor(registry, value) {
        // const timeStart = performance.now()
        super(registry, isU8a(value) || isString(value)
            ? decodeU8a(registry, u8aToU8a(value))
            : value);
        // console.log('Metadata', `${(performance.now() - timeStart).toFixed(2)}ms`)
    }
}

/** @internal */
function decorateConstants(registry, { pallets }, _version) {
    const result = {};
    for (let i = 0, count = pallets.length; i < count; i++) {
        const { constants, name } = pallets[i];
        if (!constants.isEmpty) {
            lazyMethod(result, stringCamelCase(name), () => lazyMethods({}, constants, (constant) => {
                const codec = registry.createTypeUnsafe(registry.createLookupType(constant.type), [hexToU8a(constant.value.toHex())]);
                // We are casting here since we are assigning to a read-only property
                codec.meta = constant;
                return codec;
            }, objectNameToCamel));
        }
    }
    return result;
}

function variantToMeta(lookup, variant) {
    return objectSpread({ args: variant.fields.map(({ type }) => lookup.getTypeDef(type).type) }, variant);
}
/** @internal */
function decorateErrors(registry, { lookup, pallets }, version) {
    const result = {};
    for (let i = 0, count = pallets.length; i < count; i++) {
        const { errors, index, name } = pallets[i];
        if (errors.isSome) {
            const sectionIndex = version >= 12 ? index.toNumber() : i;
            lazyMethod(result, stringCamelCase(name), () => lazyVariants(lookup, errors.unwrap(), objectNameToString, (variant) => ({
                // We sprinkle in isCodec & isU8a to ensure we are dealing with the correct objects
                is: (errorMod) => isCodec(errorMod) &&
                    isCodec(errorMod.index) &&
                    errorMod.index.eq(sectionIndex) && (isU8a(errorMod.error)
                    ? errorMod.error[0] === variant.index.toNumber()
                    : isCodec(errorMod.error) && errorMod.error.eq(variant.index)),
                meta: registry.createTypeUnsafe('ErrorMetadataLatest', [variantToMeta(lookup, variant)])
            })));
        }
    }
    return result;
}

function filterEventsSome({ events }) {
    return events.isSome;
}
/** @internal */
function decorateEvents(registry, { lookup, pallets }, version) {
    const result = {};
    const filtered = pallets.filter(filterEventsSome);
    for (let i = 0, count = filtered.length; i < count; i++) {
        const { events, index, name } = filtered[i];
        const sectionIndex = version >= 12 ? index.toNumber() : i;
        lazyMethod(result, stringCamelCase(name), () => lazyVariants(lookup, events.unwrap(), objectNameToString, (variant) => ({
            // We sprinkle in isCodec & isU8a to ensure we are dealing with the correct objects
            is: (eventRecord) => isCodec(eventRecord) &&
                isU8a(eventRecord.index) &&
                sectionIndex === eventRecord.index[0] &&
                variant.index.eq(eventRecord.index[1]),
            meta: registry.createTypeUnsafe('EventMetadataLatest', [variantToMeta(lookup, variant)])
        })));
    }
    return result;
}

const DEFAULT_FN = (data) => xxhashAsU8a(data, 128);
const HASHERS = {
    Blake2_128: (data) => // eslint-disable-line camelcase
     blake2AsU8a(data, 128),
    Blake2_128Concat: (data) => // eslint-disable-line camelcase
     u8aConcat(blake2AsU8a(data, 128), u8aToU8a(data)),
    Blake2_256: (data) => // eslint-disable-line camelcase
     blake2AsU8a(data, 256),
    Identity: (data) => u8aToU8a(data),
    Twox128: (data) => xxhashAsU8a(data, 128),
    Twox256: (data) => xxhashAsU8a(data, 256),
    Twox64Concat: (data) => u8aConcat(xxhashAsU8a(data, 64), u8aToU8a(data))
};
/** @internal */
function getHasher(hasher) {
    return HASHERS[hasher.type] || DEFAULT_FN;
}

const NO_RAW_ARGS = {
    args: [],
    hashers: [],
    keys: []
};
/** @internal */
function filterDefined(a) {
    return !isUndefined(a);
}
/** @internal */
function assertArgs({ method, section }, { args, keys }) {
    if (!Array.isArray(args)) {
        throw new Error(`Call to ${stringCamelCase(section || 'unknown')}.${stringCamelCase(method || 'unknown')} needs ${keys.length} arguments`);
    }
    else if (args.filter(filterDefined).length !== keys.length) {
        throw new Error(`Call to ${stringCamelCase(section || 'unknown')}.${stringCamelCase(method || 'unknown')} needs ${keys.length} arguments, found [${args.join(', ')}]`);
    }
}
/** @internal */
function createKeyRawParts(registry, itemFn, { args, hashers, keys }) {
    const count = keys.length;
    const extra = new Array(count);
    for (let i = 0; i < count; i++) {
        extra[i] = getHasher(hashers[i])(registry.createTypeUnsafe(registry.createLookupType(keys[i]), [args[i]]).toU8a());
    }
    return [
        [
            xxhashAsU8a(itemFn.prefix, 128),
            xxhashAsU8a(itemFn.method, 128)
        ],
        extra
    ];
}
/** @internal */
function createKeyInspect(registry, itemFn, args) {
    assertArgs(itemFn, args);
    const { meta } = itemFn;
    const [prefix, extra] = createKeyRawParts(registry, itemFn, args);
    let types = [];
    if (meta.type.isMap) {
        const { hashers, key } = meta.type.asMap;
        types = hashers.length === 1
            ? [`${hashers[0].type}(${getSiName(registry.lookup, key)})`]
            : registry.lookup.getSiType(key).def.asTuple.map((k, i) => `${hashers[i].type}(${getSiName(registry.lookup, k)})`);
    }
    const names = ['module', 'method'].concat(...args.args.map((_, i) => types[i]));
    return {
        inner: prefix
            .concat(...extra)
            .map((v, i) => ({ name: names[i], outer: [v] }))
    };
}
/** @internal */
function createKeyRaw(registry, itemFn, args) {
    const [prefix, extra] = createKeyRawParts(registry, itemFn, args);
    return u8aConcat(...prefix, ...extra);
}
/** @internal */
function createKey(registry, itemFn, args) {
    assertArgs(itemFn, args);
    // always add the length prefix (underlying it is Bytes)
    return compactAddLength(createKeyRaw(registry, itemFn, args));
}
/** @internal */
function createStorageInspect(registry, itemFn, options) {
    const { meta: { type } } = itemFn;
    return (...args) => {
        if (type.isPlain) {
            return options.skipHashing
                ? { inner: [], name: 'wellKnown', outer: [u8aToU8a(options.key)] }
                : createKeyInspect(registry, itemFn, NO_RAW_ARGS);
        }
        const { hashers, key } = type.asMap;
        return hashers.length === 1
            ? createKeyInspect(registry, itemFn, { args, hashers, keys: [key] })
            : createKeyInspect(registry, itemFn, { args, hashers, keys: registry.lookup.getSiType(key).def.asTuple });
    };
}
/** @internal */
function createStorageFn(registry, itemFn, options) {
    const { meta: { type } } = itemFn;
    let cacheKey = null;
    // Can only have zero or one argument:
    //   - storage.system.account(address)
    //   - storage.timestamp.blockPeriod()
    // For higher-map queries the params are passed in as an tuple, [key1, key2]
    return (...args) => {
        if (type.isPlain) {
            if (!cacheKey) {
                cacheKey = options.skipHashing
                    ? compactAddLength(u8aToU8a(options.key))
                    : createKey(registry, itemFn, NO_RAW_ARGS);
            }
            return cacheKey;
        }
        const { hashers, key } = type.asMap;
        return hashers.length === 1
            ? createKey(registry, itemFn, { args, hashers, keys: [key] })
            : createKey(registry, itemFn, { args, hashers, keys: registry.lookup.getSiType(key).def.asTuple });
    };
}
/** @internal */
function createWithMeta(registry, itemFn, options) {
    const { meta, method, prefix, section } = itemFn;
    const storageFn = createStorageFn(registry, itemFn, options);
    storageFn.inspect = createStorageInspect(registry, itemFn, options);
    storageFn.meta = meta;
    storageFn.method = stringCamelCase(method);
    storageFn.prefix = prefix;
    storageFn.section = section;
    // explicitly add the actual method in the toJSON, this gets used to determine caching and without it
    // instances (e.g. collective) will not work since it is only matched on param meta
    storageFn.toJSON = () => objectSpread({ storage: { method, prefix, section } }, meta.toJSON());
    return storageFn;
}
/** @internal */
function extendHeadMeta(registry, { meta: { docs, name, type }, section }, { method }, iterFn) {
    // metadata with a fallback value using the type of the key, the normal
    // meta fallback only applies to actual entry values, create one for head
    const meta = registry.createTypeUnsafe('StorageEntryMetadataLatest', [{
            docs,
            fallback: registry.createTypeUnsafe('Bytes', []),
            modifier: registry.createTypeUnsafe('StorageEntryModifierLatest', [1]), // required
            name,
            type: registry.createTypeUnsafe('StorageEntryTypeLatest', [type.asMap.key, 0])
        }]);
    iterFn.meta = meta;
    const fn = (...args) => registry.createTypeUnsafe('StorageKey', [iterFn(...args), { method, section }]);
    fn.meta = meta;
    return fn;
}
/** @internal */
function extendPrefixedMap(registry, itemFn, storageFn) {
    const { meta: { type }, method, section } = itemFn;
    storageFn.iterKey = extendHeadMeta(registry, itemFn, storageFn, (...args) => {
        if (args.length && (type.isPlain || (args.length >= type.asMap.hashers.length))) {
            throw new Error(`Iteration of ${stringCamelCase(section || 'unknown')}.${stringCamelCase(method || 'unknown')} needs arguments to be at least one less than the full arguments, found [${args.join(', ')}]`);
        }
        if (args.length) {
            if (type.isMap) {
                const { hashers, key } = type.asMap;
                const keysVec = hashers.length === 1
                    ? [key]
                    : registry.lookup.getSiType(key).def.asTuple;
                return new Raw(registry, createKeyRaw(registry, itemFn, { args, hashers: hashers.slice(0, args.length), keys: keysVec.slice(0, args.length) }));
            }
        }
        return new Raw(registry, createKeyRaw(registry, itemFn, NO_RAW_ARGS));
    });
    return storageFn;
}
/** @internal */
function createFunction(registry, itemFn, options) {
    const { meta: { type } } = itemFn;
    const storageFn = createWithMeta(registry, itemFn, options);
    if (type.isMap) {
        extendPrefixedMap(registry, itemFn, storageFn);
    }
    storageFn.keyPrefix = (...args) => (storageFn.iterKey && storageFn.iterKey(...args)) ||
        compactStripLength(storageFn())[1];
    return storageFn;
}

function findSiPrimitive(registry, type) {
    const prim = type.toLowerCase();
    return registry.lookup.types.find((t) => (t.type.def.isPrimitive &&
        t.type.def.asPrimitive.toString().toLowerCase() === prim) || (t.type.def.isHistoricMetaCompat &&
        t.type.def.asHistoricMetaCompat.toString().toLowerCase() === prim));
}
function findSiType(registry, type) {
    let portable = findSiPrimitive(registry, type);
    // some types are either Sequence or Arrays, cater for these
    // specifically (these all come from the base substrate known keys)
    if (!portable && (type === 'Bytes' || type.startsWith('[u8;'))) {
        const u8 = findSiPrimitive(registry, 'u8');
        if (u8) {
            if (type === 'Bytes') {
                portable = registry.lookup.types.find((t) => (t.type.def.isSequence &&
                    t.type.def.asSequence.type.eq(u8.id)) || (t.type.def.isHistoricMetaCompat &&
                    t.type.def.asHistoricMetaCompat.eq(type)));
            }
            else {
                const td = getTypeDef(type);
                portable = registry.lookup.types.find((t) => (t.type.def.isArray &&
                    t.type.def.asArray.eq({
                        len: td.length,
                        type: u8.id
                    })) || (t.type.def.isHistoricMetaCompat &&
                    t.type.def.asHistoricMetaCompat.eq(type)));
            }
        }
    }
    if (!portable) {
        // Not fatal, however if this happens the storage key using this
        // type will not return valid values, rather it will most probably
        // be decoded incorrectly
        console.warn(`Unable to map ${type} to a lookup index`);
    }
    return portable;
}
/** @internal */
function createRuntimeFunction({ method, prefix, section }, key, { docs, type }) {
    return (registry) => createFunction(registry, {
        meta: registry.createTypeUnsafe('StorageEntryMetadataLatest', [{
                docs: registry.createTypeUnsafe('Vec<Text>', [[docs]]),
                modifier: registry.createTypeUnsafe('StorageEntryModifierLatest', ['Required']),
                name: registry.createTypeUnsafe('Text', [method]),
                toJSON: () => key,
                type: registry.createTypeUnsafe('StorageEntryTypeLatest', [{ Plain: findSiType(registry, type)?.id || 0 }])
            }]),
        method,
        prefix,
        section
    }, { key, skipHashing: true });
}

const prefix = 'Substrate';
const section = 'substrate';
function createSubstrateFn(method, key, meta) {
    return createRuntimeFunction({ method, prefix, section }, key, meta);
}
const substrate = {
    changesTrieConfig: createSubstrateFn('changesTrieConfig', ':changes_trie', {
        docs: 'Changes trie configuration is stored under this key.',
        type: 'u32'
    }),
    childStorageKeyPrefix: createSubstrateFn('childStorageKeyPrefix', ':child_storage:', {
        docs: 'Prefix of child storage keys.',
        type: 'u32'
    }),
    code: createSubstrateFn('code', ':code', {
        docs: 'Wasm code of the runtime.',
        type: 'Bytes'
    }),
    defaultChildStorageKeyPrefix: createSubstrateFn('defaultChildStorageKeyPrefix', ':child_storage:default:', {
        docs: 'Prefix of the default child storage keys in the top trie.',
        type: 'u32'
    }),
    extrinsicIndex: createSubstrateFn('extrinsicIndex', ':extrinsic_index', {
        docs: 'Current extrinsic index (u32) is stored under this key.',
        type: 'u32'
    }),
    heapPages: createSubstrateFn('heapPages', ':heappages', {
        docs: 'Number of wasm linear memory pages required for execution of the runtime.',
        type: 'u64'
    }),
    intrablockEntropy: createSubstrateFn('intrablockEntropy', ':intrablock_entropy', {
        docs: 'Current intra-block entropy (a universally unique `[u8; 32]` value) is stored here.',
        type: '[u8; 32]'
    }),
    storageVersionStorageKeyPostfix: createSubstrateFn('storageVersionStorageKeyPostfix', ':__STORAGE_VERSION__:', {
        docs: 'The storage key postfix that is used to store the [`StorageVersion`] per pallet.',
        type: 'u16'
    }),
    transactionLevelKey: createSubstrateFn('transactionLevelKey', ':transaction_level:', {
        docs: 'The key that holds the current number of active layers.',
        type: 'u32'
    })
};

/** @internal */
function getStorage(registry) {
    const storage = {};
    const entries = Object.entries(substrate);
    for (let e = 0, count = entries.length; e < count; e++) {
        storage[entries[e][0]] = entries[e][1](registry);
    }
    return { substrate: storage };
}

const VERSION_NAME = 'palletVersion';
const VERSION_KEY = ':__STORAGE_VERSION__:';
const VERSION_DOCS = { docs: 'Returns the current pallet version from storage', type: 'u16' };
/** @internal */
function decorateStorage(registry, { pallets }, _metaVersion) {
    const result = getStorage(registry);
    for (let i = 0, count = pallets.length; i < count; i++) {
        const { name, storage } = pallets[i];
        if (storage.isSome) {
            const section = stringCamelCase(name);
            const { items, prefix: _prefix } = storage.unwrap();
            const prefix = _prefix.toString();
            lazyMethod(result, section, () => lazyMethods({
                palletVersion: createRuntimeFunction({ method: VERSION_NAME, prefix, section }, createKeyRaw(registry, { method: VERSION_KEY, prefix: name.toString() }, NO_RAW_ARGS), VERSION_DOCS)(registry)
            }, items, (meta) => createFunction(registry, { meta, method: meta.name.toString(), prefix, section }, {}), objectNameToCamel));
        }
    }
    return result;
}

/**
 * Expands the metadata by decoration into consts, query and tx sections
 */
function expandMetadata(registry, metadata) {
    if (!(metadata instanceof Metadata)) {
        throw new Error('You need to pass a valid Metadata instance to Decorated');
    }
    const latest = metadata.asLatest;
    const version = metadata.version;
    return {
        consts: decorateConstants(registry, latest),
        errors: decorateErrors(registry, latest, version),
        events: decorateEvents(registry, latest, version),
        query: decorateStorage(registry, latest),
        registry,
        tx: decorateExtrinsics(registry, latest, version)
    };
}

const DEFAULT_FIRST_CALL_IDX = new Uint8Array(2);
const l$4 = logger('registry');
function sortDecimalStrings(a, b) {
    return parseInt(a, 10) - parseInt(b, 10);
}
function valueToString(v) {
    return v.toString();
}
function getFieldArgs(lookup, fields) {
    const count = fields.length;
    const args = new Array(count);
    for (let i = 0; i < count; i++) {
        args[i] = lookup.getTypeDef(fields[i].type).type;
    }
    return args;
}
function clearRecord(record) {
    const keys = Object.keys(record);
    for (let i = 0, count = keys.length; i < count; i++) {
        delete record[keys[i]];
    }
}
function getVariantStringIdx({ index }) {
    return index.toString();
}
function injectErrors(_, { lookup, pallets }, version, result) {
    clearRecord(result);
    for (let i = 0, count = pallets.length; i < count; i++) {
        const { errors, index, name } = pallets[i];
        if (errors.isSome) {
            const sectionName = stringCamelCase(name);
            lazyMethod(result, version >= 12 ? index.toNumber() : i, () => lazyVariants(lookup, errors.unwrap(), getVariantStringIdx, ({ docs, fields, index, name }) => ({
                args: getFieldArgs(lookup, fields),
                docs: docs.map(valueToString),
                fields,
                index: index.toNumber(),
                method: name.toString(),
                name: name.toString(),
                section: sectionName
            })));
        }
    }
}
function injectEvents(registry, { lookup, pallets }, version, result) {
    const filtered = pallets.filter(filterEventsSome);
    clearRecord(result);
    for (let i = 0, count = filtered.length; i < count; i++) {
        const { events, index, name } = filtered[i];
        lazyMethod(result, version >= 12 ? index.toNumber() : i, () => lazyVariants(lookup, events.unwrap(), getVariantStringIdx, (variant) => {
            const meta = registry.createType('EventMetadataLatest', objectSpread({}, variant, { args: getFieldArgs(lookup, variant.fields) }));
            return class extends GenericEventData {
                constructor(registry, value) {
                    super(registry, value, meta, stringCamelCase(name), variant.name.toString());
                }
            };
        }));
    }
}
function injectExtrinsics(registry, { lookup, pallets }, version, result, mapping) {
    const filtered = pallets.filter(filterCallsSome);
    clearRecord(result);
    clearRecord(mapping);
    for (let i = 0, count = filtered.length; i < count; i++) {
        const { calls, index, name } = filtered[i];
        const sectionIndex = version >= 12 ? index.toNumber() : i;
        const sectionName = stringCamelCase(name);
        const allCalls = calls.unwrap();
        lazyMethod(result, sectionIndex, () => lazyVariants(lookup, allCalls, getVariantStringIdx, (variant) => createCallFunction(registry, lookup, variant, sectionName, sectionIndex)));
        const { path } = registry.lookup.getSiType(allCalls.type);
        // frame_system::pallet::Call / pallet_balances::pallet::Call / polkadot_runtime_parachains::configuration::pallet::Call /
        const palletIdx = path.findIndex((v) => v.eq('pallet'));
        if (palletIdx !== -1) {
            const name = stringCamelCase(path
                .slice(0, palletIdx)
                .map((p, i) => i === 0
                // frame_system || pallet_balances
                ? p.replace(/^(frame|pallet)_/, '')
                : p)
                .join(' '));
            if (!mapping[name]) {
                mapping[name] = [sectionName];
            }
            else {
                mapping[name].push(sectionName);
            }
        }
    }
}
function extractProperties(registry, metadata) {
    const original = registry.getChainProperties();
    const constants = decorateConstants(registry, metadata.asLatest, metadata.version);
    const ss58Format = constants['system'] && (constants['system']['sS58Prefix'] || constants['system']['ss58Prefix']);
    if (!ss58Format) {
        return original;
    }
    const { isEthereum, tokenDecimals, tokenSymbol } = original || {};
    return registry.createTypeUnsafe('ChainProperties', [{ isEthereum, ss58Format, tokenDecimals, tokenSymbol }]);
}
class TypeRegistry {
    #chainProperties;
    #classes = new Map();
    #definitions = new Map();
    #firstCallIndex = null;
    #hasher = blake2AsU8a;
    #knownTypes = {};
    #lookup;
    #metadata;
    #metadataVersion = 0;
    #signedExtensions = fallbackExtensions;
    #unknownTypes = new Map();
    #userExtensions;
    #knownDefaults;
    #knownDefaultsEntries;
    #knownDefinitions;
    #metadataCalls = {};
    #metadataErrors = {};
    #metadataEvents = {};
    #moduleMap = {};
    createdAtHash;
    constructor(createdAtHash) {
        this.#knownDefaults = new Map(Object.entries({ Json, Metadata, PortableRegistry, Raw, ...baseTypes }));
        this.#knownDefaultsEntries = Array.from(this.#knownDefaults.entries());
        this.#knownDefinitions = typeDefinitions;
        const allKnown = Object.values(this.#knownDefinitions);
        for (let i = 0, count = allKnown.length; i < count; i++) {
            this.register(allKnown[i].types);
        }
        if (createdAtHash) {
            this.createdAtHash = this.createType('BlockHash', createdAtHash);
        }
    }
    get chainDecimals() {
        if (this.#chainProperties?.tokenDecimals.isSome) {
            const allDecimals = this.#chainProperties.tokenDecimals.unwrap();
            if (allDecimals.length) {
                return allDecimals.map((b) => b.toNumber());
            }
        }
        return [12];
    }
    get chainIsEthereum() {
        return this.#chainProperties?.isEthereum.isTrue || false;
    }
    get chainSS58() {
        return this.#chainProperties?.ss58Format.isSome
            ? this.#chainProperties.ss58Format.unwrap().toNumber()
            : undefined;
    }
    get chainTokens() {
        if (this.#chainProperties?.tokenSymbol.isSome) {
            const allTokens = this.#chainProperties.tokenSymbol.unwrap();
            if (allTokens.length) {
                return allTokens.map(valueToString);
            }
        }
        return [formatBalance.getDefaults().unit];
    }
    get firstCallIndex() {
        return this.#firstCallIndex || DEFAULT_FIRST_CALL_IDX;
    }
    /**
     * @description Returns true if the type is in a Compat format
     */
    isLookupType(value) {
        return /Lookup\d+$/.test(value);
    }
    /**
     * @description Creates a lookup string from the supplied id
     */
    createLookupType(lookupId) {
        return `Lookup${typeof lookupId === 'number' ? lookupId : lookupId.toNumber()}`;
    }
    get knownTypes() {
        return this.#knownTypes;
    }
    get lookup() {
        return assertReturn(this.#lookup, 'PortableRegistry has not been set on this registry');
    }
    get metadata() {
        return assertReturn(this.#metadata, 'Metadata has not been set on this registry');
    }
    get unknownTypes() {
        return [...this.#unknownTypes.keys()];
    }
    get signedExtensions() {
        return this.#signedExtensions;
    }
    clearCache() {
        this.#classes = new Map();
    }
    /**
     * @describe Creates an instance of the class
     */
    createClass(type) {
        return createClassUnsafe(this, type);
    }
    /**
     * @describe Creates an instance of the class
     */
    createClassUnsafe(type) {
        return createClassUnsafe(this, type);
    }
    /**
     * @description Creates an instance of a type as registered
     */
    createType(type, ...params) {
        return createTypeUnsafe(this, type, params);
    }
    /**
     * @description Creates an instance of a type as registered
     */
    createTypeUnsafe(type, params, options) {
        return createTypeUnsafe(this, type, params, options);
    }
    // find a specific call
    findMetaCall(callIndex) {
        const [section, method] = [callIndex[0], callIndex[1]];
        return assertReturn(this.#metadataCalls[`${section}`] && this.#metadataCalls[`${section}`][`${method}`], () => `findMetaCall: Unable to find Call with index [${section}, ${method}]/[${callIndex.toString()}]`);
    }
    // finds an error
    findMetaError(errorIndex) {
        const [section, method] = isU8a(errorIndex)
            ? [errorIndex[0], errorIndex[1]]
            : [
                errorIndex.index.toNumber(),
                isU8a(errorIndex.error)
                    ? errorIndex.error[0]
                    : errorIndex.error.toNumber()
            ];
        return assertReturn(this.#metadataErrors[`${section}`] && this.#metadataErrors[`${section}`][`${method}`], () => `findMetaError: Unable to find Error with index [${section}, ${method}]/[${errorIndex.toString()}]`);
    }
    findMetaEvent(eventIndex) {
        const [section, method] = [eventIndex[0], eventIndex[1]];
        return assertReturn(this.#metadataEvents[`${section}`] && this.#metadataEvents[`${section}`][`${method}`], () => `findMetaEvent: Unable to find Event with index [${section}, ${method}]/[${eventIndex.toString()}]`);
    }
    get(name, withUnknown, knownTypeDef) {
        return this.getUnsafe(name, withUnknown, knownTypeDef);
    }
    getUnsafe(name, withUnknown, knownTypeDef) {
        let Type = this.#classes.get(name) || this.#knownDefaults.get(name);
        // we have not already created the type, attempt it
        if (!Type) {
            const definition = this.#definitions.get(name);
            let BaseType;
            // we have a definition, so create the class now (lazily)
            if (definition) {
                BaseType = createClassUnsafe(this, definition);
            }
            else if (knownTypeDef) {
                BaseType = constructTypeClass(this, knownTypeDef);
            }
            else if (withUnknown) {
                l$4.warn(`Unable to resolve type ${name}, it will fail on construction`);
                this.#unknownTypes.set(name, true);
                BaseType = DoNotConstruct.with(name);
            }
            if (BaseType) {
                // NOTE If we didn't extend here, we would have strange artifacts. An example is
                // Balance, with this, new Balance() instanceof u128 is true, but Balance !== u128
                // Additionally, we now pass through the registry, which is a link to ourselves
                Type = class extends BaseType {
                };
                this.#classes.set(name, Type);
                // In the case of lookups, we also want to store the actual class against
                // the lookup name, instad of having to traverse again
                if (knownTypeDef && isNumber(knownTypeDef.lookupIndex)) {
                    this.#classes.set(this.createLookupType(knownTypeDef.lookupIndex), Type);
                }
            }
        }
        return Type;
    }
    getChainProperties() {
        return this.#chainProperties;
    }
    getClassName(Type) {
        // we cannot rely on export order (anymore, since babel/core 7.15.8), so in the case of
        // items such as u32 & U32, we get the lowercase versions here... not quite as optimal
        // (previously this used to be a simple find & return)
        const names = [];
        for (const [name, Clazz] of this.#knownDefaultsEntries) {
            if (Type === Clazz) {
                names.push(name);
            }
        }
        for (const [name, Clazz] of this.#classes.entries()) {
            if (Type === Clazz) {
                names.push(name);
            }
        }
        return names.length
            // both sort and reverse are done in-place
            // ['U32', 'u32'] -> ['u32', 'U32']
            ? names.sort().reverse()[0]
            : undefined;
    }
    getDefinition(typeName) {
        return this.#definitions.get(typeName);
    }
    getModuleInstances(specName, moduleName) {
        return this.#knownTypes?.typesBundle?.spec?.[specName.toString()]?.instances?.[moduleName] || this.#moduleMap[moduleName];
    }
    getOrThrow(name) {
        const Clazz = this.get(name);
        if (!Clazz) {
            throw new Error(`type ${name} not found`);
        }
        return Clazz;
    }
    getOrUnknown(name) {
        return this.get(name, true);
    }
    // Only used in extrinsic version 5
    getTransactionExtensionVersion() {
        return 0;
    }
    getSignedExtensionExtra() {
        return expandExtensionTypes(this.#signedExtensions, 'payload', this.#userExtensions);
    }
    getSignedExtensionTypes() {
        return expandExtensionTypes(this.#signedExtensions, 'extrinsic', this.#userExtensions);
    }
    hasClass(name) {
        return this.#classes.has(name) || !!this.#knownDefaults.has(name);
    }
    hasDef(name) {
        return this.#definitions.has(name);
    }
    hasType(name) {
        return !this.#unknownTypes.get(name) && (this.hasClass(name) || this.hasDef(name));
    }
    hash(data) {
        return this.createType('CodecHash', this.#hasher(data));
    }
    // eslint-disable-next-line no-dupe-class-members
    register(arg1, arg2) {
        // NOTE Constructors appear as functions here
        if (isFunction$1(arg1)) {
            this.#classes.set(arg1.name, arg1);
        }
        else if (isString(arg1)) {
            if (!isFunction$1(arg2)) {
                throw new Error(`Expected class definition passed to '${arg1}' registration`);
            }
            else if (arg1 === arg2.toString()) {
                throw new Error(`Unable to register circular ${arg1} === ${arg1}`);
            }
            this.#classes.set(arg1, arg2);
        }
        else {
            this.#registerObject(arg1);
        }
    }
    #registerObject = (obj) => {
        const entries = Object.entries(obj);
        for (let e = 0, count = entries.length; e < count; e++) {
            const [name, type] = entries[e];
            if (isFunction$1(type)) {
                // This _looks_ a bit funny, but `typeof Clazz === 'function'
                this.#classes.set(name, type);
            }
            else {
                const def = isString(type)
                    ? type
                    : stringify(type);
                if (name === def) {
                    throw new Error(`Unable to register circular ${name} === ${def}`);
                }
                // we already have this type, remove the classes registered for it
                if (this.#classes.has(name)) {
                    this.#classes.delete(name);
                }
                this.#definitions.set(name, def);
            }
        }
    };
    // sets the chain properties
    setChainProperties(properties) {
        if (properties) {
            this.#chainProperties = properties;
        }
    }
    setHasher(hasher) {
        this.#hasher = hasher || blake2AsU8a;
    }
    setKnownTypes(knownTypes) {
        this.#knownTypes = knownTypes;
    }
    setLookup(lookup) {
        this.#lookup = lookup;
        // register all applicable types found
        lookup.register();
    }
    // register alias types alongside the portable/lookup setup
    // (we don't combine this into setLookup since that would/could
    // affect stand-along lookups, such as ABIs which don't have
    // actual on-chain metadata)
    #registerLookup = (lookup) => {
        // attach the lookup before we register any types
        this.setLookup(lookup);
        // we detect based on runtime configuration
        let Weight = null;
        if (this.hasType('SpWeightsWeightV2Weight')) {
            // detection for WeightV2 type based on latest naming
            const weightv2 = this.createType('SpWeightsWeightV2Weight');
            Weight = weightv2.refTime && weightv2.proofSize
                // with both refTime & proofSize we use as-is (WeightV2)
                ? 'SpWeightsWeightV2Weight'
                // fallback to WeightV1 (WeightV1.5 is a struct, single field)
                : 'WeightV1';
        }
        else if (!isBn(this.createType('Weight'))) {
            // where we have an already-supplied BN override, we don't clobber
            // it with our detected value (This protects against pre-defines
            // where Weight may be aliassed to WeightV0, e.g. in early Kusama chains)
            Weight = 'WeightV1';
        }
        if (Weight) {
            // we have detected a version, adjust the definition
            this.register({ Weight });
        }
    };
    // sets the metadata
    setMetadata(metadata, signedExtensions, userExtensions, noInitWarn) {
        this.#metadata = metadata.asLatest;
        this.#metadataVersion = metadata.version;
        this.#firstCallIndex = null;
        // attach the lookup at this point and register relevant types (before injecting)
        this.#registerLookup(this.#metadata.lookup);
        injectExtrinsics(this, this.#metadata, this.#metadataVersion, this.#metadataCalls, this.#moduleMap);
        injectErrors(this, this.#metadata, this.#metadataVersion, this.#metadataErrors);
        injectEvents(this, this.#metadata, this.#metadataVersion, this.#metadataEvents);
        // set the default call index (the lowest section, the lowest method)
        // in most chains this should be 0,0
        const [defSection] = Object
            .keys(this.#metadataCalls)
            .sort(sortDecimalStrings);
        if (defSection) {
            const [defMethod] = Object
                .keys(this.#metadataCalls[defSection])
                .sort(sortDecimalStrings);
            if (defMethod) {
                this.#firstCallIndex = new Uint8Array([parseInt(defSection, 10), parseInt(defMethod, 10)]);
            }
        }
        // setup the available extensions
        this.setSignedExtensions(signedExtensions || (this.#metadata.extrinsic.versions.length > 0 && this.#metadata.extrinsic.versions.every((value) => value > 0)
            // FIXME Use the extension and their injected types
            ? this.#metadata.extrinsic.transactionExtensions.map(({ identifier }) => identifier.toString())
            : fallbackExtensions), userExtensions, noInitWarn);
        // setup the chain properties with format overrides
        this.setChainProperties(extractProperties(this, metadata));
    }
    // sets the available signed extensions
    setSignedExtensions(signedExtensions = fallbackExtensions, userExtensions, noInitWarn) {
        this.#signedExtensions = signedExtensions;
        this.#userExtensions = userExtensions;
        if (!noInitWarn) {
            const unknown = findUnknownExtensions(this.#signedExtensions, this.#userExtensions);
            if (unknown.length) {
                l$4.warn(`Unknown signed extensions ${unknown.join(', ')} found, treating them as no-effect`);
            }
        }
    }
}

/** @internal */
function refCountDelay(delay = 1750) {
    return (source) => {
        // state: 0 = disconnected, 1 = disconnecting, 2 = connecting, 3 = connected
        let [state, refCount, connection, scheduler] = [0, 0, Subscription.EMPTY, Subscription.EMPTY];
        return new Observable((ob) => {
            source.subscribe(ob);
            if (refCount++ === 0) {
                if (state === 1) {
                    scheduler.unsubscribe();
                }
                else {
                    // eslint-disable-next-line deprecation/deprecation
                    connection = source.connect();
                }
                state = 3;
            }
            return () => {
                if (--refCount === 0) {
                    if (state === 2) {
                        state = 0;
                        scheduler.unsubscribe();
                    }
                    else {
                        // state === 3
                        state = 1;
                        scheduler = asapScheduler.schedule(() => {
                            state = 0;
                            connection.unsubscribe();
                        }, delay);
                    }
                }
            };
        });
    };
}

function CMP(a, b) {
    return stringify({ t: a }) === stringify({ t: b });
}
function ERR(error) {
    throw error;
}
function NOOP() {
    // empty
}
/**
 * Shorthand for distinctUntilChanged(), publishReplay(1) and refCount().
 *
 * @ignore
 * @internal
 */
function drr({ delay, skipChange = false, skipTimeout = false } = {}) {
    return (source$) => source$.pipe(catchError(ERR), skipChange
        ? tap(NOOP)
        : distinctUntilChanged(CMP), 
    // eslint-disable-next-line deprecation/deprecation
    publishReplay(1), skipTimeout
        // eslint-disable-next-line deprecation/deprecation
        ? refCount()
        : refCountDelay(delay));
}

/** @internal */
function memo(instanceId, inner) {
    const options = { getInstanceId: () => instanceId };
    const cached = memoize((...params) => new Observable((observer) => {
        const subscription = inner(...params).subscribe(observer);
        return () => {
            cached.unmemoize(...params);
            subscription.unsubscribe();
        };
    }).pipe(drr()), options);
    return cached;
}

const l$3 = logger('rpc-core');
const EMPTY_META = {
    fallback: undefined,
    modifier: { isOptional: true },
    type: {
        asMap: { linked: { isTrue: false } },
        isMap: false
    }
};
const RPC_CORE_DEFAULT_CAPACITY = 1024 * 10 * 10;
/** @internal */
function logErrorMessage(method, { noErrorLog, params, type }, error) {
    if (noErrorLog) {
        return;
    }
    l$3.error(`${method}(${params.map(({ isOptional, name, type }) => `${name}${isOptional ? '?' : ''}: ${type}`).join(', ')}): ${type}:: ${error.message}`);
}
function isTreatAsHex(key) {
    // :code is problematic - it does not have the length attached, which is
    // unlike all other storage entries where it is indeed properly encoded
    return ['0x3a636f6465'].includes(key.toHex());
}
/**
 * @name Rpc
 * @summary The API may use a HTTP or WebSockets provider.
 * @description It allows for querying a Polkadot Client Node.
 * WebSockets provider is recommended since HTTP provider only supports basic querying.
 *
 * ```mermaid
 * graph LR;
 *   A[Api] --> |WebSockets| B[WsProvider];
 *   B --> |endpoint| C[ws://127.0.0.1:9944]
 * ```
 *
 * @example
 * <BR>
 *
 * ```javascript
 * import Rpc from '@polkadot/rpc-core';
 * import { WsProvider } from '@polkadot/rpc-provider/ws';
 *
 * const provider = new WsProvider('ws://127.0.0.1:9944');
 * const rpc = new Rpc(provider);
 * ```
 */
class RpcCore {
    #instanceId;
    #isPedantic;
    #registryDefault;
    #storageCache;
    #storageCacheHits = 0;
    #getBlockRegistry;
    #getBlockHash;
    mapping = new Map();
    provider;
    sections = [];
    /**
     * @constructor
     * Default constructor for the core RPC handler
     * @param {Registry} registry Type Registry
     * @param {ProviderInterface} options.provider An API provider using any of the supported providers (HTTP, SC or WebSocket)
     * @param {number} [options.rpcCacheCapacity] Custom size of the rpc LRUCache capacity. Defaults to `RPC_CORE_DEFAULT_CAPACITY` (1024 * 10 * 10)
     */
    constructor(instanceId, registry, { isPedantic = true, provider, rpcCacheCapacity, ttl, userRpc = {} }) {
        if (!provider || !isFunction$1(provider.send)) {
            throw new Error('Expected Provider to API create');
        }
        this.#instanceId = instanceId;
        this.#isPedantic = isPedantic;
        this.#registryDefault = registry;
        this.provider = provider;
        const sectionNames = Object.keys(jsonrpc);
        // these are the base keys (i.e. part of jsonrpc)
        this.sections.push(...sectionNames);
        this.#storageCache = new LRUCache(rpcCacheCapacity || RPC_CORE_DEFAULT_CAPACITY, ttl);
        // decorate all interfaces, defined and user on this instance
        this.addUserInterfaces(userRpc);
    }
    /**
     * @description Returns the connected status of a provider
     */
    get isConnected() {
        return this.provider.isConnected;
    }
    /**
     * @description Manually connect from the attached provider
     */
    connect() {
        return this.provider.connect();
    }
    /**
     * @description Manually disconnect from the attached provider
     */
    async disconnect() {
        return this.provider.disconnect();
    }
    /**
     * @description Returns the underlying core stats, including those from teh provider
     */
    get stats() {
        const stats = this.provider.stats;
        return stats
            ? {
                ...stats,
                core: {
                    cacheHits: this.#storageCacheHits,
                    cacheSize: this.#storageCache.length
                }
            }
            : undefined;
    }
    /**
     * @description Sets a registry swap (typically from Api)
     */
    setRegistrySwap(registrySwap) {
        this.#getBlockRegistry = memoize(registrySwap, {
            getInstanceId: () => this.#instanceId
        });
    }
    /**
     * @description Sets a function to resolve block hash from block number
     */
    setResolveBlockHash(resolveBlockHash) {
        this.#getBlockHash = memoize(resolveBlockHash, {
            getInstanceId: () => this.#instanceId
        });
    }
    addUserInterfaces(userRpc) {
        // add any extra user-defined sections
        this.sections.push(...Object.keys(userRpc).filter((k) => !this.sections.includes(k)));
        for (let s = 0, scount = this.sections.length; s < scount; s++) {
            const section = this.sections[s];
            const defs = objectSpread({}, jsonrpc[section], userRpc[section]);
            const methods = Object.keys(defs);
            for (let m = 0, mcount = methods.length; m < mcount; m++) {
                const method = methods[m];
                const def = defs[method];
                const jsonrpc = def.endpoint || `${section}_${method}`;
                if (!this.mapping.has(jsonrpc)) {
                    const isSubscription = !!def.pubsub;
                    if (!this[section]) {
                        this[section] = {};
                    }
                    this.mapping.set(jsonrpc, objectSpread({}, def, { isSubscription, jsonrpc, method, section }));
                    lazyMethod(this[section], method, () => isSubscription
                        ? this._createMethodSubscribe(section, method, def)
                        : this._createMethodSend(section, method, def));
                }
            }
        }
    }
    _memomize(creator, def) {
        const memoOpts = { getInstanceId: () => this.#instanceId };
        const memoized = memoize(creator(true), memoOpts);
        memoized.raw = memoize(creator(false), memoOpts);
        memoized.meta = def;
        return memoized;
    }
    _formatResult(isScale, registry, blockHash, method, def, params, result) {
        return isScale
            ? this._formatOutput(registry, blockHash, method, def, params, result)
            : result;
    }
    _createMethodSend(section, method, def) {
        const rpcName = def.endpoint || `${section}_${method}`;
        const hashIndex = def.params.findIndex(({ isHistoric }) => isHistoric);
        let memoized = null;
        // execute the RPC call, doing a registry swap for historic as applicable
        const callWithRegistry = async (isScale, values) => {
            const blockId = hashIndex === -1
                ? null
                : values[hashIndex];
            const blockHash = blockId && def.params[hashIndex].type === 'BlockNumber'
                ? await this.#getBlockHash?.(blockId)
                : blockId;
            const { registry } = isScale && blockHash && this.#getBlockRegistry
                ? await this.#getBlockRegistry(u8aToU8a(blockHash))
                : { registry: this.#registryDefault };
            const params = this._formatParams(registry, null, def, values);
            // only cache .at(<blockHash>) queries, e.g. where valid blockHash was supplied
            const result = await this.provider.send(rpcName, params.map((p) => p.toJSON()), !!blockHash);
            return this._formatResult(isScale, registry, blockHash, method, def, params, result);
        };
        const creator = (isScale) => (...values) => {
            const isDelayed = isScale && hashIndex !== -1 && !!values[hashIndex];
            return new Observable((observer) => {
                callWithRegistry(isScale, values)
                    .then((value) => {
                    observer.next(value);
                    observer.complete();
                })
                    .catch((error) => {
                    logErrorMessage(method, def, error);
                    observer.error(error);
                    observer.complete();
                });
                return () => {
                    // delete old results from cache
                    if (isScale) {
                        memoized?.unmemoize(...values);
                    }
                    else {
                        memoized?.raw.unmemoize(...values);
                    }
                };
            }).pipe(
            // eslint-disable-next-line deprecation/deprecation
            publishReplay(1), // create a Replay(1)
            isDelayed
                ? refCountDelay() // Unsubscribe after delay
                // eslint-disable-next-line deprecation/deprecation
                : refCount());
        };
        memoized = this._memomize(creator, def);
        return memoized;
    }
    // create a subscriptor, it subscribes once and resolves with the id as subscribe
    _createSubscriber({ paramsJson, subName, subType, update }, errorHandler) {
        return new Promise((resolve, reject) => {
            this.provider
                .subscribe(subType, subName, paramsJson, update)
                .then(resolve)
                .catch((error) => {
                errorHandler(error);
                reject(error);
            });
        });
    }
    _createMethodSubscribe(section, method, def) {
        const [updateType, subMethod, unsubMethod] = def.pubsub;
        const subName = `${section}_${subMethod}`;
        const unsubName = `${section}_${unsubMethod}`;
        const subType = `${section}_${updateType}`;
        let memoized = null;
        const creator = (isScale) => (...values) => {
            return new Observable((observer) => {
                // Have at least an empty promise, as used in the unsubscribe
                let subscriptionPromise = Promise.resolve(null);
                const registry = this.#registryDefault;
                const errorHandler = (error) => {
                    logErrorMessage(method, def, error);
                    observer.error(error);
                };
                try {
                    const params = this._formatParams(registry, null, def, values);
                    const update = (error, result) => {
                        if (error) {
                            logErrorMessage(method, def, error);
                            return;
                        }
                        try {
                            observer.next(this._formatResult(isScale, registry, null, method, def, params, result));
                        }
                        catch (error) {
                            observer.error(error);
                        }
                    };
                    subscriptionPromise = this._createSubscriber({ paramsJson: params.map((p) => p.toJSON()), subName, subType, update }, errorHandler);
                }
                catch (error) {
                    errorHandler(error);
                }
                // Teardown logic
                return () => {
                    // Delete from cache, so old results don't hang around
                    if (isScale) {
                        memoized?.unmemoize(...values);
                    }
                    else {
                        memoized?.raw.unmemoize(...values);
                    }
                    // Unsubscribe from provider
                    subscriptionPromise
                        .then((subscriptionId) => isNull(subscriptionId)
                        ? Promise.resolve(false)
                        : this.provider.unsubscribe(subType, unsubName, subscriptionId))
                        .catch((error) => logErrorMessage(method, def, error));
                };
            }).pipe(drr());
        };
        memoized = this._memomize(creator, def);
        return memoized;
    }
    _formatParams(registry, blockHash, def, inputs) {
        const count = inputs.length;
        const reqCount = def.params.filter(({ isOptional }) => !isOptional).length;
        if (count < reqCount || count > def.params.length) {
            throw new Error(`Expected ${def.params.length} parameters${reqCount === def.params.length ? '' : ` (${def.params.length - reqCount} optional)`}, ${count} found instead`);
        }
        const params = new Array(count);
        for (let i = 0; i < count; i++) {
            params[i] = registry.createTypeUnsafe(def.params[i].type, [inputs[i]], { blockHash });
        }
        return params;
    }
    _formatOutput(registry, blockHash, method, rpc, params, result) {
        if (rpc.type === 'StorageData') {
            const key = params[0];
            return this._formatStorageData(registry, blockHash, key, result);
        }
        else if (rpc.type === 'StorageChangeSet') {
            const keys = params[0];
            return keys
                ? this._formatStorageSet(registry, result.block, keys, result.changes)
                : registry.createType('StorageChangeSet', result);
        }
        else if (rpc.type === 'Vec<StorageChangeSet>') {
            const jsonSet = result;
            const count = jsonSet.length;
            const mapped = new Array(count);
            for (let i = 0; i < count; i++) {
                const { block, changes } = jsonSet[i];
                mapped[i] = [
                    registry.createType('BlockHash', block),
                    this._formatStorageSet(registry, block, params[0], changes)
                ];
            }
            // we only query at a specific block, not a range - flatten
            return method === 'queryStorageAt'
                ? mapped[0][1]
                : mapped;
        }
        return registry.createTypeUnsafe(rpc.type, [result], { blockHash });
    }
    _formatStorageData(registry, blockHash, key, value) {
        const isEmpty = isNull(value);
        // we convert to Uint8Array since it maps to the raw encoding, all
        // data will be correctly encoded (incl. numbers, excl. :code)
        const input = isEmpty
            ? null
            : isTreatAsHex(key)
                ? value
                : u8aToU8a(value);
        return this._newType(registry, blockHash, key, input, isEmpty);
    }
    _formatStorageSet(registry, blockHash, keys, changes) {
        // For StorageChangeSet, the changes has the [key, value] mappings
        const count = keys.length;
        const withCache = count !== 1;
        const values = new Array(count);
        // multiple return values (via state.storage subscription), decode the
        // values one at a time, all based on the supplied query types
        for (let i = 0; i < count; i++) {
            values[i] = this._formatStorageSetEntry(registry, blockHash, keys[i], changes, withCache, i);
        }
        return values;
    }
    _formatStorageSetEntry(registry, blockHash, key, changes, withCache, entryIndex) {
        const hexKey = key.toHex();
        const found = changes.find(([key]) => key === hexKey);
        const isNotFound = isUndefined(found);
        // if we don't find the value, this is our fallback
        //   - in the case of an array of values, fill the hole from the cache
        //   - if a single result value, don't fill - it is not an update hole
        //   - fallback to an empty option in all cases
        if (isNotFound && withCache) {
            const cached = this.#storageCache.get(hexKey);
            if (cached) {
                this.#storageCacheHits++;
                return cached;
            }
        }
        const value = isNotFound
            ? null
            : found[1];
        const isEmpty = isNull(value);
        const input = isEmpty || isTreatAsHex(key)
            ? value
            : u8aToU8a(value);
        const codec = this._newType(registry, blockHash, key, input, isEmpty, entryIndex);
        this._setToCache(hexKey, codec);
        return codec;
    }
    _setToCache(key, value) {
        this.#storageCache.set(key, value);
    }
    _newType(registry, blockHash, key, input, isEmpty, entryIndex = -1) {
        // single return value (via state.getStorage), decode the value based on the
        // outputType that we have specified. Fallback to Raw on nothing
        const type = key.meta ? registry.createLookupType(unwrapStorageSi(key.meta.type)) : (key.outputType || 'Raw');
        const meta = key.meta || EMPTY_META;
        const entryNum = entryIndex === -1
            ? ''
            : ` entry ${entryIndex}:`;
        try {
            return registry.createTypeUnsafe(type, [
                isEmpty
                    ? meta.fallback
                        // For old-style Linkage, we add an empty linkage at the end
                        ? type.includes('Linkage<')
                            ? u8aConcat(hexToU8a(meta.fallback.toHex()), new Uint8Array(2))
                            : hexToU8a(meta.fallback.toHex())
                        : undefined
                    : meta.modifier.isOptional
                        ? registry.createTypeUnsafe(type, [input], { blockHash, isPedantic: this.#isPedantic })
                        : input
            ], { blockHash, isFallback: isEmpty && !!meta.fallback, isOptional: meta.modifier.isOptional, isPedantic: this.#isPedantic && !meta.modifier.isOptional });
        }
        catch (error) {
            throw new Error(`Unable to decode storage ${key.section || 'unknown'}.${key.method || 'unknown'}:${entryNum}: ${error.message}`);
        }
    }
}

function unwrapBlockNumber(hdr) {
    return isCompact(hdr.number)
        ? hdr.number.unwrap()
        : hdr.number;
}

const deriveNoopCache = {
    del: () => undefined,
    forEach: () => undefined,
    get: () => undefined,
    set: (_, value) => value
};

let deriveCache;
function setDeriveCache(prefix = '', cache) {
    deriveCache = deriveNoopCache;
}
setDeriveCache();

function firstObservable(obs) {
    return obs.pipe(map(([a]) => a));
}
function firstMemo(fn) {
    return (instanceId, api) => memo(instanceId, (...args) => firstObservable(fn(api, ...args)));
}

function lazyDeriveSection(result, section, getKeys, creator) {
    lazyMethod(result, section, () => lazyMethods({}, getKeys(section), (method) => creator(section, method)));
}

/**
 * @name accountId
 * @param {(Address | AccountId | AccountIndex | string | null)} address An accounts address in various formats.
 * @description Resolves an address (in different formats) to its corresponding `AccountId`.
 * @example
 * ```javascript
 * const ALICE = "F7Hs";
 *
 * api.derive.accounts.accountId(ALICE, (accountId) => {
 *   console.log(`Resolved AccountId: ${accountId}`);
 * });
 * ```
 */
function accountId(instanceId, api) {
    return memo(instanceId, (address) => {
        const decoded = isU8a(address)
            ? address
            : decodeAddress((address || '').toString());
        if (decoded.length > 8) {
            return of(api.registry.createType(decoded.length === 20 ? 'AccountId20' : 'AccountId', decoded));
        }
        const accountIndex = api.registry.createType('AccountIndex', decoded);
        return api.derive.accounts.indexToId(accountIndex.toString()).pipe(map((a) => assertReturn(a, 'Unable to retrieve accountId')));
    });
}

function parseFlags(address, [electionsMembers, councilMembers, technicalCommitteeMembers, societyMembers, sudoKey]) {
    const addrStr = address?.toString();
    const isIncluded = (id) => id.toString() === addrStr;
    return {
        isCouncil: (electionsMembers?.map((r) => Array.isArray(r) ? r[0] : r.who) || councilMembers || []).some(isIncluded),
        isSociety: (societyMembers || []).some(isIncluded),
        isSudo: sudoKey?.toString() === addrStr,
        isTechCommittee: (technicalCommitteeMembers || []).some(isIncluded)
    };
}
function _flags(instanceId, api) {
    return memo(instanceId, () => {
        const results = [undefined, [], [], [], undefined];
        const calls = [
            (api.query.elections || api.query['phragmenElection'] || api.query['electionsPhragmen'])?.members,
            api.query.council?.members,
            api.query.technicalCommittee?.members,
            api.query.society?.members,
            api.query.sudo?.key
        ];
        const filtered = calls.filter((c) => c);
        if (!filtered.length) {
            return of(results);
        }
        return api.queryMulti(filtered).pipe(map((values) => {
            let resultIndex = -1;
            for (let i = 0, count = calls.length; i < count; i++) {
                if (isFunction$1(calls[i])) {
                    results[i] = values[++resultIndex];
                }
            }
            return results;
        }));
    });
}
/**
 * @name flags
 * @param {(AccountId | Address | string | null)} address The account identifier.
 * @description Retrieves the membership flags for a given account.
 * @example
 * const ALICE = "F7Hs";
 *
 * api.derive.accounts.flags(ALICE, (flags) => {
 *   console.log(
 *     `Account Flags:`,
 *     Object.keys(flags).map((flag) => `${flag}: ${flags[flag]}`)
 *   );
 * });
 */
function flags(instanceId, api) {
    return memo(instanceId, (address) => api.derive.accounts._flags().pipe(map((r) => parseFlags(address, r))));
}

/**
 * @name idAndIndex
 * @param {(Address | AccountId | AccountIndex | Uint8Array | string | null)} address An accounts address in various formats.
 * @description An array containing the [[AccountId]] and [[AccountIndex]] as optional values.
 * @example
 * ```javascript
 * api.derive.accounts.idAndIndex('F7Hs', ([id, ix]) => {
 *   console.log(`AccountId #${id} with corresponding AccountIndex ${ix}`);
 * });
 * ```
 */
function idAndIndex(instanceId, api) {
    return memo(instanceId, (address) => {
        try {
            // yes, this can fail, don't care too much, catch will catch it
            const decoded = isU8a(address)
                ? address
                : decodeAddress((address || '').toString());
            if (decoded.length > 8) {
                const accountId = api.registry.createType(decoded.length === 20 ? 'AccountId20' : 'AccountId', decoded);
                return api.derive.accounts.idToIndex(accountId).pipe(map((accountIndex) => [accountId, accountIndex]));
            }
            const accountIndex = api.registry.createType('AccountIndex', decoded);
            return api.derive.accounts.indexToId(accountIndex.toString()).pipe(map((accountId) => [accountId, accountIndex]));
        }
        catch {
            return of([undefined, undefined]);
        }
    });
}

const UNDEF_HEX = { toHex: () => undefined };
function dataAsString(data) {
    if (!data) {
        return data;
    }
    return data.isRaw
        ? u8aToString(data.asRaw.toU8a(true))
        : data.isNone
            ? undefined
            : data.toHex();
}
function extractOther(additional) {
    return additional.reduce((other, [_key, _value]) => {
        const key = dataAsString(_key);
        const value = dataAsString(_value);
        if (key && value) {
            other[key] = value;
        }
        return other;
    }, {});
}
function identityCompat(identityOfOpt) {
    const identity = identityOfOpt.unwrap();
    return Array.isArray(identity)
        ? identity[0]
        : identity;
}
function extractIdentity(identityOfOpt, superOf) {
    if (!identityOfOpt?.isSome) {
        return { judgements: [] };
    }
    const { info, judgements } = identityCompat(identityOfOpt);
    const topDisplay = dataAsString(info.display);
    return {
        discord: dataAsString(info.discord),
        display: (superOf && dataAsString(superOf[1])) || topDisplay,
        displayParent: superOf && topDisplay,
        email: dataAsString(info.email),
        github: dataAsString(info.github),
        image: dataAsString(info.image),
        judgements,
        legal: dataAsString(info.legal),
        matrix: dataAsString(info.matrix),
        other: info.additional ? extractOther(info.additional) : {},
        parent: superOf?.[0],
        pgp: info.pgpFingerprint.unwrapOr(UNDEF_HEX).toHex(),
        riot: dataAsString(info.riot),
        twitter: dataAsString(info.twitter),
        web: dataAsString(info.web)
    };
}
function getParent(api, identityOfOpt, superOfOpt) {
    if (identityOfOpt?.isSome) {
        // this identity has something set
        return of([identityOfOpt, undefined]);
    }
    else if (superOfOpt?.isSome) {
        const superOf = superOfOpt.unwrap();
        return combineLatest([
            api.derive.accounts._identity(superOf[0]).pipe(map(([info]) => info)),
            of(superOf)
        ]);
    }
    // nothing of value returned
    return of([undefined, undefined]);
}
function _identity(instanceId, api) {
    return memo(instanceId, (accountId) => accountId && api.query.identity?.identityOf
        ? combineLatest([
            api.query.identity.identityOf(accountId),
            api.query.identity.superOf(accountId)
        ])
        : of([undefined, undefined]));
}
/**
 * @name identity
 * @description Retrieves the on chain identity information for a given account.
 * @param {(AccountId | Uint8Array | string)} accoutId The account identifier to query the identity for.
 * @example
 * ```javascript
 * const ALICE = "13xAUH";
 *
 * api.derive.accounts.identity(ALICE, (identity) => {
 *   console.log(
 *     "Account Identity:",
 *     Object.keys(identity).map((key) => `${key}: ${identity[key]}`)
 *   );
 * });
 * ```
 */
function identity(instanceId, api) {
    return memo(instanceId, (accountId) => api.derive.accounts._identity(accountId).pipe(switchMap(([identityOfOpt, superOfOpt]) => getParent(api, identityOfOpt, superOfOpt)), map(([identityOfOpt, superOf]) => extractIdentity(identityOfOpt, superOf)), switchMap((identity) => getSubIdentities(identity, api, accountId))));
}
function getSubIdentities(identity, api, accountId) {
    const targetAccount = identity.parent || accountId;
    if (!targetAccount || !api.query.identity) {
        // No valid accountId return the identity as-is
        return of(identity);
    }
    return api.query.identity.subsOf(targetAccount).pipe(map((subsResponse) => {
        const subs = subsResponse[1];
        return {
            ...identity,
            subs
        };
    }));
}
/**
 * @name hasIdentity
 * @description Checks if a specific account has an identity registered on chain.
 * @param {(AccountId | Uint8Array | string)} accoutId The account identifier to query.
 * @example
 * ```javascript
 * const ALICE = "13AU";
 * console.log(await api.derive.accounts.hasIdentity(ALICE));
 * ```
 */
const hasIdentity = /*#__PURE__*/ firstMemo((api, accountId) => api.derive.accounts.hasIdentityMulti([accountId]));
/**
 * @name hasIdentityMulti
 * @description Checks whether multiple accounts have on chain identities registered.
 * @param {(AccountId | Uint8Array | string)[]} accountIds Array of account identifiers to query.
 * @example
 * ```javascript
 * const ALICE = "13AU";
 * const BOB = "16WW";
 * console.log(await api.derive.accounts.hasIdentityMulti([ALICE, BOB]));
 * ```
 */
function hasIdentityMulti(instanceId, api) {
    return memo(instanceId, (accountIds) => api.query.identity?.identityOf
        ? combineLatest([
            api.query.identity.identityOf.multi(accountIds),
            api.query.identity.superOf.multi(accountIds)
        ]).pipe(map(([identities, supers]) => identities.map((identityOfOpt, index) => {
            const superOfOpt = supers[index];
            const parentId = superOfOpt && superOfOpt.isSome
                ? superOfOpt.unwrap()[0].toString()
                : undefined;
            let display;
            if (identityOfOpt && identityOfOpt.isSome) {
                const value = dataAsString(identityCompat(identityOfOpt).info.display);
                if (value && !isHex(value)) {
                    display = value;
                }
            }
            return { display, hasIdentity: !!(display || parentId), parentId };
        })))
        : of(accountIds.map(() => ({ hasIdentity: false }))));
}

/**
 * @name idToIndex
 * @description Retrieves the corresponding AccountIndex.
 * @param {( AccountId | string )} accountId An accounts Id in different formats.
 * @example
 * ```javascript
 * const ALICE = '5GrwvaEF5zXb26Fz9rcQpDWS57CtERHpNehXCPcNoHGKutQY';
 * api.derive.accounts.idToIndex(ALICE, (accountIndex) => {
 *   console.log(`The AccountIndex of ${ALICE} is ${accountIndex}`);
 * });
 * ```
 */
function idToIndex(instanceId, api) {
    return memo(instanceId, (accountId) => api.derive.accounts.indexes().pipe(map((indexes) => indexes[accountId.toString()])));
}

let indicesCache = null;
function queryAccounts(api) {
    return api.query.indices.accounts.entries().pipe(map((entries) => entries.reduce((indexes, [key, idOpt]) => {
        if (idOpt.isSome) {
            indexes[idOpt.unwrap()[0].toString()] = api.registry.createType('AccountIndex', key.args[0]);
        }
        return indexes;
    }, {})));
}
/**
 * @name indexes
 * @returns Returns all the indexes on the system.
 * @description This is an unwieldly query since it loops through
 * all of the enumsets and returns all of the values found. This could be up to 32k depending
 * on the number of active accounts in the system.
 * @example
 * ```javascript
 * api.derive.accounts.indexes((indexes) => {
 *   console.log('All existing AccountIndexes', indexes);
 * });
 * ```
 */
function indexes$1(instanceId, api) {
    return memo(instanceId, () => indicesCache
        ? of(indicesCache)
        : (api.query.indices
            ? queryAccounts(api).pipe(startWith({}))
            : of({})).pipe(map((indices) => {
            indicesCache = indices;
            return indices;
        })));
}

/**
 * @name indexToId
 * @description Resolves an AccountIndex (short address) to the full AccountId.
 * @param {( AccountIndex | string )} accountIndex An accounts index in different formats.
 * @example
 * ```javascript
 * const ALICE = "13AU";
 * const id = await api.derive.accounts.indexToId(ALICE);
 * console.log(id);
 * ```
 */
function indexToId(instanceId, api) {
    return memo(instanceId, (accountIndex) => api.query.indices
        ? api.query.indices.accounts(accountIndex).pipe(map((optResult) => optResult.unwrapOr([])[0]))
        : of(undefined));
}

function retrieveNick(api, accountId) {
    return (accountId && api.query['nicks']?.['nameOf']
        ? api.query['nicks']['nameOf'](accountId)
        : of(undefined)).pipe(map((nameOf) => nameOf?.isSome
        ? u8aToString(nameOf.unwrap()[0]).substring(0, api.consts['nicks']['maxLength'].toNumber())
        : undefined));
}
/**
 * @name info
 * @description Returns aux. info with regards to an account, current that includes the accountId, accountIndex, identity and nickname
 * @param {(AccountIndex | AccountId | Address | Uint8Array | string | null)} address An accounts in different formats.
 * @example
 * ```javascript
 * const ALICE = "13AU";
 * const info = await api.derive.accounts.info(ALICE);
 * console.log(
 *   "Account Info: ",
 *   Object.keys(info).map((key) => `${key}: ${info[key]}`)
 * );
 * ```
 */
function info$4(instanceId, api) {
    return memo(instanceId, (address) => api.derive.accounts.idAndIndex(address).pipe(switchMap(([accountId, accountIndex]) => combineLatest([
        of({ accountId, accountIndex }),
        api.derive.accounts.identity(accountId),
        retrieveNick(api, accountId)
    ])), map(([{ accountId, accountIndex }, identity, nickname]) => ({
        accountId, accountIndex, identity, nickname
    }))));
}

var accounts$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	_flags: _flags,
	_identity: _identity,
	accountId: accountId,
	flags: flags,
	hasIdentity: hasIdentity,
	hasIdentityMulti: hasIdentityMulti,
	idAndIndex: idAndIndex,
	idToIndex: idToIndex,
	identity: identity,
	indexToId: indexToId,
	indexes: indexes$1,
	info: info$4
});

function getInstance(api, section) {
    const instances = api.registry.getModuleInstances(api.runtimeVersion.specName, section);
    const name = instances?.length
        ? instances[0]
        : section;
    return api.query[name];
}
function withSection(section, fn) {
    return (instanceId, api) => memo(instanceId, fn(getInstance(api, section), api, instanceId));
}
function callMethod(method, empty) {
    return (section) => withSection(section, (query) => () => isFunction$1(query?.[method])
        ? query[method]()
        : of(empty));
}

const members$5 = /*#__PURE__*/ callMethod('members', []);

function prime$4(section) {
    return withSection(section, (query) => () => isFunction$1(query?.prime)
        ? query.prime().pipe(map((o) => o.unwrapOr(null)))
        : of(null));
}

function parse$4(api, [hashes, proposals, votes]) {
    return proposals.map((o, index) => ({
        hash: api.registry.createType('Hash', hashes[index]),
        proposal: o && o.isSome
            ? o.unwrap()
            : null,
        votes: votes[index].unwrapOr(null)
    }));
}
function _proposalsFrom(api, query, hashes) {
    return (isFunction$1(query?.proposals) && hashes.length
        ? combineLatest([
            of(hashes),
            // this should simply be api.query[section].proposalOf.multi<Option<Proposal>>(hashes),
            // however we have had cases on Edgeware where the indices have moved around after an
            // upgrade, which results in invalid on-chain data
            query.proposalOf.multi(hashes).pipe(catchError(() => of(hashes.map(() => null)))),
            query.voting.multi(hashes)
        ])
        : of([[], [], []])).pipe(map((r) => parse$4(api, r)));
}
function hasProposals$4(section) {
    return withSection(section, (query) => () => of(isFunction$1(query?.proposals)));
}
function proposals$6(section) {
    return withSection(section, (query, api) => () => api.derive[section].proposalHashes().pipe(switchMap((all) => _proposalsFrom(api, query, all))));
}
function proposal$4(section) {
    return withSection(section, (query, api) => (hash) => isFunction$1(query?.proposals)
        ? firstObservable(_proposalsFrom(api, query, [hash]))
        : of(null));
}
const proposalCount$4 = /*#__PURE__*/ callMethod('proposalCount', null);
const proposalHashes$4 = /*#__PURE__*/ callMethod('proposals', []);

/**
 * @name members
 * @description Retrieves the list of members in the "allianceMotion" collective.
 * @example
 * ```javascript
 * const members = await api.derive.alliance.members();
 * console.log(`Members: ${JSON.stringify(members)});
 * ```
 */
const members$4 = /*#__PURE__*/ members$5('allianceMotion');
/**
 * @name hasProposals
 * @description Checks if there are any active proposals in the "allianceMotion" collective.
 * @example
 * ```javascript
 * const exists = await api.derive.alliance.hasProposals();
 * console.log(exists);
 * ```
 */
const hasProposals$3 = /*#__PURE__*/ hasProposals$4('allianceMotion');
/**
 * @name proposal
 * @description Retrieves details of a specific proposal in the "allianceMotion" collective by its hash.
 * @example
 * ```javascript
 * const proposalDetails = await api.derive.alliance.proposal(PROPOSAL_HASH);
 * console.log(proposalDetails);
 * ```
 */
const proposal$3 = /*#__PURE__*/ proposal$4('allianceMotion');
/**
 * @name proposalCount
 * @description Retrieves the total number of proposals in the "allianceMotion" collective.
 * @example
 * ```javascript
 * const count = await api.derive.alliance.proposalCount();
 * console.log(`Amount of proposals: ${count}`);
 * ```
 */
const proposalCount$3 = /*#__PURE__*/ proposalCount$4('allianceMotion');
/**
 * @name proposalHashes
 * @description Retrieves an array of hashes for all active proposals in the "allianceMotion" collective.
 * @example
 * ```javascript
 * const hashes = await api.derive.alliance.proposalHashes();
 * console.log(`Proposals ${JSON.stringify(hashes)}`);
 * ```
 */
const proposalHashes$3 = /*#__PURE__*/ proposalHashes$4('allianceMotion');
/**
 * @name proposals
 * @description Retrieves a list of all active proposals in the "allianceMotion" collective.
 * @example
 * ```javascript
 * const proposals = await api.derive.alliance.proposals();
 * console.log(proposals);
 * ```
 */
const proposals$5 = /*#__PURE__*/ proposals$6('allianceMotion');
/**
 * @name prime
 * @description Retrieves the prime member of the "allianceMotion" collective, if one exists.
 * @example
 * ```javascript
 * const primeMember = await api.derive.alliance.prime();
 * console.log(primeMember);
 * ```
 */
const prime$3 = /*#__PURE__*/ prime$4('allianceMotion');

var alliance = /*#__PURE__*/Object.freeze({
	__proto__: null,
	hasProposals: hasProposals$3,
	members: members$4,
	prime: prime$3,
	proposal: proposal$3,
	proposalCount: proposalCount$3,
	proposalHashes: proposalHashes$3,
	proposals: proposals$5
});

function getQueryInterface(api) {
    return (
    // latest substrate & polkadot
    api.query.voterList ||
        // previous substrate
        api.query['voterBagsList'] ||
        api.query['bagsList']);
}

function orderBags(ids, bags) {
    const sorted = ids
        .map((id, index) => ({
        bag: bags[index].unwrapOr(null),
        id,
        key: id.toString()
    }))
        .sort((a, b) => b.id.cmp(a.id));
    const max = sorted.length - 1;
    return sorted.map((entry, index) => objectSpread(entry, {
        bagLower: index === max
            ? BN_ZERO
            : sorted[index + 1].id,
        bagUpper: entry.id,
        index
    }));
}
function _getIds(instanceId, api) {
    const query = getQueryInterface(api);
    return memo(instanceId, (_ids) => {
        const ids = _ids.map((id) => bnToBn(id));
        return ids.length
            ? query.listBags.multi(ids).pipe(map((bags) => orderBags(ids, bags)))
            : of([]);
    });
}
function all$1(instanceId, api) {
    const query = getQueryInterface(api);
    return memo(instanceId, () => query.listBags.keys().pipe(switchMap((keys) => api.derive.bagsList._getIds(keys.map(({ args: [id] }) => id))), map((list) => list.filter(({ bag }) => bag))));
}
/**
 * @name get
 * @param {(BN | number)} id The id of the bag to retrieve.
 * @description Retrieves a specific bag from the BagsList pallet by its id.
 */
function get(instanceId, api) {
    return memo(instanceId, (id) => api.derive.bagsList._getIds([bnToBn(id)]).pipe(map((bags) => bags[0])));
}

/**
 * @name expand
 * @description Expands a given bag by retrieving all its nodes (accounts contained within the bag).
 * @param {Bag} bag The bag to be expanded.
 */
function expand(instanceId, api) {
    return memo(instanceId, (bag) => api.derive.bagsList.listNodes(bag.bag).pipe(map((nodes) => objectSpread({ nodes }, bag))));
}
/**
 * @name getExpanded
 * @description Retrieves and expands a specific bag from the BagsList pallet.
 * @param {BN | number} id The id of the bag to expand.
 */
function getExpanded(instanceId, api) {
    return memo(instanceId, (id) => api.derive.bagsList.get(id).pipe(switchMap((bag) => api.derive.bagsList.expand(bag))));
}

function traverseLinks(api, head) {
    const subject = new BehaviorSubject(head);
    const query = getQueryInterface(api);
    return subject.pipe(switchMap((account) => query.listNodes(account)), tap((node) => {
        nextTick(() => {
            node.isSome && node.value.next.isSome
                ? subject.next(node.unwrap().next.unwrap())
                : subject.complete();
        });
    }), toArray(), // toArray since we want to startSubject to be completed
    map((all) => all.map((o) => o.unwrap())));
}
/**
 * @name listNodes
 * @param {(PalletBagsListListBag | null)} bag A reference to a specific bag in the BagsList pallet.
 * @description Retrieves the list of nodes (accounts) contained in a specific bag within the BagsList pallet.
 */
function listNodes(instanceId, api) {
    return memo(instanceId, (bag) => bag && bag.head.isSome
        ? traverseLinks(api, bag.head.unwrap())
        : of([]));
}

var bagsList = /*#__PURE__*/Object.freeze({
	__proto__: null,
	_getIds: _getIds,
	all: all$1,
	expand: expand,
	get: get,
	getExpanded: getExpanded,
	listNodes: listNodes
});

const VESTING_ID = '0x76657374696e6720';
function calcLocked(api, bestNumber, locks) {
    let lockedBalance = api.registry.createType('Balance');
    let lockedBreakdown = [];
    let vestingLocked = api.registry.createType('Balance');
    let allLocked = false;
    if (Array.isArray(locks)) {
        // only get the locks that are valid until passed the current block
        lockedBreakdown = locks.filter(({ until }) => !until || (bestNumber && until.gt(bestNumber)));
        allLocked = lockedBreakdown.some(({ amount }) => amount && amount.isMax());
        vestingLocked = api.registry.createType('Balance', lockedBreakdown.filter(({ id }) => id.eq(VESTING_ID)).reduce((result, { amount }) => result.iadd(amount), new BN(0)));
        // get the maximum of the locks according to https://github.com/paritytech/substrate/blob/master/srml/balances/src/lib.rs#L699
        const notAll = lockedBreakdown.filter(({ amount }) => amount && !amount.isMax());
        if (notAll.length) {
            lockedBalance = api.registry.createType('Balance', bnMax(...notAll.map(({ amount }) => amount)));
        }
    }
    return { allLocked, lockedBalance, lockedBreakdown, vestingLocked };
}
function calcShared(api, bestNumber, data, locks) {
    const { allLocked, lockedBalance, lockedBreakdown, vestingLocked } = calcLocked(api, bestNumber, locks);
    let transferable = null;
    if (data?.frameSystemAccountInfo?.frozen) {
        const { frameSystemAccountInfo, freeBalance, reservedBalance } = data;
        const noFrozenReserved = frameSystemAccountInfo.frozen.isZero() && reservedBalance.isZero();
        const ED = api.consts.balances.existentialDeposit;
        const maybeED = noFrozenReserved ? new BN(0) : ED;
        const frozenReserveDif = frameSystemAccountInfo.frozen.sub(reservedBalance);
        transferable = api.registry.createType('Balance', allLocked
            ? 0
            : bnMax(new BN(0), freeBalance.sub(bnMax(maybeED, frozenReserveDif))));
    }
    return objectSpread({}, data, {
        availableBalance: api.registry.createType('Balance', allLocked ? 0 : bnMax(new BN(0), data?.freeBalance ? data.freeBalance.sub(lockedBalance) : new BN(0))),
        lockedBalance,
        lockedBreakdown,
        transferable,
        vestingLocked
    });
}
function calcVesting(bestNumber, shared, _vesting) {
    // Calculate the vesting balances,
    //  - offset = balance locked at startingBlock
    //  - perBlock is the unlock amount
    const vesting = _vesting || [];
    const isVesting = !shared.vestingLocked.isZero();
    const vestedBalances = vesting.map(({ locked, perBlock, startingBlock }) => bestNumber.gt(startingBlock)
        ? bnMin(locked, perBlock.mul(bestNumber.sub(startingBlock)))
        : BN_ZERO);
    const vestedBalance = vestedBalances.reduce((all, value) => all.iadd(value), new BN(0));
    const vestingTotal = vesting.reduce((all, { locked }) => all.iadd(locked), new BN(0));
    return {
        isVesting,
        vestedBalance,
        vestedClaimable: isVesting
            ? shared.vestingLocked.sub(vestingTotal.sub(vestedBalance))
            : BN_ZERO,
        vesting: vesting
            .map(({ locked, perBlock, startingBlock }, index) => ({
            endBlock: locked.div(perBlock).iadd(startingBlock),
            locked,
            perBlock,
            startingBlock,
            vested: vestedBalances[index]
        }))
            .filter(({ locked }) => !locked.isZero()),
        vestingTotal
    };
}
function calcBalances$1(api, result) {
    const [data, [vesting, allLocks, namedReserves], bestNumber] = result;
    const shared = calcShared(api, bestNumber, data, allLocks[0]);
    return objectSpread(shared, calcVesting(bestNumber, shared, vesting), {
        accountId: data.accountId,
        accountNonce: data.accountNonce,
        additional: allLocks
            .slice(1)
            .map((l, index) => calcShared(api, bestNumber, data.additional[index], l)),
        namedReserves
    });
}
function queryOld(api, accountId) {
    return combineLatest([
        api.query.balances.locks(accountId),
        api.query.balances['vesting'](accountId)
    ]).pipe(map(([locks, optVesting]) => {
        let vestingNew = null;
        if (optVesting.isSome) {
            const { offset: locked, perBlock, startingBlock } = optVesting.unwrap();
            vestingNew = api.registry.createType('VestingInfo', { locked, perBlock, startingBlock });
        }
        return [
            vestingNew
                ? [vestingNew]
                : null,
            [locks],
            []
        ];
    }));
}
const isNonNullable = (nullable) => !!nullable;
function createCalls(calls) {
    return [
        calls.map((c) => !c),
        calls.filter(isNonNullable)
    ];
}
function queryCurrent(api, accountId, balanceInstances = ['balances']) {
    const [lockEmpty, lockQueries] = createCalls(balanceInstances.map((m) => api.derive[m]?.customLocks || api.query[m]?.locks));
    const [reserveEmpty, reserveQueries] = createCalls(balanceInstances.map((m) => api.query[m]?.reserves));
    return combineLatest([
        api.query.vesting?.vesting
            ? api.query.vesting.vesting(accountId)
            : of(api.registry.createType('Option<VestingInfo>')),
        lockQueries.length
            ? combineLatest(lockQueries.map((c) => c(accountId)))
            : of([]),
        reserveQueries.length
            ? combineLatest(reserveQueries.map((c) => c(accountId)))
            : of([])
    ]).pipe(map(([opt, locks, reserves]) => {
        let offsetLock = -1;
        let offsetReserve = -1;
        const vesting = opt.unwrapOr(null);
        return [
            vesting
                ? Array.isArray(vesting)
                    ? vesting
                    : [vesting]
                : null,
            lockEmpty.map((e) => e ? api.registry.createType('Vec<BalanceLock>') : locks[++offsetLock]),
            reserveEmpty.map((e) => e ? api.registry.createType('Vec<PalletBalancesReserveData>') : reserves[++offsetReserve])
        ];
    }));
}
/**
 * @name all
 * @description Retrieves the complete balance information for an account, including free balance, locked balance, reserved balance, and more.
 * @param {( AccountId | string )} address An accountsId in different formats.
 * @example
 * ```javascript
 * const ALICE = 'F7Hs';
 *
 * api.derive.balances.account(ALICE, (accountInfo) => {
 *   console.log(
 *     `${accountInfo.accountId} info:`,
 *     Object.keys(accountInfo).map((key) => `${key}: ${accountInfo[key]}`)
 *   );
 * });
 * ```
 */
function all(instanceId, api) {
    const balanceInstances = api.registry.getModuleInstances(api.runtimeVersion.specName, 'balances');
    return memo(instanceId, (address) => combineLatest([
        api.derive.balances.account(address),
        isFunction$1(api.query.system?.account) || isFunction$1(api.query.balances?.account)
            ? queryCurrent(api, address, balanceInstances)
            : queryOld(api, address)
    ]).pipe(switchMap(([account, locks]) => combineLatest([
        of(account),
        of(locks),
        api.derive.chain.bestNumber()
    ])), map((result) => calcBalances$1(api, result))));
}

function zeroBalance(api) {
    return api.registry.createType('Balance');
}
function getBalance(api, [freeBalance, reservedBalance, frozenFeeOrFrozen, frozenMiscOrFlags], accType) {
    const votingBalance = api.registry.createType('Balance', freeBalance.toBn());
    if (accType.isFrameAccountData) {
        return {
            frameSystemAccountInfo: {
                flags: frozenMiscOrFlags,
                frozen: frozenFeeOrFrozen
            },
            freeBalance,
            frozenFee: api.registry.createType('Balance', 0),
            frozenMisc: api.registry.createType('Balance', 0),
            reservedBalance,
            votingBalance
        };
    }
    return {
        freeBalance,
        frozenFee: frozenFeeOrFrozen,
        frozenMisc: frozenMiscOrFlags,
        reservedBalance,
        votingBalance
    };
}
function calcBalances(api, [accountId, [accountNonce, [primary, ...additional], accType]]) {
    return objectSpread({
        accountId,
        accountNonce,
        additional: additional.map((b) => getBalance(api, b, accType))
    }, getBalance(api, primary, accType));
}
function queryBalancesFree(api, accountId) {
    return combineLatest([
        api.query.balances['freeBalance'](accountId),
        api.query.balances['reservedBalance'](accountId),
        api.query.system['accountNonce'](accountId)
    ]).pipe(map(([freeBalance, reservedBalance, accountNonce]) => [
        accountNonce,
        [[freeBalance, reservedBalance, zeroBalance(api), zeroBalance(api)]],
        { isFrameAccountData: false }
    ]));
}
function queryNonceOnly(api, accountId) {
    const fill = (nonce) => [
        nonce,
        [[zeroBalance(api), zeroBalance(api), zeroBalance(api), zeroBalance(api)]],
        { isFrameAccountData: false }
    ];
    return isFunction$1(api.query.system.account)
        ? api.query.system.account(accountId).pipe(map(({ nonce }) => fill(nonce)))
        : isFunction$1(api.query.system['accountNonce'])
            ? api.query.system['accountNonce'](accountId).pipe(map((nonce) => fill(nonce)))
            : of(fill(api.registry.createType('Index')));
}
function queryBalancesAccount(api, accountId, modules = ['balances']) {
    const balances = modules
        .map((m) => api.derive[m]?.customAccount || api.query[m]?.account)
        .filter((q) => isFunction$1(q));
    const extract = (nonce, data) => [
        nonce,
        data.map(({ feeFrozen, free, miscFrozen, reserved }) => [free, reserved, feeFrozen, miscFrozen]),
        { isFrameAccountData: false }
    ];
    // NOTE this is for the first case where we do have instances specified
    return balances.length
        ? isFunction$1(api.query.system.account)
            ? combineLatest([
                api.query.system.account(accountId),
                ...balances.map((c) => c(accountId))
            ]).pipe(map(([{ nonce }, ...balances]) => extract(nonce, balances)))
            : combineLatest([
                api.query.system['accountNonce'](accountId),
                ...balances.map((c) => c(accountId))
            ]).pipe(map(([nonce, ...balances]) => extract(nonce, balances)))
        : queryNonceOnly(api, accountId);
}
function querySystemAccount(api, accountId) {
    // AccountInfo is current, support old, eg. Edgeware
    return api.query.system.account(accountId).pipe(map((infoOrTuple) => {
        const data = infoOrTuple.nonce
            ? infoOrTuple.data
            : infoOrTuple[1];
        const nonce = infoOrTuple.nonce || infoOrTuple[0];
        if (!data || data.isEmpty) {
            return [
                nonce,
                [[zeroBalance(api), zeroBalance(api), zeroBalance(api), zeroBalance(api)]],
                { isFrameAccountData: false }
            ];
        }
        const isFrameType = !!infoOrTuple.data.frozen;
        if (isFrameType) {
            const { flags, free, frozen, reserved } = data;
            return [
                nonce,
                [[free, reserved, frozen, flags]],
                { isFrameAccountData: true }
            ];
        }
        else {
            const { feeFrozen, free, miscFrozen, reserved } = data;
            return [
                nonce,
                [[free, reserved, feeFrozen, miscFrozen]],
                { isFrameAccountData: false }
            ];
        }
    }));
}
/**
 * @name account
 * @description Retrieves the essential balance details for an account, such as free balance and account nonce.
 * @param {( AccountIndex | AccountId | Address | string )} address An accountsId in different formats.
 * @example
 * ```javascript
 * const ALICE = 'F7Hs';
 *
 * api.derive.balances.all(ALICE, ({ accountId, lockedBalance }) => {
 *   console.log(`The account ${accountId} has a locked balance ${lockedBalance} units.`);
 * });
 * ```
 */
function account$1(instanceId, api) {
    const balanceInstances = api.registry.getModuleInstances(api.runtimeVersion.specName, 'balances');
    const nonDefaultBalances = balanceInstances && balanceInstances[0] !== 'balances';
    return memo(instanceId, (address) => api.derive.accounts.accountId(address).pipe(switchMap((accountId) => (accountId
        ? combineLatest([
            of(accountId),
            nonDefaultBalances
                ? queryBalancesAccount(api, accountId, balanceInstances)
                : isFunction$1(api.query.system?.account)
                    ? querySystemAccount(api, accountId)
                    : isFunction$1(api.query.balances?.account)
                        ? queryBalancesAccount(api, accountId)
                        : isFunction$1(api.query.balances?.['freeBalance'])
                            ? queryBalancesFree(api, accountId)
                            : queryNonceOnly(api, accountId)
        ])
        : of([api.registry.createType('AccountId'), [
                api.registry.createType('Index'),
                [[zeroBalance(api), zeroBalance(api), zeroBalance(api), zeroBalance(api)]],
                { isFrameAccountData: false }
            ]]))), map((result) => calcBalances(api, result))));
}

/**
 * @name votingBalances
 * @description Retrieves the balance information for multiple accounts, typically used in governance-related contexts to check voting power.
 * @param {(AccountId | AccountIndex | Address | string)[]} addresses An array of account identifiers.
 * @example
 * ```javascript
 * const addresses = ["5D4b...Zf1", "5HGj...yrV"];
 * const balances = await api.derive.balances.votingBalances(addresses);
 * console.log("Voting Balances:", balances);
 * ```
 */
function votingBalances(instanceId, api) {
    return memo(instanceId, (addresses) => !addresses?.length
        ? of([])
        : combineLatest(addresses.map((accountId) => api.derive.balances.account(accountId))));
}

/**
 * @name votingBalance
 * @param {( AccountId | string )} address An accounts Id in different formats.
 * @returns An object containing the results of various balance queries
 * @example
 * <BR>
 *
 * ```javascript
 * const ALICE = 'F7Hs';
 *
 * api.derive.balances.votingBalance(ALICE, ({ accountId, lockedBalance }) => {
 *   console.log(`The account ${accountId} has a locked balance ${lockedBalance} units.`);
 * });
 * ```
 */
const votingBalance = all;

var balances = /*#__PURE__*/Object.freeze({
	__proto__: null,
	account: account$1,
	all: all,
	votingBalance: votingBalance,
	votingBalances: votingBalances
});

function filterBountiesProposals(api, allProposals) {
    const bountyTxBase = api.tx.bounties ? api.tx.bounties : api.tx.treasury;
    const bountyProposalCalls = [bountyTxBase.approveBounty, bountyTxBase.closeBounty, bountyTxBase.proposeCurator, bountyTxBase.unassignCurator];
    return allProposals.filter((proposal) => bountyProposalCalls.find((bountyCall) => proposal.proposal && bountyCall.is(proposal.proposal)));
}

function parseResult$2([maybeBounties, maybeDescriptions, ids, bountyProposals]) {
    const bounties = [];
    maybeBounties.forEach((bounty, index) => {
        if (bounty.isSome) {
            bounties.push({
                bounty: bounty.unwrap(),
                description: maybeDescriptions[index].unwrapOrDefault().toUtf8(),
                index: ids[index],
                proposals: bountyProposals.filter((bountyProposal) => bountyProposal.proposal && ids[index].eq(bountyProposal.proposal.args[0]))
            });
        }
    });
    return bounties;
}
/**
 * @name bounties
 * @descrive Retrieves all active bounties, their descriptions, and associated proposals.
 * @example
 * ```javascript
 * const bounties = await api.derive.bounties();
 * console.log("Active bounties:", bounties);
 * ```
 */
function bounties$1(instanceId, api) {
    const bountyBase = api.query.bounties || api.query.treasury;
    return memo(instanceId, () => bountyBase.bounties
        ? combineLatest([
            bountyBase.bountyCount(),
            api.query.council
                ? api.query.council.proposalCount()
                : of(0)
        ]).pipe(switchMap(() => combineLatest([
            bountyBase.bounties.keys(),
            api.derive.council
                ? api.derive.council.proposals()
                : of([])
        ])), switchMap(([keys, proposals]) => {
            const ids = keys.map(({ args: [id] }) => id);
            return combineLatest([
                bountyBase.bounties.multi(ids),
                bountyBase.bountyDescriptions.multi(ids),
                of(ids),
                of(filterBountiesProposals(api, proposals))
            ]);
        }), map(parseResult$2))
        : of(parseResult$2([[], [], [], []])));
}

var bounties = /*#__PURE__*/Object.freeze({
	__proto__: null,
	bounties: bounties$1
});

function createBlockNumberDerive(fn) {
    return (instanceId, api) => memo(instanceId, () => fn(api).pipe(map(unwrapBlockNumber)));
}
/** @internal */
function getAuthorDetailsWithAt(header, queryAt) {
    const validators = queryAt.session?.validators
        ? queryAt.session.validators()
        : of(null);
    // nimbus consensus stores the session key of the block author in header logs
    const { logs: [log] } = header.digest;
    const loggedAuthor = (log && ((log.isConsensus && log.asConsensus[0].isNimbus && log.asConsensus[1]) ||
        (log.isPreRuntime && log.asPreRuntime[0].isNimbus && log.asPreRuntime[1])));
    if (loggedAuthor) {
        // use the author mapping pallet, if available (ie: moonbeam, moonriver), to map session (nimbus) key to author (collator/validator) key
        if (queryAt['authorMapping']?.['mappingWithDeposit']) {
            return combineLatest([
                of(header),
                validators,
                queryAt['authorMapping']['mappingWithDeposit'](loggedAuthor).pipe(map((o) => o.unwrapOr({ account: null }).account))
            ]);
        }
        // fall back to session and parachain staking pallets, if available (ie: manta, calamari), to map session (nimbus) key to author (collator) key
        if (queryAt['parachainStaking']?.['selectedCandidates'] && queryAt.session?.nextKeys) {
            const loggedHex = loggedAuthor.toHex();
            return combineLatest([
                of(header),
                validators,
                queryAt['parachainStaking']['selectedCandidates']().pipe(mergeMap((selectedCandidates) => combineLatest([
                    of(selectedCandidates),
                    queryAt.session.nextKeys.multi(selectedCandidates).pipe(map((nextKeys) => nextKeys.findIndex((o) => o.unwrapOrDefault().nimbus.toHex() === loggedHex)))
                ])), map(([selectedCandidates, index]) => index === -1
                    ? null
                    : selectedCandidates[index]))
            ]);
        }
    }
    // normal operation, non-mapping
    return combineLatest([
        of(header),
        validators,
        of(null)
    ]);
}
function getAuthorDetails(api, header, blockHash) {
    // For on-chain state, we need to retrieve it as per the start
    // of the block being constructed, i.e. session validators would
    // be at the point of the block construction, not when all operations
    // has been supplied.
    //
    // However for the first block (no parentHash available), we would
    // just use the as-is
    return api.queryAt(header.parentHash.isEmpty
        ? blockHash || header.hash
        : header.parentHash).pipe(switchMap((queryAt) => getAuthorDetailsWithAt(header, queryAt)));
}

/**
 * @name bestNumber
 * @descrive Retrieves the latest block number.
 * @example
 * ```javascript
 * api.derive.chain.bestNumber((blockNumber) => {
 *   console.log(`the current best block is #${blockNumber}`);
 * });
 * ```
 */
const bestNumber = /*#__PURE__*/ createBlockNumberDerive((api) => api.rpc.chain.subscribeNewHeads());

/**
 * @name bestNumberFinalized
 * @returns A BlockNumber
 * @description Get the latest finalized block number.
 * @example
 * ```javascript
 * api.derive.chain.bestNumberFinalized((blockNumber) => {
 *   console.log(`the current finalized block is #${blockNumber}`);
 * });
 * ```
 */
const bestNumberFinalized = /*#__PURE__*/ createBlockNumberDerive((api) => api.rpc.chain.subscribeFinalizedHeads());

/**
 * @name bestNumberLag
 * @returns A number of blocks
 * @description Calculates the lag between finalized head and best head
 * @examplew
 * ```javascript
 * api.derive.chain.bestNumberLag((lag) => {
 *   console.log(`finalized is ${lag} blocks behind head`);
 * });
 * ```
 */
function bestNumberLag(instanceId, api) {
    return memo(instanceId, () => combineLatest([
        api.derive.chain.bestNumber(),
        api.derive.chain.bestNumberFinalized()
    ]).pipe(map(([bestNumber, bestNumberFinalized]) => api.registry.createType('BlockNumber', bestNumber.sub(bestNumberFinalized)))));
}

function extractAuthor(digest, sessionValidators) {
    const [citem] = digest.logs.filter((e) => e.isConsensus);
    const [pitem] = digest.logs.filter((e) => e.isPreRuntime);
    const [sitem] = digest.logs.filter((e) => e.isSeal);
    let accountId;
    try {
        // This is critical to be first for BABE (before Consensus)
        // If not first, we end up dropping the author at session-end
        if (pitem) {
            const [engine, data] = pitem.asPreRuntime;
            accountId = engine.extractAuthor(data, sessionValidators);
        }
        if (!accountId && citem) {
            const [engine, data] = citem.asConsensus;
            accountId = engine.extractAuthor(data, sessionValidators);
        }
        // SEAL, still used in e.g. Kulupu for pow
        if (!accountId && sitem) {
            const [engine, data] = sitem.asSeal;
            accountId = engine.extractAuthor(data, sessionValidators);
        }
    }
    catch {
        // ignore
    }
    return accountId;
}

function createHeaderExtended(registry, header, validators, author) {
    // an instance of the base extrinsic for us to extend
    const HeaderBase = registry.createClass('Header');
    class Implementation extends HeaderBase {
        #author;
        constructor(registry, header, validators, author) {
            super(registry, header);
            this.#author = author || extractAuthor(this.digest, validators || []);
            this.createdAtHash = header?.createdAtHash;
        }
        /**
         * @description Convenience method, returns the author for the block
         */
        get author() {
            return this.#author;
        }
    }
    return new Implementation(registry, header, validators, author);
}

function mapExtrinsics(extrinsics, records) {
    return extrinsics.map((extrinsic, index) => {
        let dispatchError;
        let dispatchInfo;
        const events = records
            .filter(({ phase }) => phase.isApplyExtrinsic && phase.asApplyExtrinsic.eq(index))
            .map(({ event }) => {
            if (event.section === 'system') {
                if (event.method === 'ExtrinsicSuccess') {
                    dispatchInfo = event.data[0];
                }
                else if (event.method === 'ExtrinsicFailed') {
                    dispatchError = event.data[0];
                    dispatchInfo = event.data[1];
                }
            }
            return event;
        });
        return { dispatchError, dispatchInfo, events, extrinsic };
    });
}
function createSignedBlockExtended(registry, block, events, validators, author) {
    // an instance of the base extrinsic for us to extend
    const SignedBlockBase = registry.createClass('SignedBlock');
    class Implementation extends SignedBlockBase {
        #author;
        #events;
        #extrinsics;
        constructor(registry, block, events, validators, author) {
            super(registry, block);
            this.#author = author || extractAuthor(this.block.header.digest, validators || []);
            this.#events = events || [];
            this.#extrinsics = mapExtrinsics(this.block.extrinsics, this.#events);
            this.createdAtHash = block?.createdAtHash;
        }
        /**
         * @description Convenience method, returns the author for the block
         */
        get author() {
            return this.#author;
        }
        /**
         * @description Convenience method, returns the events associated with the block
         */
        get events() {
            return this.#events;
        }
        /**
         * @description Returns the extrinsics and their events, mapped
         */
        get extrinsics() {
            return this.#extrinsics;
        }
    }
    return new Implementation(registry, block, events, validators, author);
}

/**
 * @name getBlock
 * @param {( Uint8Array | string )} hash A block hash as U8 array or string.
 * @description Get a specific block (e.g. rpc.chain.getBlock) and extend it with the author
 * @example
 * ```javascript
 * const { author, block } = await api.derive.chain.getBlock('0x123...456');
 *
 * console.log(`block #${block.header.number} was authored by ${author}`);
 * ```
 */
function getBlock(instanceId, api) {
    return memo(instanceId, (blockHash) => combineLatest([
        api.rpc.chain.getBlock(blockHash),
        api.queryAt(blockHash)
    ]).pipe(switchMap(([signedBlock, queryAt]) => combineLatest([
        of(signedBlock),
        queryAt.system.events(),
        getAuthorDetails(api, signedBlock.block.header, blockHash)
    ])), map(([signedBlock, events, [, validators, author]]) => createSignedBlockExtended(events.registry, signedBlock, events, validators, author))));
}

/**
 * @name getBlockByNumber
 * @param {( BN | bigint | Uint8Array | number | string )} blockNumber
 * @description Get a specific block (e.g. rpc.chain.getBlock) and extend it with the author by block number
 * @example
 * ```javascript
 * const { author, block } = await api.derive.chain.getBlockByNumber(123);
 *
 * console.log(`block #${block.header.number} was authored by ${author}`);
 * ```
 */
function getBlockByNumber(instanceId, api) {
    return memo(instanceId, (blockNumber) => api.rpc.chain.getBlockHash(blockNumber).pipe(switchMap((h) => api.derive.chain.getBlock(h))));
}

/**
 * @name getHeader
 * @param {( Uint8Array | string )} hash - A block hash as U8 array or string.
 * @returns An array containing the block header and the block author
 * @description Get a specific block header and extend it with the author
 * @example
 * ```javascript
 * const { author, number } = await api.derive.chain.getHeader('0x123...456');
 *
 * console.log(`block #${number} was authored by ${author}`);
 * ```
 */
function getHeader(instanceId, api) {
    return memo(instanceId, (blockHash) => api.rpc.chain.getHeader(blockHash).pipe(switchMap((header) => getAuthorDetails(api, header, blockHash)), map(([header, validators, author]) => createHeaderExtended((validators || header).registry, header, validators, author))));
}

/**
 * @name subscribeFinalizedBlocks
 * @description Retrieves the finalized block & events for that block
 * @example
 * ```javascript
 * const unsub = await api.derive.chain.subscribeFinalizedBlocks((finalizedBlock) => {
 *  console.log(`# Finalized block ${finalizedBlock.block.hash}`);
 * });
 * ```
 */
function subscribeFinalizedBlocks(instanceId, api) {
    return memo(instanceId, () => api.derive.chain.subscribeFinalizedHeads().pipe(switchMap((header) => api.derive.chain.getBlock(header.createdAtHash || header.hash))));
}

/**
 * Returns a header range from startHash to to (not including) endHash, i.e. lastBlock.parentHash === endHash
 */
function _getHeaderRange(instanceId, api) {
    return memo(instanceId, (startHash, endHash, prev = []) => api.rpc.chain.getHeader(startHash).pipe(switchMap((header) => header.parentHash.eq(endHash)
        ? of([header, ...prev])
        : api.derive.chain._getHeaderRange(header.parentHash, endHash, [header, ...prev]))));
}
/**
 * @name subscribeFinalizedHeads
 * @description An observable of the finalized block headers. Unlike the base
 * chain.subscribeFinalizedHeads this does not skip any headers. Since finalization
 * may skip specific blocks (finalization happens in terms of chains), this version
 * of the derive tracks missing headers (since last retrieved) and provides them
 * to the caller.
 * @example
 * ```javascript
 * const unsub = await api.derive.chain.subscribeFinalizedHeads((finalizedHead) => {
 *   console.log(`${finalizedHead.hash}`);
 * });
 * ```
 */
function subscribeFinalizedHeads(instanceId, api) {
    return memo(instanceId, () => {
        let prevHash = null;
        return api.rpc.chain.subscribeFinalizedHeads().pipe(switchMap((header) => {
            const endHash = prevHash;
            const startHash = header.parentHash;
            prevHash = header.createdAtHash = header.hash;
            return endHash === null || startHash.eq(endHash)
                ? of(header)
                : api.derive.chain._getHeaderRange(startHash, endHash, [header]).pipe(switchMap((headers) => from(headers)));
        }));
    });
}

/**
 * @name subscribeNewBlocks
 * @returns The latest block & events for that block
 * @example
 * ```javascript
 * const unsub = await api.derive.chain.subscribeNewBlocks((newBlock) => {
 *   console.log(`Block Hash: ${newBlock.hash}`);
 * });
 * ```
 */
function subscribeNewBlocks(instanceId, api) {
    return memo(instanceId, () => api.derive.chain.subscribeNewHeads().pipe(switchMap((header) => api.derive.chain.getBlock(header.createdAtHash || header.hash))));
}

/**
 * @name subscribeNewHeads
 * @returns A header with the current header (including extracted author).
 * @description An observable of the current block header and it's author.
 * @example
 * ```javascript
 * api.derive.chain.subscribeNewHeads((header) => {
 *   console.log(`block #${header.number} was authored by ${header.author}`);
 * });
 * ```
 */
function subscribeNewHeads(instanceId, api) {
    return memo(instanceId, () => api.rpc.chain.subscribeNewHeads().pipe(switchMap((header) => getAuthorDetails(api, header)), map(([header, validators, author]) => {
        header.createdAtHash = header.hash;
        return createHeaderExtended(header.registry, header, validators, author);
    })));
}

var chain = /*#__PURE__*/Object.freeze({
	__proto__: null,
	_getHeaderRange: _getHeaderRange,
	bestNumber: bestNumber,
	bestNumberFinalized: bestNumberFinalized,
	bestNumberLag: bestNumberLag,
	getBlock: getBlock,
	getBlockByNumber: getBlockByNumber,
	getHeader: getHeader,
	subscribeFinalizedBlocks: subscribeFinalizedBlocks,
	subscribeFinalizedHeads: subscribeFinalizedHeads,
	subscribeNewBlocks: subscribeNewBlocks,
	subscribeNewHeads: subscribeNewHeads
});

function queryConstants(api) {
    return of([
        // deprecated
        api.consts.contracts['callBaseFee'] || api.registry.createType('Balance'),
        api.consts.contracts['contractFee'] || api.registry.createType('Balance'),
        api.consts.contracts['creationFee'] || api.registry.createType('Balance'),
        api.consts.contracts['transactionBaseFee'] || api.registry.createType('Balance'),
        api.consts.contracts['transactionByteFee'] || api.registry.createType('Balance'),
        api.consts.contracts['transferFee'] || api.registry.createType('Balance'),
        // current
        api.consts.contracts['rentByteFee'] || api.registry.createType('Balance'),
        api.consts.contracts['rentDepositOffset'] || api.registry.createType('Balance'),
        api.consts.contracts['surchargeReward'] || api.registry.createType('Balance'),
        api.consts.contracts['tombstoneDeposit'] || api.registry.createType('Balance')
    ]);
}
/**
 * @name fees
 * @returns An object containing the combined results of the queries for
 * all relevant contract fees as declared in the substrate chain spec.
 * @example
 * ```javascript
 * api.derive.contracts.fees(([creationFee, transferFee]) => {
 *   console.log(`The fee for creating a new contract on this chain is ${creationFee} units. The fee required to call this contract is ${transferFee} units.`);
 * });
 * ```
 */
function fees(instanceId, api) {
    return memo(instanceId, () => {
        return queryConstants(api).pipe(map(([callBaseFee, contractFee, creationFee, transactionBaseFee, transactionByteFee, transferFee, rentByteFee, rentDepositOffset, surchargeReward, tombstoneDeposit]) => ({
            callBaseFee,
            contractFee,
            creationFee,
            rentByteFee,
            rentDepositOffset,
            surchargeReward,
            tombstoneDeposit,
            transactionBaseFee,
            transactionByteFee,
            transferFee
        })));
    });
}

var contracts = /*#__PURE__*/Object.freeze({
	__proto__: null,
	fees: fees
});

function isVoter(value) {
    return !Array.isArray(value);
}
function retrieveStakeOf(elections) {
    return elections['stakeOf'].entries().pipe(map((entries) => entries.map(([{ args: [accountId] }, stake]) => [accountId, stake])));
}
function retrieveVoteOf(elections) {
    return elections['votesOf'].entries().pipe(map((entries) => entries.map(([{ args: [accountId] }, votes]) => [accountId, votes])));
}
function retrievePrev(api, elections) {
    return combineLatest([
        retrieveStakeOf(elections),
        retrieveVoteOf(elections)
    ]).pipe(map(([stakes, votes]) => {
        const result = [];
        votes.forEach(([voter, votes]) => {
            result.push([voter, { stake: api.registry.createType('Balance'), votes }]);
        });
        stakes.forEach(([staker, stake]) => {
            const entry = result.find(([voter]) => voter.eq(staker));
            if (entry) {
                entry[1].stake = stake;
            }
            else {
                result.push([staker, { stake, votes: [] }]);
            }
        });
        return result;
    }));
}
function retrieveCurrent(elections) {
    return elections.voting.entries().pipe(map((entries) => entries.map(([{ args: [accountId] }, value]) => [
        accountId,
        isVoter(value)
            ? { stake: value.stake, votes: value.votes }
            : { stake: value[0], votes: value[1] }
    ])));
}
/**
 * @name votes
 * @description Retrieves the council election votes for all participants.
 * @example
 * ```javascript
 * const votes = await api.derive.council.votes();
 * ```
 */
function votes(instanceId, api) {
    const elections = api.query.elections || api.query['phragmenElection'] || api.query['electionsPhragmen'];
    return memo(instanceId, () => elections
        ? elections['stakeOf']
            ? retrievePrev(api, elections)
            : retrieveCurrent(elections)
        : of([]));
}

/**
 * @name votesOf
 * @description Retrieves the council votes associated with a given account.
 * @returns The stake and the list of candidates the account has voted for.
 * @param {string | Uint8Array | AccountId} accountId The accountId to retrieve votes for.
 * @example
 * ```javascript
 * const accountId = "5Gw3s7qQ9Z..."; // Replace with a valid account ID
 * const votes = await api.derive.council.votesOf(accountId);
 * console.log("Account votes:", votes);
 * ```
 */
function votesOf(instanceId, api) {
    return memo(instanceId, (accountId) => api.derive.council.votes().pipe(map((votes) => (votes.find(([from]) => from.eq(accountId)) ||
        [null, { stake: api.registry.createType('Balance'), votes: [] }])[1])));
}

/**
 * @name members
 * @description Retrieves the list of members in the "council" collective.
 * @example
 * ```javascript
 * const members = await api.derive.council.members();
 * console.log(`Members: ${JSON.stringify(members)});
 * ```
 */
const members$3 = /*#__PURE__*/ members$5('council');
/**
 * @name hasProposals
 * @description Checks if there are any active proposals in the "council" collective.
 * @example
 * ```javascript
 * const exists = await api.derive.council.hasProposals();
 * console.log(exists);
 * ```
 */
const hasProposals$2 = /*#__PURE__*/ hasProposals$4('council');
/**
 * @name proposal
 * @description Retrieves details of a specific proposal in the "councilMotion" collective by its hash.
 * @example
 * ```javascript
 * const proposalDetails = await api.derive.council.proposal(PROPOSAL_HASH);
 * console.log(proposalDetails);
 * ```
 */
const proposal$2 = /*#__PURE__*/ proposal$4('council');
/**
 * @name proposalCount
 * @description Retrieves the total number of proposals in the "council" collective.
 * @example
 * ```javascript
 * const count = await api.derive.council.proposalCount();
 * console.log(`Amount of proposals: ${count}`);
 * ```
 */
const proposalCount$2 = /*#__PURE__*/ proposalCount$4('council');
/**
 * @name proposalHashes
 * @description Retrieves an array of hashes for all active proposals in the "council" collective.
 * @example
 * ```javascript
 * const hashes = await api.derive.council.proposalHashes();
 * console.log(`Proposals ${JSON.stringify(hashes)}`);
 * ```
 */
const proposalHashes$2 = /*#__PURE__*/ proposalHashes$4('council');
/**
 * @name proposals
 * @description Retrieves a list of all active proposals in the "council" collective.
 * @example
 * ```javascript
 * const proposals = await api.derive.council.proposals();
 * console.log(proposals);
 * ```
 */
const proposals$4 = /*#__PURE__*/ proposals$6('council');
/**
 * @name prime
 * @description Retrieves the prime member of the "council" collective, if one exists.
 * @example
 * ```javascript
 * const primeMember = await api.derive.council.prime();
 * console.log(primeMember);
 * ```
 */
const prime$2 = /*#__PURE__*/ prime$4('council');

var council = /*#__PURE__*/Object.freeze({
	__proto__: null,
	hasProposals: hasProposals$2,
	members: members$3,
	prime: prime$2,
	proposal: proposal$2,
	proposalCount: proposalCount$2,
	proposalHashes: proposalHashes$2,
	proposals: proposals$4,
	votes: votes,
	votesOf: votesOf
});

function createChildKey(info) {
    return u8aToHex(u8aConcat(':child_storage:default:', blake2AsU8a(u8aConcat('crowdloan', (info.fundIndex || info.trieIndex).toU8a()))));
}
/**
 * @name childKey
 * @description Retrieves the child storage key for a given parachain’s crowdloan contributions.
 * This key is used to access contribution data stored in a separate child trie of the blockchain’s state.
 * @param {string | number | BN} paraId The parachain ID for which contributions are being queried.
 * @example
 * ```javascript
 * const childKey = await api.derive.crowdloan.childKey(3369);
 * console.log("Child Key:", childKey);
 * ```
 */
function childKey(instanceId, api) {
    return memo(instanceId, (paraId) => api.query['crowdloan']['funds'](paraId).pipe(map((optInfo) => optInfo.isSome
        ? createChildKey(optInfo.unwrap())
        : null)));
}

function extractContributed(paraId, events) {
    const added = [];
    const removed = [];
    return events
        .filter(({ event: { data: [, eventParaId], method, section } }) => section === 'crowdloan' &&
        ['Contributed', 'Withdrew'].includes(method) &&
        eventParaId.eq(paraId))
        .reduce((result, { event: { data: [accountId], method } }) => {
        if (method === 'Contributed') {
            result.added.push(accountId.toHex());
        }
        else {
            result.removed.push(accountId.toHex());
        }
        return result;
    }, { added, blockHash: events.createdAtHash?.toHex() || '-', removed });
}

const PAGE_SIZE_K$1 = 1000; // limit aligned with the 1k on the node (trie lookups are heavy)
function _getUpdates(api, paraId) {
    let added = [];
    let removed = [];
    return api.query.system.events().pipe(switchMap((events) => {
        const changes = extractContributed(paraId, events);
        if (changes.added.length || changes.removed.length) {
            added = added.concat(...changes.added);
            removed = removed.concat(...changes.removed);
            return of({ added, addedDelta: changes.added, blockHash: events.createdAtHash?.toHex() || '-', removed, removedDelta: changes.removed });
        }
        return EMPTY;
    }), startWith({ added, addedDelta: [], blockHash: '-', removed, removedDelta: [] }));
}
function _eventTriggerAll(api, paraId) {
    return api.query.system.events().pipe(switchMap((events) => {
        const items = events.filter(({ event: { data: [eventParaId], method, section } }) => section === 'crowdloan' &&
            ['AllRefunded', 'Dissolved', 'PartiallyRefunded'].includes(method) &&
            eventParaId.eq(paraId));
        return items.length
            ? of(events.createdAtHash?.toHex() || '-')
            : EMPTY;
    }), startWith('-'));
}
function _getKeysPaged(api, childKey) {
    const subject = new BehaviorSubject(undefined);
    return subject.pipe(switchMap((startKey) => api.rpc.childstate.getKeysPaged(childKey, '0x', PAGE_SIZE_K$1, startKey)), tap((keys) => {
        nextTick(() => {
            keys.length === PAGE_SIZE_K$1
                ? subject.next(keys[PAGE_SIZE_K$1 - 1].toHex())
                : subject.complete();
        });
    }), toArray(), // toArray since we want to startSubject to be completed
    map((keyArr) => arrayFlatten(keyArr)));
}
function _getAll(api, paraId, childKey) {
    return _eventTriggerAll(api, paraId).pipe(switchMap(() => isFunction$1(api.rpc.childstate.getKeysPaged)
        ? _getKeysPaged(api, childKey)
        : api.rpc.childstate.getKeys(childKey, '0x')), map((keys) => keys.map((k) => k.toHex())));
}
function _contributions$1(api, paraId, childKey) {
    return combineLatest([
        _getAll(api, paraId, childKey),
        _getUpdates(api, paraId)
    ]).pipe(map(([keys, { added, blockHash, removed }]) => {
        const contributorsMap = {};
        keys.forEach((k) => {
            contributorsMap[k] = true;
        });
        added.forEach((k) => {
            contributorsMap[k] = true;
        });
        removed.forEach((k) => {
            delete contributorsMap[k];
        });
        return {
            blockHash,
            contributorsHex: Object.keys(contributorsMap)
        };
    }));
}
/**
 * @name contributions
 * @description Retrieves all contributions for a given parachain crowdloan.
 * @param {string | number | BN} paraId The parachain ID for which contributions are being queried.
 * @example
 * ```javascript
 * const contributions = await api.derive.crowdloan.contributions(3369);
 * console.log("Contributions:", contributions);
 * ```
 */
function contributions(instanceId, api) {
    return memo(instanceId, (paraId) => api.derive.crowdloan.childKey(paraId).pipe(switchMap((childKey) => childKey
        ? _contributions$1(api, paraId, childKey)
        : of({ blockHash: '-', contributorsHex: [] }))));
}

function _getValues(api, childKey, keys) {
    // We actually would love to use multi-keys https://github.com/paritytech/substrate/issues/9203
    return combineLatest(keys.map((k) => api.rpc.childstate.getStorage(childKey, k))).pipe(map((values) => values
        .map((v) => api.registry.createType('Option<StorageData>', v))
        .map((o) => o.isSome
        ? api.registry.createType('Balance', o.unwrap())
        : api.registry.createType('Balance'))
        .reduce((all, b, index) => objectSpread(all, { [keys[index]]: b }), {})));
}
function _watchOwnChanges(api, paraId, childkey, keys) {
    return api.query.system.events().pipe(switchMap((events) => {
        const changes = extractContributed(paraId, events);
        const filtered = keys.filter((k) => changes.added.includes(k) ||
            changes.removed.includes(k));
        return filtered.length
            ? _getValues(api, childkey, filtered)
            : EMPTY;
    }), startWith({}));
}
function _contributions(api, paraId, childKey, keys) {
    return combineLatest([
        _getValues(api, childKey, keys),
        _watchOwnChanges(api, paraId, childKey, keys)
    ]).pipe(map(([all, latest]) => objectSpread({}, all, latest)));
}
/**
 * @name ownContributions
 * @description Retrieves the contribution amounts made by specific accounts (`keys`) to a given parachain crowdloan (`paraId`).
 * @param {string | number | BN} paraId The parachain ID for which contributions are being queried.
 * @param {string[]} keys An array of account addresses whose contributions are to be fetched.
 * @example
 * ```javascript
 * const contributions = await api.derive.crowdloan.ownContributions(2000, ['5Ff...PqV', '5Gg...XyZ']);
 * console.log("Own Contributions:", contributions);
 * ```
 */
function ownContributions(instanceId, api) {
    return memo(instanceId, (paraId, keys) => api.derive.crowdloan.childKey(paraId).pipe(switchMap((childKey) => childKey && keys.length
        ? _contributions(api, paraId, childKey, keys)
        : of({}))));
}

var crowdloan = /*#__PURE__*/Object.freeze({
	__proto__: null,
	childKey: childKey,
	contributions: contributions,
	ownContributions: ownContributions
});

function isOldInfo(info) {
    return !!info.proposalHash;
}
function isCurrentStatus(status) {
    return !!status.tally;
}
function compareRationals(n1, d1, n2, d2) {
    while (true) {
        const q1 = n1.div(d1);
        const q2 = n2.div(d2);
        if (q1.lt(q2)) {
            return true;
        }
        else if (q2.lt(q1)) {
            return false;
        }
        const r1 = n1.mod(d1);
        const r2 = n2.mod(d2);
        if (r2.isZero()) {
            return false;
        }
        else if (r1.isZero()) {
            return true;
        }
        n1 = d2;
        n2 = d1;
        d1 = r2;
        d2 = r1;
    }
}
function calcPassingOther(threshold, sqrtElectorate, { votedAye, votedNay, votedTotal }) {
    const sqrtVoters = bnSqrt(votedTotal);
    return sqrtVoters.isZero()
        ? false
        : threshold.isSuperMajorityApprove
            ? compareRationals(votedNay, sqrtVoters, votedAye, sqrtElectorate)
            : compareRationals(votedNay, sqrtElectorate, votedAye, sqrtVoters);
}
function calcPassing(threshold, sqrtElectorate, state) {
    return threshold.isSimpleMajority
        ? state.votedAye.gt(state.votedNay)
        : calcPassingOther(threshold, sqrtElectorate, state);
}
function calcVotesPrev(votesFor) {
    return votesFor.reduce((state, derived) => {
        const { balance, vote } = derived;
        const isDefault = vote.conviction.index === 0;
        const counted = balance
            .muln(isDefault ? 1 : vote.conviction.index)
            .divn(isDefault ? 10 : 1);
        if (vote.isAye) {
            state.allAye.push(derived);
            state.voteCountAye++;
            state.votedAye.iadd(counted);
        }
        else {
            state.allNay.push(derived);
            state.voteCountNay++;
            state.votedNay.iadd(counted);
        }
        state.voteCount++;
        state.votedTotal.iadd(counted);
        return state;
    }, { allAye: [], allNay: [], voteCount: 0, voteCountAye: 0, voteCountNay: 0, votedAye: new BN(0), votedNay: new BN(0), votedTotal: new BN(0) });
}
function calcVotesCurrent(tally, votes) {
    const allAye = [];
    const allNay = [];
    votes.forEach((derived) => {
        if (derived.vote.isAye) {
            allAye.push(derived);
        }
        else {
            allNay.push(derived);
        }
    });
    return {
        allAye,
        allNay,
        voteCount: allAye.length + allNay.length,
        voteCountAye: allAye.length,
        voteCountNay: allNay.length,
        votedAye: tally.ayes,
        votedNay: tally.nays,
        votedTotal: tally.turnout
    };
}
function calcVotes(sqrtElectorate, referendum, votes) {
    const state = isCurrentStatus(referendum.status)
        ? calcVotesCurrent(referendum.status.tally, votes)
        : calcVotesPrev(votes);
    return objectSpread({}, state, {
        isPassing: calcPassing(referendum.status.threshold, sqrtElectorate, state),
        votes
    });
}
function getStatus(info) {
    if (info.isNone) {
        return null;
    }
    const unwrapped = info.unwrap();
    return isOldInfo(unwrapped)
        ? unwrapped
        : unwrapped.isOngoing
            ? unwrapped.asOngoing
            // done, we don't include it here... only currently active
            : null;
}
function getImageHashBounded(hash) {
    return hash.isLegacy
        ? hash.asLegacy.hash_.toHex()
        : hash.isLookup
            ? hash.asLookup.hash_.toHex()
            // for inline, use the actual Bytes hash
            : hash.isInline
                ? hash.asInline.hash.toHex()
                : isString(hash)
                    ? isHex(hash)
                        ? hash
                        : stringToHex(hash)
                    : isU8a(hash)
                        ? u8aToHex(hash)
                        : hash.toHex();
}
function getImageHash(status) {
    return getImageHashBounded(status.proposal ||
        status.proposalHash);
}

const DEMOCRACY_ID = stringToHex('democrac');
function isMaybeHashedOrBounded(call) {
    // check for enum
    return call instanceof Enum;
}
function isBounded(call) {
    // check for type
    return call.isInline || call.isLegacy || call.isLookup;
}
function queryQueue(api) {
    return api.query.democracy['dispatchQueue']().pipe(switchMap((dispatches) => combineLatest([
        of(dispatches),
        api.derive.democracy.preimages(dispatches.map(([, hash]) => hash))
    ])), map(([dispatches, images]) => dispatches.map(([at, imageHash, index], dispatchIndex) => ({
        at,
        image: images[dispatchIndex],
        imageHash: getImageHashBounded(imageHash),
        index
    }))));
}
function schedulerEntries(api) {
    // We don't get entries, but rather we get the keys (triggered via finished referendums) and
    // the subscribe to those keys - this means we pickup when the schedulers actually executes
    // at a block, the entry for that block will become empty
    return api.derive.democracy.referendumsFinished().pipe(switchMap(() => api.query.scheduler.agenda.keys()), switchMap((keys) => {
        const blockNumbers = keys.map(({ args: [blockNumber] }) => blockNumber);
        return blockNumbers.length
            ? combineLatest([
                of(blockNumbers),
                // this should simply be api.query.scheduler.agenda.multi,
                // however we have had cases on Darwinia where the indices have moved around after an
                // upgrade, which results in invalid on-chain data
                api.query.scheduler.agenda.multi(blockNumbers).pipe(catchError(() => of(blockNumbers.map(() => []))))
            ])
            : of([[], []]);
    }));
}
function queryScheduler(api) {
    return schedulerEntries(api).pipe(switchMap(([blockNumbers, agendas]) => {
        const result = [];
        blockNumbers.forEach((at, index) => {
            (agendas[index] || []).filter((o) => o.isSome).forEach((o) => {
                const scheduled = o.unwrap();
                if (scheduled.maybeId.isSome) {
                    const id = scheduled.maybeId.unwrap().toHex();
                    if (id.startsWith(DEMOCRACY_ID)) {
                        const imageHash = isMaybeHashedOrBounded(scheduled.call)
                            ? isBounded(scheduled.call)
                                ? getImageHashBounded(scheduled.call)
                                : scheduled.call.isHash
                                    ? scheduled.call.asHash.toHex()
                                    : scheduled.call.asValue.args[0].toHex()
                            : scheduled.call.args[0].toHex();
                        result.push({ at, imageHash, index: api.registry.createType('(u64, ReferendumIndex)', id)[1] });
                    }
                }
            });
        });
        return combineLatest([
            of(result),
            result.length
                ? api.derive.democracy.preimages(result.map(({ imageHash }) => imageHash))
                : of([])
        ]);
    }), map(([infos, images]) => infos.map((info, index) => objectSpread({ image: images[index] }, info))));
}
/**
 * @name dispatchQueue
 * @description Retrieves the list of scheduled or pending dispatches in the governance system.
 * @example
 * ```javascript
 * const queue = await api.derive.democracy.dispatchQueue();
 * console.log("Dispatch Queue:", queue);
 * ```
 */
function dispatchQueue(instanceId, api) {
    return memo(instanceId, () => isFunction$1(api.query.scheduler?.agenda)
        ? queryScheduler(api)
        : api.query.democracy['dispatchQueue']
            ? queryQueue(api)
            : of([]));
}

const LOCKUPS = [0, 1, 2, 4, 8, 16, 32];
function parseEnd(api, vote, { approved, end }) {
    return [
        end,
        (approved.isTrue && vote.isAye) || (approved.isFalse && vote.isNay)
            ? end.add((api.consts.democracy.voteLockingPeriod ||
                api.consts.democracy.enactmentPeriod).muln(LOCKUPS[vote.conviction.index]))
            : BN_ZERO
    ];
}
function parseLock(api, [referendumId, accountVote], referendum) {
    const { balance, vote } = accountVote.asStandard;
    const [referendumEnd, unlockAt] = referendum.isFinished
        ? parseEnd(api, vote, referendum.asFinished)
        : [BN_ZERO, BN_ZERO];
    return { balance, isDelegated: false, isFinished: referendum.isFinished, referendumEnd, referendumId, unlockAt, vote };
}
function delegateLocks(api, { balance, conviction, target }) {
    return api.derive.democracy.locks(target).pipe(map((available) => available.map(({ isFinished, referendumEnd, referendumId, unlockAt, vote }) => ({
        balance,
        isDelegated: true,
        isFinished,
        referendumEnd,
        referendumId,
        unlockAt: unlockAt.isZero()
            ? unlockAt
            : referendumEnd.add((api.consts.democracy.voteLockingPeriod ||
                api.consts.democracy.enactmentPeriod).muln(LOCKUPS[conviction.index])),
        vote: api.registry.createType('Vote', { aye: vote.isAye, conviction })
    }))));
}
function directLocks(api, { votes }) {
    if (!votes.length) {
        return of([]);
    }
    return api.query.democracy.referendumInfoOf.multi(votes.map(([referendumId]) => referendumId)).pipe(map((referendums) => votes
        .map((vote, index) => [vote, referendums[index].unwrapOr(null)])
        .filter((item) => !!item[1] && isUndefined(item[1].end) && item[0][1].isStandard)
        .map(([directVote, referendum]) => parseLock(api, directVote, referendum))));
}
/**
 * @name locks
 * @description Retrieves the democracy voting locks for a given account.
 * @param { string | AccountId } accountId The accountId for which to retrieve democracy voting locks.
 * @example
 * ```javascript
 * const locks = await api.derive.democracy.locks('5FfFjX...'); // Replace with an actual accountId
 * console.log("Democracy Locks:", locks);
 * ```
 */
function locks(instanceId, api) {
    return memo(instanceId, (accountId) => api.query.democracy.votingOf
        ? api.query.democracy.votingOf(accountId).pipe(switchMap((voting) => voting.isDirect
            ? directLocks(api, voting.asDirect)
            : voting.isDelegating
                ? delegateLocks(api, voting.asDelegating)
                : of([])))
        : of([]));
}

function withImage(api, nextOpt) {
    if (nextOpt.isNone) {
        return of(null);
    }
    const [hash, threshold] = nextOpt.unwrap();
    return api.derive.democracy.preimage(hash).pipe(map((image) => ({
        image,
        imageHash: getImageHashBounded(hash),
        threshold
    })));
}
/**
 * @name nextExternal
 * @description Retrieves the next external proposal that is scheduled for a referendum.
 * @example
 * ```javascript
 * const nextExternal = await api.derive.democracy.nextExternal();
 * console.log("Next external proposal:", nextExternal);
 * ```
 */
function nextExternal(instanceId, api) {
    return memo(instanceId, () => api.query.democracy?.nextExternal
        ? api.query.democracy.nextExternal().pipe(switchMap((nextOpt) => withImage(api, nextOpt)))
        : of(null));
}

function getUnrequestedTicket(status) {
    return status.ticket || status.deposit;
}
function getRequestedTicket(status) {
    return (status.maybeTicket || status.deposit).unwrapOrDefault();
}
function isDemocracyPreimage(api, imageOpt) {
    return !!imageOpt && !api.query.democracy['dispatchQueue'];
}
function constructProposal(api, [bytes, proposer, balance, at]) {
    let proposal;
    try {
        proposal = api.registry.createType('Call', bytes.toU8a(true));
    }
    catch (error) {
        console.error(error);
    }
    return { at, balance, proposal, proposer };
}
function parseDemocracy(api, imageOpt) {
    if (imageOpt.isNone) {
        return;
    }
    if (isDemocracyPreimage(api, imageOpt)) {
        const status = imageOpt.unwrap();
        if (status.isMissing) {
            return;
        }
        const { data, deposit, provider, since } = status.asAvailable;
        return constructProposal(api, [data, provider, deposit, since]);
    }
    return constructProposal(api, imageOpt.unwrap());
}
function parseImage(api, [proposalHash, status, bytes]) {
    if (!status) {
        return undefined;
    }
    const [proposer, balance] = status.isUnrequested
        ? getUnrequestedTicket(status.asUnrequested)
        : getRequestedTicket(status.asRequested);
    let proposal;
    if (bytes) {
        try {
            proposal = api.registry.createType('Call', bytes.toU8a(true));
        }
        catch (error) {
            console.error(error);
        }
    }
    return { at: BN_ZERO, balance, proposal, proposalHash, proposer };
}
function getDemocracyImages(api, bounded) {
    const hashes = bounded.map((b) => getImageHashBounded(b));
    return api.query.democracy['preimages'].multi(hashes).pipe(map((images) => images.map((imageOpt) => parseDemocracy(api, imageOpt))));
}
function getImages(api, bounded) {
    const hashes = bounded.map((b) => getImageHashBounded(b));
    const bytesType = api.registry.lookup.getTypeDef(api.query.preimage.preimageFor.creator.meta.type.asMap.key).type;
    return api.query.preimage.statusFor.multi(hashes).pipe(switchMap((optStatus) => {
        const statuses = optStatus.map((o) => o.unwrapOr(null));
        const keys = statuses
            .map((s, i) => s
            ? bytesType === 'H256'
                // first generation
                ? hashes[i]
                // current generation (H256,u32)
                : s.isRequested
                    ? [hashes[i], s.asRequested.len.unwrapOr(0)]
                    : [hashes[i], s.asUnrequested.len]
            : null)
            .filter((p) => !!p);
        return api.query.preimage.preimageFor.multi(keys).pipe(map((optBytes) => {
            let ptr = -1;
            return statuses
                .map((s, i) => s
                ? [hashes[i], s, optBytes[++ptr].unwrapOr(null)]
                : [hashes[i], null, null])
                .map((v) => parseImage(api, v));
        }));
    }));
}
/**
 * @name preimages
 * @description Retrieves the full details (preimages) of governance proposals using their on-chain hashes.
 * @param { (Hash | Uint8Array | string | FrameSupportPreimagesBounded)[] } hashes An array of hashes representing governance proposals.
 * @example
 * ```javascript
 * const preimages = await api.derive.democracy.preimages([HASH1, HASH2]);
 * ```
 */
function preimages(instanceId, api) {
    return memo(instanceId, (hashes) => hashes.length
        ? isFunction$1(api.query.democracy['preimages'])
            ? getDemocracyImages(api, hashes)
            : isFunction$1(api.query.preimage.preimageFor)
                ? getImages(api, hashes)
                : of([])
        : of([]));
}
/**
 * @name preimage
 * @description Retrieves the full details (preimage) of a governance proposal using its on-chain hash.
 * @param { Hash | Uint8Array | string | FrameSupportPreimagesBounded } hash Hash that represents governance proposals.
 *  * @example
 * ```javascript
 * const preimage = await api.derive.democracy.preimage(HASH);
 * ```
 */
const preimage = /*#__PURE__*/ firstMemo((api, hash) => api.derive.democracy.preimages([hash]));

function isNewDepositors(depositors) {
    // Detect balance...
    return isFunction$1(depositors[1].mul);
}
function parse$3([proposals, images, optDepositors]) {
    return proposals
        .filter(([, , proposer], index) => !!(optDepositors[index]?.isSome) && !proposer.isEmpty)
        .map(([index, hash, proposer], proposalIndex) => {
        const depositors = optDepositors[proposalIndex].unwrap();
        return objectSpread({
            image: images[proposalIndex],
            imageHash: getImageHashBounded(hash),
            index,
            proposer
        }, isNewDepositors(depositors)
            ? { balance: depositors[1], seconds: depositors[0] }
            : { balance: depositors[0], seconds: depositors[1] });
    });
}
/**
 * @name proposals
 * @description Retrieves the list of active public proposals in the democracy module, along with their associated preimage data and deposit information.
 * @example
 * ```javascript
 * const proposals = await api.derive.democracy.proposals();
 * console.log("proposals:", proposals);
 * ```
 */
function proposals$3(instanceId, api) {
    return memo(instanceId, () => isFunction$1(api.query.democracy?.publicProps)
        ? api.query.democracy.publicProps().pipe(switchMap((proposals) => proposals.length
            ? combineLatest([
                of(proposals),
                api.derive.democracy.preimages(proposals.map(([, hash]) => hash)),
                api.query.democracy.depositOf.multi(proposals.map(([index]) => index))
            ])
            : of([[], [], []])), map(parse$3))
        : of([]));
}

/**
 * @name referendumIds
 * @description Retrieves an array of active referendum IDs.
 * @example
 * ```javascript
 * const referendums = await api.derive.democracy.referendumIds();
 * ```
 */
function referendumIds(instanceId, api) {
    return memo(instanceId, () => api.query.democracy?.lowestUnbaked
        ? api.queryMulti([
            api.query.democracy.lowestUnbaked,
            api.query.democracy.referendumCount
        ]).pipe(map(([first, total]) => total.gt(first)
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            ? [...Array(total.sub(first).toNumber())].map((_, i) => first.addn(i))
            : []))
        : of([]));
}

/**
 * @name referendums
 * @description Retrieves information about all active referendums, including their details and associated votes.
 * @example
 * ```javascript
 * const referendums = await api.derive.democracy.referendums();
 * ```
 */
function referendums(instanceId, api) {
    return memo(instanceId, () => api.derive.democracy.referendumsActive().pipe(switchMap((referendums) => referendums.length
        ? combineLatest([
            of(referendums),
            api.derive.democracy._referendumsVotes(referendums)
        ])
        : of([[], []])), map(([referendums, votes]) => referendums.map((referendum, index) => objectSpread({}, referendum, votes[index])))));
}

/**
 * @name referendumsActive
 * @description Retrieves information about active referendums.
 * @example
 * ```javascript
 * const referendums = await api.derive.democracy.referendumsActive();
 * console.log("Active Referendums:", referendums);
 * ```
 */
function referendumsActive(instanceId, api) {
    return memo(instanceId, () => api.derive.democracy.referendumIds().pipe(switchMap((ids) => ids.length
        ? api.derive.democracy.referendumsInfo(ids)
        : of([]))));
}

/**
 * @name referendumsFinished
 * @description Retrieves information about finished referendums.
 * @example
 * ```javascript
 * const referendums = await api.derive.democracy.referendumsFinished();
 * console.log("Finished Referendums:", referendums);
 * ```
 */
function referendumsFinished(instanceId, api) {
    return memo(instanceId, () => api.derive.democracy.referendumIds().pipe(switchMap((ids) => api.query.democracy.referendumInfoOf.multi(ids)), map((infos) => infos
        .map((o) => o.unwrapOr(null))
        .filter((info) => !!info && info.isFinished)
        .map((info) => info.asFinished))));
}

function votesPrev(api, referendumId) {
    return api.query.democracy['votersFor'](referendumId).pipe(switchMap((votersFor) => combineLatest([
        of(votersFor),
        votersFor.length
            ? api.query.democracy['voteOf'].multi(votersFor.map((accountId) => [referendumId, accountId]))
            : of([]),
        api.derive.balances.votingBalances(votersFor)
    ])), map(([votersFor, votes, balances]) => votersFor.map((accountId, index) => ({
        accountId,
        balance: balances[index].votingBalance || api.registry.createType('Balance'),
        isDelegating: false,
        vote: votes[index] || api.registry.createType('Vote')
    }))));
}
function extractVotes(mapped, referendumId) {
    return mapped
        .filter(([, voting]) => voting.isDirect)
        .map(([accountId, voting]) => [
        accountId,
        voting.asDirect.votes.filter(([idx]) => idx.eq(referendumId))
    ])
        .filter(([, directVotes]) => !!directVotes.length)
        .reduce((result, [accountId, votes]) => 
    // FIXME We are ignoring split votes
    votes.reduce((result, [, vote]) => {
        if (vote.isStandard) {
            result.push(objectSpread({
                accountId,
                isDelegating: false
            }, vote.asStandard));
        }
        return result;
    }, result), []);
}
function votesCurr(api, referendumId) {
    return api.query.democracy.votingOf.entries().pipe(map((allVoting) => {
        const mapped = allVoting.map(([{ args: [accountId] }, voting]) => [accountId, voting]);
        const votes = extractVotes(mapped, referendumId);
        const delegations = mapped
            .filter(([, voting]) => voting.isDelegating)
            .map(([accountId, voting]) => [accountId, voting.asDelegating]);
        // add delegations
        delegations.forEach(([accountId, { balance, conviction, target }]) => {
            // Are we delegating to a delegator
            const toDelegator = delegations.find(([accountId]) => accountId.eq(target));
            const to = votes.find(({ accountId }) => accountId.eq(toDelegator ? toDelegator[0] : target));
            // this delegation has a target
            if (to) {
                votes.push({
                    accountId,
                    balance,
                    isDelegating: true,
                    vote: api.registry.createType('Vote', { aye: to.vote.isAye, conviction })
                });
            }
        });
        return votes;
    }));
}
function _referendumVotes(instanceId, api) {
    return memo(instanceId, (referendum) => combineLatest([
        api.derive.democracy.sqrtElectorate(),
        isFunction$1(api.query.democracy.votingOf)
            ? votesCurr(api, referendum.index)
            : votesPrev(api, referendum.index)
    ]).pipe(map(([sqrtElectorate, votes]) => calcVotes(sqrtElectorate, referendum, votes))));
}
function _referendumsVotes(instanceId, api) {
    return memo(instanceId, (referendums) => referendums.length
        ? combineLatest(referendums.map((referendum) => api.derive.democracy._referendumVotes(referendum)))
        : of([]));
}
function _referendumInfo(instanceId, api) {
    return memo(instanceId, (index, info) => {
        const status = getStatus(info);
        return status
            ? api.derive.democracy.preimage(status.proposal ||
                status.proposalHash).pipe(map((image) => ({
                image,
                imageHash: getImageHash(status),
                index: api.registry.createType('ReferendumIndex', index),
                status
            })))
            : of(null);
    });
}
/**
 * @name referendumsInfo
 * @description Retrieves information about multiple referendums by their IDs.
 * @param {BN[]} ids An array of referendum IDs to query.
 * @example
 * ```javascript
 * import { BN } from "@polkadot/util";
 *
 * const referendumIds = [new BN(1)];
 * const referendums = await api.derive.democracy.referendumsInfo(referendumIds);
 * console.log("Referendums Info:", referendums);
 * ```
 */
function referendumsInfo(instanceId, api) {
    return memo(instanceId, (ids) => ids.length
        ? api.query.democracy.referendumInfoOf.multi(ids).pipe(switchMap((infos) => combineLatest(ids.map((id, index) => api.derive.democracy._referendumInfo(id, infos[index])))), map((infos) => infos.filter((r) => !!r)))
        : of([]));
}

/**
 * @name sqrtElectorate
 * @description Computes the square root of the total token issuance in the network.
 * @example
 * ```javascript
 * let sqrtElectorate = await api.derive.democracy.sqrtElectorate();
 * console.log("Square root of token issuance:", sqrtElectorate);
 * ```
 */
function sqrtElectorate(instanceId, api) {
    return memo(instanceId, () => api.query.balances.totalIssuance().pipe(map(bnSqrt)));
}

var democracy = /*#__PURE__*/Object.freeze({
	__proto__: null,
	_referendumInfo: _referendumInfo,
	_referendumVotes: _referendumVotes,
	_referendumsVotes: _referendumsVotes,
	dispatchQueue: dispatchQueue,
	locks: locks,
	nextExternal: nextExternal,
	preimage: preimage,
	preimages: preimages,
	proposals: proposals$3,
	referendumIds: referendumIds,
	referendums: referendums,
	referendumsActive: referendumsActive,
	referendumsFinished: referendumsFinished,
	referendumsInfo: referendumsInfo,
	sqrtElectorate: sqrtElectorate
});

function isSeatHolder(value) {
    return !Array.isArray(value);
}
function isCandidateTuple(value) {
    return Array.isArray(value);
}
function getAccountTuple(value) {
    return isSeatHolder(value)
        ? [value.who, value.stake]
        : value;
}
function getCandidate(value) {
    return isCandidateTuple(value)
        ? value[0]
        : value;
}
function sortAccounts([, balanceA], [, balanceB]) {
    return balanceB.cmp(balanceA);
}
function getConstants(api, elections) {
    return elections
        ? {
            candidacyBond: api.consts[elections].candidacyBond,
            desiredRunnersUp: api.consts[elections].desiredRunnersUp,
            desiredSeats: api.consts[elections].desiredMembers,
            termDuration: api.consts[elections].termDuration,
            votingBond: api.consts[elections]['votingBond'],
            votingBondBase: api.consts[elections].votingBondBase,
            votingBondFactor: api.consts[elections].votingBondFactor
        }
        : {};
}
function getModules(api) {
    const [council] = api.registry.getModuleInstances(api.runtimeVersion.specName, 'council') || ['council'];
    const elections = api.query['phragmenElection']
        ? 'phragmenElection'
        : api.query['electionsPhragmen']
            ? 'electionsPhragmen'
            : api.query.elections
                ? 'elections'
                : null;
    // In some cases council here can refer to `generalCouncil` depending on what the chain specific override is.
    // Therefore, we check to see if it exists in the query field. If it does not we default to `council`.
    const resolvedCouncil = api.query[council] ? council : 'council';
    return [resolvedCouncil, elections];
}
function queryAll(api, council, elections) {
    return api.queryMulti([
        api.query[council].members,
        api.query[elections].candidates,
        api.query[elections].members,
        api.query[elections].runnersUp
    ]);
}
function queryCouncil(api, council) {
    return combineLatest([
        api.query[council].members(),
        of([]),
        of([]),
        of([])
    ]);
}
/**
 * @name info
 * @description An object containing the combined results of the storage queries for all relevant election module properties.
 * @example
 * ```javascript
 * api.derive.elections.info(({ members, candidates }) => {
 *   console.log(`There are currently ${members.length} council members and ${candidates.length} prospective council candidates.`);
 * });
 * ```
 */
function info$3(instanceId, api) {
    return memo(instanceId, () => {
        const [council, elections] = getModules(api);
        return (elections
            ? queryAll(api, council, elections)
            : queryCouncil(api, council)).pipe(map(([councilMembers, candidates, members, runnersUp]) => objectSpread({}, getConstants(api, elections), {
            candidateCount: api.registry.createType('u32', candidates.length),
            candidates: candidates.map(getCandidate),
            members: members.length
                ? members.map(getAccountTuple).sort(sortAccounts)
                : councilMembers.map((a) => [a, api.registry.createType('Balance')]),
            runnersUp: runnersUp.map(getAccountTuple).sort(sortAccounts)
        })));
    });
}

var elections = /*#__PURE__*/Object.freeze({
	__proto__: null,
	info: info$3
});

function mapResult([result, validators, heartbeats, numBlocks]) {
    validators.forEach((validator, index) => {
        const validatorId = validator.toString();
        const blockCount = numBlocks[index];
        const hasMessage = !heartbeats[index].isEmpty;
        const prev = result[validatorId];
        if (!prev || prev.hasMessage !== hasMessage || !prev.blockCount.eq(blockCount)) {
            result[validatorId] = {
                blockCount,
                hasMessage,
                isOnline: hasMessage || blockCount.gt(BN_ZERO)
            };
        }
    });
    return result;
}
/**
 * @name receivedHeartbeats
 * @description Return a boolean array indicating whether the passed accounts had received heartbeats in the current session.
 * @example
 * ```javascript
 * let unsub = await api.derive.imOnline.receivedHeartbeats((heartbeat) => {
 *   console.log(heartbeat);
 * });
 * ```
 */
function receivedHeartbeats(instanceId, api) {
    return memo(instanceId, () => api.query.imOnline?.receivedHeartbeats
        ? api.derive.staking.overview().pipe(switchMap(({ currentIndex, validators }) => combineLatest([
            of({}),
            of(validators),
            api.query.imOnline.receivedHeartbeats.multi(validators.map((_address, index) => [currentIndex, index])),
            api.query.imOnline.authoredBlocks.multi(validators.map((address) => [currentIndex, address]))
        ])), map(mapResult))
        : of({}));
}

var imOnline = /*#__PURE__*/Object.freeze({
	__proto__: null,
	receivedHeartbeats: receivedHeartbeats
});

/**
 * @name members
 * @description Retrieves the list of members in the "membership" collective.
 * @example
 * ```javascript
 * const members = await api.derive.membership.members();
 * console.log(`Members: ${JSON.stringify(members)});
 * ```
 */
const members$2 = /*#__PURE__*/ members$5('membership');
/**
 * @name hasProposals
 * @description Checks if there are any active proposals in the "membership" collective.
 * @example
 * ```javascript
 * const exists = await api.derive.membership.hasProposals();
 * console.log(exists);
 * ```
 */
const hasProposals$1 = /*#__PURE__*/ hasProposals$4('membership');
/**
 * @name proposal
 * @description Retrieves details of a specific proposal in the "membership" collective by its hash.
 * @example
 * ```javascript
 * const proposalDetails = await api.derive.membership.proposal(PROPOSAL_HASH);
 * console.log(proposalDetails);
 * ```
 */
const proposal$1 = /*#__PURE__*/ proposal$4('membership');
/**
 * @name proposalCount
 * @description Retrieves the total number of proposals in the "membership" collective.
 * @example
 * ```javascript
 * const count = await api.derive.membership.proposalCount();
 * console.log(`Amount of proposals: ${count}`);
 * ```
 */
const proposalCount$1 = /*#__PURE__*/ proposalCount$4('membership');
/**
 * @name proposalHashes
 * @description Retrieves an array of hashes for all active proposals in the "membership" collective.
 * @example
 * ```javascript
 * const hashes = await api.derive.membership.proposalHashes();
 * console.log(`Proposals ${JSON.stringify(hashes)}`);
 * ```
 */
const proposalHashes$1 = /*#__PURE__*/ proposalHashes$4('membership');
/**
 * @name proposals
 * @description Retrieves a list of all active proposals in the "membership" collective.
 * @example
 * ```javascript
 * const proposals = await api.derive.membership.proposals();
 * console.log(proposals);
 * ```
 */
const proposals$2 = /*#__PURE__*/ proposals$6('membership');
/**
 * @name prime
 * @description Retrieves the prime member of the "membership" collective, if one exists.
 * @example
 * ```javascript
 * const primeMember = await api.derive.membership.prime();
 * console.log(primeMember);
 * ```
 */
const prime$1 = /*#__PURE__*/ prime$4('membership');

var membership = /*#__PURE__*/Object.freeze({
	__proto__: null,
	hasProposals: hasProposals$1,
	members: members$2,
	prime: prime$1,
	proposal: proposal$1,
	proposalCount: proposalCount$1,
	proposalHashes: proposalHashes$1,
	proposals: proposals$2
});

function didUpdateToBool(didUpdate, id) {
    return didUpdate.isSome
        ? didUpdate.unwrap().some((paraId) => paraId.eq(id))
        : false;
}

function parseActive(id, active) {
    const found = active.find(([paraId]) => paraId === id);
    if (found && found[1].isSome) {
        const [collatorId, retriable] = found[1].unwrap();
        return objectSpread({ collatorId }, retriable.isWithRetries
            ? {
                isRetriable: true,
                retries: retriable.asWithRetries.toNumber()
            }
            : {
                isRetriable: false,
                retries: 0
            });
    }
    return null;
}
function parseCollators(id, collatorQueue) {
    return collatorQueue.map((queue) => {
        const found = queue.find(([paraId]) => paraId === id);
        return found ? found[1] : null;
    });
}
function parse$2(id, [active, retryQueue, selectedThreads, didUpdate, info, pendingSwap, heads, relayDispatchQueue]) {
    if (info.isNone) {
        return null;
    }
    return {
        active: parseActive(id, active),
        didUpdate: didUpdateToBool(didUpdate, id),
        heads,
        id,
        info: objectSpread({ id }, info.unwrap()),
        pendingSwapId: pendingSwap.unwrapOr(null),
        relayDispatchQueue,
        retryCollators: parseCollators(id, retryQueue),
        selectedCollators: parseCollators(id, selectedThreads)
    };
}
/**
 * @name info
 * @param {ParaId | number} id A unique numeric (non-negative integer) identifier for a parachain.
 * @description Retrieves detailed information about a specific parachain.
 * @example
 * ```javascript
 * await api.derive.parachains.info(1000, (info) => {
 *   if (info) {
 *     console.log(`Parachain ${info.id.toString()} is active: ${info.active}`);
 *   } else {
 *     console.log("Parachain information not available.");
 *   }
 * });
 * ```
*/
function info$2(instanceId, api) {
    return memo(instanceId, (id) => api.query['registrar'] && api.query['parachains']
        ? api.queryMulti([
            api.query['registrar']['active'],
            api.query['registrar']['retryQueue'],
            api.query['registrar']['selectedThreads'],
            api.query['parachains']['didUpdate'],
            [api.query['registrar']['paras'], id],
            [api.query['registrar']['pendingSwap'], id],
            [api.query['parachains']['heads'], id],
            [api.query['parachains']['relayDispatchQueue'], id]
        ])
            .pipe(map((result) => parse$2(api.registry.createType('ParaId', id), result)))
        : of(null));
}

function parse$1([ids, didUpdate, relayDispatchQueueSizes, infos, pendingSwaps]) {
    return ids.map((id, index) => ({
        didUpdate: didUpdateToBool(didUpdate, id),
        id,
        info: objectSpread({ id }, infos[index].unwrapOr(null)),
        pendingSwapId: pendingSwaps[index].unwrapOr(null),
        relayDispatchQueueSize: relayDispatchQueueSizes[index][0].toNumber()
    }));
}
/**
 * @name overview
 * @description Retrieves an overview of all registered parachains.
 * @example
 * ```javascript
 * await api.derive.parachains.overview((overview) => {
 *   parachains.forEach(parachain => {
 *     console.log(`Parachain ${parachain.id.toString()} is registered.`);
 *   });
 * });
 * ```
 */
function overview$1(instanceId, api) {
    return memo(instanceId, () => api.query['registrar']?.['parachains'] && api.query['parachains']
        ? api.query['registrar']['parachains']().pipe(switchMap((paraIds) => combineLatest([
            of(paraIds),
            api.query['parachains']['didUpdate'](),
            api.query['parachains']['relayDispatchQueueSize'].multi(paraIds),
            api.query['registrar']['paras'].multi(paraIds),
            api.query['registrar']['pendingSwap'].multi(paraIds)
        ])), map(parse$1))
        : of([]));
}

var parachains = /*#__PURE__*/Object.freeze({
	__proto__: null,
	info: info$2,
	overview: overview$1
});

function parse([currentIndex, activeEra, activeEraStart, currentEra, validatorCount]) {
    return {
        activeEra,
        activeEraStart,
        currentEra,
        currentIndex,
        validatorCount
    };
}
function queryStaking(api) {
    return api.queryMulti([
        api.query.session.currentIndex,
        api.query.staking.activeEra,
        api.query.staking.currentEra,
        api.query.staking.validatorCount
    ]).pipe(map(([currentIndex, activeOpt, currentEra, validatorCount]) => {
        const { index, start } = activeOpt.unwrapOrDefault();
        return parse([
            currentIndex,
            index,
            start,
            currentEra.unwrapOrDefault(),
            validatorCount
        ]);
    }));
}
function querySession(api) {
    return api.query.session.currentIndex().pipe(map((currentIndex) => parse([
        currentIndex,
        api.registry.createType('EraIndex'),
        api.registry.createType('Option<Moment>'),
        api.registry.createType('EraIndex'),
        api.registry.createType('u32')
    ])));
}
function empty(api) {
    return of(parse([
        api.registry.createType('SessionIndex', 1),
        api.registry.createType('EraIndex'),
        api.registry.createType('Option<Moment>'),
        api.registry.createType('EraIndex'),
        api.registry.createType('u32')
    ]));
}
/**
 * @name indexes
 * @description Retrieves session-related index data, adapting to whether
 * the chain has staking enabled.
 * @example
 * ```javascript
 * api.derive.session.indexes((indexes) => {
 *   console.log(`Current session index: ${indexes.currentIndex}`);
 *   console.log(`Validator count: ${indexes.validatorCount}`);
 * });
 * ```
 */
function indexes(instanceId, api) {
    return memo(instanceId, () => api.query.session
        ? api.query.staking
            ? queryStaking(api)
            : querySession(api)
        : empty(api));
}

/**
 * @name info
 * @description Retrieves all the session and era query and calculates specific values on it as the length of the session and eras.
 * @example
 * ```javascript
 * api.derive.session.info((info) => {
 *   console.log(`Session info ${JSON.stringify(info)}`);
 * });
 * ```
 */
function info$1(instanceId, api) {
    return memo(instanceId, () => api.derive.session.indexes().pipe(map((indexes) => {
        const sessionLength = api.consts?.babe?.epochDuration || api.registry.createType('u64', 1);
        const sessionsPerEra = api.consts?.staking?.sessionsPerEra || api.registry.createType('SessionIndex', 1);
        return objectSpread({
            eraLength: api.registry.createType('BlockNumber', sessionsPerEra.mul(sessionLength)),
            isEpoch: !!api.query.babe,
            sessionLength,
            sessionsPerEra
        }, indexes);
    })));
}

function withProgressField(field) {
    return (instanceId, api) => memo(instanceId, () => api.derive.session.progress().pipe(map((info) => info[field])));
}
function createDerive(api, info, [currentSlot, epochIndex, epochOrGenesisStartSlot, activeEraStartSessionIndex]) {
    const epochStartSlot = epochIndex.mul(info.sessionLength).iadd(epochOrGenesisStartSlot);
    const sessionProgress = currentSlot.sub(epochStartSlot);
    const eraProgress = info.currentIndex.sub(activeEraStartSessionIndex).imul(info.sessionLength).iadd(sessionProgress);
    return objectSpread({
        eraProgress: api.registry.createType('BlockNumber', eraProgress),
        sessionProgress: api.registry.createType('BlockNumber', sessionProgress)
    }, info);
}
function queryAura(api) {
    return api.derive.session.info().pipe(map((info) => objectSpread({
        eraProgress: api.registry.createType('BlockNumber'),
        sessionProgress: api.registry.createType('BlockNumber')
    }, info)));
}
function queryBabe(api) {
    return api.derive.session.info().pipe(switchMap((info) => combineLatest([
        of(info),
        // we may have no staking, but have babe (permissioned)
        api.query.staking?.erasStartSessionIndex
            ? api.queryMulti([
                api.query.babe.currentSlot,
                api.query.babe.epochIndex,
                api.query.babe.genesisSlot,
                [api.query.staking.erasStartSessionIndex, info.activeEra]
            ])
            : api.queryMulti([
                api.query.babe.currentSlot,
                api.query.babe.epochIndex,
                api.query.babe.genesisSlot
            ])
    ])), map(([info, [currentSlot, epochIndex, genesisSlot, optStartIndex]]) => [
        info, [currentSlot, epochIndex, genesisSlot, optStartIndex && optStartIndex.isSome ? optStartIndex.unwrap() : api.registry.createType('SessionIndex', 1)]
    ]));
}
/**
 * @name progress
 * @description Retrieves session information and progress.
 * @example
 * ```javascript
 * api.derive.session.progress((progress) => {
 *   console.log(`Session progress ${JSON.stringify(progress)}`);
 * });
 * ```
 */
function progress(instanceId, api) {
    return memo(instanceId, () => api.query.babe
        ? queryBabe(api).pipe(map(([info, slots]) => createDerive(api, info, slots)))
        : queryAura(api));
}
/**
 * @name eraLenght
 * @description Retrieves the total length of the current era.
 * @example
 * ```javascript
 * api.derive.session.eraLength((length) => {
 *   console.log(`Current era length: ${length} sessions`);
 * });
 * ```
 */
const eraLength = /*#__PURE__*/ withProgressField('eraLength');
/**
 * @name eraProgress
 * @description Retrieves the progress of the current era.
 * @example
 * ```javascript
 * api.derive.session.eraProgress((progress) => {
 *   console.log(`Current era progress: ${progress} sessions`);
 * });
 * ```
 */
const eraProgress = /*#__PURE__*/ withProgressField('eraProgress');
/**
 * @name sessionProgress
 * @description Retrieves the progress of the current session.
 * @example
 * ```javascript
 *   api.derive.session.sessionProgress((progress) => {
 *   console.log(`Current session progress: ${progress} slots`);
 * });
 * ```
 */
const sessionProgress = /*#__PURE__*/ withProgressField('sessionProgress');

var session = /*#__PURE__*/Object.freeze({
	__proto__: null,
	eraLength: eraLength,
	eraProgress: eraProgress,
	indexes: indexes,
	info: info$1,
	progress: progress,
	sessionProgress: sessionProgress
});

function getPrev(api) {
    return api.query.society.candidates().pipe(switchMap((candidates) => combineLatest([
        of(candidates),
        api.query.society['suspendedCandidates'].multi(candidates.map(({ who }) => who))
    ])), map(([candidates, suspended]) => candidates.map(({ kind, value, who }, index) => ({
        accountId: who,
        isSuspended: suspended[index].isSome,
        kind,
        value
    }))));
}
function getCurr(api) {
    return api.query.society.candidates.entries().pipe(map((entries) => entries
        .filter(([, opt]) => opt.isSome)
        .map(([{ args: [accountId] }, opt]) => [accountId, opt.unwrap()])
        // FIXME We are missing the new fields from the candidate record
        .map(([accountId, { bid, kind }]) => ({
        accountId,
        isSuspended: false,
        kind,
        value: bid
    }))));
}
/**
 * @name candidate
 * @description Retrieves the list of candidates for the society module.
 * @example
 * ```javascript
 * const societyCandidates = await api.derive.society.candidates();
 * console.log(societyCandidates);
 * ```
 */
function candidates(instanceId, api) {
    return memo(instanceId, () => api.query.society['suspendedCandidates'] && api.query.society.candidates.creator.meta.type.isPlain
        ? getPrev(api)
        : getCurr(api));
}

/**
 * @name info
 * @description Get the overall info for a society.
 * @example
 * ```javascript
 * const societyInfo = await api.derive.society.candidates();
 * console.log(societyInfo);
 * ```
 */
function info(instanceId, api) {
    return memo(instanceId, () => combineLatest([
        api.query.society.bids(),
        api.query.society['defender']
            ? api.query.society['defender']()
            : of(undefined),
        api.query.society.founder(),
        api.query.society.head(),
        api.query.society['maxMembers']
            ? api.query.society['maxMembers']()
            : of(undefined),
        api.query.society.pot()
    ]).pipe(map(([bids, defender, founder, head, maxMembers, pot]) => ({
        bids,
        defender: defender?.unwrapOr(undefined),
        founder: founder.unwrapOr(undefined),
        hasDefender: (defender?.isSome && head.isSome && !head.eq(defender)) || false,
        head: head.unwrapOr(undefined),
        maxMembers,
        pot
    }))));
}

/**
 * @name member
 * @description Get the member info for a society.
 * @param { AccountId } accountId
 * @example
 * ```javascript
 * const member = await api.derive.society.member(ALICE);
 * console.log(member);
 * ```
 */
function member(instanceId, api) {
    return memo(instanceId, (accountId) => api.derive.society._members([accountId]).pipe(map(([result]) => result)));
}

function _membersPrev(api, accountIds) {
    return combineLatest([
        of(accountIds),
        api.query.society.payouts.multi(accountIds),
        api.query.society['strikes'].multi(accountIds),
        api.query.society.defenderVotes.multi(accountIds),
        api.query.society.suspendedMembers.multi(accountIds),
        api.query.society['vouching'].multi(accountIds)
    ]).pipe(map(([accountIds, payouts, strikes, defenderVotes, suspended, vouching]) => accountIds.map((accountId, index) => ({
        accountId,
        isDefenderVoter: defenderVotes[index].isSome,
        isSuspended: suspended[index].isTrue,
        payouts: payouts[index],
        strikes: strikes[index],
        vote: defenderVotes[index].unwrapOr(undefined),
        vouching: vouching[index].unwrapOr(undefined)
    }))));
}
function _membersCurr(api, accountIds) {
    return combineLatest([
        of(accountIds),
        api.query.society.members.multi(accountIds),
        api.query.society.payouts.multi(accountIds),
        api.query.society.challengeRoundCount().pipe(switchMap((round) => api.query.society.defenderVotes.multi(accountIds.map((accountId) => [round, accountId])))),
        api.query.society.suspendedMembers.multi(accountIds)
    ]).pipe(map(([accountIds, members, payouts, defenderVotes, suspendedMembers]) => accountIds
        .map((accountId, index) => members[index].isSome
        ? {
            accountId,
            isDefenderVoter: defenderVotes[index].isSome,
            isSuspended: suspendedMembers[index].isSome,
            member: members[index].unwrap(),
            payouts: payouts[index].payouts
        }
        : null)
        .filter((m) => !!m)
        .map(({ accountId, isDefenderVoter, isSuspended, member, payouts }) => ({
        accountId,
        isDefenderVoter,
        isSuspended,
        payouts,
        strikes: member.strikes,
        vouching: member.vouching.unwrapOr(undefined)
    }))));
}
function _members(instanceId, api) {
    return memo(instanceId, (accountIds) => api.query.society.members.creator.meta.type.isMap
        ? _membersCurr(api, accountIds)
        : _membersPrev(api, accountIds));
}
/**
 * @name members
 * @description Get the society members.
 * @example
 * ```javascript
 * const members = await api.derive.society.members();
 * console.log(members);
 * ```
 */
function members$1(instanceId, api) {
    return memo(instanceId, () => api.query.society.members.creator.meta.type.isMap
        ? api.query.society.members.keys().pipe(switchMap((keys) => api.derive.society._members(keys.map(({ args: [accountId] }) => accountId))))
        : api.query.society.members().pipe(switchMap((members) => api.derive.society._members(members))));
}

var society = /*#__PURE__*/Object.freeze({
	__proto__: null,
	_members: _members,
	candidates: candidates,
	info: info,
	member: member,
	members: members$1
});

const QUERY_OPTS = {
    withDestination: true,
    withLedger: true,
    withNominations: true,
    withPrefs: true
};
function groupByEra(list) {
    return list.reduce((map, { era, value }) => {
        const key = era.toString();
        map[key] = (map[key] || BN_ZERO).add(value.unwrap());
        return map;
    }, {});
}
function calculateUnlocking(api, stakingLedger, sessionInfo) {
    const results = Object
        .entries(groupByEra((stakingLedger?.unlocking || []).filter(({ era }) => era.unwrap().gt(sessionInfo.activeEra))))
        .map(([eraString, value]) => ({
        remainingEras: new BN(eraString).isub(sessionInfo.activeEra),
        value: api.registry.createType('Balance', value)
    }));
    return results.length
        ? results
        : undefined;
}
function redeemableSum(api, stakingLedger, sessionInfo) {
    return api.registry.createType('Balance', (stakingLedger?.unlocking || []).reduce((total, { era, value }) => {
        // aligns with https://github.com/paritytech/substrate/blob/fdfdc73f9e64dc47934b72eb9af3e1989e4ba699/frame/staking/src/pallet/mod.rs#L973-L975
        // (ensure currentEra >= era passed, as per https://github.com/paritytech/substrate/blob/fdfdc73f9e64dc47934b72eb9af3e1989e4ba699/frame/staking/src/lib.rs#L477-L494)
        // NOTE: Previously we used activeEra >= era, which is incorrect for the last session
        return era.unwrap().gt(sessionInfo.currentEra)
            ? total
            : total.iadd(value.unwrap());
    }, new BN(0)));
}
function parseResult$1(api, sessionInfo, keys, query) {
    return objectSpread({}, keys, query, {
        redeemable: redeemableSum(api, query.stakingLedger, sessionInfo),
        unlocking: calculateUnlocking(api, query.stakingLedger, sessionInfo)
    });
}
/**
 * @name accounts
 * @param {(Uint8Array | string)[]} accountIds List of account stashes
 * @param {StakingQueryFlags} opts optional filtering flag
 * @description From a list of stashes, fill in all the relevant staking details
 * @example
 * ```javascript
 * const accounts = await api.derive.staking.accounts([
 *  "149B17nn7zVL4SkLSNmANupEkGexUBAxVrdk4bbWFZYibkFc",
 * ]);
 * console.log("First account staking info:", accounts[0]);
 * ```
 */
function accounts(instanceId, api) {
    return memo(instanceId, (accountIds, opts = QUERY_OPTS) => api.derive.session.info().pipe(switchMap((sessionInfo) => combineLatest([
        api.derive.staking.keysMulti(accountIds),
        api.derive.staking.queryMulti(accountIds, opts)
    ]).pipe(map(([keys, queries]) => queries.map((q, index) => parseResult$1(api, sessionInfo, keys[index], q)))))));
}
/**
 * @name account
 * @param {(Uint8Array | string)} accountId AccountId of the stash.
 * @param {StakingQueryFlags} opts (Optional) filtering flag.
 * @description From a stash, retrieve the controllerId and fill in all the relevant staking details.
 * @example
 * ```javascript
 * const accountStakingData = await api.derive.staking.account(
 *   "149B17nn7zVL4SkLSNmANupEkGexUBAxVrdk4bbWFZYibkFc"
 * );
 * console.log(accountStakingData);
 * ```
 */
const account = /*#__PURE__*/ firstMemo((api, accountId, opts) => api.derive.staking.accounts([accountId], opts));

/**
 * @name currentPoints
 * @description Retrieve the staking overview, including elected and points earned.
 * @example
 * ```javascript
 * const currentPoints = await api.derive.staking.currentPoints();
 * console.log(currentPoints.toHuman());
 * ```
 */
function currentPoints(instanceId, api) {
    return memo(instanceId, () => api.derive.session.indexes().pipe(switchMap(({ activeEra }) => api.query.staking.erasRewardPoints(activeEra))));
}

const DEFAULT_FLAGS$1 = { withController: true, withExposure: true, withPrefs: true };
function combineAccounts(nextElected, validators) {
    return arrayFlatten([nextElected, validators.filter((v) => !nextElected.find((n) => n.eq(v)))]);
}
/**
 * @name electedInfo
 * @param {StakingQueryFlags} flags? (Optional) Query flags to filter the staking data.
 * @param {number} page? (Optional) The page index for paginated results.
 * @description Retrieves detailed staking information about the next elected validators and their associated staking data.
 * @example
 * ```javascript
 * const { nextElected, validators, info } =
 *   await api.derive.staking.electedInfo();
 * console.log(
 *   "Next Elected Validators:",
 *   nextElected.map((acc) => acc.toString())
 * );
 * console.log(
 *   "Current Validators:",
 *   validators.map((acc) => acc.toString())
 * );
 * console.log("Validator Staking Info:", info);
 * ```
 */
function electedInfo(instanceId, api) {
    return memo(instanceId, (flags = DEFAULT_FLAGS$1, page = 0) => api.derive.staking.validators().pipe(switchMap(({ nextElected, validators }) => api.derive.staking.queryMulti(combineAccounts(nextElected, validators), flags, page).pipe(map((info) => ({
        info,
        nextElected,
        validators
    }))))));
}

function getEraCache(CACHE_KEY, era, withActive) {
    const cacheKey = `${CACHE_KEY}-${era.toString()}`;
    return [
        cacheKey,
        withActive
            ? undefined
            : deriveCache.get(cacheKey)
    ];
}
function getEraMultiCache(CACHE_KEY, eras, withActive) {
    const cached = withActive
        ? []
        : eras
            .map((e) => deriveCache.get(`${CACHE_KEY}-${e.toString()}`))
            .filter((v) => !!v);
    return cached;
}
function setEraCache(cacheKey, withActive, value) {
    !withActive && deriveCache.set(cacheKey, value);
    return value;
}
function setEraMultiCache(CACHE_KEY, withActive, values) {
    !withActive && values.forEach((v) => deriveCache.set(`${CACHE_KEY}-${v.era.toString()}`, v));
    return values;
}
function filterCachedEras(eras, cached, query) {
    return eras
        .map((e) => cached.find(({ era }) => e.eq(era)) ||
        query.find(({ era }) => e.eq(era)))
        .filter((e) => !!e);
}

const ERA_CHUNK_SIZE = 14;
function chunkEras(eras, fn) {
    const chunked = arrayChunk(eras, ERA_CHUNK_SIZE);
    let index = 0;
    const subject = new BehaviorSubject(chunked[index]);
    return subject.pipe(switchMap(fn), tap(() => {
        nextTick(() => {
            index++;
            index === chunked.length
                ? subject.complete()
                : subject.next(chunked[index]);
        });
    }), toArray(), map(arrayFlatten));
}
function filterEras(eras, list) {
    return eras.filter((e) => !list.some(({ era }) => e.eq(era)));
}
function erasHistoricApply(fn) {
    return (instanceId, api) => 
    // Cannot quite get the typing right, but it is right in the code
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    memo(instanceId, (withActive = false) => api.derive.staking.erasHistoric(withActive).pipe(switchMap((e) => api.derive.staking[fn](e, withActive))));
}
function erasHistoricApplyAccount(fn) {
    return (instanceId, api) => 
    // Cannot quite get the typing right, but it is right in the code
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    memo(instanceId, (accountId, withActive = false, page) => api.derive.staking.erasHistoric(withActive).pipe(switchMap((e) => api.derive.staking[fn](accountId, e, withActive, page || 0))));
}
function singleEra(fn) {
    return (instanceId, api) => 
    // Cannot quite get the typing right, but it is right in the code
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    memo(instanceId, (era) => api.derive.staking[fn](era, true));
}
function combineEras(fn) {
    return (instanceId, api) => 
    // Cannot quite get the typing right, but it is right in the code
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    memo(instanceId, (eras, withActive) => !eras.length
        ? of([])
        : chunkEras(eras, (eras) => combineLatest(eras.map((e) => api.derive.staking[fn](e, withActive)))));
}

const CACHE_KEY$4 = 'eraExposure';
function mapStakersClipped(era, stakers) {
    const nominators = {};
    const validators = {};
    stakers.forEach(([key, exposure]) => {
        const validatorId = key.args[1].toString();
        validators[validatorId] = exposure;
        exposure.others.forEach(({ who }, validatorIndex) => {
            const nominatorId = who.toString();
            nominators[nominatorId] = nominators[nominatorId] || [];
            nominators[nominatorId].push({ validatorId, validatorIndex });
        });
    });
    return { era, nominators, validators };
}
function mapStakersPaged(era, stakers) {
    const nominators = {};
    const validators = {};
    stakers.forEach(([key, exposureOpt]) => {
        if (exposureOpt.isSome) {
            const validatorId = key.args[1].toString();
            const exposure = exposureOpt.unwrap();
            validators[validatorId] = exposure;
            exposure.others.forEach(({ who }, validatorIndex) => {
                const nominatorId = who.toString();
                nominators[nominatorId] = nominators[nominatorId] || [];
                nominators[nominatorId].push({ validatorId, validatorIndex });
            });
        }
    });
    return { era, nominators, validators };
}
/**
 * erasStakersClipped will be deprecated and replaced with erasStakersPaged. Therefore support is given for both
 * storage queries until erasStakersClipped has been completely out of use.
 */
function _eraExposure(instanceId, api) {
    return memo(instanceId, (era, withActive = false) => {
        const [cacheKey, cached] = getEraCache(CACHE_KEY$4, era, withActive);
        return cached
            ? of(cached)
            : api.query.staking.erasStakersPaged
                ? api.query.staking.erasStakersPaged.entries(era).pipe(map((r) => setEraCache(cacheKey, withActive, mapStakersPaged(era, r))))
                : api.query.staking.erasStakersClipped.entries(era).pipe(map((r) => setEraCache(cacheKey, withActive, mapStakersClipped(era, r))));
    });
}
/**
 * @name eraExposure
 * @description Retrieves the staking exposure (nominators and total stake) for a specific era.
 * @param {EraIndex} eras The staking era to query.
 * @example
 * ```javascript
 * const era = api.createType("EraIndex", 1000);
 * const exposure = await api.derive.staking.eraExposure(era);
 * ```
 */
const eraExposure = /*#__PURE__*/ singleEra('_eraExposure');
const _erasExposure = /*#__PURE__*/ combineEras('_eraExposure');
/**
 * @name erasExposure
 * @description Retrieves staking exposure details for multiple past eras.
 * @param {boolean} withActive? (Optional) Whether to include the active era in the result.
 * @example
 * ```javascript
 * const exposure = await api.derive.staking.erasExposure(true);
 * ```
 */
const erasExposure = /*#__PURE__*/ erasHistoricApply('_erasExposure');

/**
 * @name erasHistoric
 * @param {boolean} withActive? (Optional) Whether to include the active era in the result.
 */
function erasHistoric(instanceId, api) {
    return memo(instanceId, (withActive) => combineLatest([
        api.query.staking.activeEra(),
        api.consts.staking.historyDepth
            ? of(api.consts.staking.historyDepth)
            : api.query.staking['historyDepth']()
    ]).pipe(map(([activeEraOpt, historyDepth]) => {
        const result = [];
        const max = historyDepth.toNumber();
        const activeEra = activeEraOpt.unwrapOrDefault().index;
        let lastEra = activeEra;
        while (lastEra.gte(BN_ZERO) && (result.length < max)) {
            if ((lastEra !== activeEra) || (withActive === true)) {
                result.push(api.registry.createType('EraIndex', lastEra));
            }
            lastEra = lastEra.sub(BN_ONE);
        }
        // go from oldest to newest
        return result.reverse();
    })));
}

const CACHE_KEY$3 = 'eraPoints';
function mapValidators({ individual }) {
    return [...individual.entries()]
        .filter(([, points]) => points.gt(BN_ZERO))
        .reduce((result, [validatorId, points]) => {
        result[validatorId.toString()] = points;
        return result;
    }, {});
}
function mapPoints(eras, points) {
    return eras.map((era, index) => ({
        era,
        eraPoints: points[index].total,
        validators: mapValidators(points[index])
    }));
}
function _erasPoints(instanceId, api) {
    return memo(instanceId, (eras, withActive) => {
        if (!eras.length) {
            return of([]);
        }
        const cached = getEraMultiCache(CACHE_KEY$3, eras, withActive);
        const remaining = filterEras(eras, cached);
        return !remaining.length
            ? of(cached)
            : api.query.staking.erasRewardPoints.multi(remaining).pipe(map((p) => filterCachedEras(eras, cached, setEraMultiCache(CACHE_KEY$3, withActive, mapPoints(remaining, p)))));
    });
}
/**
 * @name erasPoints
 * @description Retrieves historical era points with its validators.
 * @param {boolean} withActive? (Optional) Whether to include the active era in the result.
 * @example
 * ```javascript
 * const points = await api.derive.staking.erasPoints(true);
 * console.log(
 *   "Validator points:",
 *   points.map(({ era, eraPoints }) => `Era: ${era}, points ${eraPoints}`)
 * );
 * ```
 */
const erasPoints = /*#__PURE__*/ erasHistoricApply('_erasPoints');

const CACHE_KEY$2 = 'eraPrefs';
function mapPrefs(era, all) {
    const validators = {};
    all.forEach(([key, prefs]) => {
        validators[key.args[1].toString()] = prefs;
    });
    return { era, validators };
}
function _eraPrefs(instanceId, api) {
    return memo(instanceId, (era, withActive) => {
        const [cacheKey, cached] = getEraCache(CACHE_KEY$2, era, withActive);
        return cached
            ? of(cached)
            : api.query.staking.erasValidatorPrefs.entries(era).pipe(map((r) => setEraCache(cacheKey, withActive, mapPrefs(era, r))));
    });
}
/**
 * @name eraPrefs
 * @description Retrieves the validators commission preferences for a given staking era.
 * @param {EraIndex} era The staking era to query.
 * @example
 * ```javascript
 * const era = api.createType("EraIndex", 1000);
 * const prefs = await api.derive.staking.eraPrefs(era);
 * console.log(JSON.stringify(prefs));
 * ```
 */
const eraPrefs = /*#__PURE__*/ singleEra('_eraPrefs');
const _erasPrefs = /*#__PURE__*/ combineEras('_eraPrefs');
/**
 * @name erasPrefs
 * @description Retrieves validators commission preferences for multiple past staking eras
 * @param {boolean} withActive? (Optional) Whether to include the active era in the result.
 * @example
 * ```javascript
 * const prefs = await api.derive.staking.erasPrefs(true);
 * ```
 */
const erasPrefs = /*#__PURE__*/ erasHistoricApply('_erasPrefs');

const CACHE_KEY$1 = 'eraRewards';
function mapRewards(eras, optRewards) {
    return eras.map((era, index) => ({
        era,
        eraReward: optRewards[index].unwrapOrDefault()
    }));
}
function _erasRewards(instanceId, api) {
    return memo(instanceId, (eras, withActive) => {
        if (!eras.length) {
            return of([]);
        }
        const cached = getEraMultiCache(CACHE_KEY$1, eras, withActive);
        const remaining = filterEras(eras, cached);
        if (!remaining.length) {
            return of(cached);
        }
        return api.query.staking.erasValidatorReward.multi(remaining).pipe(map((r) => filterCachedEras(eras, cached, setEraMultiCache(CACHE_KEY$1, withActive, mapRewards(remaining, r)))));
    });
}
/**
 * @name erasRewards
 * @description Retrieves rewards for historical eras.
 * @param {boolean} withActive? (Optional) Whether to include the active era in the result.
 * @example
 * ```javascript
 * const rewards = await api.derive.staking.erasRewards(true);
 * ```
 */
const erasRewards = /*#__PURE__*/ erasHistoricApply('_erasRewards');

const CACHE_KEY = 'eraSlashes';
function mapSlashes(era, noms, vals) {
    const nominators = {};
    const validators = {};
    noms.forEach(([key, optBalance]) => {
        nominators[key.args[1].toString()] = optBalance.unwrap();
    });
    vals.forEach(([key, optRes]) => {
        validators[key.args[1].toString()] = optRes.unwrapOrDefault()[1];
    });
    return { era, nominators, validators };
}
function _eraSlashes(instanceId, api) {
    return memo(instanceId, (era, withActive) => {
        const [cacheKey, cached] = getEraCache(CACHE_KEY, era, withActive);
        return cached
            ? of(cached)
            : combineLatest([
                api.query.staking.nominatorSlashInEra.entries(era),
                api.query.staking.validatorSlashInEra.entries(era)
            ]).pipe(map(([n, v]) => setEraCache(cacheKey, withActive, mapSlashes(era, n, v))));
    });
}
/**
 * @name eraSlashes
 * @description Retrieves the slashes for a specific staking era.
 * @param {EraIndex} eras The staking era to query.
 * @example
 * ```javascript
 * const era = api.createType("EraIndex", 1000);
 * const slashes = await api.derive.staking.eraSlashes(era);
 * ```
 */
const eraSlashes = /*#__PURE__*/ singleEra('_eraSlashes');
const _erasSlashes = /*#__PURE__*/ combineEras('_eraSlashes');
/**
 * @name erasSlashes
 * @description Retrieves slashes for historical eras.
 * @param {boolean} withActive? (Optional) Whether to include the active era in the result.
 * @example
 * ```javascript
 * const slashes = await api.derive.staking.erasSlashes(true);
 * ```
 */
const erasSlashes = /*#__PURE__*/ erasHistoricApply('_erasSlashes');

function extractsIds(stashId, queuedKeys, nextKeys) {
    const sessionIds = (queuedKeys.find(([currentId]) => currentId.eq(stashId)) || [undefined, []])[1];
    const nextSessionIds = nextKeys.unwrapOr([]);
    return {
        nextSessionIds: Array.isArray(nextSessionIds)
            ? nextSessionIds
            : [...nextSessionIds.values()],
        sessionIds: Array.isArray(sessionIds)
            ? sessionIds
            : [...sessionIds.values()]
    };
}
/**
 * @name keys
 * @param { Uint8Array | string } stashId The stash account ID whose session keys are to be retrieved.
 * @description Retrieves the session keys associated with a given stash account.
 * @example
 * ```javascript
 * const keys = await api.derive.staking.keys(
 *   ALICE
 * );
 * console.log(
 *   "Session keys:",
 *   keys.sessionIds.map((key) => `Key: ${key}`)
 * );
 * ```
 */
const keys = /*#__PURE__*/ firstMemo((api, stashId) => api.derive.staking.keysMulti([stashId]));
/**
 * @name keysMulti
 * @description Retrieves session keys for multiple stash accounts.
 * @param { (Uint8Array | string)[] } stashIds Array of stash account IDs.
 * @example
 * ```javascript
 * const keysMulti = await api.derive.staking.keysMulti([ ALICE, BOB ]);
 * keysMulti.forEach((keys) => {
 *   console.log(
 *     "Session keys:",
 *     keys.sessionIds.map((key) => `Key: ${key}`)
 *   );
 * });
 * ```
 */
function keysMulti(instanceId, api) {
    return memo(instanceId, (stashIds) => stashIds.length
        ? api.query.session.queuedKeys().pipe(switchMap((queuedKeys) => combineLatest([
            of(queuedKeys),
            api.consts['session']?.['dedupKeyPrefix']
                ? api.query.session.nextKeys.multi(stashIds.map((s) => [api.consts['session']['dedupKeyPrefix'], s]))
                : combineLatest(stashIds.map((s) => api.query.session.nextKeys(s)))
        ])), map(([queuedKeys, nextKeys]) => stashIds.map((stashId, index) => extractsIds(stashId, queuedKeys, nextKeys[index]))))
        : of([]));
}

/**
 * @name overview
 * @description Retrieve the staking overview, including elected validators and points earned.
 * @example
 * ```javascript
 * const {
 *   activeEra,
 *   activeEraStart,
 *   currentEra,
 *   currentIndex,
 *   nextElected,
 *   validatorCount,
 *   validators,
 * } = await api.derive.staking.overview();
 * ```
 */
function overview(instanceId, api) {
    return memo(instanceId, () => combineLatest([
        api.derive.session.indexes(),
        api.derive.staking.validators()
    ]).pipe(map(([indexes, { nextElected, validators }]) => objectSpread({}, indexes, {
        nextElected,
        validators
    }))));
}

function _ownExposures(instanceId, api) {
    return memo(instanceId, (accountId, eras, _withActive, page) => {
        const emptyStakingExposure = api.registry.createType('Exposure');
        // The reason we don't explicitly make the actual types is for compatibility. If the chain doesn't have the noted type it will fail
        // on construction. Therefore we just make an empty option.
        const emptyOptionPage = api.registry.createType('Option<Null>');
        const emptyOptionMeta = api.registry.createType('Option<Null>');
        return eras.length
            ? combineLatest([
                // Backwards and forward compat for historical integrity when using `erasHistoricApplyAccount`
                api.query.staking.erasStakersClipped
                    ? combineLatest(eras.map((e) => api.query.staking.erasStakersClipped(e, accountId)))
                    : of(eras.map((_) => emptyStakingExposure)),
                api.query.staking.erasStakers
                    ? combineLatest(eras.map((e) => api.query.staking.erasStakers(e, accountId)))
                    : of(eras.map((_) => emptyStakingExposure)),
                api.query.staking.erasStakersPaged
                    ? combineLatest(eras.map((e) => api.query.staking.erasStakersPaged(e, accountId, page)))
                    : of(eras.map((_) => emptyOptionPage)),
                api.query.staking.erasStakersOverview
                    ? combineLatest(eras.map((e) => api.query.staking.erasStakersOverview(e, accountId)))
                    : of(eras.map((_) => emptyOptionMeta))
            ]).pipe(map(([clp, exp, paged, expMeta]) => eras.map((era, index) => ({ clipped: clp[index], era, exposure: exp[index], exposureMeta: expMeta[index], exposurePaged: paged[index] }))))
            : of([]);
    });
}
/**
 * @name ownExposure
 * @description Retrieves the staking exposure of a validator for a specific era, including their own stake.
 * @param { Uint8Array | string } accountId The validator stash account.
 * @param {EraIndex} era The staking era to query.
 * @param { u32 | AnyNumber } page? (Optional) The pagination index.
 * @example
 * ```javascript
 * const era = api.createType("EraIndex", 1000);
 * const exposure = await api.derive.staking.ownExposure(
 *   "11VR4pF6c7kfBhfmuwwjWY3FodeYBKWx7ix2rsRCU2q6hqJ",
 *   era
 * );
 * console.log(JSON.stringify(exposure));
 * ```
 */
const ownExposure = /*#__PURE__*/ firstMemo((api, accountId, era, page) => api.derive.staking._ownExposures(accountId, [era], true, page || 0));
/**
 * @name ownExposures
 * @description Retrieves staking exposures for a validator across multiple historical eras.
 * @param { Uint8Array | string } accountId The validator stash account.
 * @param { boolean } withActive Whether to include the active era.
 * @example
 * ```javascript
 * const exposures = await api.derive.staking.ownExposures(
 *   ALICE,
 *   true
 * );
 * ```
 */
const ownExposures = /*#__PURE__*/ erasHistoricApplyAccount('_ownExposures');

function _ownSlashes(instanceId, api) {
    return memo(instanceId, (accountId, eras, _withActive) => eras.length
        ? combineLatest([
            combineLatest(eras.map((e) => api.query.staking.validatorSlashInEra(e, accountId))),
            combineLatest(eras.map((e) => api.query.staking.nominatorSlashInEra(e, accountId)))
        ]).pipe(map(([vals, noms]) => eras.map((era, index) => ({
            era,
            total: vals[index].isSome
                ? vals[index].unwrap()[1]
                : noms[index].unwrapOrDefault()
        }))))
        : of([]));
}
/**
 * @name ownSlash
 * @description Retrieves the slashes applied to a specific account in a given era.
 * @param { Uint8Array | string } accountId The validator stash account.
 * @param {EraIndex} era The staking era to query.
 * @example
 * ```javascript
 * const era = api.createType("EraIndex", 1000);
 * const slashedAmount = await api.derive.staking.ownSlash(
 *   ALICE,
 *   era
 * );
 * console.log(`Era: ${slashedAmount.era}, total ${slashedAmount.total}`);
 * ```
 */
const ownSlash = /*#__PURE__*/ firstMemo((api, accountId, era) => api.derive.staking._ownSlashes(accountId, [era], true));
/**
 * @name ownSlashes
 * @description Retrieves the slashes for a specific account across all historic eras.
 * @param { Uint8Array | string } accountId The validator stash account.
 * @param { boolean } withActive Whether to include the active era.
 * @example
 * ```javascript
 * const slashes = await api.derive.staking.ownSlashes(
 *   ALICE,
 *   true
 * );
 * console.log(slashes);
 * ```
 */
const ownSlashes = /*#__PURE__*/ erasHistoricApplyAccount('_ownSlashes');

function rewardDestinationCompat(rewardDestination) {
    // We ensure the type is an Option by checking if isSome is a boolean. When isSome doesn't exist it will always return undefined.
    return typeof rewardDestination.isSome === 'boolean'
        ? rewardDestination.unwrapOr(null)
        : rewardDestination;
}
function filterClaimedRewards(api, cl) {
    return api.registry.createType('Vec<u32>', cl.filter((c) => c !== -1));
}
function filterRewards$1(stashIds, eras, claimedRewards, stakersOverview) {
    const claimedData = {};
    const overviewData = {};
    const ids = stashIds.map((i) => i.toString());
    claimedRewards.forEach(([keys, rewards]) => {
        const id = keys.args[1].toString();
        const era = keys.args[0].toNumber();
        if (ids.includes(id)) {
            if (claimedData[id]) {
                claimedData[id].set(era, rewards.toArray());
            }
            else {
                claimedData[id] = new Map();
                claimedData[id].set(era, rewards.toArray());
            }
        }
    });
    stakersOverview.forEach(([keys, overview]) => {
        const id = keys.args[1].toString();
        const era = keys.args[0].toNumber();
        if (ids.includes(id) && overview.isSome) {
            if (overviewData[id]) {
                overviewData[id].set(era, overview.unwrap().pageCount);
            }
            else {
                overviewData[id] = new Map();
                overviewData[id].set(era, overview.unwrap().pageCount);
            }
        }
    });
    return stashIds.map((id) => {
        const rewardsPerEra = claimedData[id.toString()];
        const overviewPerEra = overviewData[id.toString()];
        return eras.map((era) => {
            if (rewardsPerEra && rewardsPerEra.has(era) && overviewPerEra && overviewPerEra.has(era)) {
                const rewards = rewardsPerEra.get(era);
                const pageCount = overviewPerEra.get(era);
                return rewards.length === pageCount.toNumber()
                    ? era
                    : -1;
            }
            return -1;
        });
    });
}
function parseDetails(api, stashId, controllerIdOpt, nominatorsOpt, rewardDestinationOpts, validatorPrefs, exposure, stakingLedgerOpt, exposureMeta, claimedRewards, exposureEraStakers) {
    return {
        accountId: stashId,
        claimedRewardsEras: filterClaimedRewards(api, claimedRewards),
        controllerId: controllerIdOpt?.unwrapOr(null) || null,
        exposureEraStakers,
        exposureMeta,
        exposurePaged: exposure,
        nominators: nominatorsOpt.isSome
            ? nominatorsOpt.unwrap().targets
            : [],
        rewardDestination: rewardDestinationCompat(rewardDestinationOpts),
        stakingLedger: stakingLedgerOpt.unwrapOrDefault(),
        stashId,
        validatorPrefs
    };
}
function getLedgers(api, optIds, { withLedger = false }) {
    const ids = optIds
        .filter((o) => withLedger && !!o && o.isSome)
        .map((o) => o.unwrap());
    const emptyLed = api.registry.createType('Option<StakingLedger>');
    return (ids.length
        ? combineLatest(ids.map((s) => api.query.staking.ledger(s)))
        : of([])).pipe(map((optLedgers) => {
        let offset = -1;
        return optIds.map((o) => o && o.isSome
            ? optLedgers[++offset] || emptyLed
            : emptyLed);
    }));
}
function getStashInfo(api, stashIds, activeEra, { withClaimedRewardsEras, withController, withDestination, withExposure, withExposureErasStakersLegacy, withExposureMeta, withLedger, withNominations, withPrefs }, page) {
    const emptyNoms = api.registry.createType('Option<Nominations>');
    const emptyRewa = api.registry.createType('RewardDestination');
    const emptyExpoEraStakers = api.registry.createType('Exposure');
    const emptyPrefs = api.registry.createType('ValidatorPrefs');
    // The reason we don't explicitly make the actual types is for compatibility. If the chain doesn't have the noted type it will fail
    // on construction. Therefore we just make an empty option.
    const emptyExpo = api.registry.createType('Option<Null>');
    const emptyExpoMeta = api.registry.createType('Option<Null>');
    const emptyClaimedRewards = [-1];
    const depth = Number(api.consts.staking.historyDepth.toNumber());
    const eras = new Array(depth).fill(0).map((_, idx) => {
        if (idx === 0) {
            return activeEra.toNumber() - 1;
        }
        return activeEra.toNumber() - idx - 1;
    });
    return combineLatest([
        withController || withLedger
            ? combineLatest(stashIds.map((s) => api.query.staking.bonded(s)))
            : of(stashIds.map(() => null)),
        withNominations
            ? combineLatest(stashIds.map((s) => api.query.staking.nominators(s)))
            : of(stashIds.map(() => emptyNoms)),
        withDestination
            ? combineLatest(stashIds.map((s) => api.query.staking.payee(s)))
            : of(stashIds.map(() => emptyRewa)),
        withPrefs
            ? combineLatest(stashIds.map((s) => api.query.staking.validators(s)))
            : of(stashIds.map(() => emptyPrefs)),
        withExposure && api.query.staking.erasStakersPaged
            ? combineLatest(stashIds.map((s) => api.query.staking.erasStakersPaged(activeEra, s, page)))
            : of(stashIds.map(() => emptyExpo)),
        withExposureMeta && api.query.staking.erasStakersOverview
            ? combineLatest(stashIds.map((s) => api.query.staking.erasStakersOverview(activeEra, s)))
            : of(stashIds.map(() => emptyExpoMeta)),
        withClaimedRewardsEras && api.query.staking.claimedRewards
            ? combineLatest([
                api.query.staking.claimedRewards.entries(),
                api.query.staking.erasStakersOverview.entries()
            ]).pipe(map(([rewardsStorageVec, overviewStorageVec]) => filterRewards$1(stashIds, eras, rewardsStorageVec, overviewStorageVec)))
            : of(stashIds.map(() => emptyClaimedRewards)),
        withExposureErasStakersLegacy && api.query.staking.erasStakers
            ? combineLatest(stashIds.map((s) => api.query.staking.erasStakers(activeEra, s)))
            : of(stashIds.map(() => emptyExpoEraStakers))
    ]);
}
function getBatch(api, activeEra, stashIds, flags, page) {
    return getStashInfo(api, stashIds, activeEra, flags, page).pipe(switchMap(([controllerIdOpt, nominatorsOpt, rewardDestination, validatorPrefs, exposure, exposureMeta, claimedRewardsEras, exposureEraStakers]) => getLedgers(api, controllerIdOpt, flags).pipe(map((stakingLedgerOpts) => stashIds.map((stashId, index) => parseDetails(api, stashId, controllerIdOpt[index], nominatorsOpt[index], rewardDestination[index], validatorPrefs[index], exposure[index], stakingLedgerOpts[index], exposureMeta[index], claimedRewardsEras[index], exposureEraStakers[index]))))));
}
/**
 * @name query
 * @param { Uint8Array | string } accountId The stash account to query.
 * @param { StakingQueryFlags } flags Flags to customize the query.
 * @param { u32 } page (Optional) pagination parameter.
 * @description Retrieves staking details for a given stash account.
 * @example
 * ```javascript
 * const stakingInfo = await api.derive.staking.query(
 *   ALICE,
 *   {}
 * );
 * ```
 */
const query = /*#__PURE__*/ firstMemo((api, accountId, flags, page) => api.derive.staking.queryMulti([accountId], flags, page));
/**
 * @name queryMulti
 * @param { (Uint8Array | string)[] } accountIds List of stash accounts to query.
 * @param { StakingQueryFlags } flags Flags to customize the query.
 * @param { u32 } page (Optional) pagination parameter.
 * @description Retrieves staking details for multiple stash accounts.
 * @example
 * ```javascript
 * const stakingInfos = await api.derive.staking.queryMulti([stashId1, stashId2], {});
 * ```
 */
function queryMulti(instanceId, api) {
    return memo(instanceId, (accountIds, flags, page) => api.derive.session.indexes().pipe(switchMap(({ activeEra }) => {
        const stashIds = accountIds.map((a) => api.registry.createType('AccountId', a));
        const p = page || 0;
        return stashIds.length
            ? getBatch(api, activeEra, stashIds, flags, p)
            : of([]);
    })));
}

function _stakerExposures(instanceId, api) {
    return memo(instanceId, (accountIds, eras, withActive = false) => {
        const stakerIds = accountIds.map((a) => api.registry.createType('AccountId', a).toString());
        return api.derive.staking._erasExposure(eras, withActive).pipe(map((exposures) => stakerIds.map((stakerId) => exposures.map(({ era, nominators: allNominators, validators: allValidators }) => {
            const isValidator = !!allValidators[stakerId];
            const validators = {};
            const nominating = allNominators[stakerId] || [];
            if (isValidator) {
                validators[stakerId] = allValidators[stakerId];
            }
            else if (nominating) {
                nominating.forEach(({ validatorId }) => {
                    validators[validatorId] = allValidators[validatorId];
                });
            }
            return { era, isEmpty: !Object.keys(validators).length, isValidator, nominating, validators };
        }))));
    });
}
/**
 * @name stakerExposures
 * @param { (Uint8Array | string)[] } accountIds List of validator stash accounts.
 * @param { boolean } withActive Whether to include the active era.
 * @description Retrieves staking exposure for multiple accounts across historical eras.
 * @example
 * ```javascript
 * const exposure = await api.derive.staking.stakerExposures(
 *   [ALICE, BOB],
 *   true
 * );
 * ```
*/
function stakerExposures(instanceId, api) {
    return memo(instanceId, (accountIds, withActive = false) => api.derive.staking.erasHistoric(withActive).pipe(switchMap((eras) => api.derive.staking._stakerExposures(accountIds, eras, withActive))));
}
/**
 * @name stakerExposure
 * @param { Uint8Array | string } accountId The validator stash account.
 * @param { boolean } withActive Whether to include the active era.
 * @description Retrieves staking exposure for a single account across historical eras. Exposure refers to the total stake associated with a validator.
 * @example
 * ```javascript
 * const exposure = await api.derive.staking.stakerExposure(
 *   ALICE,
 *   true
 * );
 * ```
*/
const stakerExposure = /*#__PURE__*/ firstMemo((api, accountId, withActive) => api.derive.staking.stakerExposures([accountId], withActive));

function _stakerPoints(instanceId, api) {
    return memo(instanceId, (accountId, eras, withActive) => {
        const stakerId = api.registry.createType('AccountId', accountId).toString();
        return api.derive.staking._erasPoints(eras, withActive).pipe(map((points) => points.map(({ era, eraPoints, validators }) => ({
            era,
            eraPoints,
            points: validators[stakerId] || api.registry.createType('RewardPoint')
        }))));
    });
}
/**
 * @name stakerPoints
 * @param { Uint8Array | string } accountId The stakers AccountId.
 * @param { boolean } withActive Whether to include the active era.
 * @description Retrieves the era reward points earned by a given staker across all eras.
 * @example
 * ```javascript
 * const points = await api.derive.staking.stakerPoints(
 *   ALICE, //Alice accountId
 *   false
 * );
 * console.log(
 *   'Validator Era Points:',
 *   points.map(({ era, points }) => `Era ${era}: ${points.toString()} points`)
 * );
 * ```
*/
const stakerPoints = /*#__PURE__*/ erasHistoricApplyAccount('_stakerPoints');

function _stakerPrefs(instanceId, api) {
    return memo(instanceId, (accountId, eras, _withActive) => api.query.staking.erasValidatorPrefs.multi(eras.map((e) => [e, accountId])).pipe(map((all) => all.map((validatorPrefs, index) => ({
        era: eras[index],
        validatorPrefs
    })))));
}
/**
 * @name stakerPrefs
 * @param { Uint8Array | string } accountId The stakers AccountId.
 * @param { boolean } withActive Whether to include the active era.
 * @description Retrieves the validator preferences for a given staker across historical eras.
 * @example
 * ```javascript
 * const prefs = await api.derive.staking.stakerPrefs(
 *   ALICE, //Alice accountId
 *   false
 * );
 * console.log(
 *   'Validator Preferences:',
 *   prefs.map(
 *     ({ era, validatorPrefs }) => `Era ${era}: Commission ${validatorPrefs.commission.toString()}`
 *   )
 * );
 * ```
*/
const stakerPrefs = /*#__PURE__*/ erasHistoricApplyAccount('_stakerPrefs');

function extractCompatRewards(claimedRewardsEras, ledger) {
    const l = ledger
        ? (ledger.legacyClaimedRewards ||
            ledger.claimedRewards)?.toArray()
        : [];
    return (claimedRewardsEras.toArray() || []).concat(l);
}
function parseRewards(api, stashId, [erasPoints, erasPrefs, erasRewards], exposures, claimedRewardsEras) {
    return exposures.map(({ era, isEmpty, isValidator, nominating, validators: eraValidators }) => {
        const { eraPoints, validators: allValPoints } = erasPoints.find((p) => p.era.eq(era)) || { eraPoints: BN_ZERO, validators: {} };
        const { eraReward } = erasRewards.find((r) => r.era.eq(era)) || { eraReward: api.registry.createType('Balance') };
        const { validators: allValPrefs } = erasPrefs.find((p) => p.era.eq(era)) || { validators: {} };
        const validators = {};
        const stakerId = stashId.toString();
        Object.entries(eraValidators).forEach(([validatorId, exposure]) => {
            const valPoints = allValPoints[validatorId] || BN_ZERO;
            const valComm = allValPrefs[validatorId]?.commission.unwrap() || BN_ZERO;
            const expTotal = exposure.total
                ? exposure.total?.unwrap()
                : exposure.pageTotal
                    ? exposure.pageTotal?.unwrap()
                    : BN_ZERO;
            let avail = BN_ZERO;
            let value;
            if (!(expTotal.isZero() || valPoints.isZero() || eraPoints.isZero())) {
                avail = eraReward.mul(valPoints).div(eraPoints);
                const valCut = valComm.mul(avail).div(BN_BILLION);
                let staked;
                if (validatorId === stakerId) {
                    if (exposure.own) {
                        staked = exposure.own.unwrap();
                    }
                    else {
                        const expAccount = exposure.others.find(({ who }) => who.eq(validatorId));
                        staked = expAccount
                            ? expAccount.value.unwrap()
                            : BN_ZERO;
                    }
                }
                else {
                    const stakerExp = exposure.others.find(({ who }) => who.eq(stakerId));
                    staked = stakerExp
                        ? stakerExp.value.unwrap()
                        : BN_ZERO;
                }
                value = avail.sub(valCut).imul(staked).div(expTotal).iadd(validatorId === stakerId ? valCut : BN_ZERO);
            }
            validators[validatorId] = {
                total: api.registry.createType('Balance', avail),
                value: api.registry.createType('Balance', value)
            };
        });
        return {
            era,
            eraReward,
            // This might not always be accurate as you need validator account information in order to see if the rewards have been claimed.
            // This is possibly adjusted in `filterRewards` when need be.
            isClaimed: claimedRewardsEras.some((c) => c.eq(era)),
            isEmpty,
            isValidator,
            nominating,
            validators
        };
    });
}
function allUniqValidators(rewards) {
    return rewards.reduce(([all, perStash], rewards) => {
        const uniq = [];
        perStash.push(uniq);
        rewards.forEach(({ validators }) => Object.keys(validators).forEach((validatorId) => {
            if (!uniq.includes(validatorId)) {
                uniq.push(validatorId);
                if (!all.includes(validatorId)) {
                    all.push(validatorId);
                }
            }
        }));
        return [all, perStash];
    }, [[], []]);
}
function removeClaimed(validators, queryValidators, reward, claimedRewardsEras) {
    const rm = [];
    Object.keys(reward.validators).forEach((validatorId) => {
        const index = validators.indexOf(validatorId);
        if (index !== -1) {
            const valLedger = queryValidators[index].stakingLedger;
            if (extractCompatRewards(claimedRewardsEras, valLedger).some((e) => reward.era?.eq(e))) {
                rm.push(validatorId);
            }
        }
    });
    rm.forEach((validatorId) => {
        delete reward.validators[validatorId];
    });
}
function filterRewards(eras, valInfo, { claimedRewardsEras, rewards, stakingLedger }) {
    const filter = eras.filter((e) => !extractCompatRewards(claimedRewardsEras, stakingLedger).some((s) => s?.eq(e)));
    const validators = valInfo.map(([v]) => v);
    const queryValidators = valInfo.map(([, q]) => q);
    return rewards
        .filter(({ isEmpty }) => !isEmpty)
        .filter((reward) => {
        if (!filter.some((e) => reward.era.eq(e))) {
            return false;
        }
        removeClaimed(validators, queryValidators, reward, claimedRewardsEras);
        return true;
    })
        .filter(({ validators }) => Object.keys(validators).length !== 0)
        .map((reward) => {
        let isClaimed = reward.isClaimed;
        const valKeys = Object.keys(reward.validators);
        if (!reward.isClaimed && valKeys.length) {
            for (const key of valKeys) {
                const info = queryValidators.find((i) => i.accountId.toString() === key);
                if (info) {
                    isClaimed = info.claimedRewardsEras?.toArray().some((era) => era.eq(reward.era));
                    break;
                }
            }
        }
        return objectSpread({}, reward, {
            isClaimed,
            nominators: reward.nominating.filter((n) => reward.validators[n.validatorId])
        });
    });
}
function _stakerRewardsEras(instanceId, api) {
    return memo(instanceId, (eras, withActive = false) => combineLatest([
        api.derive.staking._erasPoints(eras, withActive),
        api.derive.staking._erasPrefs(eras, withActive),
        api.derive.staking._erasRewards(eras, withActive)
    ]));
}
function _stakerRewards(instanceId, api) {
    return memo(instanceId, (accountIds, eras, withActive = false) => {
        // Ensures that when number or string types are passed in they are sanitized
        // Ref: https://github.com/polkadot-js/api/issues/5910
        const sanitizedEras = eras.map((e) => typeof e === 'number' || typeof e === 'string' ? api.registry.createType('u32', e) : e);
        return combineLatest([
            api.derive.staking.queryMulti(accountIds, { withClaimedRewardsEras: true, withLedger: true }),
            api.derive.staking._stakerExposures(accountIds, sanitizedEras, withActive),
            api.derive.staking._stakerRewardsEras(sanitizedEras, withActive)
        ]).pipe(switchMap(([queries, exposures, erasResult]) => {
            const allRewards = queries.map(({ claimedRewardsEras, stakingLedger, stashId }, index) => (!stashId || (!stakingLedger && !claimedRewardsEras))
                ? []
                : parseRewards(api, stashId, erasResult, exposures[index], claimedRewardsEras));
            if (withActive) {
                return of(allRewards);
            }
            const [allValidators, stashValidators] = allUniqValidators(allRewards);
            return api.derive.staking.queryMulti(allValidators, { withClaimedRewardsEras: true, withLedger: true }).pipe(map((queriedVals) => queries.map(({ claimedRewardsEras, stakingLedger }, index) => filterRewards(eras, stashValidators[index]
                .map((validatorId) => [
                validatorId,
                queriedVals.find((q) => q.accountId.eq(validatorId))
            ])
                .filter((v) => !!v[1]), {
                claimedRewardsEras,
                rewards: allRewards[index],
                stakingLedger
            }))));
        }));
    });
}
/**
 * @name stakerRewards
 * @description Staking rewards history for a given staker.
 * @param { Uint8Array | string } accountId The stakers AccountId.
 * @param { boolean } withActive Whether to include the active era.
 * @example
 * ```javascript
 * const rewards = await api.derive.staking.stakerRewards(
 *   ALICE, //Alice accountId
 *   false
 * );
 * ```
 */
const stakerRewards = /*#__PURE__*/ firstMemo((api, accountId, withActive) => api.derive.staking.erasHistoric(withActive).pipe(switchMap((eras) => api.derive.staking._stakerRewards([accountId], eras, withActive))));
/**
 * @name stakerRewardsMultiEras
 * @description Staking rewards for multiple stakers over specific eras.
 * @param { Uint8Array | string } accountIds List of stakers identified by their AccountId.
 * @param { EraIndex[] } eras Eras for which to retrieve the data.
 * @example
 * ```javascript
 * const rewards = await api.derive.staking.stakerRewardsMultiEras(
 *   [ALICE, BOB, CHARLIER], //accountIds
 *   [100,101]  //eras
 * );
 * ```
 */
function stakerRewardsMultiEras(instanceId, api) {
    return memo(instanceId, (accountIds, eras) => accountIds.length && eras.length
        ? api.derive.staking._stakerRewards(accountIds, eras, false)
        : of([]));
}
/**
 * @name stakerRewardsMulti
 * @description Staking rewards for multiple stakers.
 * @param { Uint8Array | string } accountIds List of stakers identified by their AccountId.
 * @param { boolean } withActive Whether to include the active era.
 * @example
 * ```javascript
 * const rewards = await api.derive.staking.stakerRewardsMulti(
 *   [ALICE, BOB, CHARLIER], //accountIds
 *   true
 * );
 * ```
 */
function stakerRewardsMulti(instanceId, api) {
    return memo(instanceId, (accountIds, withActive = false) => api.derive.staking.erasHistoric(withActive).pipe(switchMap((eras) => api.derive.staking.stakerRewardsMultiEras(accountIds, eras))));
}

function _stakerSlashes(instanceId, api) {
    return memo(instanceId, (accountId, eras, withActive) => {
        const stakerId = api.registry.createType('AccountId', accountId).toString();
        return api.derive.staking._erasSlashes(eras, withActive).pipe(map((slashes) => slashes.map(({ era, nominators, validators }) => ({
            era,
            total: nominators[stakerId] || validators[stakerId] || api.registry.createType('Balance')
        }))));
    });
}
/**
 * @name stakerSlashes
 * @param { Uint8Array | string } accountId The stakers AccountId.
 * @param { boolean } withActive Whether to include the active era.
 * @description Retrieve the historical slashes (penalties) for a given staker.
 * @example
 * ```javascript
 *  const stakerSlashes = await api.derive.staking.stakerSlashes(
 *   ALICE, //Alice accountId
 *   true
 * );
 * console.log(
 *   'Staker Slashes:',
 *   stakerSlashes.map(({ era, total }) => `Era ${era}: Slashed ${total.toString()}`)
 * );
 * ```
 */
const stakerSlashes = /*#__PURE__*/ erasHistoricApplyAccount('_stakerSlashes');

function onBondedEvent(api) {
    let current = Date.now();
    return api.query.system.events().pipe(map((events) => {
        current = events.filter(({ event, phase }) => {
            try {
                return phase.isApplyExtrinsic &&
                    event.section === 'staking' &&
                    event.method === 'Bonded';
            }
            catch {
                return false;
            }
        })
            ? Date.now()
            : current;
        return current;
    }), startWith(current), drr({ skipTimeout: true }));
}
/**
 * @name stashes
 * @description Retrieve the list of all validator stashes.
 * @example
 * ```javascript
 * const stashes = await api.derive.staking.stashes();
 * console.log(
 *   "Validator Stashes:",
 *   stashes.map((s) => s.toString())
 * );
 * ```
 */
function stashes(instanceId, api) {
    return memo(instanceId, () => onBondedEvent(api).pipe(switchMap(() => api.query.staking.validators.keys()), map((keys) => keys.map(({ args: [v] }) => v).filter((a) => a))));
}

/**
 * @name nextElected
 * @description Retrieves the list of accounts that are set to be the next elected validators in the staking system. It provides a preview of who will be validators in the next staking era.
 * @example
 * ```javascript
 * const nextElected = await api.derive.staking.nextElected();
 * console.log(
 *   "Next Elected Validators:",
 *   nextElected.map((acc) => acc.toString())
 * );
 * ```
 */
function nextElected(instanceId, api) {
    return memo(instanceId, () => 
    // Compatibility for future generation changes in staking.
    api.query.staking.erasStakersOverview
        ? api.derive.session.indexes().pipe(
        // only populate for next era in the last session, so track both here - entries are not
        // subscriptions, so we need a trigger - currentIndex acts as that trigger to refresh
        switchMap(({ currentEra }) => api.query.staking.erasStakersOverview.keys(currentEra)), 
        // Dedupe any duplicates
        map((keys) => [...new Set(keys.map(({ args: [, accountId] }) => accountId.toString()))].map((a) => api.registry.createType('AccountId', a))))
        : api.query.staking.erasStakers
            ? api.derive.session.indexes().pipe(
            // only populate for next era in the last session, so track both here - entries are not
            // subscriptions, so we need a trigger - currentIndex acts as that trigger to refresh
            switchMap(({ currentEra }) => api.query.staking.erasStakers.keys(currentEra)), 
            // Dedupe any duplicates
            map((keys) => [...new Set(keys.map(({ args: [, accountId] }) => accountId.toString()))].map((a) => api.registry.createType('AccountId', a))))
            : api.query.staking['currentElected']());
}
/**
 * @name validators
 * @description Retrieve latest list of validators.
 * @example
 * ```javascript
 * const { validators, nextElected } = await api.derive.staking.validators();
 * console.log(
 *   "Current Validators:",
 *   validators.map((v) => v.toString())
 * );
 * console.log(
 *   "Next Elected Validators:",
 *   nextElected.map((v) => v.toString())
 * );
 * ```
 */
function validators(instanceId, api) {
    return memo(instanceId, () => 
    // Sadly the node-template is (for some obscure reason) not comprehensive, so while the derive works
    // in all actual real-world deployed chains, it does create some confusion for limited template chains
    combineLatest([
        api.query.session
            ? api.query.session.validators()
            : of([]),
        api.query.staking
            ? api.derive.staking.nextElected()
            : of([])
    ]).pipe(map(([validators, nextElected]) => ({
        nextElected: nextElected.length
            ? nextElected
            : validators,
        validators
    }))));
}

const DEFAULT_FLAGS = { withController: true, withPrefs: true };
/**
 * @name waitingInfo
 * @param {StakingQueryFlags} flags? (Optional) Query flags to filter the staking data.
 * @description Staking candidates who are waiting to become validators.
 * @example
 * ```javascript
 * const { waiting, info } = await api.derive.staking.waitingInfo();
 * console.log(
 *   "Waiting Candidates:",
 *   waiting.map((acc) => acc.toString())
 * );
 * ```
 */
function waitingInfo(instanceId, api) {
    return memo(instanceId, (flags = DEFAULT_FLAGS) => combineLatest([
        api.derive.staking.validators(),
        api.derive.staking.stashes()
    ]).pipe(switchMap(([{ nextElected }, stashes]) => {
        const elected = nextElected.map((a) => a.toString());
        const waiting = stashes.filter((v) => !elected.includes(v.toString()));
        return api.derive.staking.queryMulti(waiting, flags).pipe(map((info) => ({
            info,
            waiting
        })));
    })));
}

var staking = /*#__PURE__*/Object.freeze({
	__proto__: null,
	_eraExposure: _eraExposure,
	_eraPrefs: _eraPrefs,
	_eraSlashes: _eraSlashes,
	_erasExposure: _erasExposure,
	_erasPoints: _erasPoints,
	_erasPrefs: _erasPrefs,
	_erasRewards: _erasRewards,
	_erasSlashes: _erasSlashes,
	_ownExposures: _ownExposures,
	_ownSlashes: _ownSlashes,
	_stakerExposures: _stakerExposures,
	_stakerPoints: _stakerPoints,
	_stakerPrefs: _stakerPrefs,
	_stakerRewards: _stakerRewards,
	_stakerRewardsEras: _stakerRewardsEras,
	_stakerSlashes: _stakerSlashes,
	account: account,
	accounts: accounts,
	currentPoints: currentPoints,
	electedInfo: electedInfo,
	eraExposure: eraExposure,
	eraPrefs: eraPrefs,
	eraSlashes: eraSlashes,
	erasExposure: erasExposure,
	erasHistoric: erasHistoric,
	erasPoints: erasPoints,
	erasPrefs: erasPrefs,
	erasRewards: erasRewards,
	erasSlashes: erasSlashes,
	keys: keys,
	keysMulti: keysMulti,
	nextElected: nextElected,
	overview: overview,
	ownExposure: ownExposure,
	ownExposures: ownExposures,
	ownSlash: ownSlash,
	ownSlashes: ownSlashes,
	query: query,
	queryMulti: queryMulti,
	stakerExposure: stakerExposure,
	stakerExposures: stakerExposures,
	stakerPoints: stakerPoints,
	stakerPrefs: stakerPrefs,
	stakerRewards: stakerRewards,
	stakerRewardsMulti: stakerRewardsMulti,
	stakerRewardsMultiEras: stakerRewardsMultiEras,
	stakerSlashes: stakerSlashes,
	stashes: stashes,
	validators: validators,
	waitingInfo: waitingInfo
});

/**
 * @name members
 * @description Retrieves the list of members in the "technicalCommittee" collective.
 * @example
 * ```javascript
 * const members = await api.derive.technicalCommittee.members();
 * console.log(`Members: ${JSON.stringify(members)});
 * ```
 */
const members = /*#__PURE__*/ members$5('technicalCommittee');
/**
 * @name hasProposals
 * @description Checks if there are any active proposals in the "technicalCommittee" collective.
 * @example
 * ```javascript
 * const exists = await api.derive.technicalCommittee.hasProposals();
 * console.log(exists);
 * ```
 */
const hasProposals = /*#__PURE__*/ hasProposals$4('technicalCommittee');
/**
 * @name proposal
 * @description Retrieves details of a specific proposal in the "technicalCommitteeMotion" collective by its hash.
 * @example
 * ```javascript
 * const proposalDetails = await api.derive.technicalCommittee.proposal(PROPOSAL_HASH);
 * console.log(proposalDetails);
 * ```
 */
const proposal = /*#__PURE__*/ proposal$4('technicalCommittee');
/**
 * @name proposalCount
 * @description Retrieves the total number of proposals in the "technicalCommittee" collective.
 * @example
 * ```javascript
 * const count = await api.derive.technicalCommittee.proposalCount();
 * console.log(`Amount of proposals: ${count}`);
 * ```
 */
const proposalCount = /*#__PURE__*/ proposalCount$4('technicalCommittee');
/**
 * @name proposalHashes
 * @description Retrieves an array of hashes for all active proposals in the "technicalCommittee" collective.
 * @example
 * ```javascript
 * const hashes = await api.derive.technicalCommittee.proposalHashes();
 * console.log(`Proposals ${JSON.stringify(hashes)}`);
 * ```
 */
const proposalHashes = /*#__PURE__*/ proposalHashes$4('technicalCommittee');
/**
 * @name proposals
 * @description Retrieves a list of all active proposals in the "technicalCommittee" collective.
 * @example
 * ```javascript
 * const proposals = await api.derive.technicalCommittee.proposals();
 * console.log(proposals);
 * ```
 */
const proposals$1 = /*#__PURE__*/ proposals$6('technicalCommittee');
/**
 * @name prime
 * @description Retrieves the prime member of the "technicalCommittee" collective, if one exists.
 * @example
 * ```javascript
 * const primeMember = await api.derive.technicalCommittee.prime();
 * console.log(primeMember);
 * ```
 */
const prime = /*#__PURE__*/ prime$4('technicalCommittee');

var technicalCommittee = /*#__PURE__*/Object.freeze({
	__proto__: null,
	hasProposals: hasProposals,
	members: members,
	prime: prime,
	proposal: proposal,
	proposalCount: proposalCount,
	proposalHashes: proposalHashes,
	proposals: proposals$1
});

function parseResult(api, { allIds, allProposals, approvalIds, councilProposals, proposalCount }) {
    const approvals = [];
    const proposals = [];
    const councilTreasury = councilProposals.filter(({ proposal }) => 
    // FIXME `approveProposal` and `rejectProposal` have been removed in substrate and released in 1.14
    // in favor of `spend`. See: https://github.com/paritytech/polkadot-sdk/pull/3820
    proposal && ((api.tx.treasury['approveProposal'] && api.tx.treasury['approveProposal'].is(proposal)) ||
        (api.tx.treasury['rejectProposal'] && api.tx.treasury['rejectProposal'].is(proposal))));
    allIds.forEach((id, index) => {
        if (allProposals[index].isSome) {
            const council = councilTreasury
                .filter(({ proposal }) => proposal && id.eq(proposal.args[0]))
                .sort((a, b) => a.proposal && b.proposal
                ? a.proposal.method.localeCompare(b.proposal.method)
                : a.proposal
                    ? -1
                    : 1);
            const isApproval = approvalIds.some((approvalId) => approvalId.eq(id));
            const derived = { council, id, proposal: allProposals[index].unwrap() };
            if (isApproval) {
                approvals.push(derived);
            }
            else {
                proposals.push(derived);
            }
        }
    });
    return { approvals, proposalCount, proposals };
}
function retrieveProposals(api, proposalCount, approvalIds) {
    const proposalIds = [];
    const count = proposalCount.toNumber();
    for (let index = 0; index < count; index++) {
        if (!approvalIds.some((id) => id.eqn(index))) {
            proposalIds.push(api.registry.createType('ProposalIndex', index));
        }
    }
    const allIds = [...proposalIds, ...approvalIds];
    return combineLatest([
        api.query.treasury.proposals.multi(allIds),
        api.derive.council
            ? api.derive.council.proposals()
            : of([])
    ]).pipe(map(([allProposals, councilProposals]) => parseResult(api, { allIds, allProposals, approvalIds, councilProposals, proposalCount })));
}
/**
 * @name proposals
 * @description Retrieve all active and approved treasury proposals, along with their info.
 * @example
 * ```javascript
 * const treasuryProposals = await api.derive.treasury.proposals();
 * console.log(treasuryProposals);
 * ```
 */
function proposals(instanceId, api) {
    return memo(instanceId, () => api.query.treasury
        ? combineLatest([
            api.query.treasury.proposalCount(),
            api.query.treasury.approvals()
        ]).pipe(switchMap(([proposalCount, approvalIds]) => retrieveProposals(api, proposalCount, approvalIds)))
        : of({
            approvals: [],
            proposalCount: api.registry.createType('ProposalIndex'),
            proposals: []
        }));
}

var treasury = /*#__PURE__*/Object.freeze({
	__proto__: null,
	proposals: proposals
});

/**
 * @name events
 * @param {Hash} at Block hash to query at.
 * @description Retrieves the block information alongside its events at a given block hash
 * @example
 * ```javascript
 * const blockHash = api.registry.createType(
 *   "Hash",
 *   "0xf1dc2efe8265be67deea5e91b05a98a7f9f81f66854e92825cf36f541beb7af6"
 * );
 * const { events, block } = await api.derive.tx.events(blockHash);
 * ```
 */
function events(instanceId, api) {
    return memo(instanceId, (blockHash) => combineLatest([
        api.rpc.chain.getBlock(blockHash),
        api.queryAt(blockHash).pipe(switchMap((queryAt) => queryAt.system.events()))
    ]).pipe(map(([block, events]) => ({ block, events }))));
}

/**
 * @name extrinsicInfo
 * @param { Hash } at The block hash to query at.
 * @param { Uint8Array | string } transactionHash A transaction hash as U8 array or string.
 * @description Retrieves the extrinsic information and its events.
 * @example
 * ```javascript
 * const blockHash = api.registry.createType(
 *   'Hash',
 *   '0xb772e4949d2f3eb5ba356aa43f885cc4f9097ee9812c5436543f3846a0491729'
 * );
 * const extrinsicInfo = await api.derive.tx.extrinsicInfo(
 *   blockHash,
 *   '0xcd96520b05e0c4648ea365f3f063f27c5cdd8be10d41a1c44566428c91f37dcb'
 * );
 *
 * console.log(extrinsicInfo.extrinsic.toHuman());
 * ```
 */
function extrinsicInfo(instanceId, api) {
    return memo(instanceId, (at, transactionHash) => {
        return api.derive.tx.events(at).pipe(map(({ block, events }) => {
            const index = block.block.extrinsics.findIndex((ext) => ext.hash.toString() === transactionHash);
            if (index === -1) {
                return null;
            }
            const extEvents = events.filter(({ phase }) => phase.isApplyExtrinsic && phase.asApplyExtrinsic.eq(index));
            return {
                blockHash: block.hash.toHex(),
                blockNumber: block.block.header.number.toNumber(),
                events: extEvents,
                extrinsic: block.block.extrinsics[index],
                success: (extEvents.findIndex((ev) => ev.event.method === 'ExtrinsicSuccess') !== -1)
            };
        }));
    });
}
/**
 * @name accountExtrinsics
 * @description Retrieves information about every extrinsic submitted by an account at a given block.
 * @param { Hash } at The block hash to query at.
 * @param { Uint8Array | strings } accountId The account identifier to query.
 * @example
 * ```javascript
   const blockHash = api.registry.createType(
    'Hash',
    '0xb772e4949d2f3eb5ba356aa43f885cc4f9097ee9812c5436543f3846a0491729'
  );
  const extrinsicsInfo = await api.derive.tx.accountExtrinsics(
    blockHash,
    '0x21895DdfD4640b4e0aDCa2865b907f2CE6e6B777'
  );

  console.log(extrinsicsInfo.extrinsics[0]).extrinsic.toHuman();
 * ```
 */
function accountExtrinsics(instanceId, api) {
    return memo(instanceId, (at, accountId) => {
        return api.derive.tx.events(at).pipe(map(({ block, events }) => {
            const indexes = [];
            return {
                blockHash: block.hash.toHex(),
                blockNumber: block.block.header.number.toNumber(),
                extrinsics: block.block.extrinsics.filter((ext, index) => {
                    if (ext.signer.toString() === accountId) {
                        indexes.push(index);
                        return true;
                    }
                    return false;
                }).map((ext, i) => {
                    const extEvents = events.filter(({ phase }) => phase.isApplyExtrinsic && phase.asApplyExtrinsic.eq(indexes[i]));
                    return {
                        events: extEvents,
                        extrinsic: ext,
                        success: (extEvents.findIndex((ev) => ev.event.method === 'ExtrinsicSuccess') !== -1)
                    };
                })
            };
        }));
    });
}

const FALLBACK_MAX_HASH_COUNT = 250;
const FALLBACK_PERIOD = new BN(6 * 1000);
const MAX_FINALITY_LAG = new BN(5);
const MORTAL_PERIOD = new BN(5 * 60 * 1000);

function latestNonce(api, address) {
    return api.derive.balances.account(address).pipe(map(({ accountNonce }) => accountNonce));
}
function nextNonce(api, address) {
    if (api.call.accountNonceApi) {
        return api.call.accountNonceApi.accountNonce(address);
    }
    else {
        return api.rpc.system?.accountNextIndex
            ? api.rpc.system.accountNextIndex(address)
            : latestNonce(api, address);
    }
}
function signingHeader(api) {
    return combineLatest([
        api.rpc.chain.getHeader().pipe(switchMap((header) => 
        // check for chains at genesis (until block 1 is produced, e.g. 6s), since
        // we do need to allow transactions at chain start (also dev/seal chains)
        header.parentHash.isEmpty
            ? of(header)
            // in the case of the current block, we use the parent to minimize the
            // impact of forks on the system, but not completely remove it
            : api.rpc.chain.getHeader(header.parentHash).pipe(catchError(() => of(header))))),
        api.rpc.chain.getFinalizedHead().pipe(switchMap((hash) => api.rpc.chain.getHeader(hash).pipe(catchError(() => of(null)))))
    ]).pipe(map(([current, finalized]) => 
    // determine the hash to use, current when lag > max, else finalized
    !finalized || unwrapBlockNumber(current).sub(unwrapBlockNumber(finalized)).gt(MAX_FINALITY_LAG)
        ? current
        : finalized));
}
function babeOrAuraPeriod(api) {
    const period = api.consts.babe?.expectedBlockTime ||
        // this will be present ones https://github.com/paritytech/polkadot-sdk/pull/3732 is merged
        // eslint-disable-next-line
        api.consts['aura']?.['slotDuration'] ||
        api.consts.timestamp?.minimumPeriod.muln(2);
    return period && period.isZero && !period.isZero() ? period : undefined;
}
/**
 * @name signingInfo
 * @description Retrieves signing-related information for an account, including the nonce, block header, and mortal length.
 * @param {string} address The account address for which signing information is needed.
 * @param { BN | bigint | Uint8Array | number | string } nonce? (Optional) The nonce to use. If `undefined`, the latest nonce is retrieved.
 * @param { IExtrinsicEra | number } era? (Optional) The transaction era.
 * @example
 * ```javascript
 * const info = await api.derive.tx.signingInfo(
 *   "14mM9FRDDtwSYicjNxSvMfQkap8o4m9zHq7hNW4JpbSL4PPU"
 * );
 * console.log(info);
 * ```
 */
function signingInfo(_instanceId, api) {
    // no memo, we want to do this fresh on each run
    return (address, nonce, era) => combineLatest([
        // retrieve nonce if none was specified
        isUndefined(nonce)
            ? latestNonce(api, address)
            : nonce === -1
                ? nextNonce(api, address)
                : of(api.registry.createType('Index', nonce)),
        // if no era (create) or era > 0 (mortal), do block retrieval
        (isUndefined(era) || (isNumber(era) && era > 0))
            ? signingHeader(api)
            : of(null)
    ]).pipe(map(([nonce, header]) => ({
        header,
        mortalLength: Math.min(api.consts.system?.blockHashCount?.toNumber() || FALLBACK_MAX_HASH_COUNT, MORTAL_PERIOD
            .div(babeOrAuraPeriod(api) || FALLBACK_PERIOD)
            .iadd(MAX_FINALITY_LAG)
            .toNumber()),
        nonce
    })));
}

var tx = /*#__PURE__*/Object.freeze({
	__proto__: null,
	accountExtrinsics: accountExtrinsics,
	events: events,
	extrinsicInfo: extrinsicInfo,
	signingInfo: signingInfo
});

const derive = { accounts: accounts$1, alliance, bagsList, balances, bounties, chain, contracts, council, crowdloan, democracy, elections, imOnline, membership, parachains, session, society, staking, technicalCommittee, treasury, tx };

const checks = {
    allianceMotion: {
        instances: ['allianceMotion'],
        methods: []
    },
    bagsList: {
        instances: ['voterBagsList', 'voterList', 'bagsList'],
        methods: [],
        withDetect: true
    },
    contracts: {
        instances: ['contracts'],
        methods: []
    },
    council: {
        instances: ['council'],
        methods: [],
        withDetect: true
    },
    crowdloan: {
        instances: ['crowdloan'],
        methods: []
    },
    democracy: {
        instances: ['democracy'],
        methods: []
    },
    elections: {
        instances: ['phragmenElection', 'electionsPhragmen', 'elections', 'council'],
        methods: [],
        withDetect: true
    },
    imOnline: {
        instances: ['imOnline'],
        methods: []
    },
    membership: {
        instances: ['membership'],
        methods: []
    },
    parachains: {
        instances: ['parachains', 'registrar'],
        methods: []
    },
    session: {
        instances: ['session'],
        methods: []
    },
    society: {
        instances: ['society'],
        methods: []
    },
    staking: {
        instances: ['staking'],
        methods: ['erasRewardPoints']
    },
    technicalCommittee: {
        instances: ['technicalCommittee'],
        methods: [],
        withDetect: true
    },
    treasury: {
        instances: ['treasury'],
        methods: []
    }
};
function getModuleInstances(api, specName, moduleName) {
    return api.registry.getModuleInstances(specName, moduleName) || [];
}
/**
 * Returns an object that will inject `api` into all the functions inside
 * `allSections`, and keep the object architecture of `allSections`.
 */
/** @internal */
function injectFunctions(instanceId, api, derives) {
    const result = {};
    const names = Object.keys(derives);
    const keys = Object.keys(api.query);
    const specName = api.runtimeVersion.specName;
    const filterKeys = (q) => keys.includes(q);
    const filterInstances = (q) => getModuleInstances(api, specName, q).some(filterKeys);
    const filterMethods = (all) => (m) => all.some((q) => keys.includes(q) && api.query[q][m]);
    const getKeys = (s) => Object.keys(derives[s]);
    const creator = (s, m) => derives[s][m](instanceId, api);
    const isIncluded = (c) => (!checks[c] || ((checks[c].instances.some(filterKeys) && (!checks[c].methods.length ||
        checks[c].methods.every(filterMethods(checks[c].instances)))) ||
        (checks[c].withDetect &&
            checks[c].instances.some(filterInstances))));
    for (let i = 0, count = names.length; i < count; i++) {
        const name = names[i];
        isIncluded(name) &&
            lazyDeriveSection(result, name, getKeys, creator);
    }
    return result;
}
/** @internal */
function getAvailableDerives(instanceId, api, custom = {}) {
    return {
        ...injectFunctions(instanceId, api, derive),
        ...injectFunctions(instanceId, api, custom)
    };
}

/**
 * This is a section decorator which keeps all type information.
 */
function decorateDeriveSections(decorateMethod, derives) {
    const getKeys = (s) => Object.keys(derives[s]);
    const creator = (s, m) => decorateMethod(derives[s][m]);
    const result = {};
    const names = Object.keys(derives);
    for (let i = 0, count = names.length; i < count; i++) {
        lazyDeriveSection(result, names[i], getKeys, creator);
    }
    return result;
}

const recordIdentity = (record) => record;
function filterAndApply(events, section, methods, onFound) {
    return events
        .filter(({ event }) => section === event.section &&
        methods.includes(event.method))
        .map((record) => onFound(record));
}
function getDispatchError({ event: { data: [dispatchError] } }) {
    return dispatchError;
}
function getDispatchInfo({ event: { data, method } }) {
    return method === 'ExtrinsicSuccess'
        ? data[0]
        : data[1];
}
function extractError(events = []) {
    return filterAndApply(events, 'system', ['ExtrinsicFailed'], getDispatchError)[0];
}
function extractInfo(events = []) {
    return filterAndApply(events, 'system', ['ExtrinsicFailed', 'ExtrinsicSuccess'], getDispatchInfo)[0];
}
class SubmittableResult {
    dispatchError;
    dispatchInfo;
    internalError;
    events;
    status;
    txHash;
    txIndex;
    blockNumber;
    constructor({ blockNumber, dispatchError, dispatchInfo, events, internalError, status, txHash, txIndex }) {
        this.dispatchError = dispatchError || extractError(events);
        this.dispatchInfo = dispatchInfo || extractInfo(events);
        this.events = events || [];
        this.internalError = internalError;
        this.status = status;
        this.txHash = txHash;
        this.txIndex = txIndex;
        this.blockNumber = blockNumber;
    }
    get isCompleted() {
        return this.isError || this.status.isInBlock || this.status.isFinalized;
    }
    get isError() {
        return this.status.isDropped || this.status.isFinalityTimeout || this.status.isInvalid || this.status.isUsurped;
    }
    get isFinalized() {
        return this.status.isFinalized;
    }
    get isInBlock() {
        return this.status.isInBlock;
    }
    get isWarning() {
        return this.status.isRetracted;
    }
    /**
     * @description Filters EventRecords for the specified method & section (there could be multiple)
     */
    filterRecords(section, method) {
        return filterAndApply(this.events, section, Array.isArray(method) ? method : [method], recordIdentity);
    }
    /**
     * @description Finds an EventRecord for the specified method & section
     */
    findRecord(section, method) {
        return this.filterRecords(section, method)[0];
    }
    /**
     * @description Creates a human representation of the output
     */
    toHuman(isExtended) {
        return {
            dispatchError: this.dispatchError?.toHuman(),
            dispatchInfo: this.dispatchInfo?.toHuman(),
            events: this.events.map((e) => e.toHuman(isExtended)),
            internalError: this.internalError?.message.toString(),
            status: this.status.toHuman(isExtended)
        };
    }
}

function makeEraOptions(api, registry, partialOptions, { header, mortalLength, nonce }) {
    if (!header) {
        if (partialOptions.era && !partialOptions.blockHash) {
            throw new Error('Expected blockHash to be passed alongside non-immortal era options');
        }
        if (isNumber(partialOptions.era)) {
            // since we have no header, it is immortal, remove any option overrides
            // so we only supply the genesisHash and no era to the construction
            delete partialOptions.era;
            delete partialOptions.blockHash;
        }
        return makeSignOptions(api, partialOptions, { nonce });
    }
    return makeSignOptions(api, partialOptions, {
        blockHash: header.hash,
        era: registry.createTypeUnsafe('ExtrinsicEra', [{
                current: header.number,
                period: partialOptions.era || mortalLength
            }]),
        nonce
    });
}
function makeSignAndSendOptions(partialOptions, statusCb) {
    let options = {};
    if (isFunction$1(partialOptions)) {
        statusCb = partialOptions;
    }
    else {
        options = objectSpread({}, partialOptions);
    }
    return [options, statusCb];
}
function makeSignOptions(api, partialOptions, extras) {
    return objectSpread({ blockHash: api.genesisHash, genesisHash: api.genesisHash }, partialOptions, extras, { runtimeVersion: api.runtimeVersion, signedExtensions: api.registry.signedExtensions, version: api.extrinsicType });
}
function optionsOrNonce(partialOptions = {}) {
    return isBn(partialOptions) || isNumber(partialOptions)
        ? { nonce: partialOptions }
        : partialOptions;
}
function createClass({ api, apiType, blockHash, decorateMethod }) {
    // an instance of the base extrinsic for us to extend
    const ExtrinsicBase = api.registry.createClass('Extrinsic');
    const extrinsicInfoMap = new WeakMap();
    class Submittable extends ExtrinsicBase {
        #ignoreStatusCb;
        #transformResult = (identity$2);
        constructor(registry, extrinsic) {
            super(registry, extrinsic, { version: api.extrinsicType });
            this.#ignoreStatusCb = apiType === 'rxjs';
        }
        get hasDryRun() {
            return isFunction$1(api.rpc.system?.dryRun);
        }
        get hasPaymentInfo() {
            return isFunction$1(api.call.transactionPaymentApi?.queryInfo);
        }
        // dry run an extrinsic
        dryRun(account, optionsOrHash) {
            if (!this.hasDryRun) {
                throw new Error('The system.dryRun RPC call is not available in your environment');
            }
            if (blockHash || isString(optionsOrHash) || isU8a(optionsOrHash)) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return decorateMethod(() => api.rpc.system.dryRun(this.toHex(), blockHash || optionsOrHash));
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-call
            return decorateMethod(() => this.#observeSign(account, optionsOrHash).pipe(switchMap(() => api.rpc.system.dryRun(this.toHex()))))();
        }
        // calculate the payment info for this transaction (if signed and submitted)
        paymentInfo(account, optionsOrHash) {
            if (!this.hasPaymentInfo) {
                throw new Error('The transactionPaymentApi.queryInfo runtime call is not available in your environment');
            }
            if (blockHash || isString(optionsOrHash) || isU8a(optionsOrHash)) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return decorateMethod(() => api.callAt(blockHash || optionsOrHash).pipe(switchMap((callAt) => {
                    const u8a = this.toU8a();
                    return callAt.transactionPaymentApi.queryInfo(u8a, u8a.length);
                })));
            }
            const [allOptions] = makeSignAndSendOptions(optionsOrHash);
            const address = isKeyringPair(account) ? account.address : account.toString();
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-call
            return decorateMethod(() => api.derive.tx.signingInfo(address, allOptions.nonce, allOptions.era).pipe(first(), switchMap((signingInfo) => {
                // setup our options (same way as in signAndSend)
                const eraOptions = makeEraOptions(api, this.registry, allOptions, signingInfo);
                const signOptions = makeSignOptions(api, eraOptions, {});
                // 1. Don't use the internal objects inside the new tx (hence toU8a)
                // 2. Don't override the data from existing signed extrinsics
                // 3. Ensure that this object stays intact, with no new sign after operation
                const u8a = api.tx(this.toU8a()).signFake(address, signOptions).toU8a();
                return api.call.transactionPaymentApi.queryInfo(u8a, u8a.length);
            })))();
        }
        // send implementation for both immediate Hash and statusCb variants
        send(statusCb) {
            const isSubscription = api.hasSubscriptions && (this.#ignoreStatusCb || !!statusCb);
            const updatedInfo = extrinsicInfoMap.get(this);
            extrinsicInfoMap.delete(this);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-call
            return decorateMethod(isSubscription
                ? () => this.#observeSubscribe(updatedInfo)
                : () => this.#observeSend(updatedInfo))(statusCb);
        }
        /**
         * @description Signs a transaction, returning `this` to allow chaining. E.g.: `signAsync(...).send()`. Like `.signAndSend` this will retrieve the nonce and blockHash to send the tx with.
        */
        signAsync(account, partialOptions) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-call
            return decorateMethod(() => this.#observeSign(account, partialOptions).pipe(map((info) => {
                // If we got a full signed transaction from the signer, attach it
                if (info.signedTransaction) {
                    const extrinsic = new Submittable(api.registry, info.signedTransaction);
                    extrinsicInfoMap.set(this, info);
                    return extrinsic;
                }
                // Fallback if signer didn’t return signedTransaction
                return this;
            })))();
        }
        // signAndSend implementation for all 3 cases above
        signAndSend(account, partialOptions, optionalStatusCb) {
            const [options, statusCb] = makeSignAndSendOptions(partialOptions, optionalStatusCb);
            const isSubscription = api.hasSubscriptions && (this.#ignoreStatusCb || !!statusCb);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-call
            return decorateMethod(() => this.#observeSign(account, options).pipe(switchMap((info) => isSubscription
                ? this.#observeSubscribe(info)
                : this.#observeSend(info))) // FIXME This is wrong, SubmittableResult is _not_ a codec
            )(statusCb);
        }
        // adds a transform to the result, applied before result is returned
        withResultTransform(transform) {
            this.#transformResult = transform;
            return this;
        }
        #observeSign = (account, partialOptions) => {
            const address = isKeyringPair(account) ? account.address : account.toString();
            const options = optionsOrNonce(partialOptions);
            return api.derive.tx.signingInfo(address, options.nonce, options.era).pipe(first(), mergeMap(async (signingInfo) => {
                const eraOptions = makeEraOptions(api, this.registry, options, signingInfo);
                let updateId = -1;
                let signedTx = null;
                if (isKeyringPair(account)) {
                    this.sign(account, eraOptions);
                }
                else {
                    const result = await this.#signViaSigner(address, eraOptions, signingInfo.header);
                    updateId = result.id;
                    if (result.signedTransaction) {
                        signedTx = result.signedTransaction;
                    }
                }
                return { options: eraOptions, signedTransaction: signedTx, updateId };
            }));
        };
        #observeStatus = (txHash, status) => {
            if (!status.isFinalized && !status.isInBlock) {
                return of(this.#transformResult(new SubmittableResult({
                    status,
                    txHash
                })));
            }
            const blockHash = status.isInBlock
                ? status.asInBlock
                : status.asFinalized;
            return api.derive.tx.events(blockHash).pipe(map(({ block, events }) => this.#transformResult(new SubmittableResult({
                ...filterEvents(txHash, block, events, status),
                status,
                txHash
            }))), catchError((internalError) => of(this.#transformResult(new SubmittableResult({
                internalError,
                status,
                txHash
            })))));
        };
        #observeSend = (info) => {
            return api.rpc.author.submitExtrinsic(info?.signedTransaction || this).pipe(tap((hash) => {
                this.#updateSigner(hash, info);
            }));
        };
        #observeSubscribe = (info) => {
            const txHash = this.hash;
            return api.rpc.author.submitAndWatchExtrinsic(info?.signedTransaction || this).pipe(switchMap((status) => this.#observeStatus(txHash, status)), tap((status) => {
                this.#updateSigner(status, info);
            }));
        };
        #signViaSigner = async (address, options, header) => {
            const signer = options.signer || api.signer;
            const allowCallDataAlteration = options.allowCallDataAlteration ?? true;
            if (!signer) {
                throw new Error('No signer specified, either via api.setSigner or via sign options. You possibly need to pass through an explicit keypair for the origin so it can be used for signing.');
            }
            const payload = this.registry.createTypeUnsafe('SignerPayload', [objectSpread({}, options, {
                    address,
                    blockNumber: header ? header.number : 0,
                    method: this.method
                })]);
            let result;
            if (isFunction$1(signer.signPayload)) {
                result = await signer.signPayload(payload.toPayload());
                if (result.signedTransaction && !options.withSignedTransaction) {
                    throw new Error('The `signedTransaction` field may not be submitted when `withSignedTransaction` is disabled');
                }
                if (result.signedTransaction && options.withSignedTransaction) {
                    const ext = this.registry.createTypeUnsafe('Extrinsic', [result.signedTransaction]);
                    const newSignerPayload = this.registry.createTypeUnsafe('SignerPayload', [objectSpread({}, {
                            address,
                            assetId: ext.assetId && ext.assetId.isSome ? ext.assetId.toHex() : null,
                            blockHash: payload.blockHash,
                            blockNumber: header ? header.number : 0,
                            era: ext.era.toHex(),
                            genesisHash: payload.genesisHash,
                            metadataHash: ext.metadataHash ? ext.metadataHash.toHex() : null,
                            method: ext.method.toHex(),
                            mode: ext.mode ? ext.mode.toHex() : null,
                            nonce: ext.nonce.toHex(),
                            runtimeVersion: payload.runtimeVersion,
                            signedExtensions: payload.signedExtensions,
                            tip: ext.tip ? ext.tip.toHex() : null,
                            version: payload.version
                        })]);
                    if (!ext.isSigned) {
                        throw new Error(`When using the signedTransaction field, the transaction must be signed. Recieved isSigned: ${ext.isSigned}`);
                    }
                    if (!allowCallDataAlteration) {
                        this.#validateSignedTransaction(payload, ext);
                    }
                    // This is only used for signAsync - signAndSend does not need to adjust the super payload or
                    // add the signature.
                    super.addSignature(address, result.signature, newSignerPayload.toPayload());
                    return { id: result.id, signedTransaction: result.signedTransaction };
                }
            }
            else if (isFunction$1(signer.signRaw)) {
                result = await signer.signRaw(payload.toRaw());
            }
            else {
                throw new Error('Invalid signer interface, it should implement either signPayload or signRaw (or both)');
            }
            // Here we explicitly call `toPayload()` again instead of working with an object
            // (reference) as passed to the signer. This means that we are sure that the
            // payload data is not modified from our inputs, but the signer
            super.addSignature(address, result.signature, payload.toPayload());
            return { id: result.id };
        };
        #updateSigner = (status, info) => {
            if (info && (info.updateId !== -1)) {
                const { options, updateId } = info;
                const signer = options.signer || api.signer;
                if (signer && isFunction$1(signer.update)) {
                    signer.update(updateId, status);
                }
            }
        };
        /**
         * When a signer includes `signedTransaction` within the SignerResult this will validate
         * specific fields within the signed extrinsic against the original payload that was passed
         * to the signer.
         */
        #validateSignedTransaction = (signerPayload, signedExt) => {
            const payload = signerPayload.toPayload();
            const errMsg = (field) => `signAndSend: ${field} does not match the original payload`;
            if (payload.method !== signedExt.method.toHex()) {
                throw new Error(errMsg('call data'));
            }
        };
    }
    return Submittable;
}

function createSubmittable(apiType, api, decorateMethod, registry, blockHash) {
    const Submittable = createClass({ api, apiType, blockHash, decorateMethod });
    return (extrinsic) => new Submittable(registry || api.registry, extrinsic);
}

function findCall(registry, callIndex) {
    return registry.findMetaCall(u8aToU8a(callIndex));
}
function findError(registry, errorIndex) {
    return registry.findMetaError(u8aToU8a(errorIndex));
}

const typesChain = {};

const sharedTypes$7 = {
    // Anchor
    AnchorData: {
        anchoredBlock: 'u64',
        docRoot: 'H256',
        id: 'H256'
    },
    DispatchErrorModule: 'DispatchErrorModuleU8',
    PreCommitData: {
        expirationBlock: 'u64',
        identity: 'H256',
        signingRoot: 'H256'
    },
    // Fees
    Fee: {
        key: 'Hash',
        price: 'Balance'
    },
    // MultiAccount
    MultiAccountData: {
        deposit: 'Balance',
        depositor: 'AccountId',
        signatories: 'Vec<AccountId>',
        threshold: 'u16'
    },
    // Bridge
    ChainId: 'u8',
    DepositNonce: 'u64',
    ResourceId: '[u8; 32]',
    'chainbridge::ChainId': 'u8',
    // NFT
    RegistryId: 'H160',
    TokenId: 'U256',
    AssetId: {
        registryId: 'RegistryId',
        tokenId: 'TokenId'
    },
    AssetInfo: {
        metadata: 'Bytes'
    },
    MintInfo: {
        anchorId: 'Hash',
        proofs: 'Vec<ProofMint>',
        staticHashes: '[Hash; 3]'
    },
    Proof: {
        leafHash: 'H256',
        sortedHashes: 'H256'
    },
    ProofMint: {
        hashes: 'Vec<Hash>',
        property: 'Bytes',
        salt: '[u8; 32]',
        value: 'Bytes'
    },
    RegistryInfo: {
        fields: 'Vec<Bytes>',
        ownerCanBurn: 'bool'
    },
    ProxyType: {
        _enum: [
            'Any',
            'NonTransfer',
            'Governance',
            'Staking',
            'NonProxy'
        ]
    }
};
const standaloneTypes = {
    ...sharedTypes$7,
    AccountInfo: 'AccountInfoWithRefCount',
    Address: 'LookupSource',
    LookupSource: 'IndicesLookupSource',
    Multiplier: 'Fixed64',
    RefCount: 'RefCountTo259'
};
const versioned$a = [
    {
        minmax: [240, 243],
        types: {
            ...standaloneTypes,
            ProxyType: {
                _enum: [
                    'Any',
                    'NonTransfer',
                    'Governance',
                    'Staking',
                    'Vesting'
                ]
            }
        }
    },
    {
        minmax: [244, 999],
        types: { ...standaloneTypes }
    },
    {
        minmax: [1000, undefined],
        types: { ...sharedTypes$7 }
    }
];

const sharedTypes$6 = {
    CompactAssignments: 'CompactAssignmentsWith24',
    DispatchErrorModule: 'DispatchErrorModuleU8',
    RawSolution: 'RawSolutionWith24',
    Keys: 'SessionKeys6',
    ProxyType: {
        _enum: ['Any', 'NonTransfer', 'Governance', 'Staking', 'IdentityJudgement', 'CancelProxy', 'Auction']
    },
    Weight: 'WeightV1'
};
const addrIndicesTypes = {
    AccountInfo: 'AccountInfoWithRefCount',
    Address: 'LookupSource',
    CompactAssignments: 'CompactAssignmentsWith16',
    DispatchErrorModule: 'DispatchErrorModuleU8',
    RawSolution: 'RawSolutionWith16',
    Keys: 'SessionKeys5',
    LookupSource: 'IndicesLookupSource',
    ValidatorPrefs: 'ValidatorPrefsWithCommission'
};
const addrAccountIdTypes$2 = {
    AccountInfo: 'AccountInfoWithRefCount',
    Address: 'AccountId',
    CompactAssignments: 'CompactAssignmentsWith16',
    DispatchErrorModule: 'DispatchErrorModuleU8',
    RawSolution: 'RawSolutionWith16',
    Keys: 'SessionKeys5',
    LookupSource: 'AccountId',
    ValidatorPrefs: 'ValidatorPrefsWithCommission'
};
const versioned$9 = [
    {
        // 1020 is first CC3
        minmax: [1019, 1031],
        types: {
            ...addrIndicesTypes,
            BalanceLock: 'BalanceLockTo212',
            CompactAssignments: 'CompactAssignmentsTo257',
            DispatchError: 'DispatchErrorTo198',
            DispatchInfo: 'DispatchInfoTo244',
            Heartbeat: 'HeartbeatTo244',
            IdentityInfo: 'IdentityInfoTo198',
            Keys: 'SessionKeys5',
            Multiplier: 'Fixed64',
            OpenTip: 'OpenTipTo225',
            RefCount: 'RefCountTo259',
            ReferendumInfo: 'ReferendumInfoTo239',
            Scheduled: 'ScheduledTo254',
            SlashingSpans: 'SlashingSpansTo204',
            StakingLedger: 'StakingLedgerTo223',
            Votes: 'VotesTo230',
            Weight: 'u32'
        }
    },
    {
        minmax: [1032, 1042],
        types: {
            ...addrIndicesTypes,
            BalanceLock: 'BalanceLockTo212',
            CompactAssignments: 'CompactAssignmentsTo257',
            DispatchInfo: 'DispatchInfoTo244',
            Heartbeat: 'HeartbeatTo244',
            Keys: 'SessionKeys5',
            Multiplier: 'Fixed64',
            OpenTip: 'OpenTipTo225',
            RefCount: 'RefCountTo259',
            ReferendumInfo: 'ReferendumInfoTo239',
            Scheduled: 'ScheduledTo254',
            SlashingSpans: 'SlashingSpansTo204',
            StakingLedger: 'StakingLedgerTo223',
            Votes: 'VotesTo230',
            Weight: 'u32'
        }
    },
    {
        // actual at 1045 (1043-1044 is dev)
        minmax: [1043, 1045],
        types: {
            ...addrIndicesTypes,
            BalanceLock: 'BalanceLockTo212',
            CompactAssignments: 'CompactAssignmentsTo257',
            DispatchInfo: 'DispatchInfoTo244',
            Heartbeat: 'HeartbeatTo244',
            Keys: 'SessionKeys5',
            Multiplier: 'Fixed64',
            OpenTip: 'OpenTipTo225',
            RefCount: 'RefCountTo259',
            ReferendumInfo: 'ReferendumInfoTo239',
            Scheduled: 'ScheduledTo254',
            StakingLedger: 'StakingLedgerTo223',
            Votes: 'VotesTo230',
            Weight: 'u32'
        }
    },
    {
        minmax: [1046, 1049],
        types: {
            ...sharedTypes$6,
            ...addrAccountIdTypes$2,
            CompactAssignments: 'CompactAssignmentsTo257',
            DispatchInfo: 'DispatchInfoTo244',
            Heartbeat: 'HeartbeatTo244',
            Multiplier: 'Fixed64',
            OpenTip: 'OpenTipTo225',
            RefCount: 'RefCountTo259',
            ReferendumInfo: 'ReferendumInfoTo239',
            Scheduled: 'ScheduledTo254',
            StakingLedger: 'StakingLedgerTo223',
            Weight: 'u32'
        }
    },
    {
        minmax: [1050, 1054],
        types: {
            ...sharedTypes$6,
            ...addrAccountIdTypes$2,
            CompactAssignments: 'CompactAssignmentsTo257',
            DispatchInfo: 'DispatchInfoTo244',
            Heartbeat: 'HeartbeatTo244',
            Multiplier: 'Fixed64',
            OpenTip: 'OpenTipTo225',
            RefCount: 'RefCountTo259',
            ReferendumInfo: 'ReferendumInfoTo239',
            Scheduled: 'ScheduledTo254',
            StakingLedger: 'StakingLedgerTo240',
            Weight: 'u32'
        }
    },
    {
        minmax: [1055, 1056],
        types: {
            ...sharedTypes$6,
            ...addrAccountIdTypes$2,
            CompactAssignments: 'CompactAssignmentsTo257',
            DispatchInfo: 'DispatchInfoTo244',
            Heartbeat: 'HeartbeatTo244',
            Multiplier: 'Fixed64',
            OpenTip: 'OpenTipTo225',
            RefCount: 'RefCountTo259',
            Scheduled: 'ScheduledTo254',
            StakingLedger: 'StakingLedgerTo240',
            Weight: 'u32'
        }
    },
    {
        minmax: [1057, 1061],
        types: {
            ...sharedTypes$6,
            ...addrAccountIdTypes$2,
            CompactAssignments: 'CompactAssignmentsTo257',
            DispatchInfo: 'DispatchInfoTo244',
            Heartbeat: 'HeartbeatTo244',
            OpenTip: 'OpenTipTo225',
            RefCount: 'RefCountTo259',
            // Last 100% known problematic runtime range - this quite possibly need to
            // apply to more runtime ranges that follow, we just don't know how far this
            // should be applied to
            //
            // TL;DR whack-a-mole since this was not histrically checked
            //
            // See https://github.com/polkadot-js/api/issues/5618#issuecomment-1530970316
            Scheduled: 'ScheduledTo254'
        }
    },
    {
        minmax: [1062, 2012],
        types: {
            ...sharedTypes$6,
            ...addrAccountIdTypes$2,
            CompactAssignments: 'CompactAssignmentsTo257',
            OpenTip: 'OpenTipTo225',
            RefCount: 'RefCountTo259'
        }
    },
    {
        minmax: [2013, 2022],
        types: {
            ...sharedTypes$6,
            ...addrAccountIdTypes$2,
            CompactAssignments: 'CompactAssignmentsTo257',
            RefCount: 'RefCountTo259'
        }
    },
    {
        minmax: [2023, 2024],
        types: {
            ...sharedTypes$6,
            ...addrAccountIdTypes$2,
            RefCount: 'RefCountTo259'
        }
    },
    {
        minmax: [2025, 2027],
        types: {
            ...sharedTypes$6,
            ...addrAccountIdTypes$2
        }
    },
    {
        minmax: [2028, 2029],
        types: {
            ...sharedTypes$6,
            AccountInfo: 'AccountInfoWithDualRefCount',
            CompactAssignments: 'CompactAssignmentsWith16',
            RawSolution: 'RawSolutionWith16'
        }
    },
    {
        minmax: [2030, 9000],
        types: {
            ...sharedTypes$6,
            CompactAssignments: 'CompactAssignmentsWith16',
            RawSolution: 'RawSolutionWith16'
        }
    },
    {
        minmax: [9010, 9099],
        types: {
            ...sharedTypes$6,
            ...mapXcmTypes('V0')
        }
    },
    {
        // jump from 9100 to 9110, however align with Rococo
        minmax: [9100, 9105],
        types: {
            ...sharedTypes$6,
            ...mapXcmTypes('V1')
        }
    },
    {
        // metadata v14
        minmax: [9106, undefined],
        types: {
            Weight: 'WeightV1'
        }
    }
    // ,
    // {
    //   // weight v2 introduction
    //   minmax: [9300, undefined],
    //   types: {
    //     Weight: 'WeightV2'
    //   }
    // }
];

const versioned$8 = [
    {
        minmax: [0, undefined],
        types: {
            // nothing, API tracks master
            // (v2 weights are not yet the default)
            Weight: 'WeightV2'
        }
    }
];

const versioned$7 = [
    {
        minmax: [0, undefined],
        types: {
            // nothing, API tracks master
            // (v2 weights are not yet the default)
            Weight: 'WeightV2'
        }
    }
];

const sharedTypes$5 = {
    CompactAssignments: 'CompactAssignmentsWith16',
    DispatchErrorModule: 'DispatchErrorModuleU8',
    RawSolution: 'RawSolutionWith16',
    Keys: 'SessionKeys6',
    ProxyType: {
        _enum: {
            Any: 0,
            NonTransfer: 1,
            Governance: 2,
            Staking: 3,
            UnusedSudoBalances: 4,
            IdentityJudgement: 5,
            CancelProxy: 6,
            Auction: 7
        }
    },
    Weight: 'WeightV1'
};
const addrAccountIdTypes$1 = {
    AccountInfo: 'AccountInfoWithRefCount',
    Address: 'AccountId',
    DispatchErrorModule: 'DispatchErrorModuleU8',
    Keys: 'SessionKeys5',
    LookupSource: 'AccountId',
    ValidatorPrefs: 'ValidatorPrefsWithCommission'
};
const versioned$6 = [
    {
        minmax: [0, 10],
        types: {
            ...sharedTypes$5,
            ...addrAccountIdTypes$1,
            CompactAssignments: 'CompactAssignmentsTo257',
            OpenTip: 'OpenTipTo225',
            RefCount: 'RefCountTo259',
            ElectionResult: 'ElectionResultToSpec10'
        }
    },
    {
        minmax: [11, 12],
        types: {
            ...sharedTypes$5,
            ...addrAccountIdTypes$1,
            CompactAssignments: 'CompactAssignmentsTo257',
            OpenTip: 'OpenTipTo225',
            RefCount: 'RefCountTo259'
        }
    },
    {
        minmax: [13, 22],
        types: {
            ...sharedTypes$5,
            ...addrAccountIdTypes$1,
            CompactAssignments: 'CompactAssignmentsTo257',
            RefCount: 'RefCountTo259'
        }
    },
    {
        minmax: [23, 24],
        types: {
            ...sharedTypes$5,
            ...addrAccountIdTypes$1,
            RefCount: 'RefCountTo259'
        }
    },
    {
        minmax: [25, 27],
        types: {
            ...sharedTypes$5,
            ...addrAccountIdTypes$1
        }
    },
    {
        minmax: [28, 29],
        types: {
            ...sharedTypes$5,
            AccountInfo: 'AccountInfoWithDualRefCount'
        }
    },
    {
        minmax: [30, 9109],
        types: {
            ...sharedTypes$5
        }
    },
    {
        // metadata v14
        minmax: [9110, undefined],
        types: {
            Weight: 'WeightV1'
        }
    }
    // ,
    // {
    //   // weight v2 introduction
    //   minmax: [9300, undefined],
    //   types: {
    //     Weight: 'WeightV2'
    //   }
    // }
];

/* eslint-disable sort-keys */
const sharedTypes$4 = {
    DispatchErrorModule: 'DispatchErrorModuleU8',
    FullIdentification: '()', // No staking, only session (as per config)
    Keys: 'SessionKeys7B',
    Weight: 'WeightV1'
};
const versioned$5 = [
    {
        minmax: [0, 200],
        types: {
            ...sharedTypes$4,
            AccountInfo: 'AccountInfoWithDualRefCount',
            Address: 'AccountId',
            LookupSource: 'AccountId'
        }
    },
    {
        minmax: [201, 214],
        types: {
            ...sharedTypes$4,
            AccountInfo: 'AccountInfoWithDualRefCount'
        }
    },
    {
        minmax: [215, 228],
        types: {
            ...sharedTypes$4,
            Keys: 'SessionKeys6'
        }
    },
    {
        minmax: [229, 9099],
        types: {
            ...sharedTypes$4,
            ...mapXcmTypes('V0')
        }
    },
    {
        minmax: [9100, 9105],
        types: {
            ...sharedTypes$4,
            ...mapXcmTypes('V1')
        }
    },
    {
        // metadata v14
        minmax: [9106, undefined],
        types: {
            Weight: 'WeightV1'
        }
    }
    // ,
    // {
    //   // weight v2 introduction
    //   minmax: [9300, undefined],
    //   types: {
    //     Weight: 'WeightV2'
    //   }
    // }
];

const versioned$4 = [
    {
        minmax: [0, undefined],
        types: {
        // nothing, limited runtime
        }
    }
];

const sharedTypes$3 = {
    DispatchErrorModule: 'DispatchErrorModuleU8',
    TAssetBalance: 'u128',
    ProxyType: {
        _enum: [
            'Any',
            'NonTransfer',
            'CancelProxy',
            'Assets',
            'AssetOwner',
            'AssetManager',
            'Staking'
        ]
    },
    Weight: 'WeightV1'
};
const versioned$3 = [
    {
        minmax: [0, 3],
        types: {
            // Enum was modified mid-flight -
            // https://github.com/paritytech/substrate/pull/10382/files#diff-e4e016b33a82268b6208dc974eea841bad47597865a749fee2f937eb6fdf67b4R498
            DispatchError: 'DispatchErrorPre6First',
            ...sharedTypes$3,
            ...mapXcmTypes('V0')
        }
    },
    {
        minmax: [4, 5],
        types: {
            // As above, see https://github.com/polkadot-js/api/issues/5301
            DispatchError: 'DispatchErrorPre6First',
            ...sharedTypes$3,
            ...mapXcmTypes('V1')
        }
    },
    {
        // metadata V14
        minmax: [500, 9999],
        types: {
            Weight: 'WeightV1',
            TAssetConversion: 'Option<AssetId>'
        }
    },
    {
        minmax: [10000, undefined],
        types: {
            Weight: 'WeightV1'
        }
    }
];

const sharedTypes$2 = {
    DispatchErrorModule: 'DispatchErrorModuleU8',
    TAssetBalance: 'u128',
    ProxyType: {
        _enum: [
            'Any',
            'NonTransfer',
            'CancelProxy',
            'Assets',
            'AssetOwner',
            'AssetManager',
            'Staking'
        ]
    },
    Weight: 'WeightV1'
};
const versioned$2 = [
    {
        minmax: [0, 3],
        types: {
            // Enum was modified mid-flight -
            // https://github.com/paritytech/substrate/pull/10382/files#diff-e4e016b33a82268b6208dc974eea841bad47597865a749fee2f937eb6fdf67b4R498
            DispatchError: 'DispatchErrorPre6First',
            ...sharedTypes$2,
            ...mapXcmTypes('V0')
        }
    },
    {
        minmax: [4, 5],
        types: {
            // As above, see https://github.com/polkadot-js/api/issues/5301
            DispatchError: 'DispatchErrorPre6First',
            ...sharedTypes$2,
            ...mapXcmTypes('V1')
        }
    },
    {
        // metadata V14
        minmax: [500, 1001003],
        types: {
            Weight: 'WeightV1',
            TAssetConversion: 'Option<AssetId>'
        }
    },
    // ref: https://github.com/polkadot-js/api/pull/6208
    // The following patches an issue where polkadot asset hub block 9686187, can't be decoding using xcm v5
    // mappings.
    {
        minmax: [1002000, undefined],
        types: {
            Weight: 'WeightV1',
            ...mapXcmTypes('V4')
        }
    }
    // ,
    // {
    //   // weight v2 introduction
    //   minmax: [9300, undefined],
    //   types: {
    //     Weight: 'WeightV2'
    //   }
    // }
];

const sharedTypes$1 = {
    // 16 validators
    CompactAssignments: 'CompactAssignmentsWith16',
    DispatchErrorModule: 'DispatchErrorModuleU8',
    RawSolution: 'RawSolutionWith16',
    // general
    Keys: 'SessionKeys6',
    ProxyType: {
        _enum: ['Any', 'NonTransfer', 'Staking', 'SudoBalances', 'IdentityJudgement', 'CancelProxy']
    },
    Weight: 'WeightV1'
};
const addrAccountIdTypes = {
    AccountInfo: 'AccountInfoWithRefCount',
    Address: 'AccountId',
    CompactAssignments: 'CompactAssignmentsWith16',
    DispatchErrorModule: 'DispatchErrorModuleU8',
    LookupSource: 'AccountId',
    Keys: 'SessionKeys5',
    RawSolution: 'RawSolutionWith16',
    ValidatorPrefs: 'ValidatorPrefsWithCommission'
};
const versioned$1 = [
    {
        minmax: [1, 2],
        types: {
            ...sharedTypes$1,
            ...addrAccountIdTypes,
            CompactAssignments: 'CompactAssignmentsTo257',
            DispatchInfo: 'DispatchInfoTo244',
            Heartbeat: 'HeartbeatTo244',
            Multiplier: 'Fixed64',
            OpenTip: 'OpenTipTo225',
            RefCount: 'RefCountTo259',
            Weight: 'u32'
        }
    },
    {
        minmax: [3, 22],
        types: {
            ...sharedTypes$1,
            ...addrAccountIdTypes,
            CompactAssignments: 'CompactAssignmentsTo257',
            DispatchInfo: 'DispatchInfoTo244',
            Heartbeat: 'HeartbeatTo244',
            OpenTip: 'OpenTipTo225',
            RefCount: 'RefCountTo259'
        }
    },
    {
        minmax: [23, 42],
        types: {
            ...sharedTypes$1,
            ...addrAccountIdTypes,
            CompactAssignments: 'CompactAssignmentsTo257',
            DispatchInfo: 'DispatchInfoTo244',
            Heartbeat: 'HeartbeatTo244',
            RefCount: 'RefCountTo259'
        }
    },
    {
        minmax: [43, 44],
        types: {
            ...sharedTypes$1,
            ...addrAccountIdTypes,
            DispatchInfo: 'DispatchInfoTo244',
            Heartbeat: 'HeartbeatTo244',
            RefCount: 'RefCountTo259'
        }
    },
    {
        minmax: [45, 47],
        types: {
            ...sharedTypes$1,
            ...addrAccountIdTypes
        }
    },
    {
        minmax: [48, 49],
        types: {
            ...sharedTypes$1,
            AccountInfo: 'AccountInfoWithDualRefCount'
        }
    },
    {
        minmax: [50, 9099],
        types: {
            ...sharedTypes$1,
            ...mapXcmTypes('V0')
        }
    },
    {
        minmax: [9100, 9105],
        types: {
            ...sharedTypes$1,
            ...mapXcmTypes('V1')
        }
    },
    {
        // metadata v14
        minmax: [9106, undefined],
        types: {
            Weight: 'WeightV1'
        }
    }
    // ,
    // {
    //   // weight v2 introduction
    //   minmax: [9300, undefined],
    //   types: {
    //     Weight: 'WeightV2'
    //   }
    // }
];

const sharedTypes = {
    DispatchErrorModule: 'DispatchErrorModuleU8',
    TAssetBalance: 'u128',
    ProxyType: {
        _enum: [
            'Any',
            'NonTransfer',
            'CancelProxy',
            'Assets',
            'AssetOwner',
            'AssetManager',
            'Staking'
        ]
    },
    Weight: 'WeightV1'
};
const versioned = [
    {
        minmax: [0, 3],
        types: {
            // Enum was modified mid-flight -
            // https://github.com/paritytech/substrate/pull/10382/files#diff-e4e016b33a82268b6208dc974eea841bad47597865a749fee2f937eb6fdf67b4R498
            DispatchError: 'DispatchErrorPre6First',
            ...sharedTypes,
            ...mapXcmTypes('V0')
        }
    },
    {
        minmax: [4, 5],
        types: {
            // As above, see https://github.com/polkadot-js/api/issues/5301
            DispatchError: 'DispatchErrorPre6First',
            ...sharedTypes,
            ...mapXcmTypes('V1')
        }
    },
    {
        // metadata V14
        minmax: [500, 9434],
        types: {
            Weight: 'WeightV1',
            TAssetConversion: 'Option<AssetId>'
        }
    },
    {
        minmax: [9435, undefined],
        types: {
            Weight: 'WeightV1'
        }
    }
];

const typesSpec = {
    'centrifuge-chain': versioned$a,
    kusama: versioned$9,
    node: versioned$8,
    'node-template': versioned$7,
    polkadot: versioned$6,
    rococo: versioned$5,
    shell: versioned$4,
    statemine: versioned$3,
    statemint: versioned$2,
    westend: versioned$1,
    westmint: versioned
};

const upgrades$3 = [
    [
        0,
        1020,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        26669,
        1021,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        38245,
        1022,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        54248,
        1023,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        59659,
        1024,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        67651,
        1025,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        82191,
        1027,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        83238,
        1028,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        101503,
        1029,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        203466,
        1030,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        295787,
        1031,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        461692,
        1032,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        504329,
        1033,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        569327,
        1038,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                1
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        587687,
        1039,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        653183,
        1040,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        693488,
        1042,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        901442,
        1045,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1375086,
        1050,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1445458,
        1051,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1472960,
        1052,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1475648,
        1053,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1491596,
        1054,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1574408,
        1055,
        [
            [
                "0xdf6acb689907609b",
                2
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                1
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2064961,
        1058,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2201991,
        1062,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2671528,
        2005,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2704202,
        2007,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2728002,
        2008,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2832534,
        2011,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2962294,
        2012,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3240000,
        2013,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3274408,
        2015,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3323565,
        2019,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3534175,
        2022,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3860281,
        2023,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        4143129,
        2024,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        4401242,
        2025,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        4841367,
        2026,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5961600,
        2027,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        6137912,
        2028,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        6561855,
        2029,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7100891,
        2030,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7468792,
        9010,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7668600,
        9030,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7812476,
        9040,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        8010981,
        9050,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        8073833,
        9070,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        8555825,
        9080,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        8945245,
        9090,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9611377,
        9100,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9625129,
        9111,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9866422,
        9122,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10403784,
        9130,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10960765,
        9150,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11006614,
        9151,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11404482,
        9160,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11601803,
        9170,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        12008022,
        9180,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        12405451,
        9190,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        12665416,
        9200,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        12909508,
        9220,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        13109752,
        9230,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        13555777,
        9250,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        13727747,
        9260,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        14248044,
        9271,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        14433840,
        9280,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        14645900,
        9291,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        15048375,
        9300,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        15426015,
        9320,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        15680713,
        9340,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        15756296,
        9350,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        15912007,
        9360,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        16356547,
        9370,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        17335450,
        9381,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                3
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        18062739,
        9420,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                4
            ],
            [
                "0x49eaaf1b548a0cb0",
                2
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ]
        ]
    ],
    [
        18625000,
        9430,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                4
            ],
            [
                "0x49eaaf1b548a0cb0",
                2
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ]
        ]
    ],
    [
        20465806,
        1000000,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                5
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ]
        ]
    ],
    [
        21570000,
        1001000,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                7
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        21786291,
        1001002,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                7
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        22515962,
        1001003,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                7
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        22790000,
        1002000,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                10
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        23176015,
        1002001,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                10
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        23450253,
        1002004,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                10
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        23565293,
        1002005,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                10
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        23780224,
        1002006,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                10
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        24786390,
        1003000,
        [
            [
                "0xc51ff1fa3f5d0cca",
                1
            ],
            [
                "0xdf6acb689907609b",
                5
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                11
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x6ff52ee858e6c5bd",
                1
            ],
            [
                "0x91b1c8b16328eb92",
                1
            ],
            [
                "0x9ffb505aa738d69c",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ]
];

const upgrades$2 = [
    [
        0,
        0,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        29231,
        1,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        188836,
        5,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        199405,
        6,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        214264,
        7,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        244358,
        8,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        303079,
        9,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        314201,
        10,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        342400,
        11,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        443963,
        12,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        528470,
        13,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        687751,
        14,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        746085,
        15,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        787923,
        16,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        799302,
        17,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1205128,
        18,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1603423,
        23,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1733218,
        24,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2005673,
        25,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2436698,
        26,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3613564,
        27,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3899547,
        28,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        4345767,
        29,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        4876134,
        30,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5661442,
        9050,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        6321619,
        9080,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        6713249,
        9090,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7217907,
        9100,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7229126,
        9110,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7560558,
        9122,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        8115869,
        9140,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        8638103,
        9151,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9280179,
        9170,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9738717,
        9180,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10156856,
        9190,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10458576,
        9200,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10655116,
        9220,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10879371,
        9230,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11328884,
        9250,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11532856,
        9260,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11933818,
        9270,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        12217535,
        9280,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ]
        ]
    ],
    [
        12245277,
        9281,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ]
        ]
    ],
    [
        12532644,
        9291,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ]
        ]
    ],
    [
        12876189,
        9300,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ]
        ]
    ],
    [
        13800015,
        9340,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ]
        ]
    ],
    [
        14188833,
        9360,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ]
        ]
    ],
    [
        14543918,
        9370,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ]
        ]
    ],
    [
        15978362,
        9420,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                4
            ],
            [
                "0x49eaaf1b548a0cb0",
                2
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ]
        ]
    ],
    [
        16450000,
        9430,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                4
            ],
            [
                "0x49eaaf1b548a0cb0",
                2
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ]
        ]
    ],
    [
        17840000,
        9431,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                4
            ],
            [
                "0x49eaaf1b548a0cb0",
                2
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ]
        ]
    ],
    [
        18407475,
        1000001,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                5
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ]
        ]
    ],
    [
        19551000,
        1001002,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                5
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        20181758,
        1001003,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                5
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        20438530,
        1002000,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                10
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        21169168,
        1002004,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                10
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        21455374,
        1002005,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                10
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        21558004,
        1002006,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                10
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        21800141,
        1002007,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                10
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ]
];

const upgrades$1 = [
    [
        214356,
        4,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                1
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        392764,
        7,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        409740,
        8,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        809976,
        20,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        877581,
        24,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        879238,
        25,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        889472,
        26,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        902937,
        27,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        932751,
        28,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        991142,
        29,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1030162,
        31,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1119657,
        32,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1199282,
        33,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1342534,
        34,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1392263,
        35,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1431703,
        36,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1433369,
        37,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        1490972,
        41,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2087397,
        43,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2316688,
        44,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        2549864,
        45,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3925782,
        46,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        3925843,
        47,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        4207800,
        48,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        4627944,
        49,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5124076,
        50,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5478664,
        900,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5482450,
        9000,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                4
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5584305,
        9010,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5784566,
        9030,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5879822,
        9031,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5896856,
        9032,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        5897316,
        9033,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        6117927,
        9050,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        6210274,
        9070,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                2
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        6379314,
        9080,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                2
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        6979141,
        9090,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7568453,
        9100,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7766394,
        9111,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7911691,
        9120,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7968866,
        9121,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        7982889,
        9122,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        8514322,
        9130,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9091726,
        9140,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9091774,
        9150,
        [
            [
                "0xdf6acb689907609b",
                3
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                1
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9406726,
        9160,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        9921066,
        9170,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10007115,
        9180,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                5
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10480973,
        9190,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10578091,
        9200,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10678509,
        9210,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        10811001,
        9220,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11096116,
        9230,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11409279,
        9250,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11584820,
        9251,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11716837,
        9260,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11876919,
        9261,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ]
        ]
    ],
    [
        11987927,
        9270,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        12077324,
        9271,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        12301871,
        9280,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        12604343,
        9290,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                2
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        12841034,
        9300,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        13128237,
        9310,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                1
            ],
            [
                "0xf3ff14d5ab527059",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        13272363,
        9320,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        13483497,
        9330,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        13649433,
        9340,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        13761100,
        9350,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        13847400,
        9360,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        14249200,
        9370,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                2
            ],
            [
                "0xf3ff14d5ab527059",
                2
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        14576855,
        9380,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                3
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                3
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ]
        ]
    ],
    [
        14849830,
        9390,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                4
            ],
            [
                "0x49eaaf1b548a0cb0",
                1
            ],
            [
                "0x91d5df18b0d2cf58",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                3
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ]
        ]
    ],
    [
        15146832,
        9400,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                4
            ],
            [
                "0x49eaaf1b548a0cb0",
                2
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                3
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ]
        ]
    ],
    [
        15332317,
        9401,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                1
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                4
            ],
            [
                "0x49eaaf1b548a0cb0",
                2
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                3
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ]
        ]
    ],
    [
        15661793,
        9420,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                4
            ],
            [
                "0x49eaaf1b548a0cb0",
                2
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ]
        ]
    ],
    [
        16165469,
        9430,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                4
            ],
            [
                "0x49eaaf1b548a0cb0",
                2
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ]
        ]
    ],
    [
        18293984,
        102000,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                7
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        18293991,
        103000,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                8
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        18451783,
        104000,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                9
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        18679741,
        1005000,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                9
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        19166695,
        1006000,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                10
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        19234157,
        1006001,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                10
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        19542944,
        1007000,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                10
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        19621258,
        1007001,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                10
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        19761406,
        1008000,
        [
            [
                "0xdf6acb689907609b",
                4
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                10
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        20056997,
        1009000,
        [
            [
                "0xdf6acb689907609b",
                5
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                10
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        20368318,
        1010000,
        [
            [
                "0xdf6acb689907609b",
                5
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                10
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x6ff52ee858e6c5bd",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        20649086,
        1011000,
        [
            [
                "0xdf6acb689907609b",
                5
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                11
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x6ff52ee858e6c5bd",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        21217837,
        1011001,
        [
            [
                "0xdf6acb689907609b",
                5
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                11
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x6ff52ee858e6c5bd",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        21300429,
        1013000,
        [
            [
                "0xdf6acb689907609b",
                5
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                11
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x6ff52ee858e6c5bd",
                1
            ],
            [
                "0x91b1c8b16328eb92",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        21460051,
        1014000,
        [
            [
                "0xdf6acb689907609b",
                5
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                11
            ],
            [
                "0x49eaaf1b548a0cb0",
                3
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x6ff52ee858e6c5bd",
                1
            ],
            [
                "0x91b1c8b16328eb92",
                1
            ],
            [
                "0x9ffb505aa738d69c",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        21925427,
        1015000,
        [
            [
                "0xdf6acb689907609b",
                5
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                11
            ],
            [
                "0x49eaaf1b548a0cb0",
                4
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x6ff52ee858e6c5bd",
                1
            ],
            [
                "0x91b1c8b16328eb92",
                1
            ],
            [
                "0x9ffb505aa738d69c",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        22500517,
        1016000,
        [
            [
                "0xdf6acb689907609b",
                5
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                11
            ],
            [
                "0x49eaaf1b548a0cb0",
                5
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x6ff52ee858e6c5bd",
                1
            ],
            [
                "0x91b1c8b16328eb92",
                1
            ],
            [
                "0x9ffb505aa738d69c",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        22759684,
        1016001,
        [
            [
                "0xdf6acb689907609b",
                5
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                11
            ],
            [
                "0x49eaaf1b548a0cb0",
                5
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x6ff52ee858e6c5bd",
                1
            ],
            [
                "0x91b1c8b16328eb92",
                1
            ],
            [
                "0x9ffb505aa738d69c",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        23056976,
        1016002,
        [
            [
                "0xdf6acb689907609b",
                5
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                11
            ],
            [
                "0x49eaaf1b548a0cb0",
                5
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x6ff52ee858e6c5bd",
                1
            ],
            [
                "0x91b1c8b16328eb92",
                1
            ],
            [
                "0x9ffb505aa738d69c",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ]
        ]
    ],
    [
        23544582,
        1017000,
        [
            [
                "0xdf6acb689907609b",
                5
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                11
            ],
            [
                "0x49eaaf1b548a0cb0",
                5
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x6ff52ee858e6c5bd",
                1
            ],
            [
                "0x91b1c8b16328eb92",
                1
            ],
            [
                "0x9ffb505aa738d69c",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ],
            [
                "0x2609be83ac4468dc",
                1
            ]
        ]
    ],
    [
        24002343,
        1017001,
        [
            [
                "0xdf6acb689907609b",
                5
            ],
            [
                "0x37e397fc7c91f5e4",
                2
            ],
            [
                "0x40fe3ad401f8959a",
                6
            ],
            [
                "0xd2bc9897eed08f15",
                3
            ],
            [
                "0xf78b278be53f454c",
                2
            ],
            [
                "0xaf2c0297a23e6d3d",
                11
            ],
            [
                "0x49eaaf1b548a0cb0",
                5
            ],
            [
                "0x91d5df18b0d2cf58",
                2
            ],
            [
                "0x2a5e924655399e60",
                1
            ],
            [
                "0xed99c5acb25eedf5",
                3
            ],
            [
                "0xcbca25e39f142387",
                2
            ],
            [
                "0x687ad44ad37f03c2",
                1
            ],
            [
                "0xab3c0572291feb8b",
                1
            ],
            [
                "0xbc9d89904f5b923f",
                1
            ],
            [
                "0x37c8bb1350a9a2a8",
                4
            ],
            [
                "0xf3ff14d5ab527059",
                3
            ],
            [
                "0x6ff52ee858e6c5bd",
                1
            ],
            [
                "0x91b1c8b16328eb92",
                1
            ],
            [
                "0x9ffb505aa738d69c",
                1
            ],
            [
                "0x17a6bc0d0062aeb3",
                1
            ],
            [
                "0x18ef58a3b67ba770",
                1
            ],
            [
                "0xfbc577b9d747efd6",
                1
            ],
            [
                "0x2609be83ac4468dc",
                1
            ]
        ]
    ]
];

var allKnown = /*#__PURE__*/Object.freeze({
	__proto__: null,
	kusama: upgrades$3,
	polkadot: upgrades$2,
	westend: upgrades$1
});

const NET_EXTRA = {
    westend: {
        genesisHash: ['0xe143f23803ac50e8f6f8e62695d1ce9e4e1d68aa36c1cd2cfd15340213f3423e']
    }
};
/** @internal */
function mapRaw([network, versions]) {
    const chain = selectableNetworks.find((n) => n.network === network) || NET_EXTRA[network];
    if (!chain) {
        throw new Error(`Unable to find info for chain ${network}`);
    }
    return {
        genesisHash: hexToU8a(chain.genesisHash[0]),
        network,
        versions: versions.map(([blockNumber, specVersion, apis]) => ({
            apis,
            blockNumber: new BN(blockNumber),
            specVersion: new BN(specVersion)
        }))
    };
}
const upgrades = Object.entries(allKnown).map(mapRaw);

/**
 * @description Perform the callback function using the stringified spec/chain
 * @internal
 * */
function withNames(chainName, specName, fn) {
    return fn(chainName.toString(), specName.toString());
}
/**
 * @descriptionFflatten a VersionedType[] into a Record<string, string>
 * @internal
 * */
function filterVersions(versions = [], specVersion) {
    return versions
        .filter(({ minmax: [min, max] }) => (min === undefined || min === null || specVersion >= min) &&
        (max === undefined || max === null || specVersion <= max))
        .reduce((result, { types }) => ({ ...result, ...types }), {});
}
/**
 * @description Based on the chain and runtimeVersion, get the applicable signed extensions (ready for registration)
 */
function getSpecExtensions({ knownTypes }, chainName, specName) {
    return withNames(chainName, specName, (c, s) => ({
        ...(knownTypes.typesBundle?.spec?.[s]?.signedExtensions ?? {}),
        ...(knownTypes.typesBundle?.chain?.[c]?.signedExtensions ?? {})
    }));
}
/**
 * @description Based on the chain and runtimeVersion, get the applicable types (ready for registration)
 */
function getSpecTypes({ knownTypes }, chainName, specName, specVersion) {
    const _specVersion = bnToBn(specVersion).toNumber();
    return withNames(chainName, specName, (c, s) => ({
        // The order here is always, based on -
        //   - spec then chain
        //   - typesBundle takes higher precedence
        //   - types is the final catch-all override
        ...filterVersions(typesSpec[s], _specVersion),
        ...filterVersions(typesChain[c], _specVersion),
        ...filterVersions(knownTypes.typesBundle?.spec?.[s]?.types, _specVersion),
        ...filterVersions(knownTypes.typesBundle?.chain?.[c]?.types, _specVersion),
        ...(knownTypes.typesSpec?.[s] ?? {}),
        ...(knownTypes.typesChain?.[c] ?? {}),
        ...(knownTypes.types ?? {})
    }));
}
/**
 * @description Based on the chain or spec, return the hasher used
 */
function getSpecHasher({ knownTypes }, chainName, specName) {
    return withNames(chainName, specName, (c, s) => knownTypes.hasher ||
        knownTypes.typesBundle?.chain?.[c]?.hasher ||
        knownTypes.typesBundle?.spec?.[s]?.hasher ||
        null);
}
/**
 * @description Based on the chain and runtimeVersion, get the applicable rpc definitions (ready for registration)
 */
function getSpecRpc({ knownTypes }, chainName, specName) {
    return withNames(chainName, specName, (c, s) => ({
        ...(knownTypes.typesBundle?.spec?.[s]?.rpc ?? {}),
        ...(knownTypes.typesBundle?.chain?.[c]?.rpc ?? {})
    }));
}
/**
 * @description Based on the chain and runtimeVersion, get the applicable runtime definitions (ready for registration)
 */
function getSpecRuntime({ knownTypes }, chainName, specName) {
    return withNames(chainName, specName, (c, s) => ({
        ...(knownTypes.typesBundle?.spec?.[s]?.runtime ?? {}),
        ...(knownTypes.typesBundle?.chain?.[c]?.runtime ?? {})
    }));
}
/**
 * @description Based on the chain and runtimeVersion, get the applicable alias definitions (ready for registration)
 */
function getSpecAlias({ knownTypes }, chainName, specName) {
    return withNames(chainName, specName, (c, s) => ({
        // as per versions, first spec, then chain then finally non-versioned
        ...(knownTypes.typesBundle?.spec?.[s]?.alias ?? {}),
        ...(knownTypes.typesBundle?.chain?.[c]?.alias ?? {}),
        ...(knownTypes.typesAlias ?? {})
    }));
}
/**
 * @description Returns a version record for known chains where upgrades are being tracked
 */
function getUpgradeVersion(genesisHash, blockNumber) {
    const known = upgrades.find((u) => genesisHash.eq(u.genesisHash));
    return known
        ? [
            known.versions.reduce((last, version) => {
                return blockNumber.gt(version.blockNumber)
                    ? version
                    : last;
            }, undefined),
            known.versions.find((version) => blockNumber.lte(version.blockNumber))
        ]
        : [undefined, undefined];
}

const l$2 = logger('api/augment');
function logLength(type, values, and = []) {
    return values.length
        ? ` ${values.length} ${type}${and.length ? ' and' : ''}`
        : '';
}
function logValues(type, values) {
    return values.length
        ? `\n\t${type.padStart(7)}: ${values.sort().join(', ')}`
        : '';
}
function warn(prefix, type, [added, removed]) {
    if (added.length || removed.length) {
        l$2.warn(`api.${prefix}: Found${logLength('added', added, removed)}${logLength('removed', removed)} ${type}:${logValues('added', added)}${logValues('removed', removed)}`);
    }
}
function findSectionExcludes(a, b) {
    return a.filter((s) => !b.includes(s));
}
function findSectionIncludes(a, b) {
    return a.filter((s) => b.includes(s));
}
function extractSections(src, dst) {
    const srcSections = Object.keys(src);
    const dstSections = Object.keys(dst);
    return [
        findSectionExcludes(srcSections, dstSections),
        findSectionExcludes(dstSections, srcSections)
    ];
}
function findMethodExcludes(src, dst) {
    const srcSections = Object.keys(src);
    const dstSections = findSectionIncludes(Object.keys(dst), srcSections);
    const excludes = [];
    for (let s = 0, scount = dstSections.length; s < scount; s++) {
        const section = dstSections[s];
        const srcMethods = Object.keys(src[section]);
        const dstMethods = Object.keys(dst[section]);
        for (let d = 0, mcount = dstMethods.length; d < mcount; d++) {
            const method = dstMethods[d];
            if (!srcMethods.includes(method)) {
                excludes.push(`${section}.${method}`);
            }
        }
    }
    return excludes;
}
function extractMethods(src, dst) {
    return [
        findMethodExcludes(dst, src),
        findMethodExcludes(src, dst)
    ];
}
/**
 * @description Takes a decorated api section (e.g. api.tx) and augment it with the details. It does not override what is
 * already available, but rather just adds new missing items into the result object.
 * @internal
 */
function augmentObject(prefix, src, dst, fromEmpty = false) {
    fromEmpty && objectClear(dst);
    // NOTE: This part is slightly problematic since it will get the
    // values for at least all the sections and the names of the methods
    // (Since methods won't be decorated before lazy, this _may_ be ok)
    if (prefix && Object.keys(dst).length) {
        warn(prefix, 'modules', extractSections(src, dst));
        warn(prefix, 'calls', extractMethods(src, dst));
    }
    const sections = Object.keys(src);
    for (let i = 0, count = sections.length; i < count; i++) {
        const section = sections[i];
        const methods = src[section];
        // We don't set here with a lazy interface, we decorate based
        // on the top-level structure (this bypasses adding lazy onto lazy)
        if (!dst[section]) {
            dst[section] = {};
        }
        lazyMethods(dst[section], Object.keys(methods), (m) => methods[m]);
    }
    return dst;
}

function sig({ lookup }, { method, section }, args) {
    return `${section}.${method}(${args.map((a) => lookup.getTypeDef(a).type).join(', ')})`;
}
function extractStorageArgs(registry, creator, _args) {
    const args = _args.filter((a) => !isUndefined(a));
    if (creator.meta.type.isPlain) {
        if (args.length !== 0) {
            throw new Error(`${sig(registry, creator, [])} does not take any arguments, ${args.length} found`);
        }
    }
    else {
        const { hashers, key } = creator.meta.type.asMap;
        const keys = hashers.length === 1
            ? [key]
            : registry.lookup.getSiType(key).def.asTuple.map((t) => t);
        if (args.length !== keys.length) {
            throw new Error(`${sig(registry, creator, keys)} is a map, requiring ${keys.length} arguments, ${args.length} found`);
        }
    }
    // pass as tuple
    return [creator, args];
}

class Events {
    #eventemitter = new EventEmitter();
    emit(type, ...args) {
        return this.#eventemitter.emit(type, ...args);
    }
    /**
     * @description Attach an eventemitter handler to listen to a specific event
     *
     * @param type The type of event to listen to. Available events are `connected`, `disconnected`, `ready` and `error`
     * @param handler The callback to be called when the event fires. Depending on the event type, it could fire with additional arguments.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * api.on('connected', (): void => {
     *   console.log('API has been connected to the endpoint');
     * });
     *
     * api.on('disconnected', (): void => {
     *   console.log('API has been disconnected from the endpoint');
     * });
     * ```
     */
    on(type, handler) {
        this.#eventemitter.on(type, handler);
        return this;
    }
    /**
     * @description Remove the given eventemitter handler
     *
     * @param type The type of event the callback was attached to. Available events are `connected`, `disconnected`, `ready` and `error`
     * @param handler The callback to unregister.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * const handler = (): void => {
     *  console.log('Connected !);
     * };
     *
     * // Start listening
     * api.on('connected', handler);
     *
     * // Stop listening
     * api.off('connected', handler);
     * ```
     */
    off(type, handler) {
        this.#eventemitter.removeListener(type, handler);
        return this;
    }
    /**
     * @description Attach an one-time eventemitter handler to listen to a specific event
     *
     * @param type The type of event to listen to. Available events are `connected`, `disconnected`, `ready` and `error`
     * @param handler The callback to be called when the event fires. Depending on the event type, it could fire with additional arguments.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * api.once('connected', (): void => {
     *   console.log('API has been connected to the endpoint');
     * });
     *
     * api.once('disconnected', (): void => {
     *   console.log('API has been disconnected from the endpoint');
     * });
     * ```
     */
    once(type, handler) {
        this.#eventemitter.once(type, handler);
        return this;
    }
}

const PAGE_SIZE_K = 1000; // limit aligned with the 1k on the node (trie lookups are heavy)
const PAGE_SIZE_V = 250; // limited since the data may be > 16MB (e.g. misfiring elections)
const PAGE_SIZE_Q = 50; // queue of pending storage queries (mapped together, next tick)
const l$1 = logger('api/init');
let instanceCounter = 0;
function getAtQueryFn(api, { method, section }) {
    return assertReturn(api.rx.query[section] && api.rx.query[section][method], () => `query.${section}.${method} is not available in this version of the metadata`);
}
class Decorate extends Events {
    #instanceId;
    #runtimeLog = {};
    #registry;
    #storageGetQ = [];
    #storageSubQ = [];
    // HACK Use BN import so decorateDerive works... yes, wtf.
    __phantom = new BN(0);
    _type;
    _call = {};
    _consts = {};
    _derive;
    _errors = {};
    _events = {};
    _extrinsics;
    _extrinsicType = GenericExtrinsic.LATEST_EXTRINSIC_VERSION;
    _genesisHash;
    _isConnected;
    _isReady = false;
    _query = {};
    _queryMulti;
    _rpc;
    _rpcCore;
    _runtimeMap = {};
    _runtimeChain;
    _runtimeMetadata;
    _runtimeVersion;
    _rx = { call: {}, consts: {}, query: {}, tx: {} };
    _options;
    /**
     * This is the one and only method concrete children classes need to implement.
     * It's a higher-order function, which takes one argument
     * `method: Method extends (...args: any[]) => Observable<any>`
     * (and one optional `options`), and should return the user facing method.
     * For example:
     * - For ApiRx, `decorateMethod` should just be identity, because the input
     * function is already an Observable
     * - For ApiPromise, `decorateMethod` should return a function that takes all
     * the parameters from `method`, adds an optional `callback` argument, and
     * returns a Promise.
     *
     * We could easily imagine other user-facing interfaces, which are simply
     * implemented by transforming the Observable to Stream/Iterator/Kefir/Bacon
     * via `decorateMethod`.
     */
    _decorateMethod;
    /**
     * @description Create an instance of the class
     *
     * @param options Options object to create API instance or a Provider instance
     *
     * @example
     * <BR>
     *
     * ```javascript
     * import Api from '@polkadot/api/promise';
     *
     * const api = new Api().isReady();
     *
     * api.rpc.subscribeNewHeads((header) => {
     *   console.log(`new block #${header.number.toNumber()}`);
     * });
     * ```
     */
    constructor(options, type, decorateMethod) {
        super();
        this.#instanceId = `${++instanceCounter}`;
        this.#registry = options.source?.registry || options.registry || new TypeRegistry();
        this._rx.callAt = (blockHash, knownVersion) => from(this.at(blockHash, knownVersion)).pipe(map((a) => a.rx.call));
        this._rx.queryAt = (blockHash, knownVersion) => from(this.at(blockHash, knownVersion)).pipe(map((a) => a.rx.query));
        this._rx.registry = this.#registry;
        this._decorateMethod = decorateMethod;
        this._options = options;
        this._type = type;
        const provider = options.source
            ? options.source._rpcCore.provider.isClonable
                ? options.source._rpcCore.provider.clone()
                : options.source._rpcCore.provider
            : (options.provider || new WsProvider());
        // The RPC interface decorates the known interfaces on init
        this._rpcCore = new RpcCore(this.#instanceId, this.#registry, {
            isPedantic: this._options.isPedantic,
            provider,
            rpcCacheCapacity: this._options.rpcCacheCapacity,
            ttl: this._options.provider?.ttl,
            userRpc: this._options.rpc
        });
        this._isConnected = new BehaviorSubject(this._rpcCore.provider.isConnected);
        this._rx.hasSubscriptions = this._rpcCore.provider.hasSubscriptions;
    }
    /**
     * @description Return the current used registry
     */
    get registry() {
        return this.#registry;
    }
    /**
     * @description Creates an instance of a type as registered
     */
    createType(type, ...params) {
        return this.#registry.createType(type, ...params);
    }
    /**
     * @description Register additional user-defined of chain-specific types in the type registry
     */
    registerTypes(types) {
        types && this.#registry.register(types);
    }
    /**
     * @returns `true` if the API operates with subscriptions
     */
    get hasSubscriptions() {
        return this._rpcCore.provider.hasSubscriptions;
    }
    /**
     * @returns `true` if the API decorate multi-key queries
     */
    get supportMulti() {
        return this._rpcCore.provider.hasSubscriptions || !!this._rpcCore.state.queryStorageAt;
    }
    _emptyDecorated(registry, blockHash) {
        return {
            call: {},
            consts: {},
            errors: {},
            events: {},
            query: {},
            registry,
            rx: {
                call: {},
                query: {}
            },
            tx: createSubmittable(this._type, this._rx, this._decorateMethod, registry, blockHash)
        };
    }
    _createDecorated(registry, fromEmpty, decoratedApi, blockHash) {
        if (!decoratedApi) {
            decoratedApi = this._emptyDecorated(registry.registry, blockHash);
        }
        if (fromEmpty || !registry.decoratedMeta) {
            registry.decoratedMeta = expandMetadata(registry.registry, registry.metadata);
        }
        const runtime = this._decorateCalls(registry, this._decorateMethod, blockHash);
        const runtimeRx = this._decorateCalls(registry, this._rxDecorateMethod, blockHash);
        const storage = this._decorateStorage(registry.decoratedMeta, this._decorateMethod, blockHash);
        const storageRx = this._decorateStorage(registry.decoratedMeta, this._rxDecorateMethod, blockHash);
        augmentObject('consts', registry.decoratedMeta.consts, decoratedApi.consts, fromEmpty);
        augmentObject('errors', registry.decoratedMeta.errors, decoratedApi.errors, fromEmpty);
        augmentObject('events', registry.decoratedMeta.events, decoratedApi.events, fromEmpty);
        augmentObject('query', storage, decoratedApi.query, fromEmpty);
        augmentObject('query', storageRx, decoratedApi.rx.query, fromEmpty);
        augmentObject('call', runtime, decoratedApi.call, fromEmpty);
        augmentObject('call', runtimeRx, decoratedApi.rx.call, fromEmpty);
        decoratedApi.findCall = (callIndex) => findCall(registry.registry, callIndex);
        decoratedApi.findError = (errorIndex) => findError(registry.registry, errorIndex);
        decoratedApi.queryMulti = blockHash
            ? this._decorateMultiAt(decoratedApi, this._decorateMethod, blockHash)
            : this._decorateMulti(this._decorateMethod);
        decoratedApi.runtimeVersion = registry.runtimeVersion;
        return {
            createdAt: blockHash,
            decoratedApi,
            decoratedMeta: registry.decoratedMeta
        };
    }
    _injectMetadata(registry, fromEmpty = false) {
        // clear the decoration, we are redoing it here
        if (fromEmpty || !registry.decoratedApi) {
            registry.decoratedApi = this._emptyDecorated(registry.registry);
        }
        const { decoratedApi, decoratedMeta } = this._createDecorated(registry, fromEmpty, registry.decoratedApi);
        this._call = decoratedApi.call;
        this._consts = decoratedApi.consts;
        this._errors = decoratedApi.errors;
        this._events = decoratedApi.events;
        this._query = decoratedApi.query;
        this._rx.call = decoratedApi.rx.call;
        this._rx.query = decoratedApi.rx.query;
        const tx = this._decorateExtrinsics(decoratedMeta, this._decorateMethod);
        const rxtx = this._decorateExtrinsics(decoratedMeta, this._rxDecorateMethod);
        if (fromEmpty || !this._extrinsics) {
            this._extrinsics = tx;
            this._rx.tx = rxtx;
        }
        else {
            augmentObject('tx', tx, this._extrinsics, false);
            augmentObject(null, rxtx, this._rx.tx, false);
        }
        augmentObject(null, decoratedMeta.consts, this._rx.consts, fromEmpty);
        this.emit('decorated');
    }
    /**
     * @deprecated
     * backwards compatible endpoint for metadata injection, may be removed in the future (However, it is still useful for testing injection)
     */
    injectMetadata(metadata, fromEmpty, registry) {
        this._injectMetadata({ counter: 0, metadata, registry: registry || this.#registry, runtimeVersion: this.#registry.createType('RuntimeVersionPartial') }, fromEmpty);
    }
    _decorateFunctionMeta(input, output) {
        output.meta = input.meta;
        output.method = input.method;
        output.section = input.section;
        output.toJSON = input.toJSON;
        if (input.callIndex) {
            output.callIndex = input.callIndex;
        }
        return output;
    }
    // Filter all RPC methods based on the results of the rpc_methods call. We do this in the following
    // manner to cater for both old and new:
    //   - when the number of entries are 0, only remove the ones with isOptional (account & contracts)
    //   - when non-zero, remove anything that is not in the array (we don't do this)
    _filterRpc(methods, additional) {
        // add any specific user-base RPCs
        if (Object.keys(additional).length !== 0) {
            this._rpcCore.addUserInterfaces(additional);
            // re-decorate, only adding any new additional interfaces
            this._decorateRpc(this._rpcCore, this._decorateMethod, this._rpc);
            this._decorateRpc(this._rpcCore, this._rxDecorateMethod, this._rx.rpc);
        }
        // extract the actual sections from the methods (this is useful when
        // we try and create mappings to runtime names via a hash mapping)
        const sectionMap = {};
        for (let i = 0, count = methods.length; i < count; i++) {
            const [section] = methods[i].split('_');
            sectionMap[section] = true;
        }
        // convert the actual section names into an easy name lookup
        const sections = Object.keys(sectionMap);
        for (let i = 0, count = sections.length; i < count; i++) {
            const nameA = stringUpperFirst(sections[i]);
            const nameB = `${nameA}Api`;
            this._runtimeMap[blake2AsHex(nameA, 64)] = nameA;
            this._runtimeMap[blake2AsHex(nameB, 64)] = nameB;
        }
        // finally we filter the actual methods to expose
        this._filterRpcMethods(methods);
    }
    _filterRpcMethods(exposed) {
        const hasResults = exposed.length !== 0;
        const allKnown = [...this._rpcCore.mapping.entries()];
        const allKeys = [];
        const count = allKnown.length;
        for (let i = 0; i < count; i++) {
            const [, { alias, endpoint, method, pubsub, section }] = allKnown[i];
            allKeys.push(`${section}_${method}`);
            if (pubsub) {
                allKeys.push(`${section}_${pubsub[1]}`);
                allKeys.push(`${section}_${pubsub[2]}`);
            }
            if (alias) {
                allKeys.push(...alias);
            }
            if (endpoint) {
                allKeys.push(endpoint);
            }
        }
        const unknown = exposed.filter((k) => !allKeys.includes(k) &&
            !k.includes('_unstable_'));
        if (unknown.length && !this._options.noInitWarn) {
            l$1.warn(`RPC methods not decorated: ${unknown.join(', ')}`);
        }
        // loop through all entries we have (populated in decorate) and filter as required
        // only remove when we have results and method missing, or with no results if optional
        for (let i = 0; i < count; i++) {
            const [k, { method, section }] = allKnown[i];
            if (hasResults && !exposed.includes(k) && k !== 'rpc_methods') {
                if (this._rpc[section]) {
                    delete this._rpc[section][method];
                    delete this._rx.rpc[section][method];
                }
            }
        }
    }
    _rpcSubmitter(decorateMethod) {
        const method = (method, ...params) => {
            return from(this._rpcCore.provider.send(method, params));
        };
        return decorateMethod(method);
    }
    _decorateRpc(rpc, decorateMethod, input = this._rpcSubmitter(decorateMethod)) {
        const out = input;
        const decorateFn = (section, method) => {
            const source = rpc[section][method];
            const fn = decorateMethod(source, { methodName: method });
            fn.meta = source.meta;
            fn.raw = decorateMethod(source.raw, { methodName: method });
            return fn;
        };
        for (let s = 0, scount = rpc.sections.length; s < scount; s++) {
            const section = rpc.sections[s];
            if (!Object.prototype.hasOwnProperty.call(out, section)) {
                const methods = Object.keys(rpc[section]);
                const decorateInternal = (method) => decorateFn(section, method);
                for (let m = 0, mcount = methods.length; m < mcount; m++) {
                    const method = methods[m];
                    //  skip subscriptions where we have a non-subscribe interface
                    if (this.hasSubscriptions || !(method.startsWith('subscribe') || method.startsWith('unsubscribe'))) {
                        if (!Object.prototype.hasOwnProperty.call(out, section)) {
                            out[section] = {};
                        }
                        lazyMethod(out[section], method, decorateInternal);
                    }
                }
            }
        }
        return out;
    }
    // add all definition entries
    _addRuntimeDef(result, additional) {
        if (!additional) {
            return;
        }
        const entries = Object.entries(additional);
        for (let j = 0, ecount = entries.length; j < ecount; j++) {
            const [key, defs] = entries[j];
            if (result[key]) {
                // we have this one already, step through for new versions or
                // new methods and add those as applicable
                for (let k = 0, dcount = defs.length; k < dcount; k++) {
                    const def = defs[k];
                    const prev = result[key].find(({ version }) => def.version === version);
                    if (prev) {
                        // interleave the new methods with the old - last definition wins
                        objectSpread(prev.methods, def.methods);
                    }
                    else {
                        // we don't have this specific version, add it
                        result[key].push(def);
                    }
                }
            }
            else {
                // we don't have this runtime definition, add it as-is
                result[key] = defs;
            }
        }
    }
    // extract all runtime definitions
    _getRuntimeDefs(registry, specName, chain = '') {
        const result = {};
        const defValues = Object.values(typeDefinitions);
        // options > chain/spec > built-in, apply in reverse order with
        // methods overriding previous definitions (or interleave missing)
        for (let i = 0, count = defValues.length; i < count; i++) {
            this._addRuntimeDef(result, defValues[i].runtime);
        }
        this._addRuntimeDef(result, getSpecRuntime(registry, chain, specName));
        this._addRuntimeDef(result, this._options.runtime);
        return Object.entries(result);
    }
    // Helper for _getRuntimeDefsViaMetadata
    _getMethods(registry, methods) {
        const result = {};
        methods.forEach((m) => {
            const { docs, inputs, name, output } = m;
            result[name.toString()] = {
                description: docs.map((d) => d.toString()).join(),
                params: inputs.map(({ name, type }) => {
                    return { name: name.toString(), type: registry.lookup.getName(type) || registry.lookup.getTypeDef(type).type };
                }),
                type: registry.lookup.getName(output) || registry.lookup.getTypeDef(output).type
            };
        });
        return result;
    }
    // Maintains the same structure as `_getRuntimeDefs` in order to make conversion easier.
    _getRuntimeDefsViaMetadata(registry) {
        const result = {};
        const { apis } = registry.metadata;
        for (let i = 0, count = apis.length; i < count; i++) {
            const { methods, name } = apis[i];
            result[name.toString()] = [{
                    methods: this._getMethods(registry, methods),
                    // We set the version to 0 here since it will not be relevant when we are grabbing the runtime apis
                    // from the Metadata.
                    version: 0
                }];
        }
        return Object.entries(result);
    }
    // When the calls are available in the metadata, it will generate them based off of the metadata.
    // When they are not available it will use the hardcoded calls generated in the static types.
    _decorateCalls({ registry, runtimeVersion: { apis, specName, specVersion } }, decorateMethod, blockHash) {
        const result = {};
        const named = {};
        const hashes = {};
        const isApiInMetadata = registry.metadata.apis.length > 0;
        const sections = isApiInMetadata ? this._getRuntimeDefsViaMetadata(registry) : this._getRuntimeDefs(registry, specName, this._runtimeChain);
        const older = [];
        const implName = `${specName.toString()}/${specVersion.toString()}`;
        const hasLogged = this.#runtimeLog[implName] || false;
        this.#runtimeLog[implName] = true;
        if (isApiInMetadata) {
            for (let i = 0, scount = sections.length; i < scount; i++) {
                const [_section, secs] = sections[i];
                const sec = secs[0];
                const sectionHash = blake2AsHex(_section, 64);
                const section = stringCamelCase(_section);
                const methods = Object.entries(sec.methods);
                if (!named[section]) {
                    named[section] = {};
                }
                for (let m = 0, mcount = methods.length; m < mcount; m++) {
                    const [_method, def] = methods[m];
                    const method = stringCamelCase(_method);
                    named[section][method] = objectSpread({ method, name: `${_section}_${_method}`, section, sectionHash }, def);
                }
            }
        }
        else {
            for (let i = 0, scount = sections.length; i < scount; i++) {
                const [_section, secs] = sections[i];
                const sectionHash = blake2AsHex(_section, 64);
                const rtApi = apis.find(([a]) => a.eq(sectionHash));
                hashes[sectionHash] = true;
                if (rtApi) {
                    const all = secs.map(({ version }) => version).sort();
                    const sec = secs.find(({ version }) => rtApi[1].eq(version));
                    if (sec) {
                        const section = stringCamelCase(_section);
                        const methods = Object.entries(sec.methods);
                        if (methods.length) {
                            if (!named[section]) {
                                named[section] = {};
                            }
                            for (let m = 0, mcount = methods.length; m < mcount; m++) {
                                const [_method, def] = methods[m];
                                const method = stringCamelCase(_method);
                                named[section][method] = objectSpread({ method, name: `${_section}_${_method}`, section, sectionHash }, def);
                            }
                        }
                    }
                    else {
                        older.push(`${_section}/${rtApi[1].toString()} (${all.join('/')} known)`);
                    }
                }
            }
            // find the runtimes that we don't have hashes for
            const notFound = apis
                .map(([a, v]) => [a.toHex(), v.toString()])
                .filter(([a]) => !hashes[a])
                .map(([a, v]) => `${this._runtimeMap[a] || a}/${v}`);
            if (!this._options.noInitWarn && !hasLogged) {
                if (older.length) {
                    l$1.warn(`${implName}: Not decorating runtime apis without matching versions: ${older.join(', ')}`);
                }
                if (notFound.length) {
                    l$1.warn(`${implName}: Not decorating unknown runtime apis: ${notFound.join(', ')}`);
                }
            }
        }
        const stateCall = blockHash
            ? (name, bytes) => this._rpcCore.state.call(name, bytes, blockHash)
            : (name, bytes) => this._rpcCore.state.call(name, bytes);
        const lazySection = (section) => lazyMethods({}, Object.keys(named[section]), (method) => this._decorateCall(registry, named[section][method], stateCall, decorateMethod));
        const modules = Object.keys(named);
        for (let i = 0, count = modules.length; i < count; i++) {
            lazyMethod(result, modules[i], lazySection);
        }
        return result;
    }
    _decorateCall(registry, def, stateCall, decorateMethod) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const decorated = decorateMethod((...args) => {
            if (args.length !== def.params.length) {
                throw new Error(`${def.name}:: Expected ${def.params.length} arguments, found ${args.length}`);
            }
            const bytes = registry.createType('Raw', u8aConcatStrict(args.map((a, i) => registry.createTypeUnsafe(def.params[i].type, [a]).toU8a())));
            return stateCall(def.name, bytes).pipe(map((r) => registry.createTypeUnsafe(def.type, [r])));
        });
        decorated.meta = def;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return decorated;
    }
    // only be called if supportMulti is true
    _decorateMulti(decorateMethod) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return decorateMethod((keys) => keys.length
            ? (this.hasSubscriptions
                ? this._rpcCore.state.subscribeStorage
                : this._rpcCore.state.queryStorageAt)(keys.map((args) => Array.isArray(args)
                ? args[0].creator.meta.type.isPlain
                    ? [args[0].creator]
                    : args[0].creator.meta.type.asMap.hashers.length === 1
                        ? [args[0].creator, args.slice(1)]
                        : [args[0].creator, ...args.slice(1)]
                : [args.creator]))
            : of([]));
    }
    _decorateMultiAt(atApi, decorateMethod, blockHash) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return decorateMethod((calls) => calls.length
            ? this._rpcCore.state.queryStorageAt(calls.map((args) => {
                if (Array.isArray(args)) {
                    const { creator } = getAtQueryFn(atApi, args[0].creator);
                    return creator.meta.type.isPlain
                        ? [creator]
                        : creator.meta.type.asMap.hashers.length === 1
                            ? [creator, args.slice(1)]
                            : [creator, ...args.slice(1)];
                }
                return [getAtQueryFn(atApi, args.creator).creator];
            }), blockHash)
            : of([]));
    }
    _decorateExtrinsics({ tx }, decorateMethod) {
        const result = createSubmittable(this._type, this._rx, decorateMethod);
        const lazySection = (section) => lazyMethods({}, Object.keys(tx[section]), (method) => method.startsWith('$')
            ? tx[section][method]
            : this._decorateExtrinsicEntry(tx[section][method], result));
        const sections = Object.keys(tx);
        for (let i = 0, count = sections.length; i < count; i++) {
            lazyMethod(result, sections[i], lazySection);
        }
        return result;
    }
    _decorateExtrinsicEntry(method, creator) {
        const decorated = (...params) => creator(method(...params));
        // pass through the `.is`
        decorated.is = (other) => method.is(other);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this._decorateFunctionMeta(method, decorated);
    }
    _decorateStorage({ query, registry }, decorateMethod, blockHash) {
        const result = {};
        const lazySection = (section) => lazyMethods({}, Object.keys(query[section]), (method) => blockHash
            ? this._decorateStorageEntryAt(registry, query[section][method], decorateMethod, blockHash)
            : this._decorateStorageEntry(query[section][method], decorateMethod));
        const sections = Object.keys(query);
        for (let i = 0, count = sections.length; i < count; i++) {
            lazyMethod(result, sections[i], lazySection);
        }
        return result;
    }
    _decorateStorageEntry(creator, decorateMethod) {
        const getArgs = (args, registry) => extractStorageArgs(registry || this.#registry, creator, args);
        const getQueryAt = (blockHash) => from(this.at(blockHash)).pipe(map((api) => getAtQueryFn(api, creator)));
        // Disable this where it occurs for each field we are decorating
        /* eslint-disable @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment */
        const decorated = this._decorateStorageCall(creator, decorateMethod);
        decorated.creator = creator;
        // eslint-disable-next-line deprecation/deprecation
        decorated.at = decorateMethod((blockHash, ...args) => getQueryAt(blockHash).pipe(switchMap((q) => q(...args))));
        decorated.hash = decorateMethod((...args) => this._rpcCore.state.getStorageHash(getArgs(args)));
        decorated.is = (key) => key.section === creator.section &&
            key.method === creator.method;
        decorated.key = (...args) => u8aToHex(compactStripLength(creator(...args))[1]);
        decorated.keyPrefix = (...args) => u8aToHex(creator.keyPrefix(...args));
        decorated.size = decorateMethod((...args) => this._rpcCore.state.getStorageSize(getArgs(args)));
        // eslint-disable-next-line deprecation/deprecation
        decorated.sizeAt = decorateMethod((blockHash, ...args) => getQueryAt(blockHash).pipe(switchMap((q) => this._rpcCore.state.getStorageSize(getArgs(args, q.creator.meta.registry), blockHash))));
        // .keys() & .entries() only available on map types
        if (creator.iterKey && creator.meta.type.isMap) {
            decorated.entries = decorateMethod(memo(this.#instanceId, (...args) => this._retrieveMapEntries(creator, null, args)));
            // eslint-disable-next-line deprecation/deprecation
            decorated.entriesAt = decorateMethod(memo(this.#instanceId, (blockHash, ...args) => getQueryAt(blockHash).pipe(switchMap((q) => this._retrieveMapEntries(q.creator, blockHash, args)))));
            decorated.entriesPaged = decorateMethod(memo(this.#instanceId, (opts) => this._retrieveMapEntriesPaged(creator, undefined, opts)));
            decorated.keys = decorateMethod(memo(this.#instanceId, (...args) => this._retrieveMapKeys(creator, null, args)));
            // eslint-disable-next-line deprecation/deprecation
            decorated.keysAt = decorateMethod(memo(this.#instanceId, (blockHash, ...args) => getQueryAt(blockHash).pipe(switchMap((q) => this._retrieveMapKeys(q.creator, blockHash, args)))));
            decorated.keysPaged = decorateMethod(memo(this.#instanceId, (opts) => this._retrieveMapKeysPaged(creator, undefined, opts)));
        }
        if (this.supportMulti && creator.meta.type.isMap) {
            // When using double map storage function, user need to pass double map key as an array
            decorated.multi = decorateMethod((args) => creator.meta.type.asMap.hashers.length === 1
                ? this._retrieveMulti(args.map((a) => [creator, [a]]))
                : this._retrieveMulti(args.map((a) => [creator, a])));
        }
        /* eslint-enable @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment */
        return this._decorateFunctionMeta(creator, decorated);
    }
    _decorateStorageEntryAt(registry, creator, decorateMethod, blockHash) {
        const getArgs = (args) => extractStorageArgs(registry, creator, args);
        // Disable this where it occurs for each field we are decorating
        /* eslint-disable @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment */
        const decorated = decorateMethod((...args) => this._rpcCore.state.getStorage(getArgs(args), blockHash));
        decorated.creator = creator;
        decorated.hash = decorateMethod((...args) => this._rpcCore.state.getStorageHash(getArgs(args), blockHash));
        decorated.is = (key) => key.section === creator.section &&
            key.method === creator.method;
        decorated.key = (...args) => u8aToHex(compactStripLength(creator(...args))[1]);
        decorated.keyPrefix = (...keys) => u8aToHex(creator.keyPrefix(...keys));
        decorated.size = decorateMethod((...args) => this._rpcCore.state.getStorageSize(getArgs(args), blockHash));
        // .keys() & .entries() only available on map types
        if (creator.iterKey && creator.meta.type.isMap) {
            decorated.entries = decorateMethod(memo(this.#instanceId, (...args) => this._retrieveMapEntries(creator, blockHash, args)));
            decorated.entriesPaged = decorateMethod(memo(this.#instanceId, (opts) => this._retrieveMapEntriesPaged(creator, blockHash, opts)));
            decorated.keys = decorateMethod(memo(this.#instanceId, (...args) => this._retrieveMapKeys(creator, blockHash, args)));
            decorated.keysPaged = decorateMethod(memo(this.#instanceId, (opts) => this._retrieveMapKeysPaged(creator, blockHash, opts)));
        }
        if (this.supportMulti && creator.meta.type.isMap) {
            // When using double map storage function, user need to pass double map key as an array
            decorated.multi = decorateMethod((args) => creator.meta.type.asMap.hashers.length === 1
                ? this._retrieveMulti(args.map((a) => [creator, [a]]), blockHash)
                : this._retrieveMulti(args.map((a) => [creator, a]), blockHash));
        }
        /* eslint-enable @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment */
        return this._decorateFunctionMeta(creator, decorated);
    }
    _queueStorage(call, queue) {
        const query = queue === this.#storageSubQ
            ? this._rpcCore.state.subscribeStorage
            : this._rpcCore.state.queryStorageAt;
        let queueIdx = queue.length - 1;
        let valueIdx = 0;
        let valueObs;
        // if we don't have queue entries yet,
        // or the current queue has fired (see from below),
        // or the current queue has the max entries,
        // then we create a new queue
        if (queueIdx === -1 || !queue[queueIdx] || queue[queueIdx][1].length === PAGE_SIZE_Q) {
            queueIdx++;
            valueObs = from(
            // we delay the execution until the next tick, this allows
            // any queries made in this timeframe to be added to the same
            // queue for a single query
            new Promise((resolve) => {
                nextTick(() => {
                    // get all the calls in this instance, resolve with it
                    // and then clear the queue so we don't add more
                    // (anything after this will be added to a new queue)
                    const calls = queue[queueIdx][1];
                    delete queue[queueIdx];
                    resolve(calls);
                });
            })).pipe(switchMap((calls) => query(calls)));
            queue.push([valueObs, [call]]);
        }
        else {
            valueObs = queue[queueIdx][0];
            valueIdx = queue[queueIdx][1].length;
            queue[queueIdx][1].push(call);
        }
        return valueObs.pipe(
        // return the single value at this index
        map((values) => values[valueIdx]));
    }
    // Decorate the base storage call. In the case or rxjs or promise-without-callback (await)
    // we make a subscription, alternatively we push this through a single-shot query
    _decorateStorageCall(creator, decorateMethod) {
        const memoed = memo(this.#instanceId, (...args) => {
            const call = extractStorageArgs(this.#registry, creator, args);
            if (!this.hasSubscriptions) {
                return this._rpcCore.state.getStorage(call);
            }
            return this._queueStorage(call, this.#storageSubQ);
        });
        return decorateMethod(memoed, {
            methodName: creator.method,
            overrideNoSub: (...args) => this._queueStorage(extractStorageArgs(this.#registry, creator, args), this.#storageGetQ)
        });
    }
    // retrieve a set of values for a specific set of keys - here we chunk the keys into PAGE_SIZE sizes
    _retrieveMulti(keys, blockHash) {
        if (!keys.length) {
            return of([]);
        }
        const query = this.hasSubscriptions && !blockHash
            ? this._rpcCore.state.subscribeStorage
            : this._rpcCore.state.queryStorageAt;
        if (keys.length <= PAGE_SIZE_V) {
            return blockHash
                ? query(keys, blockHash)
                : query(keys);
        }
        return combineLatest(arrayChunk(keys, PAGE_SIZE_V).map((k) => blockHash
            ? query(k, blockHash)
            : query(k))).pipe(map(arrayFlatten));
    }
    _retrieveMapKeys({ iterKey, meta, method, section }, at, args) {
        if (!iterKey || !meta.type.isMap) {
            throw new Error('keys can only be retrieved on maps');
        }
        const headKey = iterKey(...args).toHex();
        const startSubject = new BehaviorSubject(headKey);
        const query = at
            ? (startKey) => this._rpcCore.state.getKeysPaged(headKey, PAGE_SIZE_K, startKey, at)
            : (startKey) => this._rpcCore.state.getKeysPaged(headKey, PAGE_SIZE_K, startKey);
        const setMeta = (key) => key.setMeta(meta, section, method);
        return startSubject.pipe(switchMap(query), map((keys) => keys.map(setMeta)), tap((keys) => nextTick(() => {
            keys.length === PAGE_SIZE_K
                ? startSubject.next(keys[PAGE_SIZE_K - 1].toHex())
                : startSubject.complete();
        })), toArray(), // toArray since we want to startSubject to be completed
        map(arrayFlatten));
    }
    _retrieveMapKeysPaged({ iterKey, meta, method, section }, at, opts) {
        if (!iterKey || !meta.type.isMap) {
            throw new Error('keys can only be retrieved on maps');
        }
        const setMeta = (key) => key.setMeta(meta, section, method);
        const query = at
            ? (headKey) => this._rpcCore.state.getKeysPaged(headKey, opts.pageSize, opts.startKey || headKey, at)
            : (headKey) => this._rpcCore.state.getKeysPaged(headKey, opts.pageSize, opts.startKey || headKey);
        return query(iterKey(...opts.args).toHex()).pipe(map((keys) => keys.map(setMeta)));
    }
    _retrieveMapEntries(entry, at, args) {
        const query = at
            ? (keys) => this._rpcCore.state.queryStorageAt(keys, at)
            : (keys) => this._rpcCore.state.queryStorageAt(keys);
        return this._retrieveMapKeys(entry, at, args).pipe(switchMap((keys) => keys.length
            ? combineLatest(arrayChunk(keys, PAGE_SIZE_V).map(query)).pipe(map((valsArr) => arrayFlatten(valsArr).map((value, index) => [keys[index], value])))
            : of([])));
    }
    _retrieveMapEntriesPaged(entry, at, opts) {
        const query = at
            ? (keys) => this._rpcCore.state.queryStorageAt(keys, at)
            : (keys) => this._rpcCore.state.queryStorageAt(keys);
        return this._retrieveMapKeysPaged(entry, at, opts).pipe(switchMap((keys) => keys.length
            ? query(keys).pipe(map((valsArr) => valsArr.map((value, index) => [keys[index], value])))
            : of([])));
    }
    _decorateDeriveRx(decorateMethod) {
        const specName = this._runtimeVersion?.specName.toString();
        // Pull in derive from api-derive
        const available = getAvailableDerives(this.#instanceId, this._rx, objectSpread({}, this._options.derives, this._options.typesBundle?.spec?.[specName || '']?.derives));
        return decorateDeriveSections(decorateMethod, available);
    }
    _decorateDerive(decorateMethod) {
        return decorateDeriveSections(decorateMethod, this._rx.derive);
    }
    /**
     * Put the `this.onCall` function of ApiRx here, because it is needed by
     * `api._rx`.
     */
    _rxDecorateMethod = (method) => {
        return method;
    };
}

const KEEPALIVE_INTERVAL = 10000;
const SUPPORTED_METADATA_VERSIONS = [16, 15, 14];
const l = logger('api/init');
function textToString(t) {
    return t.toString();
}
class Init extends Decorate {
    #atLast = null;
    #healthTimer = null;
    #registries = [];
    #updateSub = null;
    #waitingRegistries = {};
    constructor(options, type, decorateMethod) {
        super(options, type, decorateMethod);
        // all injected types added to the registry for overrides
        this.registry.setKnownTypes(options);
        // We only register the types (global) if this is not a cloned instance.
        // Do right up-front, so we get in the user types before we are actually
        // doing anything on-chain, this ensures we have the overrides in-place
        if (!options.source) {
            this.registerTypes(options.types);
        }
        else {
            this.#registries = options.source.#registries;
        }
        this._rpc = this._decorateRpc(this._rpcCore, this._decorateMethod);
        this._rx.rpc = this._decorateRpc(this._rpcCore, this._rxDecorateMethod);
        if (this.supportMulti) {
            this._queryMulti = this._decorateMulti(this._decorateMethod);
            this._rx.queryMulti = this._decorateMulti(this._rxDecorateMethod);
        }
        this._rx.signer = options.signer;
        this._rpcCore.setRegistrySwap((blockHash) => this.getBlockRegistry(blockHash));
        this._rpcCore.setResolveBlockHash((blockNumber) => firstValueFrom(this._rpcCore.chain.getBlockHash(blockNumber)));
        if (this.hasSubscriptions) {
            this._rpcCore.provider.on('disconnected', () => this.#onProviderDisconnect());
            this._rpcCore.provider.on('error', (e) => this.#onProviderError(e));
            this._rpcCore.provider.on('connected', () => this.#onProviderConnect());
        }
        else if (!this._options.noInitWarn) {
            l.warn('Api will be available in a limited mode since the provider does not support subscriptions');
        }
        // If the provider was instantiated earlier, and has already emitted a
        // 'connected' event, then the `on('connected')` won't fire anymore. To
        // cater for this case, we call manually `this._onProviderConnect`.
        if (this._rpcCore.provider.isConnected) {
            this.#onProviderConnect().catch(noop$1);
        }
    }
    /**
     * @description Decorates a registry based on the runtime version
     */
    _initRegistry(registry, chain, version, metadata, chainProps) {
        registry.clearCache();
        registry.setChainProperties(chainProps || this.registry.getChainProperties());
        registry.setKnownTypes(this._options);
        registry.register(getSpecTypes(registry, chain, version.specName, version.specVersion));
        registry.setHasher(getSpecHasher(registry, chain, version.specName));
        // for bundled types, pull through the aliases defined
        if (registry.knownTypes.typesBundle) {
            registry.knownTypes.typesAlias = getSpecAlias(registry, chain, version.specName);
        }
        registry.setMetadata(metadata, undefined, objectSpread({}, getSpecExtensions(registry, chain, version.specName), this._options.signedExtensions), this._options.noInitWarn);
    }
    /**
     * @description Returns the default versioned registry
     */
    _getDefaultRegistry() {
        return assertReturn(this.#registries.find(({ isDefault }) => isDefault), 'Initialization error, cannot find the default registry');
    }
    /**
     * @description Returns a decorated API instance at a specific point in time
     */
    async at(blockHash, knownVersion) {
        const u8aHash = u8aToU8a(blockHash);
        const u8aHex = u8aToHex(u8aHash);
        const registry = await this.getBlockRegistry(u8aHash, knownVersion);
        if (!this.#atLast || this.#atLast[0] !== u8aHex) {
            // always create a new decoration - since we are pointing to a specific hash, this
            // means that all queries needs to use that hash (not a previous one already existing)
            this.#atLast = [u8aHex, this._createDecorated(registry, true, null, u8aHash).decoratedApi];
        }
        return this.#atLast[1];
    }
    async _createBlockRegistry(blockHash, header, version) {
        const registry = new TypeRegistry(blockHash);
        const metadata = await this._retrieveMetadata(version.apis, header.parentHash, registry);
        const runtimeChain = this._runtimeChain;
        if (!runtimeChain) {
            throw new Error('Invalid initializion order, runtimeChain is not available');
        }
        this._initRegistry(registry, runtimeChain, version, metadata);
        // add our new registry
        const result = { counter: 0, lastBlockHash: blockHash, metadata, registry, runtimeVersion: version };
        this.#registries.push(result);
        return result;
    }
    _cacheBlockRegistryProgress(key, creator) {
        // look for waiting resolves
        let waiting = this.#waitingRegistries[key];
        if (isUndefined(waiting)) {
            // nothing waiting, construct new
            waiting = this.#waitingRegistries[key] = new Promise((resolve, reject) => {
                creator()
                    .then((registry) => {
                    delete this.#waitingRegistries[key];
                    resolve(registry);
                })
                    .catch((error) => {
                    delete this.#waitingRegistries[key];
                    reject(error);
                });
            });
        }
        return waiting;
    }
    _getBlockRegistryViaVersion(blockHash, version) {
        if (version) {
            // check for pre-existing registries. We also check specName, e.g. it
            // could be changed like in Westmint with upgrade from shell -> westmint
            const existingViaVersion = this.#registries.find(({ runtimeVersion: { specName, specVersion } }) => specName.eq(version.specName) &&
                specVersion.eq(version.specVersion));
            if (existingViaVersion) {
                existingViaVersion.counter++;
                existingViaVersion.lastBlockHash = blockHash;
                return existingViaVersion;
            }
        }
        return null;
    }
    async _getBlockRegistryViaHash(blockHash) {
        // ensure we have everything required
        if (!this._genesisHash || !this._runtimeVersion) {
            throw new Error('Cannot retrieve data on an uninitialized chain');
        }
        // We have to assume that on the RPC layer the calls used here does not call back into
        // the registry swap, so getHeader & getRuntimeVersion should not be historic
        const header = this.registry.createType('HeaderPartial', this._genesisHash.eq(blockHash)
            ? { number: BN_ZERO, parentHash: this._genesisHash }
            : await firstValueFrom(this._rpcCore.chain.getHeader.raw(blockHash)));
        if (header.parentHash.isEmpty) {
            l.warn(`Unable to retrieve header ${blockHash.toString()} and parent ${header.parentHash.toString()} from supplied hash`);
            throw new Error('Unable to retrieve header and parent from supplied hash');
        }
        // get the runtime version, either on-chain or via an known upgrade history
        getUpgradeVersion(this._genesisHash, header.number);
        const version = this.registry.createType('RuntimeVersionPartial', await firstValueFrom(this._rpcCore.state.getRuntimeVersion.raw(header.parentHash)));
        return (
        // try to find via version
        this._getBlockRegistryViaVersion(blockHash, version) ||
            // return new or in-flight result
            await this._cacheBlockRegistryProgress(version.toHex(), () => this._createBlockRegistry(blockHash, header, version)));
    }
    /**
     * @description Sets up a registry based on the block hash defined
     */
    async getBlockRegistry(blockHash, knownVersion) {
        return (
        // try to find via blockHash
        this.#registries.find(({ lastBlockHash }) => lastBlockHash && u8aEq(lastBlockHash, blockHash)) ||
            // try to find via version
            this._getBlockRegistryViaVersion(blockHash, knownVersion) ||
            // return new or in-flight result
            await this._cacheBlockRegistryProgress(u8aToHex(blockHash), () => this._getBlockRegistryViaHash(blockHash)));
    }
    async _loadMeta() {
        // on re-connection to the same chain, we don't want to re-do everything from chain again
        if (this._isReady) {
            // on re-connection only re-subscribe to chain updates if we are not a clone
            if (!this._options.source) {
                this._subscribeUpdates();
            }
            return true;
        }
        this._unsubscribeUpdates();
        // only load from on-chain if we are not a clone (default path), alternatively
        // just use the values from the source instance provided
        [this._genesisHash, this._runtimeMetadata] = this._options.source?._isReady
            ? await this._metaFromSource(this._options.source)
            : await this._metaFromChain(this._options.metadata);
        return this._initFromMeta(this._runtimeMetadata);
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    async _metaFromSource(source) {
        this._extrinsicType = source.extrinsicVersion;
        this._runtimeChain = source.runtimeChain;
        this._runtimeVersion = source.runtimeVersion;
        // manually build a list of all available methods in this RPC, we are
        // going to filter on it to align the cloned RPC without making a call
        const sections = Object.keys(source.rpc);
        const rpcs = [];
        for (let s = 0, scount = sections.length; s < scount; s++) {
            const section = sections[s];
            const methods = Object.keys(source.rpc[section]);
            for (let m = 0, mcount = methods.length; m < mcount; m++) {
                rpcs.push(`${section}_${methods[m]}`);
            }
        }
        this._filterRpc(rpcs, getSpecRpc(this.registry, source.runtimeChain, source.runtimeVersion.specName));
        return [source.genesisHash, source.runtimeMetadata];
    }
    // subscribe to metadata updates, inject the types on changes
    _subscribeUpdates() {
        if (this.#updateSub || !this.hasSubscriptions) {
            return;
        }
        this.#updateSub = this._rpcCore.state.subscribeRuntimeVersion().pipe(switchMap((version) => 
        // only retrieve the metadata when the on-chain version has been changed
        this._runtimeVersion?.specVersion.eq(version.specVersion)
            ? of(false)
            : this._rpcCore.state.getMetadata().pipe(map((metadata) => {
                l.log(`Runtime version updated to spec=${version.specVersion.toString()}, tx=${version.transactionVersion.toString()}`);
                this._runtimeMetadata = metadata;
                this._runtimeVersion = version;
                this._rx.runtimeVersion = version;
                // update the default registry version
                const thisRegistry = this._getDefaultRegistry();
                const runtimeChain = this._runtimeChain;
                if (!runtimeChain) {
                    throw new Error('Invalid initializion order, runtimeChain is not available');
                }
                // setup the data as per the current versions
                thisRegistry.metadata = metadata;
                thisRegistry.runtimeVersion = version;
                this._initRegistry(this.registry, runtimeChain, version, metadata);
                this._injectMetadata(thisRegistry, true);
                return true;
            })))).subscribe();
    }
    async _metaFromChain(optMetadata) {
        const [genesisHash, runtimeVersion, chain, chainProps, rpcMethods] = await Promise.all([
            firstValueFrom(this._rpcCore.chain.getBlockHash(0)),
            firstValueFrom(this._rpcCore.state.getRuntimeVersion()),
            firstValueFrom(this._rpcCore.system.chain()),
            firstValueFrom(this._rpcCore.system.properties()),
            firstValueFrom(this._rpcCore.rpc.methods())
        ]);
        // set our chain version & genesisHash as returned
        this._runtimeChain = chain;
        this._runtimeVersion = runtimeVersion;
        this._rx.runtimeVersion = runtimeVersion;
        // retrieve metadata, either from chain  or as pass-in via options
        const metadataKey = `${genesisHash.toHex() || '0x'}-${runtimeVersion.specVersion.toString()}`;
        const metadata = optMetadata?.[metadataKey]
            ? new Metadata(this.registry, optMetadata[metadataKey])
            : await this._retrieveMetadata(runtimeVersion.apis);
        // initializes the registry & RPC
        this._initRegistry(this.registry, chain, runtimeVersion, metadata, chainProps);
        this._filterRpc(rpcMethods.methods.map(textToString), getSpecRpc(this.registry, chain, runtimeVersion.specName));
        this._subscribeUpdates();
        // setup the initial registry, when we have none
        if (!this.#registries.length) {
            this.#registries.push({ counter: 0, isDefault: true, metadata, registry: this.registry, runtimeVersion });
        }
        // get unique types & validate
        metadata.getUniqTypes(this._options.throwOnUnknown || false);
        return [genesisHash, metadata];
    }
    _initFromMeta(metadata) {
        const runtimeVersion = this._runtimeVersion;
        if (!runtimeVersion) {
            throw new Error('Invalid initializion order, runtimeVersion is not available');
        }
        // ExtrinsicV5 is not fully supported yet, for that reason we default to version 4
        this._extrinsicType = metadata.asLatest.extrinsic.versions.at(0) || LATEST_EXTRINSIC_VERSION;
        this._rx.extrinsicType = this._extrinsicType;
        this._rx.genesisHash = this._genesisHash;
        this._rx.runtimeVersion = runtimeVersion;
        // inject metadata and adjust the types as detected
        this._injectMetadata(this._getDefaultRegistry(), true);
        // derive is last, since it uses the decorated rx
        this._rx.derive = this._decorateDeriveRx(this._rxDecorateMethod);
        this._derive = this._decorateDerive(this._decorateMethod);
        return true;
    }
    /**
     * @internal
     *
     * Tries to use runtime api calls to retrieve metadata. This ensures the api initializes with the latest metadata.
     * If the runtime call is not there it will use the rpc method.
     */
    async _retrieveMetadata(apis, at, registry) {
        let metadataVersion = null;
        const metadataApi = apis.find(([a]) => a.eq(blake2AsHex('Metadata', 64)));
        const typeRegistry = registry || this.registry;
        // This chain does not have support for the metadataApi, or does not have the required version.
        if (!metadataApi || metadataApi[1].toNumber() < 2) {
            l.warn('MetadataApi not available, rpc::state::get_metadata will be used.');
            return at
                ? new Metadata(typeRegistry, await firstValueFrom(this._rpcCore.state.getMetadata.raw(at)))
                : await firstValueFrom(this._rpcCore.state.getMetadata());
        }
        try {
            const metadataVersionsAsBytes = at
                ? await firstValueFrom(this._rpcCore.state.call.raw('Metadata_metadata_versions', '0x', at))
                : await firstValueFrom(this._rpcCore.state.call('Metadata_metadata_versions', '0x'));
            const versions = typeRegistry.createType('Vec<u32>', metadataVersionsAsBytes);
            // For unstable versions of the metadata the last value is set to u32 MAX in the runtime. This ensures only supported stable versions are used.
            metadataVersion = versions.filter((ver) => SUPPORTED_METADATA_VERSIONS.includes(ver.toNumber())).reduce((largest, current) => current.gt(largest) ? current : largest);
        }
        catch (e) {
            l.debug(e.message);
            l.warn('error with state_call::Metadata_metadata_versions, rpc::state::get_metadata will be used');
        }
        // When the metadata version does not align with the latest supported versions we ensure not to call the metadata runtime call.
        // I noticed on some previous runtimes that have support for `Metadata_metadata_at_version` that very irregular versions were being returned.
        // This was evident with runtime 1000000 - it return a very large number. This ensures we always stick within what is supported.
        if (metadataVersion && !SUPPORTED_METADATA_VERSIONS.includes(metadataVersion.toNumber())) {
            metadataVersion = null;
        }
        if (metadataVersion) {
            try {
                const metadataBytes = at
                    ? await firstValueFrom(this._rpcCore.state.call.raw('Metadata_metadata_at_version', u8aToHex(metadataVersion.toU8a()), at))
                    : await firstValueFrom(this._rpcCore.state.call('Metadata_metadata_at_version', u8aToHex(metadataVersion.toU8a())));
                // When the metadata is called with `at` it is required to use `.raw`. Therefore since the length prefix is not present the
                // need to create a `Raw` type is necessary before creating the `OpaqueMetadata` type or else there will be a magic number
                // mismatch
                const rawMeta = at
                    ? typeRegistry.createType('Raw', metadataBytes).toU8a()
                    : metadataBytes;
                const opaqueMetadata = typeRegistry.createType('Option<OpaqueMetadata>', rawMeta).unwrapOr(null);
                if (opaqueMetadata) {
                    return new Metadata(typeRegistry, opaqueMetadata.toHex());
                }
            }
            catch (e) {
                l.debug(e.message);
                l.warn('error with state_call::Metadata_metadata_at_version, rpc::state::get_metadata will be used');
            }
        }
        return at
            ? new Metadata(typeRegistry, await firstValueFrom(this._rpcCore.state.getMetadata.raw(at)))
            : await firstValueFrom(this._rpcCore.state.getMetadata());
    }
    _subscribeHealth() {
        this._unsubscribeHealth();
        // Only enable the health keepalive on WS, not needed on HTTP
        this.#healthTimer = this.hasSubscriptions
            ? setInterval(() => {
                firstValueFrom(this._rpcCore.system.health.raw()).catch(noop$1);
            }, KEEPALIVE_INTERVAL)
            : null;
    }
    _unsubscribeHealth() {
        if (this.#healthTimer) {
            clearInterval(this.#healthTimer);
            this.#healthTimer = null;
        }
    }
    _unsubscribeUpdates() {
        if (this.#updateSub) {
            this.#updateSub.unsubscribe();
            this.#updateSub = null;
        }
    }
    _unsubscribe() {
        this._unsubscribeHealth();
        this._unsubscribeUpdates();
    }
    async #onProviderConnect() {
        this._isConnected.next(true);
        this.emit('connected');
        try {
            const cryptoReady = this._options.initWasm === false
                ? true
                : await cryptoWaitReady();
            const hasMeta = await this._loadMeta();
            this._subscribeHealth();
            if (hasMeta && !this._isReady && cryptoReady) {
                this._isReady = true;
                this.emit('ready', this);
            }
        }
        catch (_error) {
            const error = new Error(`FATAL: Unable to initialize the API: ${_error.message}`);
            l.error(error);
            this.emit('error', error);
        }
    }
    #onProviderDisconnect() {
        this._isConnected.next(false);
        this._unsubscribe();
        this.emit('disconnected');
    }
    #onProviderError(error) {
        this.emit('error', error);
    }
}

function assertResult(value) {
    if (value === undefined) {
        throw new Error("Api interfaces needs to be initialized before using, wait for 'isReady'");
    }
    return value;
}
class Getters extends Init {
    /**
     * @description Runtime call interfaces (currently untyped, only decorated via API options)
     */
    get call() {
        return assertResult(this._call);
    }
    /**
     * @description Contains the parameter types (constants) of all modules.
     *
     * The values are instances of the appropriate type and are accessible using `section`.`constantName`,
     *
     * @example
     * <BR>
     *
     * ```javascript
     * console.log(api.consts.democracy.enactmentPeriod.toString())
     * ```
     */
    get consts() {
        return assertResult(this._consts);
    }
    /**
     * @description Derived results that are injected into the API, allowing for combinations of various query results.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * api.derive.chain.bestNumber((number) => {
     *   console.log('best number', number);
     * });
     * ```
     */
    get derive() {
        return assertResult(this._derive);
    }
    /**
     * @description Errors from metadata
     */
    get errors() {
        return assertResult(this._errors);
    }
    /**
     * @description Events from metadata
     */
    get events() {
        return assertResult(this._events);
    }
    /**
     * @description  Returns the version of extrinsics in-use on this chain
     */
    get extrinsicVersion() {
        return this._extrinsicType;
    }
    /**
     * @description Contains the genesis Hash of the attached chain. Apart from being useful to determine the actual chain, it can also be used to sign immortal transactions.
     */
    get genesisHash() {
        return assertResult(this._genesisHash);
    }
    /**
     * @description true is the underlying provider is connected
     */
    get isConnected() {
        return this._isConnected.getValue();
    }
    /**
     * @description The library information name & version (from package.json)
     */
    get libraryInfo() {
        return `${packageInfo.name} v${packageInfo.version}`;
    }
    /**
     * @description Contains all the chain state modules and their subsequent methods in the API. These are attached dynamically from the runtime metadata.
     *
     * All calls inside the namespace, is denoted by `section`.`method` and may take an optional query parameter. As an example, `api.query.timestamp.now()` (current block timestamp) does not take parameters, while `api.query.system.account(<accountId>)` (retrieving the associated nonce & balances for an account), takes the `AccountId` as a parameter.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * api.query.system.account(<accountId>, ([nonce, balance]) => {
     *   console.log('new free balance', balance.free, 'new nonce', nonce);
     * });
     * ```
     */
    get query() {
        return assertResult(this._query);
    }
    /**
     * @description Allows for the querying of multiple storage entries and the combination thereof into a single result. This is a very optimal way to make multiple queries since it only makes a single connection to the node and retrieves the data over one subscription.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * const unsub = await api.queryMulti(
     *   [
     *     // you can include the storage without any parameters
     *     api.query.balances.totalIssuance,
     *     // or you can pass parameters to the storage query
     *     [api.query.system.account, '5GrwvaEF5zXb26Fz9rcQpDWS57CtERHpNehXCPcNoHGKutQY']
     *   ],
     *   ([existential, [, { free }]]) => {
     *     console.log(`You have ${free.sub(existential)} more than the existential deposit`);
     *
     *     unsub();
     *   }
     * );
     * ```
     */
    get queryMulti() {
        return assertResult(this._queryMulti);
    }
    /**
     * @description Contains all the raw rpc sections and their subsequent methods in the API as defined by the jsonrpc interface definitions. Unlike the dynamic `api.query` and `api.tx` sections, these methods are fixed (although extensible with node upgrades) and not determined by the runtime.
     *
     * RPC endpoints available here allow for the query of chain, node and system information, in addition to providing interfaces for the raw queries of state (using known keys) and the submission of transactions.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * api.rpc.chain.subscribeNewHeads((header) => {
     *   console.log('new header', header);
     * });
     * ```
     */
    get rpc() {
        return assertResult(this._rpc);
    }
    /**
     * @description Contains the chain information for the current node.
     */
    get runtimeChain() {
        return assertResult(this._runtimeChain);
    }
    /**
     * @description Yields the current attached runtime metadata. Generally this is only used to construct extrinsics & storage, but is useful for current runtime inspection.
     */
    get runtimeMetadata() {
        return assertResult(this._runtimeMetadata);
    }
    /**
     * @description Contains the version information for the current runtime.
     */
    get runtimeVersion() {
        return assertResult(this._runtimeVersion);
    }
    /**
     * @description The underlying Rx API interface
     */
    get rx() {
        return assertResult(this._rx);
    }
    /**
     * @description Returns the underlying provider stats
     */
    get stats() {
        return this._rpcCore.stats;
    }
    /**
     * @description The type of this API instance, either 'rxjs' or 'promise'
     */
    get type() {
        return this._type;
    }
    /**
     * @description Contains all the extrinsic modules and their subsequent methods in the API. It allows for the construction of transactions and the submission thereof. These are attached dynamically from the runtime metadata.
     *
     * @example
     * <BR>
     *
     * ```javascript
     * api.tx.balances
     *   .transferAllowDeath(<recipientId>, <balance>)
     *   .signAndSend(<keyPair>, ({status}) => {
     *     console.log('tx status', status.asFinalized.toHex());
     *   });
     * ```
     */
    get tx() {
        return assertResult(this._extrinsics);
    }
    /**
     * @description Finds the definition for a specific [[CallFunction]] based on the index supplied
     */
    findCall(callIndex) {
        return findCall(this.registry, callIndex);
    }
    /**
     * @description Finds the definition for a specific [[RegistryError]] based on the index supplied
     */
    findError(errorIndex) {
        return findError(this.registry, errorIndex);
    }
}

class ApiBase extends Getters {
    /**
     * @description Create an instance of the class
     *
     * @param options Options object to create API instance or a Provider instance
     *
     * @example
     * <BR>
     *
     * ```javascript
     * import Api from '@polkadot/api/promise';
     *
     * const api = new Api().isReady();
     *
     * api.rpc.subscribeNewHeads((header) => {
     *   console.log(`new block #${header.number.toNumber()}`);
     * });
     * ```
     */
    constructor(options = {}, type, decorateMethod) {
        super(options, type, decorateMethod);
    }
    /**
     * @description Connect from the underlying provider, halting all network traffic
     */
    connect() {
        return this._rpcCore.connect();
    }
    /**
     * @description Disconnect from the underlying provider, halting all network traffic
     */
    disconnect() {
        this._unsubscribe();
        return this._rpcCore.disconnect();
    }
    /**
     * @description Set an external signer which will be used to sign extrinsic when account passed in is not KeyringPair
     */
    setSigner(signer) {
        this._rx.signer = signer;
    }
    /**
     * @description Signs a raw signer payload, string or Uint8Array
     */
    async sign(address, data, { signer } = {}) {
        if (isString(address)) {
            const _signer = signer || this._rx.signer;
            if (!_signer?.signRaw) {
                throw new Error('No signer exists with a signRaw interface. You possibly need to pass through an explicit keypair for the origin so it can be used for signing.');
            }
            return (await _signer.signRaw(objectSpread({ type: 'bytes' }, data, { address }))).signature;
        }
        return u8aToHex(address.sign(u8aToU8a(data.data)));
    }
}

class Combinator {
    #allHasFired = false;
    #callback;
    #fired = [];
    #fns = [];
    #isActive = true;
    #results = [];
    #subscriptions = [];
    constructor(fns, callback) {
        this.#callback = callback;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises, @typescript-eslint/require-await
        this.#subscriptions = fns.map(async (input, index) => {
            const [fn, ...args] = Array.isArray(input)
                ? input
                : [input];
            this.#fired.push(false);
            this.#fns.push(fn);
            // Not quite 100% how to have a variable number at the front here
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/ban-types
            return fn(...args, this._createCallback(index));
        });
    }
    _allHasFired() {
        this.#allHasFired ||= this.#fired.filter((hasFired) => !hasFired).length === 0;
        return this.#allHasFired;
    }
    _createCallback(index) {
        return (value) => {
            this.#fired[index] = true;
            this.#results[index] = value;
            this._triggerUpdate();
        };
    }
    _triggerUpdate() {
        if (!this.#isActive || !isFunction$1(this.#callback) || !this._allHasFired()) {
            return;
        }
        try {
            Promise
                .resolve(this.#callback(this.#results))
                .catch(noop$1);
        }
        catch {
            // swallow, we don't want the handler to trip us up
        }
    }
    unsubscribe() {
        if (!this.#isActive) {
            return;
        }
        this.#isActive = false;
        Promise
            .all(this.#subscriptions.map(async (subscription) => {
            try {
                const unsubscribe = await subscription;
                if (isFunction$1(unsubscribe)) {
                    unsubscribe();
                }
            }
            catch {
                // ignore
            }
        })).catch(() => {
            // ignore, already ignored above, should never throw
        });
    }
}

function promiseTracker(resolve, reject) {
    let isCompleted = false;
    return {
        reject: (error) => {
            if (!isCompleted) {
                isCompleted = true;
                reject(error);
            }
            return EMPTY;
        },
        resolve: (value) => {
            if (!isCompleted) {
                isCompleted = true;
                resolve(value);
            }
        }
    };
}
function extractArgs(args, needsCallback) {
    const actualArgs = args.slice();
    // If the last arg is a function, we pop it, put it into callback.
    // actualArgs will then hold the actual arguments to be passed to `method`
    const callback = (args.length && isFunction$1(args[args.length - 1]))
        ? actualArgs.pop()
        : undefined;
    // When we need a subscription, ensure that a valid callback is actually passed
    if (needsCallback && !isFunction$1(callback)) {
        throw new Error('Expected a callback to be passed with subscriptions');
    }
    return [actualArgs, callback];
}
function decorateCall(method, args) {
    return new Promise((resolve, reject) => {
        // single result tracker - either reject with Error or resolve with Codec result
        const tracker = promiseTracker(resolve, reject);
        // encoding errors reject immediately, any result unsubscribes and resolves
        const subscription = method(...args)
            .pipe(catchError((error) => tracker.reject(error)))
            .subscribe((result) => {
            tracker.resolve(result);
            nextTick(() => subscription.unsubscribe());
        });
    });
}
function decorateSubscribe(method, args, resultCb) {
    return new Promise((resolve, reject) => {
        // either reject with error or resolve with unsubscribe callback
        const tracker = promiseTracker(resolve, reject);
        // errors reject immediately, the first result resolves with an unsubscribe promise, all results via callback
        const subscription = method(...args)
            .pipe(catchError((error) => tracker.reject(error)), tap(() => tracker.resolve(() => subscription.unsubscribe())))
            .subscribe((result) => {
            // queue result (back of queue to clear current)
            nextTick(() => resultCb(result));
        });
    });
}
/**
 * @description Decorate method for ApiPromise, where the results are converted to the Promise equivalent
 */
function toPromiseMethod(method, options) {
    const needsCallback = !!(options?.methodName && options.methodName.includes('subscribe'));
    return function (...args) {
        const [actualArgs, resultCb] = extractArgs(args, needsCallback);
        return resultCb
            ? decorateSubscribe(method, actualArgs, resultCb)
            : decorateCall(options?.overrideNoSub || method, actualArgs);
    };
}

/**
 * # @polkadot/api/promise
 *
 * ## Overview
 *
 * @name ApiPromise
 * @description
 * ApiPromise is a standard JavaScript wrapper around the RPC and interfaces on the Polkadot network. As a full Promise-based, all interface calls return Promises, including the static `.create(...)`. Subscription calls utilise `(value) => {}` callbacks to pass through the latest values.
 *
 * The API is well suited to real-time applications where either the single-shot state is needed or use is to be made of the subscription-based features of Polkadot (and Substrate) clients.
 *
 * @see [[ApiRx]]
 *
 * ## Usage
 *
 * Making rpc calls -
 * <BR>
 *
 * ```javascript
 * import ApiPromise from '@polkadot/api/promise';
 *
 * // initialise via static create
 * const api = await ApiPromise.create();
 *
 * // make a subscription to the network head
 * api.rpc.chain.subscribeNewHeads((header) => {
 *   console.log(`Chain is at #${header.number}`);
 * });
 * ```
 * <BR>
 *
 * Subscribing to chain state -
 * <BR>
 *
 * ```javascript
 * import { ApiPromise, WsProvider } from '@polkadot/api';
 *
 * // initialise a provider with a specific endpoint
 * const provider = new WsProvider('wss://example.com:9944')
 *
 * // initialise via isReady & new with specific provider
 * const api = await new ApiPromise({ provider }).isReady;
 *
 * // retrieve the block target time
 * const blockPeriod = await api.query.timestamp.blockPeriod().toNumber();
 * let last = 0;
 *
 * // subscribe to the current block timestamp, updates automatically (callback provided)
 * api.query.timestamp.now((timestamp) => {
 *   const elapsed = last
 *     ? `, ${timestamp.toNumber() - last}s since last`
 *     : '';
 *
 *   last = timestamp.toNumber();
 *   console.log(`timestamp ${timestamp}${elapsed} (${blockPeriod}s target)`);
 * });
 * ```
 * <BR>
 *
 * Submitting a transaction -
 * <BR>
 *
 * ```javascript
 * import ApiPromise from '@polkadot/api/promise';
 *
 * ApiPromise.create().then((api) => {
 *   const [nonce] = await api.query.system.account(keyring.alice.address);
 *
 *   api.tx.balances
 *     // create transfer
 *     transfer(keyring.bob.address, 12345)
 *     // sign the transcation
 *     .sign(keyring.alice, { nonce })
 *     // send the transaction (optional status callback)
 *     .send((status) => {
 *       console.log(`current status ${status.type}`);
 *     })
 *     // retrieve the submitted extrinsic hash
 *     .then((hash) => {
 *       console.log(`submitted with hash ${hash}`);
 *     });
 * });
 * ```
 */
class ApiPromise extends ApiBase {
    #isReadyPromise;
    #isReadyOrErrorPromise;
    /**
     * @description Creates an instance of the ApiPromise class
     * @param options Options to create an instance. This can be either [[ApiOptions]] or
     * an [[WsProvider]].
     * @example
     * <BR>
     *
     * ```javascript
     * import Api from '@polkadot/api/promise';
     *
     * new Api().isReady.then((api) => {
     *   api.rpc.subscribeNewHeads((header) => {
     *     console.log(`new block #${header.number.toNumber()}`);
     *   });
     * });
     * ```
     */
    constructor(options) {
        super(options, 'promise', toPromiseMethod);
        this.#isReadyPromise = new Promise((resolve) => {
            super.once('ready', () => resolve(this));
        });
        this.#isReadyOrErrorPromise = new Promise((resolve, reject) => {
            const tracker = promiseTracker(resolve, reject);
            super.once('ready', () => tracker.resolve(this));
            super.once('error', (error) => tracker.reject(error));
        });
    }
    /**
     * @description Creates an ApiPromise instance using the supplied provider. Returns an Promise containing the actual Api instance.
     * @param options options that is passed to the class contructor. Can be either [[ApiOptions]] or a
     * provider (see the constructor arguments)
     * @example
     * <BR>
     *
     * ```javascript
     * import Api from '@polkadot/api/promise';
     *
     * Api.create().then(async (api) => {
     *   const timestamp = await api.query.timestamp.now();
     *
     *   console.log(`lastest block timestamp ${timestamp}`);
     * });
     * ```
     */
    static create(options) {
        const instance = new ApiPromise(options);
        if (options && options.throwOnConnect) {
            return instance.isReadyOrError;
        }
        // Swallow any rejections on isReadyOrError
        // (in Node 15.x this creates issues, when not being looked at)
        instance.isReadyOrError.catch(noop$1);
        return instance.isReady;
    }
    /**
     * @description Promise that resolves the first time we are connected and loaded
     */
    get isReady() {
        return this.#isReadyPromise;
    }
    /**
     * @description Promise that resolves if we can connect, or reject if there is an error
     */
    get isReadyOrError() {
        return this.#isReadyOrErrorPromise;
    }
    /**
     * @description Returns a clone of this ApiPromise instance (new underlying provider connection)
     */
    clone() {
        return new ApiPromise(objectSpread({}, this._options, { source: this }));
    }
    /**
     * @description Creates a combinator that can be used to combine the latest results from multiple subscriptions
     * @param fns An array of function to combine, each in the form of `(cb: (value: void)) => void`
     * @param callback A callback that will return an Array of all the values this combinator has been applied to
     * @example
     * <BR>
     *
     * ```javascript
     * const address = '5DTestUPts3kjeXSTMyerHihn1uwMfLj8vU8sqF7qYrFacT7';
     *
     * // combines values from balance & nonce as it updates
     * api.combineLatest([
     *   api.rpc.chain.subscribeNewHeads,
     *   (cb) => api.query.system.account(address, cb)
     * ], ([head, [balance, nonce]]) => {
     *   console.log(`#${head.number}: You have ${balance.free} units, with ${nonce} transactions sent`);
     * });
     * ```
     */
    // eslint-disable-next-line @typescript-eslint/require-await
    async combineLatest(fns, callback) {
        const combinator = new Combinator(fns, callback);
        return () => {
            combinator.unsubscribe();
        };
    }
}

function documentReadyPromise(creator) {
    return new Promise((resolve) => {
        if (document.readyState === 'complete') {
            resolve(creator());
        }
        else {
            window.addEventListener('load', () => resolve(creator()));
        }
    });
}

const win = window;
win.injectedWeb3 = win.injectedWeb3 || {};
web3IsInjected();
let web3EnablePromise = null;
/** @internal true when anything has been injected and is available */
function web3IsInjected() {
    return Object
        .values(win.injectedWeb3)
        .filter(({ connect, enable }) => !!(connect || enable))
        .length !== 0;
}
/** @internal throw a consistent error when not extensions have not been enabled */
function throwError(method) {
    throw new Error(`${method}: web3Enable(originName) needs to be called before ${method}`);
}
/** @internal map from Array<InjectedAccount> to Array<InjectedAccountWithMeta> */
function mapAccounts(source, list, ss58Format) {
    return list.map(({ address, genesisHash, name, type }) => ({
        address: address.length === 42
            ? address
            : encodeAddress(decodeAddress(address), ss58Format),
        meta: { genesisHash, name, source },
        type
    }));
}
/** @internal filter accounts based on genesisHash and type of account */
function filterAccounts(list, genesisHash, type) {
    return list.filter((a) => (!a.type || !type || type.includes(a.type)) &&
        (!a.genesisHash || !genesisHash || a.genesisHash === genesisHash));
}
/** @internal retrieves all the extensions available on the window */
function getWindowExtensions(originName) {
    return Promise
        .all(Object
        .entries(win.injectedWeb3)
        .map(([nameOrHash, { connect, enable, version }]) => Promise
        .resolve()
        .then(() => connect
        // new style, returning all info
        ? connect(originName)
        : enable
            // previous interface, leakages on name/version
            ? enable(originName).then((e) => objectSpread({ name: nameOrHash, version: version || 'unknown' }, e))
            : Promise.reject(new Error('No connect(..) or enable(...) hook found')))
        .catch(({ message }) => {
        console.error(`Error initializing ${nameOrHash}: ${message}`);
    })))
        .then((exts) => exts.filter((e) => !!e));
}
/** @internal Ensure the enable promise is resolved and filter by extensions */
async function filterEnable(caller, extensions) {
    if (!web3EnablePromise) {
        return throwError(caller);
    }
    const sources = await web3EnablePromise;
    return sources.filter(({ name }) => !extensions ||
        extensions.includes(name));
}
/**
 * @summary Enables all the providers found on the injected window interface
 * @description
 * Enables all injected extensions that has been found on the page. This
 * should be called before making use of any other web3* functions.
 */
function web3Enable(originName, compatInits = []) {
    if (!originName) {
        throw new Error('You must pass a name for your app to the web3Enable function');
    }
    const initCompat = compatInits.length
        ? Promise.all(compatInits.map((c) => c().catch(() => false)))
        : Promise.resolve([true]);
    web3EnablePromise = documentReadyPromise(() => initCompat.then(() => getWindowExtensions(originName)
        .then((values) => values.map((e) => {
        // if we don't have an accounts subscriber, add a single-shot version
        if (!e.accounts.subscribe) {
            e.accounts.subscribe = (cb) => {
                e.accounts
                    .get()
                    .then(cb)
                    .catch(console.error);
                return () => {
                    // no ubsubscribe needed, this is a single-shot
                };
            };
        }
        return e;
    }))
        .catch(() => [])
        .then((values) => {
        const names = values.map(({ name, version }) => `${name}/${version}`);
        web3IsInjected();
        console.info(`web3Enable: Enabled ${values.length} extension${values.length !== 1 ? 's' : ''}: ${names.join(', ')}`);
        return values;
    })));
    return web3EnablePromise;
}
/**
 * @summary Retrieves all the accounts across all providers
 * @description
 * This returns the full list of account available (across all extensions) to
 * the page. Filtering options are available of a per-extension, per type and
 * per-genesisHash basis. Optionally the accounts can be encoded with the provided
 * ss58Format
 */
async function web3Accounts({ accountType, extensions, genesisHash, ss58Format } = {}) {
    const accounts = [];
    const sources = await filterEnable('web3Accounts', extensions);
    const retrieved = await Promise.all(sources.map(async ({ accounts, name: source }) => {
        try {
            const list = await accounts.get();
            return mapAccounts(source, filterAccounts(list, genesisHash, accountType), ss58Format);
        }
        catch {
            // cannot handle this one
            return [];
        }
    }));
    retrieved.forEach((result) => {
        accounts.push(...result);
    });
    console.info(`web3Accounts: Found ${accounts.length} address${accounts.length !== 1 ? 'es' : ''}`);
    return accounts;
}
/**
 * @summary Finds a specific provider based on the name
 * @description
 * This retrieves a specific source (extension) based on the name. In most
 * cases it should not be needed to call it directly (e.g. it is used internally
 * by calls such as web3FromAddress) but would allow operation on a specific
 * known extension.
 */
async function web3FromSource(source) {
    if (!web3EnablePromise) {
        return throwError('web3FromSource');
    }
    const sources = await web3EnablePromise;
    const found = source && sources.find(({ name }) => name === source);
    if (!found) {
        throw new Error(`web3FromSource: Unable to find an injected ${source}`);
    }
    return found;
}
/**
 * @summary Find a specific provider that provides a specific address
 * @description
 * Based on an address, return the provider that has makes this address
 * available to the page.
 */
async function web3FromAddress(address) {
    if (!web3EnablePromise) {
        return throwError('web3FromAddress');
    }
    const accounts = await web3Accounts();
    let found;
    if (address) {
        const accountU8a = decodeAddress(address);
        found = accounts.find((account) => u8aEq(decodeAddress(account.address), accountU8a));
    }
    if (!found) {
        throw new Error(`web3FromAddress: Unable to find injected ${address}`);
    }
    return web3FromSource(found.meta.source);
}

/**
 * Asset Hub Connection Service
 *
 * Handles connection to Polkadot Asset Hub and wallet integration
 */
class AssetHubService {
    constructor(config, logger) {
        this.api = null;
        this.wsProvider = null;
        this.connectedAccounts = [];
        this.config = config;
        this.logger = logger;
    }
    /**
     * Connect to Asset Hub
     */
    async connect() {
        const endpoints = this.config.rpcEndpoint
            ? [this.config.rpcEndpoint]
            : AssetHubService.RPC_ENDPOINTS[this.config.network];
        let lastError = null;
        // Try each endpoint until one connects
        for (const endpoint of endpoints) {
            try {
                this.logger.info(`Attempting to connect to ${endpoint}`);
                this.wsProvider = new WsProvider(endpoint);
                this.api = await ApiPromise.create({ provider: this.wsProvider });
                await this.api.isReady;
                const chain = await this.api.rpc.system.chain();
                const nodeName = await this.api.rpc.system.name();
                const nodeVersion = await this.api.rpc.system.version();
                this.logger.info('Connected to Asset Hub', {
                    chain: chain.toString(),
                    node: `${nodeName.toString()} v${nodeVersion.toString()}`,
                    endpoint,
                });
                return; // Successfully connected
            }
            catch (error) {
                this.logger.warn(`Failed to connect to ${endpoint}`, error);
                lastError = error;
                // Cleanup failed attempt
                if (this.wsProvider) {
                    await this.wsProvider.disconnect();
                    this.wsProvider = null;
                }
                this.api = null;
                continue; // Try next endpoint
            }
        }
        // All endpoints failed
        throw new Error(`Failed to connect to any ${this.config.network} Asset Hub RPC endpoint. Last error: ${lastError?.message}`);
    }
    /**
     * Enable wallet extension and get accounts
     */
    async enableWallet(appName = 'PMT Gateway') {
        if (typeof window === 'undefined') {
            throw new Error('Wallet extensions only work in browser environment');
        }
        this.logger.info(`Requesting wallet access for "${appName}"`);
        // Enable Polkadot wallet extensions
        const extensions = await web3Enable(appName);
        if (extensions.length === 0) {
            throw new Error('No Polkadot wallet extension found. Please install Polkadot.js Extension, Talisman, or SubWallet.');
        }
        this.logger.info(`Found ${extensions.length} wallet extension(s)`);
        // Get all accounts from all extensions
        const allAccounts = await web3Accounts();
        // Filter out Ethereum accounts (20 bytes, starts with 0x)
        // Only keep Substrate/Polkadot accounts (32 bytes)
        const accounts = allAccounts.filter(account => {
            const isEthereumAddress = account.address.length === 42 && account.address.startsWith('0x');
            if (isEthereumAddress) {
                this.logger.warn(`Filtered out Ethereum account: ${account.address} (${account.meta.name})`);
            }
            return !isEthereumAddress;
        });
        if (accounts.length === 0) {
            if (allAccounts.length > 0) {
                throw new Error('No Substrate/Polkadot accounts found. You have Ethereum accounts in your wallet, ' +
                    'but this requires Polkadot accounts. Please create a Substrate account in Polkadot.js Extension.');
            }
            throw new Error('No accounts found in wallet. Please create or import an account first.');
        }
        this.connectedAccounts = accounts;
        this.logger.info(`Connected to ${accounts.length} Substrate account(s) (${allAccounts.length - accounts.length} Ethereum accounts filtered out)`, {
            accounts: accounts.map((a, i) => ({
                index: i + 1,
                name: a.meta.name || 'Unnamed',
                address: a.address,
            })),
        });
        return accounts;
    }
    /**
     * Get connected wallet accounts
     */
    getAccounts() {
        return this.connectedAccounts;
    }
    /**
     * Get account balance
     */
    async getBalance(address) {
        this.ensureConnected();
        const accountInfo = await this.api.query.system.account(address);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const balance = accountInfo.data;
        return {
            free: balance.free.toBigInt(),
            reserved: balance.reserved.toBigInt(),
            frozen: balance.frozen.toBigInt(),
            total: balance.free.toBigInt() + balance.reserved.toBigInt(),
        };
    }
    /**
     * Sign and send a transaction
     */
    async signAndSend(address, extrinsic, statusCallback) {
        this.ensureConnected();
        // Validate address format
        if (address.length === 42 && address.startsWith('0x')) {
            throw new Error('Ethereum address detected! Please use Polkadot.js Extension. ' +
                'MetaMask and other Ethereum wallets are not supported. ' +
                'Download: https://polkadot.js.org/extension/');
        }
        // Get the injector for signing
        const injector = await web3FromAddress(address);
        return new Promise((resolve, reject) => {
            extrinsic
                .signAndSend(address, { signer: injector.signer }, ({ status, events: _events, dispatchError }) => {
                // Build status object
                const txStatus = {
                    isInBlock: status.isInBlock,
                    isFinalized: status.isFinalized,
                    blockHash: status.isInBlock
                        ? status.asInBlock.toString()
                        : status.isFinalized
                            ? status.asFinalized.toString()
                            : undefined,
                };
                // Call status callback
                if (statusCallback) {
                    statusCallback(txStatus);
                }
                // Log status
                if (status.isInBlock) {
                    console.log(`📦 Transaction included in block: ${status.asInBlock.toString()}`);
                }
                if (status.isFinalized) {
                    console.log(`✅ Transaction finalized in block: ${status.asFinalized.toString()}`);
                    // Check for errors
                    if (dispatchError) {
                        const errorMsg = this.parseDispatchError(dispatchError);
                        console.error(`❌ Transaction failed: ${errorMsg}`);
                        txStatus.error = errorMsg;
                        statusCallback?.(txStatus);
                        reject(new Error(errorMsg));
                    }
                    else {
                        // Success - extract transaction hash
                        const txHash = extrinsic.hash.toString();
                        txStatus.txHash = txHash;
                        console.log(`   Transaction hash: ${txHash}`);
                        statusCallback?.(txStatus);
                        resolve(txHash);
                    }
                }
            })
                .catch((error) => {
                console.error('❌ Failed to sign and send transaction:', error);
                reject(error);
            });
        });
    }
    /**
     * Get network information
     */
    async getNetworkInfo() {
        this.ensureConnected();
        const [chain, nodeName, nodeVersion, genesisHash] = await Promise.all([
            this.api.rpc.system.chain(),
            this.api.rpc.system.name(),
            this.api.rpc.system.version(),
            this.api.genesisHash,
        ]);
        return {
            chain: chain.toString(),
            nodeName: nodeName.toString(),
            nodeVersion: nodeVersion.toString(),
            genesisHash: genesisHash.toString(),
        };
    }
    /**
     * Get current block number
     */
    async getCurrentBlockNumber() {
        this.ensureConnected();
        const header = await this.api.rpc.chain.getHeader();
        return header.number.toNumber();
    }
    /**
     * Get API instance (for advanced usage)
     */
    getApi() {
        this.ensureConnected();
        return this.api;
    }
    /**
     * Check if connected
     */
    isConnected() {
        return this.api !== null && this.api.isConnected;
    }
    /**
     * Disconnect from Asset Hub
     */
    async disconnect() {
        if (this.api) {
            await this.api.disconnect();
            this.api = null;
        }
        if (this.wsProvider) {
            await this.wsProvider.disconnect();
            this.wsProvider = null;
        }
        this.connectedAccounts = [];
        console.log('🔌 Disconnected from Asset Hub');
    }
    /**
     * Parse dispatch error to human-readable message
     */
    parseDispatchError(dispatchError) {
        if (dispatchError.isModule) {
            // Known module error
            const decoded = this.api.registry.findMetaError(dispatchError.asModule);
            return `${decoded.section}.${decoded.name}: ${decoded.docs.join(' ')}`;
        }
        else if (dispatchError.isToken) {
            // Token error
            return `Token error: ${dispatchError.asToken.toString()}`;
        }
        else if (dispatchError.isArithmetic) {
            // Arithmetic error (overflow, etc.)
            return `Arithmetic error: ${dispatchError.asArithmetic.toString()}`;
        }
        else {
            // Unknown error
            return dispatchError.toString();
        }
    }
    /**
     * Ensure API is connected (throws if not)
     */
    ensureConnected() {
        if (!this.api || !this.api.isConnected) {
            throw new Error('Not connected to Asset Hub. Call connect() first.');
        }
    }
}
// RPC endpoints for different networks
AssetHubService.RPC_ENDPOINTS = {
    paseo: [
        'wss://paseo-asset-hub-rpc.polkadot.io',
        'wss://sys.ibp.network/asset-hub-paseo',
        'wss://paseo-asset-hub.dotters.network',
    ],
    polkadot: [
        'wss://polkadot-asset-hub-rpc.polkadot.io',
        'wss://sys.ibp.network/asset-hub-polkadot',
        'wss://statemint.api.onfinality.io/public-ws',
    ],
    kusama: [
        'wss://kusama-asset-hub-rpc.polkadot.io',
        'wss://sys.ibp.network/asset-hub-kusama',
        'wss://statemine.api.onfinality.io/public-ws',
    ],
};

/**
 * Client-Side Rate Limiter
 *
 * Implements client-side rate limiting and anti-spam mechanisms
 * Uses browser storage to track request history
 */
class RateLimiterService {
    constructor(config) {
        this.config = {
            blockDurationMs: config.windowMs * 2, // Default: block for 2x the window
            storageKey: config.storageKey || RateLimiterService.DEFAULT_STORAGE_KEY,
            ...config,
        };
        this.storageKey = this.config.storageKey;
    }
    /**
     * Check if a request is allowed
     */
    checkLimit(key = 'default') {
        const now = Date.now();
        const data = this.getData(key);
        // Check if currently blocked
        if (data.blockedUntil && now < data.blockedUntil) {
            return {
                allowed: false,
                remaining: 0,
                resetAt: data.blockedUntil,
                blockedUntil: data.blockedUntil,
            };
        }
        // Remove requests outside the current window
        const windowStart = now - this.config.windowMs;
        data.requests = data.requests.filter(timestamp => timestamp > windowStart);
        data.blockedUntil = undefined;
        // Calculate remaining requests
        const remaining = this.config.maxRequests - data.requests.length;
        if (remaining <= 0) {
            // Rate limit exceeded - set block
            data.blockedUntil = now + this.config.blockDurationMs;
            this.saveData(key, data);
            return {
                allowed: false,
                remaining: 0,
                resetAt: data.blockedUntil,
                blockedUntil: data.blockedUntil,
            };
        }
        return {
            allowed: true,
            remaining,
            resetAt: data.requests[0] + this.config.windowMs,
        };
    }
    /**
     * Record a request
     */
    recordRequest(key = 'default') {
        const status = this.checkLimit(key);
        if (status.allowed) {
            const data = this.getData(key);
            data.requests.push(Date.now());
            this.saveData(key, data);
            return {
                ...status,
                remaining: status.remaining - 1,
            };
        }
        return status;
    }
    /**
     * Reset rate limit for a key
     */
    reset(key = 'default') {
        const storageKey = this.getStorageKey(key);
        localStorage.removeItem(storageKey);
    }
    /**
     * Reset all rate limits
     */
    resetAll() {
        const keys = Object.keys(localStorage);
        keys.forEach(key => {
            if (key.startsWith(this.storageKey)) {
                localStorage.removeItem(key);
            }
        });
    }
    /**
     * Get rate limit status without recording
     */
    getStatus(key = 'default') {
        return this.checkLimit(key);
    }
    /**
     * Check if currently blocked
     */
    isBlocked(key = 'default') {
        const status = this.checkLimit(key);
        return !status.allowed;
    }
    /**
     * Get time until reset (in milliseconds)
     */
    getTimeUntilReset(key = 'default') {
        const status = this.checkLimit(key);
        const timeUntilReset = status.resetAt - Date.now();
        return isNaN(timeUntilReset) ? 0 : Math.max(0, timeUntilReset);
    }
    // Private methods
    getStorageKey(key) {
        return `${this.storageKey}_${key}`;
    }
    getData(key) {
        if (typeof window === 'undefined') {
            return { requests: [] };
        }
        try {
            const storageKey = this.getStorageKey(key);
            const stored = localStorage.getItem(storageKey);
            if (stored) {
                return JSON.parse(stored);
            }
        }
        catch (error) {
            console.error('Failed to read rate limit data:', error);
        }
        return { requests: [] };
    }
    saveData(key, data) {
        if (typeof window === 'undefined')
            return;
        try {
            const storageKey = this.getStorageKey(key);
            localStorage.setItem(storageKey, JSON.stringify(data));
        }
        catch (error) {
            console.error('Failed to save rate limit data:', error);
        }
    }
}
RateLimiterService.DEFAULT_STORAGE_KEY = 'pmt_rate_limit';
/**
 * Default rate limiters for common use cases
 */
const RateLimitPresets = {
    // Strict: 10 requests per minute
    strict: {
        maxRequests: 10,
        windowMs: 60 * 1000,
    },
    // Moderate: 30 requests per minute
    moderate: {
        maxRequests: 30,
        windowMs: 60 * 1000,
    },
    // Lenient: 100 requests per minute
    lenient: {
        maxRequests: 100,
        windowMs: 60 * 1000,
    },
    // Payment operations: 5 per minute (prevent spam payments)
    payment: {
        maxRequests: 5,
        windowMs: 60 * 1000,
        blockDurationMs: 5 * 60 * 1000, // Block for 5 minutes
    },
    // Registration: 3 per hour
    registration: {
        maxRequests: 3,
        windowMs: 60 * 60 * 1000,
        blockDurationMs: 60 * 60 * 1000, // Block for 1 hour
    },
};

/**
 * Input Validation Service
 *
 * Provides comprehensive input validation for all user inputs
 * to prevent injection attacks, invalid data, and loss of funds
 */
class ValidationError extends Error {
    constructor(message, field, code) {
        super(message);
        this.field = field;
        this.code = code;
        this.name = 'ValidationError';
    }
}
class ValidationService {
    /**
     * Validate Polkadot/Substrate address
     */
    static validateAddress(address, fieldName = 'address') {
        if (!address) {
            throw new ValidationError(`${fieldName} is required`, fieldName, 'REQUIRED');
        }
        try {
            // Try to decode the address to validate it
            const decoded = decodeAddress(address);
            // Re-encode to ensure it's valid
            const encoded = encodeAddress(decoded);
            // Basic validation passed
            if (!encoded) {
                throw new Error('Invalid address');
            }
        }
        catch (error) {
            throw new ValidationError(`Invalid ${fieldName}: ${address}`, fieldName, 'INVALID_ADDRESS');
        }
    }
    /**
     * Validate and parse crypto amount
     */
    static validateAndParseAmount(amount, fieldName = 'amount', options = {}) {
        if (!amount) {
            throw new ValidationError(`${fieldName} is required`, fieldName, 'REQUIRED');
        }
        let parsed;
        try {
            // Validate decimal places
            const decimals = options.decimals || 18;
            const parts = amount.split('.');
            if (parts[1] && parts[1].length > decimals) {
                throw new ValidationError(`${fieldName} has too many decimal places (max: ${decimals})`, fieldName, 'INVALID_DECIMALS');
            }
            // Parse DOT amount (10 decimals)
            const dotFloat = parseFloat(amount);
            parsed = BigInt(Math.floor(dotFloat * 1e10));
        }
        catch (error) {
            throw new ValidationError(`Invalid ${fieldName} format: ${amount}`, fieldName, 'INVALID_FORMAT');
        }
        // Check for negative or zero
        if (parsed <= 0n) {
            throw new ValidationError(`${fieldName} must be greater than zero`, fieldName, 'INVALID_RANGE');
        }
        // Check minimum
        if (options.min) {
            const minFloat = parseFloat(options.min);
            const minAmount = BigInt(Math.floor(minFloat * 1e10));
            if (parsed < minAmount) {
                throw new ValidationError(`${fieldName} must be at least ${options.min}`, fieldName, 'BELOW_MINIMUM');
            }
        }
        // Check maximum
        if (options.max) {
            const maxFloat = parseFloat(options.max);
            const maxAmount = BigInt(Math.floor(maxFloat * 1e10));
            if (parsed > maxAmount) {
                throw new ValidationError(`${fieldName} must not exceed ${options.max}`, fieldName, 'ABOVE_MAXIMUM');
            }
        }
        return parsed;
    }
    /**
     * Validate fiat amount
     */
    static validateFiatAmount(amount, currency, fieldName = 'amount') {
        if (typeof amount !== 'number' || isNaN(amount)) {
            throw new ValidationError(`${fieldName} must be a valid number`, fieldName, 'INVALID_TYPE');
        }
        if (amount <= 0) {
            throw new ValidationError(`${fieldName} must be greater than zero`, fieldName, 'INVALID_RANGE');
        }
        // Check for unreasonably large amounts (> $10M)
        if (amount > 10000000) {
            throw new ValidationError(`${fieldName} exceeds maximum allowed`, fieldName, 'ABOVE_MAXIMUM');
        }
        // Validate decimal places based on currency
        const noDecimalCurrencies = ['jpy', 'krw'];
        const decimals = amount.toString().split('.')[1]?.length || 0;
        if (noDecimalCurrencies.includes(currency.toLowerCase())) {
            if (decimals > 0) {
                throw new ValidationError(`${currency.toUpperCase()} amounts cannot have decimal places`, fieldName, 'INVALID_DECIMALS');
            }
        }
        else {
            if (decimals > 2) {
                throw new ValidationError(`${fieldName} can have at most 2 decimal places`, fieldName, 'INVALID_DECIMALS');
            }
        }
    }
    /**
     * Validate and sanitize string
     */
    static validateString(value, fieldName, options = {}) {
        if (options.required && !value) {
            throw new ValidationError(`${fieldName} is required`, fieldName, 'REQUIRED');
        }
        if (!value) {
            return '';
        }
        // Check length
        if (options.minLength && value.length < options.minLength) {
            throw new ValidationError(`${fieldName} must be at least ${options.minLength} characters`, fieldName, 'TOO_SHORT');
        }
        if (options.maxLength && value.length > options.maxLength) {
            throw new ValidationError(`${fieldName} must not exceed ${options.maxLength} characters`, fieldName, 'TOO_LONG');
        }
        // Check pattern
        if (options.pattern && !options.pattern.test(value)) {
            throw new ValidationError(`${fieldName} has invalid format`, fieldName, 'INVALID_FORMAT');
        }
        // Sanitize - remove disallowed characters
        if (options.allowedChars) {
            return value.replace(new RegExp(`[^${options.allowedChars.source}]`, 'g'), '');
        }
        return value;
    }
    /**
     * Validate external ID (for payments)
     */
    static validateExternalId(externalId) {
        return this.validateString(externalId, 'externalId', {
            required: true,
            maxLength: 256,
            allowedChars: /a-zA-Z0-9_-/,
        });
    }
    /**
     * Validate expiration seconds
     */
    static validateExpiration(expirationSeconds, fieldName = 'expirationSeconds') {
        if (typeof expirationSeconds !== 'number' || isNaN(expirationSeconds)) {
            throw new ValidationError(`${fieldName} must be a valid number`, fieldName, 'INVALID_TYPE');
        }
        const MIN_EXPIRATION = 60; // 1 minute
        const MAX_EXPIRATION = 365 * 24 * 60 * 60; // 1 year
        if (expirationSeconds < MIN_EXPIRATION) {
            throw new ValidationError(`${fieldName} must be at least ${MIN_EXPIRATION} seconds (1 minute)`, fieldName, 'BELOW_MINIMUM');
        }
        if (expirationSeconds > MAX_EXPIRATION) {
            throw new ValidationError(`${fieldName} must not exceed ${MAX_EXPIRATION} seconds (1 year)`, fieldName, 'ABOVE_MAXIMUM');
        }
    }
    /**
     * Validate currency code
     */
    static validateCurrency(currency) {
        const validCurrencies = ['usd', 'eur', 'gbp', 'jpy', 'cad', 'aud', 'chf', 'cny', 'inr'];
        const normalized = currency.toLowerCase().trim();
        if (!validCurrencies.includes(normalized)) {
            throw new ValidationError(`Unsupported currency: ${currency}. Supported: ${validCurrencies.join(', ')}`, 'currency', 'INVALID_CURRENCY');
        }
        return normalized;
    }
    /**
     * Validate URL
     */
    static validateUrl(url, fieldName = 'url', required = false) {
        if (!url && !required) {
            return;
        }
        if (!url && required) {
            throw new ValidationError(`${fieldName} is required`, fieldName, 'REQUIRED');
        }
        try {
            const parsed = new URL(url);
            // Only allow http and https
            if (!['http:', 'https:'].includes(parsed.protocol)) {
                throw new ValidationError(`${fieldName} must use HTTP or HTTPS protocol`, fieldName, 'INVALID_PROTOCOL');
            }
        }
        catch (error) {
            throw new ValidationError(`${fieldName} is not a valid URL`, fieldName, 'INVALID_URL');
        }
    }
    /**
     * Validate email (basic validation)
     */
    static validateEmail(email, fieldName = 'email', required = false) {
        if (!email && !required) {
            return;
        }
        if (!email && required) {
            throw new ValidationError(`${fieldName} is required`, fieldName, 'REQUIRED');
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            throw new ValidationError(`${fieldName} is not a valid email address`, fieldName, 'INVALID_EMAIL');
        }
        if (email.length > 254) {
            throw new ValidationError(`${fieldName} is too long`, fieldName, 'TOO_LONG');
        }
    }
    /**
     * Validate payment metadata
     */
    static validateMetadata(metadata) {
        if (!metadata) {
            return;
        }
        if (typeof metadata !== 'object' || Array.isArray(metadata)) {
            throw new ValidationError('metadata must be an object', 'metadata', 'INVALID_TYPE');
        }
        // Check size (prevent storing huge objects)
        const jsonSize = JSON.stringify(metadata).length;
        const MAX_METADATA_SIZE = 10 * 1024; // 10KB
        if (jsonSize > MAX_METADATA_SIZE) {
            throw new ValidationError(`metadata size exceeds maximum (${MAX_METADATA_SIZE} bytes)`, 'metadata', 'TOO_LARGE');
        }
        // Check for nested depth (prevent stack overflow)
        const maxDepth = 5;
        const checkDepth = (obj, depth = 0) => {
            if (depth > maxDepth) {
                throw new ValidationError(`metadata nesting depth exceeds maximum (${maxDepth})`, 'metadata', 'TOO_DEEP');
            }
            if (typeof obj === 'object' && obj !== null) {
                Object.values(obj).forEach(value => checkDepth(value, depth + 1));
            }
        };
        checkDepth(metadata);
    }
    /**
     * Validate IPFS hash
     */
    static validateIPFSHash(hash, required = false) {
        if (!hash && !required) {
            return;
        }
        if (!hash && required) {
            throw new ValidationError('IPFS hash is required', 'ipfsHash', 'REQUIRED');
        }
        // IPFS v0 hashes start with Qm and are 46 characters
        // IPFS v1 hashes start with b and are variable length
        const v0Regex = /^Qm[a-zA-Z0-9]{44}$/;
        const v1Regex = /^b[a-zA-Z0-9]{50,}$/;
        if (!v0Regex.test(hash) && !v1Regex.test(hash)) {
            throw new ValidationError('Invalid IPFS hash format', 'ipfsHash', 'INVALID_FORMAT');
        }
    }
}

/**
 * Payment Service
 *
 * Simplified service for direct payments on Asset Hub
 * No escrow, no IPFS - just simple direct transfers
 */
/**
 * Payment Service
 *
 * Handles direct payment transfers on Asset Hub
 */
class PaymentService extends EventEmitter {
    // Instance-specific storage keys
    get storageKey() {
        return `${this.config.storagePrefix}_${this.config.instanceId}_payments`;
    }
    get linksStorageKey() {
        return `${this.config.storagePrefix}_${this.config.instanceId}_payment_links`;
    }
    constructor(assetHub, logger, config) {
        super();
        this.assetHub = assetHub;
        this.payments = new Map();
        this.paymentLinks = new Map();
        this.logger = logger;
        this.config = config;
        // Initialize rate limiter if enabled
        if (config.enableRateLimiting) {
            this.rateLimiter = new RateLimiterService({
                maxRequests: 10,
                windowMs: 60000, // 10 requests per minute
                storageKey: `${config.storagePrefix}_${config.instanceId}_rate_limit`,
            });
        }
        this.loadFromStorage();
        this.loadLinksFromStorage();
    }
    /**
     * Create a payment intent
     *
     * This creates a payment record but doesn't execute the transfer yet
     */
    async createPayment(params) {
        // Check rate limit
        if (this.rateLimiter && !this.rateLimiter.checkLimit('createPayment')) {
            throw new Error('Rate limit exceeded. Please try again later.');
        }
        const accounts = this.assetHub.getAccounts();
        if (accounts.length === 0) {
            throw new Error('No wallet connected. Call enableWallet() first.');
        }
        const buyer = accounts[0].address;
        const amount = typeof params.amount === 'string'
            ? this.dotToPlanck(params.amount)
            : params.amount;
        const paymentId = this.generatePaymentId();
        const now = Date.now();
        const currency = params.currency || this.getNetworkCurrency();
        const payment = {
            id: paymentId,
            buyer,
            merchant: params.merchant,
            amount,
            currency,
            description: params.description,
            externalId: params.externalId,
            status: 'created',
            createdAt: now,
            updatedAt: now,
        };
        this.payments.set(paymentId, payment);
        this.saveToStorage();
        const event = {
            type: 'payment.created',
            paymentId,
            timestamp: now,
        };
        this.emit('payment.created', event);
        this.logger.info('Payment created successfully', {
            paymentId: payment.id,
            amount: this.planckToDot(payment.amount),
            currency,
            merchant: payment.merchant,
        });
        return payment;
    }
    /**
     * Execute a payment (direct transfer)
     */
    async executePayment(paymentId) {
        // Check rate limit
        if (this.rateLimiter && !this.rateLimiter.checkLimit('executePayment')) {
            throw new Error('Rate limit exceeded. Please try again later.');
        }
        const payment = this.payments.get(paymentId);
        if (!payment) {
            throw new Error(`Payment ${paymentId} not found`);
        }
        if (payment.status !== 'created') {
            throw new Error(`Payment ${paymentId} is not in created status`);
        }
        this.logger.info('Executing payment', {
            paymentId,
            amount: this.planckToDot(payment.amount),
            currency: payment.currency,
            merchant: payment.merchant,
        });
        const api = this.assetHub.getApi();
        const transfer = api.tx.balances.transferKeepAlive(payment.merchant, payment.amount);
        // Store block info when finalized
        let blockHash;
        let blockNumber;
        const txHash = await this.assetHub.signAndSend(payment.buyer, transfer, async (status) => {
            const statusText = status.isInBlock ? 'InBlock' : status.isFinalized ? 'Finalized' : 'Pending';
            this.logger.debug('Transaction status update', { paymentId, status: statusText });
            if (status.isFinalized && status.blockHash) {
                blockHash = status.blockHash;
                // Get block number from block hash
                try {
                    const signedBlock = await api.rpc.chain.getBlock(status.blockHash);
                    blockNumber = signedBlock.block.header.number.toNumber();
                }
                catch (error) {
                    this.logger.warn('Failed to get block number', error);
                }
            }
        });
        payment.status = 'completed';
        payment.txHash = txHash;
        payment.blockHash = blockHash;
        payment.blockNumber = blockNumber;
        payment.updatedAt = Date.now();
        this.payments.set(paymentId, payment);
        this.saveToStorage();
        const event = {
            type: 'payment.completed',
            paymentId,
            txHash,
            timestamp: Date.now(),
        };
        this.emit('payment.completed', event);
        this.logger.info('Payment completed successfully', {
            paymentId,
            txHash,
            blockNumber,
        });
    }
    /**
     * Get a payment by ID
     */
    getPayment(paymentId) {
        return this.payments.get(paymentId);
    }
    /**
     * Get all payments
     */
    getAllPayments() {
        return Array.from(this.payments.values());
    }
    /**
     * Get payments for a merchant
     */
    getMerchantPayments(merchantAddress) {
        return Array.from(this.payments.values()).filter((p) => p.merchant === merchantAddress);
    }
    /**
     * Get payments for a buyer
     */
    getBuyerPayments(buyerAddress) {
        return Array.from(this.payments.values()).filter((p) => p.buyer === buyerAddress);
    }
    /**
     * Cancel a payment (only if not executed)
     */
    async cancelPayment(paymentId) {
        const payment = this.payments.get(paymentId);
        if (!payment) {
            throw new Error(`Payment ${paymentId} not found`);
        }
        if (payment.status !== 'created') {
            throw new Error(`Cannot cancel payment in ${payment.status} status`);
        }
        payment.status = 'cancelled';
        payment.updatedAt = Date.now();
        this.payments.set(paymentId, payment);
        this.saveToStorage();
        const event = {
            type: 'payment.cancelled',
            paymentId,
            timestamp: Date.now(),
        };
        this.emit('payment.cancelled', event);
    }
    /**
     * Verify a payment on-chain
     *
     * This method queries Asset Hub to verify that:
     * 1. The transaction exists and is finalized
     * 2. The transfer matches the payment details
     * 3. The amount is correct
     * 4. The recipient is correct
     *
     * @param paymentId - Payment ID to verify
     * @returns Verification result with on-chain data
     */
    async verifyPayment(paymentId) {
        const payment = this.payments.get(paymentId);
        if (!payment) {
            return {
                verified: false,
                exists: false,
                finalized: false,
                error: 'Payment not found',
                amount: 0n,
                from: '',
                to: '',
                blockNumber: 0,
                blockHash: '',
                timestamp: 0,
                txHash: '',
            };
        }
        if (!payment.txHash || !payment.blockHash) {
            return {
                verified: false,
                exists: false,
                finalized: false,
                error: 'Payment not yet executed (no transaction hash or block hash)',
                amount: payment.amount,
                from: payment.buyer,
                to: payment.merchant,
                blockNumber: payment.blockNumber || 0,
                blockHash: payment.blockHash || '',
                timestamp: payment.updatedAt,
                txHash: payment.txHash || '',
            };
        }
        try {
            const api = this.assetHub.getApi();
            this.logger.info('Verifying payment on-chain', {
                paymentId,
                blockHash: payment.blockHash,
                lookingFor: {
                    merchant: payment.merchant,
                    buyer: payment.buyer,
                    amount: this.planckToDot(payment.amount),
                },
            });
            // Query events at the specific block
            const eventsRaw = await api.query.system.events.at(payment.blockHash);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const events = eventsRaw.toArray();
            this.logger.info(`Found ${events.length} events in block`, { paymentId });
            // Find the transfer event matching our payment
            let transferFound = false;
            let actualAmount = 0n;
            let actualFrom = '';
            let actualTo = '';
            let eventIndex = -1;
            events.forEach((record, index) => {
                const { event } = record;
                // Look for balances.Transfer or balances.Withdraw events
                // In newer API versions, the event might be called differently
                if ((event.section === 'balances' && (event.method === 'Transfer' || event.method === 'Transferred')) ||
                    (event.section === 'assets' && event.method === 'Transferred')) {
                    const [from, to, amount] = event.data;
                    // Decode addresses to their raw public keys for comparison
                    // This handles different SS58 encoding formats (e.g., "5..." vs "12..." prefixes)
                    const fromDecoded = decodeAddress(from.toString());
                    const toDecoded = decodeAddress(to.toString());
                    const expectedFromDecoded = decodeAddress(payment.buyer);
                    const expectedToDecoded = decodeAddress(payment.merchant);
                    // Compare using decoded public keys
                    const fromMatch = u8aEq(fromDecoded, expectedFromDecoded);
                    const toMatch = u8aEq(toDecoded, expectedToDecoded);
                    const amountMatch = amount.toBigInt() === payment.amount;
                    // Check if this matches our payment (using decoded addresses)
                    if (toMatch && fromMatch && amountMatch) {
                        transferFound = true;
                        actualAmount = amount.toBigInt();
                        actualFrom = from.toString();
                        actualTo = to.toString();
                        eventIndex = index;
                        this.logger.info('Found matching transfer event', {
                            section: event.section,
                            method: event.method,
                            from: actualFrom,
                            to: actualTo,
                            amount: this.planckToDot(actualAmount),
                        });
                    }
                }
            });
            if (!transferFound) {
                this.logger.warn('Transfer event not found on chain', { paymentId });
                return {
                    verified: false,
                    exists: false,
                    finalized: true,
                    error: 'Transfer event not found on chain',
                    amount: payment.amount,
                    from: payment.buyer,
                    to: payment.merchant,
                    blockNumber: payment.blockNumber || 0,
                    blockHash: payment.blockHash,
                    timestamp: payment.updatedAt,
                    txHash: payment.txHash,
                };
            }
            // Verify amount matches
            const amountMatches = actualAmount === payment.amount;
            if (!amountMatches) {
                this.logger.warn('Payment amount mismatch', {
                    paymentId,
                    expected: this.planckToDot(payment.amount),
                    actual: this.planckToDot(actualAmount),
                    currency: payment.currency,
                });
            }
            const verified = transferFound && amountMatches;
            if (verified) {
                this.logger.info('Payment verified successfully', {
                    paymentId,
                    amount: this.planckToDot(actualAmount),
                    currency: payment.currency,
                    from: actualFrom,
                    to: actualTo,
                    blockNumber: payment.blockNumber,
                });
            }
            else {
                this.logger.warn('Payment verification failed', { paymentId });
            }
            return {
                verified,
                exists: true,
                finalized: true,
                amount: actualAmount,
                from: actualFrom,
                to: actualTo,
                blockNumber: payment.blockNumber || 0,
                blockHash: payment.blockHash,
                timestamp: payment.updatedAt,
                txHash: payment.txHash,
                eventIndex,
                error: amountMatches ? undefined : 'Amount mismatch',
            };
        }
        catch (error) {
            this.logger.error('Payment verification failed', error);
            return {
                verified: false,
                exists: false,
                finalized: false,
                error: `Verification failed: ${error instanceof Error ? error.message : String(error)}`,
                amount: payment.amount,
                from: payment.buyer,
                to: payment.merchant,
                blockNumber: payment.blockNumber || 0,
                blockHash: payment.blockHash || '',
                timestamp: payment.updatedAt,
                txHash: payment.txHash || '',
            };
        }
    }
    /**
     * Clear all payments (for testing)
     */
    clearAll() {
        this.payments.clear();
        this.saveToStorage();
    }
    /**
     * Create a payment link
     *
     * Payment links allow merchants to accept payments without coding.
     * Users can visit the link URL and pay directly.
     *
     * @param params - Payment link parameters
     * @returns Payment link with unique ID and shareable URL
     *
     * @example
     * ```typescript
     * const link = await gateway.createPaymentLink({
     *   merchant: '5FHneW46xGXgs5mUiveU4sbTyGBzmstUspZC92UhjJM694ty',
     *   amount: '10.5', // 10.5 DOT
     *   description: 'Premium subscription',
     *   successUrl: 'https://mysite.com/success',
     * });
     *
     * // Share the link
     * const url = gateway.getPaymentLinkUrl(link.id);
     * console.log('Share this URL:', url);
     * ```
     */
    createPaymentLink(params) {
        // Validate merchant address
        ValidationService.validateAddress(params.merchant, 'merchant');
        // Convert amount if needed
        let amount;
        if (params.amount === 'custom') {
            amount = 'custom';
        }
        else if (typeof params.amount === 'string') {
            amount = this.dotToPlanck(params.amount);
        }
        else {
            amount = params.amount;
        }
        // Generate unique link ID
        const linkId = this.generateLinkId();
        // Get current network from assetHub config
        const network = this.getNetworkFromApi();
        const currency = params.currency || this.getNetworkCurrency();
        const link = {
            id: linkId,
            merchant: params.merchant,
            amount,
            currency,
            description: params.description,
            externalId: params.externalId,
            successUrl: params.successUrl,
            cancelUrl: params.cancelUrl,
            metadata: params.metadata,
            createdAt: Date.now(),
            expiresAt: params.expiresAt,
            active: true,
            network,
        };
        this.paymentLinks.set(linkId, link);
        this.saveLinksToStorage();
        this.logger.info('Payment link created successfully', {
            linkId: link.id,
            amount: amount === 'custom' ? 'custom' : this.planckToDot(amount),
            currency,
        });
        return link;
    }
    /**
     * Get a payment link by ID
     */
    getPaymentLink(linkId) {
        return this.paymentLinks.get(linkId);
    }
    /**
     * Get all payment links for a merchant
     */
    getMerchantPaymentLinks(merchantAddress) {
        return Array.from(this.paymentLinks.values()).filter((link) => link.merchant === merchantAddress);
    }
    /**
     * Get all payment links
     */
    getAllPaymentLinks() {
        return Array.from(this.paymentLinks.values());
    }
    /**
     * Deactivate a payment link
     */
    deactivatePaymentLink(linkId) {
        const link = this.paymentLinks.get(linkId);
        if (!link) {
            throw new Error(`Payment link ${linkId} not found`);
        }
        link.active = false;
        this.paymentLinks.set(linkId, link);
        this.saveLinksToStorage();
        this.logger.info('Payment link deactivated', { linkId });
    }
    /**
     * Get the shareable URL for a payment link
     */
    getPaymentLinkUrl(linkId, baseUrl) {
        const link = this.paymentLinks.get(linkId);
        if (!link) {
            throw new Error(`Payment link ${linkId} not found`);
        }
        // Use provided baseUrl or default to current origin + /checkout
        const base = baseUrl || (typeof window !== 'undefined' ? `${window.location.origin}/checkout` : 'https://checkout.stripe3d.io');
        return `${base}?link=${linkId}`;
    }
    /**
     * Create payment from link
     *
     * This is used by the checkout page to create an actual payment from a link
     */
    async createPaymentFromLink(linkId, customAmount) {
        const link = this.paymentLinks.get(linkId);
        if (!link) {
            throw new Error(`Payment link ${linkId} not found`);
        }
        if (!link.active) {
            throw new Error('Payment link is no longer active');
        }
        if (link.expiresAt && Date.now() > link.expiresAt) {
            throw new Error('Payment link has expired');
        }
        // Determine amount
        let amount;
        if (link.amount === 'custom') {
            if (!customAmount) {
                throw new Error('Custom amount is required for this payment link');
            }
            amount = this.dotToPlanck(customAmount);
        }
        else {
            amount = link.amount;
        }
        // Create the payment
        return await this.createPayment({
            merchant: link.merchant,
            amount,
            currency: link.currency,
            description: link.description,
            externalId: link.externalId,
        });
    }
    // Helper methods
    generatePaymentId() {
        const timestamp = Date.now();
        const random = Math.random().toString(36).substring(2, 15);
        return `pay_${timestamp}_${random}`;
    }
    generateLinkId() {
        // Generate a secure random ID for payment links
        const prefix = 'pmt_';
        const bytes = new Uint8Array(16);
        if (typeof window !== 'undefined' && window.crypto) {
            window.crypto.getRandomValues(bytes);
        }
        else {
            // Fallback for non-browser environments
            for (let i = 0; i < bytes.length; i++) {
                bytes[i] = Math.floor(Math.random() * 256);
            }
        }
        const random = Array.from(bytes)
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');
        return prefix + random.slice(0, 24);
    }
    getNetworkFromApi() {
        // Try to determine network from genesis hash or chain name
        // This is a simplified version - in production you'd check genesis hash
        const endpoint = this.assetHub.getApi().runtimeVersion.specName.toString().toLowerCase();
        if (endpoint.includes('paseo'))
            return 'paseo';
        if (endpoint.includes('polkadot'))
            return 'polkadot';
        if (endpoint.includes('kusama'))
            return 'kusama';
        return 'paseo'; // Default to paseo for testnet
    }
    getNetworkCurrency() {
        try {
            const network = this.getNetworkFromApi();
            switch (network) {
                case 'paseo':
                    return 'PAS';
                case 'polkadot':
                    return 'DOT';
                case 'kusama':
                    return 'KSM';
                default:
                    return 'DOT';
            }
        }
        catch (error) {
            this.logger.warn('Failed to detect network currency, defaulting to DOT', error);
            return 'DOT';
        }
    }
    dotToPlanck(dot) {
        const parts = dot.split('.');
        const whole = parts[0] || '0';
        const decimal = (parts[1] || '0').padEnd(10, '0').substring(0, 10);
        return BigInt(whole) * BigInt(10000000000) + BigInt(decimal);
    }
    planckToDot(planck) {
        const str = planck.toString().padStart(11, '0');
        const whole = str.slice(0, -10) || '0';
        const decimal = str.slice(-10);
        return `${whole}.${decimal}`.replace(/\.?0+$/, '') || '0';
    }
    saveToStorage() {
        try {
            const data = Array.from(this.payments.entries()).map(([id, payment]) => [
                id,
                {
                    ...payment,
                    amount: payment.amount.toString(),
                    // Ensure blockNumber and blockHash are included
                    blockNumber: payment.blockNumber,
                    blockHash: payment.blockHash,
                },
            ]);
            localStorage.setItem(this.storageKey, JSON.stringify(data));
        }
        catch (error) {
            this.logger.error('Failed to save payments to storage', error);
        }
    }
    loadFromStorage() {
        try {
            const data = localStorage.getItem(this.storageKey);
            if (data) {
                const entries = JSON.parse(data);
                this.payments = new Map(entries.map(([id, payment]) => [
                    id,
                    {
                        ...payment,
                        amount: BigInt(payment.amount),
                        // Restore blockNumber and blockHash
                        blockNumber: payment.blockNumber,
                        blockHash: payment.blockHash,
                    },
                ]));
            }
        }
        catch (error) {
            this.logger.error('Failed to load payments from storage', error);
        }
    }
    saveLinksToStorage() {
        try {
            const data = Array.from(this.paymentLinks.entries()).map(([id, link]) => [
                id,
                {
                    ...link,
                    // Convert bigint to string for JSON serialization
                    amount: link.amount === 'custom' ? 'custom' : link.amount.toString(),
                },
            ]);
            localStorage.setItem(this.linksStorageKey, JSON.stringify(data));
        }
        catch (error) {
            this.logger.error('Failed to save payment links to storage', error);
        }
    }
    loadLinksFromStorage() {
        try {
            const data = localStorage.getItem(this.linksStorageKey);
            if (data) {
                const entries = JSON.parse(data);
                this.paymentLinks = new Map(entries.map(([id, link]) => [
                    id,
                    {
                        ...link,
                        // Convert string back to bigint
                        amount: link.amount === 'custom' ? 'custom' : BigInt(link.amount),
                    },
                ]));
            }
        }
        catch (error) {
            this.logger.error('Failed to load payment links from storage', error);
        }
    }
}

/**
 * Logger Service
 *
 * Configurable logging system for the SDK
 * Allows merchants to control log output and integrate with their own logging systems
 */
class Logger {
    constructor(config) {
        this.config = config;
    }
    /**
     * Log debug message (verbose details)
     */
    debug(message, data) {
        this.log('debug', message, data);
    }
    /**
     * Log info message (general information)
     */
    info(message, data) {
        this.log('info', message, data);
    }
    /**
     * Log warning message (potential issues)
     */
    warn(message, data) {
        this.log('warn', message, data);
    }
    /**
     * Log error message (errors and failures)
     */
    error(message, data) {
        this.log('error', message, data);
    }
    /**
     * Core logging method
     */
    log(level, message, data) {
        // Check if this level should be logged
        if (!this.shouldLog(level)) {
            return;
        }
        const entry = {
            level,
            message,
            timestamp: Date.now(),
            data,
            context: this.config.context,
        };
        // Use custom handler if provided
        if (this.config.onLog) {
            this.config.onLog(entry);
            return;
        }
        // Default console output
        this.logToConsole(entry);
    }
    /**
     * Check if log level should be output
     */
    shouldLog(level) {
        const configLevel = Logger.LOG_LEVELS[this.config.level];
        const messageLevel = Logger.LOG_LEVELS[level];
        return messageLevel >= configLevel;
    }
    /**
     * Output to console with formatting
     */
    logToConsole(entry) {
        const color = Logger.LEVEL_COLORS[entry.level];
        const reset = Logger.RESET_COLOR;
        const level = entry.level.toUpperCase().padEnd(5);
        let prefix = `${color}[${level}]${reset}`;
        if (this.config.context) {
            prefix += ` [${this.config.context}]`;
        }
        if (this.config.showTimestamp) {
            const time = new Date(entry.timestamp).toISOString();
            prefix += ` ${time}`;
        }
        const message = `${prefix} ${entry.message}`;
        // Output based on level
        if (entry.level === 'error') {
            console.error(message, entry.data || '');
        }
        else if (entry.level === 'warn') {
            console.warn(message, entry.data || '');
        }
        else {
            console.log(message, entry.data || '');
        }
    }
    /**
     * Create a child logger with additional context
     */
    child(context) {
        return new Logger({
            ...this.config,
            context: this.config.context
                ? `${this.config.context}:${context}`
                : context,
        });
    }
    /**
     * Update logger configuration
     */
    setLevel(level) {
        this.config.level = level;
    }
}
Logger.LOG_LEVELS = {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
    none: 4,
};
Logger.LEVEL_COLORS = {
    debug: '\x1b[36m', // Cyan
    info: '\x1b[32m', // Green
    warn: '\x1b[33m', // Yellow
    error: '\x1b[31m', // Red
    none: '',
};
Logger.RESET_COLOR = '\x1b[0m';
/**
 * Create a default logger (production-safe: level 'none')
 */
function createDefaultLogger(config) {
    return new Logger({
        level: 'none', // Production default: no logs
        showTimestamp: false,
        ...config,
    });
}
/**
 * Create a development logger (verbose)
 */
function createDevLogger(config) {
    return new Logger({
        level: 'debug',
        showTimestamp: true,
        ...config,
    });
}

/**
 * PMT Gateway Asset Hub SDK
 *
 * Main SDK class for the world's first truly decentralized payment gateway
 * Built on Polkadot Asset Hub - 100% Web3, no backend required
 */
class PMTGatewayAssetHub extends EventEmitter {
    constructor(config) {
        super();
        this.initialized = false;
        // Apply defaults
        this.config = {
            ...config,
            instanceId: config.instanceId || PMTGatewayAssetHub.DEFAULTS.instanceId,
            storagePrefix: config.storagePrefix || PMTGatewayAssetHub.DEFAULTS.storagePrefix,
            transactionTimeout: config.transactionTimeout ?? PMTGatewayAssetHub.DEFAULTS.transactionTimeout,
            reconnectOnDisconnect: config.reconnectOnDisconnect ?? PMTGatewayAssetHub.DEFAULTS.reconnectOnDisconnect,
            encryptStorage: config.encryptStorage ?? PMTGatewayAssetHub.DEFAULTS.encryptStorage,
            enableRateLimiting: config.enableRateLimiting ?? PMTGatewayAssetHub.DEFAULTS.enableRateLimiting,
            retryPolicy: {
                ...PMTGatewayAssetHub.DEFAULTS.retryPolicy,
                ...config.retryPolicy,
            },
        };
        // Initialize logger
        this.logger = createDefaultLogger({
            context: `PMT[${this.config.instanceId}]`,
            ...config.logger,
        });
        // Initialize Asset Hub service
        this.assetHubService = new AssetHubService(config.assetHub, this.logger.child('AssetHub'));
    }
    /**
     * Get the AssetHub service (for advanced usage)
     */
    get assetHub() {
        return this.assetHubService;
    }
    /**
     * Initialize the gateway
     *
     * This connects to Asset Hub and enables the wallet
     */
    async initialize() {
        if (this.initialized) {
            this.logger.info('Gateway already initialized');
            return;
        }
        this.logger.info('Initializing PMT Gateway on Asset Hub', {
            network: this.config.assetHub.network,
            instanceId: this.config.instanceId,
        });
        try {
            // Step 1: Connect to Asset Hub
            await this.assetHubService.connect();
            // Step 2: Enable wallet
            await this.assetHubService.enableWallet('PMT Gateway');
            // Step 3: Initialize payment service
            this.paymentService = new PaymentService(this.assetHubService, this.logger.child('Payment'), {
                storagePrefix: this.config.storagePrefix,
                instanceId: this.config.instanceId,
                encryptStorage: this.config.encryptStorage,
                enableRateLimiting: this.config.enableRateLimiting,
                transactionTimeout: this.config.transactionTimeout,
                retryPolicy: {
                    maxRetries: this.config.retryPolicy.maxRetries,
                    retryDelay: this.config.retryPolicy.retryDelay,
                    backoffMultiplier: this.config.retryPolicy.backoffMultiplier,
                },
            });
            // Forward payment events
            this.paymentService.on('payment.created', (event) => {
                this.emit('payment', event);
                this.emit('payment.created', event);
                this.logger.info('Payment created', { paymentId: event.paymentId });
            });
            this.paymentService.on('payment.completed', (event) => {
                this.emit('payment', event);
                this.emit('payment.completed', event);
                this.logger.info('Payment completed', { paymentId: event.paymentId, txHash: event.txHash });
            });
            this.paymentService.on('payment.cancelled', (event) => {
                this.emit('payment', event);
                this.emit('payment.cancelled', event);
                this.logger.info('Payment cancelled', { paymentId: event.paymentId });
            });
            this.initialized = true;
            this.logger.info('PMT Gateway initialized successfully', {
                network: this.config.assetHub.network,
            });
        }
        catch (error) {
            this.logger.error('Failed to initialize PMT Gateway', error);
            throw error;
        }
    }
    /**
     * Create a payment
     *
     * @example
     * ```typescript
     * const payment = await gateway.createPayment({
     *   merchant: '5FHneW46xGXgs5mUiveU4sbTyGBzmstUspZC92UhjJM694ty',
     *   amount: '10.5', // 10.5 DOT
     *   description: 'Premium subscription'
     * });
     * ```
     */
    async createPayment(params) {
        this.ensureInitialized();
        return await this.paymentService.createPayment(params);
    }
    /**
     * Execute a payment (direct transfer to merchant)
     *
     * This transfers DOT from the buyer to the merchant
     */
    async executePayment(paymentId) {
        this.ensureInitialized();
        return await this.paymentService.executePayment(paymentId);
    }
    /**
     * Cancel a payment
     *
     * Can only cancel payments that haven't been executed yet
     */
    async cancelPayment(paymentId) {
        this.ensureInitialized();
        return await this.paymentService.cancelPayment(paymentId);
    }
    /**
     * Verify a payment on-chain
     *
     * This method queries Asset Hub to verify that a payment was actually executed on-chain.
     * Use this before delivering products/services to ensure payment is legitimate.
     *
     * @param paymentId - Payment ID to verify
     * @returns Verification result with on-chain data
     *
     * @example
     * ```typescript
     * gateway.on('payment.completed', async (event) => {
     *   // Verify on-chain before delivering product
     *   const verification = await gateway.verifyPayment(event.paymentId);
     *
     *   if (verification.verified) {
     *     console.log('✅ Payment verified on-chain!');
     *     await deliverProduct(event.paymentId);
     *   } else {
     *     console.error('❌ Verification failed:', verification.error);
     *   }
     * });
     * ```
     */
    async verifyPayment(paymentId) {
        this.ensureInitialized();
        return await this.paymentService.verifyPayment(paymentId);
    }
    /**
     * Get payment by ID
     */
    getPayment(paymentId) {
        this.ensureInitialized();
        return this.paymentService.getPayment(paymentId);
    }
    /**
     * Create a payment link
     *
     * Payment links allow you to accept payments without writing code.
     * Just create a link, share the URL, and users can pay directly.
     *
     * @param params - Payment link parameters
     * @returns Payment link with unique ID
     *
     * @example
     * ```typescript
     * const link = gateway.createPaymentLink({
     *   merchant: '5FHneW46xGXgs5mUiveU4sbTyGBzmstUspZC92UhjJM694ty',
     *   amount: '10.5', // Fixed amount: 10.5 DOT
     *   description: 'Premium Plan',
     *   successUrl: 'https://mysite.com/success',
     * });
     *
     * // Get the shareable URL
     * const url = gateway.getPaymentLinkUrl(link.id);
     * console.log('Share this:', url);
     * ```
     *
     * @example
     * ```typescript
     * // Allow custom amounts
     * const link = gateway.createPaymentLink({
     *   merchant: '5FHneW46xGXgs5mUiveU4sbTyGBzmstUspZC92UhjJM694ty',
     *   amount: 'custom', // User can enter any amount
     *   description: 'Donation',
     * });
     * ```
     */
    createPaymentLink(params) {
        this.ensureInitialized();
        return this.paymentService.createPaymentLink(params);
    }
    /**
     * Get payment link by ID
     */
    getPaymentLink(linkId) {
        this.ensureInitialized();
        return this.paymentService.getPaymentLink(linkId);
    }
    /**
     * Get all payment links
     */
    getAllPaymentLinks() {
        this.ensureInitialized();
        return this.paymentService.getAllPaymentLinks();
    }
    /**
     * Get payment links for a merchant
     */
    getMerchantPaymentLinks(merchantAddress) {
        this.ensureInitialized();
        return this.paymentService.getMerchantPaymentLinks(merchantAddress);
    }
    /**
     * Deactivate a payment link
     *
     * Deactivated links cannot be used to create new payments
     */
    deactivatePaymentLink(linkId) {
        this.ensureInitialized();
        return this.paymentService.deactivatePaymentLink(linkId);
    }
    /**
     * Get the shareable URL for a payment link
     *
     * @param linkId - Payment link ID
     * @param baseUrl - Optional custom base URL (defaults to current origin + /checkout)
     * @returns Shareable checkout URL
     */
    getPaymentLinkUrl(linkId, baseUrl) {
        this.ensureInitialized();
        return this.paymentService.getPaymentLinkUrl(linkId, baseUrl);
    }
    /**
     * Create a payment from a link
     *
     * This is used internally by the checkout page
     */
    async createPaymentFromLink(linkId, customAmount) {
        this.ensureInitialized();
        return await this.paymentService.createPaymentFromLink(linkId, customAmount);
    }
    /**
     * Get all payments
     */
    getAllPayments() {
        this.ensureInitialized();
        return this.paymentService.getAllPayments();
    }
    /**
     * Get payments for a merchant
     */
    getMerchantPayments(merchantAddress) {
        this.ensureInitialized();
        return this.paymentService.getMerchantPayments(merchantAddress);
    }
    /**
     * Get payments for a buyer
     */
    getBuyerPayments(buyerAddress) {
        this.ensureInitialized();
        return this.paymentService.getBuyerPayments(buyerAddress);
    }
    /**
     * Get connected wallet accounts
     */
    getAccounts() {
        this.ensureInitialized();
        return this.assetHubService.getAccounts();
    }
    /**
     * Get account balance
     */
    async getBalance(address) {
        this.ensureInitialized();
        return await this.assetHubService.getBalance(address);
    }
    /**
     * Get network information
     */
    async getNetworkInfo() {
        this.ensureInitialized();
        return await this.assetHubService.getNetworkInfo();
    }
    /**
     * Disconnect and cleanup
     */
    async disconnect() {
        if (this.assetHubService) {
            await this.assetHubService.disconnect();
        }
        this.removeAllListeners();
        this.initialized = false;
    }
    /**
     * Ensure gateway is initialized
     */
    ensureInitialized() {
        if (!this.initialized) {
            throw new Error('Gateway not initialized. Call initialize() first.');
        }
    }
}
// Default configuration values
PMTGatewayAssetHub.DEFAULTS = {
    instanceId: 'default',
    storagePrefix: 'pmt',
    transactionTimeout: 120000, // 2 minutes
    reconnectOnDisconnect: true,
    encryptStorage: false,
    enableRateLimiting: true,
    retryPolicy: {
        maxRetries: 3,
        retryDelay: 1000,
        backoffMultiplier: 2,
    },
};

/**
 * Assets Service
 *
 * Interact with Asset Hub's Assets pallet for custom tokens and stablecoins
 */
class AssetsService {
    constructor(api) {
        this.api = api;
    }
    /**
     * Create a new asset
     *
     * @param assetId - Unique asset identifier
     * @param admin - Admin address for the asset
     * @param minBalance - Minimum balance required
     */
    createAssetTransaction(assetId, admin, minBalance) {
        return this.api.tx.assets.create(assetId, admin, minBalance);
    }
    /**
     * Set asset metadata (name, symbol, decimals)
     */
    setMetadataTransaction(assetId, name, symbol, decimals) {
        return this.api.tx.assets.setMetadata(assetId, name, symbol, decimals);
    }
    /**
     * Mint assets
     */
    mintTransaction(assetId, beneficiary, amount) {
        return this.api.tx.assets.mint(assetId, beneficiary, amount);
    }
    /**
     * Transfer assets
     */
    transferTransaction(assetId, target, amount) {
        return this.api.tx.assets.transfer(assetId, target, amount);
    }
    /**
     * Burn assets
     */
    burnTransaction(assetId, amount) {
        return this.api.tx.assets.burn(assetId, amount);
    }
    /**
     * Get asset balance for an address
     */
    async getBalance(assetId, address) {
        const account = await this.api.query.assets.account(assetId, address);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (account.isNone) {
            return null;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const accountData = account.unwrap();
        return {
            balance: accountData.balance.toBigInt(),
            isFrozen: accountData.status.isFrozen,
            isSufficient: accountData.status.isSufficient,
        };
    }
    /**
     * Get asset metadata
     */
    async getMetadata(assetId) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const metadata = await this.api.query.assets.metadata(assetId);
        if (!metadata.name.length) {
            return null;
        }
        return {
            name: metadata.name.toUtf8(),
            symbol: metadata.symbol.toUtf8(),
            decimals: metadata.decimals.toNumber(),
        };
    }
    /**
     * Get asset details
     */
    async getAssetDetails(assetId) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const details = await this.api.query.assets.asset(assetId);
        if (details.isNone) {
            return null;
        }
        const asset = details.unwrap();
        return {
            owner: asset.owner.toString(),
            issuer: asset.issuer.toString(),
            admin: asset.admin.toString(),
            freezer: asset.freezer.toString(),
            supply: asset.supply.toBigInt(),
            accounts: asset.accounts.toNumber(),
            sufficients: asset.sufficients.toNumber(),
            approvals: asset.approvals.toNumber(),
            status: asset.status.toString(),
        };
    }
}

/**
 * Error Handling Service
 *
 * Provides structured error handling with sanitization
 * Prevents information disclosure while maintaining debugging capability
 */
var ErrorCode;
(function (ErrorCode) {
    // Validation Errors (4xx equivalent)
    ErrorCode["INVALID_INPUT"] = "INVALID_INPUT";
    ErrorCode["INVALID_ADDRESS"] = "INVALID_ADDRESS";
    ErrorCode["INVALID_AMOUNT"] = "INVALID_AMOUNT";
    ErrorCode["INVALID_CURRENCY"] = "INVALID_CURRENCY";
    ErrorCode["REQUIRED_FIELD"] = "REQUIRED_FIELD";
    // Authentication/Authorization Errors
    ErrorCode["WALLET_NOT_CONNECTED"] = "WALLET_NOT_CONNECTED";
    ErrorCode["UNAUTHORIZED"] = "UNAUTHORIZED";
    ErrorCode["SESSION_EXPIRED"] = "SESSION_EXPIRED";
    // Network/Blockchain Errors
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    ErrorCode["WRONG_NETWORK"] = "WRONG_NETWORK";
    ErrorCode["TRANSACTION_FAILED"] = "TRANSACTION_FAILED";
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    ErrorCode["GAS_ESTIMATION_FAILED"] = "GAS_ESTIMATION_FAILED";
    ErrorCode["USER_REJECTED"] = "USER_REJECTED";
    // Service Errors
    ErrorCode["PAYMENT_CREATION_FAILED"] = "PAYMENT_CREATION_FAILED";
    ErrorCode["PAYMENT_NOT_FOUND"] = "PAYMENT_NOT_FOUND";
    ErrorCode["PRICE_FETCH_FAILED"] = "PRICE_FETCH_FAILED";
    ErrorCode["IPFS_UPLOAD_FAILED"] = "IPFS_UPLOAD_FAILED";
    ErrorCode["IPFS_FETCH_FAILED"] = "IPFS_FETCH_FAILED";
    // Rate Limiting
    ErrorCode["RATE_LIMIT_EXCEEDED"] = "RATE_LIMIT_EXCEEDED";
    // Initialization
    ErrorCode["NOT_INITIALIZED"] = "NOT_INITIALIZED";
    ErrorCode["INITIALIZATION_FAILED"] = "INITIALIZATION_FAILED";
    // Circuit Breaker
    ErrorCode["SERVICE_UNAVAILABLE"] = "SERVICE_UNAVAILABLE";
    // Unknown
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(ErrorCode || (ErrorCode = {}));
var ErrorSeverity;
(function (ErrorSeverity) {
    ErrorSeverity["LOW"] = "LOW";
    ErrorSeverity["MEDIUM"] = "MEDIUM";
    ErrorSeverity["HIGH"] = "HIGH";
    ErrorSeverity["CRITICAL"] = "CRITICAL"; // System-level failure
})(ErrorSeverity || (ErrorSeverity = {}));
/**
 * Base application error class
 */
class PMTError extends Error {
    constructor(message, code, options = {}) {
        super(message);
        this.name = 'PMTError';
        this.code = code;
        this.severity = options.severity || ErrorSeverity.MEDIUM;
        this.retryable = options.retryable ?? false;
        this.details = options.details;
        this.originalError = options.originalError;
        this.timestamp = Date.now();
        // Maintain proper stack trace
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PMTError);
        }
    }
    /**
     * Serialize error for client consumption (sanitized)
     */
    toJSON() {
        return {
            message: this.message,
            code: this.code,
            severity: this.severity,
            details: this.sanitizeDetails(this.details),
            timestamp: this.timestamp,
            retryable: this.retryable,
        };
    }
    /**
     * Sanitize details to prevent information disclosure
     */
    sanitizeDetails(details) {
        if (!details)
            return undefined;
        const sanitized = {};
        // Allowlist of safe fields to include
        const safeFields = [
            'paymentId',
            'transactionHash',
            'currency',
            'amount',
            'field',
            'retryAfter',
        ];
        for (const key of safeFields) {
            if (details[key] !== undefined) {
                sanitized[key] = details[key];
            }
        }
        return Object.keys(sanitized).length > 0 ? sanitized : undefined;
    }
    /**
     * Get full error for logging (includes sensitive info)
     */
    toLogObject() {
        return {
            message: this.message,
            code: this.code,
            severity: this.severity,
            retryable: this.retryable,
            details: this.details,
            timestamp: this.timestamp,
            stack: this.stack,
            originalError: this.originalError ? {
                message: this.originalError.message,
                stack: this.originalError.stack,
            } : undefined,
        };
    }
}
/**
 * Error handling utility
 */
class ErrorHandler {
    /**
     * Convert any error to PMTError
     */
    static handle(error, context) {
        // Already a PMTError
        if (error instanceof PMTError) {
            return error;
        }
        // Ethereum/ethers.js errors
        if (this.isEthersError(error)) {
            return this.handleEthersError(error, context);
        }
        // Validation errors
        if (this.isValidationError(error)) {
            return new PMTError(error.message, ErrorCode.INVALID_INPUT, {
                severity: ErrorSeverity.LOW,
                retryable: false,
                originalError: error,
            });
        }
        // Network errors
        if (this.isNetworkError(error)) {
            return new PMTError('Network request failed. Please check your connection.', ErrorCode.NETWORK_ERROR, {
                severity: ErrorSeverity.MEDIUM,
                retryable: true,
                originalError: error,
            });
        }
        // Generic error
        if (error instanceof Error) {
            return new PMTError(this.getSafeErrorMessage(error.message, context), ErrorCode.UNKNOWN_ERROR, {
                severity: ErrorSeverity.MEDIUM,
                retryable: false,
                originalError: error,
            });
        }
        // Unknown error type
        return new PMTError('An unexpected error occurred', ErrorCode.UNKNOWN_ERROR, {
            severity: ErrorSeverity.MEDIUM,
            retryable: false,
        });
    }
    /**
     * Check if error is from ethers.js
     */
    static isEthersError(error) {
        return (error !== null &&
            typeof error === 'object' &&
            ('code' in error || 'reason' in error));
    }
    /**
     * Handle ethers.js specific errors
     */
    static handleEthersError(error, _context) {
        // User rejected transaction
        if (error.code === 'ACTION_REJECTED' || error.code === 4001) {
            return new PMTError('Transaction was rejected by user', ErrorCode.USER_REJECTED, {
                severity: ErrorSeverity.LOW,
                retryable: true,
                originalError: error,
            });
        }
        // Insufficient funds
        if (error.code === 'INSUFFICIENT_FUNDS') {
            return new PMTError('Insufficient funds to complete transaction', ErrorCode.INSUFFICIENT_FUNDS, {
                severity: ErrorSeverity.HIGH,
                retryable: false,
                originalError: error,
            });
        }
        // Network/connection errors
        if (error.code === 'NETWORK_ERROR' ||
            error.code === 'TIMEOUT' ||
            error.code === 'SERVER_ERROR') {
            return new PMTError('Network connection failed. Please try again.', ErrorCode.NETWORK_ERROR, {
                severity: ErrorSeverity.MEDIUM,
                retryable: true,
                originalError: error,
            });
        }
        // Gas estimation failed
        if (error.code === 'UNPREDICTABLE_GAS_LIMIT') {
            return new PMTError('Transaction may fail. Please check parameters.', ErrorCode.GAS_ESTIMATION_FAILED, {
                severity: ErrorSeverity.HIGH,
                retryable: false,
                originalError: error,
            });
        }
        // Transaction failed
        if (error.code === 'CALL_EXCEPTION') {
            return new PMTError(error.reason || 'Transaction execution failed', ErrorCode.TRANSACTION_FAILED, {
                severity: ErrorSeverity.HIGH,
                retryable: false,
                originalError: error,
                details: {
                    transactionHash: error.transactionHash,
                },
            });
        }
        // Generic ethers error
        return new PMTError('Blockchain transaction failed', ErrorCode.TRANSACTION_FAILED, {
            severity: ErrorSeverity.HIGH,
            retryable: true,
            originalError: error,
        });
    }
    /**
     * Check if error is validation error
     */
    static isValidationError(error) {
        return (error !== null &&
            typeof error === 'object' &&
            'name' in error &&
            error.name === 'ValidationError');
    }
    /**
     * Check if error is network error
     */
    static isNetworkError(error) {
        if (!(error instanceof Error))
            return false;
        const networkErrorKeywords = [
            'network',
            'timeout',
            'connection',
            'fetch',
            'ECONNREFUSED',
            'ETIMEDOUT',
        ];
        return networkErrorKeywords.some(keyword => error.message.toLowerCase().includes(keyword.toLowerCase()));
    }
    /**
     * Get safe error message (remove sensitive info)
     */
    static getSafeErrorMessage(message, context) {
        // Remove potential sensitive data patterns
        let safe = message
            .replace(/0x[a-fA-F0-9]{40}/g, '0x[REDACTED]') // Ethereum addresses
            .replace(/\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/g, '[IP_REDACTED]') // IP addresses
            .replace(/api[_-]?key[:\s=]+[^\s]+/gi, 'api_key=[REDACTED]') // API keys
            .replace(/secret[:\s=]+[^\s]+/gi, 'secret=[REDACTED]'); // Secrets
        // Add context if provided
        if (context) {
            safe = `${context}: ${safe}`;
        }
        return safe;
    }
    /**
     * Log error appropriately based on environment
     */
    static logError(error, context) {
        const logObject = error.toLogObject();
        if (context) {
            logObject.context = context;
        }
        // In development, log full details
        if (process.env.NODE_ENV !== 'production') {
            console.error('PMTError:', logObject);
            return;
        }
        // In production, send to monitoring service
        // (Sentry, LogRocket, etc.)
        this.sendToMonitoring(logObject);
        // Log minimal info to console
        console.error(`[${error.code}] ${error.message}`);
    }
    /**
     * Send error to monitoring service
     */
    static sendToMonitoring(errorData) {
        // Implement your monitoring integration here
        // Example: Sentry, LogRocket, Datadog, etc.
        // Example with Sentry:
        // if (typeof Sentry !== 'undefined') {
        //   Sentry.captureException(new Error(errorData.message), {
        //     level: errorData.severity.toLowerCase(),
        //     extra: errorData
        //   });
        // }
        // For now, just ensure the error is captured somewhere
        if (typeof window !== 'undefined') {
            const windowWithHandler = window;
            if (windowWithHandler.__PMT_ERROR_HANDLER__) {
                windowWithHandler.__PMT_ERROR_HANDLER__(errorData);
            }
        }
    }
    /**
     * Create user-friendly error message
     */
    static getUserMessage(error) {
        const messages = {
            [ErrorCode.INVALID_INPUT]: 'Please check your input and try again.',
            [ErrorCode.INVALID_ADDRESS]: 'Please provide a valid wallet address.',
            [ErrorCode.INVALID_AMOUNT]: 'Please enter a valid amount.',
            [ErrorCode.INVALID_CURRENCY]: 'The selected currency is not supported.',
            [ErrorCode.REQUIRED_FIELD]: 'Please fill in all required fields.',
            [ErrorCode.WALLET_NOT_CONNECTED]: 'Please connect your wallet to continue.',
            [ErrorCode.UNAUTHORIZED]: 'You are not authorized to perform this action.',
            [ErrorCode.SESSION_EXPIRED]: 'Your session has expired. Please reconnect.',
            [ErrorCode.NETWORK_ERROR]: 'Network connection failed. Please check your internet and try again.',
            [ErrorCode.WRONG_NETWORK]: 'Please switch to the correct network in your wallet.',
            [ErrorCode.TRANSACTION_FAILED]: 'Transaction failed. Please try again.',
            [ErrorCode.INSUFFICIENT_FUNDS]: 'You don\'t have enough funds to complete this transaction.',
            [ErrorCode.GAS_ESTIMATION_FAILED]: 'Unable to estimate gas. Transaction may fail.',
            [ErrorCode.USER_REJECTED]: 'Transaction was cancelled.',
            [ErrorCode.PAYMENT_CREATION_FAILED]: 'Failed to create payment. Please try again.',
            [ErrorCode.PAYMENT_NOT_FOUND]: 'Payment not found.',
            [ErrorCode.PRICE_FETCH_FAILED]: 'Failed to fetch current prices. Please try again.',
            [ErrorCode.IPFS_UPLOAD_FAILED]: 'Failed to store data. Please try again.',
            [ErrorCode.IPFS_FETCH_FAILED]: 'Failed to retrieve data.',
            [ErrorCode.RATE_LIMIT_EXCEEDED]: 'Too many requests. Please wait and try again.',
            [ErrorCode.NOT_INITIALIZED]: 'Service not initialized. Please refresh the page.',
            [ErrorCode.INITIALIZATION_FAILED]: 'Failed to initialize. Please refresh the page.',
            [ErrorCode.SERVICE_UNAVAILABLE]: 'Service temporarily unavailable. Please try again later.',
            [ErrorCode.UNKNOWN_ERROR]: 'An unexpected error occurred. Please try again.',
        };
        return messages[error.code] || error.message;
    }
}

export { AssetHubService, AssetsService, ErrorCode, ErrorHandler, ErrorSeverity, Logger, PMTError, PMTGatewayAssetHub, PaymentService, RateLimitPresets, RateLimiterService, ValidationError, ValidationService, createDefaultLogger, createDevLogger };
//# sourceMappingURL=index.esm.js.map
